webpackJsonp([1],{

/***/ "/GJc":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/PUx":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/Xfn":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/kga":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/vux/src/mixins/prevent-body-scroll.js
var prevent_body_scroll = __webpack_require__("JkZY");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/x-dialog/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var x_dialog = ({
  mixins: [prevent_body_scroll["a" /* default */]],
  name: 'x-dialog',
  model: {
    prop: 'show',
    event: 'change'
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    maskTransition: {
      type: String,
      default: 'vux-mask'
    },
    maskZIndex: [String, Number],
    dialogTransition: {
      type: String,
      default: 'vux-dialog'
    },
    dialogClass: {
      type: String,
      default: 'weui-dialog'
    },
    hideOnBlur: Boolean,
    dialogStyle: Object,
    scroll: {
      type: Boolean,
      default: true,
      validator: function validator(val) {
        /* istanbul ignore if */
        if (false) {
          console.warn('[VUX warn] x-dialog:scroll 已经废弃。如果你是 100% 布局，请参照文档配置 $layout 以实现阻止滚动');
        }
        return true;
      }
    }
  },
  computed: {
    maskStyle: function maskStyle() {
      if (typeof this.maskZIndex !== 'undefined') {
        return {
          zIndex: this.maskZIndex
        };
      }
    }
  },
  mounted: function mounted() {
    if (typeof window !== 'undefined') {
      if (window.VUX_CONFIG && window.VUX_CONFIG.$layout === 'VIEW_BOX') {
        this.layout = 'VIEW_BOX';
      }
    }
  },

  watch: {
    show: function show(val) {
      this.$emit('update:show', val);
      this.$emit(val ? 'on-show' : 'on-hide');
      if (val) {
        this.addModalClassName();
      } else {
        this.removeModalClassName();
      }
    }
  },
  methods: {
    shouldPreventScroll: function shouldPreventScroll() {
      // hard to get focus on iOS device with fixed position, so just ignore it
      var iOS = /iPad|iPhone|iPod/i.test(window.navigator.userAgent);
      var hasInput = this.$el.querySelector('input') || this.$el.querySelector('textarea');
      if (iOS && hasInput) {
        return true;
      }
    },
    hide: function hide() {
      if (this.hideOnBlur) {
        this.$emit('update:show', false);
        this.$emit('change', false);
        this.$emit('on-click-mask');
      }
    }
  },
  data: function data() {
    return {
      layout: ''
    };
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/x-dialog/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var components_x_dialog = ({
  mixins: [prevent_body_scroll["a" /* default */]],
  name: 'x-dialog',
  model: {
    prop: 'show',
    event: 'change'
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    maskTransition: {
      type: String,
      default: 'vux-mask'
    },
    maskZIndex: [String, Number],
    dialogTransition: {
      type: String,
      default: 'vux-dialog'
    },
    dialogClass: {
      type: String,
      default: 'weui-dialog'
    },
    hideOnBlur: Boolean,
    dialogStyle: Object,
    scroll: {
      type: Boolean,
      default: true,
      validator: function validator(val) {
        /* istanbul ignore if */
        if (false) {
          console.warn('[VUX warn] x-dialog:scroll 已经废弃。如果你是 100% 布局，请参照文档配置 $layout 以实现阻止滚动');
        }
        return true;
      }
    }
  },
  computed: {
    maskStyle: function maskStyle() {
      if (typeof this.maskZIndex !== 'undefined') {
        return {
          zIndex: this.maskZIndex
        };
      }
    }
  },
  mounted: function mounted() {
    if (typeof window !== 'undefined') {
      if (window.VUX_CONFIG && window.VUX_CONFIG.$layout === 'VIEW_BOX') {
        this.layout = 'VIEW_BOX';
      }
    }
  },

  watch: {
    show: function show(val) {
      this.$emit('update:show', val);
      this.$emit(val ? 'on-show' : 'on-hide');
      if (val) {
        this.addModalClassName();
      } else {
        this.removeModalClassName();
      }
    }
  },
  methods: {
    shouldPreventScroll: function shouldPreventScroll() {
      // hard to get focus on iOS device with fixed position, so just ignore it
      var iOS = /iPad|iPhone|iPod/i.test(window.navigator.userAgent);
      var hasInput = this.$el.querySelector('input') || this.$el.querySelector('textarea');
      if (iOS && hasInput) {
        return true;
      }
    },
    hide: function hide() {
      if (this.hideOnBlur) {
        this.$emit('update:show', false);
        this.$emit('change', false);
        this.$emit('on-click-mask');
      }
    }
  },
  data: function data() {
    return {
      layout: ''
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-347e3f32","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/x-dialog/index.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-x-dialog",class:{'vux-x-dialog-absolute': _vm.layout === 'VIEW_BOX'}},[_c('transition',{attrs:{"name":_vm.maskTransition}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"weui-mask",style:(_vm.maskStyle),on:{"click":_vm.hide}})]),_vm._v(" "),_c('transition',{attrs:{"name":_vm.dialogTransition}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],class:_vm.dialogClass,style:(_vm.dialogStyle)},[_vm._t("default")],2)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var src_components_x_dialog = (esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/x-dialog/index.vue
function injectStyle (ssrContext) {
  __webpack_require__("5PJb")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  components_x_dialog,
  src_components_x_dialog,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var vux_src_components_x_dialog = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "/qU+":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("j1ja");
module.exports = __webpack_require__("dI99");


/***/ }),

/***/ "01kQ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "09Uw":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "0Gh9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "0UZ+":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "0w+C":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "1qFZ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "3Lt7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/flexbox/flexbox-item.vue
//
//
//
//
//
//

var prefixList = ['-moz-box-', '-webkit-box-', ''];

/* harmony default export */ var flexbox_item = ({
  name: 'flexbox-item',
  props: {
    span: [Number, String],
    order: [Number, String]
  },
  beforeMount: function beforeMount() {
    this.bodyWidth = document.documentElement.offsetWidth;
  },

  methods: {
    buildWidth: function buildWidth(width) {
      if (typeof width === 'number') {
        if (width < 1) {
          return width;
        } else {
          return width / 12;
        }
      } else if (typeof width === 'string') {
        return width.replace('px', '') / this.bodyWidth;
      }
    }
  },
  computed: {
    style: function style() {
      var styles = {};
      var marginName = this.$parent.orient === 'horizontal' ? 'marginLeft' : 'marginTop';

      if (this.$parent.gutter * 1 !== 0) {
        styles[marginName] = this.$parent.gutter + 'px';
      }

      if (this.span) {
        for (var i = 0; i < prefixList.length; i++) {
          styles[prefixList[i] + 'flex'] = '0 0 ' + this.buildWidth(this.span) * 100 + '%';
        }
      }
      if (typeof this.order !== 'undefined') {
        styles.order = this.order;
      }
      return styles;
    }
  },
  data: function data() {
    return {
      bodyWidth: 0
    };
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/flexbox/flexbox-item.vue
//
//
//
//
//
//

var flexbox_item_prefixList = ['-moz-box-', '-webkit-box-', ''];

/* harmony default export */ var flexbox_flexbox_item = ({
  name: 'flexbox-item',
  props: {
    span: [Number, String],
    order: [Number, String]
  },
  beforeMount: function beforeMount() {
    this.bodyWidth = document.documentElement.offsetWidth;
  },

  methods: {
    buildWidth: function buildWidth(width) {
      if (typeof width === 'number') {
        if (width < 1) {
          return width;
        } else {
          return width / 12;
        }
      } else if (typeof width === 'string') {
        return width.replace('px', '') / this.bodyWidth;
      }
    }
  },
  computed: {
    style: function style() {
      var styles = {};
      var marginName = this.$parent.orient === 'horizontal' ? 'marginLeft' : 'marginTop';

      if (this.$parent.gutter * 1 !== 0) {
        styles[marginName] = this.$parent.gutter + 'px';
      }

      if (this.span) {
        for (var i = 0; i < flexbox_item_prefixList.length; i++) {
          styles[flexbox_item_prefixList[i] + 'flex'] = '0 0 ' + this.buildWidth(this.span) * 100 + '%';
        }
      }
      if (typeof this.order !== 'undefined') {
        styles.order = this.order;
      }
      return styles;
    }
  },
  data: function data() {
    return {
      bodyWidth: 0
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3f79b7cb","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/flexbox/flexbox-item.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-flexbox-item",style:(_vm.style)},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var components_flexbox_flexbox_item = (esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/flexbox/flexbox-item.vue
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  flexbox_flexbox_item,
  components_flexbox_flexbox_item,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_components_flexbox_flexbox_item = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "5FKM":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5PJb":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "72rf":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "7BoG":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "8FNJ":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "98uI":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "AFQ6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Amcn":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "BCGI":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Bfwr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/loading/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var loading = ({
  name: 'loading',
  model: {
    prop: 'show',
    event: 'change'
  },
  props: {
    show: Boolean,
    text: String,
    position: String,
    transition: {
      type: String,
      default: 'vux-mask'
    }
  },
  watch: {
    show: function show(val) {
      this.$emit('update:show', val);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/loading/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var components_loading = ({
  name: 'loading',
  model: {
    prop: 'show',
    event: 'change'
  },
  props: {
    show: Boolean,
    text: String,
    position: String,
    transition: {
      type: String,
      default: 'vux-mask'
    }
  },
  watch: {
    show: function show(val) {
      this.$emit('update:show', val);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a79aa162","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/loading/index.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":_vm.transition}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"weui-loading_toast vux-loading",class:!_vm.text ? 'vux-loading-no-text' : ''},[_c('div',{staticClass:"weui-mask_transparent"}),_vm._v(" "),_c('div',{staticClass:"weui-toast",style:({
        position: _vm.position
      })},[_c('i',{staticClass:"weui-loading weui-icon_toast"}),_vm._v(" "),(_vm.text)?_c('p',{staticClass:"weui-toast__content"},[_vm._v(_vm._s(_vm.text || '加载中')),_vm._t("default")],2):_vm._e()])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var src_components_loading = (esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/loading/index.vue
function injectStyle (ssrContext) {
  __webpack_require__("0w+C")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  components_loading,
  src_components_loading,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)


/* harmony default export */ var vux_src_components_loading = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "D6RS":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/500.c6b4caf.png";

/***/ }),

/***/ "DAOZ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "DHjd":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "EzhF":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Fs3p":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Fs8M":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "GINT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Hq8V":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "IKRd":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "IYR1":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "JhC5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "KH5e":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/banner.163cb22.png";

/***/ }),

/***/ "KR60":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/pants.e598515.png";

/***/ }),

/***/ "KwMT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "LK+o":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Leuz":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "LzMh":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NGg+":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NSqn":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "OBBg":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ORep":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Owmw":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "PY3Y":
/***/ (function(module, exports) {

setHtml();
window.addEventListener('resize', function () {
  setHtml();
});
function setHtml() {
  var width = document.documentElement.clientWidth;
  document.querySelector('html').style.fontSize = 16 * (width / 375) + 'px';
}

/***/ }),

/***/ "Pet3":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/user-bg01.8cb4a55.png";

/***/ }),

/***/ "PuPU":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Q0eu":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Scr7":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Stz3":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "TKqF":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "TYQ4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "UCdd":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Uirz":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/student.3a9a83a.png";

/***/ }),

/***/ "VASZ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Yl6F":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "YxJB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/flexbox/flexbox.vue
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var flexbox = ({
  name: 'flexbox',
  props: {
    gutter: {
      type: Number,
      default: 8
    },
    orient: {
      type: String,
      default: 'horizontal'
    },
    justify: String,
    align: String,
    wrap: String,
    direction: String
  },
  computed: {
    styles: function styles() {
      var styles = {
        'justify-content': this.justify,
        '-webkit-justify-content': this.justify,
        'align-items': this.align,
        '-webkit-align-items': this.align,
        'flex-wrap': this.wrap,
        '-webkit-flex-wrap': this.wrap,
        'flex-direction': this.direction,
        '-webkit-flex-direction': this.direction
      };
      return styles;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/flexbox/flexbox.vue
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var flexbox_flexbox = ({
  name: 'flexbox',
  props: {
    gutter: {
      type: Number,
      default: 8
    },
    orient: {
      type: String,
      default: 'horizontal'
    },
    justify: String,
    align: String,
    wrap: String,
    direction: String
  },
  computed: {
    styles: function styles() {
      var styles = {
        'justify-content': this.justify,
        '-webkit-justify-content': this.justify,
        'align-items': this.align,
        '-webkit-align-items': this.align,
        'flex-wrap': this.wrap,
        '-webkit-flex-wrap': this.wrap,
        'flex-direction': this.direction,
        '-webkit-flex-direction': this.direction
      };
      return styles;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-28eb4a1c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/flexbox/flexbox.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-flexbox",class:{
  'vux-flex-col': _vm.orient === 'vertical',
  'vux-flex-row': _vm.orient === 'horizontal'
},style:(_vm.styles)},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var components_flexbox_flexbox = (esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/flexbox/flexbox.vue
function injectStyle (ssrContext) {
  __webpack_require__("zn2m")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  flexbox_flexbox,
  components_flexbox_flexbox,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_components_flexbox_flexbox = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "apLE":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "b+EJ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ckkX":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "cmRX":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "dI99":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__("7+uW");

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__("Dd8w");
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// EXTERNAL MODULE: ./node_modules/vux/src/mixins/multi-items.js
var multi_items = __webpack_require__("piuB");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/tabbar/tabbar.vue
//
//
//
//
//
//



/* harmony default export */ var tabbar = ({
  mounted: function mounted() {
    var _this = this;

    if (false) {
      this.$nextTick(function () {
        var $el = _this.$el;
        var position = window.getComputedStyle($el).position;
        if (position === 'fixed') {
          return;
        } else if (position === 'absolute') {
          if (document.documentElement.offsetHeight !== window.innerHeight) {
            console.warn('[VUX warn] tabbar 定位默认为 absolute，如果你没有使用 100% 布局(view-box)，需要手动设置 style position 为 fixed');
          }
        }
      });
    }
  },

  name: 'tabbar',
  mixins: [multi_items["b" /* parentMixin */]],
  props: {
    iconClass: String
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/tabbar/tabbar.vue
//
//
//
//
//
//



/* harmony default export */ var tabbar_tabbar = ({
  mounted: function mounted() {
    var _this = this;

    if (false) {
      this.$nextTick(function () {
        var $el = _this.$el;
        var position = window.getComputedStyle($el).position;
        if (position === 'fixed') {
          return;
        } else if (position === 'absolute') {
          if (document.documentElement.offsetHeight !== window.innerHeight) {
            console.warn('[VUX warn] tabbar 定位默认为 absolute，如果你没有使用 100% 布局(view-box)，需要手动设置 style position 为 fixed');
          }
        }
      });
    }
  },

  name: 'tabbar',
  mixins: [multi_items["b" /* parentMixin */]],
  props: {
    iconClass: String
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-df815522","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/tabbar/tabbar.vue
var tabbar_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"weui-tabbar"},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: tabbar_render, staticRenderFns: staticRenderFns }
/* harmony default export */ var components_tabbar_tabbar = (esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/tabbar/tabbar.vue
function injectStyle (ssrContext) {
  __webpack_require__("Stz3")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  tabbar_tabbar,
  components_tabbar_tabbar,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_components_tabbar_tabbar = (Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/badge/index.vue
//
//
//
//

/* harmony default export */ var badge = ({
  name: 'badge',
  props: {
    text: [String, Number]
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/badge/index.vue
//
//
//
//

/* harmony default export */ var components_badge = ({
  name: 'badge',
  props: {
    text: [String, Number]
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bcc96ffc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/badge/index.vue
var badge_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:['vux-badge', {'vux-badge-dot': typeof _vm.text === 'undefined', 'vux-badge-single': typeof _vm.text !== 'undefined' && _vm.text.toString().length === 1}],domProps:{"textContent":_vm._s(_vm.text)}})}
var badge_staticRenderFns = []
var badge_esExports = { render: badge_render, staticRenderFns: badge_staticRenderFns }
/* harmony default export */ var src_components_badge = (badge_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/badge/index.vue
function badge_injectStyle (ssrContext) {
  __webpack_require__("oNIB")
}
var badge_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var badge___vue_template_functional__ = false
/* styles */
var badge___vue_styles__ = badge_injectStyle
/* scopeId */
var badge___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var badge___vue_module_identifier__ = null
var badge_Component = badge_normalizeComponent(
  components_badge,
  src_components_badge,
  badge___vue_template_functional__,
  badge___vue_styles__,
  badge___vue_scopeId__,
  badge___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_badge = (badge_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/tabbar/tabbar-item.vue
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var tabbar_item = ({
  name: 'tabbar-item',
  components: {
    Badge: vux_src_components_badge
  },
  mounted: function mounted() {
    if (!this.$slots.icon) {
      this.simple = true;
    }
    if (this.$slots['icon-active']) {
      this.hasActiveIcon = true;
    }
  },

  mixins: [multi_items["a" /* childMixin */]],
  props: {
    showDot: {
      type: Boolean,
      default: false
    },
    badge: String,
    link: [String, Object],
    iconClass: String
  },
  computed: {
    isActive: function isActive() {
      return this.$parent.index === this.currentIndex;
    }
  },
  data: function data() {
    return {
      simple: false,
      hasActiveIcon: false
    };
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/tabbar/tabbar-item.vue
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var tabbar_tabbar_item = ({
  name: 'tabbar-item',
  components: {
    Badge: vux_src_components_badge
  },
  mounted: function mounted() {
    if (!this.$slots.icon) {
      this.simple = true;
    }
    if (this.$slots['icon-active']) {
      this.hasActiveIcon = true;
    }
  },

  mixins: [multi_items["a" /* childMixin */]],
  props: {
    showDot: {
      type: Boolean,
      default: false
    },
    badge: String,
    link: [String, Object],
    iconClass: String
  },
  computed: {
    isActive: function isActive() {
      return this.$parent.index === this.currentIndex;
    }
  },
  data: function data() {
    return {
      simple: false,
      hasActiveIcon: false
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-22fc8f9a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/tabbar/tabbar-item.vue
var tabbar_item_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"weui-tabbar__item",class:{'weui-bar__item_on': _vm.isActive, 'vux-tabbar-simple': _vm.simple},attrs:{"href":"javascript:;"},on:{"click":function($event){return _vm.onItemClick(true)}}},[(!_vm.simple)?_c('div',{staticClass:"weui-tabbar__icon",class:[_vm.iconClass || _vm.$parent.iconClass, {'vux-reddot': _vm.showDot}]},[(!_vm.simple && !(_vm.hasActiveIcon && _vm.isActive))?_vm._t("icon"):_vm._e(),_vm._v(" "),(!_vm.simple && _vm.hasActiveIcon && _vm.isActive)?_vm._t("icon-active"):_vm._e(),_vm._v(" "),(_vm.badge)?_c('sup',[_c('badge',{attrs:{"text":_vm.badge}})],1):_vm._e()],2):_vm._e(),_vm._v(" "),_c('p',{staticClass:"weui-tabbar__label"},[_vm._t("label")],2)])}
var tabbar_item_staticRenderFns = []
var tabbar_item_esExports = { render: tabbar_item_render, staticRenderFns: tabbar_item_staticRenderFns }
/* harmony default export */ var components_tabbar_tabbar_item = (tabbar_item_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/tabbar/tabbar-item.vue
var tabbar_item_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var tabbar_item___vue_template_functional__ = false
/* styles */
var tabbar_item___vue_styles__ = null
/* scopeId */
var tabbar_item___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var tabbar_item___vue_module_identifier__ = null
var tabbar_item_Component = tabbar_item_normalizeComponent(
  tabbar_tabbar_item,
  components_tabbar_tabbar_item,
  tabbar_item___vue_template_functional__,
  tabbar_item___vue_styles__,
  tabbar_item___vue_scopeId__,
  tabbar_item___vue_module_identifier__
)

/* harmony default export */ var src_components_tabbar_tabbar_item = (tabbar_item_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/tabbar.vue




/* harmony default export */ var components_tabbar = ({
  name: '',
  props: {
    tabbar: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {};
  },

  components: {
    Tabbar: src_components_tabbar_tabbar,
    TabbarItem: src_components_tabbar_tabbar_item
  },
  mounted: function mounted() {},

  methods: {
    isActive: function isActive(item) {
      var routerPath = this.$route.path;
      var itemPath = item.href;
      return itemPath === routerPath;
    },
    isShow: function isShow() {
      return this.$route.meta.tabbar;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/tabbar.vue




/* harmony default export */ var selectortype_script_index_0_src_components_tabbar = ({
  name: '',
  props: {
    tabbar: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {};
  },

  components: {
    Tabbar: src_components_tabbar_tabbar,
    TabbarItem: src_components_tabbar_tabbar_item
  },
  mounted: function mounted() {},

  methods: {
    isActive: function isActive(item) {
      var routerPath = this.$route.path;
      var itemPath = item.href;
      return itemPath === routerPath;
    },
    isShow: function isShow() {
      return this.$route.meta.tabbar;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4217cfbd","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/tabbar.vue
var components_tabbar_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.isShow())?_c('tabbar',{staticStyle:{"position":"fixed"},attrs:{"id":"tabbar"}},_vm._l((_vm.tabbar),function(item,index){return _c('tabbar-item',{key:item.label,attrs:{"selected":_vm.isActive(item),"link":item.href}},[_c('em',{staticClass:"icon",class:item.icon,attrs:{"slot":"icon"},slot:"icon"}),_c('span',{staticClass:"text",attrs:{"slot":"label"},slot:"label"},[_vm._v(_vm._s(item.label))])])}),1):_vm._e()],1)}
var tabbar_staticRenderFns = []
var tabbar_esExports = { render: components_tabbar_render, staticRenderFns: tabbar_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_tabbar = (tabbar_esExports);
// CONCATENATED MODULE: ./src/components/tabbar.vue
function tabbar_injectStyle (ssrContext) {
  __webpack_require__("DHjd")
}
var tabbar_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var tabbar___vue_template_functional__ = false
/* styles */
var tabbar___vue_styles__ = tabbar_injectStyle
/* scopeId */
var tabbar___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var tabbar___vue_module_identifier__ = null
var tabbar_Component = tabbar_normalizeComponent(
  selectortype_script_index_0_src_components_tabbar,
  selectortype_template_index_0_src_components_tabbar,
  tabbar___vue_template_functional__,
  tabbar___vue_styles__,
  tabbar___vue_scopeId__,
  tabbar___vue_module_identifier__
)

/* harmony default export */ var src_components_tabbar = (tabbar_Component.exports);

// EXTERNAL MODULE: ./node_modules/vuex/dist/vuex.esm.js
var vuex_esm = __webpack_require__("NYxO");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/yingxin/tskjxy/App.vue

//
//
//
//
//
//



// import { getRequest } from '@/assets/scripts/utils'
/* harmony default export */ var App = ({
  name: 'app',
  components: {
    Tabbars: src_components_tabbar
  },
  data: function data() {
    return {
      tabbar: [{
        'label': '首页',
        'icon': 'icon-home',
        'href': '/home'
      }, {
        'label': '办理记录',
        'icon': 'icon-record',
        'href': '/record'
      }, {
        'label': '通知',
        'icon': 'icon-notice',
        'href': '/notice'
      }, {
        'label': '我的',
        'icon': 'icon-mine',
        'href': '/user'
      }]

    };
  },
  mounted: function mounted() {
    this.getAppType();
  },

  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])(['LoginAction', 'userInfoAction']), {
    // 判断程序运行app类型--微信/学付宝
    getAppType: function getAppType() {
      var wx = navigator.userAgent.toLowerCase().indexOf('micromessenger') !== -1;
      // let token = JSON.stringify(getRequest(window.location.href)) !== '{}' ? getRequest(window.location.href).info : null
      if (!wx) {
        this.client();
      }
    },

    // 学付宝--获取客户端类型，引入不同的js
    client: function client() {
      var oScript = document.createElement('script');
      oScript.type = 'text/javascript';
      var u = navigator.userAgent;
      var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1;
      if (isAndroid) {
        oScript.src = './static/scripts/cordova/android_cordova.js';
      } else {
        oScript.src = './static/scripts/cordova/ios_cordova.js';
        // document.body.appendChild(oScript)
        // const script1 = document.createElement('script')
        // script1.setAttribute('type', 'text/javascript')
        // script1.setAttribute('src', './static/scripts/cordova/cordova_plugins.js')
        // document.body.appendChild(script1)
      }
      document.body.appendChild(oScript);
      var script1 = document.createElement('script');
      script1.setAttribute('type', 'text/javascript');
      script1.setAttribute('src', './static/scripts/cordova/cordova_plugins.js');
      document.body.appendChild(script1);
    }
  })
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/yingxin/tskjxy/App.vue

//
//
//
//
//
//



// import { getRequest } from '@/assets/scripts/utils'
/* harmony default export */ var tskjxy_App = ({
  name: 'app',
  components: {
    Tabbars: src_components_tabbar
  },
  data: function data() {
    return {
      tabbar: [{
        'label': '首页',
        'icon': 'icon-home',
        'href': '/home'
      }, {
        'label': '办理记录',
        'icon': 'icon-record',
        'href': '/record'
      }, {
        'label': '通知',
        'icon': 'icon-notice',
        'href': '/notice'
      }, {
        'label': '我的',
        'icon': 'icon-mine',
        'href': '/user'
      }]

    };
  },
  mounted: function mounted() {
    this.getAppType();
  },

  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])(['LoginAction', 'userInfoAction']), {
    // 判断程序运行app类型--微信/学付宝
    getAppType: function getAppType() {
      var wx = navigator.userAgent.toLowerCase().indexOf('micromessenger') !== -1;
      // let token = JSON.stringify(getRequest(window.location.href)) !== '{}' ? getRequest(window.location.href).info : null
      if (!wx) {
        this.client();
      }
    },

    // 学付宝--获取客户端类型，引入不同的js
    client: function client() {
      var oScript = document.createElement('script');
      oScript.type = 'text/javascript';
      var u = navigator.userAgent;
      var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1;
      if (isAndroid) {
        oScript.src = './static/scripts/cordova/android_cordova.js';
      } else {
        oScript.src = './static/scripts/cordova/ios_cordova.js';
        // document.body.appendChild(oScript)
        // const script1 = document.createElement('script')
        // script1.setAttribute('type', 'text/javascript')
        // script1.setAttribute('src', './static/scripts/cordova/cordova_plugins.js')
        // document.body.appendChild(script1)
      }
      document.body.appendChild(oScript);
      var script1 = document.createElement('script');
      script1.setAttribute('type', 'text/javascript');
      script1.setAttribute('src', './static/scripts/cordova/cordova_plugins.js');
      document.body.appendChild(script1);
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-194c5bec","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/yingxin/tskjxy/App.vue
var App_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('router-view'),_c('tabbars',{attrs:{"tabbar":_vm.tabbar}})],1)}
var App_staticRenderFns = []
var App_esExports = { render: App_render, staticRenderFns: App_staticRenderFns }
/* harmony default export */ var yingxin_tskjxy_App = (App_esExports);
// CONCATENATED MODULE: ./src/yingxin/tskjxy/App.vue
function App_injectStyle (ssrContext) {
  __webpack_require__("DAOZ")
}
var App_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var App___vue_template_functional__ = false
/* styles */
var App___vue_styles__ = App_injectStyle
/* scopeId */
var App___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var App___vue_module_identifier__ = null
var App_Component = App_normalizeComponent(
  tskjxy_App,
  yingxin_tskjxy_App,
  App___vue_template_functional__,
  App___vue_styles__,
  App___vue_scopeId__,
  App___vue_module_identifier__
)

/* harmony default export */ var src_yingxin_tskjxy_App = (App_Component.exports);

// EXTERNAL MODULE: ./node_modules/vue-router/dist/vue-router.esm.js
var vue_router_esm = __webpack_require__("/ocq");

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/json/stringify.js
var stringify = __webpack_require__("mvHQ");
var stringify_default = /*#__PURE__*/__webpack_require__.n(stringify);

// CONCATENATED MODULE: ./src/store/index.js




vue_esm["default"].use(vuex_esm["a" /* default */]);

var store_state = {
  token: sessionStorage.getItem('access_token') || null,
  // token: sessionStorage.getItem('access_token_yx') || null,
  userInfo: JSON.parse(sessionStorage.getItem('userInfo')) || {},
  flowInfo: JSON.parse(sessionStorage.getItem('flowInfo')) || {},
  currentProcedureInfo: JSON.parse(sessionStorage.getItem('currentProcedureInfo')) || {},
  loanFile: {
    id: '',
    files: [],
    filesData: []
  },
  loanInfo: [{
    name: '缓交类型',
    label: '缓交类型',
    value2: [],
    value: ''
  }, {
    name: '申请金额',
    label: '申请金额',
    value: ''
  }, {
    name: '申请原因',
    label: '申请原因',
    value: ''
  }, {
    name: '审批金额',
    label: '审批金额',
    value: ''
  }, {
    isEdit: 0,
    status: ''
  }],
  addressFile: {
    files: [],
    filesData: []
  },
  addressInfo: JSON.parse(sessionStorage.getItem('addressInfo')) || [{
    name: '原户口省份简称',
    label: '原户口省份简称',
    value2: [],
    value: ''
  }, {
    name: '编号',
    label: '编号',
    value: ''
  }, {
    name: '迁移证号',
    label: '迁移证号',
    value: ''
  }],
  carInfo: JSON.parse(sessionStorage.getItem('carInfo')) || [],
  clothesInfo: JSON.parse(sessionStorage.getItem('clothesInfo')) || [],
  stepListValue: 0,
  itemFormData: {
    isNext: false,
    data: {}
  },
  initFlowInfo: JSON.parse(sessionStorage.getItem('initFlowInfo')) || {},
  accountNotIsExist: false,
  studentInfo: {}
};

var getters = {};

var mutations = {
  Login: function Login(state, token) {
    sessionStorage.setItem('access_token', token);
    // sessionStorage.setItem('access_token_yx', token)
    state.token = token;
  },
  Logout: function Logout(state) {
    sessionStorage.removeItem('access_token');
    // sessionStorage.removeItem('access_token_yx')
    sessionStorage.clear();
    state.token = null;
  },
  userInfo: function userInfo(state, _userInfo) {
    sessionStorage.setItem('userInfo', stringify_default()(_userInfo));
    state.userInfo = _userInfo;
  },
  flowInfo: function flowInfo(state, _flowInfo) {
    sessionStorage.setItem('flowInfo', stringify_default()(_flowInfo));
    state.flowInfo = _flowInfo;
  },
  currentProcedureInfo: function currentProcedureInfo(state, _currentProcedureInfo) {
    sessionStorage.setItem('currentProcedureInfo', stringify_default()(_currentProcedureInfo));
    state.currentProcedureInfo = _currentProcedureInfo;
  },
  loanFile: function loanFile(state, _loanFile) {
    state.loanFile = _loanFile;
  },
  loanInfo: function loanInfo(state, _loanInfo) {
    sessionStorage.setItem('loanInfo', stringify_default()(_loanInfo));
    state.loanInfo = _loanInfo;
  },
  addressFile: function addressFile(state, _addressFile) {
    // localStorage.setItem('addressFile', JSON.stringify(addressFile))
    state.addressFile = _addressFile;
  },
  addressInfo: function addressInfo(state, _addressInfo) {
    sessionStorage.setItem('addressInfo', stringify_default()(_addressInfo));
    state.addressInfo = _addressInfo;
  },
  carInfo: function carInfo(state, _carInfo) {
    sessionStorage.setItem('carInfo', stringify_default()(_carInfo));
    state.carInfo = _carInfo;
  },
  clothesInfo: function clothesInfo(state, _clothesInfo) {
    sessionStorage.setItem('clothesInfo', stringify_default()(_clothesInfo));
    state.clothesInfo = _clothesInfo;
  },
  itemFormData: function itemFormData(state, _itemFormData) {
    state.itemFormData = _itemFormData;
  },
  stepListValue: function stepListValue(state, _stepListValue) {
    state.stepListValue = _stepListValue;
  },
  initFlowInfo: function initFlowInfo(state, _initFlowInfo) {
    state.initFlowInfo = _initFlowInfo;
  },
  accountNotIsExist: function accountNotIsExist(state, _accountNotIsExist) {
    state.accountNotIsExist = _accountNotIsExist;
  },
  studentInfo: function studentInfo(state, _studentInfo) {
    state.studentInfo = _studentInfo;
  }
};
var actions = {
  LoginAction: function LoginAction(context, token) {
    context.commit('Login', token);
  },
  LogoutAction: function LogoutAction(context) {
    context.commit('Logout');
  },
  userInfoAction: function userInfoAction(context, userInfo) {
    context.commit('userInfo', userInfo);
  },
  flowInfoAction: function flowInfoAction(context, flowInfo) {
    context.commit('flowInfo', flowInfo);
  },
  currentProcedureInfoAction: function currentProcedureInfoAction(context, currentProcedureInfo) {
    context.commit('currentProcedureInfo', currentProcedureInfo);
  },
  loanFileAction: function loanFileAction(context, loanFile) {
    context.commit('loanFile', loanFile);
  },
  loanInfoAction: function loanInfoAction(context, loanInfo) {
    context.commit('loanInfo', loanInfo);
  },
  addressFileAction: function addressFileAction(context, addressFile) {
    context.commit('addressFile', addressFile);
  },
  addressInfoAction: function addressInfoAction(context, addressInfo) {
    context.commit('addressInfo', addressInfo);
  },
  carInfoAction: function carInfoAction(context, carInfo) {
    context.commit('carInfo', carInfo);
  },
  clothesInfoAction: function clothesInfoAction(context, clothesInfo) {
    context.commit('clothesInfo', clothesInfo);
  },
  itemFormDataAction: function itemFormDataAction(context, itemFormData) {
    context.commit('itemFormData', itemFormData);
  },
  stepListValueAction: function stepListValueAction(context, stepListValue) {
    context.commit('stepListValue', stepListValue);
  },
  initFlowInfoAction: function initFlowInfoAction(context, _initFlowInfoAction) {
    context.commit('initFlowInfo', _initFlowInfoAction);
  },
  accountNotIsExistAction: function accountNotIsExistAction(context, accountNotIsExist) {
    context.commit('accountNotIsExist', accountNotIsExist);
  },
  studentInfoAction: function studentInfoAction(context, studentInfo) {
    context.commit('studentInfo', studentInfo);
  }
};

// 防止页面刷新vuex中的数据丢失
/* harmony default export */ var store = (new vuex_esm["a" /* default */].Store({
  namespaced: true,
  state: store_state,
  getters: getters,
  mutations: mutations,
  actions: actions
}));

/*
var obj = { name:'Jim' };
var str = JSON.stringify(obj);

//存入
sessionStorage.obj = str;
//读取
str = sessionStorage.obj;
//重新转换为对象
obj = JSON.parse(str);
*/
// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/promise.js
var promise = __webpack_require__("//Fk");
var promise_default = /*#__PURE__*/__webpack_require__.n(promise);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/object/keys.js
var keys = __webpack_require__("fZjL");
var keys_default = /*#__PURE__*/__webpack_require__.n(keys);

// EXTERNAL MODULE: ./node_modules/vux/src/libs/base.js
var base = __webpack_require__("f6Hi");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/icon/index.vue
//
//
//
//

/* harmony default export */ var icon = ({
  name: 'icon',
  props: {
    type: String,
    isMsg: Boolean
  },
  computed: {
    className: function className() {
      // compatible with old type param
      return 'weui-icon weui_icon_' + this.type + ' weui-icon-' + this.type.replace(/_/g, '-');
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/icon/index.vue
//
//
//
//

/* harmony default export */ var components_icon = ({
  name: 'icon',
  props: {
    type: String,
    isMsg: Boolean
  },
  computed: {
    className: function className() {
      // compatible with old type param
      return 'weui-icon weui_icon_' + this.type + ' weui-icon-' + this.type.replace(/_/g, '-');
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d7d30802","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/icon/index.vue
var icon_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',{class:[_vm.className, _vm.isMsg ? 'weui-icon_msg' : '']})}
var icon_staticRenderFns = []
var icon_esExports = { render: icon_render, staticRenderFns: icon_staticRenderFns }
/* harmony default export */ var src_components_icon = (icon_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/icon/index.vue
function icon_injectStyle (ssrContext) {
  __webpack_require__("apLE")
}
var icon_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var icon___vue_template_functional__ = false
/* styles */
var icon___vue_styles__ = icon_injectStyle
/* scopeId */
var icon___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var icon___vue_module_identifier__ = null
var icon_Component = icon_normalizeComponent(
  components_icon,
  src_components_icon,
  icon___vue_template_functional__,
  icon___vue_styles__,
  icon___vue_scopeId__,
  icon___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_icon = (icon_Component.exports);

// EXTERNAL MODULE: ./node_modules/vux/src/components/toast/index.vue + 3 modules
var toast = __webpack_require__("rLAy");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/inline-desc/index.vue
//
//
//
//

/* harmony default export */ var inline_desc = ({
  name: 'inline-desc'
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/inline-desc/index.vue
//
//
//
//

/* harmony default export */ var components_inline_desc = ({
  name: 'inline-desc'
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-291627fe","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/inline-desc/index.vue
var inline_desc_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"vux-label-desc"},[_vm._t("default")],2)}
var inline_desc_staticRenderFns = []
var inline_desc_esExports = { render: inline_desc_render, staticRenderFns: inline_desc_staticRenderFns }
/* harmony default export */ var src_components_inline_desc = (inline_desc_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/inline-desc/index.vue
function inline_desc_injectStyle (ssrContext) {
  __webpack_require__("VASZ")
}
var inline_desc_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var inline_desc___vue_template_functional__ = false
/* styles */
var inline_desc___vue_styles__ = inline_desc_injectStyle
/* scopeId */
var inline_desc___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var inline_desc___vue_module_identifier__ = null
var inline_desc_Component = inline_desc_normalizeComponent(
  components_inline_desc,
  src_components_inline_desc,
  inline_desc___vue_template_functional__,
  inline_desc___vue_styles__,
  inline_desc___vue_scopeId__,
  inline_desc___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_inline_desc = (inline_desc_Component.exports);

// EXTERNAL MODULE: ./node_modules/validator/lib/isEmail.js
var isEmail = __webpack_require__("2LX0");
var isEmail_default = /*#__PURE__*/__webpack_require__.n(isEmail);

// EXTERNAL MODULE: ./node_modules/validator/lib/isMobilePhone.js
var isMobilePhone = __webpack_require__("Ewe+");
var isMobilePhone_default = /*#__PURE__*/__webpack_require__.n(isMobilePhone);

// EXTERNAL MODULE: ./node_modules/vux/src/tools/debounce/index.js
var debounce = __webpack_require__("nror");

// EXTERNAL MODULE: ./node_modules/vanilla-masker/lib/vanilla-masker.js
var vanilla_masker = __webpack_require__("lFEC");
var vanilla_masker_default = /*#__PURE__*/__webpack_require__.n(vanilla_masker);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/x-input/index.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//













var validators = {
  'email': {
    fn: isEmail_default.a,
    msg: '邮箱格式'
  },
  'china-mobile': {
    fn: function fn(str) {
      return isMobilePhone_default()(str, 'zh-CN');
    },

    msg: '手机号码'
  },
  'china-name': {
    fn: function fn(str) {
      return str.length >= 2 && str.length <= 6;
    },

    msg: '中文姓名'
  }
};
/* harmony default export */ var x_input = ({
  name: 'x-input',
  created: function created() {
    var _this = this;

    this.currentValue = this.value === undefined || this.value === null ? '' : this.mask ? this.maskValue(this.value) : this.value;
    /* istanbul ignore if */
    if (false) {
      if (!this.title && !this.placeholder && !this.currentValue) {
        console.warn('no title and no placeholder?');
      }
    }

    if (this.required && (typeof this.currentValue === 'undefined' || this.currentValue === '')) {
      this.valid = false;
    }
    this.handleChangeEvent = true;
    if (this.debounce) {
      this._debounce = Object(debounce["a" /* default */])(function () {
        _this.$emit('on-change', _this.currentValue);
      }, this.debounce);
    }
  },
  beforeMount: function beforeMount() {
    if (this.$slots && this.$slots['restricted-label']) {
      this.hasRestrictedLabel = true;
    }
    if (this.$slots && this.$slots['right-full-height']) {
      this.hasRightFullHeightSlot = true;
    }
  },
  beforeDestroy: function beforeDestroy() {
    if (this._debounce) {
      this._debounce.cancel();
    }
    window.removeEventListener('resize', this.scrollIntoView);
  },

  mixins: [base["a" /* default */]],
  components: {
    Icon: vux_src_components_icon,
    InlineDesc: vux_src_components_inline_desc,
    Toast: toast["a" /* default */]
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: 'text'
    },
    placeholder: String,
    value: [String, Number],
    name: String,
    readonly: Boolean,
    disabled: Boolean,
    keyboard: String,
    inlineDesc: String,
    isType: [String, Function],
    min: Number,
    max: Number,
    showClear: {
      type: Boolean,
      default: true
    },
    equalWith: String,
    textAlign: String,
    // https://github.com/yisibl/blog/issues/3
    autocomplete: {
      type: String,
      default: 'off'
    },
    autocapitalize: {
      type: String,
      default: 'off'
    },
    autocorrect: {
      type: String,
      default: 'off'
    },
    spellcheck: {
      type: String,
      default: 'false'
    },
    novalidate: {
      type: Boolean,
      default: false
    },
    iconType: String,
    debounce: Number,
    placeholderAlign: String,
    labelWidth: String,
    mask: String,
    shouldToastError: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    labelStyles: function labelStyles() {
      return {
        width: this.labelWidthComputed || this.$parent.labelWidth || this.labelWidthComputed,
        textAlign: this.$parent.labelAlign,
        marginRight: this.$parent.labelMarginRight
      };
    },
    labelClass: function labelClass() {
      return {
        'vux-cell-justify': this.$parent.labelAlign === 'justify' || this.$parent.$parent.labelAlign === 'justify'
      };
    },
    pattern: function pattern() {
      if (this.keyboard === 'number' || this.isType === 'china-mobile') {
        return '[0-9]*';
      }
    },
    labelWidthComputed: function labelWidthComputed() {
      var width = this.title.replace(/[^x00-xff]/g, '00').length / 2 + 1;
      if (width < 10) {
        return width + 'em';
      }
    },
    hasErrors: function hasErrors() {
      return keys_default()(this.errors).length > 0;
    },
    inputStyle: function inputStyle() {
      if (this.textAlign) {
        return {
          textAlign: this.textAlign
        };
      }
    },
    showWarn: function showWarn() {
      return !this.novalidate && !this.equalWith && !this.valid && this.firstError && (this.touched || this.forceShowError);
    }
  },
  mounted: function mounted() {
    window.addEventListener('resize', this.scrollIntoView);
  },

  methods: {
    scrollIntoView: function scrollIntoView() {
      var _this2 = this;

      var time = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      // alert('scroll into view')
      if (/iphone/i.test(navigator.userAgent)) {
        // return
      }
      if (document.activeElement.tagName === 'INPUT' || document.activeElement.tagName === 'TEXTAREA') {
        // alert('will scroll')
        setTimeout(function () {
          // alert(this.$refs.input.length)
          _this2.$refs.input.scrollIntoViewIfNeeded(true);
        }, time);
      }
    },
    onClickErrorIcon: function onClickErrorIcon() {
      if (this.shouldToastError && this.firstError) {
        this.showErrorToast = true;
      }
      this.$emit('on-click-error-icon', this.firstError);
    },
    maskValue: function maskValue(val) {
      var val1 = this.mask ? vanilla_masker_default.a.toPattern(val, this.mask) : val;
      return val1;
    },
    reset: function reset() {
      var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

      this.dirty = false;
      this.currentValue = value;
      this.firstError = '';
      this.valid = true;
    },
    clear: function clear() {
      this.currentValue = '';
      this.focus();
      this.$emit('on-click-clear-icon');
    },
    focus: function focus() {
      this.$refs.input.focus();
    },
    blur: function blur() {
      this.$refs.input.blur();
    },
    focusHandler: function focusHandler($event) {
      var _this3 = this;

      this.$emit('on-focus', this.currentValue, $event);
      this.isFocus = true;
      // this.scrollIntoView(500)
      // this.scrollIntoView(5000)
      setTimeout(function () {
        _this3.$refs.input.scrollIntoViewIfNeeded(false);
        // this.$refs.input.scrollIntoViewIfNeeded()
      }, 1000);
      // $event.target.
    },
    onBlur: function onBlur($event) {
      this.setTouched();
      this.validate();
      this.isFocus = false;
      this.$emit('on-blur', this.currentValue, $event);
    },
    onKeyUp: function onKeyUp(e) {
      if (e.key === 'Enter') {
        e.target.blur();
        this.$emit('on-enter', this.currentValue, e);
      }
    },
    getError: function getError() {
      var key = keys_default()(this.errors)[0];
      this.firstError = this.errors[key];
    },
    validate: function validate() {
      if (typeof this.equalWith !== 'undefined') {
        this.validateEqual();
        return;
      }
      this.errors = {};

      if (!this.currentValue && !this.required) {
        this.valid = true;
        return;
      }

      if (!this.currentValue && this.required) {
        this.valid = false;
        this.errors.required = '必填哦';
        this.getError();
        return;
      }

      if (typeof this.isType === 'string') {
        var validator = validators[this.isType];
        if (validator) {
          var value = this.currentValue;

          if (this.isType === 'china-mobile' && this.mask === '999 9999 9999') {
            value = this.currentValue.replace(/\s+/g, '');
          }

          this.valid = validator['fn'](value);
          if (!this.valid) {
            this.forceShowError = true;
            this.errors.format = validator['msg'] + '格式不对哦~';
            this.getError();
            return;
          } else {
            delete this.errors.format;
          }
        }
      }

      if (typeof this.isType === 'function') {
        var validStatus = this.isType(this.currentValue);
        this.valid = validStatus.valid;
        if (!this.valid) {
          this.errors.format = validStatus.msg;
          this.forceShowError = true;
          this.getError();
          return;
        } else {
          delete this.errors.format;
        }
      }

      if (this.min) {
        if (this.currentValue.length < this.min) {
          this.errors.min = '\u6700\u5C11\u5E94\u8BE5\u8F93\u5165' + this.min + '\u4E2A\u5B57\u7B26\u54E6';
          this.valid = false;
          this.getError();
          return;
        } else {
          delete this.errors.min;
        }
      }

      if (this.max) {
        if (this.currentValue.length > this.max) {
          this.errors.max = '\u6700\u591A\u53EF\u4EE5\u8F93\u5165' + this.max + '\u4E2A\u5B57\u7B26\u54E6';
          this.valid = false;
          this.forceShowError = true;
          return;
        } else {
          this.forceShowError = false;
          delete this.errors.max;
        }
      }

      this.valid = true;
    },
    validateEqual: function validateEqual() {
      if (!this.equalWith && this.currentValue) {
        this.valid = false;
        this.errors.equal = '输入不一致';
        return;
      }
      var willCheck = this.dirty || this.currentValue.length >= this.equalWith.length;
      // 只在长度符合时显示正确与否
      if (willCheck && this.currentValue !== this.equalWith) {
        this.valid = false;
        this.errors.equal = '输入不一致';
        return;
      } else {
        if (!this.currentValue && this.required) {
          this.valid = false;
        } else {
          this.valid = true;
          delete this.errors.equal;
        }
      }
    },

    // #2810
    _getInputMaskSelection: function _getInputMaskSelection(selection, direction, maskVal, loop) {
      if (!this.mask || loop && direction === 0) {
        return selection;
      }
      if (direction === 0) {
        direction = this.lastDirection;
      }
      if (direction > 0) {
        var maskChar = this.mask.substr(selection - direction, 1);
        if (!maskChar.match(/[9SA]/)) {
          return this._getInputMaskSelection(selection + 1, direction, maskVal, true);
        }
      }
      return selection;
    }
  },
  data: function data() {
    return {
      hasRightFullHeightSlot: false,
      hasRestrictedLabel: false,
      firstError: '',
      forceShowError: false,
      hasLengthEqual: false,
      valid: true,
      currentValue: '',
      showErrorToast: false,
      isFocus: false
    };
  },

  watch: {
    mask: function mask(val) {
      if (val && this.currentValue) {
        this.currentValue = this.maskValue(this.currentValue);
      }
    },
    valid: function valid() {
      this.getError();
    },
    value: function value(val) {
      this.currentValue = val;
    },
    equalWith: function equalWith(newVal) {
      if (newVal && this.equalWith) {
        if (newVal.length === this.equalWith.length) {
          this.hasLengthEqual = true;
        }
        this.validateEqual();
      } else {
        this.validate();
      }
    },
    currentValue: function currentValue(newVal, oldVal) {
      var _this4 = this;

      if (!this.equalWith && newVal) {
        this.validateEqual();
      }
      if (newVal && this.equalWith) {
        if (newVal.length === this.equalWith.length) {
          this.hasLengthEqual = true;
        }
        this.validateEqual();
      } else {
        this.validate();
      }

      var selection = this.$refs.input.selectionStart;
      var direction = newVal.length - oldVal.length;
      selection = this._getInputMaskSelection(selection, direction, this.maskValue(newVal));
      this.lastDirection = direction;
      this.$emit('input', this.maskValue(newVal));
      // #2810
      this.$nextTick(function () {
        if (_this4.$refs.input.selectionStart !== selection) {
          _this4.$refs.input.selectionStart = selection;
          _this4.$refs.input.selectionEnd = selection;
        }
        if (_this4.currentValue !== _this4.maskValue(newVal)) {
          _this4.currentValue = _this4.maskValue(newVal);
        }
      });

      if (this._debounce) {
        this._debounce();
      } else {
        this.$emit('on-change', newVal);
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/x-input/index.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//













var x_input_validators = {
  'email': {
    fn: isEmail_default.a,
    msg: '邮箱格式'
  },
  'china-mobile': {
    fn: function fn(str) {
      return isMobilePhone_default()(str, 'zh-CN');
    },

    msg: '手机号码'
  },
  'china-name': {
    fn: function fn(str) {
      return str.length >= 2 && str.length <= 6;
    },

    msg: '中文姓名'
  }
};
/* harmony default export */ var components_x_input = ({
  name: 'x-input',
  created: function created() {
    var _this = this;

    this.currentValue = this.value === undefined || this.value === null ? '' : this.mask ? this.maskValue(this.value) : this.value;
    /* istanbul ignore if */
    if (false) {
      if (!this.title && !this.placeholder && !this.currentValue) {
        console.warn('no title and no placeholder?');
      }
    }

    if (this.required && (typeof this.currentValue === 'undefined' || this.currentValue === '')) {
      this.valid = false;
    }
    this.handleChangeEvent = true;
    if (this.debounce) {
      this._debounce = Object(debounce["a" /* default */])(function () {
        _this.$emit('on-change', _this.currentValue);
      }, this.debounce);
    }
  },
  beforeMount: function beforeMount() {
    if (this.$slots && this.$slots['restricted-label']) {
      this.hasRestrictedLabel = true;
    }
    if (this.$slots && this.$slots['right-full-height']) {
      this.hasRightFullHeightSlot = true;
    }
  },
  beforeDestroy: function beforeDestroy() {
    if (this._debounce) {
      this._debounce.cancel();
    }
    window.removeEventListener('resize', this.scrollIntoView);
  },

  mixins: [base["a" /* default */]],
  components: {
    Icon: vux_src_components_icon,
    InlineDesc: vux_src_components_inline_desc,
    Toast: toast["a" /* default */]
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: 'text'
    },
    placeholder: String,
    value: [String, Number],
    name: String,
    readonly: Boolean,
    disabled: Boolean,
    keyboard: String,
    inlineDesc: String,
    isType: [String, Function],
    min: Number,
    max: Number,
    showClear: {
      type: Boolean,
      default: true
    },
    equalWith: String,
    textAlign: String,
    // https://github.com/yisibl/blog/issues/3
    autocomplete: {
      type: String,
      default: 'off'
    },
    autocapitalize: {
      type: String,
      default: 'off'
    },
    autocorrect: {
      type: String,
      default: 'off'
    },
    spellcheck: {
      type: String,
      default: 'false'
    },
    novalidate: {
      type: Boolean,
      default: false
    },
    iconType: String,
    debounce: Number,
    placeholderAlign: String,
    labelWidth: String,
    mask: String,
    shouldToastError: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    labelStyles: function labelStyles() {
      return {
        width: this.labelWidthComputed || this.$parent.labelWidth || this.labelWidthComputed,
        textAlign: this.$parent.labelAlign,
        marginRight: this.$parent.labelMarginRight
      };
    },
    labelClass: function labelClass() {
      return {
        'vux-cell-justify': this.$parent.labelAlign === 'justify' || this.$parent.$parent.labelAlign === 'justify'
      };
    },
    pattern: function pattern() {
      if (this.keyboard === 'number' || this.isType === 'china-mobile') {
        return '[0-9]*';
      }
    },
    labelWidthComputed: function labelWidthComputed() {
      var width = this.title.replace(/[^x00-xff]/g, '00').length / 2 + 1;
      if (width < 10) {
        return width + 'em';
      }
    },
    hasErrors: function hasErrors() {
      return keys_default()(this.errors).length > 0;
    },
    inputStyle: function inputStyle() {
      if (this.textAlign) {
        return {
          textAlign: this.textAlign
        };
      }
    },
    showWarn: function showWarn() {
      return !this.novalidate && !this.equalWith && !this.valid && this.firstError && (this.touched || this.forceShowError);
    }
  },
  mounted: function mounted() {
    window.addEventListener('resize', this.scrollIntoView);
  },

  methods: {
    scrollIntoView: function scrollIntoView() {
      var _this2 = this;

      var time = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      // alert('scroll into view')
      if (/iphone/i.test(navigator.userAgent)) {
        // return
      }
      if (document.activeElement.tagName === 'INPUT' || document.activeElement.tagName === 'TEXTAREA') {
        // alert('will scroll')
        setTimeout(function () {
          // alert(this.$refs.input.length)
          _this2.$refs.input.scrollIntoViewIfNeeded(true);
        }, time);
      }
    },
    onClickErrorIcon: function onClickErrorIcon() {
      if (this.shouldToastError && this.firstError) {
        this.showErrorToast = true;
      }
      this.$emit('on-click-error-icon', this.firstError);
    },
    maskValue: function maskValue(val) {
      var val1 = this.mask ? vanilla_masker_default.a.toPattern(val, this.mask) : val;
      return val1;
    },
    reset: function reset() {
      var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

      this.dirty = false;
      this.currentValue = value;
      this.firstError = '';
      this.valid = true;
    },
    clear: function clear() {
      this.currentValue = '';
      this.focus();
      this.$emit('on-click-clear-icon');
    },
    focus: function focus() {
      this.$refs.input.focus();
    },
    blur: function blur() {
      this.$refs.input.blur();
    },
    focusHandler: function focusHandler($event) {
      var _this3 = this;

      this.$emit('on-focus', this.currentValue, $event);
      this.isFocus = true;
      // this.scrollIntoView(500)
      // this.scrollIntoView(5000)
      setTimeout(function () {
        _this3.$refs.input.scrollIntoViewIfNeeded(false);
        // this.$refs.input.scrollIntoViewIfNeeded()
      }, 1000);
      // $event.target.
    },
    onBlur: function onBlur($event) {
      this.setTouched();
      this.validate();
      this.isFocus = false;
      this.$emit('on-blur', this.currentValue, $event);
    },
    onKeyUp: function onKeyUp(e) {
      if (e.key === 'Enter') {
        e.target.blur();
        this.$emit('on-enter', this.currentValue, e);
      }
    },
    getError: function getError() {
      var key = keys_default()(this.errors)[0];
      this.firstError = this.errors[key];
    },
    validate: function validate() {
      if (typeof this.equalWith !== 'undefined') {
        this.validateEqual();
        return;
      }
      this.errors = {};

      if (!this.currentValue && !this.required) {
        this.valid = true;
        return;
      }

      if (!this.currentValue && this.required) {
        this.valid = false;
        this.errors.required = '必填哦';
        this.getError();
        return;
      }

      if (typeof this.isType === 'string') {
        var validator = x_input_validators[this.isType];
        if (validator) {
          var value = this.currentValue;

          if (this.isType === 'china-mobile' && this.mask === '999 9999 9999') {
            value = this.currentValue.replace(/\s+/g, '');
          }

          this.valid = validator['fn'](value);
          if (!this.valid) {
            this.forceShowError = true;
            this.errors.format = validator['msg'] + '格式不对哦~';
            this.getError();
            return;
          } else {
            delete this.errors.format;
          }
        }
      }

      if (typeof this.isType === 'function') {
        var validStatus = this.isType(this.currentValue);
        this.valid = validStatus.valid;
        if (!this.valid) {
          this.errors.format = validStatus.msg;
          this.forceShowError = true;
          this.getError();
          return;
        } else {
          delete this.errors.format;
        }
      }

      if (this.min) {
        if (this.currentValue.length < this.min) {
          this.errors.min = '\u6700\u5C11\u5E94\u8BE5\u8F93\u5165' + this.min + '\u4E2A\u5B57\u7B26\u54E6';
          this.valid = false;
          this.getError();
          return;
        } else {
          delete this.errors.min;
        }
      }

      if (this.max) {
        if (this.currentValue.length > this.max) {
          this.errors.max = '\u6700\u591A\u53EF\u4EE5\u8F93\u5165' + this.max + '\u4E2A\u5B57\u7B26\u54E6';
          this.valid = false;
          this.forceShowError = true;
          return;
        } else {
          this.forceShowError = false;
          delete this.errors.max;
        }
      }

      this.valid = true;
    },
    validateEqual: function validateEqual() {
      if (!this.equalWith && this.currentValue) {
        this.valid = false;
        this.errors.equal = '输入不一致';
        return;
      }
      var willCheck = this.dirty || this.currentValue.length >= this.equalWith.length;
      // 只在长度符合时显示正确与否
      if (willCheck && this.currentValue !== this.equalWith) {
        this.valid = false;
        this.errors.equal = '输入不一致';
        return;
      } else {
        if (!this.currentValue && this.required) {
          this.valid = false;
        } else {
          this.valid = true;
          delete this.errors.equal;
        }
      }
    },

    // #2810
    _getInputMaskSelection: function _getInputMaskSelection(selection, direction, maskVal, loop) {
      if (!this.mask || loop && direction === 0) {
        return selection;
      }
      if (direction === 0) {
        direction = this.lastDirection;
      }
      if (direction > 0) {
        var maskChar = this.mask.substr(selection - direction, 1);
        if (!maskChar.match(/[9SA]/)) {
          return this._getInputMaskSelection(selection + 1, direction, maskVal, true);
        }
      }
      return selection;
    }
  },
  data: function data() {
    return {
      hasRightFullHeightSlot: false,
      hasRestrictedLabel: false,
      firstError: '',
      forceShowError: false,
      hasLengthEqual: false,
      valid: true,
      currentValue: '',
      showErrorToast: false,
      isFocus: false
    };
  },

  watch: {
    mask: function mask(val) {
      if (val && this.currentValue) {
        this.currentValue = this.maskValue(this.currentValue);
      }
    },
    valid: function valid() {
      this.getError();
    },
    value: function value(val) {
      this.currentValue = val;
    },
    equalWith: function equalWith(newVal) {
      if (newVal && this.equalWith) {
        if (newVal.length === this.equalWith.length) {
          this.hasLengthEqual = true;
        }
        this.validateEqual();
      } else {
        this.validate();
      }
    },
    currentValue: function currentValue(newVal, oldVal) {
      var _this4 = this;

      if (!this.equalWith && newVal) {
        this.validateEqual();
      }
      if (newVal && this.equalWith) {
        if (newVal.length === this.equalWith.length) {
          this.hasLengthEqual = true;
        }
        this.validateEqual();
      } else {
        this.validate();
      }

      var selection = this.$refs.input.selectionStart;
      var direction = newVal.length - oldVal.length;
      selection = this._getInputMaskSelection(selection, direction, this.maskValue(newVal));
      this.lastDirection = direction;
      this.$emit('input', this.maskValue(newVal));
      // #2810
      this.$nextTick(function () {
        if (_this4.$refs.input.selectionStart !== selection) {
          _this4.$refs.input.selectionStart = selection;
          _this4.$refs.input.selectionEnd = selection;
        }
        if (_this4.currentValue !== _this4.maskValue(newVal)) {
          _this4.currentValue = _this4.maskValue(newVal);
        }
      });

      if (this._debounce) {
        this._debounce();
      } else {
        this.$emit('on-change', newVal);
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d6629626","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/x-input/index.vue
var x_input_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-x-input weui-cell",class:{
			'weui-cell_warn': _vm.showWarn,
			'disabled': _vm.disabled,
			'vux-x-input-has-right-full': _vm.hasRightFullHeightSlot
		}},[_c('div',{staticClass:"weui-cell__hd"},[(_vm.hasRestrictedLabel)?_c('div',{style:(_vm.labelStyles)},[_vm._t("restricted-label")],2):_vm._e(),_vm._v(" "),_vm._t("label",[(_vm.title)?_c('label',{staticClass:"weui-label",class:_vm.labelClass,style:({width: _vm.labelWidth || _vm.$parent.labelWidth || _vm.labelWidthComputed, textAlign: _vm.$parent.labelAlign, marginRight: _vm.$parent.labelMarginRight}),attrs:{"for":("vux-x-input-" + _vm.uuid)},domProps:{"innerHTML":_vm._s(_vm.title)}}):_vm._e(),_vm._v(" "),(_vm.inlineDesc)?_c('inline-desc',[_vm._v(_vm._s(_vm.inlineDesc))]):_vm._e()])],2),_vm._v(" "),_c('div',{staticClass:"weui-cell__bd weui-cell__primary",class:_vm.placeholderAlign ? ("vux-x-input-placeholder-" + _vm.placeholderAlign) : ''},[(!_vm.type || _vm.type === 'text')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentValue),expression:"currentValue"}],ref:"input",staticClass:"weui-input",style:(_vm.inputStyle),attrs:{"id":("vux-x-input-" + _vm.uuid),"maxlength":_vm.max,"autocomplete":_vm.autocomplete,"autocapitalize":_vm.autocapitalize,"autocorrect":_vm.autocorrect,"spellcheck":_vm.spellcheck,"type":"text","name":_vm.name,"pattern":_vm.pattern,"placeholder":_vm.placeholder,"readonly":_vm.readonly,"disabled":_vm.disabled},domProps:{"value":(_vm.currentValue)},on:{"focus":_vm.focusHandler,"blur":_vm.onBlur,"keyup":_vm.onKeyUp,"input":function($event){if($event.target.composing){ return; }_vm.currentValue=$event.target.value}}}):_vm._e(),_vm._v(" "),(_vm.type === 'number')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentValue),expression:"currentValue"}],ref:"input",staticClass:"weui-input",style:(_vm.inputStyle),attrs:{"id":("vux-x-input-" + _vm.uuid),"maxlength":_vm.max,"autocomplete":_vm.autocomplete,"autocapitalize":_vm.autocapitalize,"autocorrect":_vm.autocorrect,"spellcheck":_vm.spellcheck,"type":"number","name":_vm.name,"pattern":_vm.pattern,"placeholder":_vm.placeholder,"readonly":_vm.readonly,"disabled":_vm.disabled},domProps:{"value":(_vm.currentValue)},on:{"focus":_vm.focusHandler,"blur":_vm.onBlur,"keyup":_vm.onKeyUp,"input":function($event){if($event.target.composing){ return; }_vm.currentValue=$event.target.value}}}):_vm._e(),_vm._v(" "),(_vm.type === 'email')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentValue),expression:"currentValue"}],ref:"input",staticClass:"weui-input",style:(_vm.inputStyle),attrs:{"id":("vux-x-input-" + _vm.uuid),"maxlength":_vm.max,"autocomplete":_vm.autocomplete,"autocapitalize":_vm.autocapitalize,"autocorrect":_vm.autocorrect,"spellcheck":_vm.spellcheck,"type":"email","name":_vm.name,"pattern":_vm.pattern,"placeholder":_vm.placeholder,"readonly":_vm.readonly,"disabled":_vm.disabled},domProps:{"value":(_vm.currentValue)},on:{"focus":_vm.focusHandler,"blur":_vm.onBlur,"keyup":_vm.onKeyUp,"input":function($event){if($event.target.composing){ return; }_vm.currentValue=$event.target.value}}}):_vm._e(),_vm._v(" "),(_vm.type === 'password')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentValue),expression:"currentValue"}],ref:"input",staticClass:"weui-input",style:(_vm.inputStyle),attrs:{"id":("vux-x-input-" + _vm.uuid),"maxlength":_vm.max,"autocomplete":_vm.autocomplete,"autocapitalize":_vm.autocapitalize,"autocorrect":_vm.autocorrect,"spellcheck":_vm.spellcheck,"type":"password","name":_vm.name,"pattern":_vm.pattern,"placeholder":_vm.placeholder,"readonly":_vm.readonly,"disabled":_vm.disabled},domProps:{"value":(_vm.currentValue)},on:{"focus":_vm.focusHandler,"blur":_vm.onBlur,"keyup":_vm.onKeyUp,"input":function($event){if($event.target.composing){ return; }_vm.currentValue=$event.target.value}}}):_vm._e(),_vm._v(" "),(_vm.type === 'tel')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentValue),expression:"currentValue"}],ref:"input",staticClass:"weui-input",style:(_vm.inputStyle),attrs:{"id":("vux-x-input-" + _vm.uuid),"maxlength":_vm.max,"autocomplete":_vm.autocomplete,"autocapitalize":_vm.autocapitalize,"autocorrect":_vm.autocorrect,"spellcheck":_vm.spellcheck,"type":"tel","name":_vm.name,"pattern":_vm.pattern,"placeholder":_vm.placeholder,"readonly":_vm.readonly,"disabled":_vm.disabled},domProps:{"value":(_vm.currentValue)},on:{"focus":_vm.focusHandler,"blur":_vm.onBlur,"keyup":_vm.onKeyUp,"input":function($event){if($event.target.composing){ return; }_vm.currentValue=$event.target.value}}}):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"weui-cell__ft"},[_c('icon',{directives:[{name:"show",rawName:"v-show",value:(!_vm.hasRightFullHeightSlot && !_vm.equalWith && _vm.showClear && _vm.currentValue !== '' && !_vm.readonly && !_vm.disabled && _vm.isFocus),expression:"!hasRightFullHeightSlot && !equalWith && showClear && currentValue !== '' && !readonly && !disabled && isFocus"}],attrs:{"type":"clear"},nativeOn:{"click":function($event){return _vm.clear($event)}}}),_vm._v(" "),_c('icon',{directives:[{name:"show",rawName:"v-show",value:(_vm.showWarn),expression:"showWarn"}],staticClass:"vux-input-icon",attrs:{"type":"warn","title":!_vm.valid ? _vm.firstError : ''},nativeOn:{"click":function($event){return _vm.onClickErrorIcon($event)}}}),_vm._v(" "),(!_vm.novalidate && _vm.hasLengthEqual && _vm.dirty && _vm.equalWith && !_vm.valid)?_c('icon',{staticClass:"vux-input-icon",attrs:{"type":"warn"},nativeOn:{"click":function($event){return _vm.onClickErrorIcon($event)}}}):_vm._e(),_vm._v(" "),_c('icon',{directives:[{name:"show",rawName:"v-show",value:(!_vm.novalidate && _vm.equalWith && _vm.equalWith === _vm.currentValue && _vm.valid),expression:"!novalidate && equalWith && equalWith === currentValue && valid"}],attrs:{"type":"success"}}),_vm._v(" "),_c('icon',{directives:[{name:"show",rawName:"v-show",value:(_vm.novalidate && _vm.iconType === 'success'),expression:"novalidate && iconType === 'success'"}],staticClass:"vux-input-icon",attrs:{"type":"success"}}),_vm._v(" "),_c('icon',{directives:[{name:"show",rawName:"v-show",value:(_vm.novalidate && _vm.iconType === 'error'),expression:"novalidate && iconType === 'error'"}],staticClass:"vux-input-icon",attrs:{"type":"warn"}}),_vm._v(" "),_vm._t("right"),_vm._v(" "),(_vm.hasRightFullHeightSlot)?_c('div',{staticClass:"vux-x-input-right-full"},[_vm._t("right-full-height")],2):_vm._e()],2),_vm._v(" "),_c('toast',{attrs:{"type":"text","width":"auto","time":600},model:{value:(_vm.showErrorToast),callback:function ($$v) {_vm.showErrorToast=$$v},expression:"showErrorToast"}},[_vm._v(_vm._s(_vm.firstError))])],1)}
var x_input_staticRenderFns = []
var x_input_esExports = { render: x_input_render, staticRenderFns: x_input_staticRenderFns }
/* harmony default export */ var src_components_x_input = (x_input_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/x-input/index.vue
function x_input_injectStyle (ssrContext) {
  __webpack_require__("98uI")
}
var x_input_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var x_input___vue_template_functional__ = false
/* styles */
var x_input___vue_styles__ = x_input_injectStyle
/* scopeId */
var x_input___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var x_input___vue_module_identifier__ = null
var x_input_Component = x_input_normalizeComponent(
  components_x_input,
  src_components_x_input,
  x_input___vue_template_functional__,
  x_input___vue_styles__,
  x_input___vue_scopeId__,
  x_input___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_x_input = (x_input_Component.exports);

// EXTERNAL MODULE: ./node_modules/vux/src/libs/router.js
var libs_router = __webpack_require__("0FxO");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/x-button/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var x_button = ({
  name: 'x-button',
  props: {
    type: {
      default: 'default'
    },
    disabled: Boolean,
    mini: Boolean,
    plain: Boolean,
    text: String,
    actionType: String,
    showLoading: Boolean,
    link: [String, Object],
    gradients: {
      type: Array,
      validator: function validator(val) {
        return val.length === 2;
      }
    }
  },
  methods: {
    onClick: function onClick() {
      !this.disabled && Object(libs_router["b" /* go */])(this.link, this.$router);
    }
  },
  computed: {
    noBorder: function noBorder() {
      return Array.isArray(this.gradients);
    },
    buttonStyle: function buttonStyle() {
      if (this.gradients) {
        return {
          background: 'linear-gradient(90deg, ' + this.gradients[0] + ', ' + this.gradients[1] + ')',
          color: '#FFFFFF'
        };
      }
    },
    classes: function classes() {
      return [{
        'weui-btn_disabled': !this.plain && this.disabled,
        'weui-btn_plain-disabled': this.plain && this.disabled,
        'weui-btn_mini': this.mini,
        'vux-x-button-no-border': this.noBorder
      }, !this.plain ? 'weui-btn_' + this.type : '', this.plain ? 'weui-btn_plain-' + this.type : '', this.showLoading ? 'weui-btn_loading' : ''];
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/x-button/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var components_x_button = ({
  name: 'x-button',
  props: {
    type: {
      default: 'default'
    },
    disabled: Boolean,
    mini: Boolean,
    plain: Boolean,
    text: String,
    actionType: String,
    showLoading: Boolean,
    link: [String, Object],
    gradients: {
      type: Array,
      validator: function validator(val) {
        return val.length === 2;
      }
    }
  },
  methods: {
    onClick: function onClick() {
      !this.disabled && Object(libs_router["b" /* go */])(this.link, this.$router);
    }
  },
  computed: {
    noBorder: function noBorder() {
      return Array.isArray(this.gradients);
    },
    buttonStyle: function buttonStyle() {
      if (this.gradients) {
        return {
          background: 'linear-gradient(90deg, ' + this.gradients[0] + ', ' + this.gradients[1] + ')',
          color: '#FFFFFF'
        };
      }
    },
    classes: function classes() {
      return [{
        'weui-btn_disabled': !this.plain && this.disabled,
        'weui-btn_plain-disabled': this.plain && this.disabled,
        'weui-btn_mini': this.mini,
        'vux-x-button-no-border': this.noBorder
      }, !this.plain ? 'weui-btn_' + this.type : '', this.plain ? 'weui-btn_plain-' + this.type : '', this.showLoading ? 'weui-btn_loading' : ''];
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d5f075ca","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/x-button/index.vue
var x_button_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"weui-btn",class:_vm.classes,style:(_vm.buttonStyle),attrs:{"disabled":_vm.disabled,"type":_vm.actionType},on:{"click":_vm.onClick}},[(_vm.showLoading)?_c('i',{staticClass:"weui-loading"}):_vm._e(),_vm._v(" "),_vm._t("default",[_vm._v(_vm._s(_vm.text))])],2)}
var x_button_staticRenderFns = []
var x_button_esExports = { render: x_button_render, staticRenderFns: x_button_staticRenderFns }
/* harmony default export */ var src_components_x_button = (x_button_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/x-button/index.vue
function x_button_injectStyle (ssrContext) {
  __webpack_require__("Fs8M")
}
var x_button_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var x_button___vue_template_functional__ = false
/* styles */
var x_button___vue_styles__ = x_button_injectStyle
/* scopeId */
var x_button___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var x_button___vue_module_identifier__ = null
var x_button_Component = x_button_normalizeComponent(
  components_x_button,
  src_components_x_button,
  x_button___vue_template_functional__,
  x_button___vue_styles__,
  x_button___vue_scopeId__,
  x_button___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_x_button = (x_button_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/loginCaptcha.vue




/* harmony default export */ var loginCaptcha = ({
  name: 'login',
  components: {
    XInput: vux_src_components_x_input,
    XButton: vux_src_components_x_button
  },
  props: {
    loginTitle: '',
    isBtnLoading: false
  },
  data: function data() {
    return {
      loginForm: {
        username: '',
        password: '',
        captcha: '',
        uuid: ''
      },
      userToken: '',
      account: '',
      captchaUrl: ''
    };
  },
  mounted: function mounted() {
    this.accountInfo = JSON.parse(localStorage.getItem('accountInfo'));
    if (this.accountInfo) {
      this.loginForm.username = this.accountInfo.account;
      this.loginForm.password = this.accountInfo.password;
    }
    this.getCaptcha();
  },

  methods: {
    submitLogin: function submitLogin() {
      this.$emit('userInfo', this.loginForm);
      this.$parent.submitLogin();
    },
    getCaptcha: function getCaptcha() {
      var _this = this;

      this.$api.get('/login/captchaPicture', null, function (r) {
        _this.captchaUrl = r.data.captchaPicture;
        _this.loginForm.uuid = r.data.uuid;
      }, function (err) {
        _this.$vux.toast.text(err.message, 'top');
      });
    },
    refreshCaptcha: function refreshCaptcha() {
      this.getCaptcha();
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/loginCaptcha.vue




/* harmony default export */ var components_loginCaptcha = ({
  name: 'login',
  components: {
    XInput: vux_src_components_x_input,
    XButton: vux_src_components_x_button
  },
  props: {
    loginTitle: '',
    isBtnLoading: false
  },
  data: function data() {
    return {
      loginForm: {
        username: '',
        password: '',
        captcha: '',
        uuid: ''
      },
      userToken: '',
      account: '',
      captchaUrl: ''
    };
  },
  mounted: function mounted() {
    this.accountInfo = JSON.parse(localStorage.getItem('accountInfo'));
    if (this.accountInfo) {
      this.loginForm.username = this.accountInfo.account;
      this.loginForm.password = this.accountInfo.password;
    }
    this.getCaptcha();
  },

  methods: {
    submitLogin: function submitLogin() {
      this.$emit('userInfo', this.loginForm);
      this.$parent.submitLogin();
    },
    getCaptcha: function getCaptcha() {
      var _this = this;

      this.$api.get('/login/captchaPicture', null, function (r) {
        _this.captchaUrl = r.data.captchaPicture;
        _this.loginForm.uuid = r.data.uuid;
      }, function (err) {
        _this.$vux.toast.text(err.message, 'top');
      });
    },
    refreshCaptcha: function refreshCaptcha() {
      this.getCaptcha();
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-02968890","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/loginCaptcha.vue
var loginCaptcha_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"login-cms bg-white sub-page page-login-bg"},[_c('h2',{staticClass:"text-center"},[_vm._v(_vm._s(_vm.loginTitle)+"登录")]),_c('div',{staticClass:"login-form input-color-inherit"},[_c('x-input',{attrs:{"type":"text","placeholder":"请输入身份证号","show-clear":false},model:{value:(_vm.loginForm.username),callback:function ($$v) {_vm.$set(_vm.loginForm, "username", $$v)},expression:"loginForm.username"}}),_c('x-input',{attrs:{"type":"password","placeholder":"请输入密码","show-clear":false},model:{value:(_vm.loginForm.password),callback:function ($$v) {_vm.$set(_vm.loginForm, "password", $$v)},expression:"loginForm.password"}}),_c('x-input',{staticClass:"input-captcha",attrs:{"placeholder":"请输入验证码"},model:{value:(_vm.loginForm.captcha),callback:function ($$v) {_vm.$set(_vm.loginForm, "captcha", $$v)},expression:"loginForm.captcha"}},[_c('div',{staticClass:"captchaBox",attrs:{"slot":"right-full-height"},slot:"right-full-height"},[_c('i',{staticClass:"icon-refresh",on:{"click":_vm.refreshCaptcha}}),_c('img',{attrs:{"src":_vm.captchaUrl},on:{"click":_vm.refreshCaptcha}})])]),_c('x-button',{attrs:{"type":"brand","show-loading":_vm.isBtnLoading,"action-type":"button"},nativeOn:{"click":function($event){return _vm.submitLogin($event)}}},[_vm._v(" 登录")])],1)])}
var loginCaptcha_staticRenderFns = []
var loginCaptcha_esExports = { render: loginCaptcha_render, staticRenderFns: loginCaptcha_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_loginCaptcha = (loginCaptcha_esExports);
// CONCATENATED MODULE: ./src/components/loginCaptcha.vue
function loginCaptcha_injectStyle (ssrContext) {
  __webpack_require__("Leuz")
}
var loginCaptcha_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var loginCaptcha___vue_template_functional__ = false
/* styles */
var loginCaptcha___vue_styles__ = loginCaptcha_injectStyle
/* scopeId */
var loginCaptcha___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var loginCaptcha___vue_module_identifier__ = null
var loginCaptcha_Component = loginCaptcha_normalizeComponent(
  components_loginCaptcha,
  selectortype_template_index_0_src_components_loginCaptcha,
  loginCaptcha___vue_template_functional__,
  loginCaptcha___vue_styles__,
  loginCaptcha___vue_scopeId__,
  loginCaptcha___vue_module_identifier__
)

/* harmony default export */ var src_components_loginCaptcha = (loginCaptcha_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/yingxin/tskjxy/views/common/login.vue


//
//
//
//
//
//



/* harmony default export */ var common_login = ({
  name: 'login',
  props: [],
  components: {
    Login: src_components_loginCaptcha
  },
  data: function data() {
    return {
      loginTitle: '迎新注册离校',
      userInfo: {
        account: '',
        password: '',
        captcha: '',
        uuid: '',
        userType: 0
      },
      flowInfo: {
        flowId: '',
        flowType: ''
      },
      studentId: '',
      isBtnLoading: false
    };
  },
  mounted: function mounted() {},

  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])(['LoginAction', 'userInfoAction', 'flowInfoAction']), {
    refresh: function refresh() {
      this.$router.go(0);
    },
    getUserInfo: function getUserInfo(data) {
      this.userInfo.account = data.username;
      this.userInfo.password = data.password;
      this.userInfo.captcha = data.captcha;
      this.userInfo.uuid = data.uuid;
    },
    submitLogin: function submitLogin() {
      var _this = this;

      if (!this.isBtnLoading) {
        if (this.userInfo.account === '' || this.userInfo.password === '') {
          this.$vux.toast.text('请输入账号密码', 'top');
          this.$refs.child.getCaptcha();
        } else {
          this.isBtnLoading = true;
          var params = this.userInfo;
          this.$api.post('/login/token', params, function (r) {
            _this.isBtnLoading = false;
            _this.getAfterLogin().then(function () {
              _this.$store.dispatch('userInfoAction', _this.userInfo);
            });
            _this.userToken = r.data.access_token;
            _this.$store.dispatch('LoginAction', _this.userToken);
            _this.$vux.toast.text('登录成功', 'top');
            setTimeout(function () {
              _this.$router.push({ 'name': 'home' });
            }, 300);
          }, function (err) {
            _this.isBtnLoading = false;
            _this.$vux.toast.text(err.message, 'top');
            _this.$refs.child.getCaptcha();
          });
        }
      }
      setTimeout(function () {
        _this.isBtnLoading = false;
      }, 20000);
    },
    getAfterLogin: function getAfterLogin() {
      var _this2 = this;

      return new promise_default.a(function (resolve, reject) {
        _this2.$api.get('/user/afterLogin', null, function (r) {
          if (r.data.flowBean) {
            _this2.flowInfo = {
              flowId: r.data.flowBean.id,
              flowType: r.data.flowBean.flowType
            };

            _this2.$store.dispatch('flowInfoAction', _this2.flowInfo);
          } else {
            _this2.$vux.alert.show({
              title: '当前时间您不在办理流程中',
              content: '请于流程开始后再访问',
              onShow: function onShow() {
                // console.log('Plugin: I\'m showing')
              },
              onHide: function onHide() {
                this.$router.push({
                  name: 'login'
                });
              }
            });
          }
          _this2.userInfo = r.data.studentBean;
          // 用户头像
          _this2.$set(_this2.userInfo, 'studentPictureUrl', r.data.studentPictureUrl);
          resolve();
        }, function (err) {
          _this2.$vux.toast.text(err.message, 'top');
        });
      });
    }
  })
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/yingxin/tskjxy/views/common/login.vue


//
//
//
//
//
//



/* harmony default export */ var views_common_login = ({
  name: 'login',
  props: [],
  components: {
    Login: src_components_loginCaptcha
  },
  data: function data() {
    return {
      loginTitle: '迎新注册离校',
      userInfo: {
        account: '',
        password: '',
        captcha: '',
        uuid: '',
        userType: 0
      },
      flowInfo: {
        flowId: '',
        flowType: ''
      },
      studentId: '',
      isBtnLoading: false
    };
  },
  mounted: function mounted() {},

  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])(['LoginAction', 'userInfoAction', 'flowInfoAction']), {
    refresh: function refresh() {
      this.$router.go(0);
    },
    getUserInfo: function getUserInfo(data) {
      this.userInfo.account = data.username;
      this.userInfo.password = data.password;
      this.userInfo.captcha = data.captcha;
      this.userInfo.uuid = data.uuid;
    },
    submitLogin: function submitLogin() {
      var _this = this;

      if (!this.isBtnLoading) {
        if (this.userInfo.account === '' || this.userInfo.password === '') {
          this.$vux.toast.text('请输入账号密码', 'top');
          this.$refs.child.getCaptcha();
        } else {
          this.isBtnLoading = true;
          var params = this.userInfo;
          this.$api.post('/login/token', params, function (r) {
            _this.isBtnLoading = false;
            _this.getAfterLogin().then(function () {
              _this.$store.dispatch('userInfoAction', _this.userInfo);
            });
            _this.userToken = r.data.access_token;
            _this.$store.dispatch('LoginAction', _this.userToken);
            _this.$vux.toast.text('登录成功', 'top');
            setTimeout(function () {
              _this.$router.push({ 'name': 'home' });
            }, 300);
          }, function (err) {
            _this.isBtnLoading = false;
            _this.$vux.toast.text(err.message, 'top');
            _this.$refs.child.getCaptcha();
          });
        }
      }
      setTimeout(function () {
        _this.isBtnLoading = false;
      }, 20000);
    },
    getAfterLogin: function getAfterLogin() {
      var _this2 = this;

      return new promise_default.a(function (resolve, reject) {
        _this2.$api.get('/user/afterLogin', null, function (r) {
          if (r.data.flowBean) {
            _this2.flowInfo = {
              flowId: r.data.flowBean.id,
              flowType: r.data.flowBean.flowType
            };

            _this2.$store.dispatch('flowInfoAction', _this2.flowInfo);
          } else {
            _this2.$vux.alert.show({
              title: '当前时间您不在办理流程中',
              content: '请于流程开始后再访问',
              onShow: function onShow() {
                // console.log('Plugin: I\'m showing')
              },
              onHide: function onHide() {
                this.$router.push({
                  name: 'login'
                });
              }
            });
          }
          _this2.userInfo = r.data.studentBean;
          // 用户头像
          _this2.$set(_this2.userInfo, 'studentPictureUrl', r.data.studentPictureUrl);
          resolve();
        }, function (err) {
          _this2.$vux.toast.text(err.message, 'top');
        });
      });
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-992d2d84","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/yingxin/tskjxy/views/common/login.vue
var login_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"container"},[_c('Login',{ref:"child",attrs:{"loginTitle":_vm.loginTitle,"isBtnLoading":_vm.isBtnLoading},on:{"userInfo":_vm.getUserInfo}})],1)])}
var login_staticRenderFns = []
var login_esExports = { render: login_render, staticRenderFns: login_staticRenderFns }
/* harmony default export */ var tskjxy_views_common_login = (login_esExports);
// CONCATENATED MODULE: ./src/yingxin/tskjxy/views/common/login.vue
var login_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var login___vue_template_functional__ = false
/* styles */
var login___vue_styles__ = null
/* scopeId */
var login___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var login___vue_module_identifier__ = null
var login_Component = login_normalizeComponent(
  views_common_login,
  tskjxy_views_common_login,
  login___vue_template_functional__,
  login___vue_styles__,
  login___vue_scopeId__,
  login___vue_module_identifier__
)

/* harmony default export */ var yingxin_tskjxy_views_common_login = (login_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/regist.vue
//
//
//
//
//
//


/* harmony default export */ var regist = ({
  name: 'regist'
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/regist.vue
//
//
//
//
//
//


/* harmony default export */ var components_regist = ({
  name: 'regist'
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-363f13d1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/regist.vue
var regist_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v("注册")])}
var regist_staticRenderFns = []
var regist_esExports = { render: regist_render, staticRenderFns: regist_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_regist = (regist_esExports);
// CONCATENATED MODULE: ./src/components/regist.vue
function regist_injectStyle (ssrContext) {
  __webpack_require__("edYq")
}
var regist_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var regist___vue_template_functional__ = false
/* styles */
var regist___vue_styles__ = regist_injectStyle
/* scopeId */
var regist___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var regist___vue_module_identifier__ = null
var regist_Component = regist_normalizeComponent(
  components_regist,
  selectortype_template_index_0_src_components_regist,
  regist___vue_template_functional__,
  regist___vue_styles__,
  regist___vue_scopeId__,
  regist___vue_module_identifier__
)

/* harmony default export */ var src_components_regist = (regist_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/yingxin/tskjxy/views/common/regist.vue
//
//
//
//


/* harmony default export */ var common_regist = ({
  name: 'regist',
  props: [],
  components: {
    Regist: src_components_regist
  },
  data: function data() {
    return {};
  },
  created: function created() {},
  mounted: function mounted() {},

  watch: {},
  methods: {}
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/yingxin/tskjxy/views/common/regist.vue
//
//
//
//


/* harmony default export */ var views_common_regist = ({
  name: 'regist',
  props: [],
  components: {
    Regist: src_components_regist
  },
  data: function data() {
    return {};
  },
  created: function created() {},
  mounted: function mounted() {},

  watch: {},
  methods: {}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3a4c3d66","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/yingxin/tskjxy/views/common/regist.vue
var common_regist_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Regist')],1)}
var common_regist_staticRenderFns = []
var common_regist_esExports = { render: common_regist_render, staticRenderFns: common_regist_staticRenderFns }
/* harmony default export */ var tskjxy_views_common_regist = (common_regist_esExports);
// CONCATENATED MODULE: ./src/yingxin/tskjxy/views/common/regist.vue
var common_regist_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var common_regist___vue_template_functional__ = false
/* styles */
var common_regist___vue_styles__ = null
/* scopeId */
var common_regist___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var common_regist___vue_module_identifier__ = null
var common_regist_Component = common_regist_normalizeComponent(
  views_common_regist,
  tskjxy_views_common_regist,
  common_regist___vue_template_functional__,
  common_regist___vue_styles__,
  common_regist___vue_scopeId__,
  common_regist___vue_module_identifier__
)

/* harmony default export */ var yingxin_tskjxy_views_common_regist = (common_regist_Component.exports);

// EXTERNAL MODULE: ./node_modules/object-assign/index.js
var object_assign = __webpack_require__("BEQ0");
var object_assign_default = /*#__PURE__*/__webpack_require__.n(object_assign);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/x-header/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var x_header = ({
  name: 'x-header',
  props: {
    leftOptions: Object,
    title: String,
    transition: String,
    rightOptions: {
      type: Object,
      default: function _default() {
        return {
          showMore: false
        };
      }
    }
  },
  beforeMount: function beforeMount() {
    if (this.$slots['overwrite-title']) {
      this.shouldOverWriteTitle = true;
    }
  },

  computed: {
    _leftOptions: function _leftOptions() {
      return object_assign_default()({
        showBack: true,
        preventGoBack: false
      }, this.leftOptions || {});
    }
  },
  methods: {
    onClickBack: function onClickBack() {
      if (this._leftOptions.preventGoBack) {
        this.$emit('on-click-back');
      } else {
        this.$router ? this.$router.back() : window.history.back();
      }
    }
  },
  data: function data() {
    return {
      shouldOverWriteTitle: false
    };
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/x-header/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var components_x_header = ({
  name: 'x-header',
  props: {
    leftOptions: Object,
    title: String,
    transition: String,
    rightOptions: {
      type: Object,
      default: function _default() {
        return {
          showMore: false
        };
      }
    }
  },
  beforeMount: function beforeMount() {
    if (this.$slots['overwrite-title']) {
      this.shouldOverWriteTitle = true;
    }
  },

  computed: {
    _leftOptions: function _leftOptions() {
      return object_assign_default()({
        showBack: true,
        preventGoBack: false
      }, this.leftOptions || {});
    }
  },
  methods: {
    onClickBack: function onClickBack() {
      if (this._leftOptions.preventGoBack) {
        this.$emit('on-click-back');
      } else {
        this.$router ? this.$router.back() : window.history.back();
      }
    }
  },
  data: function data() {
    return {
      shouldOverWriteTitle: false
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-eb223dbe","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/x-header/index.vue
var x_header_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-header"},[_c('div',{staticClass:"vux-header-left"},[_vm._t("overwrite-left",[_c('transition',{attrs:{"name":_vm.transition}},[_c('a',{directives:[{name:"show",rawName:"v-show",value:(_vm._leftOptions.showBack),expression:"_leftOptions.showBack"}],staticClass:"vux-header-back",on:{"click":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"preventDefault",undefined,$event.key,undefined)){ return null; }},_vm.onClickBack]}},[_vm._v(_vm._s(typeof _vm._leftOptions.backText === 'undefined' ? '返回' : _vm._leftOptions.backText))])]),_vm._v(" "),_c('transition',{attrs:{"name":_vm.transition}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm._leftOptions.showBack),expression:"_leftOptions.showBack"}],staticClass:"left-arrow",on:{"click":_vm.onClickBack}})])]),_vm._v(" "),_vm._t("left")],2),_vm._v(" "),(!_vm.shouldOverWriteTitle)?_c('h1',{staticClass:"vux-header-title",on:{"click":function($event){return _vm.$emit('on-click-title')}}},[_vm._t("default",[_c('transition',{attrs:{"name":_vm.transition}},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.title),expression:"title"}]},[_vm._v(_vm._s(_vm.title))])])])],2):_vm._e(),_vm._v(" "),(_vm.shouldOverWriteTitle)?_c('div',{staticClass:"vux-header-title-area"},[_vm._t("overwrite-title")],2):_vm._e(),_vm._v(" "),_c('div',{staticClass:"vux-header-right"},[(_vm.rightOptions.showMore)?_c('a',{staticClass:"vux-header-more",on:{"click":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"preventDefault",undefined,$event.key,undefined)){ return null; }},function($event){return _vm.$emit('on-click-more')}]}}):_vm._e(),_vm._v(" "),_vm._t("right")],2)])}
var x_header_staticRenderFns = []
var x_header_esExports = { render: x_header_render, staticRenderFns: x_header_staticRenderFns }
/* harmony default export */ var src_components_x_header = (x_header_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/x-header/index.vue
function x_header_injectStyle (ssrContext) {
  __webpack_require__("1qFZ")
}
var x_header_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var x_header___vue_template_functional__ = false
/* styles */
var x_header___vue_styles__ = x_header_injectStyle
/* scopeId */
var x_header___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var x_header___vue_module_identifier__ = null
var x_header_Component = x_header_normalizeComponent(
  components_x_header,
  src_components_x_header,
  x_header___vue_template_functional__,
  x_header___vue_styles__,
  x_header___vue_scopeId__,
  x_header___vue_module_identifier__
)


/* harmony default export */ var vux_src_components_x_header = (x_header_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/error.vue
//
//
//
//
//
//
//
//

/* harmony default export */ var components_error = ({
  name: 'error',
  props: {
    errorMsg: {}
  },
  data: function data() {
    return {};
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/error.vue
//
//
//
//
//
//
//
//

/* harmony default export */ var selectortype_script_index_0_src_components_error = ({
  name: 'error',
  props: {
    errorMsg: {}
  },
  data: function data() {
    return {};
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-78948230","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/error.vue
var error_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"error-box"},[(_vm.errorMsg.type== 'null')?_c('img',{attrs:{"src":__webpack_require__("qUqB")}}):(_vm.errorMsg.type== '404')?_c('img',{attrs:{"src":__webpack_require__("oSoZ")}}):(_vm.errorMsg.type== '500')?_c('img',{attrs:{"src":__webpack_require__("D6RS")}}):_vm._e(),_c('p',{domProps:{"textContent":_vm._s(_vm.errorMsg.content)}})])}
var error_staticRenderFns = []
var error_esExports = { render: error_render, staticRenderFns: error_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_error = (error_esExports);
// CONCATENATED MODULE: ./src/components/error.vue
function error_injectStyle (ssrContext) {
  __webpack_require__("rGAb")
}
var error_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var error___vue_template_functional__ = false
/* styles */
var error___vue_styles__ = error_injectStyle
/* scopeId */
var error___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var error___vue_module_identifier__ = null
var error_Component = error_normalizeComponent(
  selectortype_script_index_0_src_components_error,
  selectortype_template_index_0_src_components_error,
  error___vue_template_functional__,
  error___vue_styles__,
  error___vue_scopeId__,
  error___vue_module_identifier__
)

/* harmony default export */ var src_components_error = (error_Component.exports);

// CONCATENATED MODULE: ./src/assets/scripts/utils.js
/*
 * 当前日期的前几个月
 * 使用 months('2019-05', 6) 返回数组 '["2019-05", "2019-04", ...]'
 */
var months = function months(date, len, res) {
  var dateString = date;
  date = new Date(date);
  res = [];
  for (var i = 0; i < len; i++) {
    date.setMonth(date.getMonth() - 1);
    var m = date.getMonth() + 1;
    m = m < 10 ? '0' + m : m;
    res.push(date.getFullYear() + '-' + m);
  }
  var newDate = new Date(dateString);
  res.unshift(newDate.getFullYear() + '-' + (newDate.getMonth() + 1 < 10 ? '0' + (newDate.getMonth() + 1) : newDate.getMonth() + 1));
  return res;
};

/*
 * 当前日期时间
 * 使用 today('YYYY-MM') 返回 '2019-05', today('YYYY-MM-DD') 返回 '2019-05-20', today() 默认返回包括时分秒
 */
var today = function today(type, Y, M, D, date) {
  var n = new Date();
  Y = n.getFullYear();
  M = n.getMonth() + 1 < 10 ? '0' + (n.getMonth() + 1) : n.getMonth() + 1;
  D = n.getDate() < 10 ? '0' + n.getDate() : n.getDate();
  var HH = n.getHours() < 10 ? '0' + n.getHours() : n.getHours();
  var MM = n.getMinutes() < 10 ? '0' + n.getMinutes() : n.getMinutes();
  var SS = n.getSeconds() < 10 ? '0' + n.getSeconds() : n.getSeconds();
  var parts = ['-', ':', ' '];
  switch (type) {
    case 'YYYY-MM':
      date = Y + parts[0] + M;
      break;
    case 'YYYY-MM-DD':
      date = Y + parts[0] + M + parts[0] + D;
      break;
    case 'MM-DD':
      date = M + parts[0] + D;
      break;
    default:
      date = Y + parts[0] + M + parts[0] + D + parts[2] + HH + parts[1] + MM + parts[1] + SS;
  }
  return date;
};

/*
 * 当前日期的近几天
 * 使用 GetDateStr(3) 或 GetDateStr(-3)
 */

function GetDateStr(AddDayCount) {
  var dd = new Date();
  dd.setDate(dd.getDate() + AddDayCount); // 获取AddDayCount天后的日期
  var y = dd.getFullYear();
  var m = dd.getMonth() + 1 < 10 ? '0' + (dd.getMonth() + 1) : dd.getMonth() + 1; // 获取当前月份的日期，不足10补0
  var d = dd.getDate() < 10 ? '0' + dd.getDate() : dd.getDate(); // 获取当前几号，不足10补0
  return y + '-' + m + '-' + d;
}

/*
 * 计算两个日期是否在几个之内
 * 使用 MonthsBetw('2019-01-01', '2019-12-31', 12), 返回false或true
 */
var MonthsBetw = function MonthsBetw(date1, date2, m) {
  var time1 = new Date(date1);
  var time2 = new Date(date2);
  var diffyear = time2.getFullYear() - time1.getFullYear();
  var diffmonth = diffyear * 12 + time2.getMonth() - time1.getMonth();
  if (diffmonth < 0) {
    return false;
  }
  var diffDay = time2.getDate() - time1.getDate();
  if (diffmonth < m || diffmonth === m && diffDay <= 0) {
    if (diffmonth === m && diffDay === 0) {
      var timeA = time1.getHours() * 3600 + 60 * time1.getMinutes() + time1.getSeconds();
      var timeB = time2.getHours() * 3600 + 60 * time2.getMinutes() + time2.getSeconds();
      if (timeB - timeA > 0) {
        return false;
      }
    }
    return true;
  }
  return false;
};

/*
 * 日期格式转时间戳
 * 使用 timestamp('2019-05') 或 timestamp('2019-05-20')
 */
var timestamp = function timestamp(date) {
  var stamp = new Date(date).getTime();
  return stamp;
};

/*
 * 日期时间格式转时间戳
 * 使用 DatetimeStamp('2014-07-10 10:21:12')
 */
var DatetimeStamp = function DatetimeStamp(datetime) {
  var newDatetime = datetime.replace(/-/g, '/');
  var stamp = Date.parse(new Date(newDatetime)) / 1000;
  return stamp;
};

/*
 * 获得某月的最后一天
 * 使用 LastDay('2019', '5')
 */
var LastDay = function LastDay(year, month) {
  var newYear = year;
  var newMonth = month++;
  if (month > 12) {
    newMonth -= 12;
    newYear++;
  }
  var newDate = new Date(newYear, newMonth, 1);
  return new Date(newDate.getTime() - 1000 * 60 * 60 * 24).getDate();
};
/*
Date difference 计算两个日期的差
*/

var GetDateDiff = function GetDateDiff(date1, date2) {
  var diffTime = Math.abs(new Date(date1).getTime() - new Date(date2).getTime());
  return diffTime / 1000 / 60 / 60 / 24;
};
/*
 * 金额格式化
 * 使用 money(5000, 2), 金额和保留小数点位数
 */
var money = function money(num, point) {
  var pow = Math.pow(10, point);
  num = num.toString().replace(/\$|/g, '');
  if (isNaN(num)) {
    num = '0';
  }
  var sign = Number(num) === (num = Math.abs(num));
  num = Math.floor(num * pow + 0.50000000001);
  var cents = num % pow;
  num = Math.floor(num / pow).toString();
  if (cents < pow / 10) {
    cents = '0' + cents;
  }
  for (var i = 0; i < Math.floor((num.length - (1 + i)) / 3); i++) {
    num = num.substring(0, num.length - (4 * i + 3)) + ',' + num.substring(num.length - (4 * i + 3));
  }
  return (sign ? '' : '-') + num + '.' + cents;
};

/*
 * 隐藏电话显示开头号码段和尾号4位
 * 使用 hidetel('13800138000')
 */
var hidetel = function hidetel(tel) {
  var reg = /^(\d{3})\d{4}(\d{4})$/;
  return tel.replace(reg, '$1****$2');
};
/*
  处理url参数
*/
var getRequest = function getRequest(url) {
  var theRequest = {};
  if (url.indexOf('?') !== -1) {
    // 获取url中"?"符后的字串
    var str = url.substr(url.indexOf('?') + 1);
    var j = url.indexOf('?');
    var k = url.indexOf('#');
    var strs = '';
    if (j > k) {
      strs = str.split('&');
    } else if (j < k) {
      var str2 = str.slice(0, str.indexOf('#'));
      strs = str2.split('&');
    }
    for (var i = 0; i < strs.length; i++) {
      theRequest[strs[i].split('=')[0]] = unescape(strs[i].split('=')[1]);
    }
  }
  return theRequest;
};

/* 文本强制换行
  text  文本内容
  包含sign字符，强制换行
*/
var textWrap = function textWrap(text) {
  var reg = /\$/g;
  var newText = text.replace(reg, '<br/>');
  return newText;
};

/* 日期转中文 */
var dateToZh = function dateToZh(dateStr, format) {
  var dict = {
    '0': '〇',
    '1': '一',
    '2': '二',
    '3': '三',
    '4': '四',
    '5': '五',
    '6': '六',
    '7': '七',
    '8': '八',
    '9': '九',
    '10': '十',
    '11': '十一',
    '12': '十二',
    '13': '十三',
    '14': '十四',
    '15': '十五',
    '16': '十六',
    '17': '十七',
    '18': '十八',
    '19': '十九',
    '20': '二十',
    '21': '二十一',
    '22': '二十二',
    '23': '二十三',
    '24': '二十四',
    '25': '二十五',
    '26': '二十六',
    '27': '二十七',
    '28': '二十八',
    '29': '二十九',
    '30': '三十',
    '31': '三十一'
  };
  var date = dateStr.split('-');
  // console.log(date)
  var yy = date[0];
  var mm = date[1];
  var dd = date[2];
  var yearStr = dict[yy[0]] + dict[yy[1]] + dict[yy[2]] + dict[yy[3]] + '年';
  // console.log(yearStr)
  var monthStr = dict['' + Number(mm)] + '月';
  // console.log(monthStr)
  var dayStr = dict['' + Number(dd)] + '日';
  // console.log(dayStr)
  var dataZh = '';
  switch (format) {
    case 'YYYY-MM':
      dataZh = yearStr + monthStr;
      break;
    case 'YYYY-MM-DD':
      dataZh = yearStr + monthStr + dayStr;
      break;
    case 'MM-DD':
      dataZh = monthStr + dayStr;
      break;
  }
  return dataZh;
};


// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/yingxin/tskjxy/views/common/errorPage.vue






/* harmony default export */ var errorPage = ({
  name: 'errorPage',
  props: [],
  components: {
    XHeader: vux_src_components_x_header,
    Error: src_components_error
  },
  data: function data() {
    return {
      errorMsg: {
        type: '404',
        content: '登录失败 ...'
      }
    };
  },
  created: function created() {
    this.getErrorInfo();
  },
  mounted: function mounted() {},

  methods: {
    getErrorInfo: function getErrorInfo() {
      var error = stringify_default()(getRequest(window.location.href)) !== '{}' ? getRequest(window.location.href).status : null;
      if (error === '404') {
        this.errorMsg.type = '400';
      } else if (error === '500' || error === '501') {
        this.errorMsg.type = '500';
      }
    },
    back: function back() {}
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/yingxin/tskjxy/views/common/errorPage.vue






/* harmony default export */ var common_errorPage = ({
  name: 'errorPage',
  props: [],
  components: {
    XHeader: vux_src_components_x_header,
    Error: src_components_error
  },
  data: function data() {
    return {
      errorMsg: {
        type: '404',
        content: '登录失败 ...'
      }
    };
  },
  created: function created() {
    this.getErrorInfo();
  },
  mounted: function mounted() {},

  methods: {
    getErrorInfo: function getErrorInfo() {
      var error = stringify_default()(getRequest(window.location.href)) !== '{}' ? getRequest(window.location.href).status : null;
      if (error === '404') {
        this.errorMsg.type = '400';
      } else if (error === '500' || error === '501') {
        this.errorMsg.type = '500';
      }
    },
    back: function back() {}
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-acfb3dde","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/yingxin/tskjxy/views/common/errorPage.vue
var errorPage_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('x-header',{staticClass:"header bg-white"},[_c('em',{staticClass:"icon icon-arrow-left",attrs:{"slot":"overwrite-left","size":""},on:{"click":_vm.back},slot:"overwrite-left"}),_vm._v("错误提示")]),_c('error',{staticStyle:{"margin-top":"18vh"},attrs:{"errorMsg":_vm.errorMsg}})],1)}
var errorPage_staticRenderFns = []
var errorPage_esExports = { render: errorPage_render, staticRenderFns: errorPage_staticRenderFns }
/* harmony default export */ var views_common_errorPage = (errorPage_esExports);
// CONCATENATED MODULE: ./src/yingxin/tskjxy/views/common/errorPage.vue
var errorPage_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var errorPage___vue_template_functional__ = false
/* styles */
var errorPage___vue_styles__ = null
/* scopeId */
var errorPage___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var errorPage___vue_module_identifier__ = null
var errorPage_Component = errorPage_normalizeComponent(
  common_errorPage,
  views_common_errorPage,
  errorPage___vue_template_functional__,
  errorPage___vue_styles__,
  errorPage___vue_scopeId__,
  errorPage___vue_module_identifier__
)

/* harmony default export */ var tskjxy_views_common_errorPage = (errorPage_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/flow/flow.vue
//
//
//
//
//
//
//
//
//

/* harmony default export */ var flow = ({
  name: 'flow',
  props: {
    orientation: {
      type: String,
      default: 'horizontal'
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/flow/flow.vue
//
//
//
//
//
//
//
//
//

/* harmony default export */ var flow_flow = ({
  name: 'flow',
  props: {
    orientation: {
      type: String,
      default: 'horizontal'
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-465f3b6e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/flow/flow.vue
var flow_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"weui-wepay-flow",class:{'weui-wepay-flow_vertical': _vm.orientation === 
'vertical'}},[_c('div',{staticClass:"weui-wepay-flow__bd"},[_vm._t("default")],2)])}
var flow_staticRenderFns = []
var flow_esExports = { render: flow_render, staticRenderFns: flow_staticRenderFns }
/* harmony default export */ var components_flow_flow = (flow_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/flow/flow.vue
function flow_injectStyle (ssrContext) {
  __webpack_require__("Fs3p")
}
var flow_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var flow___vue_template_functional__ = false
/* styles */
var flow___vue_styles__ = flow_injectStyle
/* scopeId */
var flow___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var flow___vue_module_identifier__ = null
var flow_Component = flow_normalizeComponent(
  flow_flow,
  components_flow_flow,
  flow___vue_template_functional__,
  flow___vue_styles__,
  flow___vue_scopeId__,
  flow___vue_module_identifier__
)

/* harmony default export */ var src_components_flow_flow = (flow_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/flow/flow-state.vue
//
//
//
//
//
//
//
//
//

/* harmony default export */ var flow_state = ({
  name: 'flow-state',
  props: {
    state: [String, Number],
    title: String,
    isDone: Boolean
  },
  computed: {
    titlePosition: function titlePosition() {
      return this.$parent.orientation === 'vertical' ? 'right' : 'bottom';
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/flow/flow-state.vue
//
//
//
//
//
//
//
//
//

/* harmony default export */ var flow_flow_state = ({
  name: 'flow-state',
  props: {
    state: [String, Number],
    title: String,
    isDone: Boolean
  },
  computed: {
    titlePosition: function titlePosition() {
      return this.$parent.orientation === 'vertical' ? 'right' : 'bottom';
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-06a0b65f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/flow/flow-state.vue
var flow_state_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"weui-wepay-flow__li",class:{'weui-wepay-flow__li_done': _vm.isDone}},[_c('div',{staticClass:"weui-wepay-flow__state"},[_vm._v(_vm._s(_vm.state))]),_vm._v(" "),_c('p',{class:("weui-wepay-flow__title-" + _vm.titlePosition)},[_vm._t("title",[_vm._v(_vm._s(_vm.title))])],2)])}
var flow_state_staticRenderFns = []
var flow_state_esExports = { render: flow_state_render, staticRenderFns: flow_state_staticRenderFns }
/* harmony default export */ var components_flow_flow_state = (flow_state_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/flow/flow-state.vue
var flow_state_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var flow_state___vue_template_functional__ = false
/* styles */
var flow_state___vue_styles__ = null
/* scopeId */
var flow_state___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var flow_state___vue_module_identifier__ = null
var flow_state_Component = flow_state_normalizeComponent(
  flow_flow_state,
  components_flow_flow_state,
  flow_state___vue_template_functional__,
  flow_state___vue_styles__,
  flow_state___vue_scopeId__,
  flow_state___vue_module_identifier__
)

/* harmony default export */ var src_components_flow_flow_state = (flow_state_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/flow/flow-line.vue
//
//
//
//
//
//
//

/* harmony default export */ var flow_line = ({
  name: 'flow-line',
  props: {
    tip: String,
    tipDirection: String,
    isDone: Boolean,
    lineSpan: [Number, String],
    processSpan: [Number, String]
  },
  methods: {
    getWidth: function getWidth(span) {
      return typeof span === 'number' ? span + '%' : span;
    }
  },
  computed: {
    finalTipDirection: function finalTipDirection() {
      if (typeof this.tipDirection === 'undefined') {
        return this.$parent.orientation === 'vertical' ? 'left' : 'top';
      }
      return this.tipDirection;
    },
    styles: function styles() {
      if (!this.lineSpan) {
        return;
      }
      var direction = this.$parent.orientation;
      var styles = {
        flex: 'none',
        '-webkit-box-flex': '0'
      };
      if (direction === 'vertical') {
        styles.width = '3px';
      }
      if (this.lineSpan) {
        if (direction === 'vertical') {
          styles.height = this.getWidth(this.lineSpan);
        } else {
          styles.width = this.getWidth(this.lineSpan);
        }
      }
      return styles;
    },
    classes: function classes() {
      if (this.isDone) {
        return 'weui-wepay-flow__line_done';
      }
      if (!this.isDone && this.tip) {
        return 'weui-wepay-flow__line_ing';
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/flow/flow-line.vue
//
//
//
//
//
//
//

/* harmony default export */ var flow_flow_line = ({
  name: 'flow-line',
  props: {
    tip: String,
    tipDirection: String,
    isDone: Boolean,
    lineSpan: [Number, String],
    processSpan: [Number, String]
  },
  methods: {
    getWidth: function getWidth(span) {
      return typeof span === 'number' ? span + '%' : span;
    }
  },
  computed: {
    finalTipDirection: function finalTipDirection() {
      if (typeof this.tipDirection === 'undefined') {
        return this.$parent.orientation === 'vertical' ? 'left' : 'top';
      }
      return this.tipDirection;
    },
    styles: function styles() {
      if (!this.lineSpan) {
        return;
      }
      var direction = this.$parent.orientation;
      var styles = {
        flex: 'none',
        '-webkit-box-flex': '0'
      };
      if (direction === 'vertical') {
        styles.width = '3px';
      }
      if (this.lineSpan) {
        if (direction === 'vertical') {
          styles.height = this.getWidth(this.lineSpan);
        } else {
          styles.width = this.getWidth(this.lineSpan);
        }
      }
      return styles;
    },
    classes: function classes() {
      if (this.isDone) {
        return 'weui-wepay-flow__line_done';
      }
      if (!this.isDone && this.tip) {
        return 'weui-wepay-flow__line_ing';
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-95f37842","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/flow/flow-line.vue
var flow_line_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"weui-wepay-flow__line",class:_vm.classes,style:(_vm.styles)},[_c('div',{staticClass:"weui-wepay-flow__process",style:({width: _vm.getWidth(this.processSpan)})}),_vm._v(" "),(_vm.tip)?_c('div',{class:("weui-wepay-flow__info-" + _vm.finalTipDirection),style:({left: _vm.getWidth(this.processSpan)})},[_vm._v(_vm._s(_vm.tip))]):_vm._e()])}
var flow_line_staticRenderFns = []
var flow_line_esExports = { render: flow_line_render, staticRenderFns: flow_line_staticRenderFns }
/* harmony default export */ var components_flow_flow_line = (flow_line_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/flow/flow-line.vue
var flow_line_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var flow_line___vue_template_functional__ = false
/* styles */
var flow_line___vue_styles__ = null
/* scopeId */
var flow_line___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var flow_line___vue_module_identifier__ = null
var flow_line_Component = flow_line_normalizeComponent(
  flow_flow_line,
  components_flow_flow_line,
  flow_line___vue_template_functional__,
  flow_line___vue_styles__,
  flow_line___vue_scopeId__,
  flow_line___vue_module_identifier__
)

/* harmony default export */ var src_components_flow_flow_line = (flow_line_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/grid/grid.vue
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var grid = ({
  name: 'grid',
  methods: {
    countColumn: function countColumn() {
      this.childrenSize = this.$children.length;
      this.$children.forEach(function (c, index) {
        return c.index = index;
      });
    }
  },
  props: {
    rows: {
      type: Number,
      validator: function validator() {
        /* istanbul ignore if */
        if (false) {
          console.warn('[VUX warn] Grid rows 属性已经废弃，使用 cols 代替。单行列数为自动计算');
        }
        return true;
      }
    },
    cols: {
      type: Number
    },
    showLrBorders: {
      type: Boolean,
      default: true
    },
    showVerticalDividers: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    column: function column() {
      return this.cols || this.childrenSize;
    }
  },
  data: function data() {
    return {
      childrenSize: 3
    };
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/grid/grid.vue
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var grid_grid = ({
  name: 'grid',
  methods: {
    countColumn: function countColumn() {
      this.childrenSize = this.$children.length;
      this.$children.forEach(function (c, index) {
        return c.index = index;
      });
    }
  },
  props: {
    rows: {
      type: Number,
      validator: function validator() {
        /* istanbul ignore if */
        if (false) {
          console.warn('[VUX warn] Grid rows 属性已经废弃，使用 cols 代替。单行列数为自动计算');
        }
        return true;
      }
    },
    cols: {
      type: Number
    },
    showLrBorders: {
      type: Boolean,
      default: true
    },
    showVerticalDividers: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    column: function column() {
      return this.cols || this.childrenSize;
    }
  },
  data: function data() {
    return {
      childrenSize: 3
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-21378e8c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/grid/grid.vue
var grid_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"weui-grids",class:{
    'vux-grid-no-lr-borders': !_vm.showLrBorders
  }},[_vm._t("default")],2)}
var grid_staticRenderFns = []
var grid_esExports = { render: grid_render, staticRenderFns: grid_staticRenderFns }
/* harmony default export */ var components_grid_grid = (grid_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/grid/grid.vue
function grid_injectStyle (ssrContext) {
  __webpack_require__("egYO")
}
var grid_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var grid___vue_template_functional__ = false
/* styles */
var grid___vue_styles__ = grid_injectStyle
/* scopeId */
var grid___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var grid___vue_module_identifier__ = null
var grid_Component = grid_normalizeComponent(
  grid_grid,
  components_grid_grid,
  grid___vue_template_functional__,
  grid___vue_styles__,
  grid___vue_scopeId__,
  grid___vue_module_identifier__
)

/* harmony default export */ var src_components_grid_grid = (grid_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/grid/grid-item.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var grid_item = ({
  name: 'grid-item',
  props: ['icon', 'label', 'link'],
  created: function created() {
    this.$parent.countColumn();
  },
  mounted: function mounted() {
    this.$slots.icon && (this.hasIconSlot = true);
    this.$slots.label && (this.hasLabelSlot = true);
  },
  destroyed: function destroyed() {
    this.$parent.countColumn();
  },

  computed: {
    isLast: function isLast() {
      return !((this.index + 1) % this.$parent.column);
    },
    style: function style() {
      var column = this.$parent.column;
      if (!column || column === 3) {
        return;
      }
      var styles = {};
      styles.width = 100 / column + '%';
      return styles;
    }
  },
  methods: {
    onClick: function onClick() {
      this.$emit('on-item-click');
      Object(libs_router["b" /* go */])(this.link, this.$router);
    }
  },
  data: function data() {
    return {
      index: 0,
      hasIconSlot: false,
      hasLabelSlot: false
    };
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/grid/grid-item.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var grid_grid_item = ({
  name: 'grid-item',
  props: ['icon', 'label', 'link'],
  created: function created() {
    this.$parent.countColumn();
  },
  mounted: function mounted() {
    this.$slots.icon && (this.hasIconSlot = true);
    this.$slots.label && (this.hasLabelSlot = true);
  },
  destroyed: function destroyed() {
    this.$parent.countColumn();
  },

  computed: {
    isLast: function isLast() {
      return !((this.index + 1) % this.$parent.column);
    },
    style: function style() {
      var column = this.$parent.column;
      if (!column || column === 3) {
        return;
      }
      var styles = {};
      styles.width = 100 / column + '%';
      return styles;
    }
  },
  methods: {
    onClick: function onClick() {
      this.$emit('on-item-click');
      Object(libs_router["b" /* go */])(this.link, this.$router);
    }
  },
  data: function data() {
    return {
      index: 0,
      hasIconSlot: false,
      hasLabelSlot: false
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1b090120","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/grid/grid-item.vue
var grid_item_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"weui-grid",class:{
    'vux-grid-item-no-border': (_vm.isLast && !_vm.$parent.showLrBorders) || (!_vm.isLast && !_vm.$parent.showVerticalDividers),
  },style:(_vm.style),attrs:{"href":"javascript:;"},on:{"click":_vm.onClick}},[(_vm.hasIconSlot || _vm.icon)?_c('div',{staticClass:"weui-grid__icon"},[_vm._t("icon",[_c('img',{attrs:{"src":_vm.icon,"alt":""}})])],2):_vm._e(),_vm._v(" "),(_vm.hasLabelSlot || _vm.label)?_c('p',{staticClass:"weui-grid__label"},[_vm._t("label",[_c('span',{domProps:{"innerHTML":_vm._s(_vm.label)}})])],2):_vm._e(),_vm._v(" "),_vm._t("default")],2)}
var grid_item_staticRenderFns = []
var grid_item_esExports = { render: grid_item_render, staticRenderFns: grid_item_staticRenderFns }
/* harmony default export */ var components_grid_grid_item = (grid_item_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/grid/grid-item.vue
function grid_item_injectStyle (ssrContext) {
  __webpack_require__("IKRd")
}
var grid_item_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var grid_item___vue_template_functional__ = false
/* styles */
var grid_item___vue_styles__ = grid_item_injectStyle
/* scopeId */
var grid_item___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var grid_item___vue_module_identifier__ = null
var grid_item_Component = grid_item_normalizeComponent(
  grid_grid_item,
  components_grid_grid_item,
  grid_item___vue_template_functional__,
  grid_item___vue_styles__,
  grid_item___vue_scopeId__,
  grid_item___vue_module_identifier__
)

/* harmony default export */ var src_components_grid_grid_item = (grid_item_Component.exports);

// EXTERNAL MODULE: ./node_modules/vux/src/components/swiper/swiper.js
var swiper = __webpack_require__("NjrX");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/swiper/swiper.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var swiper_swiper = ({
  name: 'swiper',
  created: function created() {
    this.index = this.value || 0;
    if (this.index) {
      this.current = this.index;
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    this.hasTwoLoopItem();
    this.$nextTick(function () {
      if (!(_this2.list && _this2.list.length === 0)) {
        _this2.render(_this2.index);
      }
      _this2.xheight = _this2.getHeight();
      _this2.$emit('on-get-height', _this2.xheight);
    });
  },

  methods: {
    hasTwoLoopItem: function hasTwoLoopItem() {
      if (this.list.length === 2 && this.loop) {
        this.listTwoLoopItem = this.list;
      } else {
        this.listTwoLoopItem = [];
      }
    },
    clickListItem: function clickListItem(item) {
      Object(libs_router["b" /* go */])(item.url, this.$router);
      this.$emit('on-click-list-item', JSON.parse(stringify_default()(item)));
    },
    buildBackgroundUrl: function buildBackgroundUrl(item) {
      return item.fallbackImg ? 'url(' + item.img + '), url(' + item.fallbackImg + ')' : 'url(' + item.img + ')';
    },
    render: function render() {
      var _this3 = this;

      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      this.swiper && this.swiper.destroy();
      this.swiper = new swiper["a" /* default */]({
        container: this.$el,
        direction: this.direction,
        auto: this.auto,
        loop: this.loop,
        interval: this.interval,
        threshold: this.threshold,
        duration: this.duration,
        height: this.height || this._height,
        minMovingDistance: this.minMovingDistance,
        imgList: this.imgList
      }).on('swiped', function (prev, index) {
        _this3.current = index % _this3.length;
        _this3.index = index % _this3.length;
      });
      if (index > 0) {
        this.swiper.go(index);
      }
    },
    rerender: function rerender() {
      var _this4 = this;

      if (!this.$el || this.hasRender) {
        return;
      }
      this.hasRender = true;
      this.hasTwoLoopItem();
      this.$nextTick(function () {
        _this4.index = _this4.value || 0;
        _this4.current = _this4.value || 0;
        _this4.length = _this4.list.length || _this4.$children.length;
        _this4.destroy();
        _this4.render(_this4.value);
      });
    },
    destroy: function destroy() {
      this.hasRender = false;
      this.swiper && this.swiper.destroy();
    },
    getHeight: function getHeight() {
      var hasHeight = parseInt(this.height, 10);
      if (hasHeight) return this.height;
      if (!hasHeight) {
        if (this.aspectRatio) {
          return this.$el.offsetWidth * this.aspectRatio + 'px';
        }
        return '180px';
      }
    }
  },
  props: {
    list: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    direction: {
      type: String,
      default: 'horizontal'
    },
    showDots: {
      type: Boolean,
      default: true
    },
    showDescMask: {
      type: Boolean,
      default: true
    },
    dotsPosition: {
      type: String,
      default: 'right'
    },
    dotsClass: String,
    auto: Boolean,
    loop: Boolean,
    interval: {
      type: Number,
      default: 3000
    },
    threshold: {
      type: Number,
      default: 50
    },
    duration: {
      type: Number,
      default: 300
    },
    height: {
      type: String,
      default: 'auto'
    },
    aspectRatio: Number,
    minMovingDistance: {
      type: Number,
      default: 0
    },
    value: {
      type: Number,
      default: 0
    }
  },
  data: function data() {
    return {
      hasRender: false,
      current: this.index || 0,
      xheight: 'auto',
      length: this.list.length,
      index: 0,
      listTwoLoopItem: [] // issue #1484
    };
  },

  watch: {
    auto: function auto(val) {
      if (!val) {
        this.swiper && this.swiper.stop();
      } else {
        this.swiper && this.swiper._auto();
      }
    },
    list: function list(val, oldVal) {
      if (stringify_default()(val) !== stringify_default()(oldVal)) {
        this.rerender();
      }
    },
    current: function current(currentIndex) {
      this.index = currentIndex;
      this.$emit('on-index-change', currentIndex);
    },
    index: function index(val) {
      var _this = this;
      if (val !== this.current) {
        this.$nextTick(function () {
          _this.swiper && _this.swiper.go(val);
        });
      }
      this.$emit('input', val);
    },
    value: function value(val) {
      this.index = val;
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.destroy();
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/swiper/swiper.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var components_swiper_swiper = ({
  name: 'swiper',
  created: function created() {
    this.index = this.value || 0;
    if (this.index) {
      this.current = this.index;
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    this.hasTwoLoopItem();
    this.$nextTick(function () {
      if (!(_this2.list && _this2.list.length === 0)) {
        _this2.render(_this2.index);
      }
      _this2.xheight = _this2.getHeight();
      _this2.$emit('on-get-height', _this2.xheight);
    });
  },

  methods: {
    hasTwoLoopItem: function hasTwoLoopItem() {
      if (this.list.length === 2 && this.loop) {
        this.listTwoLoopItem = this.list;
      } else {
        this.listTwoLoopItem = [];
      }
    },
    clickListItem: function clickListItem(item) {
      Object(libs_router["b" /* go */])(item.url, this.$router);
      this.$emit('on-click-list-item', JSON.parse(stringify_default()(item)));
    },
    buildBackgroundUrl: function buildBackgroundUrl(item) {
      return item.fallbackImg ? 'url(' + item.img + '), url(' + item.fallbackImg + ')' : 'url(' + item.img + ')';
    },
    render: function render() {
      var _this3 = this;

      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      this.swiper && this.swiper.destroy();
      this.swiper = new swiper["a" /* default */]({
        container: this.$el,
        direction: this.direction,
        auto: this.auto,
        loop: this.loop,
        interval: this.interval,
        threshold: this.threshold,
        duration: this.duration,
        height: this.height || this._height,
        minMovingDistance: this.minMovingDistance,
        imgList: this.imgList
      }).on('swiped', function (prev, index) {
        _this3.current = index % _this3.length;
        _this3.index = index % _this3.length;
      });
      if (index > 0) {
        this.swiper.go(index);
      }
    },
    rerender: function rerender() {
      var _this4 = this;

      if (!this.$el || this.hasRender) {
        return;
      }
      this.hasRender = true;
      this.hasTwoLoopItem();
      this.$nextTick(function () {
        _this4.index = _this4.value || 0;
        _this4.current = _this4.value || 0;
        _this4.length = _this4.list.length || _this4.$children.length;
        _this4.destroy();
        _this4.render(_this4.value);
      });
    },
    destroy: function destroy() {
      this.hasRender = false;
      this.swiper && this.swiper.destroy();
    },
    getHeight: function getHeight() {
      var hasHeight = parseInt(this.height, 10);
      if (hasHeight) return this.height;
      if (!hasHeight) {
        if (this.aspectRatio) {
          return this.$el.offsetWidth * this.aspectRatio + 'px';
        }
        return '180px';
      }
    }
  },
  props: {
    list: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    direction: {
      type: String,
      default: 'horizontal'
    },
    showDots: {
      type: Boolean,
      default: true
    },
    showDescMask: {
      type: Boolean,
      default: true
    },
    dotsPosition: {
      type: String,
      default: 'right'
    },
    dotsClass: String,
    auto: Boolean,
    loop: Boolean,
    interval: {
      type: Number,
      default: 3000
    },
    threshold: {
      type: Number,
      default: 50
    },
    duration: {
      type: Number,
      default: 300
    },
    height: {
      type: String,
      default: 'auto'
    },
    aspectRatio: Number,
    minMovingDistance: {
      type: Number,
      default: 0
    },
    value: {
      type: Number,
      default: 0
    }
  },
  data: function data() {
    return {
      hasRender: false,
      current: this.index || 0,
      xheight: 'auto',
      length: this.list.length,
      index: 0,
      listTwoLoopItem: [] // issue #1484
    };
  },

  watch: {
    auto: function auto(val) {
      if (!val) {
        this.swiper && this.swiper.stop();
      } else {
        this.swiper && this.swiper._auto();
      }
    },
    list: function list(val, oldVal) {
      if (stringify_default()(val) !== stringify_default()(oldVal)) {
        this.rerender();
      }
    },
    current: function current(currentIndex) {
      this.index = currentIndex;
      this.$emit('on-index-change', currentIndex);
    },
    index: function index(val) {
      var _this = this;
      if (val !== this.current) {
        this.$nextTick(function () {
          _this.swiper && _this.swiper.go(val);
        });
      }
      this.$emit('input', val);
    },
    value: function value(val) {
      this.index = val;
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.destroy();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8fe8f518","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/swiper/swiper.vue
var swiper_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-slider"},[_c('div',{staticClass:"vux-swiper",style:({height: _vm.xheight})},[_vm._t("default"),_vm._v(" "),_vm._l((_vm.list),function(item,index){return _c('div',{staticClass:"vux-swiper-item",attrs:{"data-index":index},on:{"click":function($event){return _vm.clickListItem(item)}}},[_c('a',{attrs:{"href":"javascript:"}},[_c('div',{staticClass:"vux-img",style:({backgroundImage: _vm.buildBackgroundUrl(item)})}),_vm._v(" "),(_vm.showDescMask)?_c('p',{staticClass:"vux-swiper-desc"},[_vm._v(_vm._s(item.title))]):_vm._e()])])}),_vm._v(" "),_vm._l((_vm.listTwoLoopItem),function(item,index){return (_vm.listTwoLoopItem.length > 0)?_c('div',{staticClass:"vux-swiper-item vux-swiper-item-clone",attrs:{"data-index":index},on:{"click":function($event){return _vm.clickListItem(item)}}},[_c('a',{attrs:{"href":"javascript:"}},[_c('div',{staticClass:"vux-img",style:({backgroundImage: _vm.buildBackgroundUrl(item)})}),_vm._v(" "),(_vm.showDescMask)?_c('p',{staticClass:"vux-swiper-desc"},[_vm._v(_vm._s(item.title))]):_vm._e()])]):_vm._e()})],2),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showDots),expression:"showDots"}],class:[_vm.dotsClass, 'vux-indicator', ("vux-indicator-" + _vm.dotsPosition)]},_vm._l((_vm.length),function(key){return _c('a',{attrs:{"href":"javascript:"}},[_c('i',{staticClass:"vux-icon-dot",class:{'active': key - 1 === _vm.current}})])}),0)])}
var swiper_staticRenderFns = []
var swiper_esExports = { render: swiper_render, staticRenderFns: swiper_staticRenderFns }
/* harmony default export */ var src_components_swiper_swiper = (swiper_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/swiper/swiper.vue
function swiper_injectStyle (ssrContext) {
  __webpack_require__("/PUx")
}
var swiper_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var swiper___vue_template_functional__ = false
/* styles */
var swiper___vue_styles__ = swiper_injectStyle
/* scopeId */
var swiper___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var swiper___vue_module_identifier__ = null
var swiper_Component = swiper_normalizeComponent(
  components_swiper_swiper,
  src_components_swiper_swiper,
  swiper___vue_template_functional__,
  swiper___vue_styles__,
  swiper___vue_scopeId__,
  swiper___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_swiper_swiper = (swiper_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/swiper/swiper-item.vue
//
//
//
//

/* harmony default export */ var swiper_item = ({
  name: 'swiper-item',
  mounted: function mounted() {
    var _this = this;

    this.$nextTick(function () {
      _this.$parent.rerender();
    });
  },
  beforeDestroy: function beforeDestroy() {
    var $parent = this.$parent;
    this.$nextTick(function () {
      $parent.rerender();
    });
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/swiper/swiper-item.vue
//
//
//
//

/* harmony default export */ var swiper_swiper_item = ({
  name: 'swiper-item',
  mounted: function mounted() {
    var _this = this;

    this.$nextTick(function () {
      _this.$parent.rerender();
    });
  },
  beforeDestroy: function beforeDestroy() {
    var $parent = this.$parent;
    this.$nextTick(function () {
      $parent.rerender();
    });
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4cd6837a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/swiper/swiper-item.vue
var swiper_item_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-swiper-item"},[_vm._t("default")],2)}
var swiper_item_staticRenderFns = []
var swiper_item_esExports = { render: swiper_item_render, staticRenderFns: swiper_item_staticRenderFns }
/* harmony default export */ var components_swiper_swiper_item = (swiper_item_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/swiper/swiper-item.vue
var swiper_item_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var swiper_item___vue_template_functional__ = false
/* styles */
var swiper_item___vue_styles__ = null
/* scopeId */
var swiper_item___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var swiper_item___vue_module_identifier__ = null
var swiper_item_Component = swiper_item_normalizeComponent(
  swiper_swiper_item,
  components_swiper_swiper_item,
  swiper_item___vue_template_functional__,
  swiper_item___vue_styles__,
  swiper_item___vue_scopeId__,
  swiper_item___vue_module_identifier__
)

/* harmony default export */ var src_components_swiper_swiper_item = (swiper_item_Component.exports);

// EXTERNAL MODULE: ./node_modules/vux/src/components/x-dialog/index.vue + 3 modules
var x_dialog = __webpack_require__("/kga");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/confirm/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var components_confirm = ({
  name: 'confirm',
  components: {
    XDialog: x_dialog["a" /* default */]
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    showInput: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: ''
    },
    theme: {
      type: String,
      default: 'ios'
    },
    hideOnBlur: {
      type: Boolean,
      default: false
    },
    title: String,
    confirmText: String,
    cancelText: String,
    maskTransition: {
      type: String,
      default: 'vux-fade'
    },
    maskZIndex: [Number, String],
    dialogTransition: {
      type: String,
      default: 'vux-dialog'
    },
    content: String,
    closeOnConfirm: {
      type: Boolean,
      default: true
    },
    inputAttrs: Object,
    showContent: {
      type: Boolean,
      default: true
    },
    confirmType: {
      type: String,
      default: 'primary'
    },
    showCancelButton: {
      type: Boolean,
      default: true
    },
    showConfirmButton: {
      type: Boolean,
      default: true
    }
  },
  created: function created() {
    this.showValue = this.show;
    if (this.value) {
      this.showValue = this.value;
    }
  },

  watch: {
    value: function value(val) {
      this.showValue = val;
    },
    showValue: function showValue(val) {
      var _this = this;

      this.$emit('input', val);
      if (val) {
        if (this.showInput) {
          this.msg = '';
          setTimeout(function () {
            if (_this.$refs.input) {
              _this.setInputFocus();
            }
          }, 300);
        }
        this.$emit('on-show'); // emit just after msg is cleared
      }
    }
  },
  data: function data() {
    return {
      msg: '',
      showValue: false
    };
  },

  methods: {
    getInputAttrs: function getInputAttrs() {
      return this.inputAttrs || {
        type: 'text'
      };
    },
    setInputValue: function setInputValue(val) {
      this.msg = val;
    },
    setInputFocus: function setInputFocus(evt) {
      if (evt) {
        evt.preventDefault();
      }
      this.$refs.input.focus();
    },
    _onConfirm: function _onConfirm() {
      if (!this.showValue) {
        return;
      }
      if (this.closeOnConfirm) {
        this.showValue = false;
      }
      this.$emit('on-confirm', this.msg);
    },
    _onCancel: function _onCancel() {
      if (!this.showValue) {
        return;
      }
      this.showValue = false;
      this.$emit('on-cancel');
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/confirm/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var src_components_confirm = ({
  name: 'confirm',
  components: {
    XDialog: x_dialog["a" /* default */]
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    showInput: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: ''
    },
    theme: {
      type: String,
      default: 'ios'
    },
    hideOnBlur: {
      type: Boolean,
      default: false
    },
    title: String,
    confirmText: String,
    cancelText: String,
    maskTransition: {
      type: String,
      default: 'vux-fade'
    },
    maskZIndex: [Number, String],
    dialogTransition: {
      type: String,
      default: 'vux-dialog'
    },
    content: String,
    closeOnConfirm: {
      type: Boolean,
      default: true
    },
    inputAttrs: Object,
    showContent: {
      type: Boolean,
      default: true
    },
    confirmType: {
      type: String,
      default: 'primary'
    },
    showCancelButton: {
      type: Boolean,
      default: true
    },
    showConfirmButton: {
      type: Boolean,
      default: true
    }
  },
  created: function created() {
    this.showValue = this.show;
    if (this.value) {
      this.showValue = this.value;
    }
  },

  watch: {
    value: function value(val) {
      this.showValue = val;
    },
    showValue: function showValue(val) {
      var _this = this;

      this.$emit('input', val);
      if (val) {
        if (this.showInput) {
          this.msg = '';
          setTimeout(function () {
            if (_this.$refs.input) {
              _this.setInputFocus();
            }
          }, 300);
        }
        this.$emit('on-show'); // emit just after msg is cleared
      }
    }
  },
  data: function data() {
    return {
      msg: '',
      showValue: false
    };
  },

  methods: {
    getInputAttrs: function getInputAttrs() {
      return this.inputAttrs || {
        type: 'text'
      };
    },
    setInputValue: function setInputValue(val) {
      this.msg = val;
    },
    setInputFocus: function setInputFocus(evt) {
      if (evt) {
        evt.preventDefault();
      }
      this.$refs.input.focus();
    },
    _onConfirm: function _onConfirm() {
      if (!this.showValue) {
        return;
      }
      if (this.closeOnConfirm) {
        this.showValue = false;
      }
      this.$emit('on-confirm', this.msg);
    },
    _onCancel: function _onCancel() {
      if (!this.showValue) {
        return;
      }
      this.showValue = false;
      this.$emit('on-cancel');
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c48d9308","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/confirm/index.vue
var confirm_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-confirm"},[_c('x-dialog',{attrs:{"dialog-class":_vm.theme === 'android' ? 'weui-dialog weui-skin_android' : 'weui-dialog',"mask-transition":_vm.maskTransition,"dialog-transition":_vm.theme === 'android' ? 'vux-fade' : _vm.dialogTransition,"hide-on-blur":_vm.hideOnBlur,"mask-z-index":_vm.maskZIndex},on:{"on-hide":function($event){return _vm.$emit('on-hide')}},model:{value:(_vm.showValue),callback:function ($$v) {_vm.showValue=$$v},expression:"showValue"}},[(!!_vm.title)?_c('div',{staticClass:"weui-dialog__hd",class:{'with-no-content': !_vm.showContent}},[_c('strong',{staticClass:"weui-dialog__title"},[_vm._v(_vm._s(_vm.title))])]):_vm._e(),_vm._v(" "),(_vm.showContent)?[(!_vm.showInput)?_c('div',{staticClass:"weui-dialog__bd"},[_vm._t("default",[_c('div',{domProps:{"innerHTML":_vm._s(_vm.content)}})])],2):_c('div',{staticClass:"vux-prompt"},[(((_vm.getInputAttrs()).type)==='checkbox')?_c('input',_vm._b({directives:[{name:"model",rawName:"v-model",value:(_vm.msg),expression:"msg"}],ref:"input",staticClass:"vux-prompt-msgbox",attrs:{"placeholder":_vm.placeholder,"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.msg)?_vm._i(_vm.msg,null)>-1:(_vm.msg)},on:{"touchend":_vm.setInputFocus,"change":function($event){var $$a=_vm.msg,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.msg=$$a.concat([$$v]))}else{$$i>-1&&(_vm.msg=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.msg=$$c}}}},'input',_vm.getInputAttrs(),false)):(((_vm.getInputAttrs()).type)==='radio')?_c('input',_vm._b({directives:[{name:"model",rawName:"v-model",value:(_vm.msg),expression:"msg"}],ref:"input",staticClass:"vux-prompt-msgbox",attrs:{"placeholder":_vm.placeholder,"type":"radio"},domProps:{"checked":_vm._q(_vm.msg,null)},on:{"touchend":_vm.setInputFocus,"change":function($event){_vm.msg=null}}},'input',_vm.getInputAttrs(),false)):_c('input',_vm._b({directives:[{name:"model",rawName:"v-model",value:(_vm.msg),expression:"msg"}],ref:"input",staticClass:"vux-prompt-msgbox",attrs:{"placeholder":_vm.placeholder,"type":(_vm.getInputAttrs()).type},domProps:{"value":(_vm.msg)},on:{"touchend":_vm.setInputFocus,"input":function($event){if($event.target.composing){ return; }_vm.msg=$event.target.value}}},'input',_vm.getInputAttrs(),false))])]:_vm._e(),_vm._v(" "),_c('div',{staticClass:"weui-dialog__ft"},[(_vm.showCancelButton)?_c('a',{staticClass:"weui-dialog__btn weui-dialog__btn_default",attrs:{"href":"javascript:;"},on:{"click":_vm._onCancel}},[_vm._v(_vm._s(_vm.cancelText || '取消'))]):_vm._e(),_vm._v(" "),(_vm.showConfirmButton)?_c('a',{staticClass:"weui-dialog__btn",class:("weui-dialog__btn_" + _vm.confirmType),attrs:{"href":"javascript:;"},on:{"click":_vm._onConfirm}},[_vm._v(_vm._s(_vm.confirmText || '确定'))]):_vm._e()])],2)],1)}
var confirm_staticRenderFns = []
var confirm_esExports = { render: confirm_render, staticRenderFns: confirm_staticRenderFns }
/* harmony default export */ var vux_src_components_confirm = (confirm_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/confirm/index.vue
function confirm_injectStyle (ssrContext) {
  __webpack_require__("NGg+")
}
var confirm_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var confirm___vue_template_functional__ = false
/* styles */
var confirm___vue_styles__ = confirm_injectStyle
/* scopeId */
var confirm___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var confirm___vue_module_identifier__ = null
var confirm_Component = confirm_normalizeComponent(
  src_components_confirm,
  vux_src_components_confirm,
  confirm___vue_template_functional__,
  confirm___vue_styles__,
  confirm___vue_scopeId__,
  confirm___vue_module_identifier__
)


/* harmony default export */ var node_modules_vux_src_components_confirm = (confirm_Component.exports);

// EXTERNAL MODULE: ./node_modules/vux/src/directives/click-outside/index.js
var click_outside = __webpack_require__("A1NS");

// EXTERNAL MODULE: ./node_modules/vux/src/directives/transfer-dom/index.js
var transfer_dom = __webpack_require__("63CM");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/popover/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var popover = ({
  name: 'popover',
  mounted: function mounted() {
    var _this = this;

    this.$nextTick(function () {
      _this.init();
      window.addEventListener('resize', _this.reset);
    });
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.reset);
  },

  directives: {
    TransferDom: transfer_dom["a" /* default */],
    ClickOutside: click_outside["a" /* default */]
  },
  props: {
    content: String,
    placement: String,
    gutter: {
      type: Number,
      default: 5
    }
  },
  methods: {
    reset: function reset() {
      if (this.show) {
        this.init(true);
      }
    },
    init: function init(isReset) {
      var trigger = this.$refs.trigger.children[0];
      var popover = this.$refs.popover;
      switch (this.placement) {
        case 'top':
          this.position.left = trigger.offsetLeft - popover.offsetWidth / 2 + trigger.offsetWidth / 2;
          this.position.top = trigger.getBoundingClientRect().top - popover.offsetHeight - this.gutter;
          break;
        case 'left':
          this.position.left = trigger.offsetLeft - popover.offsetWidth - this.gutter;
          this.position.top = trigger.getBoundingClientRect().top + trigger.offsetHeight / 2 - popover.offsetHeight / 2;
          break;
        case 'right':
          this.position.left = trigger.offsetLeft + trigger.offsetWidth + this.gutter;
          this.position.top = trigger.getBoundingClientRect().top + trigger.offsetHeight / 2 - popover.offsetHeight / 2;
          break;
        case 'bottom':
          this.position.left = trigger.offsetLeft - popover.offsetWidth / 2 + trigger.offsetWidth / 2;
          this.position.top = trigger.getBoundingClientRect().top + trigger.offsetHeight + this.gutter;
          break;
        default:
          console.warn('Wrong placement prop');
      }
      if (!isReset) {
        this.show = false;
      }

      this.popoverStyle = {
        top: this.position.top + 'px',
        left: this.position.left + 'px',
        display: isReset ? this.popoverStyle.display : 'none'
      };
    },
    onClickedOutside: function onClickedOutside() {
      if (this.show) {
        this.show = false;
        this.$emit('on-hide');
      }
    },
    toggle: function toggle() {
      var _this2 = this;

      this.show = !this.show;
      if (this.show) {
        this.$nextTick(function () {
          _this2.init(true);
        });
      }
      this.$emit('on-' + (this.show === true ? 'show' : 'hide'));
    }
  },
  data: function data() {
    return {
      position: {
        top: 0,
        left: 0
      },
      show: true,
      popoverStyle: {}
    };
  },

  computed: {
    arrowClass: function arrowClass() {
      return {
        'vux-popover-arrow': true,
        'vux-popover-arrow-up': this.placement === 'bottom',
        'vux-popover-arrow-right': this.placement === 'left',
        'vux-popover-arrow-left': this.placement === 'right',
        'vux-popover-arrow-down': this.placement === 'top'
      };
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/popover/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var components_popover = ({
  name: 'popover',
  mounted: function mounted() {
    var _this = this;

    this.$nextTick(function () {
      _this.init();
      window.addEventListener('resize', _this.reset);
    });
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.reset);
  },

  directives: {
    TransferDom: transfer_dom["a" /* default */],
    ClickOutside: click_outside["a" /* default */]
  },
  props: {
    content: String,
    placement: String,
    gutter: {
      type: Number,
      default: 5
    }
  },
  methods: {
    reset: function reset() {
      if (this.show) {
        this.init(true);
      }
    },
    init: function init(isReset) {
      var trigger = this.$refs.trigger.children[0];
      var popover = this.$refs.popover;
      switch (this.placement) {
        case 'top':
          this.position.left = trigger.offsetLeft - popover.offsetWidth / 2 + trigger.offsetWidth / 2;
          this.position.top = trigger.getBoundingClientRect().top - popover.offsetHeight - this.gutter;
          break;
        case 'left':
          this.position.left = trigger.offsetLeft - popover.offsetWidth - this.gutter;
          this.position.top = trigger.getBoundingClientRect().top + trigger.offsetHeight / 2 - popover.offsetHeight / 2;
          break;
        case 'right':
          this.position.left = trigger.offsetLeft + trigger.offsetWidth + this.gutter;
          this.position.top = trigger.getBoundingClientRect().top + trigger.offsetHeight / 2 - popover.offsetHeight / 2;
          break;
        case 'bottom':
          this.position.left = trigger.offsetLeft - popover.offsetWidth / 2 + trigger.offsetWidth / 2;
          this.position.top = trigger.getBoundingClientRect().top + trigger.offsetHeight + this.gutter;
          break;
        default:
          console.warn('Wrong placement prop');
      }
      if (!isReset) {
        this.show = false;
      }

      this.popoverStyle = {
        top: this.position.top + 'px',
        left: this.position.left + 'px',
        display: isReset ? this.popoverStyle.display : 'none'
      };
    },
    onClickedOutside: function onClickedOutside() {
      if (this.show) {
        this.show = false;
        this.$emit('on-hide');
      }
    },
    toggle: function toggle() {
      var _this2 = this;

      this.show = !this.show;
      if (this.show) {
        this.$nextTick(function () {
          _this2.init(true);
        });
      }
      this.$emit('on-' + (this.show === true ? 'show' : 'hide'));
    }
  },
  data: function data() {
    return {
      position: {
        top: 0,
        left: 0
      },
      show: true,
      popoverStyle: {}
    };
  },

  computed: {
    arrowClass: function arrowClass() {
      return {
        'vux-popover-arrow': true,
        'vux-popover-arrow-up': this.placement === 'bottom',
        'vux-popover-arrow-right': this.placement === 'left',
        'vux-popover-arrow-left': this.placement === 'right',
        'vux-popover-arrow-down': this.placement === 'top'
      };
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1db8704f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/popover/index.vue
var popover_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"click-outside",rawName:"v-click-outside",value:(_vm.onClickedOutside),expression:"onClickedOutside"}]},[_c('span',{ref:"trigger",on:{"click":_vm.toggle}},[_vm._t("default")],2),_vm._v(" "),_c('div',{directives:[{name:"transfer-dom",rawName:"v-transfer-dom"},{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],ref:"popover",staticClass:"vux-popover",style:(_vm.popoverStyle)},[_c('div',{class:_vm.arrowClass}),_vm._v(" "),_c('div',{on:{"click":function($event){return _vm.$emit('on-click-content')}}},[_vm._t("content",[_c('div',{domProps:{"innerHTML":_vm._s(_vm.content)}})])],2)])])}
var popover_staticRenderFns = []
var popover_esExports = { render: popover_render, staticRenderFns: popover_staticRenderFns }
/* harmony default export */ var src_components_popover = (popover_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/popover/index.vue
function popover_injectStyle (ssrContext) {
  __webpack_require__("72rf")
}
var popover_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var popover___vue_template_functional__ = false
/* styles */
var popover___vue_styles__ = popover_injectStyle
/* scopeId */
var popover___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var popover___vue_module_identifier__ = null
var popover_Component = popover_normalizeComponent(
  components_popover,
  src_components_popover,
  popover___vue_template_functional__,
  popover___vue_styles__,
  popover___vue_scopeId__,
  popover___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_popover = (popover_Component.exports);

// EXTERNAL MODULE: ./node_modules/vue-awesome-swiper/dist/vue-awesome-swiper.js
var vue_awesome_swiper = __webpack_require__("7QTg");
var vue_awesome_swiper_default = /*#__PURE__*/__webpack_require__.n(vue_awesome_swiper);

// EXTERNAL MODULE: ./node_modules/swiper/dist/css/swiper.css
var css_swiper = __webpack_require__("v2ns");
var swiper_default = /*#__PURE__*/__webpack_require__.n(css_swiper);

// EXTERNAL MODULE: ./node_modules/vuescroll/dist/vuescroll.js
var vuescroll = __webpack_require__("8/7D");
var vuescroll_default = /*#__PURE__*/__webpack_require__.n(vuescroll);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/yingxin/tskjxy/views/home.vue























/* harmony default export */ var home = ({
  name: 'home',
  components: {
    XHeader: vux_src_components_x_header,
    XButton: vux_src_components_x_button,
    Flow: src_components_flow_flow,
    FlowState: src_components_flow_flow_state,
    FlowLine: src_components_flow_flow_line,
    Grid: src_components_grid_grid,
    GridItem: src_components_grid_grid_item,
    Badge: vux_src_components_badge,
    Swiper: vux_src_components_swiper_swiper,
    SwiperItem: src_components_swiper_swiper_item,
    Error: src_components_error,
    'vueSwiper': vue_awesome_swiper["swiper"],
    swiperSlide: vue_awesome_swiper["swiperSlide"],
    'scroller': vuescroll_default.a,
    Confirm: node_modules_vux_src_components_confirm,
    Popover: vux_src_components_popover
  },
  data: function data() {
    return {
      isBadge: false,
      ops: {
        scrollPanel: {
          scrollingX: false
        },
        bar: {
          background: 'rgba(0, 107, 178, 0.3)',
          size: '3px',
          opacity: 0
        }
      },
      swiperOption: {
        speed: 400,
        slidesPerView: 'auto',
        spaceBetween: 20,
        centeredSlides: !0,
        watchSlidesProgress: !0,
        parallax: true,
        initialSlide: sessionStorage.getItem('swiperIndex') ? Number(sessionStorage.getItem('swiperIndex')) : 0,

        on: {
          slideChangeTransitionEnd: function slideChangeTransitionEnd() {
            sessionStorage.setItem('swiperIndex', this.activeIndex);
          }
        }
      },
      swiper: {
        index: 0,
        aspectRatio: 0.63,
        position: 'center'
      },
      userInfo: {},
      flowProcedureList: [],
      flowProcedureList2: [],
      dataList: [],
      dataList2: [],
      noticeList: [],
      errorMsg: {
        type: 'null',
        content: '暂无在线办理手续'
      },
      donateFlag: Boolean,
      toDay: today('YYYY-MM-DD'),
      wx: navigator.userAgent.toLowerCase().indexOf('micromessenger') !== -1,
      currentDate: ''

    };
  },

  computed: extends_default()({
    title: function title() {
      return this.$route.meta.title;
    }
  }, Object(vuex_esm["c" /* mapState */])({
    token: function token(state) {
      return state.token;
    },
    studentId: function studentId(state) {
      return state.userInfo.id;
    },
    flowId: function flowId(state) {
      return state.flowInfo ? state.flowInfo.flowId : null;
    },
    flowType: function flowType(state) {
      return state.flowInfo ? state.flowInfo.flowType : null;
    }
  }), {
    showProcedure2: function showProcedure2() {
      return this.dataList2.filter(function (obj) {
        return obj.procedureBean.flag.split('')[1] === '1';
      });
    },
    dataFinished: function dataFinished() {
      return this.dataList.filter(function (obj) {
        return obj.status === 4;
      });
    },
    dataUnfinished: function dataUnfinished() {
      return this.dataList.filter(function (obj) {
        return obj.status !== 4;
      });
    }
  }),
  created: function created() {},
  mounted: function mounted() {
    var _this = this;

    var token = stringify_default()(getRequest(window.location.href)) !== '{}' ? getRequest(window.location.href).info : null;
    if (token) {
      this.getAccessToken();
    } else {
      this.getAfterLogin().then(function () {
        _this.$store.dispatch('userInfoAction', _this.userInfo);
        _this.getflowProcedure();

        _this.getCurrentDate();
        _this.getDataList();
      });
    }

    this.getNotice();
  },

  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])(['currentProcedureInfoAction']), {
    getAccessToken: function getAccessToken() {
      var _this2 = this;

      var token = stringify_default()(getRequest(window.location.href)) !== '{}' ? getRequest(window.location.href).info : null;
      if (token) {
        this.$store.dispatch('LoginAction', token);
        this.getAfterLogin().then(function () {
          _this2.$store.dispatch('userInfoAction', _this2.userInfo);
          _this2.getflowProcedure();

          _this2.getDataList();
        });
        this.$vux.toast.text('登录成功', 'top');
      } else {
        if (!this.token) {
          this.$vux.toast.text('未通过移动泰山科技学院获取到学生身份', 'top');
        }
      }
    },
    back: function back() {

      Cordova.exec(null, null, 'SYNPlugin', 'synCordovaPlugin', ['synjones.synpay.window.exit.app']);
    },
    toLogin: function toLogin() {
      var _this3 = this;

      setTimeout(function () {
        _this3.$router.push({ 'name': 'login' });
      }, 300);
    },
    getAfterLogin: function getAfterLogin() {
      var _this4 = this;

      return new promise_default.a(function (resolve, reject) {
        _this4.$api.get('/user/afterLogin', null, function (r) {
          if (r.data.flowBean) {
            _this4.flowInfo = {
              flowId: r.data.flowBean.id,
              flowType: r.data.flowBean.flowType,
              flowYear: r.data.flowBean.year
            };
            _this4.$store.dispatch('flowInfoAction', _this4.flowInfo);
          } else {
            _this4.$vux.alert.show({
              title: '当前时间您不在办理流程中',
              content: '请于流程开始后再访问',
              onShow: function onShow() {},
              onHide: function onHide() {

                Cordova.exec(null, null, 'SYNPlugin', 'synCordovaPlugin', ['synjones.synpay.window.exit.app']);
              }
            });
          }
          _this4.userInfo = r.data.studentBean;

          _this4.$set(_this4.userInfo, 'studentPictureUrl', r.data.studentPictureUrl);
          _this4.$store.dispatch('flowInfoAction', _this4.flowInfo);
          resolve();
        }, function (err) {
          _this4.$vux.toast.text(err.message, 'middle');
        });
      });
    },
    getflowProcedure: function getflowProcedure() {
      var _this5 = this;

      var params = {
        flowId: this.flowId
      };
      this.$api.get('/flowProcedure', params, function (r) {

        var data = r.data;
        var idArr = [];
        data.forEach(function (element) {
          var obj = {
            procedureId: element.procedureBean.id,
            flowProcedureId: element.id,
            name: element.procedureBean.name,
            startDate: element.startDate,
            endDate: element.endDate,
            status: element.procedureBean.status,
            icon: element.procedureBean.icon,
            flag: element.procedureBean.flag,
            router: element.procedureBean.router,
            flagFlow: element.flag,
            config: element.config
          };

          idArr.push(element.procedureBean.id);
          _this5.flowProcedureList2.push(obj);
        });
      }, function (err) {
        _this5.$vux.toast.text(err.message, 'middle');
      });
    },
    getDataList: function getDataList() {
      var _this6 = this;

      this.$vux.loading.show();
      var params = {
        studentId: this.studentId,
        flowId: this.flowId,
        'flowBean.isInFlow': 1
      };
      this.$api.get('/dataManagement/getDataManagementList', params, function (r) {
        var data = r.data;
        var arr1 = [];
        var arr2 = [];
        data.forEach(function (element) {
          _this6.dataList.push(element);
          if (element.status !== 4) {
            arr1.push(element);
          } else {
            arr2.push(element);
          }
        });
        _this6.dataList2 = arr1.concat(arr2);
        _this6.$vux.loading.hide();
      }, function (err) {
        _this6.$vux.toast.text(err.message, 'middle');
      });
    },
    getNotice: function getNotice() {
      var _this7 = this;

      var params = {
        isQueryContent: 1,
        isExpire: 1,
        isPublish: 1
      };
      this.$api.get('/notice', params, function (r) {
        _this7.$vux.loading.hide();
        var data = r.data.slice(0, 2);
        data.forEach(function (element) {
          var obj = {
            title: element.title
          };
          _this7.noticeList.push(obj);
        });
        if (_this7.noticeList.length > 0) {
          _this7.isBadge = true;
        } else {
          _this7.isBadge = false;
        }
      }, function (err) {
        _this7.$vux.toast.text(err.message, 'middle');
      });
    },
    getCurrentDate: function getCurrentDate() {
      var _this8 = this;

      return new promise_default.a(function (resolve, reject) {
        _this8.$api.get('/helper/systemDateTime', null, function (r) {

          _this8.currentDate = r.data;
          resolve();
        }, function (err) {
          _this8.$vux.toast.text(err.message, 'middle');
        });
      });
    },
    getIsOverdue: function getIsOverdue(endDate, procedureBeanId, router, name) {

      if (Date.parse(endDate + ' 23:59:59') < Date.parse(this.currentDate)) {
        this.getManageState(endDate, procedureBeanId, router, name);
      } else {
        this.getPreposition(procedureBeanId, router, name);
      }
    },
    getPreposition: function getPreposition(procedureBeanId, router, name) {
      var _this9 = this;

      var params = {
        'procedureBean.id': procedureBeanId,
        'studentBean.id': this.studentId,
        'flowBean.id': this.flowId
      };
      this.$api.get('/dataManagement', params, function (r) {
        _this9.$vux.loading.hide();
        if (r.data.status === 4 || r.data.status === 1 || r.data.status === 3 || r.data.status === 6) {
          _this9.$router.push({ name: 'itemResult', params: { title: name, status: r.data.status } });
        } else {
          _this9.$router.push({ name: router, params: { title: name, status: r.data.status } });
        }
      }, function (err) {
        _this9.$vux.toast.text(err.message, 'middle');
      });
    },
    getManageState: function getManageState(endDate, procedureBeanId, router, name) {
      var _this10 = this;

      var params = {
        'studentId': this.studentId,
        'flowId': this.flowId,
        'procedureId': procedureBeanId
      };
      this.$api.get('/dataManagement/getDataManagementList', params, function (r) {
        _this10.$vux.loading.hide();
        if (r.data.length > 0) {
          if (r.data[0].status === 4 || r.data[0].status === 1 || r.data[0].status === 3 || r.data[0].status === 6) {
            _this10.$router.push({ name: 'itemResult', params: { title: name, status: r.data.status } });
          } else {
            _this10.$vux.toast.text('该手续已于' + endDate + '结束办理', 'middle');
          }
        }
      }, function (err) {
        _this10.$vux.toast.text(err.message, 'middle');
      });
    },
    currentProcedure: function currentProcedure(item) {
      var _this11 = this;

      var itemDate = item.flowProcedureBean.startDate;
      this.getCurrentDate().then(function () {
        if (_this11.token && DatetimeStamp(itemDate + ' 00:00:00') <= DatetimeStamp(_this11.currentDate)) {
          var currentProcedureInfo = {
            flowProcedureId: item.flowProcedureId,
            procedureId: item.procedureId,
            name: item.procedureBean.name,
            router: item.procedureBean.router,
            endDate: item.flowProcedureBean.endDate,

            parentRouter: 'home'
          };
          _this11.$store.dispatch('currentProcedureInfoAction', currentProcedureInfo);
          if (item.procedureBean.flag.split('')[0] === '1' && item.procedureBean.flag.split('')[1] === '0') {
            _this11.$vux.toast.text(item.procedureBean.name + '需到现场办理，不可网上办理', 'middle');
          } else if (item.flowProcedureBean.flag.split('')[5] === '1' && item.procedureId !== 3) {
            window.location = item.flowProcedureBean.config;
          } else {
            if (item.procedureBean.router === 'pay' || item.procedureBean.router === 'info') {
              _this11.$router.push({
                name: item.procedureBean.router,
                query: {
                  flowProcedureId: item.flowProcedureId,
                  procedureId: item.procedureId
                }
              });
            } else {
              _this11.getIsOverdue(item.flowProcedureBean.endDate, item.procedureId, item.procedureBean.router, item.procedureBean.name);
            }
          }
        } else if (!_this11.token) {
          _this11.toLogin();
        } else if (DatetimeStamp(itemDate + ' 00:00:00') > DatetimeStamp(_this11.currentDate)) {
          _this11.$vux.alert.show({
            title: item.procedureBean.name + '未到办理时间',
            content: '请于' + itemDate + '办理',
            buttonText: '我知道了'
          });
        }
      });
    },
    isDonate: function isDonate() {
      var _this12 = this;

      var params = {
        studentId: this.studentId,
        flowId: this.flowId
      };
      return new promise_default.a(function (resolve, reject) {
        _this12.$api.get('/donation', params, function (r) {
          if (r.data.length > 0) {
            _this12.donateFlag = false;
          } else {
            _this12.donateFlag = true;
          }
          resolve();
        }, function (err) {
          _this12.$vux.toast.text(err.message, 'middle');
        });
      });
    }
  })
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/yingxin/tskjxy/views/home.vue























/* harmony default export */ var views_home = ({
  name: 'home',
  components: {
    XHeader: vux_src_components_x_header,
    XButton: vux_src_components_x_button,
    Flow: src_components_flow_flow,
    FlowState: src_components_flow_flow_state,
    FlowLine: src_components_flow_flow_line,
    Grid: src_components_grid_grid,
    GridItem: src_components_grid_grid_item,
    Badge: vux_src_components_badge,
    Swiper: vux_src_components_swiper_swiper,
    SwiperItem: src_components_swiper_swiper_item,
    Error: src_components_error,
    'vueSwiper': vue_awesome_swiper["swiper"],
    swiperSlide: vue_awesome_swiper["swiperSlide"],
    'scroller': vuescroll_default.a,
    Confirm: node_modules_vux_src_components_confirm,
    Popover: vux_src_components_popover
  },
  data: function data() {
    return {
      isBadge: false,
      ops: {
        scrollPanel: {
          scrollingX: false
        },
        bar: {
          background: 'rgba(0, 107, 178, 0.3)',
          size: '3px',
          opacity: 0
        }
      },
      swiperOption: {
        speed: 400,
        slidesPerView: 'auto',
        spaceBetween: 20,
        centeredSlides: !0,
        watchSlidesProgress: !0,
        parallax: true,
        initialSlide: sessionStorage.getItem('swiperIndex') ? Number(sessionStorage.getItem('swiperIndex')) : 0,

        on: {
          slideChangeTransitionEnd: function slideChangeTransitionEnd() {
            sessionStorage.setItem('swiperIndex', this.activeIndex);
          }
        }
      },
      swiper: {
        index: 0,
        aspectRatio: 0.63,
        position: 'center'
      },
      userInfo: {},
      flowProcedureList: [],
      flowProcedureList2: [],
      dataList: [],
      dataList2: [],
      noticeList: [],
      errorMsg: {
        type: 'null',
        content: '暂无在线办理手续'
      },
      donateFlag: Boolean,
      toDay: today('YYYY-MM-DD'),
      wx: navigator.userAgent.toLowerCase().indexOf('micromessenger') !== -1,
      currentDate: ''

    };
  },

  computed: extends_default()({
    title: function title() {
      return this.$route.meta.title;
    }
  }, Object(vuex_esm["c" /* mapState */])({
    token: function token(state) {
      return state.token;
    },
    studentId: function studentId(state) {
      return state.userInfo.id;
    },
    flowId: function flowId(state) {
      return state.flowInfo ? state.flowInfo.flowId : null;
    },
    flowType: function flowType(state) {
      return state.flowInfo ? state.flowInfo.flowType : null;
    }
  }), {
    showProcedure2: function showProcedure2() {
      return this.dataList2.filter(function (obj) {
        return obj.procedureBean.flag.split('')[1] === '1';
      });
    },
    dataFinished: function dataFinished() {
      return this.dataList.filter(function (obj) {
        return obj.status === 4;
      });
    },
    dataUnfinished: function dataUnfinished() {
      return this.dataList.filter(function (obj) {
        return obj.status !== 4;
      });
    }
  }),
  created: function created() {},
  mounted: function mounted() {
    var _this = this;

    var token = stringify_default()(getRequest(window.location.href)) !== '{}' ? getRequest(window.location.href).info : null;
    if (token) {
      this.getAccessToken();
    } else {
      this.getAfterLogin().then(function () {
        _this.$store.dispatch('userInfoAction', _this.userInfo);
        _this.getflowProcedure();

        _this.getCurrentDate();
        _this.getDataList();
      });
    }

    this.getNotice();
  },

  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])(['currentProcedureInfoAction']), {
    getAccessToken: function getAccessToken() {
      var _this2 = this;

      var token = stringify_default()(getRequest(window.location.href)) !== '{}' ? getRequest(window.location.href).info : null;
      if (token) {
        this.$store.dispatch('LoginAction', token);
        this.getAfterLogin().then(function () {
          _this2.$store.dispatch('userInfoAction', _this2.userInfo);
          _this2.getflowProcedure();

          _this2.getDataList();
        });
        this.$vux.toast.text('登录成功', 'top');
      } else {
        if (!this.token) {
          this.$vux.toast.text('未通过移动泰山科技学院获取到学生身份', 'top');
        }
      }
    },
    back: function back() {

      Cordova.exec(null, null, 'SYNPlugin', 'synCordovaPlugin', ['synjones.synpay.window.exit.app']);
    },
    toLogin: function toLogin() {
      var _this3 = this;

      setTimeout(function () {
        _this3.$router.push({ 'name': 'login' });
      }, 300);
    },
    getAfterLogin: function getAfterLogin() {
      var _this4 = this;

      return new promise_default.a(function (resolve, reject) {
        _this4.$api.get('/user/afterLogin', null, function (r) {
          if (r.data.flowBean) {
            _this4.flowInfo = {
              flowId: r.data.flowBean.id,
              flowType: r.data.flowBean.flowType,
              flowYear: r.data.flowBean.year
            };
            _this4.$store.dispatch('flowInfoAction', _this4.flowInfo);
          } else {
            _this4.$vux.alert.show({
              title: '当前时间您不在办理流程中',
              content: '请于流程开始后再访问',
              onShow: function onShow() {},
              onHide: function onHide() {

                Cordova.exec(null, null, 'SYNPlugin', 'synCordovaPlugin', ['synjones.synpay.window.exit.app']);
              }
            });
          }
          _this4.userInfo = r.data.studentBean;

          _this4.$set(_this4.userInfo, 'studentPictureUrl', r.data.studentPictureUrl);
          _this4.$store.dispatch('flowInfoAction', _this4.flowInfo);
          resolve();
        }, function (err) {
          _this4.$vux.toast.text(err.message, 'middle');
        });
      });
    },
    getflowProcedure: function getflowProcedure() {
      var _this5 = this;

      var params = {
        flowId: this.flowId
      };
      this.$api.get('/flowProcedure', params, function (r) {

        var data = r.data;
        var idArr = [];
        data.forEach(function (element) {
          var obj = {
            procedureId: element.procedureBean.id,
            flowProcedureId: element.id,
            name: element.procedureBean.name,
            startDate: element.startDate,
            endDate: element.endDate,
            status: element.procedureBean.status,
            icon: element.procedureBean.icon,
            flag: element.procedureBean.flag,
            router: element.procedureBean.router,
            flagFlow: element.flag,
            config: element.config
          };

          idArr.push(element.procedureBean.id);
          _this5.flowProcedureList2.push(obj);
        });
      }, function (err) {
        _this5.$vux.toast.text(err.message, 'middle');
      });
    },
    getDataList: function getDataList() {
      var _this6 = this;

      this.$vux.loading.show();
      var params = {
        studentId: this.studentId,
        flowId: this.flowId,
        'flowBean.isInFlow': 1
      };
      this.$api.get('/dataManagement/getDataManagementList', params, function (r) {
        var data = r.data;
        var arr1 = [];
        var arr2 = [];
        data.forEach(function (element) {
          _this6.dataList.push(element);
          if (element.status !== 4) {
            arr1.push(element);
          } else {
            arr2.push(element);
          }
        });
        _this6.dataList2 = arr1.concat(arr2);
        _this6.$vux.loading.hide();
      }, function (err) {
        _this6.$vux.toast.text(err.message, 'middle');
      });
    },
    getNotice: function getNotice() {
      var _this7 = this;

      var params = {
        isQueryContent: 1,
        isExpire: 1,
        isPublish: 1
      };
      this.$api.get('/notice', params, function (r) {
        _this7.$vux.loading.hide();
        var data = r.data.slice(0, 2);
        data.forEach(function (element) {
          var obj = {
            title: element.title
          };
          _this7.noticeList.push(obj);
        });
        if (_this7.noticeList.length > 0) {
          _this7.isBadge = true;
        } else {
          _this7.isBadge = false;
        }
      }, function (err) {
        _this7.$vux.toast.text(err.message, 'middle');
      });
    },
    getCurrentDate: function getCurrentDate() {
      var _this8 = this;

      return new promise_default.a(function (resolve, reject) {
        _this8.$api.get('/helper/systemDateTime', null, function (r) {

          _this8.currentDate = r.data;
          resolve();
        }, function (err) {
          _this8.$vux.toast.text(err.message, 'middle');
        });
      });
    },
    getIsOverdue: function getIsOverdue(endDate, procedureBeanId, router, name) {

      if (Date.parse(endDate + ' 23:59:59') < Date.parse(this.currentDate)) {
        this.getManageState(endDate, procedureBeanId, router, name);
      } else {
        this.getPreposition(procedureBeanId, router, name);
      }
    },
    getPreposition: function getPreposition(procedureBeanId, router, name) {
      var _this9 = this;

      var params = {
        'procedureBean.id': procedureBeanId,
        'studentBean.id': this.studentId,
        'flowBean.id': this.flowId
      };
      this.$api.get('/dataManagement', params, function (r) {
        _this9.$vux.loading.hide();
        if (r.data.status === 4 || r.data.status === 1 || r.data.status === 3 || r.data.status === 6) {
          _this9.$router.push({ name: 'itemResult', params: { title: name, status: r.data.status } });
        } else {
          _this9.$router.push({ name: router, params: { title: name, status: r.data.status } });
        }
      }, function (err) {
        _this9.$vux.toast.text(err.message, 'middle');
      });
    },
    getManageState: function getManageState(endDate, procedureBeanId, router, name) {
      var _this10 = this;

      var params = {
        'studentId': this.studentId,
        'flowId': this.flowId,
        'procedureId': procedureBeanId
      };
      this.$api.get('/dataManagement/getDataManagementList', params, function (r) {
        _this10.$vux.loading.hide();
        if (r.data.length > 0) {
          if (r.data[0].status === 4 || r.data[0].status === 1 || r.data[0].status === 3 || r.data[0].status === 6) {
            _this10.$router.push({ name: 'itemResult', params: { title: name, status: r.data.status } });
          } else {
            _this10.$vux.toast.text('该手续已于' + endDate + '结束办理', 'middle');
          }
        }
      }, function (err) {
        _this10.$vux.toast.text(err.message, 'middle');
      });
    },
    currentProcedure: function currentProcedure(item) {
      var _this11 = this;

      var itemDate = item.flowProcedureBean.startDate;
      this.getCurrentDate().then(function () {
        if (_this11.token && DatetimeStamp(itemDate + ' 00:00:00') <= DatetimeStamp(_this11.currentDate)) {
          var currentProcedureInfo = {
            flowProcedureId: item.flowProcedureId,
            procedureId: item.procedureId,
            name: item.procedureBean.name,
            router: item.procedureBean.router,
            endDate: item.flowProcedureBean.endDate,

            parentRouter: 'home'
          };
          _this11.$store.dispatch('currentProcedureInfoAction', currentProcedureInfo);
          if (item.procedureBean.flag.split('')[0] === '1' && item.procedureBean.flag.split('')[1] === '0') {
            _this11.$vux.toast.text(item.procedureBean.name + '需到现场办理，不可网上办理', 'middle');
          } else if (item.flowProcedureBean.flag.split('')[5] === '1' && item.procedureId !== 3) {
            window.location = item.flowProcedureBean.config;
          } else {
            if (item.procedureBean.router === 'pay' || item.procedureBean.router === 'info') {
              _this11.$router.push({
                name: item.procedureBean.router,
                query: {
                  flowProcedureId: item.flowProcedureId,
                  procedureId: item.procedureId
                }
              });
            } else {
              _this11.getIsOverdue(item.flowProcedureBean.endDate, item.procedureId, item.procedureBean.router, item.procedureBean.name);
            }
          }
        } else if (!_this11.token) {
          _this11.toLogin();
        } else if (DatetimeStamp(itemDate + ' 00:00:00') > DatetimeStamp(_this11.currentDate)) {
          _this11.$vux.alert.show({
            title: item.procedureBean.name + '未到办理时间',
            content: '请于' + itemDate + '办理',
            buttonText: '我知道了'
          });
        }
      });
    },
    isDonate: function isDonate() {
      var _this12 = this;

      var params = {
        studentId: this.studentId,
        flowId: this.flowId
      };
      return new promise_default.a(function (resolve, reject) {
        _this12.$api.get('/donation', params, function (r) {
          if (r.data.length > 0) {
            _this12.donateFlag = false;
          } else {
            _this12.donateFlag = true;
          }
          resolve();
        }, function (err) {
          _this12.$vux.toast.text(err.message, 'middle');
        });
      });
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-661f8565","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/yingxin/tskjxy/views/home.vue
var home_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('x-header',{staticClass:"header bg-white border-bottom fixed top"},[_c('span',{attrs:{"slot":"overwrite-left"},slot:"overwrite-left"},[(!_vm.wx)?_c('em',{staticClass:"icon icon-arrow-left",attrs:{"size":""},on:{"click":_vm.back}}):_vm._e()]),_vm._v(_vm._s(_vm.title)),_c('div',{staticClass:"more-list",attrs:{"slot":"right"},slot:"right"},[_c('popover',{attrs:{"placement":"bottom","name":""}},[_c('div',{staticClass:"popover-demo-content more-content",attrs:{"slot":"content"},slot:"content"},[_c('ul',{ref:"fixedPopover",staticClass:"fixed-popover"},[_c('li',[_c('router-link',{attrs:{"to":{name:'qrcode'}}},[_c('em',{staticClass:"icon icon-qrcode"}),_c('span',{staticClass:"text"},[_vm._v("我的二维码")])])],1)])]),_c('button',{staticClass:"btn btn-default"},[_c('em',{staticClass:"icon-add-circle font-size-20"})])])],1)]),_c('section',{staticClass:"section fixed-next"},[_c('div',{staticClass:"container bg-white"},[_c('div',{staticClass:"panel"},[_c('div',{staticClass:"panel-header"},[_c('h4',{staticClass:"float-left text-gary"}),_c('router-link',{staticClass:"float-right text-brand",attrs:{"to":{name: 'record'}}},[_vm._v("查看全部"),_c('em',{staticClass:"icon icon-arrow-right"})])],1),(_vm.token == null)?_c('div',{staticClass:"panel-body"},[(_vm.flowProcedureList.length == 0)?[_c('error',{attrs:{"errorMsg":_vm.errorMsg}})]:[_c('vue-swiper',{ref:"swiper",staticClass:"swiper-wrapper",attrs:{"options":_vm.swiperOption}},_vm._l((_vm.flowProcedureList),function(item,index){return _c('swiper-slide',{key:index,staticClass:"swiper-slide",class:("picture-bg" + (((index)%3)+1))},[_c('div',[_c('h3',{staticClass:"name"},[_vm._v(_vm._s(item.name))]),_c('p',{staticClass:"date"},[_vm._v("登陆后查看办理时间")])])])}),1)]],2):_c('div',{staticClass:"panel-body"},[(_vm.dataList2.length == 0)?[_c('error',{attrs:{"errorMsg":_vm.errorMsg}})]:[_c('vue-swiper',{ref:"swiper",staticClass:"swiper-wrapper",attrs:{"options":_vm.swiperOption}},_vm._l((_vm.dataList2),function(item,index){return _c('swiper-slide',{key:index,staticClass:"swiper-slide",class:("picture-bg" + (((index)%3)+1))},[_c('div',{on:{"click":function($event){return _vm.currentProcedure(item)}}},[_c('div',{staticClass:"right-top-mark"},[(item.procedureBean.flag.split('')[0] === '1' && item.procedureBean.flag.split('')[1] === '0')?_c('div',{staticClass:"text"},[_vm._v("现场办理")]):(Date.parse((item.flowProcedureBean.startDate + ' 00:00:00').replace(/-/g, '/')) > Date.parse(_vm.currentDate.replace(/-/g, '/')))?_c('div',{staticClass:"text"},[_vm._v("未开始")]):(item.status === 4)?_c('div',{staticClass:"text"},[_vm._v("已完成")]):_vm._e()]),_c('h3',{staticClass:"name"},[_vm._v(_vm._s(item.procedureBean.name))]),_c('p',{staticClass:"date"},[_vm._v(_vm._s(item.flowProcedureBean.startDate.replace(/-/g,"."))+" - "+_vm._s(item.flowProcedureBean.endDate.replace(/-/g,".")))])])])}),1)]],2)])])]),_c('section',{staticClass:"section"},[_c('div',{staticClass:"container bg-white progress"},[_c('div',{staticClass:"panel"},[_vm._m(0),_c('div',{staticClass:"panel-body"},[(_vm.token == null)?_c('div',{staticClass:"text-center"},[_c('x-button',{attrs:{"type":"brand","mini":"mini"},nativeOn:{"click":function($event){return _vm.toLogin($event)}}},[_vm._v("去登录")])],1):_c('div',{staticClass:"progress-bar"},[_c('flow',[_vm._l((_vm.dataFinished),function(item,index){return [_c('flow-state',{attrs:{"is-done":item.status == 4}}),(index == (_vm.dataFinished.length - 1))?_c('flow-line',{attrs:{"tip":((_vm.dataFinished.length) + "/" + (_vm.dataList.length))}}):_c('flow-line',{attrs:{"is-done":""}})]}),_vm._l((_vm.dataUnfinished),function(item,index){return [_c('flow-state',{attrs:{"is-done":item.status == 4}}),(index != (_vm.dataUnfinished.length - 1))?_c('flow-line'):_vm._e()]})],2)],1)])])])]),_c('section',{staticClass:"section"},[_c('div',{staticClass:"container bg-white"},[_c('router-link',{attrs:{"to":{name: 'notice'}}},[_c('dl',{staticClass:"panel notice flex"},[_c('dt',{staticClass:"picture"},[_c('img',{attrs:{"src":__webpack_require__("8FNJ")}})]),_c('dd',{staticClass:"content flex-1"},[(_vm.noticeList.length > 0)?_c('ul',_vm._l((_vm.noticeList),function(item,index){return _c('li',[_vm._v(_vm._s(item.title))])}),0):_c('ul',[_c('li',{staticClass:"text-center",staticStyle:{"color":"#696969","margin-top":"0.75rem"}},[_vm._v("暂无通知")])])]),_c('dd',{staticClass:"remark text-gary-light"},[(_vm.isBadge)?_c('badge'):_vm._e(),_c('em',{staticClass:"icon icon-arrow-right"})],1)])])],1)]),_c('section',{staticClass:"section",staticStyle:{"margin-bottom":"40px"}},[_c('div',{staticClass:"container bg-white"},[_c('swiper',{attrs:{"aspect-ratio":_vm.swiper.aspectRatio,"dots-position":_vm.swiper.position,"show-dots":_vm.showProcedure2.length>8},model:{value:(_vm.swiper.index),callback:function ($$v) {_vm.$set(_vm.swiper, "index", $$v)},expression:"swiper.index"}},_vm._l((Math.ceil(_vm.showProcedure2.length / 8)),function(i){return _c('swiper-item',{key:i},[_c('grid',{attrs:{"show-lr-borders":false,"show-vertical-dividers":false,"cols":4}},_vm._l((_vm.showProcedure2),function(item,index){return (index >= (i-1)*8 && index < i*8)?_c('grid-item',{key:index,attrs:{"label":item.procedureBean.name},on:{"on-item-click":function($event){return _vm.currentProcedure(item)}}},[_c('span',{staticClass:"item-box icon-bg",class:("icon-bg" + (((index)%4)+1)),attrs:{"slot":"icon"},slot:"icon"},[_c('em',{staticClass:"icon icon-item",class:("icon-" + (item.procedureBean.icon))})])]):_vm._e()}),1)],1)}),1)],1)])],1)}
var home_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"panel-header"},[_c('h4',{staticClass:"float-left text-gary"},[_vm._v("办理进度")])])}]
var home_esExports = { render: home_render, staticRenderFns: home_staticRenderFns }
/* harmony default export */ var tskjxy_views_home = (home_esExports);
// CONCATENATED MODULE: ./src/yingxin/tskjxy/views/home.vue
var home_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var home___vue_template_functional__ = false
/* styles */
var home___vue_styles__ = null
/* scopeId */
var home___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var home___vue_module_identifier__ = null
var home_Component = home_normalizeComponent(
  views_home,
  tskjxy_views_home,
  home___vue_template_functional__,
  home___vue_styles__,
  home___vue_scopeId__,
  home___vue_module_identifier__
)

/* harmony default export */ var yingxin_tskjxy_views_home = (home_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/tab/tab.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var tab = ({
  name: 'tab',
  mixins: [multi_items["b" /* parentMixin */]],
  mounted: function mounted() {
    var _this = this;

    // stop bar anmination on first loading
    this.$nextTick(function () {
      setTimeout(function () {
        _this.hasReady = true;
      }, 0);
    });
  },

  props: {
    lineWidth: {
      type: Number,
      default: 3
    },
    activeColor: String,
    barActiveColor: String,
    defaultColor: String,
    disabledColor: String,
    animate: {
      type: Boolean,
      default: true
    },
    customBarWidth: [Function, String],
    preventDefault: Boolean,
    scrollThreshold: {
      type: Number,
      default: 4
    },
    barPosition: {
      type: String,
      default: 'bottom',
      validator: function validator(val) {
        return ['bottom', 'top'].indexOf(val) !== -1;
      }
    }
  },
  computed: {
    barLeft: function barLeft() {
      if (this.hasReady) {
        var count = this.scrollable ? window.innerWidth / this.$children[this.currentIndex || 0].$el.getBoundingClientRect().width : this.number;
        return this.currentIndex * (100 / count) + '%';
      }
    },
    barRight: function barRight() {
      if (this.hasReady) {
        var count = this.scrollable ? window.innerWidth / this.$children[this.currentIndex || 0].$el.getBoundingClientRect().width : this.number;
        return (count - this.currentIndex - 1) * (100 / count) + '%';
      }
    },

    // when prop:custom-bar-width
    innerBarStyle: function innerBarStyle() {
      return {
        width: typeof this.customBarWidth === 'function' ? this.customBarWidth(this.currentIndex) : this.customBarWidth,
        backgroundColor: this.barActiveColor || this.activeColor
      };
    },

    // end
    barStyle: function barStyle() {
      var commonStyle = {
        left: this.barLeft,
        right: this.barRight,
        display: 'block',
        height: this.lineWidth + 'px',
        transition: !this.hasReady ? 'none' : null
      };
      if (!this.customBarWidth) {
        commonStyle.backgroundColor = this.barActiveColor || this.activeColor;
      } else {
        commonStyle.backgroundColor = 'transparent'; // when=prop:custom-bar-width
      }
      return commonStyle;
    },
    barClass: function barClass() {
      return {
        'vux-tab-ink-bar-transition-forward': this.direction === 'forward',
        'vux-tab-ink-bar-transition-backward': this.direction === 'backward'
      };
    },
    scrollable: function scrollable() {
      return this.number > this.scrollThreshold;
    }
  },
  watch: {
    currentIndex: function currentIndex(newIndex, oldIndex) {
      this.direction = newIndex > oldIndex ? 'forward' : 'backward';
      this.$emit('on-index-change', newIndex, oldIndex);
      this.hasReady && this.scrollToActiveTab();
    }
  },
  data: function data() {
    return {
      direction: 'forward',
      right: '100%',
      hasReady: false
    };
  },

  methods: {
    scrollToActiveTab: function scrollToActiveTab() {
      var _this2 = this;

      if (!this.scrollable || !this.$children || !this.$children.length) {
        return;
      }
      var currentIndexTab = this.$children[this.currentIndex].$el;
      var count = 0;
      // scroll animation
      var step = function step() {
        var scrollDuration = 15;
        var nav = _this2.$refs.nav;
        nav.scrollLeft += (currentIndexTab.offsetLeft - (nav.offsetWidth - currentIndexTab.offsetWidth) / 2 - nav.scrollLeft) / scrollDuration;
        if (++count < scrollDuration) {
          window.requestAnimationFrame(step);
        }
      };
      window.requestAnimationFrame(step);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/tab/tab.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var tab_tab = ({
  name: 'tab',
  mixins: [multi_items["b" /* parentMixin */]],
  mounted: function mounted() {
    var _this = this;

    // stop bar anmination on first loading
    this.$nextTick(function () {
      setTimeout(function () {
        _this.hasReady = true;
      }, 0);
    });
  },

  props: {
    lineWidth: {
      type: Number,
      default: 3
    },
    activeColor: String,
    barActiveColor: String,
    defaultColor: String,
    disabledColor: String,
    animate: {
      type: Boolean,
      default: true
    },
    customBarWidth: [Function, String],
    preventDefault: Boolean,
    scrollThreshold: {
      type: Number,
      default: 4
    },
    barPosition: {
      type: String,
      default: 'bottom',
      validator: function validator(val) {
        return ['bottom', 'top'].indexOf(val) !== -1;
      }
    }
  },
  computed: {
    barLeft: function barLeft() {
      if (this.hasReady) {
        var count = this.scrollable ? window.innerWidth / this.$children[this.currentIndex || 0].$el.getBoundingClientRect().width : this.number;
        return this.currentIndex * (100 / count) + '%';
      }
    },
    barRight: function barRight() {
      if (this.hasReady) {
        var count = this.scrollable ? window.innerWidth / this.$children[this.currentIndex || 0].$el.getBoundingClientRect().width : this.number;
        return (count - this.currentIndex - 1) * (100 / count) + '%';
      }
    },

    // when prop:custom-bar-width
    innerBarStyle: function innerBarStyle() {
      return {
        width: typeof this.customBarWidth === 'function' ? this.customBarWidth(this.currentIndex) : this.customBarWidth,
        backgroundColor: this.barActiveColor || this.activeColor
      };
    },

    // end
    barStyle: function barStyle() {
      var commonStyle = {
        left: this.barLeft,
        right: this.barRight,
        display: 'block',
        height: this.lineWidth + 'px',
        transition: !this.hasReady ? 'none' : null
      };
      if (!this.customBarWidth) {
        commonStyle.backgroundColor = this.barActiveColor || this.activeColor;
      } else {
        commonStyle.backgroundColor = 'transparent'; // when=prop:custom-bar-width
      }
      return commonStyle;
    },
    barClass: function barClass() {
      return {
        'vux-tab-ink-bar-transition-forward': this.direction === 'forward',
        'vux-tab-ink-bar-transition-backward': this.direction === 'backward'
      };
    },
    scrollable: function scrollable() {
      return this.number > this.scrollThreshold;
    }
  },
  watch: {
    currentIndex: function currentIndex(newIndex, oldIndex) {
      this.direction = newIndex > oldIndex ? 'forward' : 'backward';
      this.$emit('on-index-change', newIndex, oldIndex);
      this.hasReady && this.scrollToActiveTab();
    }
  },
  data: function data() {
    return {
      direction: 'forward',
      right: '100%',
      hasReady: false
    };
  },

  methods: {
    scrollToActiveTab: function scrollToActiveTab() {
      var _this2 = this;

      if (!this.scrollable || !this.$children || !this.$children.length) {
        return;
      }
      var currentIndexTab = this.$children[this.currentIndex].$el;
      var count = 0;
      // scroll animation
      var step = function step() {
        var scrollDuration = 15;
        var nav = _this2.$refs.nav;
        nav.scrollLeft += (currentIndexTab.offsetLeft - (nav.offsetWidth - currentIndexTab.offsetWidth) / 2 - nav.scrollLeft) / scrollDuration;
        if (++count < scrollDuration) {
          window.requestAnimationFrame(step);
        }
      };
      window.requestAnimationFrame(step);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2507d984","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/tab/tab.vue
var tab_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-tab-wrap",class:_vm.barPosition === 'top' ? 'vux-tab-bar-top' : ''},[_c('div',{staticClass:"vux-tab-container"},[_c('div',{ref:"nav",staticClass:"vux-tab",class:[{'vux-tab-no-animate': !_vm.animate},{ scrollable: _vm.scrollable }]},[_vm._t("default"),_vm._v(" "),(_vm.animate)?_c('div',{staticClass:"vux-tab-ink-bar",class:_vm.barClass,style:(_vm.barStyle)},[(_vm.customBarWidth)?_c('span',{staticClass:"vux-tab-bar-inner",style:(_vm.innerBarStyle)}):_vm._e()]):_vm._e()],2)])])}
var tab_staticRenderFns = []
var tab_esExports = { render: tab_render, staticRenderFns: tab_staticRenderFns }
/* harmony default export */ var components_tab_tab = (tab_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/tab/tab.vue
function tab_injectStyle (ssrContext) {
  __webpack_require__("kKqQ")
}
var tab_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var tab___vue_template_functional__ = false
/* styles */
var tab___vue_styles__ = tab_injectStyle
/* scopeId */
var tab___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var tab___vue_module_identifier__ = null
var tab_Component = tab_normalizeComponent(
  tab_tab,
  components_tab_tab,
  tab___vue_template_functional__,
  tab___vue_styles__,
  tab___vue_scopeId__,
  tab___vue_module_identifier__
)

/* harmony default export */ var src_components_tab_tab = (tab_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/tab/tab-item.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var tab_item = ({
  name: 'tab-item',
  mixins: [multi_items["a" /* childMixin */]],
  props: {
    activeClass: String,
    disabled: Boolean,
    badgeBackground: {
      type: String,
      default: '#f74c31'
    },
    badgeColor: {
      type: String,
      default: '#fff'
    },
    badgeLabel: String
  },
  computed: {
    style: function style() {
      return {
        borderWidth: this.$parent.lineWidth + 'px',
        borderColor: this.$parent.activeColor,
        color: this.currentSelected ? this.$parent.activeColor : this.disabled ? this.$parent.disabledColor : this.$parent.defaultColor,
        border: this.$parent.animate ? 'none' : 'auto'
      };
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/tab/tab-item.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var tab_tab_item = ({
  name: 'tab-item',
  mixins: [multi_items["a" /* childMixin */]],
  props: {
    activeClass: String,
    disabled: Boolean,
    badgeBackground: {
      type: String,
      default: '#f74c31'
    },
    badgeColor: {
      type: String,
      default: '#fff'
    },
    badgeLabel: String
  },
  computed: {
    style: function style() {
      return {
        borderWidth: this.$parent.lineWidth + 'px',
        borderColor: this.$parent.activeColor,
        color: this.currentSelected ? this.$parent.activeColor : this.disabled ? this.$parent.disabledColor : this.$parent.defaultColor,
        border: this.$parent.animate ? 'none' : 'auto'
      };
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9b8ab944","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/tab/tab-item.vue
var tab_item_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-tab-item",class:[_vm.currentSelected ? _vm.activeClass : '', {
    'vux-tab-selected': _vm.currentSelected,
    'vux-tab-disabled': _vm.disabled 
  }],style:(_vm.style),on:{"click":_vm.onItemClick}},[_vm._t("default"),_vm._v(" "),(typeof _vm.badgeLabel !== 'undefined' && _vm.badgeLabel !== '')?_c('span',{staticClass:"vux-tab-item-badge",style:({
      background: _vm.badgeBackground,
      color: _vm.badgeColor
    })},[_vm._v("\n  "+_vm._s(_vm.badgeLabel))]):_vm._e()],2)}
var tab_item_staticRenderFns = []
var tab_item_esExports = { render: tab_item_render, staticRenderFns: tab_item_staticRenderFns }
/* harmony default export */ var components_tab_tab_item = (tab_item_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/tab/tab-item.vue
var tab_item_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var tab_item___vue_template_functional__ = false
/* styles */
var tab_item___vue_styles__ = null
/* scopeId */
var tab_item___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var tab_item___vue_module_identifier__ = null
var tab_item_Component = tab_item_normalizeComponent(
  tab_tab_item,
  components_tab_tab_item,
  tab_item___vue_template_functional__,
  tab_item___vue_styles__,
  tab_item___vue_scopeId__,
  tab_item___vue_module_identifier__
)

/* harmony default export */ var src_components_tab_tab_item = (tab_item_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/yingxin/tskjxy/views/notice/notice.vue













/* harmony default export */ var notice = ({
  name: 'notice',
  props: [],
  components: {
    XHeader: vux_src_components_x_header,
    Badge: vux_src_components_badge,
    Tab: src_components_tab_tab,
    TabItem: src_components_tab_tab_item,
    Swiper: vux_src_components_swiper_swiper,
    SwiperItem: src_components_swiper_swiper_item,
    'scroller': vuescroll_default.a,
    XButton: vux_src_components_x_button,
    Error: src_components_error
  },
  data: function data() {
    return {
      title: this.$route.meta.title,
      index: 0,
      nTpye: 0,
      meaaageNum: 0,
      messageText: '',
      messageInfo: '',
      noticeType: '',
      nTitleList: [],
      noticeList: [],
      fixedTop: 0,
      errorMsg: {
        type: 'null',
        content: '暂无数据，请查看其他类型'
      },
      errorNotice: {
        type: 'null',
        content: '暂无通知消息'
      },
      isFirstLoad: true,
      isNoMoreData: false,
      current: 1,
      totalPage: 0,
      listNew: [],
      scrollHeight: 0,
      ops: {
        vuescroll: {
          mode: 'slide',
          pullRefresh: {
            enable: true,
            tips: {
              deactive: '下拉刷新',
              active: '释放刷新',
              start: '刷新中...',
              beforeDeactive: '刷新成功!'
            }
          },
          pushLoad: {
            enable: true,
            tips: {
              deactive: '上拉加载',
              active: '释放加载',
              start: '加载中...',
              beforeDeactive: '加载成功!'
            }
          }
        },
        bar: {
          background: 'rgba(0, 107, 178, 0.3)',
          size: '3px',
          opacity: 0
        }
      }
    };
  },

  computed: extends_default()({}, Object(vuex_esm["c" /* mapState */])({
    token: function token(state) {
      return state.token;
    }
  })),
  created: function created() {},
  mounted: function mounted() {
    this.$vux.loading.show({
      text: '加载中'
    });
    this.getNoticeTitle();
    this.getMessage();
  },
  updated: function updated() {},
  destroyed: function destroyed() {},

  watch: {},
  methods: {
    back: function back() {
      var _this = this;

      setTimeout(function () {
        _this.$router.back(-1);
      }, 300);
    },
    getNoticeTitle: function getNoticeTitle() {
      var _this2 = this;

      this.$vux.loading.show({
        text: '加载中'
      });
      var params = {};
      params.status = 1;
      this.$api.get('/noticeType', params, function (r) {
        _this2.$vux.loading.hide();
        _this2.nTitleList = r.data;
        if (r.data.length > 0) {
          _this2.noticeType = r.data[0].id;
          _this2.getNoticeList();
        }
      }, function (err) {
        _this2.$vux.toast.text(err.message, 'top');
      });
    },
    changeType: function changeType(type) {
      this.noticeType = type;
      this.isFirstLoad = true;
      this.isNoMoreData = false;
      this.current = 1;
      this.getNoticeList();
    },
    getNoticeList: function getNoticeList() {
      var _this3 = this;

      var pageSize = 10;
      var params = {};
      this.listNew = [];
      params.typeId = this.noticeType;
      params.isExpire = 1;
      params.isPublish = 1;
      params.pageSize = pageSize;
      params.current = this.current;
      this.$api.get('/notice/page', params, function (r) {
        _this3.$vux.loading.hide();
        _this3.totalPage = Math.ceil(r.data.totalCount / pageSize);
        if (r.data.list.length > 0) {
          _this3.listNew = r.data.list;
        }
        if (_this3.isFirstLoad) {
          _this3.noticeList = r.data.list;
          if (_this3.$refs['vs'] && r.data.list.length > 0) {
            _this3.$refs['vs'].refresh();
          }
        }
        _this3.getScrollHeight();
      }, function (err) {
        _this3.$vux.toast.text(err.message, 'top');
      });
    },
    getMessage: function getMessage() {
      var _this4 = this;

      var params = {};
      params.status = 0;
      params.isRead = 0;
      params.sendType = 0;
      this.$api.get('/message/info', params, function (r) {
        _this4.$vux.loading.hide();
        if (r.data.length > 0) {
          _this4.messageText = r.data[0].content;
          _this4.messageInfo = r.data;
          _this4.meaaageNum = r.data.length;
        } else {
          _this4.getMessageRead();
        }
      }, function (err) {
        _this4.$vux.toast.text(err.message, 'top');
      });
    },
    getMessageRead: function getMessageRead() {
      var _this5 = this;

      var params = {};
      params.sendType = 0;
      params.status = 0;
      params.pageSize = 5;
      params.current = 1;
      this.$api.get('/message/info/page', params, function (r) {
        _this5.$vux.loading.hide();
        _this5.messageInfo = r.data.list;
        if (r.data.list.length > 0) {
          _this5.messageText = r.data.list[0].messageBean.name;
        }
      }, function (err) {
        _this5.$vux.toast.text(err.message, 'top');
      });
    },
    goNoticeDetail: function goNoticeDetail(id) {
      this.$router.push({ name: 'noticeDetail', params: { id: id } });
    },
    getScrollHeight: function getScrollHeight() {
      this.scrollHeight = document.documentElement.clientHeight - this.$refs.fixbox.offsetHeight - 53;
    },
    handleRS: function handleRS(vsInstance, refreshDom, done) {
      var _this6 = this;

      setTimeout(function () {
        _this6.isFirstLoad = false;
        _this6.isNoMoreData = false;
        _this6.current = 1;
        _this6.getNoticeList();
        done();
      }, 1500);
    },
    handleLoadStart: function handleLoadStart(vm, dom, done) {
      var _this7 = this;

      setTimeout(function () {
        _this7.isFirstLoad = false;
        if (_this7.current < _this7.totalPage) {
          _this7.current = _this7.current + 1;
          _this7.getNoticeList();
          _this7.ops.vuescroll.pushLoad.tips.beforeDeactive = '加载成功';
        } else {
          _this7.isNoMoreData = true;
          _this7.ops.vuescroll.pushLoad.tips.beforeDeactive = '没有更多数据了';
        }
        done();
      }, 600);
    },
    handleLBD: function handleLBD(vm, loadDom, done) {
      var _this8 = this;

      setTimeout(function () {
        if (!_this8.isNoMoreData) {
          _this8.noticeList = _this8.noticeList.concat(_this8.listNew);
        }
        _this8.$refs['vs'].refresh();
        done();
      }, 500);
    },
    handleRBD: function handleRBD(vm, loadDom, done) {
      var _this9 = this;

      setTimeout(function () {
        _this9.noticeList = [];
        _this9.noticeList = _this9.noticeList.concat(_this9.listNew);
        _this9.$refs['vs'].refresh();
        done();
      }, 500);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/yingxin/tskjxy/views/notice/notice.vue













/* harmony default export */ var notice_notice = ({
  name: 'notice',
  props: [],
  components: {
    XHeader: vux_src_components_x_header,
    Badge: vux_src_components_badge,
    Tab: src_components_tab_tab,
    TabItem: src_components_tab_tab_item,
    Swiper: vux_src_components_swiper_swiper,
    SwiperItem: src_components_swiper_swiper_item,
    'scroller': vuescroll_default.a,
    XButton: vux_src_components_x_button,
    Error: src_components_error
  },
  data: function data() {
    return {
      title: this.$route.meta.title,
      index: 0,
      nTpye: 0,
      meaaageNum: 0,
      messageText: '',
      messageInfo: '',
      noticeType: '',
      nTitleList: [],
      noticeList: [],
      fixedTop: 0,
      errorMsg: {
        type: 'null',
        content: '暂无数据，请查看其他类型'
      },
      errorNotice: {
        type: 'null',
        content: '暂无通知消息'
      },
      isFirstLoad: true,
      isNoMoreData: false,
      current: 1,
      totalPage: 0,
      listNew: [],
      scrollHeight: 0,
      ops: {
        vuescroll: {
          mode: 'slide',
          pullRefresh: {
            enable: true,
            tips: {
              deactive: '下拉刷新',
              active: '释放刷新',
              start: '刷新中...',
              beforeDeactive: '刷新成功!'
            }
          },
          pushLoad: {
            enable: true,
            tips: {
              deactive: '上拉加载',
              active: '释放加载',
              start: '加载中...',
              beforeDeactive: '加载成功!'
            }
          }
        },
        bar: {
          background: 'rgba(0, 107, 178, 0.3)',
          size: '3px',
          opacity: 0
        }
      }
    };
  },

  computed: extends_default()({}, Object(vuex_esm["c" /* mapState */])({
    token: function token(state) {
      return state.token;
    }
  })),
  created: function created() {},
  mounted: function mounted() {
    this.$vux.loading.show({
      text: '加载中'
    });
    this.getNoticeTitle();
    this.getMessage();
  },
  updated: function updated() {},
  destroyed: function destroyed() {},

  watch: {},
  methods: {
    back: function back() {
      var _this = this;

      setTimeout(function () {
        _this.$router.back(-1);
      }, 300);
    },
    getNoticeTitle: function getNoticeTitle() {
      var _this2 = this;

      this.$vux.loading.show({
        text: '加载中'
      });
      var params = {};
      params.status = 1;
      this.$api.get('/noticeType', params, function (r) {
        _this2.$vux.loading.hide();
        _this2.nTitleList = r.data;
        if (r.data.length > 0) {
          _this2.noticeType = r.data[0].id;
          _this2.getNoticeList();
        }
      }, function (err) {
        _this2.$vux.toast.text(err.message, 'top');
      });
    },
    changeType: function changeType(type) {
      this.noticeType = type;
      this.isFirstLoad = true;
      this.isNoMoreData = false;
      this.current = 1;
      this.getNoticeList();
    },
    getNoticeList: function getNoticeList() {
      var _this3 = this;

      var pageSize = 10;
      var params = {};
      this.listNew = [];
      params.typeId = this.noticeType;
      params.isExpire = 1;
      params.isPublish = 1;
      params.pageSize = pageSize;
      params.current = this.current;
      this.$api.get('/notice/page', params, function (r) {
        _this3.$vux.loading.hide();
        _this3.totalPage = Math.ceil(r.data.totalCount / pageSize);
        if (r.data.list.length > 0) {
          _this3.listNew = r.data.list;
        }
        if (_this3.isFirstLoad) {
          _this3.noticeList = r.data.list;
          if (_this3.$refs['vs'] && r.data.list.length > 0) {
            _this3.$refs['vs'].refresh();
          }
        }
        _this3.getScrollHeight();
      }, function (err) {
        _this3.$vux.toast.text(err.message, 'top');
      });
    },
    getMessage: function getMessage() {
      var _this4 = this;

      var params = {};
      params.status = 0;
      params.isRead = 0;
      params.sendType = 0;
      this.$api.get('/message/info', params, function (r) {
        _this4.$vux.loading.hide();
        if (r.data.length > 0) {
          _this4.messageText = r.data[0].content;
          _this4.messageInfo = r.data;
          _this4.meaaageNum = r.data.length;
        } else {
          _this4.getMessageRead();
        }
      }, function (err) {
        _this4.$vux.toast.text(err.message, 'top');
      });
    },
    getMessageRead: function getMessageRead() {
      var _this5 = this;

      var params = {};
      params.sendType = 0;
      params.status = 0;
      params.pageSize = 5;
      params.current = 1;
      this.$api.get('/message/info/page', params, function (r) {
        _this5.$vux.loading.hide();
        _this5.messageInfo = r.data.list;
        if (r.data.list.length > 0) {
          _this5.messageText = r.data.list[0].messageBean.name;
        }
      }, function (err) {
        _this5.$vux.toast.text(err.message, 'top');
      });
    },
    goNoticeDetail: function goNoticeDetail(id) {
      this.$router.push({ name: 'noticeDetail', params: { id: id } });
    },
    getScrollHeight: function getScrollHeight() {
      this.scrollHeight = document.documentElement.clientHeight - this.$refs.fixbox.offsetHeight - 53;
    },
    handleRS: function handleRS(vsInstance, refreshDom, done) {
      var _this6 = this;

      setTimeout(function () {
        _this6.isFirstLoad = false;
        _this6.isNoMoreData = false;
        _this6.current = 1;
        _this6.getNoticeList();
        done();
      }, 1500);
    },
    handleLoadStart: function handleLoadStart(vm, dom, done) {
      var _this7 = this;

      setTimeout(function () {
        _this7.isFirstLoad = false;
        if (_this7.current < _this7.totalPage) {
          _this7.current = _this7.current + 1;
          _this7.getNoticeList();
          _this7.ops.vuescroll.pushLoad.tips.beforeDeactive = '加载成功';
        } else {
          _this7.isNoMoreData = true;
          _this7.ops.vuescroll.pushLoad.tips.beforeDeactive = '没有更多数据了';
        }
        done();
      }, 600);
    },
    handleLBD: function handleLBD(vm, loadDom, done) {
      var _this8 = this;

      setTimeout(function () {
        if (!_this8.isNoMoreData) {
          _this8.noticeList = _this8.noticeList.concat(_this8.listNew);
        }
        _this8.$refs['vs'].refresh();
        done();
      }, 500);
    },
    handleRBD: function handleRBD(vm, loadDom, done) {
      var _this9 = this;

      setTimeout(function () {
        _this9.noticeList = [];
        _this9.noticeList = _this9.noticeList.concat(_this9.listNew);
        _this9.$refs['vs'].refresh();
        done();
      }, 500);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-69a575e5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/yingxin/tskjxy/views/notice/notice.vue
var notice_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{ref:"fixbox"},[_c('x-header',{staticClass:"header bg-white box-shadow",attrs:{"left-options":{showBack: false}}},[_vm._v(_vm._s(_vm.title))]),_c('div',{ref:"middlebox",staticClass:"section inbox-wrapper fixed-next"},[_c('router-link',{attrs:{"to":{name: _vm.token ? 'messageList' : 'login'}}},[_c('div',{staticClass:"container bg-white inbox"},[_c('div',{staticClass:"inbox-icon icon-message"}),_c('div',{staticClass:"inbox-content"},[_c('div',{staticClass:"titile"},[_vm._v("私信"),(_vm.token&&_vm.meaaageNum>0)?_c('badge',{attrs:{"text":_vm.meaaageNum < 999 ? _vm.meaaageNum : "999"}}):_vm._e()],1),(_vm.token&&_vm.messageInfo.length>0)?_c('p',[_vm._v(_vm._s(_vm.messageText))]):(_vm.token&&_vm.messageInfo.length==0)?_c('p',[_vm._v("您暂无私信")]):_c('p',[_vm._v("请登录")])]),_c('i',{staticClass:"icon-arrow-right"})])])],1),_c('tab',{class:_vm.nTitleList.length==0 ?"notict-title-bg" : "",attrs:{"line-width":_vm.nTitleList.length==1 ? 0 : 2,"active-color":_vm.nTitleList.length==1 ? "#666" :"#FEAA33"},model:{value:(_vm.index),callback:function ($$v) {_vm.index=$$v},expression:"index"}},_vm._l((_vm.nTitleList),function(item,index){return _c('tab-item',{key:index,on:{"on-item-click":function($event){return _vm.changeType(item.id)}}},[_vm._v(_vm._s(item.name))])}),1)],1),_c('div',{staticClass:"panel-body notice notice-fised"},[(_vm.nTitleList.length == 0)?_c('error',{attrs:{"errorMsg":_vm.errorNotice}}):_c('div',{staticClass:"notice-list"},[_c('div',{staticClass:"n-list-wrapper",style:(("height:" + _vm.scrollHeight + "px"))},[(_vm.noticeList.length > 0)?_c('scroller',{ref:"vs",attrs:{"ops":_vm.ops},on:{"refresh-start":_vm.handleRS,"load-before-deactivate":_vm.handleLBD,"refresh-before-deactivate":_vm.handleRBD,"load-start":_vm.handleLoadStart}},[_c('section',_vm._l((_vm.noticeList),function(itemList,i){return _c('div',{key:i,staticClass:"n-list-item bg-white",on:{"click":function($event){return _vm.goNoticeDetail(itemList.id)}}},[_c('div',{staticClass:"n-source"},[_c('span',{staticClass:"n-unit"},[_vm._v(_vm._s(itemList.departmentBean.name))]),_c('span',{staticClass:"date"},[_vm._v(_vm._s(itemList.publishDatetime))])]),_c('div',{staticClass:"n-title"},[_vm._v(_vm._s(itemList.title))])])}),0)]):_c('error',{staticStyle:{"padding":"2rem 0"},attrs:{"errorMsg":_vm.errorMsg}})],1)])],1),_c('transition',{attrs:{"name":"slide","enter-active-class":"animated fastest slideInRight","leave-active-class":"animated fastest slideOutRight"}},[_c('router-view')],1)],1)}
var notice_staticRenderFns = []
var notice_esExports = { render: notice_render, staticRenderFns: notice_staticRenderFns }
/* harmony default export */ var views_notice_notice = (notice_esExports);
// CONCATENATED MODULE: ./src/yingxin/tskjxy/views/notice/notice.vue
var notice_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var notice___vue_template_functional__ = false
/* styles */
var notice___vue_styles__ = null
/* scopeId */
var notice___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var notice___vue_module_identifier__ = null
var notice_Component = notice_normalizeComponent(
  notice_notice,
  views_notice_notice,
  notice___vue_template_functional__,
  notice___vue_styles__,
  notice___vue_scopeId__,
  notice___vue_module_identifier__
)

/* harmony default export */ var tskjxy_views_notice_notice = (notice_Component.exports);

// EXTERNAL MODULE: ./node_modules/vux/src/libs/clean-style.js
var clean_style = __webpack_require__("wmxo");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/group/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var group = ({
  name: 'group',
  methods: {
    cleanStyle: clean_style["a" /* default */]
  },
  props: {
    title: String,
    titleColor: String,
    labelWidth: String,
    labelAlign: String,
    labelMarginRight: String,
    gutter: [String, Number],
    footerTitle: String,
    footerTitleColor: String
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/group/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var components_group = ({
  name: 'group',
  methods: {
    cleanStyle: clean_style["a" /* default */]
  },
  props: {
    title: String,
    titleColor: String,
    labelWidth: String,
    labelAlign: String,
    labelMarginRight: String,
    gutter: [String, Number],
    footerTitle: String,
    footerTitleColor: String
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4e216ed4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/group/index.vue
var group_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.title)?_c('div',{staticClass:"weui-cells__title",style:(_vm.cleanStyle({
    color: _vm.titleColor
  })),domProps:{"innerHTML":_vm._s(_vm.title)}}):_vm._e(),_vm._v(" "),_vm._t("title"),_vm._v(" "),_c('div',{staticClass:"weui-cells",class:{
    'vux-no-group-title': !_vm.title
  },style:(_vm.cleanStyle({
    marginTop: typeof _vm.gutter === 'number' ? (_vm.gutter + 'px') : _vm.gutter
  }))},[_vm._t("after-title"),_vm._v(" "),_vm._t("default")],2),_vm._v(" "),(_vm.footerTitle)?_c('div',{staticClass:"weui-cells__title vux-group-footer-title",style:(_vm.cleanStyle({
    color: _vm.footerTitleColor
  })),domProps:{"innerHTML":_vm._s(_vm.footerTitle)}}):_vm._e()],2)}
var group_staticRenderFns = []
var group_esExports = { render: group_render, staticRenderFns: group_staticRenderFns }
/* harmony default export */ var src_components_group = (group_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/group/index.vue
function group_injectStyle (ssrContext) {
  __webpack_require__("tAeU")
}
var group_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var group___vue_template_functional__ = false
/* styles */
var group___vue_styles__ = group_injectStyle
/* scopeId */
var group___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var group___vue_module_identifier__ = null
var group_Component = group_normalizeComponent(
  components_group,
  src_components_group,
  group___vue_template_functional__,
  group___vue_styles__,
  group___vue_scopeId__,
  group___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_group = (group_Component.exports);

// EXTERNAL MODULE: ./node_modules/vux/src/components/cell/props.js
var props = __webpack_require__("2IIR");

// EXTERNAL MODULE: ./node_modules/vux/src/libs/get-parent-prop.js
var get_parent_prop = __webpack_require__("vLYD");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/cell/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ var cell = ({
  name: 'cell',
  components: {
    InlineDesc: vux_src_components_inline_desc
  },
  props: Object(props["a" /* default */])(),
  created: function created() {
    /* istanbul ignore if */
    if (false) {
      console.warn('[VUX] 抱歉，当前组件[cell]要求更新依赖 vux-loader@latest');
    }
  },
  beforeMount: function beforeMount() {
    this.hasTitleSlot = !!this.$slots.title;
    /* istanbul ignore if */
    if (this.$slots.value && "production" === 'development') {
      console.warn('[VUX] [cell] slot=value 已经废弃，请使用默认 slot 替代');
    }
  },

  computed: {
    labelStyles: function labelStyles() {
      return Object(clean_style["a" /* default */])({
        width: Object(get_parent_prop["a" /* default */])(this, 'labelWidth'),
        textAlign: Object(get_parent_prop["a" /* default */])(this, 'labelAlign'),
        marginRight: Object(get_parent_prop["a" /* default */])(this, 'labelMarginRight')
      });
    },
    valueClass: function valueClass() {
      return {
        'vux-cell-primary': this.primary === 'content' || this.valueAlign === 'left',
        'vux-cell-align-left': this.valueAlign === 'left',
        'vux-cell-arrow-transition': !!this.arrowDirection,
        'vux-cell-arrow-up': this.arrowDirection === 'up',
        'vux-cell-arrow-down': this.arrowDirection === 'down'
      };
    },
    labelClass: function labelClass() {
      return {
        'vux-cell-justify': this.$parent && (this.$parent.labelAlign === 'justify' || this.$parent.$parent.labelAlign === 'justify')
      };
    },
    style: function style() {
      if (this.alignItems) {
        return {
          alignItems: this.alignItems
        };
      }
    }
  },
  methods: {
    onClick: function onClick() {
      /* istanbul ignore next */
      !this.disabled && Object(libs_router["b" /* go */])(this.link, this.$router);
    }
  },
  data: function data() {
    return {
      hasTitleSlot: true,
      hasMounted: false
    };
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/cell/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ var components_cell = ({
  name: 'cell',
  components: {
    InlineDesc: vux_src_components_inline_desc
  },
  props: Object(props["a" /* default */])(),
  created: function created() {
    /* istanbul ignore if */
    if (false) {
      console.warn('[VUX] 抱歉，当前组件[cell]要求更新依赖 vux-loader@latest');
    }
  },
  beforeMount: function beforeMount() {
    this.hasTitleSlot = !!this.$slots.title;
    /* istanbul ignore if */
    if (this.$slots.value && "production" === 'development') {
      console.warn('[VUX] [cell] slot=value 已经废弃，请使用默认 slot 替代');
    }
  },

  computed: {
    labelStyles: function labelStyles() {
      return Object(clean_style["a" /* default */])({
        width: Object(get_parent_prop["a" /* default */])(this, 'labelWidth'),
        textAlign: Object(get_parent_prop["a" /* default */])(this, 'labelAlign'),
        marginRight: Object(get_parent_prop["a" /* default */])(this, 'labelMarginRight')
      });
    },
    valueClass: function valueClass() {
      return {
        'vux-cell-primary': this.primary === 'content' || this.valueAlign === 'left',
        'vux-cell-align-left': this.valueAlign === 'left',
        'vux-cell-arrow-transition': !!this.arrowDirection,
        'vux-cell-arrow-up': this.arrowDirection === 'up',
        'vux-cell-arrow-down': this.arrowDirection === 'down'
      };
    },
    labelClass: function labelClass() {
      return {
        'vux-cell-justify': this.$parent && (this.$parent.labelAlign === 'justify' || this.$parent.$parent.labelAlign === 'justify')
      };
    },
    style: function style() {
      if (this.alignItems) {
        return {
          alignItems: this.alignItems
        };
      }
    }
  },
  methods: {
    onClick: function onClick() {
      /* istanbul ignore next */
      !this.disabled && Object(libs_router["b" /* go */])(this.link, this.$router);
    }
  },
  data: function data() {
    return {
      hasTitleSlot: true,
      hasMounted: false
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-62e51266","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/cell/index.vue
var cell_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"weui-cell",class:{
    'vux-tap-active': _vm.isLink || !!_vm.link,
    'weui-cell_access': _vm.isLink || !!_vm.link,
    'vux-cell-no-border-intent': !_vm.borderIntent,
    'vux-cell-disabled': _vm.disabled
  },style:(_vm.style),on:{"click":_vm.onClick}},[_c('div',{staticClass:"weui-cell__hd"},[_vm._t("icon")],2),_vm._v(" "),_c('div',{staticClass:"vux-cell-bd",class:{'vux-cell-primary': _vm.primary === 'title' && _vm.valueAlign !== 'left'}},[_c('p',[(_vm.title || _vm.hasTitleSlot)?_c('label',{staticClass:"vux-label",class:_vm.labelClass,style:(_vm.labelStyles)},[_vm._t("title",[_vm._v(_vm._s(_vm.title))])],2):_vm._e(),_vm._v(" "),_vm._t("after-title")],2),_vm._v(" "),_c('inline-desc',[_vm._t("inline-desc",[_vm._v(_vm._s(_vm.inlineDesc))])],2)],1),_vm._v(" "),_c('div',{staticClass:"weui-cell__ft",class:_vm.valueClass},[_vm._t("value"),_vm._v(" "),_vm._t("default",[_vm._v(_vm._s(_vm.value))]),_vm._v(" "),(_vm.isLoading)?_c('i',{staticClass:"weui-loading"}):_vm._e()],2),_vm._v(" "),_vm._t("child")],2)}
var cell_staticRenderFns = []
var cell_esExports = { render: cell_render, staticRenderFns: cell_staticRenderFns }
/* harmony default export */ var src_components_cell = (cell_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/cell/index.vue
function cell_injectStyle (ssrContext) {
  __webpack_require__("IYR1")
}
var cell_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var cell___vue_template_functional__ = false
/* styles */
var cell___vue_styles__ = cell_injectStyle
/* scopeId */
var cell___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var cell___vue_module_identifier__ = null
var cell_Component = cell_normalizeComponent(
  components_cell,
  src_components_cell,
  cell___vue_template_functional__,
  cell___vue_styles__,
  cell___vue_scopeId__,
  cell___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_cell = (cell_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/cell-form-preview/index.vue
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var cell_form_preview = ({
  name: 'cell-form-preview',
  props: {
    list: Array,
    borderIntent: {
      type: Boolean,
      default: true
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/cell-form-preview/index.vue
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var components_cell_form_preview = ({
  name: 'cell-form-preview',
  props: {
    list: Array,
    borderIntent: {
      type: Boolean,
      default: true
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-91b5af26","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/cell-form-preview/index.vue
var cell_form_preview_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"weui-cell vux-cell-form-preview",class:{'vux-cell-no-border-intent': !_vm.borderIntent}},[_c('div',{staticClass:"weui-form-preview__bd"},_vm._l((_vm.list),function(item){return _c('div',{staticClass:"weui-form-preview__item"},[_c('label',{staticClass:"weui-form-preview__label",domProps:{"innerHTML":_vm._s(item.label)}}),_vm._v(" "),_c('span',{staticClass:"weui-form-preview__value",domProps:{"innerHTML":_vm._s(item.value)}})])}),0)])}
var cell_form_preview_staticRenderFns = []
var cell_form_preview_esExports = { render: cell_form_preview_render, staticRenderFns: cell_form_preview_staticRenderFns }
/* harmony default export */ var src_components_cell_form_preview = (cell_form_preview_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/cell-form-preview/index.vue
function cell_form_preview_injectStyle (ssrContext) {
  __webpack_require__("7BoG")
}
var cell_form_preview_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var cell_form_preview___vue_template_functional__ = false
/* styles */
var cell_form_preview___vue_styles__ = cell_form_preview_injectStyle
/* scopeId */
var cell_form_preview___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var cell_form_preview___vue_module_identifier__ = null
var cell_form_preview_Component = cell_form_preview_normalizeComponent(
  components_cell_form_preview,
  src_components_cell_form_preview,
  cell_form_preview___vue_template_functional__,
  cell_form_preview___vue_styles__,
  cell_form_preview___vue_scopeId__,
  cell_form_preview___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_cell_form_preview = (cell_form_preview_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/yingxin/tskjxy/views/record/record.vue

















/* harmony default export */ var record = ({
  name: 'record',
  props: [],
  components: {
    XHeader: vux_src_components_x_header,
    Swiper: vux_src_components_swiper_swiper,
    SwiperItem: src_components_swiper_swiper_item,
    XButton: vux_src_components_x_button,
    Tab: src_components_tab_tab,
    TabItem: src_components_tab_tab_item,
    Group: vux_src_components_group,
    Cell: vux_src_components_cell,
    CellFormPreview: vux_src_components_cell_form_preview,
    'scroller': vuescroll_default.a,
    Error: src_components_error
  },
  data: function data() {
    return {
      isError: false,
      ops: {
        scrollPanel: {
          scrollingX: false
        },
        bar: {
          background: 'rgba(0, 107, 178, 0.3)',
          size: '3px',
          opacity: 0
        }
      },
      index: sessionStorage.getItem('recordTypeIndex') ? Number(sessionStorage.getItem('recordTypeIndex')) : 0,
      recordList: [{
        name: '未办理',
        itemList: []
      }, {
        name: '办理中',
        itemList: []
      }, {
        name: '已办理',
        itemList: []
      }, {
        name: '全部',
        itemList: []
      }],
      dataList: [],
      errorMsg: {
        type: 'null',
        content: '无办理手续，请查看其他类型'
      },
      snoDes: '',
      currentDate: ''
    };
  },

  computed: extends_default()({
    title: function title() {
      return this.$route.meta.title;
    }
  }, Object(vuex_esm["c" /* mapState */])({
    token: function token(state) {
      return state.token;
    },
    studentId: function studentId(state) {
      return state.userInfo.id;
    },
    studentNo: function studentNo(state) {
      return state.userInfo.sno;
    },
    flowId: function flowId(state) {
      return state.flowInfo.flowId;
    }
  })),
  created: function created() {
    if (this.token && this.flowId) {

      this.getRecordList(this.index);
      this.getHelperDes();
    }
  },
  mounted: function mounted() {},
  updated: function updated() {},
  destroyed: function destroyed() {},

  watch: {},
  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])(['currentProcedureInfoAction']), {
    changeList: function changeList(index) {

      sessionStorage.setItem('recordTypeIndex', index);
      this.getRecordList(index);
    },
    handleScroll: function handleScroll(vertical, horizontal, nativeEvent) {
      var offsetTop = document.getElementById('tab-outer').offsetTop;
      if (vertical.scrollTop >= offsetTop) {
        this.isFixed = true;
      } else {
        this.isFixed = false;
      }
    },
    getRecordList: function getRecordList(index) {
      var _this = this;

      this.$vux.loading.show();
      var params = {
        studentId: this.studentId,
        flowId: this.flowId,
        'flowBean.isInFlow': 1
      };
      this.$api.get('/dataManagement/getDataManagementList', params, function (r) {
        var data = r.data;
        if (index === 0) {
          /* 未办理 */
          _this.dataList = data.filter(function (item) {
            if (item.status === -1 || item.status === 0 || item.status === 2 || item.status === 5) {
              return true;
            }
          });
        } else if (index === 1) {
          /* 办理中 */
          _this.dataList = data.filter(function (item) {
            if (item.status === 1 || item.status === 3) {
              return true;
            }
          });
        } else if (index === 2) {
          /* 已办理 */
          _this.dataList = data.filter(function (item) {
            if (item.status === 4) {
              return true;
            }
          });
        } else if (index === 3) {
          /* 全部 */
          _this.dataList = data;
        }
        if (_this.dataList.length === 0) {
          _this.isError = true;
        } else {
          _this.isError = false;
        }
        _this.$vux.loading.hide();
      }, function (err) {
        _this.$vux.toast.text(err.message, 'middle');
      });
    },
    toMap: function toMap(name, flowProcedureId, procedureId) {
      this.$router.push({
        name: 'mapPosition',
        params: {
          title: name,
          flowProcedureId: flowProcedureId,
          procedureId: procedureId
        }
      });
    },
    getCurrentDate: function getCurrentDate() {
      var _this2 = this;

      return new promise_default.a(function (resolve, reject) {
        _this2.$api.get('/helper/systemDateTime', null, function (r) {

          _this2.currentDate = r.data;
          resolve();
        }, function (err) {
          _this2.$vux.toast.text(err.message, 'middle');
        });
      });
    },
    getIsOverdue: function getIsOverdue(endDate, procedureBeanId, router, name) {
      if (DatetimeStamp(endDate + ' 23:59:59') < DatetimeStamp(this.currentDate)) {
        this.getManageState(endDate, procedureBeanId, router, name);
      } else {
        this.getPreposition(procedureBeanId, router, name);
      }
    },
    getPreposition: function getPreposition(procedureBeanId, router, name) {
      var _this3 = this;

      var params = {
        'procedureBean.id': procedureBeanId,
        'studentBean.id': this.studentId,
        'flowBean.id': this.flowId
      };
      this.$api.get('/dataManagement', params, function (r) {
        _this3.$vux.loading.hide();
        if (r.data.status === 4 || r.data.status === 1 || r.data.status === 3 || r.data.status === 6) {
          _this3.$router.push({ name: 'itemResult', params: { title: name, status: r.data.status } });
        } else {
          _this3.$router.push({ name: router, params: { title: name, status: r.data.status } });
        }
      }, function (err) {
        _this3.$vux.toast.text(err.message, 'middle');
      });
    },
    getManageState: function getManageState(endDate, procedureBeanId, router, name) {
      var _this4 = this;

      var params = {
        'studentId': this.studentId,
        'flowId': this.flowId,
        'procedureId': procedureBeanId
      };
      this.$api.get('/dataManagement/getDataManagementList', params, function (r) {
        _this4.$vux.loading.hide();
        if (r.data.length > 0) {
          if (r.data[0].status === 4 || r.data[0].status === 1 || r.data[0].status === 3 || r.data[0].status === 6) {
            _this4.$router.push({ name: 'itemResult', params: { title: name, status: r.data.status } });
          } else {
            _this4.$vux.toast.text('该手续已于' + endDate + '结束办理', 'middle');
          }
        }
      }, function (err) {
        _this4.$vux.toast.text(err.message, 'middle');
      });
    },
    currentProcedure: function currentProcedure(subItem, i) {
      var _this5 = this;

      var itemDate = subItem.flowProcedureBean.startDate;
      if (i === 0 || subItem.procedureBean.flag.split('')[1] === '1') {

        this.getCurrentDate().then(function () {
          if (DatetimeStamp(itemDate + ' 00:00:00') <= DatetimeStamp(_this5.currentDate)) {
            var currentProcedureInfo = {
              flowProcedureId: subItem.flowProcedureId,
              procedureId: subItem.procedureId,
              name: subItem.procedureBean.name,
              router: subItem.procedureBean.router,
              endDate: subItem.flowProcedureBean.endDate,
              parentRouter: 'record'
            };
            _this5.$store.dispatch('currentProcedureInfoAction', currentProcedureInfo);

            if (subItem.flowProcedureBean.flag.split('')[5] === '1' && subItem.procedureId !== 3) {
              window.location = subItem.flowProcedureBean.config;
            } else {
              if (subItem.procedureBean.router === 'pay' || subItem.procedureBean.router === 'info') {
                _this5.$router.push({
                  name: subItem.procedureBean.router,
                  query: {
                    flowProcedureId: subItem.flowProcedureId,
                    procedureId: subItem.procedureId
                  }
                });
              } else {
                _this5.getIsOverdue(subItem.flowProcedureBean.endDate, subItem.procedureId, subItem.procedureBean.router, subItem.procedureBean.name);
              }
            }
          } else {
            _this5.$vux.alert.show({
              title: subItem.procedureBean.name + '未到办理时间',
              content: '请于' + itemDate + '办理',
              buttonText: '我知道了'
            });
          }
        });
      }
    },
    getHelperDes: function getHelperDes() {
      var _this6 = this;

      var params = {
        info: this.studentNo
      };
      this.$api.get('/helper/des', params, function (r) {
        _this6.snoDes = encodeURIComponent(r.data);
      }, function (err) {
        console.log('获取HelperDes失败', err);
      });
    }
  })
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/yingxin/tskjxy/views/record/record.vue

















/* harmony default export */ var record_record = ({
  name: 'record',
  props: [],
  components: {
    XHeader: vux_src_components_x_header,
    Swiper: vux_src_components_swiper_swiper,
    SwiperItem: src_components_swiper_swiper_item,
    XButton: vux_src_components_x_button,
    Tab: src_components_tab_tab,
    TabItem: src_components_tab_tab_item,
    Group: vux_src_components_group,
    Cell: vux_src_components_cell,
    CellFormPreview: vux_src_components_cell_form_preview,
    'scroller': vuescroll_default.a,
    Error: src_components_error
  },
  data: function data() {
    return {
      isError: false,
      ops: {
        scrollPanel: {
          scrollingX: false
        },
        bar: {
          background: 'rgba(0, 107, 178, 0.3)',
          size: '3px',
          opacity: 0
        }
      },
      index: sessionStorage.getItem('recordTypeIndex') ? Number(sessionStorage.getItem('recordTypeIndex')) : 0,
      recordList: [{
        name: '未办理',
        itemList: []
      }, {
        name: '办理中',
        itemList: []
      }, {
        name: '已办理',
        itemList: []
      }, {
        name: '全部',
        itemList: []
      }],
      dataList: [],
      errorMsg: {
        type: 'null',
        content: '无办理手续，请查看其他类型'
      },
      snoDes: '',
      currentDate: ''
    };
  },

  computed: extends_default()({
    title: function title() {
      return this.$route.meta.title;
    }
  }, Object(vuex_esm["c" /* mapState */])({
    token: function token(state) {
      return state.token;
    },
    studentId: function studentId(state) {
      return state.userInfo.id;
    },
    studentNo: function studentNo(state) {
      return state.userInfo.sno;
    },
    flowId: function flowId(state) {
      return state.flowInfo.flowId;
    }
  })),
  created: function created() {
    if (this.token && this.flowId) {

      this.getRecordList(this.index);
      this.getHelperDes();
    }
  },
  mounted: function mounted() {},
  updated: function updated() {},
  destroyed: function destroyed() {},

  watch: {},
  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])(['currentProcedureInfoAction']), {
    changeList: function changeList(index) {

      sessionStorage.setItem('recordTypeIndex', index);
      this.getRecordList(index);
    },
    handleScroll: function handleScroll(vertical, horizontal, nativeEvent) {
      var offsetTop = document.getElementById('tab-outer').offsetTop;
      if (vertical.scrollTop >= offsetTop) {
        this.isFixed = true;
      } else {
        this.isFixed = false;
      }
    },
    getRecordList: function getRecordList(index) {
      var _this = this;

      this.$vux.loading.show();
      var params = {
        studentId: this.studentId,
        flowId: this.flowId,
        'flowBean.isInFlow': 1
      };
      this.$api.get('/dataManagement/getDataManagementList', params, function (r) {
        var data = r.data;
        if (index === 0) {
          /* 未办理 */
          _this.dataList = data.filter(function (item) {
            if (item.status === -1 || item.status === 0 || item.status === 2 || item.status === 5) {
              return true;
            }
          });
        } else if (index === 1) {
          /* 办理中 */
          _this.dataList = data.filter(function (item) {
            if (item.status === 1 || item.status === 3) {
              return true;
            }
          });
        } else if (index === 2) {
          /* 已办理 */
          _this.dataList = data.filter(function (item) {
            if (item.status === 4) {
              return true;
            }
          });
        } else if (index === 3) {
          /* 全部 */
          _this.dataList = data;
        }
        if (_this.dataList.length === 0) {
          _this.isError = true;
        } else {
          _this.isError = false;
        }
        _this.$vux.loading.hide();
      }, function (err) {
        _this.$vux.toast.text(err.message, 'middle');
      });
    },
    toMap: function toMap(name, flowProcedureId, procedureId) {
      this.$router.push({
        name: 'mapPosition',
        params: {
          title: name,
          flowProcedureId: flowProcedureId,
          procedureId: procedureId
        }
      });
    },
    getCurrentDate: function getCurrentDate() {
      var _this2 = this;

      return new promise_default.a(function (resolve, reject) {
        _this2.$api.get('/helper/systemDateTime', null, function (r) {

          _this2.currentDate = r.data;
          resolve();
        }, function (err) {
          _this2.$vux.toast.text(err.message, 'middle');
        });
      });
    },
    getIsOverdue: function getIsOverdue(endDate, procedureBeanId, router, name) {
      if (DatetimeStamp(endDate + ' 23:59:59') < DatetimeStamp(this.currentDate)) {
        this.getManageState(endDate, procedureBeanId, router, name);
      } else {
        this.getPreposition(procedureBeanId, router, name);
      }
    },
    getPreposition: function getPreposition(procedureBeanId, router, name) {
      var _this3 = this;

      var params = {
        'procedureBean.id': procedureBeanId,
        'studentBean.id': this.studentId,
        'flowBean.id': this.flowId
      };
      this.$api.get('/dataManagement', params, function (r) {
        _this3.$vux.loading.hide();
        if (r.data.status === 4 || r.data.status === 1 || r.data.status === 3 || r.data.status === 6) {
          _this3.$router.push({ name: 'itemResult', params: { title: name, status: r.data.status } });
        } else {
          _this3.$router.push({ name: router, params: { title: name, status: r.data.status } });
        }
      }, function (err) {
        _this3.$vux.toast.text(err.message, 'middle');
      });
    },
    getManageState: function getManageState(endDate, procedureBeanId, router, name) {
      var _this4 = this;

      var params = {
        'studentId': this.studentId,
        'flowId': this.flowId,
        'procedureId': procedureBeanId
      };
      this.$api.get('/dataManagement/getDataManagementList', params, function (r) {
        _this4.$vux.loading.hide();
        if (r.data.length > 0) {
          if (r.data[0].status === 4 || r.data[0].status === 1 || r.data[0].status === 3 || r.data[0].status === 6) {
            _this4.$router.push({ name: 'itemResult', params: { title: name, status: r.data.status } });
          } else {
            _this4.$vux.toast.text('该手续已于' + endDate + '结束办理', 'middle');
          }
        }
      }, function (err) {
        _this4.$vux.toast.text(err.message, 'middle');
      });
    },
    currentProcedure: function currentProcedure(subItem, i) {
      var _this5 = this;

      var itemDate = subItem.flowProcedureBean.startDate;
      if (i === 0 || subItem.procedureBean.flag.split('')[1] === '1') {

        this.getCurrentDate().then(function () {
          if (DatetimeStamp(itemDate + ' 00:00:00') <= DatetimeStamp(_this5.currentDate)) {
            var currentProcedureInfo = {
              flowProcedureId: subItem.flowProcedureId,
              procedureId: subItem.procedureId,
              name: subItem.procedureBean.name,
              router: subItem.procedureBean.router,
              endDate: subItem.flowProcedureBean.endDate,
              parentRouter: 'record'
            };
            _this5.$store.dispatch('currentProcedureInfoAction', currentProcedureInfo);

            if (subItem.flowProcedureBean.flag.split('')[5] === '1' && subItem.procedureId !== 3) {
              window.location = subItem.flowProcedureBean.config;
            } else {
              if (subItem.procedureBean.router === 'pay' || subItem.procedureBean.router === 'info') {
                _this5.$router.push({
                  name: subItem.procedureBean.router,
                  query: {
                    flowProcedureId: subItem.flowProcedureId,
                    procedureId: subItem.procedureId
                  }
                });
              } else {
                _this5.getIsOverdue(subItem.flowProcedureBean.endDate, subItem.procedureId, subItem.procedureBean.router, subItem.procedureBean.name);
              }
            }
          } else {
            _this5.$vux.alert.show({
              title: subItem.procedureBean.name + '未到办理时间',
              content: '请于' + itemDate + '办理',
              buttonText: '我知道了'
            });
          }
        });
      }
    },
    getHelperDes: function getHelperDes() {
      var _this6 = this;

      var params = {
        info: this.studentNo
      };
      this.$api.get('/helper/des', params, function (r) {
        _this6.snoDes = encodeURIComponent(r.data);
      }, function (err) {
        console.log('获取HelperDes失败', err);
      });
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2d2e02e2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/yingxin/tskjxy/views/record/record.vue
var record_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('x-header',{staticClass:"header bg-white",attrs:{"left-options":{showBack: false}}},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"scroller-wrapper-bottom"},[_c('scroller',{attrs:{"ops":_vm.ops},on:{"handle-scroll":_vm.handleScroll}},[_c('section',{staticClass:"section record-list"},[_c('div',{staticClass:"tab-box"},[_c('div',{staticClass:"tab-outer",attrs:{"id":"tab-outer"}},[_c('tab',{staticClass:"bg-white",attrs:{"line-width":2,"active-color":"#FEAA33","scroll-threshold":_vm.recordList.length},model:{value:(_vm.index),callback:function ($$v) {_vm.index=$$v},expression:"index"}},_vm._l((_vm.recordList),function(item,i){return _c('tab-item',{key:i,staticClass:"vux-center",on:{"on-item-click":function($event){return _vm.changeList(i)}}},[_vm._v(_vm._s(item.name))])}),1)],1)]),_c('div',{staticClass:"scroller-wrapper",staticStyle:{"top":"44px","bottom":"0"}},[_c('scroller',{attrs:{"ops":_vm.ops},on:{"handle-scroll":_vm.handleScroll}},[_c('div',{staticClass:"dataList"},[(_vm.isError)?[_c('br'),_c('error',{attrs:{"errorMsg":_vm.errorMsg}})]:_c('group',_vm._l((_vm.dataList),function(item,j){return (item.procedureBean.flag)?_c('cell',{key:j,staticStyle:{"font-size":"1.025rem"},attrs:{"title":item.procedureBean.name,"is-link":item.procedureBean.flag.split('')[1] == '1'},nativeOn:{"click":function($event){return _vm.currentProcedure(item, _vm.index)}}},[_c('em',{staticClass:"icon icon-item-o",class:("icon-" + (item.procedureBean.icon) + "-o"),attrs:{"slot":"icon","width":"0"},slot:"icon"}),(_vm.index == 0)?[(item.procedureBean.flag!=null && item.procedureBean.flag.split('')[1] != '1')?_c('div',{staticClass:"attach text-brand",on:{"click":function($event){$event.stopPropagation();return _vm.toMap(item.procedureBean.name, item.flowProcedureId, item.procedureBean.id)}}},[_c('em',{staticClass:"icon icon-position"})]):_vm._e()]:_vm._e(),(_vm.index == 3)?[_c('div',{staticClass:"attach",class:{paddingRight0: item.procedureBean.flag.split('')[1] == '1'}},[(item.status == -1)?_c('span',{staticClass:"remark text-gary-light"},[_vm._v("未办理")]):_vm._e(),(item.status == 0)?_c('span',{staticClass:"remark text-gary-light"},[_vm._v("不通过")]):_vm._e(),(item.status == 1)?_c('span',{staticClass:"remark text-warning"},[_vm._v("申请中")]):_vm._e(),(item.status == 2)?_c('span',{staticClass:"remark text-gary-light"},[_vm._v("撤销申请")]):_vm._e(),(item.status == 3)?_c('span',{staticClass:"remark text-danger"},[_vm._v("审核不通过")]):_vm._e(),(item.status == 4)?_c('span',{staticClass:"remark text-success"},[_vm._v("已办理")]):_vm._e(),(item.status == 5)?_c('span',{staticClass:"remark text-gary-light"},[_vm._v("办理撤销")]):_vm._e()])]:_vm._e()],2):_vm._e()}),1)],2)])],1)])])],1),_c('transition',{attrs:{"name":"slide","enter-active-class":"animated fastest slideInRight","leave-active-class":"animated fastest slideOutRight"}},[_c('router-view')],1)],1)}
var record_staticRenderFns = []
var record_esExports = { render: record_render, staticRenderFns: record_staticRenderFns }
/* harmony default export */ var views_record_record = (record_esExports);
// CONCATENATED MODULE: ./src/yingxin/tskjxy/views/record/record.vue
var record_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var record___vue_template_functional__ = false
/* styles */
var record___vue_styles__ = null
/* scopeId */
var record___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var record___vue_module_identifier__ = null
var record_Component = record_normalizeComponent(
  record_record,
  views_record_record,
  record___vue_template_functional__,
  record___vue_styles__,
  record___vue_scopeId__,
  record___vue_module_identifier__
)

/* harmony default export */ var tskjxy_views_record_record = (record_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/yingxin/tskjxy/views/user/user.vue








/* harmony default export */ var user = ({
  name: 'user',
  props: [],
  components: {
    XHeader: vux_src_components_x_header,
    XButton: vux_src_components_x_button,
    Group: vux_src_components_group,
    Cell: vux_src_components_cell
  },
  data: function data() {
    return {
      scrollTag: false,
      userPicture: __webpack_require__("Uirz"),
      defaultPicture: 'this.src="' + __webpack_require__("Uirz") + '"',
      wx: navigator.userAgent.toLowerCase().indexOf('micromessenger') !== -1
    };
  },

  computed: extends_default()({
    title: function title() {
      return this.$route.meta.title;
    }
  }, Object(vuex_esm["c" /* mapState */])({
    token: function token(state) {
      return state.token;
    },
    flowType: function flowType(state) {
      return state.flowInfo.flowType;
    },
    userInfo: function userInfo(state) {
      return state.userInfo;
    }
  })),
  created: function created() {},
  mounted: function mounted() {
    if (this.token && this.userInfo.studentPictureUrl !== null) {
      this.userPicture = this.userInfo.studentPictureUrl;
    }
    this.scrollPageHeader();
  },

  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])(['LogoutAction']), {
    back: function back() {
      var _this2 = this;

      setTimeout(function () {
        _this2.$router.back(-1);
      }, 300);
    },
    login: function login() {
      if (!this.token) {
        this.$router.push({
          name: 'login'
        });
      }
    },
    logout: function logout() {
      var _this3 = this;

      this.$api.post('/logout', null, function (r) {
        _this3.$store.dispatch('LogoutAction');
      }, function (err) {
        _this3.$vux.toast.text(err.message, 'top');
      });
    },
    scrollPageHeader: function scrollPageHeader() {
      var _this = this;
      window.addEventListener('scroll', function () {
        var top = document.documentElement.scrollTop || document.body.scrollTop || window.pageYOffset;
        if (top < 35) {
          _this.scrollTag = false;
        } else {
          _this.scrollTag = true;
        }
      });
    }
  })
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/yingxin/tskjxy/views/user/user.vue








/* harmony default export */ var user_user = ({
  name: 'user',
  props: [],
  components: {
    XHeader: vux_src_components_x_header,
    XButton: vux_src_components_x_button,
    Group: vux_src_components_group,
    Cell: vux_src_components_cell
  },
  data: function data() {
    return {
      scrollTag: false,
      userPicture: __webpack_require__("Uirz"),
      defaultPicture: 'this.src="' + __webpack_require__("Uirz") + '"',
      wx: navigator.userAgent.toLowerCase().indexOf('micromessenger') !== -1
    };
  },

  computed: extends_default()({
    title: function title() {
      return this.$route.meta.title;
    }
  }, Object(vuex_esm["c" /* mapState */])({
    token: function token(state) {
      return state.token;
    },
    flowType: function flowType(state) {
      return state.flowInfo.flowType;
    },
    userInfo: function userInfo(state) {
      return state.userInfo;
    }
  })),
  created: function created() {},
  mounted: function mounted() {
    if (this.token && this.userInfo.studentPictureUrl !== null) {
      this.userPicture = this.userInfo.studentPictureUrl;
    }
    this.scrollPageHeader();
  },

  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])(['LogoutAction']), {
    back: function back() {
      var _this2 = this;

      setTimeout(function () {
        _this2.$router.back(-1);
      }, 300);
    },
    login: function login() {
      if (!this.token) {
        this.$router.push({
          name: 'login'
        });
      }
    },
    logout: function logout() {
      var _this3 = this;

      this.$api.post('/logout', null, function (r) {
        _this3.$store.dispatch('LogoutAction');
      }, function (err) {
        _this3.$vux.toast.text(err.message, 'top');
      });
    },
    scrollPageHeader: function scrollPageHeader() {
      var _this = this;
      window.addEventListener('scroll', function () {
        var top = document.documentElement.scrollTop || document.body.scrollTop || window.pageYOffset;
        if (top < 35) {
          _this.scrollTag = false;
        } else {
          _this.scrollTag = true;
        }
      });
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4e5caa44","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/yingxin/tskjxy/views/user/user.vue
var user_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"viewBox",staticClass:"tabbar-bottom",nativeOn:{"scroll":function($event){return _vm.scrollHandler($event)}}},[_c('x-header',{staticClass:"header bg-transparent",class:_vm.scrollTag ? 'bg-white' : '',attrs:{"left-options":{showBack: false}}},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"banner user-center"},[_c('img',{attrs:{"src":__webpack_require__("Pet3")}}),_c('div',{staticClass:"userinfo",on:{"click":_vm.login}},[_c('img',{staticClass:"user-img",attrs:{"src":_vm.userPicture,"onerror":_vm.defaultPicture}}),_c('p',{staticClass:"user-name"},[_vm._v(_vm._s(_vm.token ? _vm.userInfo.name : '请登录'))])])]),_c('div',{staticClass:"user-item"},[_c('group',[_c('cell',{attrs:{"title":"个人信息","link":{name: 'userInfo'}}},[_c('i',{staticClass:"icon icon-invoice",attrs:{"slot":"icon"},slot:"icon"})]),(_vm.flowType == 3)?_c('cell',{attrs:{"title":"余额捐赠","link":{name: 'donate', params:{title: '余额捐赠'}}}},[_c('i',{staticClass:"icon icon-pay-o",attrs:{"slot":"icon"},slot:"icon"})]):_vm._e()],1)],1),(_vm.wx)?_c('div',{staticClass:"container"},[(!_vm.token)?_c('x-button',{attrs:{"gradients":['#1D62F0', '#19D5FD']},nativeOn:{"click":function($event){return _vm.login($event)}}},[_vm._v(" 登录账号")]):_c('x-button',{attrs:{"gradients":['#FF5E3A', '#FF9500']},nativeOn:{"click":function($event){return _vm.logout($event)}}},[_vm._v(" 退出登录")])],1):_vm._e(),_c('transition',{attrs:{"name":"slide","enter-active-class":"animated fastest slideInRight","leave-active-class":"animated fastest slideOutRight"}},[_c('router-view')],1)],1)}
var user_staticRenderFns = []
var user_esExports = { render: user_render, staticRenderFns: user_staticRenderFns }
/* harmony default export */ var views_user_user = (user_esExports);
// CONCATENATED MODULE: ./src/yingxin/tskjxy/views/user/user.vue
var user_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var user___vue_template_functional__ = false
/* styles */
var user___vue_styles__ = null
/* scopeId */
var user___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var user___vue_module_identifier__ = null
var user_Component = user_normalizeComponent(
  user_user,
  views_user_user,
  user___vue_template_functional__,
  user___vue_styles__,
  user___vue_scopeId__,
  user___vue_module_identifier__
)

/* harmony default export */ var tskjxy_views_user_user = (user_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/yingxin/tskjxy/views/items/info.vue










/* harmony default export */ var info = ({
  name: 'info',
  props: [],
  components: {
    XHeader: vux_src_components_x_header,
    Group: vux_src_components_group,
    Cell: vux_src_components_cell,
    XButton: vux_src_components_x_button,
    'scroller': vuescroll_default.a
  },
  data: function data() {
    return {
      ops: {
        scrollPanel: {
          scrollingX: false
        },
        bar: {
          background: 'rgba(0, 107, 178, 0.3)',
          size: '3px',
          opacity: 0
        }
      },
      userPicture: __webpack_require__("rPBl"),
      defaultPicture: 'this.src="' + __webpack_require__("rPBl") + '"',
      extendInfo: [],
      personalInfo: [],
      familyInfo: [],
      isAdd: true,
      country: [],
      nation: [],
      politicsStatus: [],
      identity: [],
      userInfo: this.$store.state.userInfo,
      isShow: true,
      toDay: today('YYYY-MM-DD')
    };
  },

  computed: extends_default()({}, Object(vuex_esm["c" /* mapState */])({
    title: function title(state) {
      return state.currentProcedureInfo.name;
    },
    flowId: function flowId(state) {
      return state.flowInfo.flowId;
    },
    currentProcedureInfo: function currentProcedureInfo(state) {
      return state.currentProcedureInfo;
    },
    procedureId: function procedureId(state) {
      return state.currentProcedureInfo.procedureId;
    },
    parentRouter: function parentRouter(state) {
      return state.currentProcedureInfo.parentRouter;
    }
  })),
  created: function created() {
    this.getFlowProcedureStatus();
    this.getStudent();
    this.getExtendInfo();
    this.getFamilyInfo();
  },
  mounted: function mounted() {
    if (this.token && this.userInfo.studentPictureUrl !== null) {
      this.userPicture = this.userInfo.studentPictureUrl;
    }
    if (this.currentProcedureInfo.endDate < this.toDay) {
      this.isShow = false;
    } else {
      this.isShow = true;
    }
  },
  updated: function updated() {},
  destroyed: function destroyed() {},

  watch: {},
  methods: {
    back: function back() {
      var _this = this;

      setTimeout(function () {

        _this.$router.push({
          name: _this.parentRouter
        });
      }, 300);
    },
    finish: function finish() {
      var _this2 = this;

      setTimeout(function () {
        _this2.$router.push({
          name: _this2.parentRouter
        });
      }, 300);
    },
    getFlowProcedureStatus: function getFlowProcedureStatus() {
      var _this3 = this;

      var params = {
        'procedureBean.id': this.procedureId,
        'studentBean.id': this.$store.state.userInfo.id,
        'flowBean.id': this.flowId
      };
      this.$api.get('/dataManagement', params, function (r) {
        var data = r.data;
        if (data.status === 4) {
          _this3.isAdd = false;
        } else {
          _this3.isAdd = true;
        }
      }, function (err) {
        _this3.$vux.toast.text(err.message, 'top');
      });
    },
    getStudent: function getStudent() {
      var _this4 = this;

      var params = {
        account: this.$store.state.userInfo.account
      };
      this.$api.get('/student', params, function (r) {
        var data = r.data[0];
        _this4.userInfo = data;
        _this4.getInfoList();
        _this4.$store.dispatch('userInfoAction', data);
      });
    },
    getExtendInfo: function getExtendInfo() {
      var _this5 = this;

      var params = {
        tableName: 'V_USER_STUDENT',
        resourceId: this.userInfo.id
      };
      this.$api.get('/extendInfo', params, function (r) {
        _this5.extendInfo = r.data;
      });
    },
    getInfoList: function getInfoList() {
      var _this6 = this;

      this.$vux.loading.show();
      var params = {
        flowId: this.flowId,
        flowProcedureId: this.currentProcedureInfo.flowProcedureId,
        procedureId: this.procedureId
      };
      this.$api.get('/studentInfo/config', params, function (r) {
        _this6.$vux.loading.hide();
        var data = r.data;
        var baseInfo = [];
        var extendInfo = [];

        data.baseFeildList.forEach(function (element) {
          if (element === 'academyCode') {
            element = 'academyName';
          } else if (element === 'departmentCode') {
            element = 'departmentName';
          } else if (element === 'professionCode') {
            element = 'professionName';
          } else if (element === 'classCode') {
            element = 'className';
          } else if (element === 'campusCode') {
            element = 'campusName';
          }
          var obj = {
            name: element,
            comments: _this6.switchName(element),
            value: _this6.userInfo[element]
          };
          if (element === 'countryCode') {
            _this6.$set(obj, 'value', _this6.userInfo.standardCountryBean.name);
          } else if (element === 'nationCode') {
            _this6.$set(obj, 'value', _this6.userInfo.standardNationBean.name);
          } else if (element === 'politicsStatusCode') {
            _this6.$set(obj, 'value', _this6.userInfo.standardPoliticsStatusBean ? _this6.userInfo.standardPoliticsStatusBean.name : null);
          } else if (element === 'identityCode') {
            _this6.$set(obj, 'value', _this6.userInfo.baseIdentityBean.name);
          }
          if (element === 'sex') {
            if (obj.value === 2) {
              _this6.$set(obj, 'value', '女');
            } else if (obj.value === 1) {
              _this6.$set(obj, 'value', '男');
            }
          }
          baseInfo.push(obj);
        });

        data.extendFeildList.forEach(function (element) {
          var obj = {};
          for (var i = 0; i < _this6.extendInfo.length; i++) {
            if (element === _this6.extendInfo[i].tableField) {
              obj = {
                name: element,
                comments: _this6.extendInfo[i].extendFieldBean.name,
                value: _this6.extendInfo[i].value
              };
            }
          }
          extendInfo.push(obj);
        });
        _this6.personalInfo = baseInfo.concat(extendInfo);
      }, function (err) {
        _this6.$vux.toast.text(err.message, 'top');
      });
    },
    switchName: function switchName(name) {
      switch (name) {
        case 'name':
          return '姓名';
        case 'account':
          return '账号';
        case 'sno':
          return '学号';
        case 'idNumber':
          return '身份证号';
        case 'cardId':
          return '一卡通号';
        case 'cardAccount':
          return '卡账号';
        case 'examNumber':
          return '准考证号';
        case 'sex':
          return '性别';
        case 'birthdate':
          return '出生日期';
        case 'countryCode':
          return '国籍';
        case 'nationCode':
          return '民族';
        case 'politicsStatusCode':
          return '政治面貌';
        case 'identityCode':
          return '身份类型';
        case 'campusName':
          return '校区';
        case 'grade':
          return '年级';
        case 'academyName':
          return '书院';
        case 'departmentName':
          return '学院';
        case 'professionName':
          return '专业';
        case 'className':
          return '班级';
        case 'phoneNumber':
          return '联系电话';
        case 'email':
          return '邮箱';
        case 'qq':
          return 'QQ';
        case 'wechat':
          return '微信';
        case 'origin':
          return '生源地';
      }
    },
    getFamilyInfo: function getFamilyInfo() {
      var _this7 = this;

      this.$vux.loading.show();
      var params = {
        studentId: this.userInfo.id
      };
      this.$api.get('/family', params, function (r) {
        _this7.$vux.loading.hide();
        var data = r.data;
        _this7.familyInfo = data;
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/yingxin/tskjxy/views/items/info.vue










/* harmony default export */ var items_info = ({
  name: 'info',
  props: [],
  components: {
    XHeader: vux_src_components_x_header,
    Group: vux_src_components_group,
    Cell: vux_src_components_cell,
    XButton: vux_src_components_x_button,
    'scroller': vuescroll_default.a
  },
  data: function data() {
    return {
      ops: {
        scrollPanel: {
          scrollingX: false
        },
        bar: {
          background: 'rgba(0, 107, 178, 0.3)',
          size: '3px',
          opacity: 0
        }
      },
      userPicture: __webpack_require__("rPBl"),
      defaultPicture: 'this.src="' + __webpack_require__("rPBl") + '"',
      extendInfo: [],
      personalInfo: [],
      familyInfo: [],
      isAdd: true,
      country: [],
      nation: [],
      politicsStatus: [],
      identity: [],
      userInfo: this.$store.state.userInfo,
      isShow: true,
      toDay: today('YYYY-MM-DD')
    };
  },

  computed: extends_default()({}, Object(vuex_esm["c" /* mapState */])({
    title: function title(state) {
      return state.currentProcedureInfo.name;
    },
    flowId: function flowId(state) {
      return state.flowInfo.flowId;
    },
    currentProcedureInfo: function currentProcedureInfo(state) {
      return state.currentProcedureInfo;
    },
    procedureId: function procedureId(state) {
      return state.currentProcedureInfo.procedureId;
    },
    parentRouter: function parentRouter(state) {
      return state.currentProcedureInfo.parentRouter;
    }
  })),
  created: function created() {
    this.getFlowProcedureStatus();
    this.getStudent();
    this.getExtendInfo();
    this.getFamilyInfo();
  },
  mounted: function mounted() {
    if (this.token && this.userInfo.studentPictureUrl !== null) {
      this.userPicture = this.userInfo.studentPictureUrl;
    }
    if (this.currentProcedureInfo.endDate < this.toDay) {
      this.isShow = false;
    } else {
      this.isShow = true;
    }
  },
  updated: function updated() {},
  destroyed: function destroyed() {},

  watch: {},
  methods: {
    back: function back() {
      var _this = this;

      setTimeout(function () {

        _this.$router.push({
          name: _this.parentRouter
        });
      }, 300);
    },
    finish: function finish() {
      var _this2 = this;

      setTimeout(function () {
        _this2.$router.push({
          name: _this2.parentRouter
        });
      }, 300);
    },
    getFlowProcedureStatus: function getFlowProcedureStatus() {
      var _this3 = this;

      var params = {
        'procedureBean.id': this.procedureId,
        'studentBean.id': this.$store.state.userInfo.id,
        'flowBean.id': this.flowId
      };
      this.$api.get('/dataManagement', params, function (r) {
        var data = r.data;
        if (data.status === 4) {
          _this3.isAdd = false;
        } else {
          _this3.isAdd = true;
        }
      }, function (err) {
        _this3.$vux.toast.text(err.message, 'top');
      });
    },
    getStudent: function getStudent() {
      var _this4 = this;

      var params = {
        account: this.$store.state.userInfo.account
      };
      this.$api.get('/student', params, function (r) {
        var data = r.data[0];
        _this4.userInfo = data;
        _this4.getInfoList();
        _this4.$store.dispatch('userInfoAction', data);
      });
    },
    getExtendInfo: function getExtendInfo() {
      var _this5 = this;

      var params = {
        tableName: 'V_USER_STUDENT',
        resourceId: this.userInfo.id
      };
      this.$api.get('/extendInfo', params, function (r) {
        _this5.extendInfo = r.data;
      });
    },
    getInfoList: function getInfoList() {
      var _this6 = this;

      this.$vux.loading.show();
      var params = {
        flowId: this.flowId,
        flowProcedureId: this.currentProcedureInfo.flowProcedureId,
        procedureId: this.procedureId
      };
      this.$api.get('/studentInfo/config', params, function (r) {
        _this6.$vux.loading.hide();
        var data = r.data;
        var baseInfo = [];
        var extendInfo = [];

        data.baseFeildList.forEach(function (element) {
          if (element === 'academyCode') {
            element = 'academyName';
          } else if (element === 'departmentCode') {
            element = 'departmentName';
          } else if (element === 'professionCode') {
            element = 'professionName';
          } else if (element === 'classCode') {
            element = 'className';
          } else if (element === 'campusCode') {
            element = 'campusName';
          }
          var obj = {
            name: element,
            comments: _this6.switchName(element),
            value: _this6.userInfo[element]
          };
          if (element === 'countryCode') {
            _this6.$set(obj, 'value', _this6.userInfo.standardCountryBean.name);
          } else if (element === 'nationCode') {
            _this6.$set(obj, 'value', _this6.userInfo.standardNationBean.name);
          } else if (element === 'politicsStatusCode') {
            _this6.$set(obj, 'value', _this6.userInfo.standardPoliticsStatusBean ? _this6.userInfo.standardPoliticsStatusBean.name : null);
          } else if (element === 'identityCode') {
            _this6.$set(obj, 'value', _this6.userInfo.baseIdentityBean.name);
          }
          if (element === 'sex') {
            if (obj.value === 2) {
              _this6.$set(obj, 'value', '女');
            } else if (obj.value === 1) {
              _this6.$set(obj, 'value', '男');
            }
          }
          baseInfo.push(obj);
        });

        data.extendFeildList.forEach(function (element) {
          var obj = {};
          for (var i = 0; i < _this6.extendInfo.length; i++) {
            if (element === _this6.extendInfo[i].tableField) {
              obj = {
                name: element,
                comments: _this6.extendInfo[i].extendFieldBean.name,
                value: _this6.extendInfo[i].value
              };
            }
          }
          extendInfo.push(obj);
        });
        _this6.personalInfo = baseInfo.concat(extendInfo);
      }, function (err) {
        _this6.$vux.toast.text(err.message, 'top');
      });
    },
    switchName: function switchName(name) {
      switch (name) {
        case 'name':
          return '姓名';
        case 'account':
          return '账号';
        case 'sno':
          return '学号';
        case 'idNumber':
          return '身份证号';
        case 'cardId':
          return '一卡通号';
        case 'cardAccount':
          return '卡账号';
        case 'examNumber':
          return '准考证号';
        case 'sex':
          return '性别';
        case 'birthdate':
          return '出生日期';
        case 'countryCode':
          return '国籍';
        case 'nationCode':
          return '民族';
        case 'politicsStatusCode':
          return '政治面貌';
        case 'identityCode':
          return '身份类型';
        case 'campusName':
          return '校区';
        case 'grade':
          return '年级';
        case 'academyName':
          return '书院';
        case 'departmentName':
          return '学院';
        case 'professionName':
          return '专业';
        case 'className':
          return '班级';
        case 'phoneNumber':
          return '联系电话';
        case 'email':
          return '邮箱';
        case 'qq':
          return 'QQ';
        case 'wechat':
          return '微信';
        case 'origin':
          return '生源地';
      }
    },
    getFamilyInfo: function getFamilyInfo() {
      var _this7 = this;

      this.$vux.loading.show();
      var params = {
        studentId: this.userInfo.id
      };
      this.$api.get('/family', params, function (r) {
        _this7.$vux.loading.hide();
        var data = r.data;
        _this7.familyInfo = data;
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ac9ac0d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/yingxin/tskjxy/views/items/info.vue
var info_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('x-header',{staticClass:"header bg-white box-shadow"},[_c('em',{staticClass:"icon icon-arrow-left",attrs:{"slot":"overwrite-left","size":""},on:{"click":_vm.back},slot:"overwrite-left"}),_vm._v(_vm._s(_vm.title)),_c('span',{staticClass:"text-brand",attrs:{"slot":"right","size":""},on:{"click":_vm.finish},slot:"right"},[_vm._v("完成")])]),_c('div',{staticClass:"scroller-wrapper bg-white"},[_c('scroller',{attrs:{"ops":_vm.ops}},[_c('div',{staticClass:"container bg-body",staticStyle:{"padding-top":"0.5rem"}},[_c('ul',{staticClass:"info-content flex"},[_c('li',{staticClass:"avatar"},[_c('img',{staticClass:"user-img",attrs:{"src":_vm.userPicture,"onerror":_vm.defaultPicture}})]),_c('li',{staticClass:"information flex-1"},[_c('p',[_vm._v(_vm._s(_vm.userInfo.professionName)+_vm._s(_vm.userInfo.className))]),_c('h3',[_vm._v(_vm._s(_vm.userInfo.name))]),_c('p',[_vm._v(_vm._s(_vm.userInfo.sno))])])])]),_c('section',{staticClass:"section",staticStyle:{"padding-top":".875rem"}},[_c('div',{staticClass:"container"},[(_vm.isAdd)?_c('router-link',{attrs:{"to":{name: 'personalInfo'}}},[_c('ul',{staticClass:"card info-card"},[_c('li',{staticClass:"icon-circle"},[_c('em',{staticClass:"icon icon-add"})]),_c('li',{staticClass:"text-center title"},[_vm._v("完善个人信息")])])]):[_c('div',{staticStyle:{"overflow":"hidden"}},[_c('h4',{staticClass:"float-left"},[_vm._v("  个人信息")]),(_vm.isShow)?_c('router-link',{staticClass:"float-right text-brand",attrs:{"to":{name: 'personalInfo'}}},[_vm._v("编辑  ")]):_vm._e()],1),_c('div',{staticClass:"card group-card"},[_c('group',{attrs:{"title":""}},_vm._l((_vm.personalInfo),function(item,i){return _c('cell',{key:i,attrs:{"title":item.comments,"value":item.value,"name":item.name}})}),1)],1),_c('br')]],2),_c('div',{staticClass:"container"},[(_vm.familyInfo.length == 0)?_c('router-link',{attrs:{"to":{name: 'parentsInfo'}}},[_c('ul',{staticClass:"card info-card"},[_c('li',{staticClass:"icon-circle"},[_c('em',{staticClass:"icon icon-add"})]),_c('li',{staticClass:"text-center title"},[_vm._v("完善家庭成员信息")])])]):_c('x-button',{attrs:{"type":"brand","link":{name: 'parentsInfo'}}},[_vm._v("查看家庭成员信息")])],1)])])],1),_c('transition',{attrs:{"name":"slide","enter-active-class":"animated fastest slideInUp","leave-active-class":"animated fastest slideOutDown"}},[_c('router-view',{attrs:{"isShow":_vm.isShow}})],1)],1)}
var info_staticRenderFns = []
var info_esExports = { render: info_render, staticRenderFns: info_staticRenderFns }
/* harmony default export */ var views_items_info = (info_esExports);
// CONCATENATED MODULE: ./src/yingxin/tskjxy/views/items/info.vue
function info_injectStyle (ssrContext) {
  __webpack_require__("eds1")
}
var info_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var info___vue_template_functional__ = false
/* styles */
var info___vue_styles__ = info_injectStyle
/* scopeId */
var info___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var info___vue_module_identifier__ = null
var info_Component = info_normalizeComponent(
  items_info,
  views_items_info,
  info___vue_template_functional__,
  info___vue_styles__,
  info___vue_scopeId__,
  info___vue_module_identifier__
)

/* harmony default export */ var tskjxy_views_items_info = (info_Component.exports);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/object/assign.js
var core_js_object_assign = __webpack_require__("woOf");
var assign_default = /*#__PURE__*/__webpack_require__.n(core_js_object_assign);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/typeof.js
var helpers_typeof = __webpack_require__("pFYg");
var typeof_default = /*#__PURE__*/__webpack_require__.n(helpers_typeof);

// EXTERNAL MODULE: ./node_modules/vux/src/components/popup/popup.js
var popup = __webpack_require__("+v63");

// EXTERNAL MODULE: ./node_modules/vux/src/libs/dom.js
var dom = __webpack_require__("te2A");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/popup/index.vue

//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var components_popup = ({
  name: 'popup',
  props: {
    value: Boolean,
    height: {
      type: String,
      default: 'auto'
    },
    width: {
      type: String,
      default: 'auto'
    },
    showMask: {
      type: Boolean,
      default: true
    },
    isTransparent: Boolean,
    hideOnBlur: {
      type: Boolean,
      default: true
    },
    position: {
      type: String,
      default: 'bottom'
    },
    maxHeight: String,
    popupStyle: Object,
    hideOnDeactivated: {
      type: Boolean,
      default: true
    },
    shouldRerenderOnShow: {
      type: Boolean,
      default: false
    },
    shouldScrollTopOnShow: {
      type: Boolean,
      default: false
    }
  },
  created: function created() {
    // get global layout config
    if (this.$vux && this.$vux.config && this.$vux.config.$layout === 'VIEW_BOX') {
      this.layout = 'VIEW_BOX';
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    this.$overflowScrollingList = document.querySelectorAll('.vux-fix-safari-overflow-scrolling');
    this.$nextTick(function () {
      var _this = _this2;
      _this2.popup = new popup["a" /* default */]({
        showMask: _this.showMask,
        container: _this.$el,
        hideOnBlur: _this.hideOnBlur,
        onOpen: function onOpen() {
          _this.fixSafariOverflowScrolling('auto');
          _this.show = true;
        },
        onClose: function onClose() {
          _this.show = false;
          if (window.__$vuxPopups && keys_default()(window.__$vuxPopups).length > 1) return;
          if (document.querySelector('.vux-popup-dialog.vux-popup-mask-disabled')) return;
          setTimeout(function () {
            _this.fixSafariOverflowScrolling('touch');
          }, 300);
        }
      });
      if (_this2.value) {
        _this2.popup.show();
      }
      _this2.initialShow = false;
    });
  },
  deactivated: function deactivated() {
    if (this.hideOnDeactivated) {
      this.show = false;
    }
    this.removeModalClassName();
  },

  methods: {
    /**
    * https://github.com/airyland/vux/issues/311
    * https://benfrain.com/z-index-stacking-contexts-experimental-css-and-ios-safari/
    */
    fixSafariOverflowScrolling: function fixSafariOverflowScrolling(type) {
      if (!this.$overflowScrollingList.length) return;
      // if (!/iphone/i.test(navigator.userAgent)) return
      for (var i = 0; i < this.$overflowScrollingList.length; i++) {
        this.$overflowScrollingList[i].style.webkitOverflowScrolling = type;
      }
    },
    removeModalClassName: function removeModalClassName() {
      this.layout === 'VIEW_BOX' && dom["a" /* default */].removeClass(document.body, 'vux-modal-open');
    },
    doShow: function doShow() {
      this.popup && this.popup.show();
      this.$emit('on-show');
      this.fixSafariOverflowScrolling('auto');
      this.layout === 'VIEW_BOX' && dom["a" /* default */].addClass(document.body, 'vux-modal-open');
      if (!this.hasFirstShow) {
        this.$emit('on-first-show');
        this.hasFirstShow = true;
      }
    },
    scrollTop: function scrollTop() {
      var _this3 = this;

      this.$nextTick(function () {
        _this3.$el.scrollTop = 0;
        var box = _this3.$el.querySelectorAll('.vux-scrollable');
        if (box.length) {
          for (var i = 0; i < box.length; i++) {
            box[i].scrollTop = 0;
          }
        }
      });
    }
  },
  data: function data() {
    return {
      layout: '',
      initialShow: true,
      hasFirstShow: false,
      shouldRenderBody: true,
      show: this.value
    };
  },

  computed: {
    styles: function styles() {
      var styles = {};
      if (!this.position || this.position === 'bottom' || this.position === 'top') {
        styles.height = this.height;
      } else {
        styles.width = this.width;
      }

      if (this.maxHeight) {
        styles['max-height'] = this.maxHeight;
      }

      this.isTransparent && (styles['background'] = 'transparent');
      if (this.popupStyle) {
        for (var i in this.popupStyle) {
          styles[i] = this.popupStyle[i];
        }
      }
      return styles;
    }
  },
  watch: {
    value: function value(val) {
      this.show = val;
    },
    show: function show(val) {
      var _this4 = this;

      this.$emit('input', val);
      if (val) {
        // rerender body
        if (this.shouldRerenderOnShow) {
          this.shouldRenderBody = false;
          this.$nextTick(function () {
            _this4.scrollTop();
            _this4.shouldRenderBody = true;
            _this4.doShow();
          });
        } else {
          if (this.shouldScrollTopOnShow) {
            this.scrollTop();
          }
          this.doShow();
        }
      } else {
        this.$emit('on-hide');
        this.show = false;
        this.popup.hide(false);
        setTimeout(function () {
          if (!document.querySelector('.vux-popup-dialog.vux-popup-show')) {
            _this4.fixSafariOverflowScrolling('touch');
          }
          _this4.removeModalClassName();
        }, 200);
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.popup && this.popup.destroy();
    this.fixSafariOverflowScrolling('touch');
    this.removeModalClassName();
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/popup/index.vue

//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var src_components_popup = ({
  name: 'popup',
  props: {
    value: Boolean,
    height: {
      type: String,
      default: 'auto'
    },
    width: {
      type: String,
      default: 'auto'
    },
    showMask: {
      type: Boolean,
      default: true
    },
    isTransparent: Boolean,
    hideOnBlur: {
      type: Boolean,
      default: true
    },
    position: {
      type: String,
      default: 'bottom'
    },
    maxHeight: String,
    popupStyle: Object,
    hideOnDeactivated: {
      type: Boolean,
      default: true
    },
    shouldRerenderOnShow: {
      type: Boolean,
      default: false
    },
    shouldScrollTopOnShow: {
      type: Boolean,
      default: false
    }
  },
  created: function created() {
    // get global layout config
    if (this.$vux && this.$vux.config && this.$vux.config.$layout === 'VIEW_BOX') {
      this.layout = 'VIEW_BOX';
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    this.$overflowScrollingList = document.querySelectorAll('.vux-fix-safari-overflow-scrolling');
    this.$nextTick(function () {
      var _this = _this2;
      _this2.popup = new popup["a" /* default */]({
        showMask: _this.showMask,
        container: _this.$el,
        hideOnBlur: _this.hideOnBlur,
        onOpen: function onOpen() {
          _this.fixSafariOverflowScrolling('auto');
          _this.show = true;
        },
        onClose: function onClose() {
          _this.show = false;
          if (window.__$vuxPopups && keys_default()(window.__$vuxPopups).length > 1) return;
          if (document.querySelector('.vux-popup-dialog.vux-popup-mask-disabled')) return;
          setTimeout(function () {
            _this.fixSafariOverflowScrolling('touch');
          }, 300);
        }
      });
      if (_this2.value) {
        _this2.popup.show();
      }
      _this2.initialShow = false;
    });
  },
  deactivated: function deactivated() {
    if (this.hideOnDeactivated) {
      this.show = false;
    }
    this.removeModalClassName();
  },

  methods: {
    /**
    * https://github.com/airyland/vux/issues/311
    * https://benfrain.com/z-index-stacking-contexts-experimental-css-and-ios-safari/
    */
    fixSafariOverflowScrolling: function fixSafariOverflowScrolling(type) {
      if (!this.$overflowScrollingList.length) return;
      // if (!/iphone/i.test(navigator.userAgent)) return
      for (var i = 0; i < this.$overflowScrollingList.length; i++) {
        this.$overflowScrollingList[i].style.webkitOverflowScrolling = type;
      }
    },
    removeModalClassName: function removeModalClassName() {
      this.layout === 'VIEW_BOX' && dom["a" /* default */].removeClass(document.body, 'vux-modal-open');
    },
    doShow: function doShow() {
      this.popup && this.popup.show();
      this.$emit('on-show');
      this.fixSafariOverflowScrolling('auto');
      this.layout === 'VIEW_BOX' && dom["a" /* default */].addClass(document.body, 'vux-modal-open');
      if (!this.hasFirstShow) {
        this.$emit('on-first-show');
        this.hasFirstShow = true;
      }
    },
    scrollTop: function scrollTop() {
      var _this3 = this;

      this.$nextTick(function () {
        _this3.$el.scrollTop = 0;
        var box = _this3.$el.querySelectorAll('.vux-scrollable');
        if (box.length) {
          for (var i = 0; i < box.length; i++) {
            box[i].scrollTop = 0;
          }
        }
      });
    }
  },
  data: function data() {
    return {
      layout: '',
      initialShow: true,
      hasFirstShow: false,
      shouldRenderBody: true,
      show: this.value
    };
  },

  computed: {
    styles: function styles() {
      var styles = {};
      if (!this.position || this.position === 'bottom' || this.position === 'top') {
        styles.height = this.height;
      } else {
        styles.width = this.width;
      }

      if (this.maxHeight) {
        styles['max-height'] = this.maxHeight;
      }

      this.isTransparent && (styles['background'] = 'transparent');
      if (this.popupStyle) {
        for (var i in this.popupStyle) {
          styles[i] = this.popupStyle[i];
        }
      }
      return styles;
    }
  },
  watch: {
    value: function value(val) {
      this.show = val;
    },
    show: function show(val) {
      var _this4 = this;

      this.$emit('input', val);
      if (val) {
        // rerender body
        if (this.shouldRerenderOnShow) {
          this.shouldRenderBody = false;
          this.$nextTick(function () {
            _this4.scrollTop();
            _this4.shouldRenderBody = true;
            _this4.doShow();
          });
        } else {
          if (this.shouldScrollTopOnShow) {
            this.scrollTop();
          }
          this.doShow();
        }
      } else {
        this.$emit('on-hide');
        this.show = false;
        this.popup.hide(false);
        setTimeout(function () {
          if (!document.querySelector('.vux-popup-dialog.vux-popup-show')) {
            _this4.fixSafariOverflowScrolling('touch');
          }
          _this4.removeModalClassName();
        }, 200);
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.popup && this.popup.destroy();
    this.fixSafariOverflowScrolling('touch');
    this.removeModalClassName();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-613daa96","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/popup/index.vue
var popup_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":("vux-popup-animate-" + _vm.position)}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show && !_vm.initialShow),expression:"show && !initialShow"}],staticClass:"vux-popup-dialog",class:[("vux-popup-" + _vm.position), _vm.show ? 'vux-popup-show' : ''],style:(_vm.styles)},[(_vm.shouldRenderBody)?_vm._t("default"):_vm._e()],2)])}
var popup_staticRenderFns = []
var popup_esExports = { render: popup_render, staticRenderFns: popup_staticRenderFns }
/* harmony default export */ var vux_src_components_popup = (popup_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/popup/index.vue
function popup_injectStyle (ssrContext) {
  __webpack_require__("/qU+")
}
var popup_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var popup___vue_template_functional__ = false
/* styles */
var popup___vue_styles__ = popup_injectStyle
/* scopeId */
var popup___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var popup___vue_module_identifier__ = null
var popup_Component = popup_normalizeComponent(
  src_components_popup,
  vux_src_components_popup,
  popup___vue_template_functional__,
  popup___vue_styles__,
  popup___vue_scopeId__,
  popup___vue_module_identifier__
)

/* harmony default export */ var node_modules_vux_src_components_popup = (popup_Component.exports);

// EXTERNAL MODULE: ./node_modules/vux/src/components/checklist/object-filter.js
var object_filter = __webpack_require__("q5lo");

// EXTERNAL MODULE: ./node_modules/vux/src/components/radio/props.js
var radio_props = __webpack_require__("Zor0");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/radio/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var components_radio = ({
  name: 'radio',
  mixins: [base["a" /* default */]],
  filters: {
    getValue: object_filter["e" /* getValue */],
    getKey: object_filter["b" /* getKey */]
  },
  props: Object(radio_props["a" /* default */])(),
  created: function created() {
    this.handleChangeEvent = true;
  },

  methods: {
    getValue: object_filter["e" /* getValue */],
    getKey: object_filter["b" /* getKey */],
    onFocus: function onFocus() {
      this.currentValue = this.fillValue || '';
      this.isFocus = true;
    }
  },
  watch: {
    value: function value(val) {
      this.currentValue = val;
    },
    currentValue: function currentValue(newVal) {
      var isOption = contains(this.options, newVal);
      if (newVal !== '' && isOption) {
        this.fillValue = '';
      }
      this.$emit('on-change', newVal, Object(object_filter["c" /* getLabel */])(this.options, newVal));
      this.$emit('input', newVal);
    },
    fillValue: function fillValue(newVal) {
      if (this.fillMode && this.isFocus) {
        this.currentValue = newVal;
      }
    }
  },
  data: function data() {
    return {
      fillValue: '',
      isFocus: false,
      currentValue: this.value
    };
  }
});

function contains(a, obj) {
  var i = a.length;
  while (i--) {
    if (a[i] === obj) {
      return true;
    }
  }
  return false;
}
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/radio/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var src_components_radio = ({
  name: 'radio',
  mixins: [base["a" /* default */]],
  filters: {
    getValue: object_filter["e" /* getValue */],
    getKey: object_filter["b" /* getKey */]
  },
  props: Object(radio_props["a" /* default */])(),
  created: function created() {
    this.handleChangeEvent = true;
  },

  methods: {
    getValue: object_filter["e" /* getValue */],
    getKey: object_filter["b" /* getKey */],
    onFocus: function onFocus() {
      this.currentValue = this.fillValue || '';
      this.isFocus = true;
    }
  },
  watch: {
    value: function value(val) {
      this.currentValue = val;
    },
    currentValue: function currentValue(newVal) {
      var isOption = radio_contains(this.options, newVal);
      if (newVal !== '' && isOption) {
        this.fillValue = '';
      }
      this.$emit('on-change', newVal, Object(object_filter["c" /* getLabel */])(this.options, newVal));
      this.$emit('input', newVal);
    },
    fillValue: function fillValue(newVal) {
      if (this.fillMode && this.isFocus) {
        this.currentValue = newVal;
      }
    }
  },
  data: function data() {
    return {
      fillValue: '',
      isFocus: false,
      currentValue: this.value
    };
  }
});

function radio_contains(a, obj) {
  var i = a.length;
  while (i--) {
    if (a[i] === obj) {
      return true;
    }
  }
  return false;
}
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-956dfba4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/radio/index.vue
var radio_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"weui-cells_radio",class:_vm.disabled ? 'vux-radio-disabled' : ''},[_vm._l((_vm.options),function(one,index){return _c('label',{staticClass:"weui-cell weui-cell_radio weui-check__label",attrs:{"for":("radio_" + _vm.uuid + "_" + index)}},[_c('div',{staticClass:"weui-cell__bd"},[_vm._t("each-item",[_c('p',[_c('img',{directives:[{name:"show",rawName:"v-show",value:(one && one.icon),expression:"one && one.icon"}],staticClass:"vux-radio-icon",attrs:{"src":one.icon}}),_vm._v(" "),_c('span',{staticClass:"vux-radio-label",style:(_vm.currentValue === _vm.getKey(one) ? (_vm.selectedLabelStyle || '') : '')},[_vm._v(_vm._s(_vm._f("getValue")(one)))])])],{"icon":one.icon,"label":_vm.getValue(one),"index":index,"selected":_vm.currentValue === _vm.getKey(one)})],2),_vm._v(" "),_c('div',{staticClass:"weui-cell__ft"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentValue),expression:"currentValue"}],staticClass:"weui-check",attrs:{"type":"radio","id":_vm.disabled ? '' : ("radio_" + _vm.uuid + "_" + index)},domProps:{"value":_vm.getKey(one),"checked":_vm._q(_vm.currentValue,_vm.getKey(one))},on:{"change":function($event){_vm.currentValue=_vm.getKey(one)}}}),_vm._v(" "),_c('span',{staticClass:"weui-icon-checked"})])])}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.fillMode),expression:"fillMode"}],staticClass:"weui-cell"},[_c('div',{staticClass:"weui-cell__hd"},[_c('label',{staticClass:"weui-label",attrs:{"for":""}},[_vm._v(_vm._s(_vm.fillLabel))])]),_vm._v(" "),_c('div',{staticClass:"weui-cell__bd"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.fillValue),expression:"fillValue"}],staticClass:"weui-input needsclick",attrs:{"type":"text","placeholder":_vm.fillPlaceholder},domProps:{"value":(_vm.fillValue)},on:{"blur":function($event){_vm.isFocus=false},"focus":function($event){return _vm.onFocus()},"input":function($event){if($event.target.composing){ return; }_vm.fillValue=$event.target.value}}})]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.value==='' && !_vm.isFocus),expression:"value==='' && !isFocus"}],staticClass:"weui-cell__ft"},[_c('i',{staticClass:"weui-icon-warn"})])])],2)}
var radio_staticRenderFns = []
var radio_esExports = { render: radio_render, staticRenderFns: radio_staticRenderFns }
/* harmony default export */ var vux_src_components_radio = (radio_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/radio/index.vue
function radio_injectStyle (ssrContext) {
  __webpack_require__("5FKM")
}
var radio_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var radio___vue_template_functional__ = false
/* styles */
var radio___vue_styles__ = radio_injectStyle
/* scopeId */
var radio___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var radio___vue_module_identifier__ = null
var radio_Component = radio_normalizeComponent(
  src_components_radio,
  vux_src_components_radio,
  radio___vue_template_functional__,
  radio___vue_styles__,
  radio___vue_scopeId__,
  radio___vue_module_identifier__
)

/* harmony default export */ var node_modules_vux_src_components_radio = (radio_Component.exports);

// EXTERNAL MODULE: ./node_modules/array-find/find.js
var find = __webpack_require__("NXHL");
var find_default = /*#__PURE__*/__webpack_require__.n(find);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/popup-radio/index.vue


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









var _cellProps = Object(props["a" /* default */])();
delete _cellProps.value;

/* harmony default export */ var popup_radio = ({
  name: 'popup-radio',
  components: {
    Popup: node_modules_vux_src_components_popup,
    Radio: node_modules_vux_src_components_radio,
    Cell: vux_src_components_cell
  },
  directives: {
    TransferDom: transfer_dom["a" /* default */]
  },
  props: extends_default()({
    placeholder: String,
    readonly: Boolean
  }, _cellProps, Object(radio_props["a" /* default */])()),
  computed: {
    displayValue: function displayValue() {
      var _this = this;

      if (!this.options.length) {
        return '';
      }
      if (typeof_default()(this.options[0]) === 'object') {
        var match = find_default()(this.options, function (option) {
          return option.key === _this.currentValue;
        });
        if (match) {
          return match.value;
        }
      }
      return this.currentValue;
    }
  },
  methods: {
    onValueChange: function onValueChange(val) {
      this.hide();
    },
    show: function show() {
      if (!this.readonly) {
        this.showPopup = true;
      }
    },
    hide: function hide() {
      this.showPopup = false;
    }
  },
  watch: {
    value: function value(val) {
      this.currentValue = val;
    },
    currentValue: function currentValue(val) {
      this.$emit('input', val);
      this.$emit('on-change', val);
    }
  },
  data: function data() {
    return {
      showPopup: false,
      currentValue: this.value
    };
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/popup-radio/index.vue


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









var popup_radio__cellProps = Object(props["a" /* default */])();
delete popup_radio__cellProps.value;

/* harmony default export */ var components_popup_radio = ({
  name: 'popup-radio',
  components: {
    Popup: node_modules_vux_src_components_popup,
    Radio: node_modules_vux_src_components_radio,
    Cell: vux_src_components_cell
  },
  directives: {
    TransferDom: transfer_dom["a" /* default */]
  },
  props: extends_default()({
    placeholder: String,
    readonly: Boolean
  }, popup_radio__cellProps, Object(radio_props["a" /* default */])()),
  computed: {
    displayValue: function displayValue() {
      var _this = this;

      if (!this.options.length) {
        return '';
      }
      if (typeof_default()(this.options[0]) === 'object') {
        var match = find_default()(this.options, function (option) {
          return option.key === _this.currentValue;
        });
        if (match) {
          return match.value;
        }
      }
      return this.currentValue;
    }
  },
  methods: {
    onValueChange: function onValueChange(val) {
      this.hide();
    },
    show: function show() {
      if (!this.readonly) {
        this.showPopup = true;
      }
    },
    hide: function hide() {
      this.showPopup = false;
    }
  },
  watch: {
    value: function value(val) {
      this.currentValue = val;
    },
    currentValue: function currentValue(val) {
      this.$emit('input', val);
      this.$emit('on-change', val);
    }
  },
  data: function data() {
    return {
      showPopup: false,
      currentValue: this.value
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-51e4c581","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/popup-radio/index.vue
var popup_radio_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('cell',{attrs:{"title":_vm.title,"value":_vm.currentValue,"is-link":!_vm.readonly,"value-align":_vm.valueAlign,"border-intent":_vm.borderIntent},nativeOn:{"click":function($event){return _vm.show($event)}}},[(!_vm.displayValue && _vm.placeholder)?_c('span',{staticClass:"vux-cell-placeholder"},[_vm._v(_vm._s(_vm.placeholder))]):_vm._e(),_vm._v(" "),(_vm.displayValue)?_c('span',{staticClass:"vux-cell-value"},[_vm._v(_vm._s(_vm.displayValue))]):_vm._e(),_vm._v(" "),_c('span',{attrs:{"slot":"icon"},slot:"icon"},[_vm._t("icon")],2),_vm._v(" "),_c('div',{directives:[{name:"transfer-dom",rawName:"v-transfer-dom"}]},[_c('popup',{staticStyle:{"background-color":"#fff"},on:{"on-hide":function($event){return _vm.$emit('on-hide')},"on-show":function($event){return _vm.$emit('on-show')}},model:{value:(_vm.showPopup),callback:function ($$v) {_vm.showPopup=$$v},expression:"showPopup"}},[_vm._t("popup-header",null,{"options":_vm.options,"value":_vm.currentValue}),_vm._v(" "),_c('radio',{attrs:{"options":_vm.options,"fill-mode":false},on:{"on-change":_vm.onValueChange},scopedSlots:_vm._u([{key:"each-item",fn:function(props){return [_vm._t("each-item",[_c('p',[_c('img',{directives:[{name:"show",rawName:"v-show",value:(props.icon),expression:"props.icon"}],staticClass:"vux-radio-icon",attrs:{"src":props.icon}}),_vm._v(" "),_c('span',{staticClass:"vux-radio-label"},[_vm._v(_vm._s(props.label))])])],{"icon":props.icon,"label":props.label,"index":props.index})]}}],null,true),model:{value:(_vm.currentValue),callback:function ($$v) {_vm.currentValue=$$v},expression:"currentValue"}})],2)],1)])}
var popup_radio_staticRenderFns = []
var popup_radio_esExports = { render: popup_radio_render, staticRenderFns: popup_radio_staticRenderFns }
/* harmony default export */ var src_components_popup_radio = (popup_radio_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/popup-radio/index.vue
function popup_radio_injectStyle (ssrContext) {
  __webpack_require__("NSqn")
}
var popup_radio_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var popup_radio___vue_template_functional__ = false
/* styles */
var popup_radio___vue_styles__ = popup_radio_injectStyle
/* scopeId */
var popup_radio___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var popup_radio___vue_module_identifier__ = null
var popup_radio_Component = popup_radio_normalizeComponent(
  components_popup_radio,
  src_components_popup_radio,
  popup_radio___vue_template_functional__,
  popup_radio___vue_styles__,
  popup_radio___vue_scopeId__,
  popup_radio___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_popup_radio = (popup_radio_Component.exports);

// EXTERNAL MODULE: ./node_modules/vux/src/components/datetime/datetimepicker.js + 2 modules
var datetimepicker = __webpack_require__("zV4+");

// EXTERNAL MODULE: ./node_modules/vux/src/mixins/uuid.js
var uuid = __webpack_require__("KRg4");

// EXTERNAL MODULE: ./node_modules/vux/src/tools/date/format.js
var date_format = __webpack_require__("ODCk");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/datetime/index.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ var datetime = ({
  name: 'datetime',
  mixins: [uuid["a" /* default */]],
  components: {
    Group: vux_src_components_group,
    InlineDesc: vux_src_components_inline_desc,
    Icon: vux_src_components_icon
  },
  props: {
    format: {
      type: String,
      default: 'YYYY-MM-DD',
      validator: function validator(val) {
        /* istanbul ignore if */
        if (false) {
          return console.error('[VUX] Datetime prop:format 使用 A 时只允许的值为： YYYY-MM-DD A');
        }
        return true;
      }
    },
    title: String,
    value: {
      type: String,
      default: ''
    },
    inlineDesc: String,
    placeholder: String,
    minYear: Number,
    maxYear: Number,
    confirmText: String,
    cancelText: String,
    clearText: String,
    yearRow: {
      type: String,
      default: '{value}'
    },
    monthRow: {
      type: String,
      default: '{value}'
    },
    dayRow: {
      type: String,
      default: '{value}'
    },
    hourRow: {
      type: String,
      default: '{value}'
    },
    minuteRow: {
      type: String,
      default: '{value}'
    },
    required: {
      type: Boolean,
      default: false
    },
    minHour: {
      type: Number,
      default: 0
    },
    maxHour: {
      type: Number,
      default: 23
    },
    startDate: {
      type: String,
      validator: function validator(val) {
        /* istanbul ignore if */
        if (false) {
          console.error('[VUX] Datetime prop:start-date 必须为 YYYY-MM-DD 格式');
        }
        return val ? val.length === 10 : true;
      }
    },
    endDate: {
      type: String,
      validator: function validator(val) {
        /* istanbul ignore if */
        if (false) {
          console.error('[VUX] Datetime prop:end-date 必须为 YYYY-MM-DD 格式');
        }
        return val ? val.length === 10 : true;
      }
    },
    valueTextAlign: String,
    displayFormat: Function,
    readonly: Boolean,
    hourList: Array,
    minuteList: Array,
    show: Boolean,
    defaultSelectedValue: String,
    computeHoursFunction: Function,
    computeDaysFunction: Function,
    orderMap: Object
  },
  created: function created() {
    this.isFirstSetValue = false;
    this.currentValue = this.value;
  },
  data: function data() {
    return {
      currentShow: false,
      currentValue: null,
      valid: true,
      errors: {}
    };
  },
  mounted: function mounted() {
    var _this2 = this;

    var uuid = this.uuid;
    this.$el.setAttribute('id', 'vux-datetime-' + uuid);
    if (!this.readonly) {
      this.$nextTick(function () {
        _this2.render();

        if (_this2.show) {
          _this2.$nextTick(function () {
            _this2.picker && _this2.picker.show(_this2.currentValue);
          });
        }
      });
    }
  },

  computed: {
    styles: function styles() {
      if (!this.$parent) {
        return {};
      }
      return {
        width: this.$parent.labelWidth,
        textAlign: this.$parent.labelAlign,
        marginRight: this.$parent.labelMarginRight
      };
    },
    pickerOptions: function pickerOptions() {
      var _this = this;
      var options = {
        trigger: '#vux-datetime-' + this.uuid,
        format: this.format,
        value: this.currentValue,
        output: '.vux-datetime-value',
        confirmText: _this.getButtonText('confirm'),
        cancelText: _this.getButtonText('cancel'),
        clearText: _this.clearText,
        yearRow: this.yearRow,
        monthRow: this.monthRow,
        dayRow: this.dayRow,
        hourRow: this.hourRow,
        minuteRow: this.minuteRow,
        minHour: this.minHour,
        maxHour: this.maxHour,
        startDate: this.startDate,
        endDate: this.endDate,
        hourList: this.hourList,
        minuteList: this.minuteList,
        defaultSelectedValue: this.defaultSelectedValue,
        computeHoursFunction: this.computeHoursFunction,
        computeDaysFunction: this.computeDaysFunction,
        orderMap: this.orderMap || {},
        onSelect: function onSelect(type, val, wholeValue) {
          if (_this.picker && _this.picker.config.renderInline) {
            _this.$emit('input', wholeValue);
            _this.$emit('on-change', wholeValue);
          }
        },
        onConfirm: function onConfirm(value) {
          _this.currentValue = value;
        },
        onClear: function onClear(value) {
          _this.$emit('on-clear', value);
        },
        onHide: function onHide(type) {
          _this.currentShow = false;
          _this.$emit('update:show', false);
          _this.validate();
          _this.$emit('on-hide', type);
          if (type === 'cancel') {
            _this.$emit('on-cancel');
          }
          if (type === 'confirm') {
            setTimeout(function () {
              _this.$nextTick(function () {
                _this.$emit('on-confirm', _this.value);
              });
            });
          }
        },
        onShow: function onShow() {
          _this.currentShow = true;
          _this.$emit('update:show', true);
          _this.$emit('on-show');
        }
      };
      if (this.minYear) {
        options.minYear = this.minYear;
      }
      if (this.maxYear) {
        options.maxYear = this.maxYear;
      }
      return options;
    },
    firstError: function firstError() {
      var key = keys_default()(this.errors)[0];
      return this.errors[key];
    },
    labelClass: function labelClass() {
      if (!this.$parent) {
        return {};
      }
      return {
        'vux-cell-justify': this.$parent.labelAlign === 'justify' || this.$parent.$parent.labelAlign === 'justify'
      };
    }
  },
  methods: {
    getButtonText: function getButtonText(type) {
      if (type === 'cancel' && this.cancelText) {
        return this.cancelText;
      } else if (type === 'confirm' && this.confirmText) {
        return this.confirmText;
      }
      return this.$el.getAttribute('data-' + type + '-text');
    },
    render: function render() {
      var _this3 = this;

      this.$nextTick(function () {
        _this3.picker && _this3.picker.destroy();
        _this3.picker = new datetimepicker["a" /* default */](_this3.pickerOptions);
      });
    },
    validate: function validate() {
      if (!this.currentValue && this.required) {
        this.valid = false;
        this.errors.required = '必填';
        return;
      }
      this.valid = true;
      this.errors = {};
    }
  },
  watch: {
    readonly: function readonly(val) {
      if (val) {
        this.picker && this.picker.destroy();
      } else {
        this.render();
      }
    },
    show: function show(val) {
      if (val === this.currentShow) return;
      if (val) {
        this.picker && this.picker.show(this.currentValue);
      } else {
        this.picker && this.picker.hide(this.currentValue);
      }
    },
    currentValue: function currentValue(val, oldVal) {
      this.$emit('input', val);
      if (!this.isFirstSetValue) {
        this.isFirstSetValue = true;
        oldVal && this.$emit('on-change', val);
      } else {
        this.$emit('on-change', val);
      }
      this.validate();
    },
    startDate: function startDate() {
      this.render();
    },
    endDate: function endDate() {
      this.render();
    },
    format: function format(val) {
      if (this.currentValue) {
        this.currentValue = Object(date_format["a" /* default */])(this.currentValue, val);
      }
      this.render();
    },
    value: function value(val) {
      // do not force render when renderInline is true
      if (this.readonly || this.picker && this.picker.config.renderInline) {
        this.currentValue = val;
        return;
      }
      if (this.currentValue !== val) {
        this.currentValue = val;
        this.render();
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.picker && this.picker.destroy();
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/datetime/index.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ var components_datetime = ({
  name: 'datetime',
  mixins: [uuid["a" /* default */]],
  components: {
    Group: vux_src_components_group,
    InlineDesc: vux_src_components_inline_desc,
    Icon: vux_src_components_icon
  },
  props: {
    format: {
      type: String,
      default: 'YYYY-MM-DD',
      validator: function validator(val) {
        /* istanbul ignore if */
        if (false) {
          return console.error('[VUX] Datetime prop:format 使用 A 时只允许的值为： YYYY-MM-DD A');
        }
        return true;
      }
    },
    title: String,
    value: {
      type: String,
      default: ''
    },
    inlineDesc: String,
    placeholder: String,
    minYear: Number,
    maxYear: Number,
    confirmText: String,
    cancelText: String,
    clearText: String,
    yearRow: {
      type: String,
      default: '{value}'
    },
    monthRow: {
      type: String,
      default: '{value}'
    },
    dayRow: {
      type: String,
      default: '{value}'
    },
    hourRow: {
      type: String,
      default: '{value}'
    },
    minuteRow: {
      type: String,
      default: '{value}'
    },
    required: {
      type: Boolean,
      default: false
    },
    minHour: {
      type: Number,
      default: 0
    },
    maxHour: {
      type: Number,
      default: 23
    },
    startDate: {
      type: String,
      validator: function validator(val) {
        /* istanbul ignore if */
        if (false) {
          console.error('[VUX] Datetime prop:start-date 必须为 YYYY-MM-DD 格式');
        }
        return val ? val.length === 10 : true;
      }
    },
    endDate: {
      type: String,
      validator: function validator(val) {
        /* istanbul ignore if */
        if (false) {
          console.error('[VUX] Datetime prop:end-date 必须为 YYYY-MM-DD 格式');
        }
        return val ? val.length === 10 : true;
      }
    },
    valueTextAlign: String,
    displayFormat: Function,
    readonly: Boolean,
    hourList: Array,
    minuteList: Array,
    show: Boolean,
    defaultSelectedValue: String,
    computeHoursFunction: Function,
    computeDaysFunction: Function,
    orderMap: Object
  },
  created: function created() {
    this.isFirstSetValue = false;
    this.currentValue = this.value;
  },
  data: function data() {
    return {
      currentShow: false,
      currentValue: null,
      valid: true,
      errors: {}
    };
  },
  mounted: function mounted() {
    var _this2 = this;

    var uuid = this.uuid;
    this.$el.setAttribute('id', 'vux-datetime-' + uuid);
    if (!this.readonly) {
      this.$nextTick(function () {
        _this2.render();

        if (_this2.show) {
          _this2.$nextTick(function () {
            _this2.picker && _this2.picker.show(_this2.currentValue);
          });
        }
      });
    }
  },

  computed: {
    styles: function styles() {
      if (!this.$parent) {
        return {};
      }
      return {
        width: this.$parent.labelWidth,
        textAlign: this.$parent.labelAlign,
        marginRight: this.$parent.labelMarginRight
      };
    },
    pickerOptions: function pickerOptions() {
      var _this = this;
      var options = {
        trigger: '#vux-datetime-' + this.uuid,
        format: this.format,
        value: this.currentValue,
        output: '.vux-datetime-value',
        confirmText: _this.getButtonText('confirm'),
        cancelText: _this.getButtonText('cancel'),
        clearText: _this.clearText,
        yearRow: this.yearRow,
        monthRow: this.monthRow,
        dayRow: this.dayRow,
        hourRow: this.hourRow,
        minuteRow: this.minuteRow,
        minHour: this.minHour,
        maxHour: this.maxHour,
        startDate: this.startDate,
        endDate: this.endDate,
        hourList: this.hourList,
        minuteList: this.minuteList,
        defaultSelectedValue: this.defaultSelectedValue,
        computeHoursFunction: this.computeHoursFunction,
        computeDaysFunction: this.computeDaysFunction,
        orderMap: this.orderMap || {},
        onSelect: function onSelect(type, val, wholeValue) {
          if (_this.picker && _this.picker.config.renderInline) {
            _this.$emit('input', wholeValue);
            _this.$emit('on-change', wholeValue);
          }
        },
        onConfirm: function onConfirm(value) {
          _this.currentValue = value;
        },
        onClear: function onClear(value) {
          _this.$emit('on-clear', value);
        },
        onHide: function onHide(type) {
          _this.currentShow = false;
          _this.$emit('update:show', false);
          _this.validate();
          _this.$emit('on-hide', type);
          if (type === 'cancel') {
            _this.$emit('on-cancel');
          }
          if (type === 'confirm') {
            setTimeout(function () {
              _this.$nextTick(function () {
                _this.$emit('on-confirm', _this.value);
              });
            });
          }
        },
        onShow: function onShow() {
          _this.currentShow = true;
          _this.$emit('update:show', true);
          _this.$emit('on-show');
        }
      };
      if (this.minYear) {
        options.minYear = this.minYear;
      }
      if (this.maxYear) {
        options.maxYear = this.maxYear;
      }
      return options;
    },
    firstError: function firstError() {
      var key = keys_default()(this.errors)[0];
      return this.errors[key];
    },
    labelClass: function labelClass() {
      if (!this.$parent) {
        return {};
      }
      return {
        'vux-cell-justify': this.$parent.labelAlign === 'justify' || this.$parent.$parent.labelAlign === 'justify'
      };
    }
  },
  methods: {
    getButtonText: function getButtonText(type) {
      if (type === 'cancel' && this.cancelText) {
        return this.cancelText;
      } else if (type === 'confirm' && this.confirmText) {
        return this.confirmText;
      }
      return this.$el.getAttribute('data-' + type + '-text');
    },
    render: function render() {
      var _this3 = this;

      this.$nextTick(function () {
        _this3.picker && _this3.picker.destroy();
        _this3.picker = new datetimepicker["a" /* default */](_this3.pickerOptions);
      });
    },
    validate: function validate() {
      if (!this.currentValue && this.required) {
        this.valid = false;
        this.errors.required = '必填';
        return;
      }
      this.valid = true;
      this.errors = {};
    }
  },
  watch: {
    readonly: function readonly(val) {
      if (val) {
        this.picker && this.picker.destroy();
      } else {
        this.render();
      }
    },
    show: function show(val) {
      if (val === this.currentShow) return;
      if (val) {
        this.picker && this.picker.show(this.currentValue);
      } else {
        this.picker && this.picker.hide(this.currentValue);
      }
    },
    currentValue: function currentValue(val, oldVal) {
      this.$emit('input', val);
      if (!this.isFirstSetValue) {
        this.isFirstSetValue = true;
        oldVal && this.$emit('on-change', val);
      } else {
        this.$emit('on-change', val);
      }
      this.validate();
    },
    startDate: function startDate() {
      this.render();
    },
    endDate: function endDate() {
      this.render();
    },
    format: function format(val) {
      if (this.currentValue) {
        this.currentValue = Object(date_format["a" /* default */])(this.currentValue, val);
      }
      this.render();
    },
    value: function value(val) {
      // do not force render when renderInline is true
      if (this.readonly || this.picker && this.picker.config.renderInline) {
        this.currentValue = val;
        return;
      }
      if (this.currentValue !== val) {
        this.currentValue = val;
        this.render();
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.picker && this.picker.destroy();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-241efaf4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/datetime/index.vue
var datetime_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"vux-datetime weui-cell",class:{'weui-cell_access': !_vm.readonly},attrs:{"data-cancel-text":'取消',"data-confirm-text":'确定',"href":"javascript:"}},[_vm._t("default",[_c('div',[_vm._t("title",[_c('p',{class:_vm.labelClass,style:(_vm.styles),domProps:{"innerHTML":_vm._s(_vm.title)}})]),_vm._v(" "),(_vm.inlineDesc)?_c('inline-desc',[_vm._v(_vm._s(_vm.inlineDesc))]):_vm._e()],2),_vm._v(" "),_c('div',{staticClass:"weui-cell__ft vux-cell-primary vux-datetime-value",style:({
        textAlign: _vm.valueTextAlign
      })},[(!_vm.currentValue && _vm.placeholder)?_c('span',{staticClass:"vux-cell-placeholder"},[_vm._v(_vm._s(_vm.placeholder))]):_vm._e(),_vm._v(" "),(_vm.currentValue)?_c('span',{staticClass:"vux-cell-value"},[_vm._v(_vm._s(_vm.displayFormat ? _vm.displayFormat(_vm.currentValue) : _vm.currentValue))]):_vm._e(),_vm._v(" "),_c('icon',{directives:[{name:"show",rawName:"v-show",value:(!_vm.valid),expression:"!valid"}],staticClass:"vux-input-icon",attrs:{"type":"warn","title":_vm.firstError}})],1)])],2)}
var datetime_staticRenderFns = []
var datetime_esExports = { render: datetime_render, staticRenderFns: datetime_staticRenderFns }
/* harmony default export */ var src_components_datetime = (datetime_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/datetime/index.vue
function datetime_injectStyle (ssrContext) {
  __webpack_require__("i+k6")
}
var datetime_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var datetime___vue_template_functional__ = false
/* styles */
var datetime___vue_styles__ = datetime_injectStyle
/* scopeId */
var datetime___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var datetime___vue_module_identifier__ = null
var datetime_Component = datetime_normalizeComponent(
  components_datetime,
  src_components_datetime,
  datetime___vue_template_functional__,
  datetime___vue_styles__,
  datetime___vue_scopeId__,
  datetime___vue_module_identifier__
)


/* harmony default export */ var vux_src_components_datetime = (datetime_Component.exports);

// EXTERNAL MODULE: ./node_modules/vux/src/components/picker/scroller.js + 1 modules
var scroller = __webpack_require__("+geU");

// EXTERNAL MODULE: ./node_modules/vux/src/components/flexbox/index.js
var flexbox = __webpack_require__("F3HL");

// EXTERNAL MODULE: ./node_modules/vux/src/components/picker/chain.js
var chain = __webpack_require__("zDi5");

// EXTERNAL MODULE: ./node_modules/vux/src/filters/value2name.js
var value2name = __webpack_require__("NE4E");

// EXTERNAL MODULE: ./node_modules/vux/src/libs/is-array.js
var is_array = __webpack_require__("cEdU");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/picker/index.vue


//
//
//
//
//
//
//
//
//
//







/* harmony default export */ var picker = ({
  name: 'picker',
  components: {
    Flexbox: flexbox["a" /* Flexbox */],
    FlexboxItem: flexbox["b" /* FlexboxItem */]
  },
  created: function created() {
    if (this.columns !== 0) {
      var length = this.columns;
      this.store = new chain["a" /* default */](this.data, length, this.fixedColumns || this.columns);
      this.currentData = this.store.getColumns(this.value);
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    this.uuid = Math.random().toString(36).substring(3, 8);
    this.$nextTick(function () {
      _this2.render(_this2.currentData, _this2.currentValue);
    });
  },

  props: {
    data: Array,
    columns: {
      type: Number,
      default: 0
    },
    fixedColumns: {
      type: Number,
      default: 0
    },
    value: Array,
    itemClass: {
      type: String,
      default: 'scroller-item'
    },
    columnWidth: Array
  },
  methods: {
    getNameValues: function getNameValues() {
      return Object(value2name["a" /* default */])(this.currentValue, this.data);
    },
    getId: function getId(i) {
      return '#vux-picker-' + this.uuid + '-' + i;
    },
    render: function render(data, value) {
      this.count = this.currentData.length;
      var _this = this;
      if (!data || !data.length) {
        return;
      }
      var count = this.currentData.length;
      // set first item as value
      if (value.length < count) {
        for (var i = 0; i < count; i++) {
          if (false) {
            console.error('[VUX error] 渲染出错，如果为联动模式，需要指定 columns(列数)');
          }
          this.$set(_this.currentValue, i, data[i][0].value || data[i][0]);
        }
      }

      var _loop = function _loop(_i) {
        /**
        * Still don't know why this happens
        */
        if (!document.querySelector(_this.getId(_i))) {
          return {
            v: void 0
          };
        }

        _this.scroller[_i] && _this.scroller[_i].destroy();
        _this.scroller[_i] = new scroller["a" /* default */](_this.getId(_i), {
          data: data[_i],
          defaultValue: value[_i] || data[_i][0].value,
          itemClass: _this.itemClass,
          onSelect: function onSelect(value) {
            _this.$set(_this.currentValue, _i, value);
            if (!this.columns || this.columns && _this.getValue().length === _this.store.count) {
              _this.$nextTick(function () {
                _this.$emit('on-change', _this.getValue());
              });
            }
            if (_this.columns !== 0) {
              _this.renderChain(_i + 1);
            }
          }
        });
        if (_this.currentValue) {
          _this.scroller[_i].select(value[_i]);
        }
      };

      for (var _i = 0; _i < data.length; _i++) {
        var _ret = _loop(_i);

        if ((typeof _ret === 'undefined' ? 'undefined' : typeof_default()(_ret)) === "object") return _ret.v;
      }
    },
    renderChain: function renderChain(i) {
      if (!this.columns) {
        return;
      }

      // do not render for last scroller
      if (i > this.count - 1) {
        return;
      }

      var _this = this;
      var ID = this.getId(i);
      // destroy old one
      this.scroller[i].destroy();
      var list = this.store.getChildren(_this.getValue()[i - 1]);
      this.scroller[i] = new scroller["a" /* default */](ID, {
        data: list,
        itemClass: _this.item_class,
        onSelect: function onSelect(value) {
          _this.$set(_this.currentValue, i, value);
          _this.$nextTick(function () {
            _this.$emit('on-change', _this.getValue());
          });
          _this.renderChain(i + 1);
        }
      });
      // list is Array(empty) as maybe
      if (list.length) {
        this.$set(this.currentValue, i, list[0].value);
        this.renderChain(i + 1);
      } else {
        this.$set(this.currentValue, i, null);
      }
    },
    getValue: function getValue() {
      var data = [];
      for (var i = 0; i < this.currentData.length; i++) {
        if (this.scroller[i]) {
          data.push(this.scroller[i].value);
        } else {
          return [];
        }
      }
      return data;
    },
    emitValueChange: function emitValueChange(val) {
      if (!this.columns || this.columns && val.length === this.store.count) {
        this.$emit('on-change', val);
      }
    }
  },
  data: function data() {
    return {
      scroller: [],
      count: 0,
      uuid: '',
      currentData: this.data,
      currentValue: this.value
    };
  },

  watch: {
    value: function value(val) {
      if (stringify_default()(val) !== stringify_default()(this.currentValue)) {
        this.currentValue = val;
      }
    },
    currentValue: function currentValue(val, oldVal) {
      this.$emit('input', val);
      // render all the scroller for chain datas
      if (this.columns !== 0) {
        if (val.length > 0) {
          if (stringify_default()(val) !== stringify_default()(oldVal)) {
            this.currentData = this.store.getColumns(val);
            this.$nextTick(function () {
              this.render(this.currentData, val);
            });
          }
        }
      } else {
        if (val.length) {
          for (var i = 0; i < val.length; i++) {
            if (this.scroller[i] && this.scroller[i].value !== val[i]) {
              this.scroller[i].select(val[i]);
            }
          }
        } else {
          this.render(this.currentData, []);
        }
      }
    },
    data: function data(val) {
      if (stringify_default()(val) !== stringify_default()(this.currentData)) {
        this.currentData = val;
      }
    },
    currentData: function currentData(newData) {
      var _this3 = this;

      if (Object.prototype.toString.call(newData[0]) === '[object Array]') {
        this.$nextTick(function () {
          _this3.render(newData, _this3.currentValue);
          // emit on-change after rerender
          _this3.$nextTick(function () {
            _this3.emitValueChange(_this3.getValue());

            if (stringify_default()(_this3.getValue()) !== stringify_default()(_this3.currentValue)) {
              if (!_this3.columns || _this3.columns && _this3.getValue().length === _this3.store.count) {
                _this3.currentValue = _this3.getValue();
              }
            }
          });
        });
      } else {
        if (this.columns !== 0) {
          if (!newData.length) {
            return;
          }
          var length = this.columns;
          this.store = new chain["a" /* default */](newData, length, this.fixedColumns || this.columns);
          this.currentData = this.store.getColumns(this.currentValue);
        }
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    for (var i = 0; i < this.count; i++) {
      this.scroller[i] && this.scroller[i].destroy();
      this.scroller[i] = null;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/picker/index.vue


//
//
//
//
//
//
//
//
//
//







/* harmony default export */ var components_picker = ({
  name: 'picker',
  components: {
    Flexbox: flexbox["a" /* Flexbox */],
    FlexboxItem: flexbox["b" /* FlexboxItem */]
  },
  created: function created() {
    if (this.columns !== 0) {
      var length = this.columns;
      this.store = new chain["a" /* default */](this.data, length, this.fixedColumns || this.columns);
      this.currentData = this.store.getColumns(this.value);
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    this.uuid = Math.random().toString(36).substring(3, 8);
    this.$nextTick(function () {
      _this2.render(_this2.currentData, _this2.currentValue);
    });
  },

  props: {
    data: Array,
    columns: {
      type: Number,
      default: 0
    },
    fixedColumns: {
      type: Number,
      default: 0
    },
    value: Array,
    itemClass: {
      type: String,
      default: 'scroller-item'
    },
    columnWidth: Array
  },
  methods: {
    getNameValues: function getNameValues() {
      return Object(value2name["a" /* default */])(this.currentValue, this.data);
    },
    getId: function getId(i) {
      return '#vux-picker-' + this.uuid + '-' + i;
    },
    render: function render(data, value) {
      this.count = this.currentData.length;
      var _this = this;
      if (!data || !data.length) {
        return;
      }
      var count = this.currentData.length;
      // set first item as value
      if (value.length < count) {
        for (var i = 0; i < count; i++) {
          if (false) {
            console.error('[VUX error] 渲染出错，如果为联动模式，需要指定 columns(列数)');
          }
          this.$set(_this.currentValue, i, data[i][0].value || data[i][0]);
        }
      }

      var _loop = function _loop(_i) {
        /**
        * Still don't know why this happens
        */
        if (!document.querySelector(_this.getId(_i))) {
          return {
            v: void 0
          };
        }

        _this.scroller[_i] && _this.scroller[_i].destroy();
        _this.scroller[_i] = new scroller["a" /* default */](_this.getId(_i), {
          data: data[_i],
          defaultValue: value[_i] || data[_i][0].value,
          itemClass: _this.itemClass,
          onSelect: function onSelect(value) {
            _this.$set(_this.currentValue, _i, value);
            if (!this.columns || this.columns && _this.getValue().length === _this.store.count) {
              _this.$nextTick(function () {
                _this.$emit('on-change', _this.getValue());
              });
            }
            if (_this.columns !== 0) {
              _this.renderChain(_i + 1);
            }
          }
        });
        if (_this.currentValue) {
          _this.scroller[_i].select(value[_i]);
        }
      };

      for (var _i = 0; _i < data.length; _i++) {
        var _ret = _loop(_i);

        if ((typeof _ret === 'undefined' ? 'undefined' : typeof_default()(_ret)) === "object") return _ret.v;
      }
    },
    renderChain: function renderChain(i) {
      if (!this.columns) {
        return;
      }

      // do not render for last scroller
      if (i > this.count - 1) {
        return;
      }

      var _this = this;
      var ID = this.getId(i);
      // destroy old one
      this.scroller[i].destroy();
      var list = this.store.getChildren(_this.getValue()[i - 1]);
      this.scroller[i] = new scroller["a" /* default */](ID, {
        data: list,
        itemClass: _this.item_class,
        onSelect: function onSelect(value) {
          _this.$set(_this.currentValue, i, value);
          _this.$nextTick(function () {
            _this.$emit('on-change', _this.getValue());
          });
          _this.renderChain(i + 1);
        }
      });
      // list is Array(empty) as maybe
      if (list.length) {
        this.$set(this.currentValue, i, list[0].value);
        this.renderChain(i + 1);
      } else {
        this.$set(this.currentValue, i, null);
      }
    },
    getValue: function getValue() {
      var data = [];
      for (var i = 0; i < this.currentData.length; i++) {
        if (this.scroller[i]) {
          data.push(this.scroller[i].value);
        } else {
          return [];
        }
      }
      return data;
    },
    emitValueChange: function emitValueChange(val) {
      if (!this.columns || this.columns && val.length === this.store.count) {
        this.$emit('on-change', val);
      }
    }
  },
  data: function data() {
    return {
      scroller: [],
      count: 0,
      uuid: '',
      currentData: this.data,
      currentValue: this.value
    };
  },

  watch: {
    value: function value(val) {
      if (stringify_default()(val) !== stringify_default()(this.currentValue)) {
        this.currentValue = val;
      }
    },
    currentValue: function currentValue(val, oldVal) {
      this.$emit('input', val);
      // render all the scroller for chain datas
      if (this.columns !== 0) {
        if (val.length > 0) {
          if (stringify_default()(val) !== stringify_default()(oldVal)) {
            this.currentData = this.store.getColumns(val);
            this.$nextTick(function () {
              this.render(this.currentData, val);
            });
          }
        }
      } else {
        if (val.length) {
          for (var i = 0; i < val.length; i++) {
            if (this.scroller[i] && this.scroller[i].value !== val[i]) {
              this.scroller[i].select(val[i]);
            }
          }
        } else {
          this.render(this.currentData, []);
        }
      }
    },
    data: function data(val) {
      if (stringify_default()(val) !== stringify_default()(this.currentData)) {
        this.currentData = val;
      }
    },
    currentData: function currentData(newData) {
      var _this3 = this;

      if (Object.prototype.toString.call(newData[0]) === '[object Array]') {
        this.$nextTick(function () {
          _this3.render(newData, _this3.currentValue);
          // emit on-change after rerender
          _this3.$nextTick(function () {
            _this3.emitValueChange(_this3.getValue());

            if (stringify_default()(_this3.getValue()) !== stringify_default()(_this3.currentValue)) {
              if (!_this3.columns || _this3.columns && _this3.getValue().length === _this3.store.count) {
                _this3.currentValue = _this3.getValue();
              }
            }
          });
        });
      } else {
        if (this.columns !== 0) {
          if (!newData.length) {
            return;
          }
          var length = this.columns;
          this.store = new chain["a" /* default */](newData, length, this.fixedColumns || this.columns);
          this.currentData = this.store.getColumns(this.currentValue);
        }
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    for (var i = 0; i < this.count; i++) {
      this.scroller[i] && this.scroller[i].destroy();
      this.scroller[i] = null;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-589c23ef","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/picker/index.vue
var picker_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-picker"},[_c('flexbox',{attrs:{"gutter":0}},_vm._l((_vm.currentData),function(one,index){return _c('flexbox-item',{key:index,staticStyle:{"margin-left":"0"},attrs:{"span":_vm.columnWidth && _vm.columnWidth[index]}},[_c('div',{staticClass:"vux-picker-item",attrs:{"id":("vux-picker-" + _vm.uuid + "-" + index)}})])}),1)],1)}
var picker_staticRenderFns = []
var picker_esExports = { render: picker_render, staticRenderFns: picker_staticRenderFns }
/* harmony default export */ var src_components_picker = (picker_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/picker/index.vue
function picker_injectStyle (ssrContext) {
  __webpack_require__("iHWY")
}
var picker_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var picker___vue_template_functional__ = false
/* styles */
var picker___vue_styles__ = picker_injectStyle
/* scopeId */
var picker___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var picker___vue_module_identifier__ = null
var picker_Component = picker_normalizeComponent(
  components_picker,
  src_components_picker,
  picker___vue_template_functional__,
  picker___vue_styles__,
  picker___vue_scopeId__,
  picker___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_picker = (picker_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/popup-header/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var popup_header = ({
  name: 'popup-header',
  props: {
    leftText: String,
    rightText: String,
    title: String,
    showBottomBorder: {
      type: Boolean,
      default: true
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/popup-header/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var components_popup_header = ({
  name: 'popup-header',
  props: {
    leftText: String,
    rightText: String,
    title: String,
    showBottomBorder: {
      type: Boolean,
      default: true
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d5bfd958","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/popup-header/index.vue
var popup_header_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-popup-header",class:_vm.showBottomBorder ? 'vux-1px-b' : ''},[_c('div',{staticClass:"vux-popup-header-left",on:{"click":function($event){return _vm.$emit('on-click-left')}}},[_vm._t("left-text",[_vm._v(_vm._s(_vm.leftText))])],2),_vm._v(" "),_c('div',{staticClass:"vux-popup-header-title"},[_vm._t("title",[_vm._v(_vm._s(_vm.title))])],2),_vm._v(" "),_c('div',{staticClass:"vux-popup-header-right",on:{"click":function($event){return _vm.$emit('on-click-right')}}},[_vm._t("right-text",[_vm._v(_vm._s(_vm.rightText))])],2)])}
var popup_header_staticRenderFns = []
var popup_header_esExports = { render: popup_header_render, staticRenderFns: popup_header_staticRenderFns }
/* harmony default export */ var src_components_popup_header = (popup_header_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/popup-header/index.vue
function popup_header_injectStyle (ssrContext) {
  __webpack_require__("LzMh")
}
var popup_header_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var popup_header___vue_template_functional__ = false
/* styles */
var popup_header___vue_styles__ = popup_header_injectStyle
/* scopeId */
var popup_header___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var popup_header___vue_module_identifier__ = null
var popup_header_Component = popup_header_normalizeComponent(
  components_popup_header,
  src_components_popup_header,
  popup_header___vue_template_functional__,
  popup_header___vue_styles__,
  popup_header___vue_scopeId__,
  popup_header___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_popup_header = (popup_header_Component.exports);

// EXTERNAL MODULE: ./node_modules/vux/src/filters/array2String.js
var array2String = __webpack_require__("LsKW");

// EXTERNAL MODULE: ./node_modules/vux/src/libs/mixin_uuid.js
var mixin_uuid = __webpack_require__("OFgA");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/popup-picker/index.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//












var popup_picker_getObject = function getObject(obj) {
  return JSON.parse(stringify_default()(obj));
};

/* harmony default export */ var popup_picker = ({
  name: 'popup-picker',
  directives: {
    TransferDom: transfer_dom["a" /* default */]
  },
  created: function created() {
    if (typeof this.show !== 'undefined') {
      this.showValue = this.show;
    }
  },

  mixins: [mixin_uuid["a" /* default */]],
  components: {
    Picker: vux_src_components_picker,
    Cell: vux_src_components_cell,
    Popup: node_modules_vux_src_components_popup,
    PopupHeader: vux_src_components_popup_header,
    Flexbox: flexbox["a" /* Flexbox */],
    FlexboxItem: flexbox["b" /* FlexboxItem */],
    InlineDesc: vux_src_components_inline_desc
  },
  filters: {
    array2string: array2String["a" /* default */],
    value2name: value2name["a" /* default */]
  },
  props: {
    valueTextAlign: {
      type: String,
      default: 'right'
    },
    title: String,
    cancelText: String,
    confirmText: String,
    data: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    placeholder: String,
    columns: {
      type: Number,
      default: 0
    },
    fixedColumns: {
      type: Number,
      default: 0
    },
    value: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    showName: Boolean,
    inlineDesc: [String, Number, Array, Object, Boolean],
    showCell: {
      type: Boolean,
      default: true
    },
    show: Boolean,
    displayFormat: Function,
    isTransferDom: {
      type: Boolean,
      default: true
    },
    columnWidth: Array,
    popupStyle: Object,
    popupTitle: String,
    disabled: Boolean
  },
  computed: {
    labelStyles: function labelStyles() {
      return {
        display: 'block',
        width: this.$parent && (this.$parent.labelWidth || this.$parent.$parent.labelWidth) || 'auto',
        textAlign: this.$parent && (this.$parent.labelAlign || this.$parent.$parent.labelAlign),
        marginRight: this.$parent && (this.$parent.labelMarginRight || this.$parent.$parent.labelMarginRight)
      };
    },
    labelClass: function labelClass() {
      return {
        'vux-cell-justify': this.$parent && (this.$parent.labelAlign === 'justify' || this.$parent.$parent.labelAlign === 'justify')
      };
    }
  },
  methods: {
    value2name: value2name["a" /* default */],
    getNameValues: function getNameValues() {
      return Object(value2name["a" /* default */])(this.currentValue, this.data);
    },
    onClick: function onClick() {
      if (!this.disabled) {
        this.showValue = true;
      }
    },
    onHide: function onHide(type) {
      this.showValue = false;
      if (type) {
        this.closeType = true;
        this.currentValue = popup_picker_getObject(this.tempValue);
      }
      if (!type) {
        this.closeType = false;
        if (this.value.length > 0) {
          this.tempValue = popup_picker_getObject(this.currentValue);
        }
      }
    },
    onPopupShow: function onPopupShow() {
      // reset close type to false
      this.closeType = false;
      this.$emit('on-show');
    },
    onPopupHide: function onPopupHide(val) {
      if (this.value.length > 0) {
        this.tempValue = popup_picker_getObject(this.currentValue);
      }
      this.$emit('on-hide', this.closeType);
    },
    onPickerChange: function onPickerChange(val) {
      if (stringify_default()(this.currentValue) !== stringify_default()(val)) {
        // if has value, replace it
        if (this.value.length) {
          var nowData = stringify_default()(this.data);
          if (nowData !== this.currentData && this.currentData !== '[]') {
            this.tempValue = popup_picker_getObject(val);
          }
          this.currentData = nowData;
        } else {// if no value, stay quiet
          // if set to auto update, do update the value
        }
      }
      var _val = popup_picker_getObject(val);
      this.$emit('on-shadow-change', _val, Object(value2name["a" /* default */])(_val, this.data).split(' '));
    }
  },
  watch: {
    value: function value(val) {
      if (stringify_default()(val) !== stringify_default()(this.tempValue)) {
        this.tempValue = popup_picker_getObject(val);
        this.currentValue = popup_picker_getObject(val);
      }
    },
    currentValue: function currentValue(val) {
      this.$emit('input', popup_picker_getObject(val));
      this.$emit('on-change', popup_picker_getObject(val));
    },
    show: function show(val) {
      this.showValue = val;
    },
    showValue: function showValue(val) {
      this.$emit('update:show', val);
    }
  },
  data: function data() {
    return {
      onShowProcess: false,
      tempValue: popup_picker_getObject(this.value),
      closeType: false,
      currentData: stringify_default()(this.data), // used for detecting if it is after data change
      showValue: false,
      currentValue: this.value
    };
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/popup-picker/index.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//












var components_popup_picker_getObject = function getObject(obj) {
  return JSON.parse(stringify_default()(obj));
};

/* harmony default export */ var components_popup_picker = ({
  name: 'popup-picker',
  directives: {
    TransferDom: transfer_dom["a" /* default */]
  },
  created: function created() {
    if (typeof this.show !== 'undefined') {
      this.showValue = this.show;
    }
  },

  mixins: [mixin_uuid["a" /* default */]],
  components: {
    Picker: vux_src_components_picker,
    Cell: vux_src_components_cell,
    Popup: node_modules_vux_src_components_popup,
    PopupHeader: vux_src_components_popup_header,
    Flexbox: flexbox["a" /* Flexbox */],
    FlexboxItem: flexbox["b" /* FlexboxItem */],
    InlineDesc: vux_src_components_inline_desc
  },
  filters: {
    array2string: array2String["a" /* default */],
    value2name: value2name["a" /* default */]
  },
  props: {
    valueTextAlign: {
      type: String,
      default: 'right'
    },
    title: String,
    cancelText: String,
    confirmText: String,
    data: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    placeholder: String,
    columns: {
      type: Number,
      default: 0
    },
    fixedColumns: {
      type: Number,
      default: 0
    },
    value: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    showName: Boolean,
    inlineDesc: [String, Number, Array, Object, Boolean],
    showCell: {
      type: Boolean,
      default: true
    },
    show: Boolean,
    displayFormat: Function,
    isTransferDom: {
      type: Boolean,
      default: true
    },
    columnWidth: Array,
    popupStyle: Object,
    popupTitle: String,
    disabled: Boolean
  },
  computed: {
    labelStyles: function labelStyles() {
      return {
        display: 'block',
        width: this.$parent && (this.$parent.labelWidth || this.$parent.$parent.labelWidth) || 'auto',
        textAlign: this.$parent && (this.$parent.labelAlign || this.$parent.$parent.labelAlign),
        marginRight: this.$parent && (this.$parent.labelMarginRight || this.$parent.$parent.labelMarginRight)
      };
    },
    labelClass: function labelClass() {
      return {
        'vux-cell-justify': this.$parent && (this.$parent.labelAlign === 'justify' || this.$parent.$parent.labelAlign === 'justify')
      };
    }
  },
  methods: {
    value2name: value2name["a" /* default */],
    getNameValues: function getNameValues() {
      return Object(value2name["a" /* default */])(this.currentValue, this.data);
    },
    onClick: function onClick() {
      if (!this.disabled) {
        this.showValue = true;
      }
    },
    onHide: function onHide(type) {
      this.showValue = false;
      if (type) {
        this.closeType = true;
        this.currentValue = components_popup_picker_getObject(this.tempValue);
      }
      if (!type) {
        this.closeType = false;
        if (this.value.length > 0) {
          this.tempValue = components_popup_picker_getObject(this.currentValue);
        }
      }
    },
    onPopupShow: function onPopupShow() {
      // reset close type to false
      this.closeType = false;
      this.$emit('on-show');
    },
    onPopupHide: function onPopupHide(val) {
      if (this.value.length > 0) {
        this.tempValue = components_popup_picker_getObject(this.currentValue);
      }
      this.$emit('on-hide', this.closeType);
    },
    onPickerChange: function onPickerChange(val) {
      if (stringify_default()(this.currentValue) !== stringify_default()(val)) {
        // if has value, replace it
        if (this.value.length) {
          var nowData = stringify_default()(this.data);
          if (nowData !== this.currentData && this.currentData !== '[]') {
            this.tempValue = components_popup_picker_getObject(val);
          }
          this.currentData = nowData;
        } else {// if no value, stay quiet
          // if set to auto update, do update the value
        }
      }
      var _val = components_popup_picker_getObject(val);
      this.$emit('on-shadow-change', _val, Object(value2name["a" /* default */])(_val, this.data).split(' '));
    }
  },
  watch: {
    value: function value(val) {
      if (stringify_default()(val) !== stringify_default()(this.tempValue)) {
        this.tempValue = components_popup_picker_getObject(val);
        this.currentValue = components_popup_picker_getObject(val);
      }
    },
    currentValue: function currentValue(val) {
      this.$emit('input', components_popup_picker_getObject(val));
      this.$emit('on-change', components_popup_picker_getObject(val));
    },
    show: function show(val) {
      this.showValue = val;
    },
    showValue: function showValue(val) {
      this.$emit('update:show', val);
    }
  },
  data: function data() {
    return {
      onShowProcess: false,
      tempValue: components_popup_picker_getObject(this.value),
      closeType: false,
      currentData: stringify_default()(this.data), // used for detecting if it is after data change
      showValue: false,
      currentValue: this.value
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-49a333ce","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/popup-picker/index.vue
var popup_picker_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-cell-box"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showCell),expression:"showCell"}],staticClass:"weui-cell vux-tap-active",class:{'weui-cell_access': !_vm.disabled},on:{"click":_vm.onClick}},[_c('div',{staticClass:"weui-cell__hd"},[_vm._t("title",[(_vm.title)?_c('label',{staticClass:"weui-label",class:_vm.labelClass,style:(_vm.labelStyles),domProps:{"innerHTML":_vm._s(_vm.title)}}):_vm._e()],{"labelClass":"weui-label","labelStyle":_vm.labelStyles,"labelTitle":_vm.title}),_vm._v(" "),(_vm.inlineDesc)?_c('inline-desc',[_vm._v(_vm._s(_vm.inlineDesc))]):_vm._e()],2),_vm._v(" "),_c('div',{staticClass:"vux-cell-primary vux-popup-picker-select-box"},[_c('div',{staticClass:"vux-popup-picker-select",style:({textAlign: _vm.valueTextAlign})},[(!_vm.displayFormat && !_vm.showName && _vm.value.length)?_c('span',{staticClass:"vux-popup-picker-value vux-cell-value"},[_vm._v(_vm._s(_vm._f("array2string")(_vm.value)))]):_vm._e(),_vm._v(" "),(!_vm.displayFormat && _vm.showName && _vm.value.length)?_c('span',{staticClass:"vux-popup-picker-value vux-cell-value"},[_vm._v(_vm._s(_vm._f("value2name")(_vm.value,_vm.data)))]):_vm._e(),_vm._v(" "),(_vm.displayFormat && _vm.value.length)?_c('span',{staticClass:"vux-popup-picker-value vux-cell-value"},[_vm._v(_vm._s(_vm.displayFormat(_vm.value, _vm.value2name(_vm.value, _vm.data))))]):_vm._e(),_vm._v(" "),(!_vm.value.length && _vm.placeholder)?_c('span',{staticClass:"vux-popup-picker-placeholder vux-cell-placeholder",domProps:{"textContent":_vm._s(_vm.placeholder)}}):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"weui-cell__ft"})]),_vm._v(" "),_c('div',{directives:[{name:"transfer-dom",rawName:"v-transfer-dom",value:(_vm.isTransferDom),expression:"isTransferDom"}]},[_c('popup',{staticClass:"vux-popup-picker",attrs:{"id":("vux-popup-picker-" + _vm.uuid),"popup-style":_vm.popupStyle},on:{"on-hide":_vm.onPopupHide,"on-show":_vm.onPopupShow},model:{value:(_vm.showValue),callback:function ($$v) {_vm.showValue=$$v},expression:"showValue"}},[_c('div',{staticClass:"vux-popup-picker-container"},[_c('popup-header',{attrs:{"left-text":_vm.cancelText || '取消',"right-text":_vm.confirmText || '完成',"title":_vm.popupTitle},on:{"on-click-left":function($event){return _vm.onHide(false)},"on-click-right":function($event){return _vm.onHide(true)}}}),_vm._v(" "),_c('picker',{attrs:{"data":_vm.data,"columns":_vm.columns,"fixed-columns":_vm.fixedColumns,"container":'#vux-popup-picker-'+_vm.uuid,"column-width":_vm.columnWidth},on:{"on-change":_vm.onPickerChange},model:{value:(_vm.tempValue),callback:function ($$v) {_vm.tempValue=$$v},expression:"tempValue"}})],1)])],1)])}
var popup_picker_staticRenderFns = []
var popup_picker_esExports = { render: popup_picker_render, staticRenderFns: popup_picker_staticRenderFns }
/* harmony default export */ var src_components_popup_picker = (popup_picker_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/popup-picker/index.vue
function popup_picker_injectStyle (ssrContext) {
  __webpack_require__("ckkX")
}
var popup_picker_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var popup_picker___vue_template_functional__ = false
/* styles */
var popup_picker___vue_styles__ = popup_picker_injectStyle
/* scopeId */
var popup_picker___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var popup_picker___vue_module_identifier__ = null
var popup_picker_Component = popup_picker_normalizeComponent(
  components_popup_picker,
  src_components_popup_picker,
  popup_picker___vue_template_functional__,
  popup_picker___vue_styles__,
  popup_picker___vue_scopeId__,
  popup_picker___vue_module_identifier__
)


/* harmony default export */ var vux_src_components_popup_picker = (popup_picker_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/checker/checker.vue
//
//
//
//
//
//

/* harmony default export */ var checker = ({
  name: 'checker',
  props: {
    defaultItemClass: String,
    selectedItemClass: String,
    disabledItemClass: String,
    type: {
      type: String,
      default: 'radio'
    },
    value: [String, Number, Array, Object],
    max: Number,
    radioRequired: Boolean
  },
  watch: {
    value: function value(newValue) {
      this.currentValue = newValue;
    },
    currentValue: function currentValue(val) {
      this.$emit('input', val);
      this.$emit('on-change', val);
    }
  },
  data: function data() {
    return {
      currentValue: this.value
    };
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/checker/checker.vue
//
//
//
//
//
//

/* harmony default export */ var checker_checker = ({
  name: 'checker',
  props: {
    defaultItemClass: String,
    selectedItemClass: String,
    disabledItemClass: String,
    type: {
      type: String,
      default: 'radio'
    },
    value: [String, Number, Array, Object],
    max: Number,
    radioRequired: Boolean
  },
  watch: {
    value: function value(newValue) {
      this.currentValue = newValue;
    },
    currentValue: function currentValue(val) {
      this.$emit('input', val);
      this.$emit('on-change', val);
    }
  },
  data: function data() {
    return {
      currentValue: this.value
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a5c9f890","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/checker/checker.vue
var checker_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-checker-box"},[_vm._t("default")],2)}
var checker_staticRenderFns = []
var checker_esExports = { render: checker_render, staticRenderFns: checker_staticRenderFns }
/* harmony default export */ var components_checker_checker = (checker_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/checker/checker.vue
function checker_injectStyle (ssrContext) {
  __webpack_require__("Q0eu")
}
var checker_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var checker___vue_template_functional__ = false
/* styles */
var checker___vue_styles__ = checker_injectStyle
/* scopeId */
var checker___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var checker___vue_module_identifier__ = null
var checker_Component = checker_normalizeComponent(
  checker_checker,
  components_checker_checker,
  checker___vue_template_functional__,
  checker___vue_styles__,
  checker___vue_scopeId__,
  checker___vue_module_identifier__
)

/* harmony default export */ var src_components_checker_checker = (checker_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/checker/checker-item.vue


//
//
//
//
//
//

/* harmony default export */ var checker_item = ({
  name: 'checker-item',
  props: {
    value: {
      type: [String, Number, Object],
      required: true
    },
    disabled: Boolean
  },
  watch: {
    disabled: function disabled(val) {
      if (val && this.$parent.type === 'radio' && this.value === this.$parent.currentValue) {
        this.$parent.currentValue = '';
      }
    }
  },
  computed: {
    classNames: function classNames() {
      var _this = this;

      var isSimpleValue = typeof this.value === 'string' || typeof this.value === 'number';
      var names = {
        'vux-tap-active': !this.disabled
      };

      if (this.$parent.defaultItemClass) {
        names[this.$parent.defaultItemClass] = true;
      }

      if (this.$parent.selectedItemClass) {
        var selected = false;
        if (this.$parent.type === 'radio') {
          if (isSimpleValue && this.$parent.currentValue === this.value) {
            selected = true;
          } else if (typeof_default()(this.value) === 'object' && isEqual(this.$parent.currentValue, this.value)) {
            selected = true;
          }
        } else {
          if (typeof this.value === 'string') {
            if (this.$parent.currentValue.indexOf(this.value) > -1) {
              selected = true;
            }
          } else if (this.$parent.currentValue && this.$parent.currentValue.length) {
            var match = this.$parent.currentValue.filter(function (one) {
              return isEqual(one, _this.value);
            });
            selected = match.length > 0;
          }
        }
        names[this.$parent.selectedItemClass] = selected;
      }

      if (this.$parent.disabledItemClass) {
        names[this.$parent.disabledItemClass] = this.disabled;
      }

      return names;
    }
  },
  methods: {
    select: function select() {
      if (this.$parent.type === 'radio') {
        this.selectRadio();
      } else {
        this.selectCheckbox();
      }
    },
    selectRadio: function selectRadio() {
      if (!this.disabled) {
        if (this.$parent.currentValue === this.value) {
          if (!this.$parent.radioRequired) {
            this.$parent.currentValue = '';
          }
        } else {
          this.$parent.currentValue = this.value;
        }
      }
      this.$emit('on-item-click', this.value, this.disabled);
    },
    selectCheckbox: function selectCheckbox() {
      if (!this.$parent.currentValue || this.$parent.currentValue === null) {
        this.$parent.currentValue = [];
      }
      var isSimpleValue = typeof this.value === 'string' || typeof this.value === 'number';
      if (!this.disabled) {
        var index = -1;
        if (isSimpleValue) {
          index = this.$parent.currentValue.indexOf(this.value);
        } else {
          index = this.$parent.currentValue.map(function (one) {
            return stringify_default()(one);
          }).indexOf(stringify_default()(this.value));
        }
        if (index > -1) {
          this.$parent.currentValue.splice(index, 1);
        } else {
          if (!this.$parent.max || this.$parent.max && this.$parent.currentValue !== null && this.$parent.currentValue.length < this.$parent.max) {
            if (!this.$parent.currentValue || !this.$parent.currentValue.length) {
              this.$parent.currentValue = [];
            }
            this.$parent.currentValue.push(this.value);
          }
        }
      }
      this.$emit('on-item-click', this.value, this.disabled);
    }
  }
});

function isEqual(obj1, obj2) {
  return stringify_default()(obj1) === stringify_default()(obj2);
}
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/checker/checker-item.vue


//
//
//
//
//
//

/* harmony default export */ var checker_checker_item = ({
  name: 'checker-item',
  props: {
    value: {
      type: [String, Number, Object],
      required: true
    },
    disabled: Boolean
  },
  watch: {
    disabled: function disabled(val) {
      if (val && this.$parent.type === 'radio' && this.value === this.$parent.currentValue) {
        this.$parent.currentValue = '';
      }
    }
  },
  computed: {
    classNames: function classNames() {
      var _this = this;

      var isSimpleValue = typeof this.value === 'string' || typeof this.value === 'number';
      var names = {
        'vux-tap-active': !this.disabled
      };

      if (this.$parent.defaultItemClass) {
        names[this.$parent.defaultItemClass] = true;
      }

      if (this.$parent.selectedItemClass) {
        var selected = false;
        if (this.$parent.type === 'radio') {
          if (isSimpleValue && this.$parent.currentValue === this.value) {
            selected = true;
          } else if (typeof_default()(this.value) === 'object' && checker_item_isEqual(this.$parent.currentValue, this.value)) {
            selected = true;
          }
        } else {
          if (typeof this.value === 'string') {
            if (this.$parent.currentValue.indexOf(this.value) > -1) {
              selected = true;
            }
          } else if (this.$parent.currentValue && this.$parent.currentValue.length) {
            var match = this.$parent.currentValue.filter(function (one) {
              return checker_item_isEqual(one, _this.value);
            });
            selected = match.length > 0;
          }
        }
        names[this.$parent.selectedItemClass] = selected;
      }

      if (this.$parent.disabledItemClass) {
        names[this.$parent.disabledItemClass] = this.disabled;
      }

      return names;
    }
  },
  methods: {
    select: function select() {
      if (this.$parent.type === 'radio') {
        this.selectRadio();
      } else {
        this.selectCheckbox();
      }
    },
    selectRadio: function selectRadio() {
      if (!this.disabled) {
        if (this.$parent.currentValue === this.value) {
          if (!this.$parent.radioRequired) {
            this.$parent.currentValue = '';
          }
        } else {
          this.$parent.currentValue = this.value;
        }
      }
      this.$emit('on-item-click', this.value, this.disabled);
    },
    selectCheckbox: function selectCheckbox() {
      if (!this.$parent.currentValue || this.$parent.currentValue === null) {
        this.$parent.currentValue = [];
      }
      var isSimpleValue = typeof this.value === 'string' || typeof this.value === 'number';
      if (!this.disabled) {
        var index = -1;
        if (isSimpleValue) {
          index = this.$parent.currentValue.indexOf(this.value);
        } else {
          index = this.$parent.currentValue.map(function (one) {
            return stringify_default()(one);
          }).indexOf(stringify_default()(this.value));
        }
        if (index > -1) {
          this.$parent.currentValue.splice(index, 1);
        } else {
          if (!this.$parent.max || this.$parent.max && this.$parent.currentValue !== null && this.$parent.currentValue.length < this.$parent.max) {
            if (!this.$parent.currentValue || !this.$parent.currentValue.length) {
              this.$parent.currentValue = [];
            }
            this.$parent.currentValue.push(this.value);
          }
        }
      }
      this.$emit('on-item-click', this.value, this.disabled);
    }
  }
});

function checker_item_isEqual(obj1, obj2) {
  return stringify_default()(obj1) === stringify_default()(obj2);
}
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-dcb1243a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/checker/checker-item.vue
var checker_item_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-checker-item",class:_vm.classNames,on:{"click":_vm.select}},[_vm._t("default")],2)}
var checker_item_staticRenderFns = []
var checker_item_esExports = { render: checker_item_render, staticRenderFns: checker_item_staticRenderFns }
/* harmony default export */ var components_checker_checker_item = (checker_item_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/checker/checker-item.vue
function checker_item_injectStyle (ssrContext) {
  __webpack_require__("KwMT")
}
var checker_item_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var checker_item___vue_template_functional__ = false
/* styles */
var checker_item___vue_styles__ = checker_item_injectStyle
/* scopeId */
var checker_item___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var checker_item___vue_module_identifier__ = null
var checker_item_Component = checker_item_normalizeComponent(
  checker_checker_item,
  components_checker_checker_item,
  checker_item___vue_template_functional__,
  checker_item___vue_styles__,
  checker_item___vue_scopeId__,
  checker_item___vue_module_identifier__
)

/* harmony default export */ var src_components_checker_checker_item = (checker_item_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/yingxin/tskjxy/views/items/info/personalInfo.vue




















/* harmony default export */ var personalInfo = ({
  name: 'info',
  props: [],
  components: {
    'scroller': vuescroll_default.a,
    XHeader: vux_src_components_x_header,
    XInput: vux_src_components_x_input,
    Group: vux_src_components_group,
    XButton: vux_src_components_x_button,
    PopupRadio: vux_src_components_popup_radio,
    Datetime: vux_src_components_datetime,
    PopupPicker: vux_src_components_popup_picker,
    Checker: src_components_checker_checker,
    CheckerItem: src_components_checker_checker_item,
    Cell: vux_src_components_cell
  },
  data: function data() {
    return {
      ops: {
        scrollPanel: {
          scrollingX: false
        },
        bar: {
          background: 'rgba(0, 107, 178, 0.3)',
          size: '3px',
          opacity: 0
        }
      },
      isProfession: false,
      isClass: false,
      professionText: '请选择您的专业',
      classText: '请选择您的班级',
      studentInfo: {
        name: this.$store.state.userInfo.name,
        account: this.$store.state.userInfo.account,
        sno: this.$store.state.userInfo.sno,
        idNumber: this.$store.state.userInfo.idNumber,
        cardId: this.$store.state.userInfo.cardId,
        cardAccount: this.$store.state.userInfo.cardAccount,
        examNumber: this.$store.state.userInfo.examNumber,
        sex: this.$store.state.userInfo.sex,
        birthdate: this.$store.state.userInfo.birthdate,
        countryCode: [this.$store.state.userInfo.countryCode],
        nationCode: [this.$store.state.userInfo.nationCode],
        politicsStatusCode: [this.$store.state.userInfo.politicsStatusCode],
        identityCode: [this.$store.state.userInfo.identityCode],
        campusCode: [this.$store.state.userInfo.campusCode],
        campusName: this.$store.state.userInfo.campusName,
        grade: String(this.$store.state.userInfo.grade),
        academyCode: [this.$store.state.userInfo.academyCode],
        academyName: this.$store.state.userInfo.academyName,
        departmentCode: [this.$store.state.userInfo.departmentCode],
        departmentName: this.$store.state.userInfo.departmentName,
        professionCode: [this.$store.state.userInfo.professionCode],
        professionName: this.$store.state.userInfo.professionName,
        classCode: [this.$store.state.userInfo.classCode],
        className: this.$store.state.userInfo.className,
        originCode: [],
        origin: this.$store.state.userInfo.origin,
        phoneNumber: this.$store.state.userInfo.phoneNumber,
        email: this.$store.state.userInfo.email,
        qq: this.$store.state.userInfo.qq,
        wechat: this.$store.state.userInfo.wechat
      },
      showInfoArr: [],
      value: [],
      grade: [],
      country: [],
      nation: [],
      politicsStatus: [],
      identity: [],
      campus: [],
      academy: [],
      department: [],
      profession: [],
      classes: [],
      origin: [],
      fromItem: {
        baseFeildList: [],
        extendFeildList: [],
        studentExtendFeildList: [],
        baseValueList: [],
        extendValueList: []
      },
      today: Object(date_format["a" /* default */])(new Date(), 'YYYY-MM-DD'),
      year: Object(date_format["a" /* default */])(new Date(), 'YYYY'),
      extendInfo: [],
      departmentDetail: []
    };
  },

  computed: extends_default()({}, Object(vuex_esm["c" /* mapState */])({
    userInfo: function userInfo(state) {
      return state.userInfo;
    },
    flowId: function flowId(state) {
      return state.flowInfo.flowId;
    },
    flowProcedureId: function flowProcedureId(state) {
      return state.currentProcedureInfo.flowProcedureId;
    },
    procedureId: function procedureId(state) {
      return state.currentProcedureInfo.procedureId;
    }
  }), {
    title: function title() {
      return this.$route.meta.title;
    }
  }),
  created: function created() {
    this.getStudent();
    this.getExtendInfo();
    this.getInfoList();
    this.getCountry();
    this.getNation();
    this.getIdentity();
    this.getPoliticsStatus();
    this.getCampus();
    this.getAcademy();
    this.getDepartment();
    this.getProfession(this.studentInfo.departmentCode[0]);
    this.getClass(this.studentInfo.departmentCode[0], this.studentInfo.professionCode[0]);
  },
  mounted: function mounted() {
    var _this = this;

    var originCode = [];
    this.getArea().then(function () {
      var newArr = [];
      var arr = _this.studentInfo.origin ? _this.studentInfo.origin.split(' ') : [];
      var originLen = _this.origin.length;
      for (var i = 0; i < originLen; i++) {
        for (var j = 0; j < arr.length; j++) {
          if (_this.origin[i].name === arr[j]) {
            newArr.push(_this.origin[i]);
          }
        }
      }

      newArr.sort(_this.compare('grade'));
      newArr.forEach(function (element) {
        originCode.push(element.value);
      });
      _this.studentInfo.originCode = originCode;
    });
  },
  updated: function updated() {},
  destroyed: function destroyed() {},

  watch: {},
  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])(['userInfoAction']), {
    compare: function compare(property) {
      return function (a, b) {
        var value1 = a[property];
        var value2 = b[property];
        return value1 - value2;
      };
    },
    back: function back() {
      var _this2 = this;

      setTimeout(function () {
        _this2.$router.back(-1);
      }, 300);
    },
    getStudent: function getStudent() {
      var _this3 = this;

      var params = {
        account: this.userInfo.account
      };
      this.$api.get('/student', params, function (r) {
        var data = r.data[0];
        _this3.$store.dispatch('userInfoAction', data);
      });
    },
    getExtendInfo: function getExtendInfo() {
      var _this4 = this;

      var params = {
        tableName: 'V_USER_STUDENT',
        resourceId: this.userInfo.id
      };
      this.$api.get('/extendInfo', params, function (r) {
        _this4.extendInfo = r.data;
      });
    },
    getInfoList: function getInfoList() {
      var _this5 = this;

      this.$vux.loading.show();
      var params = {
        flowId: this.flowId,
        flowProcedureId: this.flowProcedureId,
        procedureId: this.procedureId
      };
      this.$api.get('/studentInfo/config', params, function (r) {
        _this5.$vux.loading.hide();
        var data = r.data;
        _this5.showInfoArr = data.baseFeildList;
        _this5.fromItem.extendFeildList = data.extendFeildList;
        _this5.fromItem.studentExtendFeildList = data.studentExtendFeildList;

        var extendLen = _this5.extendInfo.length;

        _this5.fromItem.studentExtendFeildList.forEach(function (element) {
          if (extendLen === 0) {
            _this5.$set(element, 'value', '');
          } else {

            for (var i = 0; i < extendLen; i++) {
              if (element.name === _this5.extendInfo[i].tableField) {
                _this5.$set(element, 'value', _this5.extendInfo[i].value);
              }
            }
          }
        });
      }, function (err) {
        _this5.$vux.toast.text(err.message, 'top');
      });
    },
    getName: function getName(value) {},
    changeIdentity: function changeIdentity(value) {
      this.studentInfo.professionCode = [];
      this.studentInfo.classCode = [];
      this.studentInfo.professionName = [];
      this.studentInfo.className = [];
      this.getProfession(this.studentInfo.departmentCode[0]);
      this.getClass(this.studentInfo.departmentCode[0], null);
    },
    changeCampus: function changeCampus(value) {
      this.studentInfo.campusName = this.$refs.campus.getNameValues();
    },
    changeAcademy: function changeAcademy(value) {
      this.studentInfo.academyName = this.$refs.academy.getNameValues();
    },
    changeDepartment: function changeDepartment(value) {
      this.studentInfo.departmentName = this.$refs.department.getNameValues();
      var departmentCode = value[0];
      this.studentInfo.professionCode = [];
      this.studentInfo.classCode = [];
      this.studentInfo.professionName = [];
      this.studentInfo.className = [];
      this.getProfession(departmentCode);
      this.getClass(departmentCode, null);
    },
    changeProfession: function changeProfession(value) {
      this.studentInfo.professionName = this.$refs.profession.getNameValues();
      var professionCode = value[0];
      this.studentInfo.classCode = [];
      this.studentInfo.className = [];
      this.getClass(this.studentInfo.departmentCode[0], professionCode);
    },
    changeClass: function changeClass(value) {
      this.studentInfo.className = this.$refs.classes.getNameValues();
    },
    changeOrigin: function changeOrigin(value) {
      this.studentInfo.origin = this.$refs.origin.getNameValues();
    },
    getCountry: function getCountry() {
      var _this6 = this;

      this.$api.get('/country', null, function (r) {
        var data = r.data;
        var arr = [];
        data.forEach(function (element, i) {
          var obj = {
            name: element.name,
            value: element.code
          };
          arr.push(obj);
        });
        _this6.country.push(arr);
      }, function (err) {
        _this6.$vux.toast.text(err.message, 'top');
      });
    },
    getNation: function getNation() {
      var _this7 = this;

      this.$api.get('/nation', null, function (r) {
        var data = r.data;
        var arr = [];
        data.forEach(function (element, i) {
          var obj = {
            name: element.name,
            value: element.code
          };
          arr.push(obj);
        });
        _this7.nation.push(arr);
      }, function (err) {
        _this7.$vux.toast.text(err.message, 'top');
      });
    },
    getPoliticsStatus: function getPoliticsStatus() {
      var _this8 = this;

      this.$api.get('/politicsStatus', null, function (r) {
        var data = r.data;
        var arr = [];
        data.forEach(function (element, i) {
          var obj = {
            name: element.name,
            value: element.code
          };
          arr.push(obj);
        });
        _this8.politicsStatus.push(arr);
      }, function (err) {
        _this8.$vux.toast.text(err.message, 'top');
      });
    },
    getIdentity: function getIdentity() {
      var _this9 = this;

      this.$api.get('identity', null, function (r) {
        var data = r.data;
        var arr = [];
        data.forEach(function (element, i) {
          var obj = {
            name: element.name,
            value: element.code
          };
          arr.push(obj);
        });
        _this9.identity.push(arr);
      }, function (err) {
        _this9.$vux.toast.text(err.message, 'top');
      });
    },
    getArea: function getArea() {
      var _this10 = this;

      return new promise_default.a(function (resolve, reject) {
        _this10.$api.get('area', null, function (r) {
          var data = r.data;
          data.forEach(function (element, index) {
            if (element.grade !== 1) {
              var obj = {
                name: element.name,
                value: String(element.code),
                grade: element.grade
              };
              if (element.grade === 2) {
                obj.parent = 0;
              } else if (element.grade > 2 && element.grade <= 4) {
                obj.parent = String(element.parentCode);
              }
              _this10.origin.push(obj);
            }
          });
          resolve();
        }, function (err) {
          _this10.$vux.toast.text(err.message, 'top');
        });
      });
    },
    getCampus: function getCampus() {
      var _this11 = this;

      this.$api.get('campus', null, function (r) {
        var data = r.data;
        var arr = [];
        data.forEach(function (element, i) {
          var obj = {
            name: element.name,
            value: element.code
          };
          arr.push(obj);
        });
        _this11.campus.push(arr);
      }, function (err) {
        _this11.$vux.toast.text(err.message, 'top');
      });
    },
    getAcademy: function getAcademy() {
      var _this12 = this;

      var params = {
        type: 2
      };
      this.$api.get('department', params, function (r) {
        var data = r.data;
        var arr = [];
        data.forEach(function (element, i) {
          var obj = {
            name: element.name,
            value: element.code
          };
          arr.push(obj);
        });
        _this12.academy.push(arr);
      }, function (err) {
        _this12.$vux.toast.text(err.message, 'top');
      });
    },
    getDepartment: function getDepartment() {
      var _this13 = this;

      var params = {
        type: 1
      };
      this.$api.get('department', params, function (r) {
        var data = r.data;

        var arr = [];
        data.forEach(function (element, i) {
          var obj = {
            name: element.name,
            value: element.code,
            parent: 0
          };
          arr.push(obj);
        });
        _this13.department.push(arr);
      }, function (err) {
        _this13.$vux.toast.text(err.message, 'top');
      });
    },
    getProfession: function getProfession(code) {
      var _this14 = this;

      var params = {
        departmentCode: code,
        identityCode: this.studentInfo.identityCode[0]
      };
      this.$api.get('profession', params, function (r) {
        var data = r.data;
        if (data.length > 0) {
          _this14.isProfession = false;
          _this14.professionText = '请选择您的专业';
          var arr = [];
          data.forEach(function (element, i) {
            var obj = {
              name: element.name,
              value: element.code,
              parent: element.departmentCode
            };
            arr.push(obj);
          });
          _this14.profession = [];
          _this14.profession.push(arr);
        } else {
          _this14.professionText = '暂无专业';
          _this14.isProfession = true;
          _this14.studentInfo.professionCode = [];
          _this14.studentInfo.professionName = [];
        }
      }, function (err) {
        _this14.$vux.toast.text(err.message, 'top');
      });
    },
    getClass: function getClass(departmentCode, professionCode) {
      var _this15 = this;

      var params = {
        departmentCode: departmentCode,
        professionCode: professionCode
      };
      this.$api.get('class', params, function (r) {
        var data = r.data;
        if (data.length > 0) {
          _this15.isClasss = false;
          _this15.classText = '请选择您的班级';
          var arr = [];
          data.forEach(function (element, i) {
            var obj = {
              name: element.name,
              value: element.code
            };
            arr.push(obj);
          });
          _this15.classes = [];
          _this15.classes.push(arr);
        } else {
          _this15.isClass = true;
          _this15.classes = [];
          _this15.studentInfo.classCode = [];
          _this15.studentInfo.className = [];
          _this15.classText = '暂无班级';
        }
      }, function (err) {
        _this15.$vux.toast.text(err.message, 'top');
      });
    },
    checkWechat: function checkWechat(value) {
      var reg = /^([-_a-zA-Z0-9]{5,19})+$/;
      if (reg.test(value)) {
        return { valid: true };
      } else {
        return { valid: false, msg: '微信格式错误' };
      }
    },
    checkTel: function checkTel(value) {
      var reg = /^([0-9]{3,4}-)?[0-9]{7,8}$/;
      if (reg.test(value)) {
        return { valid: true };
      } else {
        return { valid: false, msg: '联系电话格式错误' };
      }
    },
    save: function save() {
      var _this16 = this;

      var errorLength = document.getElementsByClassName('weui-cell weui-cell_warn').length;
      var defaultObj = {
        id: this.userInfo.id,
        flowId: this.flowId,
        flowProcedureId: this.flowProcedureId,
        procedureId: this.procedureId
      };

      var baseObj = {};

      this.showInfoArr.forEach(function (element) {
        var obj = {};
        if (typeof_default()(_this16.studentInfo[element]) === 'object') {

          obj[element] = _this16.studentInfo[element] === null ? '' : _this16.studentInfo[element][0];
        } else {
          obj[element] = _this16.studentInfo[element];
        }
        var objName = {};
        if (element === 'academyCode') {
          objName = {
            academyName: _this16.studentInfo['academyName']
          };
        } else if (element === 'departmentCode') {
          objName = {
            departmentName: _this16.studentInfo['departmentName']
          };
        } else if (element === 'professionCode') {
          objName = {
            professionName: _this16.studentInfo['professionName']
          };
        } else if (element === 'classCode') {
          objName = {
            className: _this16.studentInfo['className']
          };
        } else if (element === 'campusCode') {
          objName = {
            campusName: _this16.studentInfo['campusName']
          };
        }
        baseObj = assign_default()(baseObj, obj, objName);
      });

      var extendObj = {};
      var extendInfo = [];
      this.fromItem.studentExtendFeildList.forEach(function (element) {
        for (var i = 0; i < _this16.fromItem.extendFeildList.length; i++) {
          var obj = {};
          if (element.name === _this16.fromItem.extendFeildList[i]) {
            obj['code'] = element.name;
            obj['value'] = element.value;
            extendInfo.push(obj);
          }
        }
      });
      var isSubmit = false;
      var valueArr = [];

      for (var j in baseObj) {
        valueArr.push(baseObj[j]);
      }
      for (var i in extendInfo) {
        valueArr.push(extendInfo[i].value);
      }

      if (valueArr.indexOf('') === -1) {
        isSubmit = true;
      }
      extendObj['extendInfo'] = stringify_default()(extendInfo);
      var params = assign_default()(defaultObj, baseObj, extendObj);
      if (errorLength === 0 && isSubmit) {
        this.$vux.loading.show();
        this.$api.post('/studentInfo', params, function (r) {
          _this16.$vux.loading.hide();
          _this16.$vux.toast.show({
            text: '提交成功',
            position: 'middle',
            time: 1000
          });
          _this16.$parent.getStudent();
          _this16.$parent.getExtendInfo();
          _this16.$parent.getFlowProcedureStatus();

          setTimeout(function () {
            _this16.back();
          }, 1000);
        }, function (err) {
          _this16.$vux.toast.text(err.message, 'top');
        });
      } else {
        this.$vux.toast.text('请填写完整的信息', 'middle');
      }
    }
  })
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/yingxin/tskjxy/views/items/info/personalInfo.vue




















/* harmony default export */ var info_personalInfo = ({
  name: 'info',
  props: [],
  components: {
    'scroller': vuescroll_default.a,
    XHeader: vux_src_components_x_header,
    XInput: vux_src_components_x_input,
    Group: vux_src_components_group,
    XButton: vux_src_components_x_button,
    PopupRadio: vux_src_components_popup_radio,
    Datetime: vux_src_components_datetime,
    PopupPicker: vux_src_components_popup_picker,
    Checker: src_components_checker_checker,
    CheckerItem: src_components_checker_checker_item,
    Cell: vux_src_components_cell
  },
  data: function data() {
    return {
      ops: {
        scrollPanel: {
          scrollingX: false
        },
        bar: {
          background: 'rgba(0, 107, 178, 0.3)',
          size: '3px',
          opacity: 0
        }
      },
      isProfession: false,
      isClass: false,
      professionText: '请选择您的专业',
      classText: '请选择您的班级',
      studentInfo: {
        name: this.$store.state.userInfo.name,
        account: this.$store.state.userInfo.account,
        sno: this.$store.state.userInfo.sno,
        idNumber: this.$store.state.userInfo.idNumber,
        cardId: this.$store.state.userInfo.cardId,
        cardAccount: this.$store.state.userInfo.cardAccount,
        examNumber: this.$store.state.userInfo.examNumber,
        sex: this.$store.state.userInfo.sex,
        birthdate: this.$store.state.userInfo.birthdate,
        countryCode: [this.$store.state.userInfo.countryCode],
        nationCode: [this.$store.state.userInfo.nationCode],
        politicsStatusCode: [this.$store.state.userInfo.politicsStatusCode],
        identityCode: [this.$store.state.userInfo.identityCode],
        campusCode: [this.$store.state.userInfo.campusCode],
        campusName: this.$store.state.userInfo.campusName,
        grade: String(this.$store.state.userInfo.grade),
        academyCode: [this.$store.state.userInfo.academyCode],
        academyName: this.$store.state.userInfo.academyName,
        departmentCode: [this.$store.state.userInfo.departmentCode],
        departmentName: this.$store.state.userInfo.departmentName,
        professionCode: [this.$store.state.userInfo.professionCode],
        professionName: this.$store.state.userInfo.professionName,
        classCode: [this.$store.state.userInfo.classCode],
        className: this.$store.state.userInfo.className,
        originCode: [],
        origin: this.$store.state.userInfo.origin,
        phoneNumber: this.$store.state.userInfo.phoneNumber,
        email: this.$store.state.userInfo.email,
        qq: this.$store.state.userInfo.qq,
        wechat: this.$store.state.userInfo.wechat
      },
      showInfoArr: [],
      value: [],
      grade: [],
      country: [],
      nation: [],
      politicsStatus: [],
      identity: [],
      campus: [],
      academy: [],
      department: [],
      profession: [],
      classes: [],
      origin: [],
      fromItem: {
        baseFeildList: [],
        extendFeildList: [],
        studentExtendFeildList: [],
        baseValueList: [],
        extendValueList: []
      },
      today: Object(date_format["a" /* default */])(new Date(), 'YYYY-MM-DD'),
      year: Object(date_format["a" /* default */])(new Date(), 'YYYY'),
      extendInfo: [],
      departmentDetail: []
    };
  },

  computed: extends_default()({}, Object(vuex_esm["c" /* mapState */])({
    userInfo: function userInfo(state) {
      return state.userInfo;
    },
    flowId: function flowId(state) {
      return state.flowInfo.flowId;
    },
    flowProcedureId: function flowProcedureId(state) {
      return state.currentProcedureInfo.flowProcedureId;
    },
    procedureId: function procedureId(state) {
      return state.currentProcedureInfo.procedureId;
    }
  }), {
    title: function title() {
      return this.$route.meta.title;
    }
  }),
  created: function created() {
    this.getStudent();
    this.getExtendInfo();
    this.getInfoList();
    this.getCountry();
    this.getNation();
    this.getIdentity();
    this.getPoliticsStatus();
    this.getCampus();
    this.getAcademy();
    this.getDepartment();
    this.getProfession(this.studentInfo.departmentCode[0]);
    this.getClass(this.studentInfo.departmentCode[0], this.studentInfo.professionCode[0]);
  },
  mounted: function mounted() {
    var _this = this;

    var originCode = [];
    this.getArea().then(function () {
      var newArr = [];
      var arr = _this.studentInfo.origin ? _this.studentInfo.origin.split(' ') : [];
      var originLen = _this.origin.length;
      for (var i = 0; i < originLen; i++) {
        for (var j = 0; j < arr.length; j++) {
          if (_this.origin[i].name === arr[j]) {
            newArr.push(_this.origin[i]);
          }
        }
      }

      newArr.sort(_this.compare('grade'));
      newArr.forEach(function (element) {
        originCode.push(element.value);
      });
      _this.studentInfo.originCode = originCode;
    });
  },
  updated: function updated() {},
  destroyed: function destroyed() {},

  watch: {},
  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])(['userInfoAction']), {
    compare: function compare(property) {
      return function (a, b) {
        var value1 = a[property];
        var value2 = b[property];
        return value1 - value2;
      };
    },
    back: function back() {
      var _this2 = this;

      setTimeout(function () {
        _this2.$router.back(-1);
      }, 300);
    },
    getStudent: function getStudent() {
      var _this3 = this;

      var params = {
        account: this.userInfo.account
      };
      this.$api.get('/student', params, function (r) {
        var data = r.data[0];
        _this3.$store.dispatch('userInfoAction', data);
      });
    },
    getExtendInfo: function getExtendInfo() {
      var _this4 = this;

      var params = {
        tableName: 'V_USER_STUDENT',
        resourceId: this.userInfo.id
      };
      this.$api.get('/extendInfo', params, function (r) {
        _this4.extendInfo = r.data;
      });
    },
    getInfoList: function getInfoList() {
      var _this5 = this;

      this.$vux.loading.show();
      var params = {
        flowId: this.flowId,
        flowProcedureId: this.flowProcedureId,
        procedureId: this.procedureId
      };
      this.$api.get('/studentInfo/config', params, function (r) {
        _this5.$vux.loading.hide();
        var data = r.data;
        _this5.showInfoArr = data.baseFeildList;
        _this5.fromItem.extendFeildList = data.extendFeildList;
        _this5.fromItem.studentExtendFeildList = data.studentExtendFeildList;

        var extendLen = _this5.extendInfo.length;

        _this5.fromItem.studentExtendFeildList.forEach(function (element) {
          if (extendLen === 0) {
            _this5.$set(element, 'value', '');
          } else {

            for (var i = 0; i < extendLen; i++) {
              if (element.name === _this5.extendInfo[i].tableField) {
                _this5.$set(element, 'value', _this5.extendInfo[i].value);
              }
            }
          }
        });
      }, function (err) {
        _this5.$vux.toast.text(err.message, 'top');
      });
    },
    getName: function getName(value) {},
    changeIdentity: function changeIdentity(value) {
      this.studentInfo.professionCode = [];
      this.studentInfo.classCode = [];
      this.studentInfo.professionName = [];
      this.studentInfo.className = [];
      this.getProfession(this.studentInfo.departmentCode[0]);
      this.getClass(this.studentInfo.departmentCode[0], null);
    },
    changeCampus: function changeCampus(value) {
      this.studentInfo.campusName = this.$refs.campus.getNameValues();
    },
    changeAcademy: function changeAcademy(value) {
      this.studentInfo.academyName = this.$refs.academy.getNameValues();
    },
    changeDepartment: function changeDepartment(value) {
      this.studentInfo.departmentName = this.$refs.department.getNameValues();
      var departmentCode = value[0];
      this.studentInfo.professionCode = [];
      this.studentInfo.classCode = [];
      this.studentInfo.professionName = [];
      this.studentInfo.className = [];
      this.getProfession(departmentCode);
      this.getClass(departmentCode, null);
    },
    changeProfession: function changeProfession(value) {
      this.studentInfo.professionName = this.$refs.profession.getNameValues();
      var professionCode = value[0];
      this.studentInfo.classCode = [];
      this.studentInfo.className = [];
      this.getClass(this.studentInfo.departmentCode[0], professionCode);
    },
    changeClass: function changeClass(value) {
      this.studentInfo.className = this.$refs.classes.getNameValues();
    },
    changeOrigin: function changeOrigin(value) {
      this.studentInfo.origin = this.$refs.origin.getNameValues();
    },
    getCountry: function getCountry() {
      var _this6 = this;

      this.$api.get('/country', null, function (r) {
        var data = r.data;
        var arr = [];
        data.forEach(function (element, i) {
          var obj = {
            name: element.name,
            value: element.code
          };
          arr.push(obj);
        });
        _this6.country.push(arr);
      }, function (err) {
        _this6.$vux.toast.text(err.message, 'top');
      });
    },
    getNation: function getNation() {
      var _this7 = this;

      this.$api.get('/nation', null, function (r) {
        var data = r.data;
        var arr = [];
        data.forEach(function (element, i) {
          var obj = {
            name: element.name,
            value: element.code
          };
          arr.push(obj);
        });
        _this7.nation.push(arr);
      }, function (err) {
        _this7.$vux.toast.text(err.message, 'top');
      });
    },
    getPoliticsStatus: function getPoliticsStatus() {
      var _this8 = this;

      this.$api.get('/politicsStatus', null, function (r) {
        var data = r.data;
        var arr = [];
        data.forEach(function (element, i) {
          var obj = {
            name: element.name,
            value: element.code
          };
          arr.push(obj);
        });
        _this8.politicsStatus.push(arr);
      }, function (err) {
        _this8.$vux.toast.text(err.message, 'top');
      });
    },
    getIdentity: function getIdentity() {
      var _this9 = this;

      this.$api.get('identity', null, function (r) {
        var data = r.data;
        var arr = [];
        data.forEach(function (element, i) {
          var obj = {
            name: element.name,
            value: element.code
          };
          arr.push(obj);
        });
        _this9.identity.push(arr);
      }, function (err) {
        _this9.$vux.toast.text(err.message, 'top');
      });
    },
    getArea: function getArea() {
      var _this10 = this;

      return new promise_default.a(function (resolve, reject) {
        _this10.$api.get('area', null, function (r) {
          var data = r.data;
          data.forEach(function (element, index) {
            if (element.grade !== 1) {
              var obj = {
                name: element.name,
                value: String(element.code),
                grade: element.grade
              };
              if (element.grade === 2) {
                obj.parent = 0;
              } else if (element.grade > 2 && element.grade <= 4) {
                obj.parent = String(element.parentCode);
              }
              _this10.origin.push(obj);
            }
          });
          resolve();
        }, function (err) {
          _this10.$vux.toast.text(err.message, 'top');
        });
      });
    },
    getCampus: function getCampus() {
      var _this11 = this;

      this.$api.get('campus', null, function (r) {
        var data = r.data;
        var arr = [];
        data.forEach(function (element, i) {
          var obj = {
            name: element.name,
            value: element.code
          };
          arr.push(obj);
        });
        _this11.campus.push(arr);
      }, function (err) {
        _this11.$vux.toast.text(err.message, 'top');
      });
    },
    getAcademy: function getAcademy() {
      var _this12 = this;

      var params = {
        type: 2
      };
      this.$api.get('department', params, function (r) {
        var data = r.data;
        var arr = [];
        data.forEach(function (element, i) {
          var obj = {
            name: element.name,
            value: element.code
          };
          arr.push(obj);
        });
        _this12.academy.push(arr);
      }, function (err) {
        _this12.$vux.toast.text(err.message, 'top');
      });
    },
    getDepartment: function getDepartment() {
      var _this13 = this;

      var params = {
        type: 1
      };
      this.$api.get('department', params, function (r) {
        var data = r.data;

        var arr = [];
        data.forEach(function (element, i) {
          var obj = {
            name: element.name,
            value: element.code,
            parent: 0
          };
          arr.push(obj);
        });
        _this13.department.push(arr);
      }, function (err) {
        _this13.$vux.toast.text(err.message, 'top');
      });
    },
    getProfession: function getProfession(code) {
      var _this14 = this;

      var params = {
        departmentCode: code,
        identityCode: this.studentInfo.identityCode[0]
      };
      this.$api.get('profession', params, function (r) {
        var data = r.data;
        if (data.length > 0) {
          _this14.isProfession = false;
          _this14.professionText = '请选择您的专业';
          var arr = [];
          data.forEach(function (element, i) {
            var obj = {
              name: element.name,
              value: element.code,
              parent: element.departmentCode
            };
            arr.push(obj);
          });
          _this14.profession = [];
          _this14.profession.push(arr);
        } else {
          _this14.professionText = '暂无专业';
          _this14.isProfession = true;
          _this14.studentInfo.professionCode = [];
          _this14.studentInfo.professionName = [];
        }
      }, function (err) {
        _this14.$vux.toast.text(err.message, 'top');
      });
    },
    getClass: function getClass(departmentCode, professionCode) {
      var _this15 = this;

      var params = {
        departmentCode: departmentCode,
        professionCode: professionCode
      };
      this.$api.get('class', params, function (r) {
        var data = r.data;
        if (data.length > 0) {
          _this15.isClasss = false;
          _this15.classText = '请选择您的班级';
          var arr = [];
          data.forEach(function (element, i) {
            var obj = {
              name: element.name,
              value: element.code
            };
            arr.push(obj);
          });
          _this15.classes = [];
          _this15.classes.push(arr);
        } else {
          _this15.isClass = true;
          _this15.classes = [];
          _this15.studentInfo.classCode = [];
          _this15.studentInfo.className = [];
          _this15.classText = '暂无班级';
        }
      }, function (err) {
        _this15.$vux.toast.text(err.message, 'top');
      });
    },
    checkWechat: function checkWechat(value) {
      var reg = /^([-_a-zA-Z0-9]{5,19})+$/;
      if (reg.test(value)) {
        return { valid: true };
      } else {
        return { valid: false, msg: '微信格式错误' };
      }
    },
    checkTel: function checkTel(value) {
      var reg = /^([0-9]{3,4}-)?[0-9]{7,8}$/;
      if (reg.test(value)) {
        return { valid: true };
      } else {
        return { valid: false, msg: '联系电话格式错误' };
      }
    },
    save: function save() {
      var _this16 = this;

      var errorLength = document.getElementsByClassName('weui-cell weui-cell_warn').length;
      var defaultObj = {
        id: this.userInfo.id,
        flowId: this.flowId,
        flowProcedureId: this.flowProcedureId,
        procedureId: this.procedureId
      };

      var baseObj = {};

      this.showInfoArr.forEach(function (element) {
        var obj = {};
        if (typeof_default()(_this16.studentInfo[element]) === 'object') {

          obj[element] = _this16.studentInfo[element] === null ? '' : _this16.studentInfo[element][0];
        } else {
          obj[element] = _this16.studentInfo[element];
        }
        var objName = {};
        if (element === 'academyCode') {
          objName = {
            academyName: _this16.studentInfo['academyName']
          };
        } else if (element === 'departmentCode') {
          objName = {
            departmentName: _this16.studentInfo['departmentName']
          };
        } else if (element === 'professionCode') {
          objName = {
            professionName: _this16.studentInfo['professionName']
          };
        } else if (element === 'classCode') {
          objName = {
            className: _this16.studentInfo['className']
          };
        } else if (element === 'campusCode') {
          objName = {
            campusName: _this16.studentInfo['campusName']
          };
        }
        baseObj = assign_default()(baseObj, obj, objName);
      });

      var extendObj = {};
      var extendInfo = [];
      this.fromItem.studentExtendFeildList.forEach(function (element) {
        for (var i = 0; i < _this16.fromItem.extendFeildList.length; i++) {
          var obj = {};
          if (element.name === _this16.fromItem.extendFeildList[i]) {
            obj['code'] = element.name;
            obj['value'] = element.value;
            extendInfo.push(obj);
          }
        }
      });
      var isSubmit = false;
      var valueArr = [];

      for (var j in baseObj) {
        valueArr.push(baseObj[j]);
      }
      for (var i in extendInfo) {
        valueArr.push(extendInfo[i].value);
      }

      if (valueArr.indexOf('') === -1) {
        isSubmit = true;
      }
      extendObj['extendInfo'] = stringify_default()(extendInfo);
      var params = assign_default()(defaultObj, baseObj, extendObj);
      if (errorLength === 0 && isSubmit) {
        this.$vux.loading.show();
        this.$api.post('/studentInfo', params, function (r) {
          _this16.$vux.loading.hide();
          _this16.$vux.toast.show({
            text: '提交成功',
            position: 'middle',
            time: 1000
          });
          _this16.$parent.getStudent();
          _this16.$parent.getExtendInfo();
          _this16.$parent.getFlowProcedureStatus();

          setTimeout(function () {
            _this16.back();
          }, 1000);
        }, function (err) {
          _this16.$vux.toast.text(err.message, 'top');
        });
      } else {
        this.$vux.toast.text('请填写完整的信息', 'middle');
      }
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-994f12d0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/yingxin/tskjxy/views/items/info/personalInfo.vue
var personalInfo_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sub-page"},[_c('x-header',{staticClass:"header bg-white border-bottom fixed top"},[_c('em',{staticClass:"icon icon-arrow-left",attrs:{"slot":"overwrite-left","size":""},on:{"click":_vm.back},slot:"overwrite-left"}),_vm._v(_vm._s(_vm.title))]),_c('section',{staticClass:"section fixed-next input-color-inherit",staticStyle:{"padding-bottom":"60px"}},[_c('group',{attrs:{"title":"基本信息","label-width":"6em"}},[(_vm.showInfoArr.indexOf('name') !== -1)?_c('x-input',{attrs:{"title":"姓名","type":"text","placeholder":"请填写您的姓名"},model:{value:(_vm.studentInfo.name),callback:function ($$v) {_vm.$set(_vm.studentInfo, "name", $$v)},expression:"studentInfo.name"}}):_vm._e(),(_vm.showInfoArr.indexOf('account') !== -1)?_c('x-input',{attrs:{"title":"账号","type":"text","placeholder":"请填写您的账号"},model:{value:(_vm.studentInfo.account),callback:function ($$v) {_vm.$set(_vm.studentInfo, "account", $$v)},expression:"studentInfo.account"}}):_vm._e(),(_vm.showInfoArr.indexOf('sno') !== -1)?_c('x-input',{attrs:{"title":"学号","type":"number","placeholder":"请填写您的学号"},model:{value:(_vm.studentInfo.sno),callback:function ($$v) {_vm.$set(_vm.studentInfo, "sno", $$v)},expression:"studentInfo.sno"}}):_vm._e(),(_vm.showInfoArr.indexOf('idNumber') !== -1)?_c('x-input',{attrs:{"title":"身份证号","type":"number","placeholder":"请填写您的身份证号"},model:{value:(_vm.studentInfo.idNumber),callback:function ($$v) {_vm.$set(_vm.studentInfo, "idNumber", $$v)},expression:"studentInfo.idNumber"}}):_vm._e(),(_vm.showInfoArr.indexOf('cardId') !== -1)?_c('x-input',{attrs:{"title":"一卡通号","type":"number","placeholder":"请填写您的一卡通号"},model:{value:(_vm.studentInfo.cardId),callback:function ($$v) {_vm.$set(_vm.studentInfo, "cardId", $$v)},expression:"studentInfo.cardId"}}):_vm._e(),(_vm.showInfoArr.indexOf('cardAccount') !== -1)?_c('x-input',{attrs:{"title":"卡账号","type":"number","placeholder":"请填写您的卡账号"},model:{value:(_vm.studentInfo.cardAccount),callback:function ($$v) {_vm.$set(_vm.studentInfo, "cardAccount", $$v)},expression:"studentInfo.cardAccount"}}):_vm._e(),(_vm.showInfoArr.indexOf('examNumber') !== -1)?_c('x-input',{attrs:{"title":"准考证号","type":"number","placeholder":"请填写您的准考证号"},model:{value:(_vm.studentInfo.examNumber),callback:function ($$v) {_vm.$set(_vm.studentInfo, "examNumber", $$v)},expression:"studentInfo.examNumber"}}):_vm._e(),(_vm.showInfoArr.indexOf('sex') !== -1)?_c('cell',{attrs:{"title":"性别","type":"text","placeholder":"请选择您的性别"}},[_c('div',{attrs:{"slot":"value"},slot:"value"},[_c('checker',{attrs:{"radio-required":"radio-required","default-item-class":"demo2-item","selected-item-class":"demo2-item-selected"},model:{value:(_vm.studentInfo.sex),callback:function ($$v) {_vm.$set(_vm.studentInfo, "sex", $$v)},expression:"studentInfo.sex"}},[_c('checker-item',{attrs:{"value":1}},[_vm._v("男")]),_c('checker-item',{attrs:{"value":2}},[_vm._v("女")])],1)],1)]):_vm._e(),(_vm.showInfoArr.indexOf('birthdate') !== -1)?_c('datetime',{attrs:{"title":"出生日期","placeholder":"请选择日期","start-date":"1980-01-01","end-date":_vm.today},model:{value:(_vm.studentInfo.birthdate),callback:function ($$v) {_vm.$set(_vm.studentInfo, "birthdate", $$v)},expression:"studentInfo.birthdate"}}):_vm._e(),(_vm.showInfoArr.indexOf('countryCode') !== -1)?_c('popup-picker',{attrs:{"title":"国籍","data":_vm.country,"placeholder":"请选择您的国籍","show-name":true},on:{"on-change":_vm.getName},model:{value:(_vm.studentInfo.countryCode),callback:function ($$v) {_vm.$set(_vm.studentInfo, "countryCode", $$v)},expression:"studentInfo.countryCode"}}):_vm._e(),(_vm.showInfoArr.indexOf('nationCode') !== -1)?_c('popup-picker',{attrs:{"title":"民族","data":_vm.nation,"placeholder":"请选择您的民族","show-name":true},on:{"on-change":_vm.getName},model:{value:(_vm.studentInfo.nationCode),callback:function ($$v) {_vm.$set(_vm.studentInfo, "nationCode", $$v)},expression:"studentInfo.nationCode"}}):_vm._e(),(_vm.showInfoArr.indexOf('politicsStatusCode') !== -1)?_c('popup-picker',{attrs:{"title":"政治面貌","data":_vm.politicsStatus,"placeholder":"请选择您的政治面貌","show-name":true},on:{"on-change":_vm.getName},model:{value:(_vm.studentInfo.politicsStatusCode),callback:function ($$v) {_vm.$set(_vm.studentInfo, "politicsStatusCode", $$v)},expression:"studentInfo.politicsStatusCode"}}):_vm._e(),(_vm.showInfoArr.indexOf('identityCode') !== -1)?_c('popup-picker',{attrs:{"title":"身份类型","data":_vm.identity,"placeholder":"请选择您的身份类型","show-name":true},on:{"on-change":_vm.changeIdentity},model:{value:(_vm.studentInfo.identityCode),callback:function ($$v) {_vm.$set(_vm.studentInfo, "identityCode", $$v)},expression:"studentInfo.identityCode"}}):_vm._e(),(_vm.showInfoArr.indexOf('campusCode') !== -1)?_c('popup-picker',{ref:"campus",attrs:{"title":"校区","data":_vm.campus,"placeholder":"请选择您的校区","show-name":true},on:{"on-change":_vm.changeCampus},model:{value:(_vm.studentInfo.campusCode),callback:function ($$v) {_vm.$set(_vm.studentInfo, "campusCode", $$v)},expression:"studentInfo.campusCode"}}):_vm._e(),(_vm.showInfoArr.indexOf('grade') !== -1)?_c('datetime',{attrs:{"title":"年级","placeholder":"请选择年级","min-year":1980,"max-year":Number(_vm.year),"format":"YYYY"},model:{value:(_vm.studentInfo.grade),callback:function ($$v) {_vm.$set(_vm.studentInfo, "grade", $$v)},expression:"studentInfo.grade"}}):_vm._e(),(_vm.showInfoArr.indexOf('academyCode') !== -1)?_c('popup-picker',{ref:"academy",attrs:{"title":"书院","data":_vm.academy,"placeholder":"请选择您的书院","show-name":true},on:{"on-change":_vm.changeAcademy},model:{value:(_vm.studentInfo.academyCode),callback:function ($$v) {_vm.$set(_vm.studentInfo, "academyCode", $$v)},expression:"studentInfo.academyCode"}}):_vm._e(),(_vm.showInfoArr.indexOf('departmentCode') !== -1)?_c('popup-picker',{ref:"department",attrs:{"title":"学院","data":_vm.department,"placeholder":"请选择您的学院","show-name":true},on:{"on-change":_vm.changeDepartment},model:{value:(_vm.studentInfo.departmentCode),callback:function ($$v) {_vm.$set(_vm.studentInfo, "departmentCode", $$v)},expression:"studentInfo.departmentCode"}}):_vm._e(),(_vm.showInfoArr.indexOf('professionCode') !== -1)?_c('popup-picker',{ref:"profession",attrs:{"title":"专业","data":_vm.profession,"placeholder":_vm.professionText,"show-name":true,"disabled":_vm.isProfession},on:{"on-change":_vm.changeProfession},model:{value:(_vm.studentInfo.professionCode),callback:function ($$v) {_vm.$set(_vm.studentInfo, "professionCode", $$v)},expression:"studentInfo.professionCode"}}):_vm._e(),(_vm.showInfoArr.indexOf('classCode') !== -1)?_c('popup-picker',{ref:"classes",attrs:{"title":"班级","data":_vm.classes,"placeholder":_vm.classText,"show-name":true,"disabled":_vm.isClass},on:{"on-change":_vm.changeClass},model:{value:(_vm.studentInfo.classCode),callback:function ($$v) {_vm.$set(_vm.studentInfo, "classCode", $$v)},expression:"studentInfo.classCode"}}):_vm._e(),(_vm.showInfoArr.indexOf('phoneNumber') !== -1)?_c('x-input',{attrs:{"title":"联系电话","type":"tel","placeholder":"请填写您的联系电话","show-clear":false},model:{value:(_vm.studentInfo.phoneNumber),callback:function ($$v) {_vm.$set(_vm.studentInfo, "phoneNumber", $$v)},expression:"studentInfo.phoneNumber"}}):_vm._e(),(_vm.showInfoArr.indexOf('email') !== -1)?_c('x-input',{attrs:{"title":"邮箱","type":"email","placeholder":"请填写您的邮箱","show-clear":false,"is-type":"email"},model:{value:(_vm.studentInfo.email),callback:function ($$v) {_vm.$set(_vm.studentInfo, "email", $$v)},expression:"studentInfo.email"}}):_vm._e(),(_vm.showInfoArr.indexOf('qq') !== -1)?_c('x-input',{attrs:{"title":"QQ","type":"tel","placeholder":"请填写您的QQ","show-clear":false},model:{value:(_vm.studentInfo.qq),callback:function ($$v) {_vm.$set(_vm.studentInfo, "qq", $$v)},expression:"studentInfo.qq"}}):_vm._e(),(_vm.showInfoArr.indexOf('wechat') !== -1)?_c('x-input',{attrs:{"title":"微信","type":"text","placeholder":"请填写您的微信","show-clear":false,"is-type":_vm.checkWechat},model:{value:(_vm.studentInfo.wechat),callback:function ($$v) {_vm.$set(_vm.studentInfo, "wechat", $$v)},expression:"studentInfo.wechat"}}):_vm._e(),(_vm.showInfoArr.indexOf('origin') !== -1)?_c('popup-picker',{ref:"origin",attrs:{"title":"生源地","columns":3,"data":_vm.origin,"placeholder":"请选择您的生源地","show-name":true},on:{"on-change":_vm.changeOrigin},model:{value:(_vm.studentInfo.originCode),callback:function ($$v) {_vm.$set(_vm.studentInfo, "originCode", $$v)},expression:"studentInfo.originCode"}}):_vm._e()],1),(_vm.fromItem.extendFeildList.length > 0)?_c('group',{attrs:{"title":"其他信息","label-width":"6em"}},[_vm._l((_vm.fromItem.studentExtendFeildList),function(item,index){return [(_vm.fromItem.extendFeildList.indexOf(item.name) !== -1)?_c('x-input',{key:index,attrs:{"title":item.comments,"name":item.name,"type":"text","placeholder":"必填","show-clear":false},model:{value:(item.value),callback:function ($$v) {_vm.$set(item, "value", $$v)},expression:"item.value"}}):_vm._e()]})],2):_vm._e()],1),_c('div',{staticClass:"button-group container fixed bottom"},[_c('x-button',{attrs:{"type":"brand"},nativeOn:{"click":function($event){return _vm.save($event)}}},[_vm._v("保存")])],1)],1)}
var personalInfo_staticRenderFns = []
var personalInfo_esExports = { render: personalInfo_render, staticRenderFns: personalInfo_staticRenderFns }
/* harmony default export */ var items_info_personalInfo = (personalInfo_esExports);
// CONCATENATED MODULE: ./src/yingxin/tskjxy/views/items/info/personalInfo.vue
function personalInfo_injectStyle (ssrContext) {
  __webpack_require__("ORep")
}
var personalInfo_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var personalInfo___vue_template_functional__ = false
/* styles */
var personalInfo___vue_styles__ = personalInfo_injectStyle
/* scopeId */
var personalInfo___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var personalInfo___vue_module_identifier__ = null
var personalInfo_Component = personalInfo_normalizeComponent(
  info_personalInfo,
  items_info_personalInfo,
  personalInfo___vue_template_functional__,
  personalInfo___vue_styles__,
  personalInfo___vue_scopeId__,
  personalInfo___vue_module_identifier__
)

/* harmony default export */ var views_items_info_personalInfo = (personalInfo_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/swipeout/swipeout.vue
//
//
//
//
//
//

/* harmony default export */ var swipeout = ({
  name: 'swipeout'
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/swipeout/swipeout.vue
//
//
//
//
//
//

/* harmony default export */ var swipeout_swipeout = ({
  name: 'swipeout'
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-675a2dea","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/swipeout/swipeout.vue
var swipeout_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-swipeout"},[_vm._t("default")],2)}
var swipeout_staticRenderFns = []
var swipeout_esExports = { render: swipeout_render, staticRenderFns: swipeout_staticRenderFns }
/* harmony default export */ var components_swipeout_swipeout = (swipeout_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/swipeout/swipeout.vue
function swipeout_injectStyle (ssrContext) {
  __webpack_require__("UCdd")
}
var swipeout_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var swipeout___vue_template_functional__ = false
/* styles */
var swipeout___vue_styles__ = swipeout_injectStyle
/* scopeId */
var swipeout___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var swipeout___vue_module_identifier__ = null
var swipeout_Component = swipeout_normalizeComponent(
  swipeout_swipeout,
  components_swipeout_swipeout,
  swipeout___vue_template_functional__,
  swipeout___vue_styles__,
  swipeout___vue_scopeId__,
  swipeout___vue_module_identifier__
)

/* harmony default export */ var src_components_swipeout_swipeout = (swipeout_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/swipeout/swipeout-item.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var swipeout_item = ({
  name: 'swipeout-item',
  props: {
    sensitivity: {
      type: Number,
      default: 0
    },
    autoCloseOnButtonClick: {
      type: Boolean,
      default: true
    },
    disabled: Boolean,
    threshold: {
      type: Number,
      default: 0.3
    },
    underlayColor: String,
    transitionMode: {
      type: String,
      default: 'reveal'
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.$nextTick(function () {
      _this.render();
    });
  },

  methods: {
    render: function render() {
      this.target = this.$refs.content;
      if (this.$slots['left-menu']) {
        this.hasLeftMenu = true;
        this.caculateMenuWidth('left');
      }
      if (this.$slots['right-menu']) {
        this.hasRightMenu = true;
        this.caculateMenuWidth('right');
      }
    },
    caculateMenuWidth: function caculateMenuWidth(direction) {
      var list = this.$slots[direction + '-menu'][0].children.filter(function (one) {
        return one.tag;
      });
      var width = 0;
      list.forEach(function (one) {
        var propsData = one.componentOptions ? one.componentOptions.propsData : {};
        width += propsData.width || 80;
      });
      this[direction + 'MenuWidth'] = width;
    },
    onContentClick: function onContentClick() {
      if (this.styles.transform.indexOf('(0px, 0, 0)') === -1) {
        this._setClose(200);
      }
    },
    onItemClick: function onItemClick() {
      if (this.autoCloseOnButtonClick) {
        this._setClose();
      }
    },
    start: function start(ev) {
      if (this.disabled || this.isOpen || ev.target.nodeName.toLowerCase() === 'button') {
        return;
      }
      if (this.$parent.$options._componentTag === 'swipeout') {
        var openItems = this.$parent.$children.filter(function (item) {
          return item.$data.styles.transform.indexOf('(0px, 0, 0)') === -1;
        });
        if (openItems.length > 0) {
          openItems.forEach(function (item) {
            item.setOffset(0, true);
          });
          ev.preventDefault();
          return;
        }
      }
      var touch = ev.touches ? ev.touches[0] : ev;
      this.pageX = touch.pageX;
      this.pageY = touch.pageY;
    },
    move: function move(ev) {
      if (this.disabled) {
        return;
      }
      if (ev.target.nodeName.toLowerCase() === 'button') {
        ev.preventDefault();
        return;
      }
      if (this.pageX === undefined) {
        ev.preventDefault();
        return;
      }

      var touch = ev.touches ? ev.touches[0] : ev;
      this.distX = touch.pageX - this.pageX;
      this.distY = touch.pageY - this.pageY;

      if (!this.direction) {
        this.direction = this.distX > 0 ? 'left' : 'right';
      }

      if (this.direction === 'right' && this.distX > 0 && this.hasRightMenu || this.direction === 'left' && this.distX < 0 && this.hasLeftMenu) {
        this.valid = true;
        ev.preventDefault();
      }

      if (this.valid === undefined) {
        if (this.distX > 0 && this.hasLeftMenu === false) {
          this.valid = false;
        } else if (this.distX < 0 && this.hasRightMenu === false) {
          this.valid = false;
        } else if (Math.abs(this.distX) > this.sensitivity || Math.abs(this.distY) > this.sensitivity) {
          this.valid = Math.abs(this.distX) > Math.abs(this.distY);
        } else {
          ev.preventDefault();
        }
      }

      if (this.valid === true) {
        if (Math.abs(this.distX) <= this.menuWidth) {
          this.setOffset(this.distX, false);
        } else {
          var extra = (Math.abs(this.distX) - this.menuWidth) * 0.5;
          var offset = (this.menuWidth + extra) * (this.distX < 0 ? -1 : 1);
          this.setOffset(offset, false);
        }
        ev.preventDefault();
      }
    },
    end: function end(ev) {
      if (this.disabled) {
        return;
      }
      if (ev.target.nodeName.toLowerCase() === 'button') {
        return;
      }
      if (this.valid === true) {
        if (this.distX < 0 && this.direction === 'right') {
          var threshold = this.threshold <= 1 ? this.rightMenuWidth * this.threshold : this.threshold;

          if (this.distX < -threshold) {
            this.setOffset(-this.rightMenuWidth, true);
            this.$emit('on-open');
            this.isOpen = true;
          } else {
            this._setClose();
          }
        } else if (this.distX > 0 && this.direction === 'left') {
          var _threshold = this.threshold <= 1 ? this.leftMenuWidth * this.threshold : this.threshold;

          if (this.distX > _threshold) {
            this.setOffset(this.leftMenuWidth, true);
            this.$emit('on-open');
            this.isOpen = true;
          } else {
            this._setClose();
          }
        }
      } else if (this.pageX !== undefined) {}

      this.pageX = this.pageY = this.valid = undefined;
      this.direction = '';
    },
    setOffset: function setOffset(x) {
      var _this2 = this;

      var animated = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var force = arguments[2];

      this.isAnimated = animated;
      if (this.disabled && !force) {
        return;
      }
      if (this.direction === 'right' && x > 0 || this.direction === 'left' && x < 0) {
        x = 0;
      }

      if (x === 0) {
        setTimeout(function () {
          _this2.isOpen = false;
        }, 300);
      }

      if (x < 0 && Math.abs(x) === this.rightMenuWidth) {
        this.distX = -this.rightMenuWidth;
      } else if (x > 0 && Math.abs(x) === this.leftMenuWidth) {
        this.distX = this.leftMenuWidth;
      }
      if (animated && this.target) {
        this.target && this.target.classList.add('vux-swipeout-content-animated');
        var cb = function (self, target) {
          return function () {
            target.classList.remove('vux-swipeout-content-animated');
            self.isAnimated = false;
            target.removeEventListener('webkitTransitionEnd', cb);
            target.removeEventListener('transitionend', cb);
          };
        }(this, this.target);

        this.target.addEventListener('webkitTransitionEnd', cb);
        this.target.addEventListener('transitionend', cb);
      }
      this.styles.transform = 'translate3d(' + x + 'px, 0, 0)';
    },
    _setClose: function _setClose() {
      var _this3 = this;

      var delay = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      this.setOffset(0, true);
      this.$emit('on-close');
      if (!delay) {
        this.isOpen = false;
      } else {
        setTimeout(function () {
          _this3.isOpen = false;
        }, delay);
      }
      this.distX = 0;
    },
    open: function open() {
      var position = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'right';

      this.setOffset(position === 'right' ? -this.rightMenuWidth : this.leftMenuWidth, true, true);
    },
    close: function close() {
      this.setOffset(0, true, true);
    }
  },
  computed: {
    menuWidth: function menuWidth() {
      if (!this.hasLeftMenu && this.hasRightMenu) {
        return this.rightMenuWidth;
      }
      if (this.hasLeftMenu && !this.hasRightMenu) {
        return this.leftMenuWidth;
      }
      if (this.hasLeftMenu && this.hasRightMenu) {
        return this.distX < 0 ? this.rightMenuWidth : this.leftMenuWidth;
      }
    },
    buttonBoxStyle: function buttonBoxStyle() {
      return {
        backgroundColor: this.underlayColor
      };
    },
    leftButtonBoxStyle: function leftButtonBoxStyle() {
      var styles = JSON.parse(stringify_default()(this.buttonBoxStyle));
      if (this.transitionMode === 'follow') {
        var offset = this.styles.transform.indexOf('(0px, 0, 0)') === -1 ? this.leftMenuWidth - this.distX : this.leftMenuWidth;
        styles.transform = 'translate3d(-' + offset + 'px, 0, 0)';
      }
      return styles;
    },
    rightButtonBoxStyle: function rightButtonBoxStyle() {
      var styles = JSON.parse(stringify_default()(this.buttonBoxStyle));
      if (this.transitionMode === 'follow') {
        var offset = this.styles.transform.indexOf('(0px, 0, 0)') === -1 ? this.rightMenuWidth - Math.abs(this.distX) : this.rightMenuWidth;
        if (offset < 0) {
          offset = 0;
        }
        if (this.isAnimated) {
          styles.transition = 'transform 0.2s';
        }
        styles.transform = 'translate3d(' + offset + 'px, 0, 0)';
      }
      return styles;
    }
  },
  data: function data() {
    return {
      pageX: undefined,
      pageY: undefined,
      distX: 0,
      distY: 0,
      hasLeftMenu: false,
      hasRightMenu: false,
      animated: false,
      isAnimated: false,
      isOpen: false,
      styles: {
        transform: 'translate3d(0px, 0, 0)'
      },
      direction: '',
      leftMenuWidth: 160,
      rightMenuWidth: 160
    };
  },

  watch: {
    disabled: function disabled(newVal, oldVal) {
      if (newVal === true && !oldVal) {
        this.setOffset(0, true, true);
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/swipeout/swipeout-item.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var swipeout_swipeout_item = ({
  name: 'swipeout-item',
  props: {
    sensitivity: {
      type: Number,
      default: 0
    },
    autoCloseOnButtonClick: {
      type: Boolean,
      default: true
    },
    disabled: Boolean,
    threshold: {
      type: Number,
      default: 0.3
    },
    underlayColor: String,
    transitionMode: {
      type: String,
      default: 'reveal'
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.$nextTick(function () {
      _this.render();
    });
  },

  methods: {
    render: function render() {
      this.target = this.$refs.content;
      if (this.$slots['left-menu']) {
        this.hasLeftMenu = true;
        this.caculateMenuWidth('left');
      }
      if (this.$slots['right-menu']) {
        this.hasRightMenu = true;
        this.caculateMenuWidth('right');
      }
    },
    caculateMenuWidth: function caculateMenuWidth(direction) {
      var list = this.$slots[direction + '-menu'][0].children.filter(function (one) {
        return one.tag;
      });
      var width = 0;
      list.forEach(function (one) {
        var propsData = one.componentOptions ? one.componentOptions.propsData : {};
        width += propsData.width || 80;
      });
      this[direction + 'MenuWidth'] = width;
    },
    onContentClick: function onContentClick() {
      if (this.styles.transform.indexOf('(0px, 0, 0)') === -1) {
        this._setClose(200);
      }
    },
    onItemClick: function onItemClick() {
      if (this.autoCloseOnButtonClick) {
        this._setClose();
      }
    },
    start: function start(ev) {
      if (this.disabled || this.isOpen || ev.target.nodeName.toLowerCase() === 'button') {
        return;
      }
      if (this.$parent.$options._componentTag === 'swipeout') {
        var openItems = this.$parent.$children.filter(function (item) {
          return item.$data.styles.transform.indexOf('(0px, 0, 0)') === -1;
        });
        if (openItems.length > 0) {
          openItems.forEach(function (item) {
            item.setOffset(0, true);
          });
          ev.preventDefault();
          return;
        }
      }
      var touch = ev.touches ? ev.touches[0] : ev;
      this.pageX = touch.pageX;
      this.pageY = touch.pageY;
    },
    move: function move(ev) {
      if (this.disabled) {
        return;
      }
      if (ev.target.nodeName.toLowerCase() === 'button') {
        ev.preventDefault();
        return;
      }
      if (this.pageX === undefined) {
        ev.preventDefault();
        return;
      }

      var touch = ev.touches ? ev.touches[0] : ev;
      this.distX = touch.pageX - this.pageX;
      this.distY = touch.pageY - this.pageY;

      if (!this.direction) {
        this.direction = this.distX > 0 ? 'left' : 'right';
      }

      if (this.direction === 'right' && this.distX > 0 && this.hasRightMenu || this.direction === 'left' && this.distX < 0 && this.hasLeftMenu) {
        this.valid = true;
        ev.preventDefault();
      }

      if (this.valid === undefined) {
        if (this.distX > 0 && this.hasLeftMenu === false) {
          this.valid = false;
        } else if (this.distX < 0 && this.hasRightMenu === false) {
          this.valid = false;
        } else if (Math.abs(this.distX) > this.sensitivity || Math.abs(this.distY) > this.sensitivity) {
          this.valid = Math.abs(this.distX) > Math.abs(this.distY);
        } else {
          ev.preventDefault();
        }
      }

      if (this.valid === true) {
        if (Math.abs(this.distX) <= this.menuWidth) {
          this.setOffset(this.distX, false);
        } else {
          var extra = (Math.abs(this.distX) - this.menuWidth) * 0.5;
          var offset = (this.menuWidth + extra) * (this.distX < 0 ? -1 : 1);
          this.setOffset(offset, false);
        }
        ev.preventDefault();
      }
    },
    end: function end(ev) {
      if (this.disabled) {
        return;
      }
      if (ev.target.nodeName.toLowerCase() === 'button') {
        return;
      }
      if (this.valid === true) {
        if (this.distX < 0 && this.direction === 'right') {
          var threshold = this.threshold <= 1 ? this.rightMenuWidth * this.threshold : this.threshold;

          if (this.distX < -threshold) {
            this.setOffset(-this.rightMenuWidth, true);
            this.$emit('on-open');
            this.isOpen = true;
          } else {
            this._setClose();
          }
        } else if (this.distX > 0 && this.direction === 'left') {
          var _threshold = this.threshold <= 1 ? this.leftMenuWidth * this.threshold : this.threshold;

          if (this.distX > _threshold) {
            this.setOffset(this.leftMenuWidth, true);
            this.$emit('on-open');
            this.isOpen = true;
          } else {
            this._setClose();
          }
        }
      } else if (this.pageX !== undefined) {}

      this.pageX = this.pageY = this.valid = undefined;
      this.direction = '';
    },
    setOffset: function setOffset(x) {
      var _this2 = this;

      var animated = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var force = arguments[2];

      this.isAnimated = animated;
      if (this.disabled && !force) {
        return;
      }
      if (this.direction === 'right' && x > 0 || this.direction === 'left' && x < 0) {
        x = 0;
      }

      if (x === 0) {
        setTimeout(function () {
          _this2.isOpen = false;
        }, 300);
      }

      if (x < 0 && Math.abs(x) === this.rightMenuWidth) {
        this.distX = -this.rightMenuWidth;
      } else if (x > 0 && Math.abs(x) === this.leftMenuWidth) {
        this.distX = this.leftMenuWidth;
      }
      if (animated && this.target) {
        this.target && this.target.classList.add('vux-swipeout-content-animated');
        var cb = function (self, target) {
          return function () {
            target.classList.remove('vux-swipeout-content-animated');
            self.isAnimated = false;
            target.removeEventListener('webkitTransitionEnd', cb);
            target.removeEventListener('transitionend', cb);
          };
        }(this, this.target);

        this.target.addEventListener('webkitTransitionEnd', cb);
        this.target.addEventListener('transitionend', cb);
      }
      this.styles.transform = 'translate3d(' + x + 'px, 0, 0)';
    },
    _setClose: function _setClose() {
      var _this3 = this;

      var delay = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      this.setOffset(0, true);
      this.$emit('on-close');
      if (!delay) {
        this.isOpen = false;
      } else {
        setTimeout(function () {
          _this3.isOpen = false;
        }, delay);
      }
      this.distX = 0;
    },
    open: function open() {
      var position = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'right';

      this.setOffset(position === 'right' ? -this.rightMenuWidth : this.leftMenuWidth, true, true);
    },
    close: function close() {
      this.setOffset(0, true, true);
    }
  },
  computed: {
    menuWidth: function menuWidth() {
      if (!this.hasLeftMenu && this.hasRightMenu) {
        return this.rightMenuWidth;
      }
      if (this.hasLeftMenu && !this.hasRightMenu) {
        return this.leftMenuWidth;
      }
      if (this.hasLeftMenu && this.hasRightMenu) {
        return this.distX < 0 ? this.rightMenuWidth : this.leftMenuWidth;
      }
    },
    buttonBoxStyle: function buttonBoxStyle() {
      return {
        backgroundColor: this.underlayColor
      };
    },
    leftButtonBoxStyle: function leftButtonBoxStyle() {
      var styles = JSON.parse(stringify_default()(this.buttonBoxStyle));
      if (this.transitionMode === 'follow') {
        var offset = this.styles.transform.indexOf('(0px, 0, 0)') === -1 ? this.leftMenuWidth - this.distX : this.leftMenuWidth;
        styles.transform = 'translate3d(-' + offset + 'px, 0, 0)';
      }
      return styles;
    },
    rightButtonBoxStyle: function rightButtonBoxStyle() {
      var styles = JSON.parse(stringify_default()(this.buttonBoxStyle));
      if (this.transitionMode === 'follow') {
        var offset = this.styles.transform.indexOf('(0px, 0, 0)') === -1 ? this.rightMenuWidth - Math.abs(this.distX) : this.rightMenuWidth;
        if (offset < 0) {
          offset = 0;
        }
        if (this.isAnimated) {
          styles.transition = 'transform 0.2s';
        }
        styles.transform = 'translate3d(' + offset + 'px, 0, 0)';
      }
      return styles;
    }
  },
  data: function data() {
    return {
      pageX: undefined,
      pageY: undefined,
      distX: 0,
      distY: 0,
      hasLeftMenu: false,
      hasRightMenu: false,
      animated: false,
      isAnimated: false,
      isOpen: false,
      styles: {
        transform: 'translate3d(0px, 0, 0)'
      },
      direction: '',
      leftMenuWidth: 160,
      rightMenuWidth: 160
    };
  },

  watch: {
    disabled: function disabled(newVal, oldVal) {
      if (newVal === true && !oldVal) {
        this.setOffset(0, true, true);
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5af13bd6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/swipeout/swipeout-item.vue
var swipeout_item_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-swipeout-item",on:{"touchstart":_vm.start,"mousedown":_vm.start,"touchmove":_vm.move,"mousemove":_vm.move,"touchend":_vm.end,"mouseup":_vm.end,"touchcancel":_vm.end}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.distX >= 0),expression:"distX >= 0"}],staticClass:"vux-swipeout-button-box vux-swipeout-button-box-left",style:(_vm.leftButtonBoxStyle)},[_vm._t("left-menu")],2),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.distX <= 0),expression:"distX <= 0"}],staticClass:"vux-swipeout-button-box",style:(_vm.rightButtonBoxStyle)},[_vm._t("right-menu")],2),_vm._v(" "),_c('div',{ref:"content",staticClass:"vux-swipeout-content",style:(_vm.styles),on:{"mousedown":_vm.onContentClick,"touchstart":_vm.onContentClick}},[_vm._t("content")],2)])}
var swipeout_item_staticRenderFns = []
var swipeout_item_esExports = { render: swipeout_item_render, staticRenderFns: swipeout_item_staticRenderFns }
/* harmony default export */ var components_swipeout_swipeout_item = (swipeout_item_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/swipeout/swipeout-item.vue
var swipeout_item_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var swipeout_item___vue_template_functional__ = false
/* styles */
var swipeout_item___vue_styles__ = null
/* scopeId */
var swipeout_item___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var swipeout_item___vue_module_identifier__ = null
var swipeout_item_Component = swipeout_item_normalizeComponent(
  swipeout_swipeout_item,
  components_swipeout_swipeout_item,
  swipeout_item___vue_template_functional__,
  swipeout_item___vue_styles__,
  swipeout_item___vue_scopeId__,
  swipeout_item___vue_module_identifier__
)

/* harmony default export */ var src_components_swipeout_swipeout_item = (swipeout_item_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/swipeout/swipeout-button.vue
//
//
//
//
//
//
//

/* harmony default export */ var swipeout_button = ({
  name: 'swipeout-button',
  props: {
    text: String,
    backgroundColor: String,
    type: String,
    width: {
      type: Number,
      default: 80
    }
  },
  methods: {
    onButtonClick: function onButtonClick() {
      if (this.$parent.$options._componentTag === 'swipeout-item') {
        this.$parent.onItemClick(this.text);
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/swipeout/swipeout-button.vue
//
//
//
//
//
//
//

/* harmony default export */ var swipeout_swipeout_button = ({
  name: 'swipeout-button',
  props: {
    text: String,
    backgroundColor: String,
    type: String,
    width: {
      type: Number,
      default: 80
    }
  },
  methods: {
    onButtonClick: function onButtonClick() {
      if (this.$parent.$options._componentTag === 'swipeout-item') {
        this.$parent.onItemClick(this.text);
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-78513114","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/swipeout/swipeout-button.vue
var swipeout_button_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"vux-swipeout-button",class:{'vux-swipeout-button-primary': _vm.type === 'primary', 'vux-swipeout-button-warn': _vm.type === 'warn', 'vux-swipeout-button-default': _vm.type === 'default'},style:({width: (_vm.width + "px"), backgroundColor: _vm.backgroundColor}),attrs:{"type":"button"},on:{"click":_vm.onButtonClick}},[_vm._t("default",[_vm._v(_vm._s(_vm.text))])],2)}
var swipeout_button_staticRenderFns = []
var swipeout_button_esExports = { render: swipeout_button_render, staticRenderFns: swipeout_button_staticRenderFns }
/* harmony default export */ var components_swipeout_swipeout_button = (swipeout_button_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/swipeout/swipeout-button.vue
var swipeout_button_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var swipeout_button___vue_template_functional__ = false
/* styles */
var swipeout_button___vue_styles__ = null
/* scopeId */
var swipeout_button___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var swipeout_button___vue_module_identifier__ = null
var swipeout_button_Component = swipeout_button_normalizeComponent(
  swipeout_swipeout_button,
  components_swipeout_swipeout_button,
  swipeout_button___vue_template_functional__,
  swipeout_button___vue_styles__,
  swipeout_button___vue_scopeId__,
  swipeout_button___vue_module_identifier__
)

/* harmony default export */ var src_components_swipeout_swipeout_button = (swipeout_button_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/yingxin/tskjxy/views/items/info/parentsInfo.vue












/* harmony default export */ var parentsInfo = ({
  name: 'info',
  props: [],
  components: {
    XHeader: vux_src_components_x_header,
    XInput: vux_src_components_x_input,
    Group: vux_src_components_group,
    XButton: vux_src_components_x_button,
    Cell: vux_src_components_cell,
    Swipeout: src_components_swipeout_swipeout,
    SwipeoutItem: src_components_swipeout_swipeout_item,
    SwipeoutButton: src_components_swipeout_swipeout_button
  },
  data: function data() {
    return {
      title: this.$route.meta.title,
      familyInfo: []
    };
  },

  computed: extends_default()({}, Object(vuex_esm["c" /* mapState */])({
    userInfo: function userInfo(state) {
      return state.userInfo;
    }
  })),
  created: function created() {},
  mounted: function mounted() {
    this.getFamilyInfo();
  },
  updated: function updated() {},
  destroyed: function destroyed() {},

  watch: {},
  methods: {
    back: function back() {
      var _this = this;

      setTimeout(function () {
        _this.$router.back(-1);
      }, 300);
    },
    finish: function finish() {
      var _this2 = this;

      setTimeout(function () {
        _this2.back();
        _this2.$parent.getFamilyInfo();
      }, 300);
    },
    getFamilyInfo: function getFamilyInfo() {
      var _this3 = this;

      this.$vux.loading.show();
      var params = {
        studentId: this.userInfo.id
      };
      this.$api.get('/family', params, function (r) {
        _this3.$vux.loading.hide();
        var data = r.data;
        _this3.familyInfo = data;
      });
    },
    onButtonClick: function onButtonClick(type, id) {
      if (type === 'edit') {
        this.toEdit(id);
      } else if (type === 'delete') {
        this.deleteInfo(id);
      }
    },
    handleEvents: function handleEvents(type) {},
    deleteInfo: function deleteInfo(id) {
      var _this4 = this;

      this.$vux.loading.show();
      var params = {
        id: id
      };
      this.$api.delete('/family', params, function (r) {
        _this4.$vux.loading.hide();
        _this4.$vux.toast.show({
          type: 'text',
          text: '删除成功',
          position: 'top',
          time: 1000
        });
        _this4.getFamilyInfo();
      }, function (err) {
        _this4.$vux.toast.text(err.message, 'top');
      });
    },
    toAdd: function toAdd(id) {
      this.$router.push({
        name: 'parentsInfoEdit'
      });
      sessionStorage.setItem('editInfoId', null);
    },
    toEdit: function toEdit(id) {
      this.$router.push({
        name: 'parentsInfoEdit'
      });
      sessionStorage.setItem('editInfoId', id);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/yingxin/tskjxy/views/items/info/parentsInfo.vue












/* harmony default export */ var info_parentsInfo = ({
  name: 'info',
  props: [],
  components: {
    XHeader: vux_src_components_x_header,
    XInput: vux_src_components_x_input,
    Group: vux_src_components_group,
    XButton: vux_src_components_x_button,
    Cell: vux_src_components_cell,
    Swipeout: src_components_swipeout_swipeout,
    SwipeoutItem: src_components_swipeout_swipeout_item,
    SwipeoutButton: src_components_swipeout_swipeout_button
  },
  data: function data() {
    return {
      title: this.$route.meta.title,
      familyInfo: []
    };
  },

  computed: extends_default()({}, Object(vuex_esm["c" /* mapState */])({
    userInfo: function userInfo(state) {
      return state.userInfo;
    }
  })),
  created: function created() {},
  mounted: function mounted() {
    this.getFamilyInfo();
  },
  updated: function updated() {},
  destroyed: function destroyed() {},

  watch: {},
  methods: {
    back: function back() {
      var _this = this;

      setTimeout(function () {
        _this.$router.back(-1);
      }, 300);
    },
    finish: function finish() {
      var _this2 = this;

      setTimeout(function () {
        _this2.back();
        _this2.$parent.getFamilyInfo();
      }, 300);
    },
    getFamilyInfo: function getFamilyInfo() {
      var _this3 = this;

      this.$vux.loading.show();
      var params = {
        studentId: this.userInfo.id
      };
      this.$api.get('/family', params, function (r) {
        _this3.$vux.loading.hide();
        var data = r.data;
        _this3.familyInfo = data;
      });
    },
    onButtonClick: function onButtonClick(type, id) {
      if (type === 'edit') {
        this.toEdit(id);
      } else if (type === 'delete') {
        this.deleteInfo(id);
      }
    },
    handleEvents: function handleEvents(type) {},
    deleteInfo: function deleteInfo(id) {
      var _this4 = this;

      this.$vux.loading.show();
      var params = {
        id: id
      };
      this.$api.delete('/family', params, function (r) {
        _this4.$vux.loading.hide();
        _this4.$vux.toast.show({
          type: 'text',
          text: '删除成功',
          position: 'top',
          time: 1000
        });
        _this4.getFamilyInfo();
      }, function (err) {
        _this4.$vux.toast.text(err.message, 'top');
      });
    },
    toAdd: function toAdd(id) {
      this.$router.push({
        name: 'parentsInfoEdit'
      });
      sessionStorage.setItem('editInfoId', null);
    },
    toEdit: function toEdit(id) {
      this.$router.push({
        name: 'parentsInfoEdit'
      });
      sessionStorage.setItem('editInfoId', id);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4835ab02","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/yingxin/tskjxy/views/items/info/parentsInfo.vue
var parentsInfo_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sub-page"},[_c('x-header',{staticClass:"header bg-white border-bottom fixed top"},[_c('em',{staticClass:"icon icon-arrow-left",attrs:{"slot":"overwrite-left","size":""},on:{"click":_vm.back},slot:"overwrite-left"}),_vm._v(_vm._s(_vm.title)),_c('span',{staticClass:"text-brand",attrs:{"slot":"right","size":""},on:{"click":_vm.finish},slot:"right"},[_vm._v("完成")])]),_c('section',{staticClass:"section fixed-next"},[_c('swipeout',_vm._l((_vm.familyInfo),function(item,i){return (_vm.familyInfo.length > 0)?_c('swipeout-item',{key:i,attrs:{"transition-mode":"follow"},on:{"on-close":function($event){return _vm.handleEvents('on-close')},"on-open":function($event){return _vm.handleEvents('on-open')}}},[_c('div',{attrs:{"slot":"right-menu"},slot:"right-menu"},[_c('swipeout-button',{attrs:{"type":"primary"},nativeOn:{"click":function($event){return _vm.onButtonClick('edit', item.id)}}},[_vm._v("编辑")]),_c('swipeout-button',{attrs:{"type":"warn"},nativeOn:{"click":function($event){return _vm.onButtonClick('delete', item.id)}}},[_vm._v("删除")])],1),_c('div',{staticClass:"demo-content vux-1px-t",attrs:{"slot":"content"},slot:"content"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"card group-card"},[_c('group',{attrs:{"title":""}},[_c('cell',{attrs:{"title":"姓名","value":item.name}}),_c('cell',{attrs:{"title":"称谓","value":item.call}}),(item.age != null)?_c('cell',{attrs:{"title":"年龄","value":item.age}}):_vm._e(),(item.job != null)?_c('cell',{attrs:{"title":"职位","value":item.job}}):_vm._e(),_c('cell',{attrs:{"title":"民族","value":item.nation}}),_c('cell',{attrs:{"title":"政治面貌","value":item.politics}}),_c('cell',{attrs:{"title":"联系方式","value":item.phone}})],1)],1)])])]):_vm._e()}),1),_c('div',{staticClass:"button-group container"},[_c('br'),_c('x-button',{attrs:{"type":"white"},nativeOn:{"click":function($event){return _vm.toAdd($event)}}},[_c('em',{staticClass:"icon icon-add"}),_vm._v(" 添加家庭成员信息")])],1)],1),_c('transition',{attrs:{"name":"slide","enter-active-class":"animated fastest slideInRight","leave-active-class":"animated fastest slideOutRight"}},[_c('router-view')],1)],1)}
var parentsInfo_staticRenderFns = []
var parentsInfo_esExports = { render: parentsInfo_render, staticRenderFns: parentsInfo_staticRenderFns }
/* harmony default export */ var items_info_parentsInfo = (parentsInfo_esExports);
// CONCATENATED MODULE: ./src/yingxin/tskjxy/views/items/info/parentsInfo.vue
function parentsInfo_injectStyle (ssrContext) {
  __webpack_require__("TKqF")
}
var parentsInfo_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var parentsInfo___vue_template_functional__ = false
/* styles */
var parentsInfo___vue_styles__ = parentsInfo_injectStyle
/* scopeId */
var parentsInfo___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var parentsInfo___vue_module_identifier__ = null
var parentsInfo_Component = parentsInfo_normalizeComponent(
  info_parentsInfo,
  items_info_parentsInfo,
  parentsInfo___vue_template_functional__,
  parentsInfo___vue_styles__,
  parentsInfo___vue_scopeId__,
  parentsInfo___vue_module_identifier__
)

/* harmony default export */ var views_items_info_parentsInfo = (parentsInfo_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/yingxin/tskjxy/views/items/info/parentsInfoEdit.vue











/* harmony default export */ var parentsInfoEdit = ({
  name: 'info',
  props: [],
  components: {
    XHeader: vux_src_components_x_header,
    XInput: vux_src_components_x_input,
    Group: vux_src_components_group,
    XButton: vux_src_components_x_button,
    PopupPicker: vux_src_components_popup_picker
  },
  data: function data() {
    return {
      title: this.$route.meta.title,
      nation: [],
      politicsStatus: [],
      familyInfo: {
        name: '',
        call: [],
        age: '',
        job: '',
        nationCode: [],
        nation: '',
        politicsCode: [],
        politics: '',
        phone: ''
      },
      isButton: true,
      callArr: [['父亲', '母亲', '兄弟姐妹', '其他']],
      isAdd: true,
      editInfoId: null
    };
  },

  computed: extends_default()({}, Object(vuex_esm["c" /* mapState */])({
    userInfo: function userInfo(state) {
      return state.userInfo;
    }
  })),
  created: function created() {
    this.getNation();
    this.getPoliticsStatus();
  },
  mounted: function mounted() {
    this.editInfoId = JSON.parse(sessionStorage.getItem('editInfoId'));
    if (this.editInfoId) {
      this.title = '编辑家庭成员信息';
      this.isAdd = false;
      this.getFamilyInfo(this.editInfoId);
    } else {
      this.isAdd = true;
      this.title = '添加家庭成员信息';
    }
  },
  updated: function updated() {},
  destroyed: function destroyed() {},

  watch: {},
  methods: {
    back: function back() {
      var _this = this;

      setTimeout(function () {
        _this.$router.back(-1);
      }, 300);
    },
    save: function save() {
      var _this2 = this;

      var errorLength = document.getElementsByClassName('weui-cell weui-cell_warn').length;
      var infoObj = {};
      var defaultObj = {
        studentId: String(this.userInfo.id)
      };
      for (var i in this.familyInfo) {
        if (typeof_default()(this.familyInfo[i]) === 'object') {
          this.$set(infoObj, i, this.familyInfo[i][0]);
        } else {
          this.$set(infoObj, i, this.familyInfo[i]);
        }
      }
      var obj = assign_default()(defaultObj, infoObj);
      var isSubmit = false;
      var valueArr = [];
      for (var j in obj) {
        if (j === 'name' || j === 'call' || j === 'nation' || j === 'politics' || j === 'phone' || j === 'age') {
          valueArr.push(obj[j]);
        }
      }
      if (valueArr.indexOf('') === -1) {
        isSubmit = true;
      }
      var params = obj;
      if (errorLength === 0 && isSubmit) {
        this.$vux.loading.show();
        if (this.isAdd) {
          this.$api.post('/family', params, function (r) {
            _this2.$vux.loading.hide();
            _this2.$vux.toast.show({
              text: '提交成功',
              position: 'middle',
              time: 1000
            });
            _this2.$parent.getFamilyInfo();
            setTimeout(function () {
              _this2.back();
            }, 1000);
          }, function (err) {
            _this2.$vux.toast.text(err.message, 'top');
          });
        } else {
          this.$set(params, 'id', this.editInfoId);
          this.$api.put('/family', params, function (r) {
            _this2.$vux.loading.hide();
            _this2.$vux.toast.show({
              text: '修改成功',
              position: 'middle',
              time: 1000
            });
            _this2.$parent.getFamilyInfo();
            setTimeout(function () {
              _this2.back();
            }, 1000);
          }, function (err) {
            _this2.$vux.toast.text(err.message, 'top');
          });
        }
      } else {
        this.$vux.toast.text('请完整填写信息', 'middle');
      }
    },
    changeInput: function changeInput(name) {

      if (name === 'nation') {
        this.familyInfo.nation = this.$refs.nation.getNameValues();
      } else if (name === 'politics') {
        this.familyInfo.politics = this.$refs.politics.getNameValues();
      }
    },
    getNation: function getNation() {
      var _this3 = this;

      this.$api.get('/nation', null, function (r) {
        var data = r.data;
        var arr = [];
        data.forEach(function (element, i) {
          var obj = {
            name: element.name,
            value: element.code
          };
          arr.push(obj);
        });
        _this3.nation.push(arr);
      }, function (err) {
        _this3.$vux.toast.text(err.message, 'top');
      });
    },
    getPoliticsStatus: function getPoliticsStatus() {
      var _this4 = this;

      this.$api.get('/politicsStatus', null, function (r) {
        var data = r.data;
        var arr = [];
        data.forEach(function (element, i) {
          var obj = {
            name: element.name,
            value: element.code
          };
          arr.push(obj);
        });
        _this4.politicsStatus.push(arr);
      }, function (err) {
        _this4.$vux.toast.text(err.message, 'top');
      });
    },
    getFamilyInfo: function getFamilyInfo(id) {
      var _this5 = this;

      this.$vux.loading.show();
      var params = {
        studentId: this.userInfo.id,
        id: id
      };
      this.$api.get('/family', params, function (r) {
        _this5.$vux.loading.hide();
        var data = r.data;
        if (data.length > 0) {
          _this5.familyInfo = {
            name: data[0].name,
            call: [],
            age: data[0].age,
            job: data[0].job,
            nationCode: [],
            nation: data[0].nation,
            politicsCode: [],
            politics: data[0].politics,
            phone: data[0].phone
          };
          _this5.nation[0].forEach(function (element) {
            if (element.name === data[0].nation) {
              _this5.familyInfo['nationCode'].push(element.value);
            }
          });
          _this5.politicsStatus[0].forEach(function (element) {
            if (element.name === data[0].politics) {
              _this5.familyInfo['politicsCode'].push(element.value);
            }
          });
          _this5.familyInfo['call'].push(data[0].call);
        }
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/yingxin/tskjxy/views/items/info/parentsInfoEdit.vue











/* harmony default export */ var info_parentsInfoEdit = ({
  name: 'info',
  props: [],
  components: {
    XHeader: vux_src_components_x_header,
    XInput: vux_src_components_x_input,
    Group: vux_src_components_group,
    XButton: vux_src_components_x_button,
    PopupPicker: vux_src_components_popup_picker
  },
  data: function data() {
    return {
      title: this.$route.meta.title,
      nation: [],
      politicsStatus: [],
      familyInfo: {
        name: '',
        call: [],
        age: '',
        job: '',
        nationCode: [],
        nation: '',
        politicsCode: [],
        politics: '',
        phone: ''
      },
      isButton: true,
      callArr: [['父亲', '母亲', '兄弟姐妹', '其他']],
      isAdd: true,
      editInfoId: null
    };
  },

  computed: extends_default()({}, Object(vuex_esm["c" /* mapState */])({
    userInfo: function userInfo(state) {
      return state.userInfo;
    }
  })),
  created: function created() {
    this.getNation();
    this.getPoliticsStatus();
  },
  mounted: function mounted() {
    this.editInfoId = JSON.parse(sessionStorage.getItem('editInfoId'));
    if (this.editInfoId) {
      this.title = '编辑家庭成员信息';
      this.isAdd = false;
      this.getFamilyInfo(this.editInfoId);
    } else {
      this.isAdd = true;
      this.title = '添加家庭成员信息';
    }
  },
  updated: function updated() {},
  destroyed: function destroyed() {},

  watch: {},
  methods: {
    back: function back() {
      var _this = this;

      setTimeout(function () {
        _this.$router.back(-1);
      }, 300);
    },
    save: function save() {
      var _this2 = this;

      var errorLength = document.getElementsByClassName('weui-cell weui-cell_warn').length;
      var infoObj = {};
      var defaultObj = {
        studentId: String(this.userInfo.id)
      };
      for (var i in this.familyInfo) {
        if (typeof_default()(this.familyInfo[i]) === 'object') {
          this.$set(infoObj, i, this.familyInfo[i][0]);
        } else {
          this.$set(infoObj, i, this.familyInfo[i]);
        }
      }
      var obj = assign_default()(defaultObj, infoObj);
      var isSubmit = false;
      var valueArr = [];
      for (var j in obj) {
        if (j === 'name' || j === 'call' || j === 'nation' || j === 'politics' || j === 'phone' || j === 'age') {
          valueArr.push(obj[j]);
        }
      }
      if (valueArr.indexOf('') === -1) {
        isSubmit = true;
      }
      var params = obj;
      if (errorLength === 0 && isSubmit) {
        this.$vux.loading.show();
        if (this.isAdd) {
          this.$api.post('/family', params, function (r) {
            _this2.$vux.loading.hide();
            _this2.$vux.toast.show({
              text: '提交成功',
              position: 'middle',
              time: 1000
            });
            _this2.$parent.getFamilyInfo();
            setTimeout(function () {
              _this2.back();
            }, 1000);
          }, function (err) {
            _this2.$vux.toast.text(err.message, 'top');
          });
        } else {
          this.$set(params, 'id', this.editInfoId);
          this.$api.put('/family', params, function (r) {
            _this2.$vux.loading.hide();
            _this2.$vux.toast.show({
              text: '修改成功',
              position: 'middle',
              time: 1000
            });
            _this2.$parent.getFamilyInfo();
            setTimeout(function () {
              _this2.back();
            }, 1000);
          }, function (err) {
            _this2.$vux.toast.text(err.message, 'top');
          });
        }
      } else {
        this.$vux.toast.text('请完整填写信息', 'middle');
      }
    },
    changeInput: function changeInput(name) {

      if (name === 'nation') {
        this.familyInfo.nation = this.$refs.nation.getNameValues();
      } else if (name === 'politics') {
        this.familyInfo.politics = this.$refs.politics.getNameValues();
      }
    },
    getNation: function getNation() {
      var _this3 = this;

      this.$api.get('/nation', null, function (r) {
        var data = r.data;
        var arr = [];
        data.forEach(function (element, i) {
          var obj = {
            name: element.name,
            value: element.code
          };
          arr.push(obj);
        });
        _this3.nation.push(arr);
      }, function (err) {
        _this3.$vux.toast.text(err.message, 'top');
      });
    },
    getPoliticsStatus: function getPoliticsStatus() {
      var _this4 = this;

      this.$api.get('/politicsStatus', null, function (r) {
        var data = r.data;
        var arr = [];
        data.forEach(function (element, i) {
          var obj = {
            name: element.name,
            value: element.code
          };
          arr.push(obj);
        });
        _this4.politicsStatus.push(arr);
      }, function (err) {
        _this4.$vux.toast.text(err.message, 'top');
      });
    },
    getFamilyInfo: function getFamilyInfo(id) {
      var _this5 = this;

      this.$vux.loading.show();
      var params = {
        studentId: this.userInfo.id,
        id: id
      };
      this.$api.get('/family', params, function (r) {
        _this5.$vux.loading.hide();
        var data = r.data;
        if (data.length > 0) {
          _this5.familyInfo = {
            name: data[0].name,
            call: [],
            age: data[0].age,
            job: data[0].job,
            nationCode: [],
            nation: data[0].nation,
            politicsCode: [],
            politics: data[0].politics,
            phone: data[0].phone
          };
          _this5.nation[0].forEach(function (element) {
            if (element.name === data[0].nation) {
              _this5.familyInfo['nationCode'].push(element.value);
            }
          });
          _this5.politicsStatus[0].forEach(function (element) {
            if (element.name === data[0].politics) {
              _this5.familyInfo['politicsCode'].push(element.value);
            }
          });
          _this5.familyInfo['call'].push(data[0].call);
        }
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5aef9a48","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/yingxin/tskjxy/views/items/info/parentsInfoEdit.vue
var parentsInfoEdit_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sub-page"},[_c('x-header',{staticClass:"header bg-white border-bottom"},[_c('em',{staticClass:"icon icon-arrow-left",attrs:{"slot":"overwrite-left","size":""},on:{"click":_vm.back},slot:"overwrite-left"}),_vm._v(_vm._s(_vm.title))]),_c('section',{staticClass:"section input-color-inherit"},[_c('group',{attrs:{"title":"","label-width":"5rem"}},[_c('x-input',{attrs:{"title":"姓名","type":"text","placeholder":"必填项","show-clear":false,"require":"require"},model:{value:(_vm.familyInfo.name),callback:function ($$v) {_vm.$set(_vm.familyInfo, "name", $$v)},expression:"familyInfo.name"}}),_c('popup-picker',{attrs:{"title":"称谓","data":_vm.callArr,"placeholder":"请选择称谓"},model:{value:(_vm.familyInfo.call),callback:function ($$v) {_vm.$set(_vm.familyInfo, "call", $$v)},expression:"familyInfo.call"}}),_c('x-input',{attrs:{"title":"年龄","type":"number","show-clear":false,"placeholder":"必填项","required":"required"},model:{value:(_vm.familyInfo.age),callback:function ($$v) {_vm.$set(_vm.familyInfo, "age", $$v)},expression:"familyInfo.age"}}),_c('x-input',{attrs:{"title":"职业","type":"text"},model:{value:(_vm.familyInfo.job),callback:function ($$v) {_vm.$set(_vm.familyInfo, "job", $$v)},expression:"familyInfo.job"}}),_c('popup-picker',{ref:"nation",attrs:{"title":"民族","data":_vm.nation,"placeholder":"请选择民族","show-name":true},on:{"on-change":function($event){return _vm.changeInput('nation')}},model:{value:(_vm.familyInfo.nationCode),callback:function ($$v) {_vm.$set(_vm.familyInfo, "nationCode", $$v)},expression:"familyInfo.nationCode"}}),_c('popup-picker',{ref:"politics",attrs:{"title":"政治面貌","data":_vm.politicsStatus,"placeholder":"请选择政治面貌","show-name":true},on:{"on-change":function($event){return _vm.changeInput('politics')}},model:{value:(_vm.familyInfo.politicsCode),callback:function ($$v) {_vm.$set(_vm.familyInfo, "politicsCode", $$v)},expression:"familyInfo.politicsCode"}}),_c('x-input',{attrs:{"title":"联系方式","type":"tel","placeholder":"必填项","show-clear":false,"required":"required","is-type":"china-mobile"},model:{value:(_vm.familyInfo.phone),callback:function ($$v) {_vm.$set(_vm.familyInfo, "phone", $$v)},expression:"familyInfo.phone"}})],1)],1),_c('div',{staticClass:"button-group fixed bottom container"},[_c('x-button',{attrs:{"type":"brand"},nativeOn:{"click":function($event){return _vm.save($event)}}},[_vm._v("保存")])],1)],1)}
var parentsInfoEdit_staticRenderFns = []
var parentsInfoEdit_esExports = { render: parentsInfoEdit_render, staticRenderFns: parentsInfoEdit_staticRenderFns }
/* harmony default export */ var items_info_parentsInfoEdit = (parentsInfoEdit_esExports);
// CONCATENATED MODULE: ./src/yingxin/tskjxy/views/items/info/parentsInfoEdit.vue
var parentsInfoEdit_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var parentsInfoEdit___vue_template_functional__ = false
/* styles */
var parentsInfoEdit___vue_styles__ = null
/* scopeId */
var parentsInfoEdit___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var parentsInfoEdit___vue_module_identifier__ = null
var parentsInfoEdit_Component = parentsInfoEdit_normalizeComponent(
  info_parentsInfoEdit,
  items_info_parentsInfoEdit,
  parentsInfoEdit___vue_template_functional__,
  parentsInfoEdit___vue_styles__,
  parentsInfoEdit___vue_scopeId__,
  parentsInfoEdit___vue_module_identifier__
)

/* harmony default export */ var views_items_info_parentsInfoEdit = (parentsInfoEdit_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/yingxin/tskjxy/views/items/car.vue







/* harmony default export */ var car = ({
  name: 'car',
  props: [],
  components: {
    XHeader: vux_src_components_x_header,
    Grid: src_components_grid_grid,
    GridItem: src_components_grid_grid_item
  },
  data: function data() {
    return {
      isEdit: this.$route.params.isEdit,
      traffic: [{
        name: '飞机',
        site: ['site1', 'site2'],
        icon: 'airplane',
        type: '1',
        isShow: false
      }, {
        name: '火车',
        site: ['site3', 'site4'],
        icon: 'rail',
        type: '2',
        isShow: false
      }, {
        name: '汽车',
        site: ['site5'],
        icon: 'coach',
        type: '3',
        isShow: false
      }, {
        name: '其他',
        site: null,
        icon: 'autocar',
        type: '4',
        isShow: true
      }]
    };
  },

  computed: extends_default()({}, Object(vuex_esm["c" /* mapState */])({
    token: function token(state) {
      return state.token;
    },
    studentId: function studentId(state) {
      return state.userInfo.id;
    },
    flowId: function flowId(state) {
      return state.flowInfo.flowId;
    },
    flowType: function flowType(state) {
      return state.flowInfo.flowType;
    },
    title: function title(state) {
      return state.currentProcedureInfo.name;
    },
    flowProcedureId: function flowProcedureId(state) {
      return state.currentProcedureInfo.flowProcedureId;
    },
    procedureId: function procedureId(state) {
      return state.currentProcedureInfo.procedureId;
    },
    parentRouter: function parentRouter(state) {
      return state.currentProcedureInfo.parentRouter;
    }
  }), {
    status: function status() {
      return this.$route.params.status;
    }
  }),
  created: function created() {},
  mounted: function mounted() {
    this.getCarList();
  },
  updated: function updated() {},
  destroyed: function destroyed() {},

  watch: {},
  methods: {
    back: function back() {
      var _this = this;

      setTimeout(function () {

        _this.$router.push({
          name: _this.parentRouter
        });
      }, 300);
    },
    getCarList: function getCarList() {
      var _this2 = this;

      var params = {
        flowId: this.flowId,
        flowProcedureId: this.flowProcedureId,
        procedureId: this.procedureId
      };
      this.$api.get('/configWayToSchool', params, function (r) {
        _this2.airplane = r.data.filter(function (item) {
          if (item.transportation === '1') {
            return true;
          }
        });
        _this2.train = r.data.filter(function (item) {
          if (item.transportation === '2') {
            return true;
          }
        });
        _this2.car = r.data.filter(function (item) {
          if (item.transportation === '3') {
            return true;
          }
        });
        if (_this2.airplane.length > 0) {
          _this2.traffic[0].isShow = true;
        }
        if (_this2.train.length > 0) {
          _this2.traffic[1].isShow = true;
        }
        if (_this2.car.length > 0) {
          _this2.traffic[2].isShow = true;
        }
      }, function (err) {
        _this2.$vux.toast.text(err.message, 'top');
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/yingxin/tskjxy/views/items/car.vue







/* harmony default export */ var items_car = ({
  name: 'car',
  props: [],
  components: {
    XHeader: vux_src_components_x_header,
    Grid: src_components_grid_grid,
    GridItem: src_components_grid_grid_item
  },
  data: function data() {
    return {
      isEdit: this.$route.params.isEdit,
      traffic: [{
        name: '飞机',
        site: ['site1', 'site2'],
        icon: 'airplane',
        type: '1',
        isShow: false
      }, {
        name: '火车',
        site: ['site3', 'site4'],
        icon: 'rail',
        type: '2',
        isShow: false
      }, {
        name: '汽车',
        site: ['site5'],
        icon: 'coach',
        type: '3',
        isShow: false
      }, {
        name: '其他',
        site: null,
        icon: 'autocar',
        type: '4',
        isShow: true
      }]
    };
  },

  computed: extends_default()({}, Object(vuex_esm["c" /* mapState */])({
    token: function token(state) {
      return state.token;
    },
    studentId: function studentId(state) {
      return state.userInfo.id;
    },
    flowId: function flowId(state) {
      return state.flowInfo.flowId;
    },
    flowType: function flowType(state) {
      return state.flowInfo.flowType;
    },
    title: function title(state) {
      return state.currentProcedureInfo.name;
    },
    flowProcedureId: function flowProcedureId(state) {
      return state.currentProcedureInfo.flowProcedureId;
    },
    procedureId: function procedureId(state) {
      return state.currentProcedureInfo.procedureId;
    },
    parentRouter: function parentRouter(state) {
      return state.currentProcedureInfo.parentRouter;
    }
  }), {
    status: function status() {
      return this.$route.params.status;
    }
  }),
  created: function created() {},
  mounted: function mounted() {
    this.getCarList();
  },
  updated: function updated() {},
  destroyed: function destroyed() {},

  watch: {},
  methods: {
    back: function back() {
      var _this = this;

      setTimeout(function () {

        _this.$router.push({
          name: _this.parentRouter
        });
      }, 300);
    },
    getCarList: function getCarList() {
      var _this2 = this;

      var params = {
        flowId: this.flowId,
        flowProcedureId: this.flowProcedureId,
        procedureId: this.procedureId
      };
      this.$api.get('/configWayToSchool', params, function (r) {
        _this2.airplane = r.data.filter(function (item) {
          if (item.transportation === '1') {
            return true;
          }
        });
        _this2.train = r.data.filter(function (item) {
          if (item.transportation === '2') {
            return true;
          }
        });
        _this2.car = r.data.filter(function (item) {
          if (item.transportation === '3') {
            return true;
          }
        });
        if (_this2.airplane.length > 0) {
          _this2.traffic[0].isShow = true;
        }
        if (_this2.train.length > 0) {
          _this2.traffic[1].isShow = true;
        }
        if (_this2.car.length > 0) {
          _this2.traffic[2].isShow = true;
        }
      }, function (err) {
        _this2.$vux.toast.text(err.message, 'top');
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e067274e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/yingxin/tskjxy/views/items/car.vue
var car_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('x-header',{staticClass:"header bg-white box-shadow"},[_c('em',{staticClass:"icon icon-arrow-left",attrs:{"slot":"overwrite-left","size":""},on:{"click":_vm.back},slot:"overwrite-left"}),_vm._v(_vm._s(_vm.title))]),_c('section',{staticClass:"section"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"panel"},[_vm._m(0),_c('div',{staticClass:"panel-body car-panel"},[_c('grid',{attrs:{"show-lr-borders":false,"show-vertical-dividers":false,"cols":2}},_vm._l((_vm.traffic),function(item,index){return (item.isShow)?_c('grid-item',{key:index,attrs:{"link":{name: 'carInfo',params:{way: item.name, type: item.type, status: _vm.status, isEdit: _vm.isEdit,}}}},[_c('ul',{class:("car-bg" + (index+1))},[_c('li',{staticClass:"picture"},[_c('em',{staticClass:"icon",class:("icon-" + (item.icon))})]),_c('li',{staticClass:"name"},[_vm._v(_vm._s(item.name))])])]):_vm._e()}),1)],1)])])]),_c('transition',{attrs:{"name":"slide","enter-active-class":"animated fastest slideInUp","leave-active-class":"animated fastest slideOutDown"}},[_c('router-view')],1)],1)}
var car_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"panel-header"},[_c('h4',{staticClass:"float-left text-gary"},[_vm._v("交通工具")])])}]
var car_esExports = { render: car_render, staticRenderFns: car_staticRenderFns }
/* harmony default export */ var views_items_car = (car_esExports);
// CONCATENATED MODULE: ./src/yingxin/tskjxy/views/items/car.vue
function car_injectStyle (ssrContext) {
  __webpack_require__("01kQ")
}
var car_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var car___vue_template_functional__ = false
/* styles */
var car___vue_styles__ = car_injectStyle
/* scopeId */
var car___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var car___vue_module_identifier__ = null
var car_Component = car_normalizeComponent(
  items_car,
  views_items_car,
  car___vue_template_functional__,
  car___vue_styles__,
  car___vue_scopeId__,
  car___vue_module_identifier__
)

/* harmony default export */ var tskjxy_views_items_car = (car_Component.exports);

// EXTERNAL MODULE: ./node_modules/vux/src/components/flexbox/flexbox.vue + 3 modules
var flexbox_flexbox = __webpack_require__("YxJB");

// EXTERNAL MODULE: ./node_modules/vux/src/components/flexbox/flexbox-item.vue + 3 modules
var flexbox_item = __webpack_require__("3Lt7");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/x-switch/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var x_switch = ({
  name: 'x-switch',
  components: {
    InlineDesc: vux_src_components_inline_desc
  },
  computed: {
    labelStyle: function labelStyle() {
      var isHTML = /<\/?[^>]*>/.test(this.title);
      var width = Math.min(isHTML ? 5 : this.title.length + 1, 14) + 'em';
      return Object(clean_style["a" /* default */])({
        display: 'block',
        width: this.$parent.labelWidth || width,
        textAlign: this.$parent.labelAlign
      });
    },
    labelClass: function labelClass() {
      return {
        'vux-cell-justify': this.$parent && this.$parent.labelAlign === 'justify'
      };
    }
  },
  methods: {
    onClick: function onClick() {
      this.$emit('on-click', !this.currentValue, this.currentValue);
    },
    toBoolean: function toBoolean(val) {
      if (!this.valueMap) {
        return val;
      } else {
        var index = this.valueMap.indexOf(val);
        return index === 1;
      }
    },
    toRaw: function toRaw(val) {
      if (!this.valueMap) {
        return val;
      } else {
        return this.valueMap[val ? 1 : 0];
      }
    }
  },
  props: {
    title: {
      type: String,
      required: true
    },
    disabled: Boolean,
    value: {
      type: [Boolean, String, Number],
      default: false
    },
    inlineDesc: [String, Boolean, Number],
    preventDefault: Boolean,
    valueMap: {
      type: Array,
      default: function _default() {
        return [false, true];
      }
    }
  },
  data: function data() {
    return {
      currentValue: this.toBoolean(this.value)
    };
  },

  watch: {
    currentValue: function currentValue(val) {
      var rawValue = this.toRaw(val);
      this.$emit('input', rawValue);
      this.$emit('on-change', rawValue);
    },
    value: function value(val) {
      this.currentValue = this.toBoolean(val);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/x-switch/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var components_x_switch = ({
  name: 'x-switch',
  components: {
    InlineDesc: vux_src_components_inline_desc
  },
  computed: {
    labelStyle: function labelStyle() {
      var isHTML = /<\/?[^>]*>/.test(this.title);
      var width = Math.min(isHTML ? 5 : this.title.length + 1, 14) + 'em';
      return Object(clean_style["a" /* default */])({
        display: 'block',
        width: this.$parent.labelWidth || width,
        textAlign: this.$parent.labelAlign
      });
    },
    labelClass: function labelClass() {
      return {
        'vux-cell-justify': this.$parent && this.$parent.labelAlign === 'justify'
      };
    }
  },
  methods: {
    onClick: function onClick() {
      this.$emit('on-click', !this.currentValue, this.currentValue);
    },
    toBoolean: function toBoolean(val) {
      if (!this.valueMap) {
        return val;
      } else {
        var index = this.valueMap.indexOf(val);
        return index === 1;
      }
    },
    toRaw: function toRaw(val) {
      if (!this.valueMap) {
        return val;
      } else {
        return this.valueMap[val ? 1 : 0];
      }
    }
  },
  props: {
    title: {
      type: String,
      required: true
    },
    disabled: Boolean,
    value: {
      type: [Boolean, String, Number],
      default: false
    },
    inlineDesc: [String, Boolean, Number],
    preventDefault: Boolean,
    valueMap: {
      type: Array,
      default: function _default() {
        return [false, true];
      }
    }
  },
  data: function data() {
    return {
      currentValue: this.toBoolean(this.value)
    };
  },

  watch: {
    currentValue: function currentValue(val) {
      var rawValue = this.toRaw(val);
      this.$emit('input', rawValue);
      this.$emit('on-change', rawValue);
    },
    value: function value(val) {
      this.currentValue = this.toBoolean(val);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-50bd6926","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/x-switch/index.vue
var x_switch_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-x-switch weui-cell weui-cell_switch"},[_c('div',{staticClass:"weui-cell__bd"},[_c('label',{staticClass:"weui-label",class:_vm.labelClass,style:(_vm.labelStyle),domProps:{"innerHTML":_vm._s(_vm.title)}}),_vm._v(" "),(_vm.inlineDesc)?_c('inline-desc',[_vm._v(_vm._s(_vm.inlineDesc))]):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"weui-cell__ft"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentValue),expression:"currentValue"}],staticClass:"weui-switch",attrs:{"type":"checkbox","disabled":_vm.disabled},domProps:{"checked":Array.isArray(_vm.currentValue)?_vm._i(_vm.currentValue,null)>-1:(_vm.currentValue)},on:{"change":function($event){var $$a=_vm.currentValue,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.currentValue=$$a.concat([$$v]))}else{$$i>-1&&(_vm.currentValue=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.currentValue=$$c}}}}),_vm._v(" "),(_vm.preventDefault)?_c('div',{staticClass:"vux-x-switch-overlay",on:{"click":_vm.onClick}}):_vm._e()])])}
var x_switch_staticRenderFns = []
var x_switch_esExports = { render: x_switch_render, staticRenderFns: x_switch_staticRenderFns }
/* harmony default export */ var src_components_x_switch = (x_switch_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/x-switch/index.vue
function x_switch_injectStyle (ssrContext) {
  __webpack_require__("kEC1")
}
var x_switch_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var x_switch___vue_template_functional__ = false
/* styles */
var x_switch___vue_styles__ = x_switch_injectStyle
/* scopeId */
var x_switch___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var x_switch___vue_module_identifier__ = null
var x_switch_Component = x_switch_normalizeComponent(
  components_x_switch,
  src_components_x_switch,
  x_switch___vue_template_functional__,
  x_switch___vue_styles__,
  x_switch___vue_scopeId__,
  x_switch___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_x_switch = (x_switch_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/x-number/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var Big = __webpack_require__("gaXx");
/* harmony default export */ var x_number = ({
  name: 'x-number',
  props: {
    min: Number,
    max: Number,
    readonly: Boolean,
    step: {
      type: Number,
      default: 1
    },
    value: {
      validator: function validator(value) {
        if (typeof value === 'number') {
          return true;
        } else if (typeof value === 'string') {
          return value === '';
        }
        return false;
      },

      default: 0
    },
    name: String,
    title: String,
    fillable: {
      type: Boolean,
      default: false
    },
    width: {
      type: String,
      default: '50px'
    },
    buttonStyle: {
      type: String,
      default: 'square'
    },
    align: {
      type: String,
      default: 'right'
    }
  },
  created: function created() {
    this.currentValue = this.value;
  },
  data: function data() {
    return {
      currentValue: 0
    };
  },

  computed: {
    disabledMin: function disabledMin() {
      return typeof this.min === 'undefined' ? false : this.currentValue === '' ? true : this.currentValue <= this.min;
    },
    disabledMax: function disabledMax() {
      return typeof this.max === 'undefined' ? false : this.currentValue === '' ? true : this.currentValue >= this.max;
    },
    labelClass: function labelClass() {
      return {
        'vux-cell-justify': this.$parent.labelAlign === 'justify' || this.$parent.$parent.labelAlign === 'justify'
      };
    }
  },
  watch: {
    currentValue: function currentValue(newValue, old) {
      if (newValue !== '') {
        if (typeof this.min !== 'undefined' && this.currentValue < this.min) {
          this.currentValue = this.min;
        }
        if (this.max && this.currentValue > this.max) {
          this.currentValue = this.max;
        }
      }
      this.$emit('input', this.currentValue);
    },
    value: function value(newValue) {
      this.currentValue = newValue;
      this.$emit('on-change', newValue);
    }
  },
  methods: {
    add: function add() {
      if (!this.disabledMax) {
        var x = new Big(this.currentValue);
        this.currentValue = x.plus(this.step) * 1;
      }
    },
    sub: function sub() {
      if (!this.disabledMin) {
        var x = new Big(this.currentValue);
        this.currentValue = x.minus(this.step) * 1;
      }
    },
    blur: function blur() {
      if (this.currentValue === '') {
        this.currentValue = 0;
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/x-number/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var x_number_Big = __webpack_require__("gaXx");
/* harmony default export */ var components_x_number = ({
  name: 'x-number',
  props: {
    min: Number,
    max: Number,
    readonly: Boolean,
    step: {
      type: Number,
      default: 1
    },
    value: {
      validator: function validator(value) {
        if (typeof value === 'number') {
          return true;
        } else if (typeof value === 'string') {
          return value === '';
        }
        return false;
      },

      default: 0
    },
    name: String,
    title: String,
    fillable: {
      type: Boolean,
      default: false
    },
    width: {
      type: String,
      default: '50px'
    },
    buttonStyle: {
      type: String,
      default: 'square'
    },
    align: {
      type: String,
      default: 'right'
    }
  },
  created: function created() {
    this.currentValue = this.value;
  },
  data: function data() {
    return {
      currentValue: 0
    };
  },

  computed: {
    disabledMin: function disabledMin() {
      return typeof this.min === 'undefined' ? false : this.currentValue === '' ? true : this.currentValue <= this.min;
    },
    disabledMax: function disabledMax() {
      return typeof this.max === 'undefined' ? false : this.currentValue === '' ? true : this.currentValue >= this.max;
    },
    labelClass: function labelClass() {
      return {
        'vux-cell-justify': this.$parent.labelAlign === 'justify' || this.$parent.$parent.labelAlign === 'justify'
      };
    }
  },
  watch: {
    currentValue: function currentValue(newValue, old) {
      if (newValue !== '') {
        if (typeof this.min !== 'undefined' && this.currentValue < this.min) {
          this.currentValue = this.min;
        }
        if (this.max && this.currentValue > this.max) {
          this.currentValue = this.max;
        }
      }
      this.$emit('input', this.currentValue);
    },
    value: function value(newValue) {
      this.currentValue = newValue;
      this.$emit('on-change', newValue);
    }
  },
  methods: {
    add: function add() {
      if (!this.disabledMax) {
        var x = new x_number_Big(this.currentValue);
        this.currentValue = x.plus(this.step) * 1;
      }
    },
    sub: function sub() {
      if (!this.disabledMin) {
        var x = new x_number_Big(this.currentValue);
        this.currentValue = x.minus(this.step) * 1;
      }
    },
    blur: function blur() {
      if (this.currentValue === '') {
        this.currentValue = 0;
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8d7cecf2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/x-number/index.vue
var x_number_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"weui-cell"},[_c('div',[_c('p',{class:_vm.labelClass,style:({width: _vm.$parent.labelWidth, textAlign: _vm.$parent.labelAlign, marginRight: _vm.$parent.labelMarginRight}),domProps:{"innerHTML":_vm._s(_vm.title)}})]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.readonly),expression:"!readonly"}],staticClass:"weui-cell__ft vux-cell-primary",class:{'vux-number-round': _vm.buttonStyle === 'round'},staticStyle:{"font-size":"0"}},[_c('div',{style:({float:_vm.align})},[_c('a',{staticClass:"vux-number-selector vux-number-selector-sub",class:{'vux-number-disabled':_vm.disabledMin},on:{"click":_vm.sub}},[_c('svg',{attrs:{"viewBox":"0 0 1024 1024","version":"1.1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","width":"18","height":"18"}},[_c('defs'),_c('path',{attrs:{"d":"M863.74455 544.00086 163.424056 544.00086c-17.664722 0-32.00086-14.336138-32.00086-32.00086s14.336138-32.00086 32.00086-32.00086l700.320495 0c17.695686 0 31.99914 14.336138 31.99914 32.00086S881.440237 544.00086 863.74455 544.00086z"}})])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.currentValue),expression:"currentValue",modifiers:{"number":true}}],staticClass:"vux-number-input",style:({width: _vm.width}),attrs:{"name":_vm.name,"readonly":!_vm.fillable,"pattern":"[0-9]*","type":"number"},domProps:{"value":(_vm.currentValue)},on:{"blur":[_vm.blur,function($event){return _vm.$forceUpdate()}],"input":function($event){if($event.target.composing){ return; }_vm.currentValue=_vm._n($event.target.value)}}}),_vm._v(" "),_c('a',{staticClass:"vux-number-selector vux-number-selector-plus",class:{'vux-number-disabled':_vm.disabledMax},on:{"click":_vm.add}},[_c('svg',{attrs:{"viewBox":"0 0 1024 1024","version":"1.1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","width":"20","height":"20"}},[_c('defs'),_c('path',{attrs:{"d":"M863.328262 481.340895l-317.344013 0.099772L545.984249 162.816826c0-17.664722-14.336138-32.00086-32.00086-32.00086s-31.99914 14.336138-31.99914 32.00086l0 318.400215-322.368714-0.17718c-0.032684 0-0.063647 0-0.096331 0-17.632039 0-31.935493 14.239806-32.00086 31.904529-0.096331 17.664722 14.208843 32.031824 31.871845 32.095471l322.59234 0.17718 0 319.167424c0 17.695686 14.336138 32.00086 31.99914 32.00086s32.00086-14.303454 32.00086-32.00086L545.982529 545.440667l317.087703-0.099772c0.063647 0 0.096331 0 0.127295 0 17.632039 0 31.935493-14.239806 32.00086-31.904529S880.960301 481.404542 863.328262 481.340895z"}})])])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.readonly),expression:"readonly"}],staticClass:"weui-cell__ft vux-cell-primary"},[_vm._v("\n    "+_vm._s(_vm.value)+"\n  ")])])}
var x_number_staticRenderFns = []
var x_number_esExports = { render: x_number_render, staticRenderFns: x_number_staticRenderFns }
/* harmony default export */ var src_components_x_number = (x_number_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/x-number/index.vue
function x_number_injectStyle (ssrContext) {
  __webpack_require__("/Xfn")
}
var x_number_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var x_number___vue_template_functional__ = false
/* styles */
var x_number___vue_styles__ = x_number_injectStyle
/* scopeId */
var x_number___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var x_number___vue_module_identifier__ = null
var x_number_Component = x_number_normalizeComponent(
  components_x_number,
  src_components_x_number,
  x_number___vue_template_functional__,
  x_number___vue_styles__,
  x_number___vue_scopeId__,
  x_number___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_x_number = (x_number_Component.exports);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/defineProperty.js
var defineProperty = __webpack_require__("bOdI");
var defineProperty_default = /*#__PURE__*/__webpack_require__.n(defineProperty);

// EXTERNAL MODULE: ./node_modules/vux/src/components/datetime/format.js
var datetime_format = __webpack_require__("ghQH");

// EXTERNAL MODULE: ./node_modules/vux/src/components/inline-calendar/util.js
var util = __webpack_require__("1bLG");

// EXTERNAL MODULE: ./node_modules/vux/src/components/inline-calendar/props.js
var inline_calendar_props = __webpack_require__("0sN4");

// EXTERNAL MODULE: ./node_modules/vux/src/mixins/calendar-marks.js
var calendar_marks = __webpack_require__("o6oK");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/inline-calendar/index.vue


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var inline_calendar = ({
  name: 'inline-calendar',
  mixins: [calendar_marks["a" /* default */]],
  props: Object(inline_calendar_props["a" /* default */])(),
  data: function data() {
    return {
      multi: false,
      year: 0,
      month: 0,
      days: [],
      today: Object(datetime_format["a" /* default */])(new Date(), 'YYYY-MM-DD'),
      months: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12'],
      currentValue: '',
      viewChangeEventCount: -1
    };
  },
  created: function created() {
    this.currentValue = this.value;
    this.multi = Object.prototype.toString.call(this.currentValue) === '[object Array]';

    if (this.multi) {
      for (var i = 0; i < this.currentValue.length; i++) {
        this.$set(this.currentValue, i, this.convertDate(this.currentValue[i]));
      }
    } else {
      this.currentValue = this.convertDate(this.currentValue);
    }

    this.render(this.renderMonth[0], this.renderMonth[1] - 1);
  },

  computed: {
    _weeksList: function _weeksList() {
      if (this.weeksList && this.weeksList.length) {
        return this.weeksList;
      }
      if (!this.weeksList || !this.weeksList.length) {
        // tip for older vux-loader
        if (false) {
          if (process.env.NODE_ENV === 'development') {
            console.warn('[VUX warn] 抱歉，inline-calendar 组件需要升级 vux-loader 到最新版本才能正常使用');
          }
          return ['日', '一', '二', '三', '四', '五', '六'];
        } else {
          if (false) {
            // eslint-disable-line
            return ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'];
          } else if (true) {
            // eslint-disable-line
            return ['日', '一', '二', '三', '四', '五', '六'];
          } else if (V_LOCALE === 'MULTI') {
            // eslint-disable-line
            return [0, 0, 0, 0, 0, 0, 0];
          }
        }
      }
    },
    _replaceTextList: function _replaceTextList() {
      var rs = {};
      for (var i in this.replaceTextList) {
        rs[this.convertDate(i)] = this.replaceTextList[i];
      }
      return rs;
    },
    currentYearMonth: function currentYearMonth() {
      return this.year + this.month;
    }
  },
  watch: {
    value: function value(val) {
      this.currentValue = this.multi ? val : this.convertDate(val);
    },
    currentValue: function currentValue(val, oldVal) {
      this.$emit('input', this.currentValue);
      this.$emit('on-change', this.currentValue);

      if (this.renderOnValueChange) {
        // if on the same year+month, stay quiet
        if (val && oldVal && val.slice(0, 7) === oldVal.slice(0, 7)) {
          return;
        }
        this.render(null, null, 'value change');
      }
    },
    renderFunction: function renderFunction() {
      this.render(this.year, this.month, this.currentValue);
    },
    renderMonth: function renderMonth(val) {
      if (val && val.length === 2) {
        this.render(val[0], val[1] - 1);
      }
    },
    returnSixRows: function returnSixRows(val) {
      this.render(this.year, this.month);
    },
    startDate: function startDate(val) {
      this.render(this.year, this.month);
    },
    endDate: function endDate(val) {
      this.render(this.year, this.month);
    },
    disablePast: function disablePast() {
      this.render(this.year, this.month);
    },
    disableFuture: function disableFuture() {
      this.render(this.year, this.month);
    },
    currentYearMonth: function currentYearMonth() {
      var lastLine = this.days[this.days.length - 1];
      var lastDate = lastLine[lastLine.length - 1];

      var days = [];
      this.days.forEach(function (line) {
        days = days.concat(line);
      });
      days = days.filter(function (date) {
        return !date.isLastMonth && !date.isNextMonth;
      });
      this.viewChangeEventCount++;
      this.$emit('on-view-change', {
        year: this.year,
        month: this.month + 1,
        firstDate: this.days[0][0].formatedDate,
        lastDate: lastDate.formatedDate,
        firstCurrentMonthDate: days[0].formatedDate,
        lastCurrentMonthDate: days[days.length - 1].formatedDate,
        allDates: this.days
      }, this.viewChangeEventCount);
    }
  },
  methods: {
    processDateItem: function processDateItem(item) {
      var temp = JSON.parse(stringify_default()(item));
      temp.isDisabled = this.isDisabled(item);
      temp.isBetween = this.isBetween(item.formatedDate);
      return temp;
    },
    isBetween: function isBetween(formatedDate) {
      return Object(util["b" /* isBetween */])(formatedDate, this.disablePast, this.disableFuture, this.startDate, this.endDate);
    },
    isDisabled: function isDisabled(date) {
      var disabled = !this.isBetween(date.formatedDate);
      disabled = disabled || date.isWeekend && this.disableWeekend;
      disabled = disabled || date.isNextMonth || date.isLastMonth;

      if (!this.disableDateFunction) {
        return disabled;
      } else {
        var value = this.disableDateFunction(date);
        if (typeof value === 'undefined') {
          return disabled;
        } else {
          return value;
        }
      }
    },
    switchViewToToday: function switchViewToToday() {
      var today = new Date();
      this.render(today.getFullYear(), today.getMonth());
    },
    switchViewToCurrentValue: function switchViewToCurrentValue() {
      if (!this.currentValue || this.multi && !this.currentValue.length) {
        return;
      }

      var value = void 0;
      var year = void 0;
      var month = void 0;
      if (typeof this.currentValue === 'string') {
        value = this.currentValue;
      } else {
        value = this.currentValue[0];
      }
      var splitList = value.split('-');
      year = parseInt(splitList[0], 10);
      month = parseInt(splitList[1], 10);
      this.switchViewToMonth(year, month);
    },
    switchViewToMonth: function switchViewToMonth(year, month) {
      if (!year || !month) {
        return this.switchViewToToday();
      }
      this.render(year, month - 1);
    },
    getDates: function getDates() {
      return this.days;
    },
    replaceText: function replaceText(day, formatDay) {
      var text = this._replaceTextList[formatDay];
      if (!text && typeof text === 'undefined') {
        return day;
      } else {
        return text;
      }
    },
    convertDate: function convertDate(date) {
      return date === 'TODAY' ? this.today : date;
    },
    buildClass: function buildClass(index, child) {
      var isCurrent = false;
      if (!child.isLastMonth && !child.isNextMonth) {
        if (this.multi && this.currentValue.length > 0) {
          isCurrent = this.currentValue.indexOf(this.formatDate(this.year, this.month, child)) > -1;
        } else {
          isCurrent = this.currentValue === this.formatDate(this.year, this.month, child);
        }
      }
      var className = defineProperty_default()({
        'current': isCurrent,
        'is-disabled': this.isDisabled(child),
        'is-today': child.isToday
      }, 'is-week-' + index, true);
      return className;
    },
    render: function render(year, month) {
      var force = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

      var data = null;
      var value = this.multi ? this.currentValue[this.currentValue.length - 1] : this.currentValue;
      data = Object(util["a" /* getDays */])({
        year: year,
        month: month,
        value: value,
        rangeBegin: this.convertDate(this.startDate),
        rangeEnd: this.convertDate(this.endDate),
        returnSixRows: this.returnSixRows,
        disablePast: this.disablePast,
        disableFuture: this.disableFuture
      });

      if (this.year === data.year && this.month === data.month && !force) {
        return;
      }
      this.year = data.year;
      this.month = data.month;
      this.days = data.days;
    },

    formatDate: function formatDate(year, month, child) {
      return [year, Object(util["c" /* zero */])(child.month + 1), Object(util["c" /* zero */])(child.day)].join('-');
    },
    prev: function prev() {
      if (this.month === 0) {
        this.month = 11;
        this.year = this.year - 1;
      } else {
        this.month = this.month - 1;
      }
      this.render(this.year, this.month, true);
    },
    next: function next() {
      if (this.month === 11) {
        this.month = 0;
        this.year = this.year + 1;
      } else {
        this.month = this.month + 1;
      }
      this.render(this.year, this.month, true);
    },
    go: function go(year, month) {
      this.render(year, month, true);
    },
    select: function select(k1, k2, data) {
      if (data.isLastMonth && !this.showLastMonth) {
        return;
      }
      if (data.isNextMonth && !this.showNextMonth) {
        return;
      }
      if (!this.isBetween(data.formatedDate)) {
        return;
      }

      if (this.isDisabled(data)) {
        // not in range
        if (!this.isBetween(data.formatedDate)) {
          return;
        } else {
          // in range but disabled by disableDateFunction
          if (this.disableDateFunction && this.disableDateFunction(data)) {
            return;
          }
          if (data.isWeekend && this.disableWeekend) {
            return;
          }
        }
      }
      var _currentValue = null;
      if (!data.isLastMonth && !data.isNextMonth) {
        this.days[k1][k2].current = true;
        _currentValue = [this.year, Object(util["c" /* zero */])(this.month + 1), Object(util["c" /* zero */])(this.days[k1][k2].day)].join('-');
      } else {
        _currentValue = [data.year, Object(util["c" /* zero */])(data.month + 1), Object(util["c" /* zero */])(data.day)].join('-');
      }
      if (this.multi) {
        var index = this.currentValue.indexOf(_currentValue);
        if (index > -1) {
          this.currentValue.splice(index, 1);
        } else {
          this.currentValue.push(_currentValue);
        }
      } else {
        this.currentValue = _currentValue;
        this.$emit('on-select-single-date', this.currentValue);
      }

      if (this.multi) {
        for (var i = 0; i < this.currentValue.length; i++) {
          this.$set(this.currentValue, i, this.convertDate(this.currentValue[i]));
        }
      } else {
        this.currentValue = this.convertDate(this.currentValue);
      }

      if (this.renderOnValueChange) {
        this.render(null, null);
      }
    },
    showChild: function showChild(year, month, child) {
      if (this.replaceText(child.day, this.formatDate(year, month, child))) {
        return !child.isLastMonth && !child.isNextMonth || child.isLastMonth && this.showLastMonth || child.isNextMonth && this.showNextMonth;
      } else {
        return false;
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/inline-calendar/index.vue


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var components_inline_calendar = ({
  name: 'inline-calendar',
  mixins: [calendar_marks["a" /* default */]],
  props: Object(inline_calendar_props["a" /* default */])(),
  data: function data() {
    return {
      multi: false,
      year: 0,
      month: 0,
      days: [],
      today: Object(datetime_format["a" /* default */])(new Date(), 'YYYY-MM-DD'),
      months: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12'],
      currentValue: '',
      viewChangeEventCount: -1
    };
  },
  created: function created() {
    this.currentValue = this.value;
    this.multi = Object.prototype.toString.call(this.currentValue) === '[object Array]';

    if (this.multi) {
      for (var i = 0; i < this.currentValue.length; i++) {
        this.$set(this.currentValue, i, this.convertDate(this.currentValue[i]));
      }
    } else {
      this.currentValue = this.convertDate(this.currentValue);
    }

    this.render(this.renderMonth[0], this.renderMonth[1] - 1);
  },

  computed: {
    _weeksList: function _weeksList() {
      if (this.weeksList && this.weeksList.length) {
        return this.weeksList;
      }
      if (!this.weeksList || !this.weeksList.length) {
        // tip for older vux-loader
        if (false) {
          if (process.env.NODE_ENV === 'development') {
            console.warn('[VUX warn] 抱歉，inline-calendar 组件需要升级 vux-loader 到最新版本才能正常使用');
          }
          return ['日', '一', '二', '三', '四', '五', '六'];
        } else {
          if (false) {
            // eslint-disable-line
            return ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'];
          } else if (true) {
            // eslint-disable-line
            return ['日', '一', '二', '三', '四', '五', '六'];
          } else if (V_LOCALE === 'MULTI') {
            // eslint-disable-line
            return [0, 0, 0, 0, 0, 0, 0];
          }
        }
      }
    },
    _replaceTextList: function _replaceTextList() {
      var rs = {};
      for (var i in this.replaceTextList) {
        rs[this.convertDate(i)] = this.replaceTextList[i];
      }
      return rs;
    },
    currentYearMonth: function currentYearMonth() {
      return this.year + this.month;
    }
  },
  watch: {
    value: function value(val) {
      this.currentValue = this.multi ? val : this.convertDate(val);
    },
    currentValue: function currentValue(val, oldVal) {
      this.$emit('input', this.currentValue);
      this.$emit('on-change', this.currentValue);

      if (this.renderOnValueChange) {
        // if on the same year+month, stay quiet
        if (val && oldVal && val.slice(0, 7) === oldVal.slice(0, 7)) {
          return;
        }
        this.render(null, null, 'value change');
      }
    },
    renderFunction: function renderFunction() {
      this.render(this.year, this.month, this.currentValue);
    },
    renderMonth: function renderMonth(val) {
      if (val && val.length === 2) {
        this.render(val[0], val[1] - 1);
      }
    },
    returnSixRows: function returnSixRows(val) {
      this.render(this.year, this.month);
    },
    startDate: function startDate(val) {
      this.render(this.year, this.month);
    },
    endDate: function endDate(val) {
      this.render(this.year, this.month);
    },
    disablePast: function disablePast() {
      this.render(this.year, this.month);
    },
    disableFuture: function disableFuture() {
      this.render(this.year, this.month);
    },
    currentYearMonth: function currentYearMonth() {
      var lastLine = this.days[this.days.length - 1];
      var lastDate = lastLine[lastLine.length - 1];

      var days = [];
      this.days.forEach(function (line) {
        days = days.concat(line);
      });
      days = days.filter(function (date) {
        return !date.isLastMonth && !date.isNextMonth;
      });
      this.viewChangeEventCount++;
      this.$emit('on-view-change', {
        year: this.year,
        month: this.month + 1,
        firstDate: this.days[0][0].formatedDate,
        lastDate: lastDate.formatedDate,
        firstCurrentMonthDate: days[0].formatedDate,
        lastCurrentMonthDate: days[days.length - 1].formatedDate,
        allDates: this.days
      }, this.viewChangeEventCount);
    }
  },
  methods: {
    processDateItem: function processDateItem(item) {
      var temp = JSON.parse(stringify_default()(item));
      temp.isDisabled = this.isDisabled(item);
      temp.isBetween = this.isBetween(item.formatedDate);
      return temp;
    },
    isBetween: function isBetween(formatedDate) {
      return Object(util["b" /* isBetween */])(formatedDate, this.disablePast, this.disableFuture, this.startDate, this.endDate);
    },
    isDisabled: function isDisabled(date) {
      var disabled = !this.isBetween(date.formatedDate);
      disabled = disabled || date.isWeekend && this.disableWeekend;
      disabled = disabled || date.isNextMonth || date.isLastMonth;

      if (!this.disableDateFunction) {
        return disabled;
      } else {
        var value = this.disableDateFunction(date);
        if (typeof value === 'undefined') {
          return disabled;
        } else {
          return value;
        }
      }
    },
    switchViewToToday: function switchViewToToday() {
      var today = new Date();
      this.render(today.getFullYear(), today.getMonth());
    },
    switchViewToCurrentValue: function switchViewToCurrentValue() {
      if (!this.currentValue || this.multi && !this.currentValue.length) {
        return;
      }

      var value = void 0;
      var year = void 0;
      var month = void 0;
      if (typeof this.currentValue === 'string') {
        value = this.currentValue;
      } else {
        value = this.currentValue[0];
      }
      var splitList = value.split('-');
      year = parseInt(splitList[0], 10);
      month = parseInt(splitList[1], 10);
      this.switchViewToMonth(year, month);
    },
    switchViewToMonth: function switchViewToMonth(year, month) {
      if (!year || !month) {
        return this.switchViewToToday();
      }
      this.render(year, month - 1);
    },
    getDates: function getDates() {
      return this.days;
    },
    replaceText: function replaceText(day, formatDay) {
      var text = this._replaceTextList[formatDay];
      if (!text && typeof text === 'undefined') {
        return day;
      } else {
        return text;
      }
    },
    convertDate: function convertDate(date) {
      return date === 'TODAY' ? this.today : date;
    },
    buildClass: function buildClass(index, child) {
      var isCurrent = false;
      if (!child.isLastMonth && !child.isNextMonth) {
        if (this.multi && this.currentValue.length > 0) {
          isCurrent = this.currentValue.indexOf(this.formatDate(this.year, this.month, child)) > -1;
        } else {
          isCurrent = this.currentValue === this.formatDate(this.year, this.month, child);
        }
      }
      var className = defineProperty_default()({
        'current': isCurrent,
        'is-disabled': this.isDisabled(child),
        'is-today': child.isToday
      }, 'is-week-' + index, true);
      return className;
    },
    render: function render(year, month) {
      var force = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

      var data = null;
      var value = this.multi ? this.currentValue[this.currentValue.length - 1] : this.currentValue;
      data = Object(util["a" /* getDays */])({
        year: year,
        month: month,
        value: value,
        rangeBegin: this.convertDate(this.startDate),
        rangeEnd: this.convertDate(this.endDate),
        returnSixRows: this.returnSixRows,
        disablePast: this.disablePast,
        disableFuture: this.disableFuture
      });

      if (this.year === data.year && this.month === data.month && !force) {
        return;
      }
      this.year = data.year;
      this.month = data.month;
      this.days = data.days;
    },

    formatDate: function formatDate(year, month, child) {
      return [year, Object(util["c" /* zero */])(child.month + 1), Object(util["c" /* zero */])(child.day)].join('-');
    },
    prev: function prev() {
      if (this.month === 0) {
        this.month = 11;
        this.year = this.year - 1;
      } else {
        this.month = this.month - 1;
      }
      this.render(this.year, this.month, true);
    },
    next: function next() {
      if (this.month === 11) {
        this.month = 0;
        this.year = this.year + 1;
      } else {
        this.month = this.month + 1;
      }
      this.render(this.year, this.month, true);
    },
    go: function go(year, month) {
      this.render(year, month, true);
    },
    select: function select(k1, k2, data) {
      if (data.isLastMonth && !this.showLastMonth) {
        return;
      }
      if (data.isNextMonth && !this.showNextMonth) {
        return;
      }
      if (!this.isBetween(data.formatedDate)) {
        return;
      }

      if (this.isDisabled(data)) {
        // not in range
        if (!this.isBetween(data.formatedDate)) {
          return;
        } else {
          // in range but disabled by disableDateFunction
          if (this.disableDateFunction && this.disableDateFunction(data)) {
            return;
          }
          if (data.isWeekend && this.disableWeekend) {
            return;
          }
        }
      }
      var _currentValue = null;
      if (!data.isLastMonth && !data.isNextMonth) {
        this.days[k1][k2].current = true;
        _currentValue = [this.year, Object(util["c" /* zero */])(this.month + 1), Object(util["c" /* zero */])(this.days[k1][k2].day)].join('-');
      } else {
        _currentValue = [data.year, Object(util["c" /* zero */])(data.month + 1), Object(util["c" /* zero */])(data.day)].join('-');
      }
      if (this.multi) {
        var index = this.currentValue.indexOf(_currentValue);
        if (index > -1) {
          this.currentValue.splice(index, 1);
        } else {
          this.currentValue.push(_currentValue);
        }
      } else {
        this.currentValue = _currentValue;
        this.$emit('on-select-single-date', this.currentValue);
      }

      if (this.multi) {
        for (var i = 0; i < this.currentValue.length; i++) {
          this.$set(this.currentValue, i, this.convertDate(this.currentValue[i]));
        }
      } else {
        this.currentValue = this.convertDate(this.currentValue);
      }

      if (this.renderOnValueChange) {
        this.render(null, null);
      }
    },
    showChild: function showChild(year, month, child) {
      if (this.replaceText(child.day, this.formatDate(year, month, child))) {
        return !child.isLastMonth && !child.isNextMonth || child.isLastMonth && this.showLastMonth || child.isNextMonth && this.showNextMonth;
      } else {
        return false;
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-49308382","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/inline-calendar/index.vue
var inline_calendar_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"inline-calendar",class:{'is-weekend-highlight': _vm.highlightWeekend}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.hideHeader),expression:"!hideHeader"}],staticClass:"calendar-header"},[_c('div',{staticClass:"calendar-year"},[_c('span',{on:{"click":function($event){return _vm.go(_vm.year - 1, _vm.month)}}},[_c('a',{staticClass:"year-prev vux-prev-icon",attrs:{"href":"javascript:"}})]),_vm._v(" "),_c('a',{staticClass:"calendar-year-txt calendar-title",attrs:{"href":"javascript:"}},[_vm._v(_vm._s(_vm.year))]),_vm._v(" "),_c('span',{staticClass:"calendar-header-right-arrow",on:{"click":function($event){return _vm.go(_vm.year + 1, _vm.month)}}},[_c('a',{staticClass:"year-next vux-next-icon",attrs:{"href":"javascript:"}})])]),_vm._v(" "),_c('div',{staticClass:"calendar-month"},[_c('span',{on:{"click":_vm.prev}},[_c('a',{staticClass:"month-prev vux-prev-icon",attrs:{"href":"javascript:"}})]),_vm._v(" "),_c('a',{staticClass:"calendar-month-txt calendar-title",attrs:{"href":"javascript:"}},[_vm._v(_vm._s(_vm.months[_vm.month]))]),_vm._v(" "),_c('span',{staticClass:"calendar-header-right-arrow",on:{"click":_vm.next}},[_c('a',{staticClass:"month-next vux-next-icon",attrs:{"href":"javascript:"}})])])]),_vm._v(" "),_c('table',[_c('thead',{directives:[{name:"show",rawName:"v-show",value:(!_vm.hideWeekList),expression:"!hideWeekList"}]},[_c('tr',_vm._l((_vm._weeksList),function(week,index){return _c('th',{staticClass:"week",class:("is-week-list-" + index)},[_vm._v(_vm._s(week || week))])}),0)]),_vm._v(" "),_c('tbody',_vm._l((_vm.days),function(day,k1){return _c('tr',_vm._l((day),function(child,k2){return _c('td',{class:_vm.buildClass(k2, child),attrs:{"data-date":_vm.formatDate(_vm.year, _vm.month, child),"data-current":_vm.currentValue},on:{"click":function($event){return _vm.select(k1, k2, child)}}},[_vm._t("each-day",[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.showChild(_vm.year, _vm.month, child)),expression:"showChild(year, month, child)"}],staticClass:"vux-calendar-each-date",style:(_vm.getMarkStyle(child))},[_vm._v("\n              "+_vm._s(_vm.replaceText(child.day, _vm.formatDate(_vm.year, _vm.month, child)))+"\n              "),(_vm.isShowTopTip(child))?_c('span',{staticClass:"vux-calendar-top-tip",style:(_vm.isShowTopTip(child, 'style'))},[_c('span',[_vm._v(_vm._s(_vm.isShowTopTip(child, 'text')))])]):_vm._e()]),_vm._v(" "),(_vm.isShowBottomDot(child))?_c('span',{staticClass:"vux-calendar-dot"}):_vm._e(),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showChild(_vm.year, _vm.month, child)),expression:"showChild(year, month, child)"}],domProps:{"innerHTML":_vm._s(_vm.renderFunction(k1, k2, child))}})],{"year":_vm.year,"month":_vm.month,"child":_vm.processDateItem(child)/* deprecated, use date instead */,"date":_vm.processDateItem(child),"className":"vux-calendar-each-date","row":k1,"col":k2,"rawDate":_vm.formatDate(_vm.year, _vm.month, child),"showDate":_vm.replaceText(child.day, _vm.formatDate(_vm.year, _vm.month, child)),"isShow":_vm.showChild(_vm.year, _vm.month, child)})],2)}),0)}),0)])])}
var inline_calendar_staticRenderFns = []
var inline_calendar_esExports = { render: inline_calendar_render, staticRenderFns: inline_calendar_staticRenderFns }
/* harmony default export */ var src_components_inline_calendar = (inline_calendar_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/inline-calendar/index.vue
function inline_calendar_injectStyle (ssrContext) {
  __webpack_require__("0Gh9")
}
var inline_calendar_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var inline_calendar___vue_template_functional__ = false
/* styles */
var inline_calendar___vue_styles__ = inline_calendar_injectStyle
/* scopeId */
var inline_calendar___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var inline_calendar___vue_module_identifier__ = null
var inline_calendar_Component = inline_calendar_normalizeComponent(
  components_inline_calendar,
  src_components_inline_calendar,
  inline_calendar___vue_template_functional__,
  inline_calendar___vue_styles__,
  inline_calendar___vue_scopeId__,
  inline_calendar___vue_module_identifier__
)


/* harmony default export */ var vux_src_components_inline_calendar = (inline_calendar_Component.exports);

// EXTERNAL MODULE: ./node_modules/vux/src/tools/number/pad.js
var pad = __webpack_require__("U0Eg");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/yingxin/tskjxy/views/items/car/carInfo.vue























/* harmony default export */ var car_carInfo = ({
  name: 'info',
  props: [],
  directives: {
    TransferDom: transfer_dom["a" /* default */]
  },
  components: {
    XHeader: vux_src_components_x_header,
    XInput: vux_src_components_x_input,
    Group: vux_src_components_group,
    XButton: vux_src_components_x_button,
    Checker: src_components_checker_checker,
    CheckerItem: src_components_checker_checker_item,
    Flexbox: flexbox_flexbox["a" /* default */],
    FlexboxItem: flexbox_item["a" /* default */],
    PopupHeader: vux_src_components_popup_header,
    Popup: node_modules_vux_src_components_popup,
    Cell: vux_src_components_cell,
    XSwitch: vux_src_components_x_switch,
    XNumber: vux_src_components_x_number,
    InlineCalendar: vux_src_components_inline_calendar,
    'scroller': vuescroll_default.a,
    Confirm: node_modules_vux_src_components_confirm
  },
  data: function data() {
    return {
      isEdit: this.$route.params.isEdit,
      brand: '#FEAA33',
      sites: [],
      dateShow: false,
      isTimes: '',
      carItem: {
        way: this.$route.params.way,
        site: '',
        isTransfer: false,
        personNumber: 1,
        stationDay: '',
        stationTime: '',
        schoolDay: '',
        schoolTime: '',
        isOnTime: false
      },
      carInfo: [],
      timeOps: {
        scrollPanel: {
          scrollingY: false,
          initialScrollX: 480
        },
        bar: {
          background: 'rgba(0, 107, 178, 1)',
          size: '3px',
          opacity: 0
        }
      },
      timeNum: 24,
      selectTime: {
        date: '',
        time: '00:00',
        startDate: '',
        endDate: ''
      },
      siteCueent: '',
      showConfirm: false,
      sureToLeave: false,
      id: '',
      datamanagementId: '',
      btnSavetext: '办理',
      companion: ''
    };
  },

  computed: extends_default()({}, Object(vuex_esm["c" /* mapState */])({
    token: function token(state) {
      return state.token;
    },
    studentId: function studentId(state) {
      return state.userInfo.id;
    },
    flowId: function flowId(state) {
      return state.flowInfo.flowId;
    },
    flowType: function flowType(state) {
      return state.flowInfo.flowType;
    },
    title: function title(state) {
      return state.currentProcedureInfo.name;
    },
    flowProcedureId: function flowProcedureId(state) {
      return state.currentProcedureInfo.flowProcedureId;
    },
    procedureId: function procedureId(state) {
      return state.currentProcedureInfo.procedureId;
    },
    endDate: function endDate(state) {
      return state.currentProcedureInfo.endDate;
    }
  }), {
    type: function type() {
      return this.$route.params.type;
    },
    status: function status() {
      return this.$route.params.status;
    },
    btnDisabled: function btnDisabled() {
      var flag = true;
      if (this.siteCueent === '' && this.type !== '4' || this.carItem.stationDay === '' || this.carItem.schoolDay === '') {
        flag = true;
      } else {
        flag = false;
      }
      return flag;
    }
  }),
  created: function created() {},
  mounted: function mounted() {
    this.getCarList();
  },
  updated: function updated() {},
  destroyed: function destroyed() {},

  watch: {},
  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])(['carInfoAction']), {
    back: function back() {
      var _this = this;

      setTimeout(function () {
        _this.$router.back(-1);
      }, 300);
    },
    save: function save() {
      var _this2 = this;

      this.$vux.loading.show({
        text: '加载中,请稍后'
      });
      var params = {
        'id': this.id,
        'studentId': this.studentId,
        'datamanagementId': this.datamanagementId,
        'flowId': this.flowId,
        'flowProcedureId': this.flowProcedureId,
        'procedureId': this.procedureId,
        'transportation': this.type,
        'departureDatetime': this.carItem.stationDay + ' ' + this.carItem.stationTime + ':00',
        'arriveDatetime': this.carItem.schoolDay + ' ' + this.carItem.schoolTime + ':00',
        'arriveStation': this.siteCueent,
        'arriveNumber': this.carItem.personNumber,
        'isPicked': this.carItem.isTransfer ? 1 : 0,
        'isOntime': this.carItem.isOnTime ? 2 : 1
      };
      this.$api.post('/wayToSchool/handle', params, function (r) {
        _this2.$vux.loading.hide();
        setTimeout(function () {
          _this2.$router.push({ name: 'itemResult' });
        }, 300);
      }, function (err) {
        _this2.$vux.toast.text(err.message, 'top');
      });
    },
    popupDate: function popupDate(obj) {
      if (this.dateShow) {
        this.dateShow = false;
      } else {
        this.dateShow = true;
      }
      this.isTimes = obj;
      if (obj === 'station') {
        this.selectTime.startDate = '';
        this.selectTime.endDate = this.carItem.schoolDay;
      } else if (obj === 'school') {
        this.selectTime.startDate = this.carItem.stationDay;
        this.selectTime.endDate = '';
      }
    },
    onRight: function onRight(obj) {
      if (obj === 'station') {
        this.carItem.stationDay = this.selectTime.date;
        this.carItem.stationTime = this.selectTime.time;
      } else if (obj === 'school') {
        this.carItem.schoolDay = this.selectTime.date;
        this.carItem.schoolTime = this.selectTime.time;
      }
      if (this.selectTime.date !== '') {
        this.dateShow = false;
      } else {
        this.$vux.toast.text('请选择日期', 'middle');
      }
      if (timestamp(this.endDate) < timestamp(this.carItem.stationDay) || timestamp(this.endDate) < timestamp(this.carItem.schoolDay)) {
        this.carItem.isTransfer = false;
        this.carItem.isOnTime = true;
        this.sureToLeave = true;
      } else {
        this.carItem.isTransfer = false;
        this.carItem.isOnTime = false;
        this.sureToLeave = false;
      }
    },
    onLeft: function onLeft() {
      this.dateShow = false;
    },

    /* Time */
    handleScrollTime: function handleScrollTime(vertical, horizontal, nativeEvent) {
      var hour = Math.floor(horizontal.scrollLeft / 30 * 0.5);
      var min = Math.round((horizontal.scrollLeft / 30 * 0.5 - hour) * 60);
      this.selectTime.time = Object(pad["a" /* default */])(hour) + ':' + Object(pad["a" /* default */])(min);
    },
    changeChecker: function changeChecker(itemValue, itemDisabled) {
      var _this3 = this;

      this.sites.forEach(function (element) {
        if (element.arriveStation === itemValue) {
          _this3.companion = element.companion;
        }
      });
    },
    cancelEdit: function cancelEdit() {
      var _this4 = this;

      setTimeout(function () {
        _this4.$router.push({ name: 'itemResult' });
      }, 300);
    },
    changeDate: function changeDate() {
      if (this.isTimes === 'station') {
        if (timestamp(this.endDate) < timestamp(this.selectTime.date)) {
          this.showConfirm = true;
        } else {
          this.sureToLeave = false;
        }
      } else if (this.isTimes === 'school') {
        if (timestamp(this.endDate) < timestamp(this.selectTime.date)) {
          this.showConfirm = true;
        } else {
          this.sureToLeave = false;
        }
      }
    },
    onConfirm: function onConfirm() {
      this.sureToLeave = true;
    },
    onCancel: function onCancel() {
      this.selectTime.date = '';
    },
    getCarList: function getCarList() {
      var _this5 = this;

      var params = {
        flowId: this.flowId,
        flowProcedureId: this.flowProcedureId,
        procedureId: this.procedureId
      };
      this.$api.get('/configWayToSchool', params, function (r) {
        if (_this5.type !== '4') {
          _this5.sites = r.data.filter(function (item) {
            if (item.transportation === _this5.type) {
              return true;
            }
          });
        }
        _this5.getLastData();
      }, function (err) {
        _this5.$vux.toast.text(err.message, 'top');
      });
    },
    getLastData: function getLastData() {
      var _this6 = this;

      var params = {
        'studentId': this.studentId
      };
      this.$api.get('/wayToSchool', params, function (r) {
        if (r.data.length > 0) {
          _this6.btnSavetext = '重新办理';
          _this6.id = r.data[0].id;
          _this6.datamanagementId = r.data[0].datamanagementId;
          _this6.carItem.stationDay = r.data[0].departureDatetime.split(' ')[0];
          _this6.carItem.stationTime = r.data[0].departureDatetime.split(' ')[1].substring(0, 5);
          _this6.carItem.schoolDay = r.data[0].arriveDatetime.split(' ')[0];
          _this6.carItem.schoolTime = r.data[0].arriveDatetime.split(' ')[1].substring(0, 5);
          _this6.carItem.isTransfer = r.data[0].isPicked === 1;
          _this6.carItem.personNumber = r.data[0].arriveNumber;
          _this6.carItem.isOnTime = r.data[0].isOntime !== 1;
          if (r.data[0].transportation === _this6.type) {
            _this6.siteCueent = r.data[0].arriveStation;
          }
          _this6.sites.forEach(function (element) {
            if (element.arriveStation === r.data[0].arriveStation) {
              _this6.companion = element.companion;
            }
          });
          if (timestamp(_this6.endDate) < timestamp(_this6.carItem.stationDay) || timestamp(_this6.endDate) < timestamp(_this6.carItem.schoolDay)) {
            _this6.sureToLeave = true;
          } else {
            _this6.sureToLeave = false;
          }
        }
      }, function (err) {
        _this6.$vux.toast.text(err.message, 'top');
      });
    }
  })
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/yingxin/tskjxy/views/items/car/carInfo.vue























/* harmony default export */ var items_car_carInfo = ({
  name: 'info',
  props: [],
  directives: {
    TransferDom: transfer_dom["a" /* default */]
  },
  components: {
    XHeader: vux_src_components_x_header,
    XInput: vux_src_components_x_input,
    Group: vux_src_components_group,
    XButton: vux_src_components_x_button,
    Checker: src_components_checker_checker,
    CheckerItem: src_components_checker_checker_item,
    Flexbox: flexbox_flexbox["a" /* default */],
    FlexboxItem: flexbox_item["a" /* default */],
    PopupHeader: vux_src_components_popup_header,
    Popup: node_modules_vux_src_components_popup,
    Cell: vux_src_components_cell,
    XSwitch: vux_src_components_x_switch,
    XNumber: vux_src_components_x_number,
    InlineCalendar: vux_src_components_inline_calendar,
    'scroller': vuescroll_default.a,
    Confirm: node_modules_vux_src_components_confirm
  },
  data: function data() {
    return {
      isEdit: this.$route.params.isEdit,
      brand: '#FEAA33',
      sites: [],
      dateShow: false,
      isTimes: '',
      carItem: {
        way: this.$route.params.way,
        site: '',
        isTransfer: false,
        personNumber: 1,
        stationDay: '',
        stationTime: '',
        schoolDay: '',
        schoolTime: '',
        isOnTime: false
      },
      carInfo: [],
      timeOps: {
        scrollPanel: {
          scrollingY: false,
          initialScrollX: 480
        },
        bar: {
          background: 'rgba(0, 107, 178, 1)',
          size: '3px',
          opacity: 0
        }
      },
      timeNum: 24,
      selectTime: {
        date: '',
        time: '00:00',
        startDate: '',
        endDate: ''
      },
      siteCueent: '',
      showConfirm: false,
      sureToLeave: false,
      id: '',
      datamanagementId: '',
      btnSavetext: '办理',
      companion: ''
    };
  },

  computed: extends_default()({}, Object(vuex_esm["c" /* mapState */])({
    token: function token(state) {
      return state.token;
    },
    studentId: function studentId(state) {
      return state.userInfo.id;
    },
    flowId: function flowId(state) {
      return state.flowInfo.flowId;
    },
    flowType: function flowType(state) {
      return state.flowInfo.flowType;
    },
    title: function title(state) {
      return state.currentProcedureInfo.name;
    },
    flowProcedureId: function flowProcedureId(state) {
      return state.currentProcedureInfo.flowProcedureId;
    },
    procedureId: function procedureId(state) {
      return state.currentProcedureInfo.procedureId;
    },
    endDate: function endDate(state) {
      return state.currentProcedureInfo.endDate;
    }
  }), {
    type: function type() {
      return this.$route.params.type;
    },
    status: function status() {
      return this.$route.params.status;
    },
    btnDisabled: function btnDisabled() {
      var flag = true;
      if (this.siteCueent === '' && this.type !== '4' || this.carItem.stationDay === '' || this.carItem.schoolDay === '') {
        flag = true;
      } else {
        flag = false;
      }
      return flag;
    }
  }),
  created: function created() {},
  mounted: function mounted() {
    this.getCarList();
  },
  updated: function updated() {},
  destroyed: function destroyed() {},

  watch: {},
  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])(['carInfoAction']), {
    back: function back() {
      var _this = this;

      setTimeout(function () {
        _this.$router.back(-1);
      }, 300);
    },
    save: function save() {
      var _this2 = this;

      this.$vux.loading.show({
        text: '加载中,请稍后'
      });
      var params = {
        'id': this.id,
        'studentId': this.studentId,
        'datamanagementId': this.datamanagementId,
        'flowId': this.flowId,
        'flowProcedureId': this.flowProcedureId,
        'procedureId': this.procedureId,
        'transportation': this.type,
        'departureDatetime': this.carItem.stationDay + ' ' + this.carItem.stationTime + ':00',
        'arriveDatetime': this.carItem.schoolDay + ' ' + this.carItem.schoolTime + ':00',
        'arriveStation': this.siteCueent,
        'arriveNumber': this.carItem.personNumber,
        'isPicked': this.carItem.isTransfer ? 1 : 0,
        'isOntime': this.carItem.isOnTime ? 2 : 1
      };
      this.$api.post('/wayToSchool/handle', params, function (r) {
        _this2.$vux.loading.hide();
        setTimeout(function () {
          _this2.$router.push({ name: 'itemResult' });
        }, 300);
      }, function (err) {
        _this2.$vux.toast.text(err.message, 'top');
      });
    },
    popupDate: function popupDate(obj) {
      if (this.dateShow) {
        this.dateShow = false;
      } else {
        this.dateShow = true;
      }
      this.isTimes = obj;
      if (obj === 'station') {
        this.selectTime.startDate = '';
        this.selectTime.endDate = this.carItem.schoolDay;
      } else if (obj === 'school') {
        this.selectTime.startDate = this.carItem.stationDay;
        this.selectTime.endDate = '';
      }
    },
    onRight: function onRight(obj) {
      if (obj === 'station') {
        this.carItem.stationDay = this.selectTime.date;
        this.carItem.stationTime = this.selectTime.time;
      } else if (obj === 'school') {
        this.carItem.schoolDay = this.selectTime.date;
        this.carItem.schoolTime = this.selectTime.time;
      }
      if (this.selectTime.date !== '') {
        this.dateShow = false;
      } else {
        this.$vux.toast.text('请选择日期', 'middle');
      }
      if (timestamp(this.endDate) < timestamp(this.carItem.stationDay) || timestamp(this.endDate) < timestamp(this.carItem.schoolDay)) {
        this.carItem.isTransfer = false;
        this.carItem.isOnTime = true;
        this.sureToLeave = true;
      } else {
        this.carItem.isTransfer = false;
        this.carItem.isOnTime = false;
        this.sureToLeave = false;
      }
    },
    onLeft: function onLeft() {
      this.dateShow = false;
    },

    /* Time */
    handleScrollTime: function handleScrollTime(vertical, horizontal, nativeEvent) {
      var hour = Math.floor(horizontal.scrollLeft / 30 * 0.5);
      var min = Math.round((horizontal.scrollLeft / 30 * 0.5 - hour) * 60);
      this.selectTime.time = Object(pad["a" /* default */])(hour) + ':' + Object(pad["a" /* default */])(min);
    },
    changeChecker: function changeChecker(itemValue, itemDisabled) {
      var _this3 = this;

      this.sites.forEach(function (element) {
        if (element.arriveStation === itemValue) {
          _this3.companion = element.companion;
        }
      });
    },
    cancelEdit: function cancelEdit() {
      var _this4 = this;

      setTimeout(function () {
        _this4.$router.push({ name: 'itemResult' });
      }, 300);
    },
    changeDate: function changeDate() {
      if (this.isTimes === 'station') {
        if (timestamp(this.endDate) < timestamp(this.selectTime.date)) {
          this.showConfirm = true;
        } else {
          this.sureToLeave = false;
        }
      } else if (this.isTimes === 'school') {
        if (timestamp(this.endDate) < timestamp(this.selectTime.date)) {
          this.showConfirm = true;
        } else {
          this.sureToLeave = false;
        }
      }
    },
    onConfirm: function onConfirm() {
      this.sureToLeave = true;
    },
    onCancel: function onCancel() {
      this.selectTime.date = '';
    },
    getCarList: function getCarList() {
      var _this5 = this;

      var params = {
        flowId: this.flowId,
        flowProcedureId: this.flowProcedureId,
        procedureId: this.procedureId
      };
      this.$api.get('/configWayToSchool', params, function (r) {
        if (_this5.type !== '4') {
          _this5.sites = r.data.filter(function (item) {
            if (item.transportation === _this5.type) {
              return true;
            }
          });
        }
        _this5.getLastData();
      }, function (err) {
        _this5.$vux.toast.text(err.message, 'top');
      });
    },
    getLastData: function getLastData() {
      var _this6 = this;

      var params = {
        'studentId': this.studentId
      };
      this.$api.get('/wayToSchool', params, function (r) {
        if (r.data.length > 0) {
          _this6.btnSavetext = '重新办理';
          _this6.id = r.data[0].id;
          _this6.datamanagementId = r.data[0].datamanagementId;
          _this6.carItem.stationDay = r.data[0].departureDatetime.split(' ')[0];
          _this6.carItem.stationTime = r.data[0].departureDatetime.split(' ')[1].substring(0, 5);
          _this6.carItem.schoolDay = r.data[0].arriveDatetime.split(' ')[0];
          _this6.carItem.schoolTime = r.data[0].arriveDatetime.split(' ')[1].substring(0, 5);
          _this6.carItem.isTransfer = r.data[0].isPicked === 1;
          _this6.carItem.personNumber = r.data[0].arriveNumber;
          _this6.carItem.isOnTime = r.data[0].isOntime !== 1;
          if (r.data[0].transportation === _this6.type) {
            _this6.siteCueent = r.data[0].arriveStation;
          }
          _this6.sites.forEach(function (element) {
            if (element.arriveStation === r.data[0].arriveStation) {
              _this6.companion = element.companion;
            }
          });
          if (timestamp(_this6.endDate) < timestamp(_this6.carItem.stationDay) || timestamp(_this6.endDate) < timestamp(_this6.carItem.schoolDay)) {
            _this6.sureToLeave = true;
          } else {
            _this6.sureToLeave = false;
          }
        }
      }, function (err) {
        _this6.$vux.toast.text(err.message, 'top');
      });
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5f4ad0c0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/yingxin/tskjxy/views/items/car/carInfo.vue
var carInfo_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sub-page"},[_c('x-header',{staticClass:"header bg-white border-bottom"},[_c('em',{staticClass:"icon icon-arrow-left",attrs:{"slot":"overwrite-left","size":""},on:{"click":_vm.back},slot:"overwrite-left"}),_vm._v(_vm._s(_vm.title))]),(this.type!='4')?_c('section',{staticClass:"section bg-white border-bottom"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"panel"},[_c('div',{staticClass:"panel-header"},[_vm._v("到达站点")]),_c('div',{staticClass:"panel-body"},_vm._l((Math.ceil(_vm.sites.length/3)),function(i){return _c('flexbox',{key:i,staticStyle:{"margin-bottom":"1rem"}},_vm._l((_vm.sites),function(item,index){return (index >= (i-1)*3 && index < i*3)?_c('flexbox-item',{key:index},[_c('checker',{attrs:{"default-item-class":"site-item","selected-item-class":"site-item-selected"},model:{value:(_vm.siteCueent),callback:function ($$v) {_vm.siteCueent=$$v},expression:"siteCueent"}},[_c('checker-item',{attrs:{"value":item.arriveStation},on:{"on-item-click":_vm.changeChecker}},[_vm._v(_vm._s(item.arriveStation))])],1)],1):_vm._e()}),1)}),1),(_vm.companion!== '')?_c('p',[_vm._v("推荐路线："),_c('span',{staticClass:"text-orange"},[_vm._v(_vm._s(_vm.companion))])]):_vm._e()])])]):_vm._e(),_c('section',{staticClass:"section"},[_c('group',{attrs:{"title":"","label-width":"6rem"}},[_c('cell',{attrs:{"title":"预期出发时间","is-link":"is-link","value":_vm.carItem.stationDay + ' ' + _vm.carItem.stationTime},nativeOn:{"click":function($event){return _vm.popupDate('station')}}}),_c('cell',{attrs:{"title":"预期到达时间","is-link":"is-link","value":_vm.carItem.schoolDay + ' ' + _vm.carItem.schoolTime},nativeOn:{"click":function($event){return _vm.popupDate('school')}}})],1),_c('group',{attrs:{"title":"","label-width":"6rem"}},[_c('x-switch',{attrs:{"title":"是否接站","disabled":_vm.sureToLeave ? true : false},model:{value:(_vm.carItem.isTransfer),callback:function ($$v) {_vm.$set(_vm.carItem, "isTransfer", $$v)},expression:"carItem.isTransfer"}}),(_vm.carItem.isTransfer)?_c('x-number',{attrs:{"title":"接站人数","button-style":"round","min":1},model:{value:(_vm.carItem.personNumber),callback:function ($$v) {_vm.$set(_vm.carItem, "personNumber", $$v)},expression:"carItem.personNumber"}}):_vm._e()],1),_c('group',{attrs:{"title":"","label-width":"6rem"}},[_c('x-switch',{attrs:{"title":"是否请假","disabled":_vm.sureToLeave ? true : false},model:{value:(_vm.carItem.isOnTime),callback:function ($$v) {_vm.$set(_vm.carItem, "isOnTime", $$v)},expression:"carItem.isOnTime"}})],1)],1),_c('div',{directives:[{name:"transfer-dom",rawName:"v-transfer-dom"}]},[_c('popup',{model:{value:(_vm.dateShow),callback:function ($$v) {_vm.dateShow=$$v},expression:"dateShow"}},[_c('popup-header',{attrs:{"left-text":"取消","right-text":"确定","title":"选择日期","show-bottom-border":false},on:{"on-click-left":function($event){return _vm.onLeft(_vm.isTimes)},"on-click-right":function($event){return _vm.onRight(_vm.isTimes)}}}),_c('InlineCalendar',{attrs:{"start-date":_vm.selectTime.startDate,"end-date":_vm.selectTime.endDate},on:{"on-change":_vm.changeDate},model:{value:(_vm.selectTime.date),callback:function ($$v) {_vm.$set(_vm.selectTime, "date", $$v)},expression:"selectTime.date"}}),_c('div',{staticClass:"timeLine bg-white"},[_c('div',{ref:"markingTime",staticClass:"marking-time"},[_c('div',{staticClass:"solid"})]),_c('div',{staticClass:"selected-time"},[_vm._v(_vm._s(_vm.selectTime.time))]),_c('div',{staticClass:"timeLine-outer"},[_c('scroller',{attrs:{"ops":_vm.timeOps},on:{"handle-scroll":_vm.handleScrollTime}},[_c('div',{staticClass:"timeLine-inner"},[_c('div',{staticClass:"scale-box"},[_vm._l((_vm.timeNum),function(i){return [_c('span',{key:i,staticClass:"scale long"}),_c('span',{staticClass:"scale"})]})],2),_c('div',{staticClass:"number-box"},_vm._l((_vm.timeNum),function(i){return _c('span',{key:i,staticClass:"number"},[_vm._v(_vm._s(i-1)+":00")])}),0)])])],1)])],1)],1),_c('div',{staticClass:"button-group fixed bottom container"},[_c('flexbox',[(_vm.isEdit)?_c('flexbox-item',[_c('x-button',{attrs:{"type":"warn"},nativeOn:{"click":function($event){return _vm.cancelEdit()}}},[_vm._v("取消编辑")])],1):_vm._e(),_c('flexbox-item',[_c('x-button',{attrs:{"type":"brand","disabled":_vm.btnDisabled},nativeOn:{"click":function($event){return _vm.save($event)}}},[_vm._v(_vm._s(_vm.btnSavetext))])],1)],1)],1),_c('div',{directives:[{name:"transfer-dom",rawName:"v-transfer-dom"}]},[_c('confirm',{attrs:{"title":"提示"},on:{"on-confirm":_vm.onConfirm,"on-cancel":_vm.onCancel},model:{value:(_vm.showConfirm),callback:function ($$v) {_vm.showConfirm=$$v},expression:"showConfirm"}},[_c('p',{staticStyle:{"text-align":"center"}},[_vm._v("到站时间超出手续截止日期，是否请假？")])])],1)],1)}
var carInfo_staticRenderFns = []
var carInfo_esExports = { render: carInfo_render, staticRenderFns: carInfo_staticRenderFns }
/* harmony default export */ var views_items_car_carInfo = (carInfo_esExports);
// CONCATENATED MODULE: ./src/yingxin/tskjxy/views/items/car/carInfo.vue
var carInfo_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var carInfo___vue_template_functional__ = false
/* styles */
var carInfo___vue_styles__ = null
/* scopeId */
var carInfo___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var carInfo___vue_module_identifier__ = null
var carInfo_Component = carInfo_normalizeComponent(
  items_car_carInfo,
  views_items_car_carInfo,
  carInfo___vue_template_functional__,
  carInfo___vue_styles__,
  carInfo___vue_scopeId__,
  carInfo___vue_module_identifier__
)

/* harmony default export */ var tskjxy_views_items_car_carInfo = (carInfo_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/step/step.vue
//
//
//
//
//
//

/* harmony default export */ var step = ({
  name: 'step',
  props: {
    value: Number,
    backgroundColor: {
      type: String,
      default: '#fff'
    },
    gutter: {
      type: String,
      default: '10px'
    }
  },
  created: function created() {
    this.current = this.value;
  },
  mounted: function mounted() {
    this._mapPropsToChildComponent();
  },

  watch: {
    value: function value(val) {
      this.current = val;
    },
    current: function current(val) {
      this._mapPropsToChildComponent();
      this.$emit('input', val);
    }
  },
  data: function data() {
    return {
      current: 0
    };
  },

  methods: {
    _mapPropsToChildComponent: function _mapPropsToChildComponent() {
      var _this = this;
      var len = this.$children.length - 1;
      this.$children.forEach(function (child, index) {
        child.currentStepNumber = (index + 1).toString();
        child.currentStepLast = index === len;

        if (index === _this.current) {
          child.currentStatus = 'process';
        } else if (index < _this.current) {
          child.currentStatus = 'finish';
        } else {
          child.currentStatus = 'wait';
        }
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/step/step.vue
//
//
//
//
//
//

/* harmony default export */ var step_step = ({
  name: 'step',
  props: {
    value: Number,
    backgroundColor: {
      type: String,
      default: '#fff'
    },
    gutter: {
      type: String,
      default: '10px'
    }
  },
  created: function created() {
    this.current = this.value;
  },
  mounted: function mounted() {
    this._mapPropsToChildComponent();
  },

  watch: {
    value: function value(val) {
      this.current = val;
    },
    current: function current(val) {
      this._mapPropsToChildComponent();
      this.$emit('input', val);
    }
  },
  data: function data() {
    return {
      current: 0
    };
  },

  methods: {
    _mapPropsToChildComponent: function _mapPropsToChildComponent() {
      var _this = this;
      var len = this.$children.length - 1;
      this.$children.forEach(function (child, index) {
        child.currentStepNumber = (index + 1).toString();
        child.currentStepLast = index === len;

        if (index === _this.current) {
          child.currentStatus = 'process';
        } else if (index < _this.current) {
          child.currentStatus = 'finish';
        } else {
          child.currentStatus = 'wait';
        }
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2adc97aa","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/step/step.vue
var step_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-step"},[_vm._t("default")],2)}
var step_staticRenderFns = []
var step_esExports = { render: step_render, staticRenderFns: step_staticRenderFns }
/* harmony default export */ var components_step_step = (step_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/step/step.vue
function step_injectStyle (ssrContext) {
  __webpack_require__("p80d")
}
var step_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var step___vue_template_functional__ = false
/* styles */
var step___vue_styles__ = step_injectStyle
/* scopeId */
var step___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var step___vue_module_identifier__ = null
var step_Component = step_normalizeComponent(
  step_step,
  components_step_step,
  step___vue_template_functional__,
  step___vue_styles__,
  step___vue_scopeId__,
  step___vue_module_identifier__
)

/* harmony default export */ var src_components_step_step = (step_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/step/step-item.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var step_item = ({
  name: 'step-item',
  props: {
    title: String,
    description: String,
    stepNumber: Number,
    stepLast: Boolean,
    icon: String,
    status: String,
    tailWidth: Object
  },
  computed: {
    iconName: function iconName() {
      return this.icon || 'check';
    }
  },
  created: function created() {
    this.currentStatus = this.status;
    this.currentStepLast = this.stepLast;
    this.currentStepNumber = this.stepNumber;
  },
  data: function data() {
    return {
      currentStatus: '',
      currentStepLast: false,
      currentStepNumber: 0
    };
  },

  components: {
    Icon: vux_src_components_icon
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/step/step-item.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var step_step_item = ({
  name: 'step-item',
  props: {
    title: String,
    description: String,
    stepNumber: Number,
    stepLast: Boolean,
    icon: String,
    status: String,
    tailWidth: Object
  },
  computed: {
    iconName: function iconName() {
      return this.icon || 'check';
    }
  },
  created: function created() {
    this.currentStatus = this.status;
    this.currentStepLast = this.stepLast;
    this.currentStepNumber = this.stepNumber;
  },
  data: function data() {
    return {
      currentStatus: '',
      currentStepLast: false,
      currentStepNumber: 0
    };
  },

  components: {
    Icon: vux_src_components_icon
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c88d1eb6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/step/step-item.vue
var step_item_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-step-item",class:{ 'vux-step-item-with-tail' : !_vm.currentStepLast}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.currentStepLast),expression:"!currentStepLast"}],class:'vux-step-item-tail ' + 'vux-step-item-tail-' + _vm.currentStatus,style:({right: _vm.$parent.gutter})}),_vm._v(" "),_c('div',{class:'vux-step-item-head ' + 'vux-step-item-head-' + _vm.currentStatus},[_c('div',{staticClass:"vux-step-item-head-inner"},[(!_vm.icon && _vm.currentStatus!='finish')?_c('span',{staticClass:"vux-step-item-icon"},[_vm._v(_vm._s(_vm.currentStepNumber))]):_c('span',{class:'vux-step-item-icon ' + 'vux-step-item-' + _vm.iconName},[_c('icon',{staticClass:"vux-step-item-checked",attrs:{"type":"success_no_circle"}})],1)])]),_vm._v(" "),_c('div',{class:'vux-step-item-main ' + 'vux-step-item-main-' + _vm.currentStatus,style:({backgroundColor: _vm.$parent.backgroundColor, paddingRight: _vm.currentStepLast ? 0 : _vm.$parent.gutter})},[_c('span',{staticClass:"vux-step-item-title"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('div',{staticClass:"vux-step-item-description"},[_vm._v(_vm._s(_vm.description))])])])}
var step_item_staticRenderFns = []
var step_item_esExports = { render: step_item_render, staticRenderFns: step_item_staticRenderFns }
/* harmony default export */ var components_step_step_item = (step_item_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/step/step-item.vue
var step_item_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var step_item___vue_template_functional__ = false
/* styles */
var step_item___vue_styles__ = null
/* scopeId */
var step_item___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var step_item___vue_module_identifier__ = null
var step_item_Component = step_item_normalizeComponent(
  step_step_item,
  components_step_step_item,
  step_item___vue_template_functional__,
  step_item___vue_styles__,
  step_item___vue_scopeId__,
  step_item___vue_module_identifier__
)

/* harmony default export */ var src_components_step_step_item = (step_item_Component.exports);

// EXTERNAL MODULE: ./node_modules/x-photoswipe/dist/photoswipe.js
var photoswipe = __webpack_require__("i7N3");
var photoswipe_default = /*#__PURE__*/__webpack_require__.n(photoswipe);

// EXTERNAL MODULE: ./node_modules/x-photoswipe/dist/photoswipe-ui-default.js
var photoswipe_ui_default = __webpack_require__("72M0");
var photoswipe_ui_default_default = /*#__PURE__*/__webpack_require__.n(photoswipe_ui_default);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/previewer/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var previewer = ({
  name: 'previewer',
  computed: {
    imgs: function imgs() {
      return this.list.map(function (one) {
        if (!one.msrc) {
          one.msrc = one.src;
        }
        if (typeof one.w === 'undefined') {
          one.w = 0;
          one.h = 0;
        }
        return one;
      });
    }
  },
  watch: {
    imgs: function imgs(newVal, oldVal) {
      if (!this.photoswipe) {
        return;
      }
      if (newVal.length && newVal.length - oldVal.length === -1) {
        var index = this.photoswipe.getCurrentIndex();
        this.photoswipe.invalidateCurrItems();
        this.photoswipe.items.splice(index, 1);
        var goToIndex = index;
        if (goToIndex > this.photoswipe.items.length - 1) {
          goToIndex = 0;
        }
        this.photoswipe.goTo(goToIndex);
        this.photoswipe.updateSize(true);
        this.photoswipe.ui.update();
      } else if (!newVal.length) {
        this.close();
      }
    }
  },
  methods: {
    init: function init(index) {
      var self = this;
      var showItem = this.imgs[index];
      if (!showItem.w || !showItem.h || showItem.w < 5 || showItem.h < 5) {
        var img = new Image();
        img.onload = function () {
          showItem.w = this.width;
          showItem.h = this.height;
          self.doInit(index);
        };
        img.src = showItem.src;
      } else {
        this.doInit(index);
      }
    },
    doInit: function doInit(index) {
      var _this = this;

      var self = this;
      var options = object_assign_default()({
        history: false,
        shareEl: false,
        tapToClose: true,
        index: index
      }, this.options);
      this.photoswipe = new photoswipe_default.a(this.$el, photoswipe_ui_default_default.a, this.imgs, options);

      this.photoswipe.listen('gettingData', function (index, item) {
        if (!item.w || !item.h || item.w < 1 || item.h < 1) {
          var img = new Image();
          img.onload = function () {
            item.w = this.width;
            item.h = this.height;
            self.photoswipe.updateSize(true);
          };
          img.src = item.src;
        }
      });

      this.photoswipe.init();
      this.photoswipe.listen('close', function () {
        _this.$emit('on-close');
      });
      this.photoswipe.listen('afterChange', function (a, b) {
        _this.$emit('on-index-change', {
          currentIndex: _this.photoswipe.getCurrentIndex()
        });
      });
    },
    show: function show(index) {
      this.init(index);
    },
    getCurrentIndex: function getCurrentIndex() {
      return this.photoswipe.getCurrentIndex();
    },
    close: function close() {
      this.photoswipe.close();
    },
    goTo: function goTo(index) {
      this.photoswipe.goTo(index);
    },
    prev: function prev() {
      this.photoswipe.prev();
    },
    next: function next() {
      this.photoswipe.next();
    }
  },
  props: {
    list: {
      type: Array,
      required: true
    },
    index: {
      type: Number,
      default: 0
    },
    options: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/previewer/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var components_previewer = ({
  name: 'previewer',
  computed: {
    imgs: function imgs() {
      return this.list.map(function (one) {
        if (!one.msrc) {
          one.msrc = one.src;
        }
        if (typeof one.w === 'undefined') {
          one.w = 0;
          one.h = 0;
        }
        return one;
      });
    }
  },
  watch: {
    imgs: function imgs(newVal, oldVal) {
      if (!this.photoswipe) {
        return;
      }
      if (newVal.length && newVal.length - oldVal.length === -1) {
        var index = this.photoswipe.getCurrentIndex();
        this.photoswipe.invalidateCurrItems();
        this.photoswipe.items.splice(index, 1);
        var goToIndex = index;
        if (goToIndex > this.photoswipe.items.length - 1) {
          goToIndex = 0;
        }
        this.photoswipe.goTo(goToIndex);
        this.photoswipe.updateSize(true);
        this.photoswipe.ui.update();
      } else if (!newVal.length) {
        this.close();
      }
    }
  },
  methods: {
    init: function init(index) {
      var self = this;
      var showItem = this.imgs[index];
      if (!showItem.w || !showItem.h || showItem.w < 5 || showItem.h < 5) {
        var img = new Image();
        img.onload = function () {
          showItem.w = this.width;
          showItem.h = this.height;
          self.doInit(index);
        };
        img.src = showItem.src;
      } else {
        this.doInit(index);
      }
    },
    doInit: function doInit(index) {
      var _this = this;

      var self = this;
      var options = object_assign_default()({
        history: false,
        shareEl: false,
        tapToClose: true,
        index: index
      }, this.options);
      this.photoswipe = new photoswipe_default.a(this.$el, photoswipe_ui_default_default.a, this.imgs, options);

      this.photoswipe.listen('gettingData', function (index, item) {
        if (!item.w || !item.h || item.w < 1 || item.h < 1) {
          var img = new Image();
          img.onload = function () {
            item.w = this.width;
            item.h = this.height;
            self.photoswipe.updateSize(true);
          };
          img.src = item.src;
        }
      });

      this.photoswipe.init();
      this.photoswipe.listen('close', function () {
        _this.$emit('on-close');
      });
      this.photoswipe.listen('afterChange', function (a, b) {
        _this.$emit('on-index-change', {
          currentIndex: _this.photoswipe.getCurrentIndex()
        });
      });
    },
    show: function show(index) {
      this.init(index);
    },
    getCurrentIndex: function getCurrentIndex() {
      return this.photoswipe.getCurrentIndex();
    },
    close: function close() {
      this.photoswipe.close();
    },
    goTo: function goTo(index) {
      this.photoswipe.goTo(index);
    },
    prev: function prev() {
      this.photoswipe.prev();
    },
    next: function next() {
      this.photoswipe.next();
    }
  },
  props: {
    list: {
      type: Array,
      required: true
    },
    index: {
      type: Number,
      default: 0
    },
    options: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-76aee302","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/previewer/index.vue
var previewer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pswp vux-previewer",attrs:{"tabindex":"-1","role":"dialog","aria-hidden":"true"}},[_c('div',{staticClass:"pswp__bg"}),_vm._v(" "),_c('div',{staticClass:"pswp__scroll-wrap"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"pswp__ui pswp__ui--hidden"},[_c('div',{staticClass:"pswp__top-bar"},[_c('div',{staticClass:"pswp__counter"}),_vm._v(" "),_vm._t("button-after"),_vm._v(" "),_c('button',{staticClass:"pswp__button pswp__button--close",attrs:{"title":"Close (Esc)"}}),_vm._v(" "),_c('button',{staticClass:"pswp__button pswp__button--share",attrs:{"title":"Share"}}),_vm._v(" "),_c('button',{staticClass:"pswp__button pswp__button--fs",attrs:{"title":"Toggle fullscreen"}}),_vm._v(" "),_c('button',{staticClass:"pswp__button pswp__button--zoom",attrs:{"title":"Zoom in/out"}}),_vm._v(" "),_vm._t("button-before"),_vm._v(" "),_vm._m(1)],2),_vm._v(" "),_vm._m(2),_vm._v(" "),_c('button',{staticClass:"pswp__button pswp__button--arrow--left",attrs:{"title":"Previous (arrow left)"}}),_vm._v(" "),_c('button',{staticClass:"pswp__button pswp__button--arrow--right",attrs:{"title":"Next (arrow right)"}}),_vm._v(" "),_vm._m(3)])])])}
var previewer_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pswp__container"},[_c('div',{staticClass:"pswp__item"}),_vm._v(" "),_c('div',{staticClass:"pswp__item"}),_vm._v(" "),_c('div',{staticClass:"pswp__item"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pswp__preloader"},[_c('div',{staticClass:"pswp__preloader__icn"},[_c('div',{staticClass:"pswp__preloader__cut"},[_c('div',{staticClass:"pswp__preloader__donut"})])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pswp__share-modal pswp__share-modal--hidden pswp__single-tap"},[_c('div',{staticClass:"pswp__share-tooltip"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pswp__caption"},[_c('div',{staticClass:"pswp__caption__center"})])}]
var previewer_esExports = { render: previewer_render, staticRenderFns: previewer_staticRenderFns }
/* harmony default export */ var src_components_previewer = (previewer_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/previewer/index.vue
function previewer_injectStyle (ssrContext) {
  __webpack_require__("iJSS")
  __webpack_require__("p8bI")
}
var previewer_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var previewer___vue_template_functional__ = false
/* styles */
var previewer___vue_styles__ = previewer_injectStyle
/* scopeId */
var previewer___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var previewer___vue_module_identifier__ = null
var previewer_Component = previewer_normalizeComponent(
  components_previewer,
  src_components_previewer,
  previewer___vue_template_functional__,
  previewer___vue_styles__,
  previewer___vue_scopeId__,
  previewer___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_previewer = (previewer_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/inline-loading/index.vue
//
//
//
//

/* harmony default export */ var inline_loading = ({
  name: 'inline-loading'
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/inline-loading/index.vue
//
//
//
//

/* harmony default export */ var components_inline_loading = ({
  name: 'inline-loading'
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-137803b6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/inline-loading/index.vue
var inline_loading_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',{staticClass:"weui-loading"})}
var inline_loading_staticRenderFns = []
var inline_loading_esExports = { render: inline_loading_render, staticRenderFns: inline_loading_staticRenderFns }
/* harmony default export */ var src_components_inline_loading = (inline_loading_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/inline-loading/index.vue
function inline_loading_injectStyle (ssrContext) {
  __webpack_require__("cmRX")
}
var inline_loading_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var inline_loading___vue_template_functional__ = false
/* styles */
var inline_loading___vue_styles__ = inline_loading_injectStyle
/* scopeId */
var inline_loading___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var inline_loading___vue_module_identifier__ = null
var inline_loading_Component = inline_loading_normalizeComponent(
  components_inline_loading,
  src_components_inline_loading,
  inline_loading___vue_template_functional__,
  inline_loading___vue_styles__,
  inline_loading___vue_scopeId__,
  inline_loading___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_inline_loading = (inline_loading_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/upload.vue






/* harmony default export */ var upload = ({
  components: {
    Flexbox: flexbox_flexbox["a" /* default */],
    FlexboxItem: flexbox_item["a" /* default */],
    Previewer: vux_src_components_previewer,
    InlineLoading: vux_src_components_inline_loading
  },
  model: {
    prop: 'images',
    event: 'change'
  },
  props: {
    images: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    readonly: {
      type: Boolean,
      default: false
    },
    max: {
      type: Number,
      default: 9
    },
    beforeUpload: Function,
    withCredentials: {
      type: Boolean,
      default: false
    },
    data: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    span: {
      type: Number,
      default: 4
    },
    accept: {
      type: String,
      default: 'image/*'
    },
    capture: {
      type: String,
      default: ''
    },
    preview: {
      type: Boolean,
      default: true
    },
    compress: Object,
    maxSize: Number
  },
  data: function data() {
    return {
      loading: false,
      isUpload: false
    };
  },

  computed: {
    showCapture: function showCapture() {
      return this.capture || undefined;
    }
  },
  watch: {
    loading: function loading(newValue) {
      if (!newValue) {
        this.$refs['file'].value = '';
      }
    }
  },
  methods: {
    onChange: function onChange(event) {
      var num = event.target.files.length;
      if (num === 1) {
        var file = event.target.files[0];
        this.uploadFile(file);
      } else {
        var fileArr = event.target.files;
        for (var index = 0; index < fileArr.length; index++) {
          this.uploadFile(fileArr[index]);
        }
      }
    },
    uploadFile: function uploadFile(file) {
      var _this = this;

      if (this.images.length > this.max - 1) {
        return false;
      } else {
        var size = (this.maxSize / 1024 / 1024).toFixed(1);
        if (file.size > this.maxSize) {
          this.$vux.toast.text('上传图片大小不得超过' + size + 'M，请重新上传', 'middle');
        } else {

          if (this.beforeUpload && typeof this.beforeUpload === 'function') {
            var before = this.beforeUpload(file);
            if (before && before.then) {
              before.then(function (processedFile) {
                var fileType = Object.prototype.toString.call(processedFile);
                if (fileType === '[object File]' || fileType === '[object Blob]') {
                  _this.post(processedFile);
                } else {
                  _this.post(file);
                }
              });
            } else if (before !== false) {
              this.post(file);
            }
          } else {
            this.post(file);
          }
        }
      }
    },
    post: function post(file) {
      var _this2 = this;

      this.loading = true;
      var reader = new FileReader();
      var data = [];
      reader.readAsDataURL(file);
      reader.onloadend = function () {
        data.push(reader.result);
        _this2.onSuccess(file, data);
      };
      this.loading = false;
    },
    onProgress: function onProgress(e) {
      this.loading = true;
    },
    onPreview: function onPreview(index) {
      if (this.preview) {
        this.$refs.previewer.show(index);
      }
    },
    onSuccess: function onSuccess(file, data) {
      this.$emit('success', file, data);
    },
    onError: function onError(file) {
      this.$emit('error', file);
    },
    onRemove: function onRemove(index, e) {
      e.stopPropagation();
      this.$emit('remove', index);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/upload.vue






/* harmony default export */ var components_upload = ({
  components: {
    Flexbox: flexbox_flexbox["a" /* default */],
    FlexboxItem: flexbox_item["a" /* default */],
    Previewer: vux_src_components_previewer,
    InlineLoading: vux_src_components_inline_loading
  },
  model: {
    prop: 'images',
    event: 'change'
  },
  props: {
    images: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    readonly: {
      type: Boolean,
      default: false
    },
    max: {
      type: Number,
      default: 9
    },
    beforeUpload: Function,
    withCredentials: {
      type: Boolean,
      default: false
    },
    data: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    span: {
      type: Number,
      default: 4
    },
    accept: {
      type: String,
      default: 'image/*'
    },
    capture: {
      type: String,
      default: ''
    },
    preview: {
      type: Boolean,
      default: true
    },
    compress: Object,
    maxSize: Number
  },
  data: function data() {
    return {
      loading: false,
      isUpload: false
    };
  },

  computed: {
    showCapture: function showCapture() {
      return this.capture || undefined;
    }
  },
  watch: {
    loading: function loading(newValue) {
      if (!newValue) {
        this.$refs['file'].value = '';
      }
    }
  },
  methods: {
    onChange: function onChange(event) {
      var num = event.target.files.length;
      if (num === 1) {
        var file = event.target.files[0];
        this.uploadFile(file);
      } else {
        var fileArr = event.target.files;
        for (var index = 0; index < fileArr.length; index++) {
          this.uploadFile(fileArr[index]);
        }
      }
    },
    uploadFile: function uploadFile(file) {
      var _this = this;

      if (this.images.length > this.max - 1) {
        return false;
      } else {
        var size = (this.maxSize / 1024 / 1024).toFixed(1);
        if (file.size > this.maxSize) {
          this.$vux.toast.text('上传图片大小不得超过' + size + 'M，请重新上传', 'middle');
        } else {

          if (this.beforeUpload && typeof this.beforeUpload === 'function') {
            var before = this.beforeUpload(file);
            if (before && before.then) {
              before.then(function (processedFile) {
                var fileType = Object.prototype.toString.call(processedFile);
                if (fileType === '[object File]' || fileType === '[object Blob]') {
                  _this.post(processedFile);
                } else {
                  _this.post(file);
                }
              });
            } else if (before !== false) {
              this.post(file);
            }
          } else {
            this.post(file);
          }
        }
      }
    },
    post: function post(file) {
      var _this2 = this;

      this.loading = true;
      var reader = new FileReader();
      var data = [];
      reader.readAsDataURL(file);
      reader.onloadend = function () {
        data.push(reader.result);
        _this2.onSuccess(file, data);
      };
      this.loading = false;
    },
    onProgress: function onProgress(e) {
      this.loading = true;
    },
    onPreview: function onPreview(index) {
      if (this.preview) {
        this.$refs.previewer.show(index);
      }
    },
    onSuccess: function onSuccess(file, data) {
      this.$emit('success', file, data);
    },
    onError: function onError(file) {
      this.$emit('error', file);
    },
    onRemove: function onRemove(index, e) {
      e.stopPropagation();
      this.$emit('remove', index);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1f757eb5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/upload.vue
var upload_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-upload"},[_c('div',[_c('div',{staticClass:"vux-upload-bg"},[_c('div',{staticClass:"weui-uploader__input-box vux-upload-content",class:{ loading: _vm.loading }},[_c('input',{directives:[{name:"show",rawName:"v-show",value:(!_vm.loading),expression:"!loading"}],ref:"file",staticClass:"weui-uploader__input",attrs:{"value":"","type":"file","accept":_vm.accept,"capture":_vm.showCapture,"multiple":"multiple","disabled":_vm.images.length > _vm.max || _vm.images.length === _vm.max},on:{"change":function($event){return _vm.onChange($event)}}}),_c('inline-loading',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading),expression:"loading"}]})],1)])]),_c('flexbox',{attrs:{"gutter":0,"wrap":"wrap"}},_vm._l((_vm.images),function(item,index){return _c('flexbox-item',{key:index,attrs:{"span":_vm.span},nativeOn:{"click":function($event){return _vm.onPreview(index)}}},[_c('div',{staticClass:"vux-upload-bg"},[_c('div',{staticClass:"vux-upload-content",style:({ backgroundImage: ("url(" + (item.src) + ")") })},[(!_vm.readonly)?_c('svg',{staticClass:"vux-x-icon vux-x-icon-ios-close red",attrs:{"type":"ios-close","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 512 512"},on:{"click":function($event){return _vm.onRemove(index, $event)}}},[_c('path',{staticClass:"st0",attrs:{"d":"M403.1 108.9c-81.2-81.2-212.9-81.2-294.2 0s-81.2 212.9 0 294.2c81.2 81.2 212.9 81.2 294.2 0s81.2-213 0-294.2zM352 340.2L340.2 352l-84.4-84.2-84 83.8-11.8-11.8 84-83.8-84-83.8 11.8-11.8 84 83.8 84.4-84.2 11.8 11.8-84.4 84.2 84.4 84.2z"}})]):_vm._e()])])])}),1),_c('previewer',{ref:"previewer",attrs:{"list":_vm.images}})],1)}
var upload_staticRenderFns = []
var upload_esExports = { render: upload_render, staticRenderFns: upload_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_upload = (upload_esExports);
// CONCATENATED MODULE: ./src/components/upload.vue
function upload_injectStyle (ssrContext) {
  __webpack_require__("i+gR")
}
var upload_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var upload___vue_template_functional__ = false
/* styles */
var upload___vue_styles__ = upload_injectStyle
/* scopeId */
var upload___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var upload___vue_module_identifier__ = null
var upload_Component = upload_normalizeComponent(
  components_upload,
  selectortype_template_index_0_src_components_upload,
  upload___vue_template_functional__,
  upload___vue_styles__,
  upload___vue_scopeId__,
  upload___vue_module_identifier__
)

/* harmony default export */ var src_components_upload = (upload_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/yingxin/tskjxy/views/items/address/upload.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var address_upload = ({
  name: 'upload',
  props: [],
  components: {
    VuxUpload: src_components_upload
  },
  data: function data() {
    return {
      upload: {
        data: {
          id: 1
        },
        images: [],
        max: 3,
        maxSize: 2048000,
        accept: 'image/png, image/jpeg, image/gif, image/jpg, image/bmp',
        capture: ''
      },
      files: [],
      addressFile: {
        iles: [],
        filesData: []
      }
    };
  },

  computed: {},
  created: function created() {},
  mounted: function mounted() {
    this.files = this.$store.state.addressFile.files;
    this.upload.images = this.$store.state.addressFile.filesData;
  },

  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])(['addressFileAction']), {
    onSuccess: function onSuccess(file, data) {
      this.upload.images.push({
        src: data[0]
      });
      this.files.push(file);
      this.addressFile = {
        filesData: this.upload.images,
        files: this.files
      };
      this.$store.dispatch('addressFileAction', this.addressFile);
    },
    onError: function onError(e) {
      console.log(e.message);
    },
    onRemove: function onRemove(index) {
      this.upload.images.splice(index, 1);
      this.files.splice(index, 1);
      this.addressFile = {
        filesData: this.upload.images,
        files: this.files
      };
      this.$store.dispatch('addressFileAction', this.addressFile);
    }
  })
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/yingxin/tskjxy/views/items/address/upload.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var items_address_upload = ({
  name: 'upload',
  props: [],
  components: {
    VuxUpload: src_components_upload
  },
  data: function data() {
    return {
      upload: {
        data: {
          id: 1
        },
        images: [],
        max: 3,
        maxSize: 2048000,
        accept: 'image/png, image/jpeg, image/gif, image/jpg, image/bmp',
        capture: ''
      },
      files: [],
      addressFile: {
        iles: [],
        filesData: []
      }
    };
  },

  computed: {},
  created: function created() {},
  mounted: function mounted() {
    this.files = this.$store.state.addressFile.files;
    this.upload.images = this.$store.state.addressFile.filesData;
  },

  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])(['addressFileAction']), {
    onSuccess: function onSuccess(file, data) {
      this.upload.images.push({
        src: data[0]
      });
      this.files.push(file);
      this.addressFile = {
        filesData: this.upload.images,
        files: this.files
      };
      this.$store.dispatch('addressFileAction', this.addressFile);
    },
    onError: function onError(e) {
      console.log(e.message);
    },
    onRemove: function onRemove(index) {
      this.upload.images.splice(index, 1);
      this.files.splice(index, 1);
      this.addressFile = {
        filesData: this.upload.images,
        files: this.files
      };
      this.$store.dispatch('addressFileAction', this.addressFile);
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6cdaf8fa","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/yingxin/tskjxy/views/items/address/upload.vue
var address_upload_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"panel"},[_c('div',{staticClass:"panel-header text-gary"},[_vm._v("请拍照并上传迁移证")]),_c('div',{staticClass:"panel-body"},[_c('div',{staticClass:"upload-image-box"},[_c('vux-upload',{attrs:{"data":_vm.upload.data,"images":_vm.upload.images,"readonly":false,"max":_vm.upload.max,"withCredentials":false,"span":4,"preview":true,"maxSize":_vm.upload.maxSize,"accept":_vm.upload.accept,"capture":_vm.upload.capture},on:{"success":_vm.onSuccess,"error":_vm.onError,"remove":_vm.onRemove}})],1)])])}
var address_upload_staticRenderFns = []
var address_upload_esExports = { render: address_upload_render, staticRenderFns: address_upload_staticRenderFns }
/* harmony default export */ var views_items_address_upload = (address_upload_esExports);
// CONCATENATED MODULE: ./src/yingxin/tskjxy/views/items/address/upload.vue
var address_upload_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var address_upload___vue_template_functional__ = false
/* styles */
var address_upload___vue_styles__ = null
/* scopeId */
var address_upload___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var address_upload___vue_module_identifier__ = null
var address_upload_Component = address_upload_normalizeComponent(
  items_address_upload,
  views_items_address_upload,
  address_upload___vue_template_functional__,
  address_upload___vue_styles__,
  address_upload___vue_scopeId__,
  address_upload___vue_module_identifier__
)

/* harmony default export */ var tskjxy_views_items_address_upload = (address_upload_Component.exports);

// EXTERNAL MODULE: ./node_modules/autosize/dist/autosize.js
var autosize = __webpack_require__("JnrT");
var autosize_default = /*#__PURE__*/__webpack_require__.n(autosize);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/x-textarea/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



 // prop.autosize

/* harmony default export */ var x_textarea = ({
  name: 'x-textarea',
  minxins: [base["a" /* default */]],
  mounted: function mounted() {
    var _this = this;

    if (this.$slots && this.$slots['restricted-label']) {
      this.hasRestrictedLabel = true;
    }
    // prop.autosize
    this.$nextTick(function () {
      if (_this.autosize) {
        _this.bindAutosize();
      }
    });
    // prop.autosize
  },

  components: {
    InlineDesc: vux_src_components_inline_desc
  },
  props: {
    title: String,
    inlineDesc: String,
    showCounter: {
      type: Boolean,
      default: true
    },
    max: Number,
    value: String,
    name: String,
    placeholder: String,
    readonly: Boolean,
    disabled: Boolean,
    rows: {
      type: Number,
      default: 3
    },
    cols: {
      type: Number,
      default: 30
    },
    height: Number,
    // https://github.com/yisibl/blog/issues/3
    autocomplete: {
      type: String,
      default: 'off'
    },
    autocapitalize: {
      type: String,
      default: 'off'
    },
    autocorrect: {
      type: String,
      default: 'off'
    },
    spellcheck: {
      type: String,
      default: 'false'
    },
    autosize: Boolean // prop.autosize
  },
  created: function created() {
    this.currentValue = this.value;
  },

  watch: {
    // prop.autosize
    autosize: function autosize(val) {
      this.unbindAutosize();
      if (val) {
        this.bindAutosize();
      }
    },

    // prop.autosize
    value: function value(val) {
      this.currentValue = val;
    },
    currentValue: function currentValue(newVal) {
      if (this.max && newVal && newVal.length > this.max) {
        this.currentValue = newVal.slice(0, this.max);
      }
      this.$emit('input', this.currentValue);
      this.$emit('on-change', this.currentValue);
    }
  },
  data: function data() {
    return {
      hasRestrictedLabel: false,
      currentValue: ''
    };
  },

  computed: {
    count: function count() {
      var len = 0;
      if (this.currentValue) {
        len = this.currentValue.replace(/\n/g, 'aa').length;
      }
      return len > this.max ? this.max : len;
    },
    textareaStyle: function textareaStyle() {
      if (this.height) {
        return {
          height: this.height + 'px'
        };
      }
    },
    labelStyles: function labelStyles() {
      return {
        width: this.$parent.labelWidth || this.labelWidth + 'em',
        textAlign: this.$parent.labelAlign,
        marginRight: this.$parent.labelMarginRight
      };
    },
    labelWidth: function labelWidth() {
      return this.title.replace(/[^x00-xff]/g, '00').length / 2 + 1;
    },
    labelClass: function labelClass() {
      return {
        'vux-cell-justify': this.$parent.labelAlign === 'justify' || this.$parent.$parent.labelAlign === 'justify'
      };
    }
  },
  methods: {
    updateAutosize: function updateAutosize() {
      autosize_default.a.update(this.$refs.textarea);
    },

    // prop.autosize
    bindAutosize: function bindAutosize() {
      autosize_default()(this.$refs.textarea);
    },
    unbindAutosize: function unbindAutosize() {
      autosize_default.a.destroy(this.$refs.textarea);
    },

    // prop.autosize
    focus: function focus() {
      this.$refs.textarea.focus();
    }
  },
  // prop.autosize
  beforeDestroy: function beforeDestroy() {
    this.unbindAutosize();
  }
  // prop.autosize

});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/x-textarea/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



 // prop.autosize

/* harmony default export */ var components_x_textarea = ({
  name: 'x-textarea',
  minxins: [base["a" /* default */]],
  mounted: function mounted() {
    var _this = this;

    if (this.$slots && this.$slots['restricted-label']) {
      this.hasRestrictedLabel = true;
    }
    // prop.autosize
    this.$nextTick(function () {
      if (_this.autosize) {
        _this.bindAutosize();
      }
    });
    // prop.autosize
  },

  components: {
    InlineDesc: vux_src_components_inline_desc
  },
  props: {
    title: String,
    inlineDesc: String,
    showCounter: {
      type: Boolean,
      default: true
    },
    max: Number,
    value: String,
    name: String,
    placeholder: String,
    readonly: Boolean,
    disabled: Boolean,
    rows: {
      type: Number,
      default: 3
    },
    cols: {
      type: Number,
      default: 30
    },
    height: Number,
    // https://github.com/yisibl/blog/issues/3
    autocomplete: {
      type: String,
      default: 'off'
    },
    autocapitalize: {
      type: String,
      default: 'off'
    },
    autocorrect: {
      type: String,
      default: 'off'
    },
    spellcheck: {
      type: String,
      default: 'false'
    },
    autosize: Boolean // prop.autosize
  },
  created: function created() {
    this.currentValue = this.value;
  },

  watch: {
    // prop.autosize
    autosize: function autosize(val) {
      this.unbindAutosize();
      if (val) {
        this.bindAutosize();
      }
    },

    // prop.autosize
    value: function value(val) {
      this.currentValue = val;
    },
    currentValue: function currentValue(newVal) {
      if (this.max && newVal && newVal.length > this.max) {
        this.currentValue = newVal.slice(0, this.max);
      }
      this.$emit('input', this.currentValue);
      this.$emit('on-change', this.currentValue);
    }
  },
  data: function data() {
    return {
      hasRestrictedLabel: false,
      currentValue: ''
    };
  },

  computed: {
    count: function count() {
      var len = 0;
      if (this.currentValue) {
        len = this.currentValue.replace(/\n/g, 'aa').length;
      }
      return len > this.max ? this.max : len;
    },
    textareaStyle: function textareaStyle() {
      if (this.height) {
        return {
          height: this.height + 'px'
        };
      }
    },
    labelStyles: function labelStyles() {
      return {
        width: this.$parent.labelWidth || this.labelWidth + 'em',
        textAlign: this.$parent.labelAlign,
        marginRight: this.$parent.labelMarginRight
      };
    },
    labelWidth: function labelWidth() {
      return this.title.replace(/[^x00-xff]/g, '00').length / 2 + 1;
    },
    labelClass: function labelClass() {
      return {
        'vux-cell-justify': this.$parent.labelAlign === 'justify' || this.$parent.$parent.labelAlign === 'justify'
      };
    }
  },
  methods: {
    updateAutosize: function updateAutosize() {
      autosize_default.a.update(this.$refs.textarea);
    },

    // prop.autosize
    bindAutosize: function bindAutosize() {
      autosize_default()(this.$refs.textarea);
    },
    unbindAutosize: function unbindAutosize() {
      autosize_default.a.destroy(this.$refs.textarea);
    },

    // prop.autosize
    focus: function focus() {
      this.$refs.textarea.focus();
    }
  },
  // prop.autosize
  beforeDestroy: function beforeDestroy() {
    this.unbindAutosize();
  }
  // prop.autosize

});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-54e6a49a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/x-textarea/index.vue
var x_textarea_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"weui-cell vux-x-textarea"},[_c('div',{staticClass:"weui-cell__hd"},[(_vm.hasRestrictedLabel)?_c('div',{style:(_vm.labelStyles)},[_vm._t("restricted-label")],2):_vm._e(),_vm._v(" "),_vm._t("label",[(_vm.title)?_c('label',{staticClass:"weui-label",class:_vm.labelClass,style:({width: _vm.$parent.labelWidth || (_vm.labelWidth + 'em'), textAlign: _vm.$parent.labelAlign, marginRight: _vm.$parent.labelMarginRight}),domProps:{"innerHTML":_vm._s(_vm.title)}}):_vm._e(),_vm._v(" "),(_vm.inlineDesc)?_c('inline-desc',[_vm._v(_vm._s(_vm.inlineDesc))]):_vm._e()])],2),_vm._v(" "),_c('div',{staticClass:"weui-cell__bd"},[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentValue),expression:"currentValue"}],ref:"textarea",staticClass:"weui-textarea",style:(_vm.textareaStyle),attrs:{"autocomplete":_vm.autocomplete,"autocapitalize":_vm.autocapitalize,"autocorrect":_vm.autocorrect,"spellcheck":_vm.spellcheck,"placeholder":_vm.placeholder,"readonly":_vm.readonly,"disabled":_vm.disabled,"name":_vm.name,"rows":_vm.rows,"cols":_vm.cols,"maxlength":_vm.max},domProps:{"value":(_vm.currentValue)},on:{"focus":function($event){return _vm.$emit('on-focus')},"blur":function($event){return _vm.$emit('on-blur')},"input":function($event){if($event.target.composing){ return; }_vm.currentValue=$event.target.value}}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showCounter && _vm.max),expression:"showCounter && max"}],staticClass:"weui-textarea-counter",on:{"click":_vm.focus}},[_c('span',[_vm._v(_vm._s(_vm.count))]),_vm._v("/"+_vm._s(_vm.max)+"\n    ")])])])}
var x_textarea_staticRenderFns = []
var x_textarea_esExports = { render: x_textarea_render, staticRenderFns: x_textarea_staticRenderFns }
/* harmony default export */ var src_components_x_textarea = (x_textarea_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/x-textarea/index.vue
function x_textarea_injectStyle (ssrContext) {
  __webpack_require__("oWAa")
}
var x_textarea_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var x_textarea___vue_template_functional__ = false
/* styles */
var x_textarea___vue_styles__ = x_textarea_injectStyle
/* scopeId */
var x_textarea___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var x_textarea___vue_module_identifier__ = null
var x_textarea_Component = x_textarea_normalizeComponent(
  components_x_textarea,
  src_components_x_textarea,
  x_textarea___vue_template_functional__,
  x_textarea___vue_styles__,
  x_textarea___vue_scopeId__,
  x_textarea___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_x_textarea = (x_textarea_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/yingxin/tskjxy/views/items/address/info.vue










/* harmony default export */ var address_info = ({
  name: 'info',
  props: [],
  components: {
    Group: vux_src_components_group,
    Cell: vux_src_components_cell,
    PopupPicker: vux_src_components_popup_picker,
    XInput: vux_src_components_x_input,
    XTextarea: vux_src_components_x_textarea
  },
  data: function data() {
    return {
      fromItem: [{
        name: '原户口省份简称',
        type: 'select',
        data: [[{
          id: '01',
          value: '陕',
          name: '陕'
        }, {
          id: '02',
          value: '黑',
          name: '黑'
        }, {
          id: '03',
          value: '浙',
          name: '浙'
        }, {
          id: '04',
          value: '京',
          name: '京'
        }]],
        value: []
      }, {
        name: '编号',
        type: 'text',
        max: '',
        readonly: false,
        value: ''
      }, {
        name: '迁移证号',
        type: 'text',
        readonly: true,
        max: '',
        value: ''
      }],
      addressInfo: [{
        name: '原户口省份简称',
        label: '原户口省份简称',
        value2: [],
        value: ''
      }, {
        name: '编号',
        label: '编号',
        value: ''
      }, {
        name: '迁移证号',
        label: '迁移证号',
        value: ''
      }]
    };
  },

  computed: {},
  created: function created() {},
  mounted: function mounted() {
    this.addressInfo = this.$store.state.addressInfo;
  },

  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])(['addressInfoAction']), {
    onBlur: function onBlur() {
      this.addressInfo.forEach(function (element) {
        if (typeof_default()(element.value2) === 'object') {
          element.value = element.value2[0];
        }
      });
      this.addressInfo[2].value = this.addressInfo[0].value + this.addressInfo[1].value;
      this.$store.dispatch('addressInfoAction', this.addressInfo);
    },
    onShow: function onShow() {},
    onHide: function onHide(closeType) {

      if (closeType === true) {
        this.onBlur();
      }
    }
  })
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/yingxin/tskjxy/views/items/address/info.vue










/* harmony default export */ var items_address_info = ({
  name: 'info',
  props: [],
  components: {
    Group: vux_src_components_group,
    Cell: vux_src_components_cell,
    PopupPicker: vux_src_components_popup_picker,
    XInput: vux_src_components_x_input,
    XTextarea: vux_src_components_x_textarea
  },
  data: function data() {
    return {
      fromItem: [{
        name: '原户口省份简称',
        type: 'select',
        data: [[{
          id: '01',
          value: '陕',
          name: '陕'
        }, {
          id: '02',
          value: '黑',
          name: '黑'
        }, {
          id: '03',
          value: '浙',
          name: '浙'
        }, {
          id: '04',
          value: '京',
          name: '京'
        }]],
        value: []
      }, {
        name: '编号',
        type: 'text',
        max: '',
        readonly: false,
        value: ''
      }, {
        name: '迁移证号',
        type: 'text',
        readonly: true,
        max: '',
        value: ''
      }],
      addressInfo: [{
        name: '原户口省份简称',
        label: '原户口省份简称',
        value2: [],
        value: ''
      }, {
        name: '编号',
        label: '编号',
        value: ''
      }, {
        name: '迁移证号',
        label: '迁移证号',
        value: ''
      }]
    };
  },

  computed: {},
  created: function created() {},
  mounted: function mounted() {
    this.addressInfo = this.$store.state.addressInfo;
  },

  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])(['addressInfoAction']), {
    onBlur: function onBlur() {
      this.addressInfo.forEach(function (element) {
        if (typeof_default()(element.value2) === 'object') {
          element.value = element.value2[0];
        }
      });
      this.addressInfo[2].value = this.addressInfo[0].value + this.addressInfo[1].value;
      this.$store.dispatch('addressInfoAction', this.addressInfo);
    },
    onShow: function onShow() {},
    onHide: function onHide(closeType) {

      if (closeType === true) {
        this.onBlur();
      }
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f4cb3a04","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/yingxin/tskjxy/views/items/address/info.vue
var address_info_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"panel"},[_c('div',{staticClass:"panel-header text-gary"},[_vm._v("请填写信息")]),_c('div',{staticClass:"panel-body"},[_c('div',{staticClass:"card group-card"},[_c('Group',[_vm._l((_vm.fromItem),function(item,index){return [(item.type =='select')?_c('popup-picker',{attrs:{"title":item.name,"data":item.data,"placeholder":"请选择"},on:{"on-hide":_vm.onHide},model:{value:(_vm.addressInfo[index].value2),callback:function ($$v) {_vm.$set(_vm.addressInfo[index], "value2", $$v)},expression:"addressInfo[index].value2"}}):_vm._e(),(item.type == 'text')?_c('x-input',{key:index,attrs:{"title":item.name,"type":"text","placeholder":"输入编号","text-align":"right","readonly":item.readonly},on:{"on-blur":_vm.onBlur},model:{value:(_vm.addressInfo[index].value),callback:function ($$v) {_vm.$set(_vm.addressInfo[index], "value", $$v)},expression:"addressInfo[index].value"}}):_vm._e()]})],2)],1)])])}
var address_info_staticRenderFns = []
var address_info_esExports = { render: address_info_render, staticRenderFns: address_info_staticRenderFns }
/* harmony default export */ var views_items_address_info = (address_info_esExports);
// CONCATENATED MODULE: ./src/yingxin/tskjxy/views/items/address/info.vue
var address_info_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var address_info___vue_template_functional__ = false
/* styles */
var address_info___vue_styles__ = null
/* scopeId */
var address_info___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var address_info___vue_module_identifier__ = null
var address_info_Component = address_info_normalizeComponent(
  items_address_info,
  views_items_address_info,
  address_info___vue_template_functional__,
  address_info___vue_styles__,
  address_info___vue_scopeId__,
  address_info___vue_module_identifier__
)

/* harmony default export */ var tskjxy_views_items_address_info = (address_info_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/yingxin/tskjxy/views/items/address/submit.vue







/* harmony default export */ var address_submit = ({
  name: 'subimit',
  props: [],
  components: {
    Group: vux_src_components_group, Cell: vux_src_components_cell, Flexbox: flexbox_flexbox["a" /* default */], FlexboxItem: flexbox_item["a" /* default */], Previewer: vux_src_components_previewer
  },
  data: function data() {
    return {
      addressInfo: this.$store.state.addressInfo,
      images: {
        data: this.$store.state.addressFile.filesData,
        preview: {
          type: Boolean,
          default: true
        }
      }

    };
  },

  computed: {},
  created: function created() {},
  mounted: function mounted() {},
  updated: function updated() {},
  destroyed: function destroyed() {},

  watch: {},
  methods: {
    onPreview: function onPreview(index) {
      if (this.images.preview) {
        this.$refs.previewer.show(index);
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/yingxin/tskjxy/views/items/address/submit.vue







/* harmony default export */ var items_address_submit = ({
  name: 'subimit',
  props: [],
  components: {
    Group: vux_src_components_group, Cell: vux_src_components_cell, Flexbox: flexbox_flexbox["a" /* default */], FlexboxItem: flexbox_item["a" /* default */], Previewer: vux_src_components_previewer
  },
  data: function data() {
    return {
      addressInfo: this.$store.state.addressInfo,
      images: {
        data: this.$store.state.addressFile.filesData,
        preview: {
          type: Boolean,
          default: true
        }
      }

    };
  },

  computed: {},
  created: function created() {},
  mounted: function mounted() {},
  updated: function updated() {},
  destroyed: function destroyed() {},

  watch: {},
  methods: {
    onPreview: function onPreview(index) {
      if (this.images.preview) {
        this.$refs.previewer.show(index);
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f45e7a9e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/yingxin/tskjxy/views/items/address/submit.vue
var submit_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"panel"},[_c('div',{staticClass:"panel-header text-gary"},[_vm._v("迁移证照片")]),_c('div',{staticClass:"panel-body"},[_c('div',{staticClass:"vux-upload"},[_c('flexbox',{attrs:{"gutter":0,"wrap":"wrap"}},_vm._l((_vm.images.data),function(item,index){return _c('flexbox-item',{key:index,attrs:{"span":4},nativeOn:{"click":function($event){return _vm.onPreview(index)}}},[_c('div',{staticClass:"vux-upload-bg"},[_c('div',{staticClass:"vux-upload-content",style:({ backgroundImage: ("url(" + (item.src) + ")") })})])])}),1),_c('previewer',{ref:"previewer",attrs:{"list":_vm.images.data}})],1)])]),_c('div',{staticClass:"panel"},[_c('div',{staticClass:"panel-header text-gary"},[_vm._v("户口迁移信息")]),_c('div',{staticClass:"panel-body"},[_c('div',{staticClass:"card group-card"},[_c('Group',[_c('cell',{attrs:{"addressInfo":"addressInfo","title":_vm.addressInfo[_vm.addressInfo.length-1].name,"value":_vm.addressInfo[_vm.addressInfo.length-1].value}})],1)],1)])])])}
var submit_staticRenderFns = []
var submit_esExports = { render: submit_render, staticRenderFns: submit_staticRenderFns }
/* harmony default export */ var views_items_address_submit = (submit_esExports);
// CONCATENATED MODULE: ./src/yingxin/tskjxy/views/items/address/submit.vue
var submit_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var submit___vue_template_functional__ = false
/* styles */
var submit___vue_styles__ = null
/* scopeId */
var submit___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var submit___vue_module_identifier__ = null
var submit_Component = submit_normalizeComponent(
  items_address_submit,
  views_items_address_submit,
  submit___vue_template_functional__,
  submit___vue_styles__,
  submit___vue_scopeId__,
  submit___vue_module_identifier__
)

/* harmony default export */ var tskjxy_views_items_address_submit = (submit_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/yingxin/tskjxy/views/items/address.vue











/* harmony default export */ var address = ({
  name: 'info',
  props: [],
  components: {
    XHeader: vux_src_components_x_header,
    Step: src_components_step_step,
    StepItem: src_components_step_step_item,
    XButton: vux_src_components_x_button,
    Flexbox: flexbox_flexbox["a" /* default */],
    FlexboxItem: flexbox_item["a" /* default */],
    Upload: tskjxy_views_items_address_upload,
    Info: tskjxy_views_items_address_info,
    Submit: tskjxy_views_items_address_submit
  },
  data: function data() {
    return {
      stepList: {
        value: 0,
        list: [{
          name: '上传凭证'
        }, {
          name: '填写信息'
        }, {
          name: '提交审核'
        }]
      }
    };
  },

  computed: {
    title: function title() {
      return this.$route.params.title;
    },
    imgList: function imgList() {
      return this.$store.state.addressFile.filesData;
    },
    isNext: function isNext() {
      var flag = true;
      var info = this.$store.state.addressInfo;

      var arr = [];
      info.forEach(function (element) {
        if (element.value !== [] && element.value !== '') {
          arr.push(true);
        } else {
          arr.push(false);
        }
      });

      for (var i = 0; i < arr.length; i++) {

        if (arr[i] === true) {
          flag = false;
        } else {
          flag = true;
        }
      }
      return flag;
    }
  },
  created: function created() {},
  mounted: function mounted() {},
  updated: function updated() {},
  destroyed: function destroyed() {},

  watch: {},
  methods: {
    back: function back() {
      var _this = this;

      setTimeout(function () {
        _this.$router.back(-1);
      }, 300);
    },
    prev: function prev() {
      this.stepList.value--;
    },
    next: function next() {
      this.stepList.value++;
    },
    submit: function submit() {
      var _this2 = this;

      setTimeout(function () {
        _this2.$router.push({
          name: 'addressResult'
        });
      }, 300);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/yingxin/tskjxy/views/items/address.vue











/* harmony default export */ var items_address = ({
  name: 'info',
  props: [],
  components: {
    XHeader: vux_src_components_x_header,
    Step: src_components_step_step,
    StepItem: src_components_step_step_item,
    XButton: vux_src_components_x_button,
    Flexbox: flexbox_flexbox["a" /* default */],
    FlexboxItem: flexbox_item["a" /* default */],
    Upload: tskjxy_views_items_address_upload,
    Info: tskjxy_views_items_address_info,
    Submit: tskjxy_views_items_address_submit
  },
  data: function data() {
    return {
      stepList: {
        value: 0,
        list: [{
          name: '上传凭证'
        }, {
          name: '填写信息'
        }, {
          name: '提交审核'
        }]
      }
    };
  },

  computed: {
    title: function title() {
      return this.$route.params.title;
    },
    imgList: function imgList() {
      return this.$store.state.addressFile.filesData;
    },
    isNext: function isNext() {
      var flag = true;
      var info = this.$store.state.addressInfo;

      var arr = [];
      info.forEach(function (element) {
        if (element.value !== [] && element.value !== '') {
          arr.push(true);
        } else {
          arr.push(false);
        }
      });

      for (var i = 0; i < arr.length; i++) {

        if (arr[i] === true) {
          flag = false;
        } else {
          flag = true;
        }
      }
      return flag;
    }
  },
  created: function created() {},
  mounted: function mounted() {},
  updated: function updated() {},
  destroyed: function destroyed() {},

  watch: {},
  methods: {
    back: function back() {
      var _this = this;

      setTimeout(function () {
        _this.$router.back(-1);
      }, 300);
    },
    prev: function prev() {
      this.stepList.value--;
    },
    next: function next() {
      this.stepList.value++;
    },
    submit: function submit() {
      var _this2 = this;

      setTimeout(function () {
        _this2.$router.push({
          name: 'addressResult'
        });
      }, 300);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7bc8e2ae","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/yingxin/tskjxy/views/items/address.vue
var address_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg-white"},[_c('x-header',{staticClass:"header bg-white box-shadow"},[_c('em',{staticClass:"icon icon-arrow-left",attrs:{"slot":"overwrite-left","size":""},on:{"click":_vm.back},slot:"overwrite-left"}),_vm._v(_vm._s(_vm.title))]),_c('section',{staticClass:"section bg-white"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"step-box"},[_c('step',{attrs:{"background-color":"#fff"},model:{value:(_vm.stepList.value),callback:function ($$v) {_vm.$set(_vm.stepList, "value", $$v)},expression:"stepList.value"}},_vm._l((_vm.stepList.list),function(item,index){return _c('step-item',{key:index,attrs:{"title":"step 1","title":item.name}})}),1)],1),(_vm.stepList.value == 0)?_c('Upload'):_vm._e(),(_vm.stepList.value == 1)?_c('Info'):_vm._e(),(_vm.stepList.value == 2)?_c('Submit'):_vm._e()],1)]),_c('div',{staticClass:"button-group fixed bottom container"},[(_vm.stepList.value == 0)?_c('x-button',{attrs:{"type":"brand","disabled":_vm.imgList.length == 0},nativeOn:{"click":function($event){return _vm.next($event)}}},[_vm._v("下一步")]):_vm._e(),(_vm.stepList.value !== 0)?_c('flexbox',[_c('flexbox-item',[_c('x-button',{attrs:{"type":"warn"},nativeOn:{"click":function($event){return _vm.prev($event)}}},[_vm._v("上一步")])],1),(_vm.stepList.value !== _vm.stepList.list.length-1)?_c('flexbox-item',[_c('x-button',{attrs:{"type":"brand","disabled":_vm.isNext},nativeOn:{"click":function($event){return _vm.next($event)}}},[_vm._v("下一步")])],1):_vm._e(),(_vm.stepList.value == _vm.stepList.list.length-1)?_c('flexbox-item',[_c('x-button',{attrs:{"type":"brand"},nativeOn:{"click":function($event){return _vm.submit($event)}}},[_vm._v("提交")])],1):_vm._e()],1):_vm._e()],1),_c('transition',{attrs:{"name":"slide","enter-active-class":"animated fastest slideInRight","leave-active-class":"animated fastest slideOutRight"}},[_c('router-view')],1)],1)}
var address_staticRenderFns = []
var address_esExports = { render: address_render, staticRenderFns: address_staticRenderFns }
/* harmony default export */ var views_items_address = (address_esExports);
// CONCATENATED MODULE: ./src/yingxin/tskjxy/views/items/address.vue
function address_injectStyle (ssrContext) {
  __webpack_require__("EzhF")
}
var address_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var address___vue_template_functional__ = false
/* styles */
var address___vue_styles__ = address_injectStyle
/* scopeId */
var address___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var address___vue_module_identifier__ = null
var address_Component = address_normalizeComponent(
  items_address,
  views_items_address,
  address___vue_template_functional__,
  address___vue_styles__,
  address___vue_scopeId__,
  address___vue_module_identifier__
)

/* harmony default export */ var tskjxy_views_items_address = (address_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/check-icon/index.vue
//
//
//
//
//
//
//
//
//



/* harmony default export */ var check_icon = ({
  name: 'check-icon',
  components: {
    Icon: vux_src_components_icon
  },
  methods: {
    updateValue: function updateValue() {
      this.$emit('update:value', !this.value);
    }
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: 'default'
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/check-icon/index.vue
//
//
//
//
//
//
//
//
//



/* harmony default export */ var components_check_icon = ({
  name: 'check-icon',
  components: {
    Icon: vux_src_components_icon
  },
  methods: {
    updateValue: function updateValue() {
      this.$emit('update:value', !this.value);
    }
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: 'default'
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7de9c80d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/check-icon/index.vue
var check_icon_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-check-icon",on:{"click":_vm.updateValue}},[_c('icon',{directives:[{name:"show",rawName:"v-show",value:(_vm.type === 'default' && _vm.value),expression:"type === 'default' && value"}],attrs:{"type":"success"}}),_vm._v(" "),_c('icon',{directives:[{name:"show",rawName:"v-show",value:(_vm.type === 'plain' && _vm.value),expression:"type === 'plain' && value"}],attrs:{"type":"success_circle"}}),_vm._v(" "),_c('icon',{directives:[{name:"show",rawName:"v-show",value:(!_vm.value),expression:"!value"}],attrs:{"type":"circle"}}),_vm._v(" "),_c('span',[_vm._t("default")],2)],1)}
var check_icon_staticRenderFns = []
var check_icon_esExports = { render: check_icon_render, staticRenderFns: check_icon_staticRenderFns }
/* harmony default export */ var src_components_check_icon = (check_icon_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/check-icon/index.vue
function check_icon_injectStyle (ssrContext) {
  __webpack_require__("dUMw")
}
var check_icon_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var check_icon___vue_template_functional__ = false
/* styles */
var check_icon___vue_styles__ = check_icon_injectStyle
/* scopeId */
var check_icon___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var check_icon___vue_module_identifier__ = null
var check_icon_Component = check_icon_normalizeComponent(
  components_check_icon,
  src_components_check_icon,
  check_icon___vue_template_functional__,
  check_icon___vue_styles__,
  check_icon___vue_scopeId__,
  check_icon___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_check_icon = (check_icon_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/yingxin/tskjxy/views/items/loan.vue













/* harmony default export */ var loan = ({
  name: 'info',
  props: ['lastDataObj'],
  components: {
    Group: vux_src_components_group,
    Cell: vux_src_components_cell,
    PopupPicker: vux_src_components_popup_picker,
    XInput: vux_src_components_x_input,
    XTextarea: vux_src_components_x_textarea,
    XHeader: vux_src_components_x_header,
    XButton: vux_src_components_x_button,
    CheckIcon: vux_src_components_check_icon
  },
  data: function data() {
    return {
      readNotice: false,
      id: '',
      btnTextSave: '',
      infoList: [],
      fromItem: [{
        name: '缓交类型：',
        type: 'select',
        data: [[' ']],
        value: [],
        id: '',
        max: ''
      }, {
        name: '申请金额：',
        type: 'text',
        max: '',
        value: 0
      }, {
        name: '申请原因：',
        type: 'textarea',
        max: 40,
        value: ''
      }],
      loanInfo: [{
        name: '缓交类型',
        label: '缓交类型',
        value2: [],
        value: '',
        id: ''
      }, {
        name: '申请金额',
        label: '申请金额',
        value: '',
        max: 0
      }, {
        name: '申请原因',
        label: '申请原因',
        value: ''
      }],
      termText: '',
      disabledEditMoney: false,
      isEdit: 0,
      lastTypeId: '',
      lastApplyMoney: ''
    };
  },

  computed: extends_default()({}, Object(vuex_esm["c" /* mapState */])({
    token: function token(state) {
      return state.token;
    },
    studentId: function studentId(state) {
      return state.userInfo.id;
    },
    flowId: function flowId(state) {
      return state.flowInfo.flowId;
    },
    flowType: function flowType(state) {
      return state.flowInfo.flowType;
    },
    title: function title(state) {
      return state.currentProcedureInfo.name;
    },
    flowProcedureId: function flowProcedureId(state) {
      return state.currentProcedureInfo.flowProcedureId;
    },
    procedureId: function procedureId(state) {
      return state.currentProcedureInfo.procedureId;
    },
    endDate: function endDate(state) {
      return state.currentProcedureInfo.endDate;
    },
    flowYear: function flowYear(state) {
      return state.flowInfo.flowYear;
    },
    parentRouter: function parentRouter(state) {
      return state.currentProcedureInfo.parentRouter;
    }
  }), {
    btndisabled: function btndisabled() {
      var flag = true;
      if (this.loanInfo[2].value === '') {
        flag = true;
      } else {
        flag = false;
      }
      return flag;
    }
  }),
  created: function created() {},
  mounted: function mounted() {
    this.getLastData();
  },
  updated: function updated() {},
  destroyed: function destroyed() {},

  watch: {},
  methods: {
    back: function back() {
      var _this = this;

      setTimeout(function () {

        _this.$router.push({
          name: _this.parentRouter
        });
      }, 300);
    },
    onShow: function onShow() {},
    onHide: function onHide(closeType) {
      if (closeType === true) {
        this.onBlur();
      }
    },
    submitForm: function submitForm() {
      var _this2 = this;

      var params = {
        'id': this.id,
        'studentId': this.studentId,
        'flowId': this.flowId,
        'flowProcedureId': this.flowProcedureId,
        'procedureId': this.procedureId,
        'greenchanneltypeId': 1,
        'status': 1,
        'applyMoney': 0,
        'checkMoney': '',
        'handdlerType': 0,
        'handler': '',
        'remark': this.loanInfo[2].value,
        'fileIds': ''
      };
      this.$api.post('/sdtskjxy/greenChannel/handle', params, function (r) {
        _this2.$router.push({ name: 'itemResult' });
      }, function (err) {
        _this2.$vux.toast.text(err.message, 'top');
      });
    },
    getLastData: function getLastData() {
      var _this3 = this;

      var params = {
        'studentId': this.studentId,
        'flowId': this.flowId,
        'procedureId': this.procedureId
      };
      this.$api.get('greenChannel', params, function (r) {
        if (r.data) {
          _this3.id = r.data.id;
          _this3.btnTextSave = '重新申请';
          _this3.loanInfo[2].value = r.data.remark;
        } else {
          _this3.btnTextSave = '申请';
        }
      }, function (err) {
        _this3.$vux.toast.text(err.message, 'top');
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/yingxin/tskjxy/views/items/loan.vue













/* harmony default export */ var items_loan = ({
  name: 'info',
  props: ['lastDataObj'],
  components: {
    Group: vux_src_components_group,
    Cell: vux_src_components_cell,
    PopupPicker: vux_src_components_popup_picker,
    XInput: vux_src_components_x_input,
    XTextarea: vux_src_components_x_textarea,
    XHeader: vux_src_components_x_header,
    XButton: vux_src_components_x_button,
    CheckIcon: vux_src_components_check_icon
  },
  data: function data() {
    return {
      readNotice: false,
      id: '',
      btnTextSave: '',
      infoList: [],
      fromItem: [{
        name: '缓交类型：',
        type: 'select',
        data: [[' ']],
        value: [],
        id: '',
        max: ''
      }, {
        name: '申请金额：',
        type: 'text',
        max: '',
        value: 0
      }, {
        name: '申请原因：',
        type: 'textarea',
        max: 40,
        value: ''
      }],
      loanInfo: [{
        name: '缓交类型',
        label: '缓交类型',
        value2: [],
        value: '',
        id: ''
      }, {
        name: '申请金额',
        label: '申请金额',
        value: '',
        max: 0
      }, {
        name: '申请原因',
        label: '申请原因',
        value: ''
      }],
      termText: '',
      disabledEditMoney: false,
      isEdit: 0,
      lastTypeId: '',
      lastApplyMoney: ''
    };
  },

  computed: extends_default()({}, Object(vuex_esm["c" /* mapState */])({
    token: function token(state) {
      return state.token;
    },
    studentId: function studentId(state) {
      return state.userInfo.id;
    },
    flowId: function flowId(state) {
      return state.flowInfo.flowId;
    },
    flowType: function flowType(state) {
      return state.flowInfo.flowType;
    },
    title: function title(state) {
      return state.currentProcedureInfo.name;
    },
    flowProcedureId: function flowProcedureId(state) {
      return state.currentProcedureInfo.flowProcedureId;
    },
    procedureId: function procedureId(state) {
      return state.currentProcedureInfo.procedureId;
    },
    endDate: function endDate(state) {
      return state.currentProcedureInfo.endDate;
    },
    flowYear: function flowYear(state) {
      return state.flowInfo.flowYear;
    },
    parentRouter: function parentRouter(state) {
      return state.currentProcedureInfo.parentRouter;
    }
  }), {
    btndisabled: function btndisabled() {
      var flag = true;
      if (this.loanInfo[2].value === '') {
        flag = true;
      } else {
        flag = false;
      }
      return flag;
    }
  }),
  created: function created() {},
  mounted: function mounted() {
    this.getLastData();
  },
  updated: function updated() {},
  destroyed: function destroyed() {},

  watch: {},
  methods: {
    back: function back() {
      var _this = this;

      setTimeout(function () {

        _this.$router.push({
          name: _this.parentRouter
        });
      }, 300);
    },
    onShow: function onShow() {},
    onHide: function onHide(closeType) {
      if (closeType === true) {
        this.onBlur();
      }
    },
    submitForm: function submitForm() {
      var _this2 = this;

      var params = {
        'id': this.id,
        'studentId': this.studentId,
        'flowId': this.flowId,
        'flowProcedureId': this.flowProcedureId,
        'procedureId': this.procedureId,
        'greenchanneltypeId': 1,
        'status': 1,
        'applyMoney': 0,
        'checkMoney': '',
        'handdlerType': 0,
        'handler': '',
        'remark': this.loanInfo[2].value,
        'fileIds': ''
      };
      this.$api.post('/sdtskjxy/greenChannel/handle', params, function (r) {
        _this2.$router.push({ name: 'itemResult' });
      }, function (err) {
        _this2.$vux.toast.text(err.message, 'top');
      });
    },
    getLastData: function getLastData() {
      var _this3 = this;

      var params = {
        'studentId': this.studentId,
        'flowId': this.flowId,
        'procedureId': this.procedureId
      };
      this.$api.get('greenChannel', params, function (r) {
        if (r.data) {
          _this3.id = r.data.id;
          _this3.btnTextSave = '重新申请';
          _this3.loanInfo[2].value = r.data.remark;
        } else {
          _this3.btnTextSave = '申请';
        }
      }, function (err) {
        _this3.$vux.toast.text(err.message, 'top');
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3c956ae6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/yingxin/tskjxy/views/items/loan.vue
var loan_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('x-header',{staticClass:"header bg-white box-shadow"},[_c('em',{staticClass:"icon icon-arrow-left",attrs:{"slot":"overwrite-left","size":""},on:{"click":_vm.back},slot:"overwrite-left"}),_vm._v(_vm._s(_vm.title))]),_c('section',{staticClass:"section"},[_c('Group',[_c('x-textarea',{attrs:{"title":_vm.fromItem[2].name,"max":_vm.fromItem[2].max},model:{value:(_vm.loanInfo[2].value),callback:function ($$v) {_vm.$set(_vm.loanInfo[2], "value", $$v)},expression:"loanInfo[2].value"}})],1)],1),_c('div',{staticClass:"button-group fixed bottom container"},[_c('x-button',{attrs:{"type":"brand","disabled":_vm.btndisabled},nativeOn:{"click":function($event){return _vm.submitForm($event)}}},[_vm._v(_vm._s(_vm.btnTextSave))])],1)],1)}
var loan_staticRenderFns = []
var loan_esExports = { render: loan_render, staticRenderFns: loan_staticRenderFns }
/* harmony default export */ var views_items_loan = (loan_esExports);
// CONCATENATED MODULE: ./src/yingxin/tskjxy/views/items/loan.vue
var loan_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var loan___vue_template_functional__ = false
/* styles */
var loan___vue_styles__ = null
/* scopeId */
var loan___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var loan___vue_module_identifier__ = null
var loan_Component = loan_normalizeComponent(
  items_loan,
  views_items_loan,
  loan___vue_template_functional__,
  loan___vue_styles__,
  loan___vue_scopeId__,
  loan___vue_module_identifier__
)

/* harmony default export */ var tskjxy_views_items_loan = (loan_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/search/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var search = ({
  name: 'search',
  mixins: [uuid["a" /* default */]],
  props: {
    required: {
      type: Boolean,
      default: false
    },
    placeholder: String,
    cancelText: String,
    value: {
      type: String,
      default: ''
    },
    results: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    autoFixed: {
      type: Boolean,
      default: true
    },
    top: {
      type: String,
      default: '0px'
    },
    position: {
      type: String,
      default: 'fixed'
    },
    autoScrollToTop: Boolean
  },
  created: function created() {
    if (this.value) {
      this.currentValue = this.value;
    }
  },

  computed: {
    fixPosition: function fixPosition() {
      if (this.isFixed) {
        return this.position === 'absolute' ? 'absolute' : 'fixed';
      }
      return 'static';
    }
  },
  methods: {
    emitEvent: function emitEvent() {
      var _this = this;

      this.$nextTick(function () {
        _this.$emit('input', _this.currentValue);
        _this.$emit('on-change', _this.currentValue);
      });
    },
    onComposition: function onComposition($event, type) {
      if (type === 'start') {
        this.onInput = true;
      }
      if (type === 'end') {
        this.onInput = false;
        this.emitEvent();
      }
      if (type === 'input') {
        if (!this.onInput) {
          this.emitEvent();
        }
      }
    },
    clear: function clear() {
      this.currentValue = '';
      this.emitEvent();
      this.isFocus = true;
      this.setFocus();
      if (this.autoFixed && !this.isFixed) {
        this.isFixed = true;
      }
      this.$emit('on-clear');
    },
    cancel: function cancel() {
      this.isCancel = true;
      this.currentValue = '';
      this.emitEvent();
      this.isFixed = false;
      this.$emit('on-cancel');
    },
    handleResultClick: function handleResultClick(item) {
      this.$emit('result-click', item); // just for compatibility
      this.$emit('on-result-click', item);
      this.isCancel = true;
      this.isFixed = false;
    },
    touch: function touch() {
      this.isCancel = false;
      if (this.autoFixed) {
        this.isFixed = true;
      }
      this.$emit('on-touch');
    },
    setFocus: function setFocus() {
      this.$refs.input.focus();
    },
    setBlur: function setBlur() {
      this.$refs.input.blur();
    },
    onFocus: function onFocus() {
      this.isFocus = true;
      this.$emit('on-focus');
      this.touch();
    },
    onBlur: function onBlur() {
      this.isFocus = false;
      this.$emit('on-blur');
    }
  },
  data: function data() {
    return {
      onInput: false,
      currentValue: '',
      isCancel: true,
      isFocus: false,
      isFixed: false
    };
  },

  watch: {
    isFixed: function isFixed(val) {
      if (val === true) {
        this.setFocus();
        this.isFocus = true;

        if (this.autoScrollToTop) {
          setTimeout(function () {
            window.scrollTo(0, 0);
          }, 150);
        }
      } else {}
    },
    value: function value(val) {
      this.currentValue = val;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/search/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var components_search = ({
  name: 'search',
  mixins: [uuid["a" /* default */]],
  props: {
    required: {
      type: Boolean,
      default: false
    },
    placeholder: String,
    cancelText: String,
    value: {
      type: String,
      default: ''
    },
    results: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    autoFixed: {
      type: Boolean,
      default: true
    },
    top: {
      type: String,
      default: '0px'
    },
    position: {
      type: String,
      default: 'fixed'
    },
    autoScrollToTop: Boolean
  },
  created: function created() {
    if (this.value) {
      this.currentValue = this.value;
    }
  },

  computed: {
    fixPosition: function fixPosition() {
      if (this.isFixed) {
        return this.position === 'absolute' ? 'absolute' : 'fixed';
      }
      return 'static';
    }
  },
  methods: {
    emitEvent: function emitEvent() {
      var _this = this;

      this.$nextTick(function () {
        _this.$emit('input', _this.currentValue);
        _this.$emit('on-change', _this.currentValue);
      });
    },
    onComposition: function onComposition($event, type) {
      if (type === 'start') {
        this.onInput = true;
      }
      if (type === 'end') {
        this.onInput = false;
        this.emitEvent();
      }
      if (type === 'input') {
        if (!this.onInput) {
          this.emitEvent();
        }
      }
    },
    clear: function clear() {
      this.currentValue = '';
      this.emitEvent();
      this.isFocus = true;
      this.setFocus();
      if (this.autoFixed && !this.isFixed) {
        this.isFixed = true;
      }
      this.$emit('on-clear');
    },
    cancel: function cancel() {
      this.isCancel = true;
      this.currentValue = '';
      this.emitEvent();
      this.isFixed = false;
      this.$emit('on-cancel');
    },
    handleResultClick: function handleResultClick(item) {
      this.$emit('result-click', item); // just for compatibility
      this.$emit('on-result-click', item);
      this.isCancel = true;
      this.isFixed = false;
    },
    touch: function touch() {
      this.isCancel = false;
      if (this.autoFixed) {
        this.isFixed = true;
      }
      this.$emit('on-touch');
    },
    setFocus: function setFocus() {
      this.$refs.input.focus();
    },
    setBlur: function setBlur() {
      this.$refs.input.blur();
    },
    onFocus: function onFocus() {
      this.isFocus = true;
      this.$emit('on-focus');
      this.touch();
    },
    onBlur: function onBlur() {
      this.isFocus = false;
      this.$emit('on-blur');
    }
  },
  data: function data() {
    return {
      onInput: false,
      currentValue: '',
      isCancel: true,
      isFocus: false,
      isFixed: false
    };
  },

  watch: {
    isFixed: function isFixed(val) {
      if (val === true) {
        this.setFocus();
        this.isFocus = true;

        if (this.autoScrollToTop) {
          setTimeout(function () {
            window.scrollTo(0, 0);
          }, 150);
        }
      } else {}
    },
    value: function value(val) {
      this.currentValue = val;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9205242a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/search/index.vue
var search_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-search-box",class:{ 'vux-search-fixed':_vm.isFixed },style:({ top: _vm.isFixed ? _vm.top : '', position: _vm.fixPosition })},[_c('div',{staticClass:"weui-search-bar",class:{'weui-search-bar_focusing': !_vm.isCancel || _vm.currentValue}},[_vm._t("left"),_vm._v(" "),_c('form',{staticClass:"weui-search-bar__form",attrs:{"action":"."},on:{"submit":function($event){$event.preventDefault();return _vm.$emit('on-submit', _vm.value)}}},[_c('label',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isFixed && _vm.autoFixed),expression:"!isFixed && autoFixed"}],staticClass:"vux-search-mask",attrs:{"for":("search_input_" + _vm.uuid)},on:{"click":_vm.touch}}),_vm._v(" "),_c('div',{staticClass:"weui-search-bar__box"},[_c('i',{staticClass:"weui-icon-search"}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentValue),expression:"currentValue"}],ref:"input",staticClass:"weui-search-bar__input",attrs:{"type":"search","autocomplete":"off","id":("search_input_" + _vm.uuid),"placeholder":_vm.placeholder,"required":_vm.required},domProps:{"value":(_vm.currentValue)},on:{"focus":_vm.onFocus,"blur":_vm.onBlur,"compositionstart":function($event){return _vm.onComposition($event, 'start')},"compositionend":function($event){return _vm.onComposition($event, 'end')},"input":[function($event){if($event.target.composing){ return; }_vm.currentValue=$event.target.value},function($event){return _vm.onComposition($event, 'input')}]}}),_vm._v(" "),_c('a',{directives:[{name:"show",rawName:"v-show",value:(_vm.currentValue),expression:"currentValue"}],staticClass:"weui-icon-clear",attrs:{"href":"javascript:"},on:{"click":_vm.clear}})]),_vm._v(" "),_c('label',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isFocus && !_vm.value),expression:"!isFocus && !value"}],staticClass:"weui-search-bar__label",attrs:{"for":("search_input_" + _vm.uuid)}},[_c('i',{staticClass:"weui-icon-search"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.placeholder || '搜索'))])])]),_vm._v(" "),_c('a',{staticClass:"weui-search-bar__cancel-btn",attrs:{"href":"javascript:"},on:{"click":_vm.cancel}},[_vm._v(_vm._s(_vm.cancelText || '取消')+"\n    ")]),_vm._v(" "),_vm._t("right")],2),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isFixed),expression:"isFixed"}],staticClass:"weui-cells vux-search_show"},[_vm._t("default"),_vm._v(" "),_vm._l((_vm.results),function(item){return _c('div',{staticClass:"weui-cell weui-cell_access",on:{"click":function($event){return _vm.handleResultClick(item)}}},[_c('div',{staticClass:"weui-cell__bd weui-cell_primary"},[_c('p',[_vm._v(_vm._s(item.title))])])])})],2)])}
var search_staticRenderFns = []
var search_esExports = { render: search_render, staticRenderFns: search_staticRenderFns }
/* harmony default export */ var src_components_search = (search_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/search/index.vue
function search_injectStyle (ssrContext) {
  __webpack_require__("AFQ6")
}
var search_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var search___vue_template_functional__ = false
/* styles */
var search___vue_styles__ = search_injectStyle
/* scopeId */
var search___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var search___vue_module_identifier__ = null
var search_Component = search_normalizeComponent(
  components_search,
  src_components_search,
  search___vue_template_functional__,
  search___vue_styles__,
  search___vue_scopeId__,
  search___vue_module_identifier__
)


/* harmony default export */ var vux_src_components_search = (search_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/panel/index.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var panel = ({
  name: 'panel',
  props: {
    header: String,
    footer: Object,
    list: Array,
    type: {
      type: String,
      default: '1'
    }
  },
  methods: {
    onImgError: function onImgError(item, $event) {
      this.$emit('on-img-error', JSON.parse(stringify_default()(item)), $event);
      if (item.fallbackSrc) {
        $event.target.src = item.fallbackSrc;
      }
    },
    getUrl: function getUrl(url) {
      return Object(libs_router["a" /* getUrl */])(url, this.$router);
    },
    onClickFooter: function onClickFooter() {
      this.$emit('on-click-footer');
      Object(libs_router["b" /* go */])(this.footer.url, this.$router);
    },
    onClickHeader: function onClickHeader() {
      this.$emit('on-click-header');
    },
    onItemClick: function onItemClick(item) {
      this.$emit('on-click-item', item);
      Object(libs_router["b" /* go */])(item.url, this.$router);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/panel/index.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var components_panel = ({
  name: 'panel',
  props: {
    header: String,
    footer: Object,
    list: Array,
    type: {
      type: String,
      default: '1'
    }
  },
  methods: {
    onImgError: function onImgError(item, $event) {
      this.$emit('on-img-error', JSON.parse(stringify_default()(item)), $event);
      if (item.fallbackSrc) {
        $event.target.src = item.fallbackSrc;
      }
    },
    getUrl: function getUrl(url) {
      return Object(libs_router["a" /* getUrl */])(url, this.$router);
    },
    onClickFooter: function onClickFooter() {
      this.$emit('on-click-footer');
      Object(libs_router["b" /* go */])(this.footer.url, this.$router);
    },
    onClickHeader: function onClickHeader() {
      this.$emit('on-click-header');
    },
    onItemClick: function onItemClick(item) {
      this.$emit('on-click-item', item);
      Object(libs_router["b" /* go */])(item.url, this.$router);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b8e11956","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/panel/index.vue
var panel_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"weui-panel weui-panel_access"},[(_vm.header)?_c('div',{staticClass:"weui-panel__hd",domProps:{"innerHTML":_vm._s(_vm.header)},on:{"click":_vm.onClickHeader}},[_vm._t("header")],2):_vm._e(),_vm._v(" "),_c('div',{staticClass:"weui-panel__bd"},[_vm._t("body",[(_vm.type === '1')?_vm._l((_vm.list),function(item){return _c('a',{staticClass:"weui-media-box weui-media-box_appmsg",attrs:{"href":_vm.getUrl(item.url)},on:{"click":function($event){$event.preventDefault();return _vm.onItemClick(item)}}},[(item.src)?_c('div',{staticClass:"weui-media-box__hd"},[_c('img',{staticClass:"weui-media-box__thumb",attrs:{"src":item.src,"alt":""},on:{"error":function($event){return _vm.onImgError(item, $event)}}})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"weui-media-box__bd"},[_c('h4',{staticClass:"weui-media-box__title",domProps:{"innerHTML":_vm._s(item.title)}}),_vm._v(" "),_c('p',{staticClass:"weui-media-box__desc",domProps:{"innerHTML":_vm._s(item.desc)}})])])}):_vm._e(),_vm._v(" "),(_vm.type === '2')?_vm._l((_vm.list),function(item){return _c('div',{staticClass:"weui-media-box weui-media-box_text",on:{"click":function($event){$event.preventDefault();return _vm.onItemClick(item)}}},[_c('h4',{staticClass:"weui-media-box__title",domProps:{"innerHTML":_vm._s(item.title)}}),_vm._v(" "),_c('p',{staticClass:"weui-media-box__desc",domProps:{"innerHTML":_vm._s(item.desc)}})])}):_vm._e(),_vm._v(" "),(_vm.type === '3')?[_c('div',{staticClass:"weui-media-box weui-media-box_small-appmsg"},[_c('div',{staticClass:"weui-cells"},_vm._l((_vm.list),function(item){return _c('a',{staticClass:"weui-cell weui-cell_access",attrs:{"href":_vm.getUrl(item.url)},on:{"click":function($event){$event.preventDefault();return _vm.onItemClick(item)}}},[_c('div',{staticClass:"weui-cell__hd"},[_c('img',{staticStyle:{"width":"20px","margin-right":"5px","display":"block"},attrs:{"src":item.src,"alt":""},on:{"error":function($event){return _vm.onImgError(item, $event)}}})]),_vm._v(" "),_c('div',{staticClass:"weui-cell__bd"},[_c('p',{domProps:{"innerHTML":_vm._s(item.title)}})]),_vm._v(" "),_c('span',{staticClass:"weui-cell__ft"})])}),0)])]:_vm._e(),_vm._v(" "),(_vm.type === '4')?_vm._l((_vm.list),function(item){return _c('div',{staticClass:"weui-media-box weui-media-box_text",on:{"click":function($event){$event.preventDefault();return _vm.onItemClick(item)}}},[_c('h4',{staticClass:"weui-media-box__title",domProps:{"innerHTML":_vm._s(item.title)}}),_vm._v(" "),_c('p',{staticClass:"weui-media-box__desc",domProps:{"innerHTML":_vm._s(item.desc)}}),_vm._v(" "),(item.meta)?_c('ul',{staticClass:"weui-media-box__info"},[_c('li',{staticClass:"weui-media-box__info__meta",domProps:{"innerHTML":_vm._s(item.meta.source)}}),_vm._v(" "),_c('li',{staticClass:"weui-media-box__info__meta",domProps:{"innerHTML":_vm._s(item.meta.date)}}),_vm._v(" "),_c('li',{staticClass:"weui-media-box__info__meta weui-media-box__info__meta_extra",domProps:{"innerHTML":_vm._s(item.meta.other)}})]):_vm._e()])}):_vm._e(),_vm._v(" "),(_vm.type === '5')?_vm._l((_vm.list),function(item){return _c('div',{staticClass:"weui-media-box weui-media-box_text",on:{"click":function($event){$event.preventDefault();return _vm.onItemClick(item)}}},[_c('div',{staticClass:"weui-media-box_appmsg"},[(item.src)?_c('div',{staticClass:"weui-media-box__hd"},[_c('img',{staticClass:"weui-media-box__thumb",attrs:{"src":item.src,"alt":""},on:{"error":function($event){return _vm.onImgError(item, $event)}}})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"weui-media-box__bd"},[_c('h4',{staticClass:"weui-media-box__title",domProps:{"innerHTML":_vm._s(item.title)}}),_vm._v(" "),_c('p',{staticClass:"weui-media-box__desc",domProps:{"innerHTML":_vm._s(item.desc)}})])]),_vm._v(" "),(item.meta)?_c('ul',{staticClass:"weui-media-box__info"},[_c('li',{staticClass:"weui-media-box__info__meta",domProps:{"innerHTML":_vm._s(item.meta.source)}}),_vm._v(" "),_c('li',{staticClass:"weui-media-box__info__meta",domProps:{"innerHTML":_vm._s(item.meta.date)}}),_vm._v(" "),_c('li',{staticClass:"weui-media-box__info__meta weui-media-box__info__meta_extra",domProps:{"innerHTML":_vm._s(item.meta.other)}})]):_vm._e()])}):_vm._e()])],2),_vm._v(" "),_c('div',{staticClass:"weui-panel__ft"},[(_vm.footer && _vm.footer.title && _vm.type !== '3')?_c('a',{staticClass:"weui-cell weui-cell_access weui-cell_link",attrs:{"href":_vm.getUrl(_vm.footer.url)},on:{"click":function($event){$event.preventDefault();return _vm.onClickFooter($event)}}},[_c('div',{staticClass:"weui-cell__bd",domProps:{"innerHTML":_vm._s(_vm.footer.title)}})]):_vm._e()])])}
var panel_staticRenderFns = []
var panel_esExports = { render: panel_render, staticRenderFns: panel_staticRenderFns }
/* harmony default export */ var src_components_panel = (panel_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/panel/index.vue
function panel_injectStyle (ssrContext) {
  __webpack_require__("LK+o")
}
var panel_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var panel___vue_template_functional__ = false
/* styles */
var panel___vue_styles__ = panel_injectStyle
/* scopeId */
var panel___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var panel___vue_module_identifier__ = null
var panel_Component = panel_normalizeComponent(
  components_panel,
  src_components_panel,
  panel___vue_template_functional__,
  panel___vue_styles__,
  panel___vue_scopeId__,
  panel___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_panel = (panel_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/yingxin/tskjxy/views/items/dormroom.vue













/* harmony default export */ var dormroom = ({
  directives: {
    TransferDom: transfer_dom["a" /* default */]
  },
  name: 'dormroom',
  props: [],
  components: {
    XHeader: vux_src_components_x_header,
    Search: vux_src_components_search,
    Panel: vux_src_components_panel,
    'scroller': vuescroll_default.a,
    Popup: node_modules_vux_src_components_popup,
    Checker: src_components_checker_checker,
    CheckerItem: src_components_checker_checker_item,
    XButton: vux_src_components_x_button,
    Flexbox: flexbox_flexbox["a" /* default */],
    FlexboxItem: flexbox_item["a" /* default */]
  },
  data: function data() {
    return {
      serach: {
        results: [],
        value: 'test',
        autoFixed: false,
        placeholder: '',
        cancelText: ''
      },
      ops: {
        scrollPanel: {
          scrollingX: false
        },
        bar: {
          background: 'rgba(0, 107, 178, 0.3)',
          size: '3px',
          opacity: 0
        }
      },
      dormList: {
        type: '5',
        list: [{
          src: '/src/assets/sass/images/bg/dorm01.png',

          title: '15楼501',
          desc: '<ul class="dorm-info">\n<li>\u8D39\u7528\u6807\u51C6\uFF1A\xA51500555/\u5B66\u5E74</li>\n<li>\u5BBF\u820D\u89C4\u683C\uFF1A\u6807\u51C6\u56DB\u4EBA\u95F4 </li>\n</ul>'

        }, {
          src: '/src/assets/sass/images/bg/dorm01.png',
          title: '15楼501',
          desc: '<ul class="dorm-info">\n<li>\u8D39\u7528\u6807\u51C6\uFF1A\xA51500/\u5B66\u5E74</li>\n<li>\u5BBF\u820D\u89C4\u683C\uFF1A\u6807\u51C6\u56DB\u4EBA\u95F4 </li>\n</ul>',
          url: {}
        }, {
          src: '/src/assets/sass/images/bg/dorm01.png',
          title: '15楼501',
          desc: '<ul class="dorm-info">\n<li>\u8D39\u7528\u6807\u51C6\uFF1A\xA51500/\u5B66\u5E74</li>\n<li>\u5BBF\u820D\u89C4\u683C\uFF1A\u6807\u51C6\u56DB\u4EBA\u95F4 </li>\n</ul>',
          url: {}
        }, {
          src: '/src/assets/sass/images/bg/dorm01.png',
          title: '15楼501',
          desc: '<ul class="dorm-info">\n<li>\u8D39\u7528\u6807\u51C6\uFF1A\xA51500/\u5B66\u5E74</li>\n<li>\u5BBF\u820D\u89C4\u683C\uFF1A\u6807\u51C6\u56DB\u4EBA\u95F4 </li>\n</ul>',
          url: {}
        }, {
          src: '/src/assets/sass/images/bg/dorm01.png',
          title: '15楼501',
          desc: '<ul class="dorm-info">\n<li>\u8D39\u7528\u6807\u51C6\uFF1A\xA51500/\u5B66\u5E74</li>\n<li>\u5BBF\u820D\u89C4\u683C\uFF1A\u6807\u51C6\u56DB\u4EBA\u95F4 </li>\n</ul>',
          url: {}
        }, {
          src: '/src/assets/sass/images/bg/dorm01.png',
          title: '15楼501',
          desc: '<ul class="dorm-info">\n<li>\u8D39\u7528\u6807\u51C6\uFF1A\xA51500/\u5B66\u5E74</li>\n<li>\u5BBF\u820D\u89C4\u683C\uFF1A\u6807\u51C6\u56DB\u4EBA\u95F4 </li>\n</ul>',
          url: {}
        }]
      },
      isShowPanel: false,
      value: '',
      value1: ''
    };
  },

  computed: {
    title: function title() {
      return this.$route.params.title;
    }
  },
  created: function created() {},
  mounted: function mounted() {},
  updated: function updated() {},
  destroyed: function destroyed() {},

  watch: {},
  methods: {
    back: function back() {
      var _this = this;

      setTimeout(function () {
        _this.$router.back(-1);
      }, 300);
    },
    onFocus: function onFocus() {},
    onCancel: function onCancel() {},
    onSubmit: function onSubmit() {
      this.$refs.search.setBlur();
      this.$vux.toast.show({
        type: 'text',
        position: 'top',
        text: 'on submit'
      });
    },
    onImgError: function onImgError(item, $event) {
      console.log(item);
    },
    showPanel: function showPanel() {
      this.isShowPanel = !this.isShowPanel;
    },
    goDetail: function goDetail() {
      this.$router.push({
        name: 'dormroomDeatil'
      });
    },
    saveFilter: function saveFilter() {
      this.isShowPanel = false;
    },
    resetFilter: function resetFilter() {
      this.value = '';
      this.value1 = '';
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/yingxin/tskjxy/views/items/dormroom.vue













/* harmony default export */ var items_dormroom = ({
  directives: {
    TransferDom: transfer_dom["a" /* default */]
  },
  name: 'dormroom',
  props: [],
  components: {
    XHeader: vux_src_components_x_header,
    Search: vux_src_components_search,
    Panel: vux_src_components_panel,
    'scroller': vuescroll_default.a,
    Popup: node_modules_vux_src_components_popup,
    Checker: src_components_checker_checker,
    CheckerItem: src_components_checker_checker_item,
    XButton: vux_src_components_x_button,
    Flexbox: flexbox_flexbox["a" /* default */],
    FlexboxItem: flexbox_item["a" /* default */]
  },
  data: function data() {
    return {
      serach: {
        results: [],
        value: 'test',
        autoFixed: false,
        placeholder: '',
        cancelText: ''
      },
      ops: {
        scrollPanel: {
          scrollingX: false
        },
        bar: {
          background: 'rgba(0, 107, 178, 0.3)',
          size: '3px',
          opacity: 0
        }
      },
      dormList: {
        type: '5',
        list: [{
          src: '/src/assets/sass/images/bg/dorm01.png',

          title: '15楼501',
          desc: '<ul class="dorm-info">\n<li>\u8D39\u7528\u6807\u51C6\uFF1A\xA51500555/\u5B66\u5E74</li>\n<li>\u5BBF\u820D\u89C4\u683C\uFF1A\u6807\u51C6\u56DB\u4EBA\u95F4 </li>\n</ul>'

        }, {
          src: '/src/assets/sass/images/bg/dorm01.png',
          title: '15楼501',
          desc: '<ul class="dorm-info">\n<li>\u8D39\u7528\u6807\u51C6\uFF1A\xA51500/\u5B66\u5E74</li>\n<li>\u5BBF\u820D\u89C4\u683C\uFF1A\u6807\u51C6\u56DB\u4EBA\u95F4 </li>\n</ul>',
          url: {}
        }, {
          src: '/src/assets/sass/images/bg/dorm01.png',
          title: '15楼501',
          desc: '<ul class="dorm-info">\n<li>\u8D39\u7528\u6807\u51C6\uFF1A\xA51500/\u5B66\u5E74</li>\n<li>\u5BBF\u820D\u89C4\u683C\uFF1A\u6807\u51C6\u56DB\u4EBA\u95F4 </li>\n</ul>',
          url: {}
        }, {
          src: '/src/assets/sass/images/bg/dorm01.png',
          title: '15楼501',
          desc: '<ul class="dorm-info">\n<li>\u8D39\u7528\u6807\u51C6\uFF1A\xA51500/\u5B66\u5E74</li>\n<li>\u5BBF\u820D\u89C4\u683C\uFF1A\u6807\u51C6\u56DB\u4EBA\u95F4 </li>\n</ul>',
          url: {}
        }, {
          src: '/src/assets/sass/images/bg/dorm01.png',
          title: '15楼501',
          desc: '<ul class="dorm-info">\n<li>\u8D39\u7528\u6807\u51C6\uFF1A\xA51500/\u5B66\u5E74</li>\n<li>\u5BBF\u820D\u89C4\u683C\uFF1A\u6807\u51C6\u56DB\u4EBA\u95F4 </li>\n</ul>',
          url: {}
        }, {
          src: '/src/assets/sass/images/bg/dorm01.png',
          title: '15楼501',
          desc: '<ul class="dorm-info">\n<li>\u8D39\u7528\u6807\u51C6\uFF1A\xA51500/\u5B66\u5E74</li>\n<li>\u5BBF\u820D\u89C4\u683C\uFF1A\u6807\u51C6\u56DB\u4EBA\u95F4 </li>\n</ul>',
          url: {}
        }]
      },
      isShowPanel: false,
      value: '',
      value1: ''
    };
  },

  computed: {
    title: function title() {
      return this.$route.params.title;
    }
  },
  created: function created() {},
  mounted: function mounted() {},
  updated: function updated() {},
  destroyed: function destroyed() {},

  watch: {},
  methods: {
    back: function back() {
      var _this = this;

      setTimeout(function () {
        _this.$router.back(-1);
      }, 300);
    },
    onFocus: function onFocus() {},
    onCancel: function onCancel() {},
    onSubmit: function onSubmit() {
      this.$refs.search.setBlur();
      this.$vux.toast.show({
        type: 'text',
        position: 'top',
        text: 'on submit'
      });
    },
    onImgError: function onImgError(item, $event) {
      console.log(item);
    },
    showPanel: function showPanel() {
      this.isShowPanel = !this.isShowPanel;
    },
    goDetail: function goDetail() {
      this.$router.push({
        name: 'dormroomDeatil'
      });
    },
    saveFilter: function saveFilter() {
      this.isShowPanel = false;
    },
    resetFilter: function resetFilter() {
      this.value = '';
      this.value1 = '';
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1db5ddf2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/yingxin/tskjxy/views/items/dormroom.vue
var dormroom_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg-white dormroom"},[_c('x-header',{staticClass:"header bg-transparent"},[_c('em',{staticClass:"icon icon-arrow-left",attrs:{"slot":"overwrite-left","size":""},on:{"click":_vm.back},slot:"overwrite-left"})]),_vm._m(0),_c('div',{staticClass:"container"},[_c('div',{staticClass:"panel"},[_c('div',{staticClass:"panel-header"},[_c('strong',{staticClass:"float-left"},[_vm._v("为您推荐")]),_c('span',{staticClass:"float-right text-gary",on:{"click":_vm.showPanel}},[_vm._v("筛选"),_c('em',{staticClass:"icon icon-point-down"})])]),_c('div',{staticClass:"panel-body dorm-list"},[_c('panel',{attrs:{"list":_vm.dormList.list,"type":_vm.dormList.type},on:{"on-img-error":_vm.onImgError},nativeOn:{"click":function($event){return _vm.goDetail($event)}}})],1)])]),_c('div',{directives:[{name:"transfer-dom",rawName:"v-transfer-dom"}],staticClass:"medical-date-modal"},[_c('popup',{attrs:{"position":"top","width":"100%","height":"100%"},model:{value:(_vm.isShowPanel),callback:function ($$v) {_vm.isShowPanel=$$v},expression:"isShowPanel"}},[_c('div',[_c('x-header',{staticClass:"header bg-white fixed"},[_c('em',{staticClass:"icon icon-arrow-left",attrs:{"slot":"overwrite-left","size":""},on:{"click":function($event){_vm.isShowPanel = false}},slot:"overwrite-left"}),_vm._v("筛选宿舍")])],1),_c('div',{staticClass:"dormroom-filter-content"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"filter-item"},[_c('div',{staticClass:"name"},[_vm._v("宿舍标准")]),_c('div',{staticClass:"checkers check-line-2"},[_c('checker',{attrs:{"default-item-class":"checker-item","selected-item-class":"checker-item-selected","disabled-item-class":"checker-item-disabled"},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}},[_c('div',{staticClass:"check-box"},[_c('checker-item',{attrs:{"value":"1"}},[_vm._v("不限")])],1),_c('div',{staticClass:"check-box"},[_c('checker-item',{attrs:{"value":"2"}},[_c('p',[_vm._v("单人间")]),_c('p',{staticClass:"remark"},[_vm._v("￥3000/学年")])])],1),_c('div',{staticClass:"check-box"},[_c('checker-item',{attrs:{"value":"3"}},[_c('p',[_vm._v("单人间")]),_c('p',{staticClass:"remark"},[_vm._v("￥3000/学年")])])],1),_c('div',{staticClass:"check-box"},[_c('checker-item',{attrs:{"value":"4"}},[_c('p',[_vm._v("单人间")]),_c('p',{staticClass:"remark"},[_vm._v("￥3000/学年")])])],1),_c('div',{staticClass:"check-box"},[_c('checker-item',{attrs:{"value":"5"}},[_c('p',[_vm._v("单人间")]),_c('p',{staticClass:"remark"},[_vm._v("￥3000/学年")])])],1)])],1)]),_c('div',{staticClass:"filter-item"},[_c('div',{staticClass:"name"},[_vm._v("宿舍标准")]),_c('div',{staticClass:"checkers check-line-1"},[_c('checker',{attrs:{"default-item-class":"checker-item","selected-item-class":"checker-item-selected","disabled-item-class":"checker-item-disabled"},model:{value:(_vm.value1),callback:function ($$v) {_vm.value1=$$v},expression:"value1"}},[_c('div',{staticClass:"check-box"},[_c('checker-item',{attrs:{"value":"a"}},[_vm._v("不限")])],1),_c('div',{staticClass:"check-box"},[_c('checker-item',{attrs:{"value":"b"}},[_vm._v("1号楼")])],1),_c('div',{staticClass:"check-box"},[_c('checker-item',{attrs:{"value":"c"}},[_vm._v("1号楼")])],1),_c('div',{staticClass:"check-box"},[_c('checker-item',{attrs:{"value":"d"}},[_vm._v("1号楼")])],1),_c('div',{staticClass:"check-box"},[_c('checker-item',{attrs:{"value":"e"}},[_vm._v("1号楼")])],1)])],1)]),_c('div',{staticClass:"button-group fixed bottom container"},[_c('flexbox',[_c('flexbox-item',[_c('x-button',{attrs:{"type":"default"},nativeOn:{"click":function($event){return _vm.resetFilter($event)}}},[_vm._v("重置")])],1),_c('flexbox-item',[_c('x-button',{attrs:{"type":"brand"},nativeOn:{"click":function($event){return _vm.saveFilter($event)}}},[_vm._v(" 确定")])],1)],1)],1)])])])],1),_c('transition',{attrs:{"name":"slide","enter-active-class":"animated fastest slideInRight","leave-active-class":"animated fastest slideOutRight"}},[_c('router-view')],1)],1)}
var dormroom_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"banner"},[_c('img',{attrs:{"src":__webpack_require__("rIeQ")}}),_c('h2',[_vm._v("宿舍")])])}]
var dormroom_esExports = { render: dormroom_render, staticRenderFns: dormroom_staticRenderFns }
/* harmony default export */ var views_items_dormroom = (dormroom_esExports);
// CONCATENATED MODULE: ./src/yingxin/tskjxy/views/items/dormroom.vue
function dormroom_injectStyle (ssrContext) {
  __webpack_require__("Hq8V")
}
var dormroom_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var dormroom___vue_template_functional__ = false
/* styles */
var dormroom___vue_styles__ = dormroom_injectStyle
/* scopeId */
var dormroom___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var dormroom___vue_module_identifier__ = null
var dormroom_Component = dormroom_normalizeComponent(
  items_dormroom,
  views_items_dormroom,
  dormroom___vue_template_functional__,
  dormroom___vue_styles__,
  dormroom___vue_scopeId__,
  dormroom___vue_module_identifier__
)

/* harmony default export */ var tskjxy_views_items_dormroom = (dormroom_Component.exports);

// EXTERNAL MODULE: ./node_modules/vue-baidu-map/index.js
var vue_baidu_map = __webpack_require__("dAEq");
var vue_baidu_map_default = /*#__PURE__*/__webpack_require__.n(vue_baidu_map);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/yingxin/tskjxy/views/items/dormroom/dormroomDeatil.vue









/* harmony default export */ var dormroomDeatil = ({
  name: 'dormroom',
  props: [],
  components: {
    XHeader: vux_src_components_x_header,
    Panel: vux_src_components_panel,
    Swiper: vux_src_components_swiper_swiper,
    Flexbox: flexbox_flexbox["a" /* default */],
    FlexboxItem: flexbox_item["a" /* default */],
    XButton: vux_src_components_x_button,
    BaiduMap: vue_baidu_map["BaiduMap"],
    BmMarker: vue_baidu_map["BmMarker"],
    BmLabel: vue_baidu_map["BmLabel"],
    BmOverlay: vue_baidu_map["BmOverlay"]
  },
  data: function data() {
    return {
      demo01_index: 0,
      bannaerList: [{
        url: 'javascript:',
        img: __webpack_require__("KH5e"),
        title: '送你一朵fua'
      }, {
        url: 'javascript:',
        img: __webpack_require__("KH5e"),
        title: '送你一辆车'
      }, {
        url: 'javascript:',
        img: __webpack_require__("KH5e"),
        title: '送你一次旅行',
        fallbackImg: 'https://ww1.sinaimg.cn/large/663d3650gy1fq66vw50iwj20ff0aaaci.jpg'
      }],
      imgsrc: '',
      imgErrorUrl: 'this.src="' + __webpack_require__("rPBl") + '"',
      zoom: 16,
      center: {
        lat: 30.82825,
        lng: 104.197039
      },
      contactInfo: {
        position: {
          lat: 30.82825,
          lng: 104.197039
        }
      },
      mapStyle: {
        styleJson: [{
          'featureType': 'all',
          'elementType': 'geometry',
          'stylers': {
            'hue': '#007fff',
            'saturation': 89
          }
        }, {
          'featureType': 'water',
          'elementType': 'all',
          'stylers': {
            'color': '#ffffff'
          }
        }]
      }
    };
  },

  computed: {
    title: function title() {
      return this.$route.meta.title;
    }
  },
  created: function created() {},
  mounted: function mounted() {},
  updated: function updated() {},
  destroyed: function destroyed() {},

  watch: {},
  methods: {
    back: function back() {
      var _this = this;

      setTimeout(function () {
        _this.$router.back(-1);
      }, 300);
    },
    goChoseRoom: function goChoseRoom() {
      this.$router.push({
        name: 'dormChoseRoom'
      });
    },
    onFocus: function onFocus() {},
    onCancel: function onCancel() {},
    onSubmit: function onSubmit() {
      this.$refs.search.setBlur();
      this.$vux.toast.show({
        type: 'text',
        position: 'top',
        text: 'on submit'
      });
    },
    onImgError: function onImgError(item, $event) {
      console.log(item);
    },
    draw: function draw(_ref) {
      var _this2 = this;

      var el = _ref.el,
          BMap = _ref.BMap,
          map = _ref.map;

      this.getContactInfo().then(function () {
        var pixel = map.pointToOverlayPixel(new BMap.Point(_this2.contactInfo.position.lng, _this2.contactInfo.position.lat));
        el.style.left = pixel.x - 82 + 'px';
        el.style.top = pixel.y + 'px';
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/yingxin/tskjxy/views/items/dormroom/dormroomDeatil.vue









/* harmony default export */ var dormroom_dormroomDeatil = ({
  name: 'dormroom',
  props: [],
  components: {
    XHeader: vux_src_components_x_header,
    Panel: vux_src_components_panel,
    Swiper: vux_src_components_swiper_swiper,
    Flexbox: flexbox_flexbox["a" /* default */],
    FlexboxItem: flexbox_item["a" /* default */],
    XButton: vux_src_components_x_button,
    BaiduMap: vue_baidu_map["BaiduMap"],
    BmMarker: vue_baidu_map["BmMarker"],
    BmLabel: vue_baidu_map["BmLabel"],
    BmOverlay: vue_baidu_map["BmOverlay"]
  },
  data: function data() {
    return {
      demo01_index: 0,
      bannaerList: [{
        url: 'javascript:',
        img: __webpack_require__("KH5e"),
        title: '送你一朵fua'
      }, {
        url: 'javascript:',
        img: __webpack_require__("KH5e"),
        title: '送你一辆车'
      }, {
        url: 'javascript:',
        img: __webpack_require__("KH5e"),
        title: '送你一次旅行',
        fallbackImg: 'https://ww1.sinaimg.cn/large/663d3650gy1fq66vw50iwj20ff0aaaci.jpg'
      }],
      imgsrc: '',
      imgErrorUrl: 'this.src="' + __webpack_require__("rPBl") + '"',
      zoom: 16,
      center: {
        lat: 30.82825,
        lng: 104.197039
      },
      contactInfo: {
        position: {
          lat: 30.82825,
          lng: 104.197039
        }
      },
      mapStyle: {
        styleJson: [{
          'featureType': 'all',
          'elementType': 'geometry',
          'stylers': {
            'hue': '#007fff',
            'saturation': 89
          }
        }, {
          'featureType': 'water',
          'elementType': 'all',
          'stylers': {
            'color': '#ffffff'
          }
        }]
      }
    };
  },

  computed: {
    title: function title() {
      return this.$route.meta.title;
    }
  },
  created: function created() {},
  mounted: function mounted() {},
  updated: function updated() {},
  destroyed: function destroyed() {},

  watch: {},
  methods: {
    back: function back() {
      var _this = this;

      setTimeout(function () {
        _this.$router.back(-1);
      }, 300);
    },
    goChoseRoom: function goChoseRoom() {
      this.$router.push({
        name: 'dormChoseRoom'
      });
    },
    onFocus: function onFocus() {},
    onCancel: function onCancel() {},
    onSubmit: function onSubmit() {
      this.$refs.search.setBlur();
      this.$vux.toast.show({
        type: 'text',
        position: 'top',
        text: 'on submit'
      });
    },
    onImgError: function onImgError(item, $event) {
      console.log(item);
    },
    draw: function draw(_ref) {
      var _this2 = this;

      var el = _ref.el,
          BMap = _ref.BMap,
          map = _ref.map;

      this.getContactInfo().then(function () {
        var pixel = map.pointToOverlayPixel(new BMap.Point(_this2.contactInfo.position.lng, _this2.contactInfo.position.lat));
        el.style.left = pixel.x - 82 + 'px';
        el.style.top = pixel.y + 'px';
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0aee4ec2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/yingxin/tskjxy/views/items/dormroom/dormroomDeatil.vue
var dormroomDeatil_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg-white sub-page dorm-detail"},[_c('x-header',{staticClass:"header bg-white box-shadow fixed"},[_c('em',{staticClass:"icon icon-arrow-left",attrs:{"slot":"overwrite-left","size":""},on:{"click":_vm.back},slot:"overwrite-left"}),_vm._v(_vm._s(_vm.title))]),_c('section',[_c('swiper',{attrs:{"list":_vm.bannaerList,"aspect-ratio":0.5},model:{value:(_vm.demo01_index),callback:function ($$v) {_vm.demo01_index=$$v},expression:"demo01_index"}})],1),_c('div',{staticClass:"container"},[_vm._m(0),_c('div',{staticClass:"dorm-d-member"},[_c('h4',[_vm._v("房屋信息")]),_c('ul',{staticClass:"has-live"},[_c('li',[_c('div',{staticClass:"float-left"},[_c('span',[_vm._v("01卧")]),_c('img',{attrs:{"src":_vm.imgsrc,"onerror":_vm.imgErrorUrl}}),_c('span',[_vm._v("已入住")])]),_vm._m(1)]),_c('li',[_c('div',{staticClass:"float-left"},[_c('span',[_vm._v("01卧")]),_c('img',{attrs:{"src":_vm.imgsrc,"onerror":_vm.imgErrorUrl}}),_c('span',[_vm._v("已入住")])]),_vm._m(2)])]),_c('ul',[_c('li',[_c('div',{staticClass:"float-left"},[_c('span',[_vm._v("01卧")]),_c('img',{attrs:{"src":_vm.imgsrc,"onerror":_vm.imgErrorUrl}}),_c('span',[_vm._v("可入住")])])])])]),_c('div',{staticClass:"dorm-d-member"},[_c('h4',[_vm._v("周边及交通")]),_c('div',{staticClass:"map-content"},[_c('baidu-map',{staticStyle:{"width":"100%","height":"50vh"},attrs:{"center":_vm.center,"scroll-wheel-zoom":true,"zoom":_vm.zoom,"ak":"teb3oj4kPudP57wFREYRCyRUga5X4Qpj","mapStyle":_vm.mapStyle},on:{"ready":function($event){}}},[_c('bm-marker',{attrs:{"position":_vm.contactInfo.position,"animation":"BMAP_ANIMATION_BOUNCE","icon":{url: __webpack_require__("09Uw"), size: {width: 60, height: 100}},"offset":{width: -4, height: 0}}})],1)],1)])]),_c('div',{staticClass:"button-group fixed bottom container"},[_c('x-button',{attrs:{"type":"brand"},nativeOn:{"click":function($event){return _vm.goChoseRoom($event)}}},[_vm._v("立即预定")])],1)],1)}
var dormroomDeatil_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dorm-d-info"},[_c('h3',[_vm._v("宿舍 (东校区)安雅园 15号楼 05层 501室")]),_c('div',{staticClass:"info"},[_c('div',{staticClass:"float-left fee"},[_vm._v(" ¥1500/学年")]),_c('div',{staticClass:"float-right way"},[_vm._v("付款方式 >")])]),_c('ul',{staticClass:"info configuration"},[_c('li',{staticClass:"float-left"},[_vm._v(" 标准四人间")]),_c('li',{staticClass:"float-left"},[_vm._v(" 独立卫浴")]),_c('li',{staticClass:"float-left"},[_vm._v(" 空调")])]),_c('ul',{staticClass:"info info-panl"},[_c('li',{staticClass:"float-left"},[_c('span',{staticClass:"title"},[_vm._v("面积")]),_c('span',{staticClass:"text"},[_vm._v("20m（使用面积）")])]),_c('li',{staticClass:"float-left"},[_c('span',{staticClass:"title"},[_vm._v("面积")]),_c('span',{staticClass:"text"},[_vm._v("20m（使用面积)")])]),_c('li',{staticClass:"float-left"},[_c('span',{staticClass:"title"},[_vm._v("面积")]),_c('span',{staticClass:"text"},[_vm._v("20m（使用面积）")])]),_c('li',{staticClass:"float-left"},[_c('span',{staticClass:"title"},[_vm._v("面积")]),_c('span',{staticClass:"text"},[_vm._v("20m（使用面积)")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"float-right"},[_c('span',[_vm._v("女 |")]),_c('span',[_vm._v("双鱼座 |")]),_c('span',[_vm._v("18岁 |")]),_c('span',[_vm._v("北京")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"float-right"},[_c('span',[_vm._v("女 |")]),_c('span',[_vm._v("双鱼座 |")]),_c('span',[_vm._v("18岁 |")]),_c('span',[_vm._v("北京")])])}]
var dormroomDeatil_esExports = { render: dormroomDeatil_render, staticRenderFns: dormroomDeatil_staticRenderFns }
/* harmony default export */ var items_dormroom_dormroomDeatil = (dormroomDeatil_esExports);
// CONCATENATED MODULE: ./src/yingxin/tskjxy/views/items/dormroom/dormroomDeatil.vue
function dormroomDeatil_injectStyle (ssrContext) {
  __webpack_require__("Owmw")
}
var dormroomDeatil_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var dormroomDeatil___vue_template_functional__ = false
/* styles */
var dormroomDeatil___vue_styles__ = dormroomDeatil_injectStyle
/* scopeId */
var dormroomDeatil___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var dormroomDeatil___vue_module_identifier__ = null
var dormroomDeatil_Component = dormroomDeatil_normalizeComponent(
  dormroom_dormroomDeatil,
  items_dormroom_dormroomDeatil,
  dormroomDeatil___vue_template_functional__,
  dormroomDeatil___vue_styles__,
  dormroomDeatil___vue_scopeId__,
  dormroomDeatil___vue_module_identifier__
)

/* harmony default export */ var views_items_dormroom_dormroomDeatil = (dormroomDeatil_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/yingxin/tskjxy/views/items/dormroom/dormChoseRoom.vue










/* harmony default export */ var dormChoseRoom = ({
  name: 'dormroom',
  props: [],
  components: {
    XHeader: vux_src_components_x_header,
    Panel: vux_src_components_panel,
    Swiper: vux_src_components_swiper_swiper,
    Flexbox: flexbox_flexbox["a" /* default */],
    FlexboxItem: flexbox_item["a" /* default */],
    XButton: vux_src_components_x_button,
    Checker: src_components_checker_checker,
    CheckerItem: src_components_checker_checker_item
  },
  data: function data() {
    return {
      value: ''
    };
  },

  computed: {
    title: function title() {
      return this.$route.meta.title;
    }
  },
  created: function created() {},
  mounted: function mounted() {},
  updated: function updated() {},
  destroyed: function destroyed() {},

  watch: {},
  methods: {
    back: function back() {
      var _this = this;

      setTimeout(function () {
        _this.$router.back(-1);
      }, 300);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/yingxin/tskjxy/views/items/dormroom/dormChoseRoom.vue










/* harmony default export */ var dormroom_dormChoseRoom = ({
  name: 'dormroom',
  props: [],
  components: {
    XHeader: vux_src_components_x_header,
    Panel: vux_src_components_panel,
    Swiper: vux_src_components_swiper_swiper,
    Flexbox: flexbox_flexbox["a" /* default */],
    FlexboxItem: flexbox_item["a" /* default */],
    XButton: vux_src_components_x_button,
    Checker: src_components_checker_checker,
    CheckerItem: src_components_checker_checker_item
  },
  data: function data() {
    return {
      value: ''
    };
  },

  computed: {
    title: function title() {
      return this.$route.meta.title;
    }
  },
  created: function created() {},
  mounted: function mounted() {},
  updated: function updated() {},
  destroyed: function destroyed() {},

  watch: {},
  methods: {
    back: function back() {
      var _this = this;

      setTimeout(function () {
        _this.$router.back(-1);
      }, 300);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ce0acef0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/yingxin/tskjxy/views/items/dormroom/dormChoseRoom.vue
var dormChoseRoom_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg-white sub-page dorm-chose-room"},[_c('x-header',{staticClass:"header bg-white box-shadow fixed"},[_c('em',{staticClass:"icon icon-arrow-left",attrs:{"slot":"overwrite-left","size":""},on:{"click":_vm.back},slot:"overwrite-left"}),_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"container fixed-next"},[_c('h3',{staticClass:"info"},[_vm._v("安雅园15号楼-05层-501室")]),_vm._m(0),_c('div',{staticClass:"card"},[_c('checker',{attrs:{"default-item-class":"checker-item","selected-item-class":"checker-item-selected","disabled-item-class":"checker-item-disabled"},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}},[_c('div',{staticClass:"check-box"},[_c('checker-item',{attrs:{"value":"1"}},[_vm._v("1")])],1),_c('div',{staticClass:"check-box"},[_c('checker-item',{attrs:{"value":"2"}},[_vm._v("2")])],1),_c('div',{staticClass:"check-box"},[_c('checker-item',{attrs:{"value":"3"}},[_vm._v("3")])],1),_c('div',{staticClass:"check-box"},[_c('checker-item',{attrs:{"value":"4","disabled":"true"}},[_vm._v("4")])],1),_c('div',{staticClass:"check-box"},[_c('checker-item',{attrs:{"value":"5","disabled":"true"}},[_vm._v("5")])],1),_c('div',{staticClass:"check-box"},[_c('checker-item',{attrs:{"value":"5","disabled":"true"}},[_vm._v("6")])],1),_c('div',{staticClass:"line"})])],1)]),_c('div',{staticClass:"button-group fixed bottom container"},[_c('x-button',{attrs:{"type":"brand","disabled":_vm.value==''},nativeOn:{"click":function($event){return _vm.next($event)}}},[_vm._v("立即预定")])],1)],1)}
var dormChoseRoom_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"title"},[_c('div',{staticClass:"float-left"},[_vm._v("请选择床位")]),_c('ul',{staticClass:"float-right legend"},[_c('li',{staticClass:"Optiona"},[_c('span',[_vm._v("可选")])]),_c('li',{staticClass:"cur-Optiona"},[_c('span',[_vm._v("选中")])]),_c('li',{staticClass:"not-optiona"},[_c('span',[_vm._v(" 不可选")])])])])}]
var dormChoseRoom_esExports = { render: dormChoseRoom_render, staticRenderFns: dormChoseRoom_staticRenderFns }
/* harmony default export */ var items_dormroom_dormChoseRoom = (dormChoseRoom_esExports);
// CONCATENATED MODULE: ./src/yingxin/tskjxy/views/items/dormroom/dormChoseRoom.vue
function dormChoseRoom_injectStyle (ssrContext) {
  __webpack_require__("OBBg")
}
var dormChoseRoom_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var dormChoseRoom___vue_template_functional__ = false
/* styles */
var dormChoseRoom___vue_styles__ = dormChoseRoom_injectStyle
/* scopeId */
var dormChoseRoom___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var dormChoseRoom___vue_module_identifier__ = null
var dormChoseRoom_Component = dormChoseRoom_normalizeComponent(
  dormroom_dormChoseRoom,
  items_dormroom_dormChoseRoom,
  dormChoseRoom___vue_template_functional__,
  dormChoseRoom___vue_styles__,
  dormChoseRoom___vue_scopeId__,
  dormChoseRoom___vue_module_identifier__
)

/* harmony default export */ var views_items_dormroom_dormChoseRoom = (dormChoseRoom_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/yingxin/tskjxy/views/items/pay.vue















/* harmony default export */ var pay = ({
  name: 'pay',
  props: [],
  components: {
    XHeader: vux_src_components_x_header,
    Swiper: vux_src_components_swiper_swiper,
    SwiperItem: src_components_swiper_swiper_item,
    Grid: src_components_grid_grid,
    GridItem: src_components_grid_grid_item,
    XButton: vux_src_components_x_button,
    Tab: src_components_tab_tab,
    TabItem: src_components_tab_tab_item,
    'scroller': vuescroll_default.a,
    Error: src_components_error
  },
  data: function data() {
    return {
      title: this.$store.state.currentProcedureInfo.name,
      ops: {
        scrollPanel: {
          scrollingX: false
        },
        bar: {
          background: 'rgba(0, 107, 178, 0.3)',
          size: '3px',
          opacity: 0
        }
      },

      swiper: {
        isDots: false,
        aspectRatio: 0.35
      },
      isFixed: false,
      pendingList: [],
      index: 0,
      billType: [{
        name: '全部'
      }, {
        name: '待缴'
      }, {
        name: '已缴'
      }],
      billList: [],
      errorMsg: {
        type: 'null',
        content: '当前分类无账单明细'
      },
      thirdUrl: '',
      snoDes: '',
      owes: 0
    };
  },

  computed: extends_default()({}, Object(vuex_esm["c" /* mapState */])({
    studentSno: function studentSno(state) {
      return state.userInfo.sno;
    },
    flowId: function flowId(state) {
      return state.flowInfo ? state.flowInfo.flowId : null;
    },
    parentRouter: function parentRouter(state) {
      return state.currentProcedureInfo.parentRouter;
    }
  })),
  created: function created() {},
  mounted: function mounted() {
    this.$vux.loading.show({
      text: '加载中'
    });
    this.getBillList(0);
    this.getHelperDes();
    this.getThirdUrl();
  },
  updated: function updated() {},
  destroyed: function destroyed() {},

  watch: {},
  methods: {
    back: function back() {
      var _this = this;

      setTimeout(function () {

        _this.$router.push({
          name: _this.parentRouter
        });
      }, 300);
    },
    toPay: function toPay() {
      window.location = this.thirdUrl + '?synjones_ticket=' + this.snoDes + '&synjones_type=app';
    },
    getBillList: function getBillList(index) {
      var _this2 = this;

      var params = {
        studentSno: this.studentSno
      };
      return new promise_default.a(function (resolve, reject) {
        _this2.$api.get('/charge', params, function (r) {
          _this2.$vux.loading.hide();
          var data = r.data;
          _this2.pendingList = data.filter(function (item) {
            return item.owe > 0;
          });
          if (index === 0) {

            _this2.billList = data;
          } else if (index === 1) {

            _this2.billList = data.filter(function (item) {
              return item.owe > 0;
            });
          } else if (index === 2) {

            _this2.billList = data.filter(function (item) {
              return item.owe <= 0;
            });
          }
          _this2.owes = 0;
          data.forEach(function (element) {
            if (element.owe > 0) {
              _this2.owes++;
            }
          });
          resolve();
        }, function (err) {
          console.log('charge' + err);
          _this2.$vux.toast.text(err.message, 'top');
        });
      });
    },
    getThirdUrl: function getThirdUrl() {
      var _this3 = this;

      var params = {
        flowId: this.flowId,
        flowProcedureId: this.$route.query.flowProcedureId,
        procedureId: this.$route.query.procedureId
      };
      this.$api.get('/flowProcedure', params, function (r) {
        _this3.thirdUrl = r.data[0].config;
      }, function (err) {
        console.log(err);
      });
    },
    getHelperDes: function getHelperDes() {
      var _this4 = this;

      var params = {
        info: this.studentSno
      };
      this.$api.get('/helper/des', params, function (r) {
        _this4.snoDes = encodeURIComponent(r.data);
      }, function (err) {
        console.log('获取HelperDes失败', err);
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/yingxin/tskjxy/views/items/pay.vue















/* harmony default export */ var items_pay = ({
  name: 'pay',
  props: [],
  components: {
    XHeader: vux_src_components_x_header,
    Swiper: vux_src_components_swiper_swiper,
    SwiperItem: src_components_swiper_swiper_item,
    Grid: src_components_grid_grid,
    GridItem: src_components_grid_grid_item,
    XButton: vux_src_components_x_button,
    Tab: src_components_tab_tab,
    TabItem: src_components_tab_tab_item,
    'scroller': vuescroll_default.a,
    Error: src_components_error
  },
  data: function data() {
    return {
      title: this.$store.state.currentProcedureInfo.name,
      ops: {
        scrollPanel: {
          scrollingX: false
        },
        bar: {
          background: 'rgba(0, 107, 178, 0.3)',
          size: '3px',
          opacity: 0
        }
      },

      swiper: {
        isDots: false,
        aspectRatio: 0.35
      },
      isFixed: false,
      pendingList: [],
      index: 0,
      billType: [{
        name: '全部'
      }, {
        name: '待缴'
      }, {
        name: '已缴'
      }],
      billList: [],
      errorMsg: {
        type: 'null',
        content: '当前分类无账单明细'
      },
      thirdUrl: '',
      snoDes: '',
      owes: 0
    };
  },

  computed: extends_default()({}, Object(vuex_esm["c" /* mapState */])({
    studentSno: function studentSno(state) {
      return state.userInfo.sno;
    },
    flowId: function flowId(state) {
      return state.flowInfo ? state.flowInfo.flowId : null;
    },
    parentRouter: function parentRouter(state) {
      return state.currentProcedureInfo.parentRouter;
    }
  })),
  created: function created() {},
  mounted: function mounted() {
    this.$vux.loading.show({
      text: '加载中'
    });
    this.getBillList(0);
    this.getHelperDes();
    this.getThirdUrl();
  },
  updated: function updated() {},
  destroyed: function destroyed() {},

  watch: {},
  methods: {
    back: function back() {
      var _this = this;

      setTimeout(function () {

        _this.$router.push({
          name: _this.parentRouter
        });
      }, 300);
    },
    toPay: function toPay() {
      window.location = this.thirdUrl + '?synjones_ticket=' + this.snoDes + '&synjones_type=app';
    },
    getBillList: function getBillList(index) {
      var _this2 = this;

      var params = {
        studentSno: this.studentSno
      };
      return new promise_default.a(function (resolve, reject) {
        _this2.$api.get('/charge', params, function (r) {
          _this2.$vux.loading.hide();
          var data = r.data;
          _this2.pendingList = data.filter(function (item) {
            return item.owe > 0;
          });
          if (index === 0) {

            _this2.billList = data;
          } else if (index === 1) {

            _this2.billList = data.filter(function (item) {
              return item.owe > 0;
            });
          } else if (index === 2) {

            _this2.billList = data.filter(function (item) {
              return item.owe <= 0;
            });
          }
          _this2.owes = 0;
          data.forEach(function (element) {
            if (element.owe > 0) {
              _this2.owes++;
            }
          });
          resolve();
        }, function (err) {
          console.log('charge' + err);
          _this2.$vux.toast.text(err.message, 'top');
        });
      });
    },
    getThirdUrl: function getThirdUrl() {
      var _this3 = this;

      var params = {
        flowId: this.flowId,
        flowProcedureId: this.$route.query.flowProcedureId,
        procedureId: this.$route.query.procedureId
      };
      this.$api.get('/flowProcedure', params, function (r) {
        _this3.thirdUrl = r.data[0].config;
      }, function (err) {
        console.log(err);
      });
    },
    getHelperDes: function getHelperDes() {
      var _this4 = this;

      var params = {
        info: this.studentSno
      };
      this.$api.get('/helper/des', params, function (r) {
        _this4.snoDes = encodeURIComponent(r.data);
      }, function (err) {
        console.log('获取HelperDes失败', err);
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3903a0d6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/yingxin/tskjxy/views/items/pay.vue
var pay_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('x-header',{staticClass:"header bg-white box-shadow"},[_c('em',{staticClass:"icon icon-arrow-left",attrs:{"slot":"overwrite-left","size":""},on:{"click":_vm.back},slot:"overwrite-left"}),_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"tab-box"},[_c('div',{staticClass:"tab-outer isFixed",attrs:{"id":"tab-outer"}},[_c('tab',{attrs:{"line-width":2,"active-color":"#FEAA33","scroll-threshold":_vm.billType.length},model:{value:(_vm.index),callback:function ($$v) {_vm.index=$$v},expression:"index"}},_vm._l((_vm.billType),function(item,index){return _c('tab-item',{key:index,staticClass:"vux-center",on:{"on-item-click":function($event){return _vm.getBillList(index)}}},[_vm._v(_vm._s(item.name))])}),1)],1)]),[(_vm.billList == "")?_c('error',{staticStyle:{"padding-top":"50px"},attrs:{"errorMsg":_vm.errorMsg}}):_c('div',{staticClass:"scroller-wrapper",style:({'padding-top':'50px','bottom': (_vm.thirdUrl && _vm.owes != 0 ? '50px':'0')})},[_c('scroller',{attrs:{"ops":_vm.ops}},[_c('section',{staticClass:"section"},[_c('div',{staticClass:"container"},_vm._l((_vm.billList),function(subItem,j){return _c('div',{key:j,ref:"card",refInFor:true,staticClass:"card pay-card"},[_c('div',{staticClass:"card-header"},[_c('span',{staticClass:"icons icon-bg",class:("icon-bg" + (j%4+1))},[_c('em',{staticClass:"icon icon-item-o"})]),_c('div',{staticClass:"title float-left"},[_vm._v(_vm._s(subItem.chargeItemBean.name))]),_c('div',{staticClass:"remark float-right",class:subItem.owe == 0 || subItem.owe == null ? 'text-success' : 'text-danger'},[_vm._v(_vm._s(subItem.owe == 0 || subItem.owe == null ? '已缴' : '待缴'))])]),_c('div',{staticClass:"card-body"},[_c('ul',[_c('li',[_vm._v("缴费年度: "+_vm._s(subItem.year))]),(subItem.pay !== null)?_c('li',[_vm._v("应缴金额: ￥"+_vm._s(subItem.pay.toFixed(2)))]):_vm._e(),(subItem.paid !== null)?_c('li',[_vm._v("已缴金额: ￥"+_vm._s(subItem.paid.toFixed(2)))]):_vm._e(),(subItem.owe)?_c('li',[_vm._v("待缴金额: ￥"+_vm._s(subItem.owe.toFixed(2)))]):_vm._e(),(subItem.chargeDelayBean.money > 0)?_c('li',[_vm._v("缓缴金额: ￥"+_vm._s(subItem.chargeDelayBean.money.toFixed(2)))]):_vm._e(),(subItem.reduce > 0)?_c('li',[_vm._v("减免金额: ￥"+_vm._s(subItem.reduce.toFixed(2)))]):_vm._e()])])])}),0)])])],1),_c('div',{staticClass:"button-group container fixed bottom"},[(_vm.thirdUrl && _vm.owes != 0)?_c('x-button',{attrs:{"type":"brand"},nativeOn:{"click":function($event){return _vm.toPay($event)}}},[_vm._v("去缴费")]):_vm._e()],1)]],2)}
var pay_staticRenderFns = []
var pay_esExports = { render: pay_render, staticRenderFns: pay_staticRenderFns }
/* harmony default export */ var views_items_pay = (pay_esExports);
// CONCATENATED MODULE: ./src/yingxin/tskjxy/views/items/pay.vue
var pay_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var pay___vue_template_functional__ = false
/* styles */
var pay___vue_styles__ = null
/* scopeId */
var pay___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var pay___vue_module_identifier__ = null
var pay_Component = pay_normalizeComponent(
  items_pay,
  views_items_pay,
  pay___vue_template_functional__,
  pay___vue_styles__,
  pay___vue_scopeId__,
  pay___vue_module_identifier__
)

/* harmony default export */ var tskjxy_views_items_pay = (pay_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/yingxin/tskjxy/views/items/pay/pendingBill.vue









/* harmony default export */ var pendingBill = ({
  name: 'pendingBill',
  props: [],
  components: {
    XHeader: vux_src_components_x_header,
    XButton: vux_src_components_x_button,
    CheckIcon: vux_src_components_check_icon,
    'scroller': vuescroll_default.a
  },
  data: function data() {
    return {
      title: this.$route.meta.title,
      ops: {
        scrollPanel: {
          scrollingX: false
        },
        bar: {
          background: 'rgba(0, 107, 178, 0.3)',
          size: '3px',
          opacity: 0
        }
      },
      buttons: {
        type: 'brand',
        disabled: true,
        value: 0
      },
      pendingList: [],
      allCheck: false,
      checkArray: [],
      total: 0
    };
  },

  computed: extends_default()({}, Object(vuex_esm["c" /* mapState */])({
    studentSno: function studentSno(state) {
      return state.userInfo.sno;
    }
  })),
  created: function created() {},
  mounted: function mounted() {
    var _this = this;

    this.getBillList().then(function () {
      _this.getCheckArr();
    });
  },
  updated: function updated() {},
  destroyed: function destroyed() {},

  watch: {},
  methods: {
    back: function back() {
      var _this2 = this;

      setTimeout(function () {
        _this2.$router.back(-1);
      }, 300);
    },
    save: function save() {
      this.back();
    },
    getCheckArr: function getCheckArr() {
      var _this3 = this;

      this.pendingList.forEach(function (element) {
        _this3.checkArray.push(false);
      });
    },
    selectAll: function selectAll($event) {
      var _this4 = this;

      var flag = this.allCheck;
      var checkArray2 = [];
      var num = 0;
      if (flag) {
        this.checkArray.forEach(function (element, index) {
          element = flag;
          checkArray2.push(element);
          num += _this4.pendingList[index].owe;
        });
        this.buttons = {
          type: 'brand',
          disabled: false,
          value: this.pendingList.length
        };
      } else {
        this.checkArray.forEach(function (element) {
          element = flag;
          checkArray2.push(element);
          num = 0;
        });
        this.buttons = {
          type: 'brand',
          disabled: true,
          value: 0
        };
      }
      this.checkArray = checkArray2;
      this.total = num.toFixed(2);
    },
    selected: function selected(index) {
      var _this5 = this;

      var trueArr = [];
      var falseArr = [];
      var num = 0;
      this.checkArray.forEach(function (element, index) {
        if (element) {
          trueArr.push(element);
          num += _this5.pendingList[index].owe;
        } else {
          falseArr.push(element);
        }
      });
      this.total = num.toFixed(2);
      this.buttons = {
        type: 'brand',
        disabled: false,
        value: trueArr.length
      };
      if (this.checkArray[index]) {
        if (trueArr.length === this.pendingList.length) {
          this.allCheck = true;
        }
      } else {
        this.allCheck = false;
        if (falseArr.length === this.pendingList.length) {
          this.buttons = {
            type: '',
            disabled: true,
            value: trueArr.length
          };
        }
      }
    },
    getBillList: function getBillList() {
      var _this6 = this;

      var params = {
        studentSno: this.studentSno
      };
      return new promise_default.a(function (resolve, reject) {
        _this6.$api.get('/charge', params, function (r) {
          _this6.$vux.loading.hide();
          var data = r.data;

          _this6.pendingList = data.filter(function (item) {
            return item.owe > 0;
          });
          resolve();
        }, function (err) {
          console.log('charge' + err);
          _this6.$vux.toast.text(err.message, 'top');
        });
      });
    },
    toPay: function toPay() {
      this.$vux.toast.text('去第三方支付平台支付', 'middle');
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/yingxin/tskjxy/views/items/pay/pendingBill.vue









/* harmony default export */ var pay_pendingBill = ({
  name: 'pendingBill',
  props: [],
  components: {
    XHeader: vux_src_components_x_header,
    XButton: vux_src_components_x_button,
    CheckIcon: vux_src_components_check_icon,
    'scroller': vuescroll_default.a
  },
  data: function data() {
    return {
      title: this.$route.meta.title,
      ops: {
        scrollPanel: {
          scrollingX: false
        },
        bar: {
          background: 'rgba(0, 107, 178, 0.3)',
          size: '3px',
          opacity: 0
        }
      },
      buttons: {
        type: 'brand',
        disabled: true,
        value: 0
      },
      pendingList: [],
      allCheck: false,
      checkArray: [],
      total: 0
    };
  },

  computed: extends_default()({}, Object(vuex_esm["c" /* mapState */])({
    studentSno: function studentSno(state) {
      return state.userInfo.sno;
    }
  })),
  created: function created() {},
  mounted: function mounted() {
    var _this = this;

    this.getBillList().then(function () {
      _this.getCheckArr();
    });
  },
  updated: function updated() {},
  destroyed: function destroyed() {},

  watch: {},
  methods: {
    back: function back() {
      var _this2 = this;

      setTimeout(function () {
        _this2.$router.back(-1);
      }, 300);
    },
    save: function save() {
      this.back();
    },
    getCheckArr: function getCheckArr() {
      var _this3 = this;

      this.pendingList.forEach(function (element) {
        _this3.checkArray.push(false);
      });
    },
    selectAll: function selectAll($event) {
      var _this4 = this;

      var flag = this.allCheck;
      var checkArray2 = [];
      var num = 0;
      if (flag) {
        this.checkArray.forEach(function (element, index) {
          element = flag;
          checkArray2.push(element);
          num += _this4.pendingList[index].owe;
        });
        this.buttons = {
          type: 'brand',
          disabled: false,
          value: this.pendingList.length
        };
      } else {
        this.checkArray.forEach(function (element) {
          element = flag;
          checkArray2.push(element);
          num = 0;
        });
        this.buttons = {
          type: 'brand',
          disabled: true,
          value: 0
        };
      }
      this.checkArray = checkArray2;
      this.total = num.toFixed(2);
    },
    selected: function selected(index) {
      var _this5 = this;

      var trueArr = [];
      var falseArr = [];
      var num = 0;
      this.checkArray.forEach(function (element, index) {
        if (element) {
          trueArr.push(element);
          num += _this5.pendingList[index].owe;
        } else {
          falseArr.push(element);
        }
      });
      this.total = num.toFixed(2);
      this.buttons = {
        type: 'brand',
        disabled: false,
        value: trueArr.length
      };
      if (this.checkArray[index]) {
        if (trueArr.length === this.pendingList.length) {
          this.allCheck = true;
        }
      } else {
        this.allCheck = false;
        if (falseArr.length === this.pendingList.length) {
          this.buttons = {
            type: '',
            disabled: true,
            value: trueArr.length
          };
        }
      }
    },
    getBillList: function getBillList() {
      var _this6 = this;

      var params = {
        studentSno: this.studentSno
      };
      return new promise_default.a(function (resolve, reject) {
        _this6.$api.get('/charge', params, function (r) {
          _this6.$vux.loading.hide();
          var data = r.data;

          _this6.pendingList = data.filter(function (item) {
            return item.owe > 0;
          });
          resolve();
        }, function (err) {
          console.log('charge' + err);
          _this6.$vux.toast.text(err.message, 'top');
        });
      });
    },
    toPay: function toPay() {
      this.$vux.toast.text('去第三方支付平台支付', 'middle');
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ed1e2556","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/yingxin/tskjxy/views/items/pay/pendingBill.vue
var pendingBill_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sub-page"},[_c('x-header',{staticClass:"header bg-white border-bottom"},[_c('em',{staticClass:"icon icon-arrow-left",attrs:{"slot":"overwrite-left","size":""},on:{"click":_vm.back},slot:"overwrite-left"}),_vm._v(_vm._s(_vm.title))]),_c('section',{staticClass:"section"},[_c('div',{staticClass:"scroller-wrapper-bottom",staticStyle:{"bottom":"3.75rem"}},[_c('scroller',{attrs:{"ops":_vm.ops}},[(_vm.pendingList !='')?_c('div',{staticClass:"container bill-list"},[_c('h4',{staticStyle:{"line-height":"3rem"}},[_vm._v("您共 "+_vm._s(_vm.pendingList.length)+" 个待缴账单")]),_vm._l((_vm.pendingList),function(item,index){return _c('div',{key:index,staticClass:"card"},[_c('div',{staticClass:"card-header"},[_c('div',{staticClass:"checkbox",on:{"click":function($event){return _vm.selected(index)}}},[_c('check-icon',{attrs:{"value":_vm.checkArray[index]},on:{"update:value":function($event){return _vm.$set(_vm.checkArray, index, $event)}}}),_c('span',{staticClass:"label"},[_vm._v(_vm._s(item.chargeItemBean.name))])],1)]),_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"price text-danger"},[_vm._v("￥"+_vm._s(item.owe.toFixed(2)))])]),_c('div',{staticClass:"card-footer"},[_c('p',{staticClass:"remark"},[_vm._v("财务处 "+_vm._s(item.year)+"年度")])])])})],2):_vm._e()])],1)]),_c('div',{staticClass:"footbar fixed bottom"},[_c('ul',{staticClass:"total-box"},[_c('li',{staticClass:"float-left"},[_c('div',{staticClass:"checkbox",on:{"click":function($event){return _vm.selectAll()}}},[_c('check-icon',{attrs:{"value":_vm.allCheck},on:{"update:value":function($event){_vm.allCheck=$event}}},[_vm._v("全选")])],1)]),_c('li',{staticClass:"float-right"},[_c('x-button',{attrs:{"type":_vm.buttons.type,"disabled":_vm.buttons.disabled},nativeOn:{"click":function($event){return _vm.toPay($event)}}},[_vm._v("立即缴费("+_vm._s(_vm.buttons.value)+")")])],1),_c('li',{staticClass:"float-right total-num"},[_vm._v("合计:"),_c('strong',{staticClass:"text-danger"},[_vm._v("￥"+_vm._s(_vm.total))])])])])],1)}
var pendingBill_staticRenderFns = []
var pendingBill_esExports = { render: pendingBill_render, staticRenderFns: pendingBill_staticRenderFns }
/* harmony default export */ var items_pay_pendingBill = (pendingBill_esExports);
// CONCATENATED MODULE: ./src/yingxin/tskjxy/views/items/pay/pendingBill.vue
function pendingBill_injectStyle (ssrContext) {
  __webpack_require__("ze5M")
}
var pendingBill_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var pendingBill___vue_template_functional__ = false
/* styles */
var pendingBill___vue_styles__ = pendingBill_injectStyle
/* scopeId */
var pendingBill___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var pendingBill___vue_module_identifier__ = null
var pendingBill_Component = pendingBill_normalizeComponent(
  pay_pendingBill,
  items_pay_pendingBill,
  pendingBill___vue_template_functional__,
  pendingBill___vue_styles__,
  pendingBill___vue_scopeId__,
  pendingBill___vue_module_identifier__
)

/* harmony default export */ var views_items_pay_pendingBill = (pendingBill_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/yingxin/tskjxy/views/items/picture.vue



/* harmony default export */ var picture = ({
  name: 'info',
  props: [],
  components: {
    XHeader: vux_src_components_x_header
  },
  data: function data() {
    return {};
  },

  computed: {
    title: function title() {
      return this.$route.params.title;
    }
  },
  created: function created() {},
  mounted: function mounted() {},
  updated: function updated() {},
  destroyed: function destroyed() {},

  watch: {},
  methods: {
    back: function back() {
      var _this = this;

      setTimeout(function () {
        _this.$router.back(-1);
      }, 300);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/yingxin/tskjxy/views/items/picture.vue



/* harmony default export */ var items_picture = ({
  name: 'info',
  props: [],
  components: {
    XHeader: vux_src_components_x_header
  },
  data: function data() {
    return {};
  },

  computed: {
    title: function title() {
      return this.$route.params.title;
    }
  },
  created: function created() {},
  mounted: function mounted() {},
  updated: function updated() {},
  destroyed: function destroyed() {},

  watch: {},
  methods: {
    back: function back() {
      var _this = this;

      setTimeout(function () {
        _this.$router.back(-1);
      }, 300);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-765f65c1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/yingxin/tskjxy/views/items/picture.vue
var picture_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('x-header',{staticClass:"header bg-white box-shadow"},[_c('em',{staticClass:"icon icon-arrow-left",attrs:{"slot":"overwrite-left","size":""},on:{"click":_vm.back},slot:"overwrite-left"}),_vm._v(_vm._s(_vm.title)),_c('span',{staticClass:"text-brand",attrs:{"slot":"right","size":""},slot:"right"},[_vm._v("完成")])]),_c('transition',{attrs:{"name":"slide","enter-active-class":"animated fastest slideInUp","leave-active-class":"animated fastest slideOutDown"}},[_c('router-view')],1)],1)}
var picture_staticRenderFns = []
var picture_esExports = { render: picture_render, staticRenderFns: picture_staticRenderFns }
/* harmony default export */ var views_items_picture = (picture_esExports);
// CONCATENATED MODULE: ./src/yingxin/tskjxy/views/items/picture.vue
function picture_injectStyle (ssrContext) {
  __webpack_require__("b+EJ")
}
var picture_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var picture___vue_template_functional__ = false
/* styles */
var picture___vue_styles__ = picture_injectStyle
/* scopeId */
var picture___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var picture___vue_module_identifier__ = null
var picture_Component = picture_normalizeComponent(
  items_picture,
  views_items_picture,
  picture___vue_template_functional__,
  picture___vue_styles__,
  picture___vue_scopeId__,
  picture___vue_module_identifier__
)

/* harmony default export */ var tskjxy_views_items_picture = (picture_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/x-table/index.vue
//
//
//
//
//
//

/* harmony default export */ var x_table = ({
  name: 'x-table',
  props: {
    fullBordered: Boolean,
    cellBordered: {
      type: Boolean,
      default: true
    },
    contentBordered: {
      type: Boolean,
      default: true
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/x-table/index.vue
//
//
//
//
//
//

/* harmony default export */ var components_x_table = ({
  name: 'x-table',
  props: {
    fullBordered: Boolean,
    cellBordered: {
      type: Boolean,
      default: true
    },
    contentBordered: {
      type: Boolean,
      default: true
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-53380570","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/x-table/index.vue
var x_table_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('table',{staticClass:"vux-table",class:{'vux-table-bordered': _vm.fullBordered, 'vux-table-no-cell-bordered': !_vm.cellBordered, 'vux-table-no-content-bordered': !_vm.contentBordered}},[_vm._t("default")],2)}
var x_table_staticRenderFns = []
var x_table_esExports = { render: x_table_render, staticRenderFns: x_table_staticRenderFns }
/* harmony default export */ var src_components_x_table = (x_table_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/x-table/index.vue
function x_table_injectStyle (ssrContext) {
  __webpack_require__("GINT")
}
var x_table_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var x_table___vue_template_functional__ = false
/* styles */
var x_table___vue_styles__ = x_table_injectStyle
/* scopeId */
var x_table___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var x_table___vue_module_identifier__ = null
var x_table_Component = x_table_normalizeComponent(
  components_x_table,
  src_components_x_table,
  x_table___vue_template_functional__,
  x_table___vue_styles__,
  x_table___vue_scopeId__,
  x_table___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_x_table = (x_table_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/yingxin/tskjxy/views/items/clothes.vue














/* harmony default export */ var clothes = ({
  name: 'clothes',
  props: [],
  directives: {
    TransferDom: transfer_dom["a" /* default */]
  },
  components: {
    XHeader: vux_src_components_x_header,
    Grid: src_components_grid_grid,
    GridItem: src_components_grid_grid_item,
    XButton: vux_src_components_x_button,
    Popup: node_modules_vux_src_components_popup,
    Checker: src_components_checker_checker,
    CheckerItem: src_components_checker_checker_item,
    XTable: vux_src_components_x_table
  },
  data: function data() {
    return {
      id: '',
      isDisabled: true,
      clothes: [{
        name: '军需服装—上衣',
        value: 'coat',
        referenceSize: '',
        selectSize: JSON.parse(sessionStorage.getItem('clotheSize')) ? JSON.parse(sessionStorage.getItem('clotheSize')).clothes : '请选择',
        icon: 'coat',
        pictureUrl: __webpack_require__("KR60"),
        defaultPicture: 'this.src="' + __webpack_require__("pE22") + '"'
      }, {
        name: '军需服装—迷彩裤',
        value: 'pants',
        referenceSize: '',
        selectSize: JSON.parse(sessionStorage.getItem('clotheSize')) ? JSON.parse(sessionStorage.getItem('clotheSize')).clothes : '请选择',
        icon: 'pants',
        pictureUrl: __webpack_require__("KR60"),
        defaultPicture: 'this.src="' + __webpack_require__("KR60") + '"'
      }, {
        name: '军需服装—迷彩帽',
        value: 'hat',
        referenceSize: '',
        selectSize: JSON.parse(sessionStorage.getItem('clotheSize')) ? JSON.parse(sessionStorage.getItem('clotheSize')).hat : '请选择',
        icon: 'hat',
        pictureUrl: __webpack_require__("KR60"),
        defaultPicture: 'this.src="' + __webpack_require__("jk1Q") + '"'
      }, {
        name: '军需服装—迷彩鞋',
        value: 'shoes',
        referenceSize: '',
        selectSize: JSON.parse(sessionStorage.getItem('clotheSize')) ? JSON.parse(sessionStorage.getItem('clotheSize')).shoes : '请选择',
        icon: 'shoes',
        pictureUrl: __webpack_require__("KR60"),
        defaultPicture: 'this.src="' + __webpack_require__("ptqo") + '"'
      }],
      notice: {
        isShow: false,
        msg: '(根据身高体重推荐)'
      },
      sizeShow: false,
      popUp: {
        title: '',
        icon: ''
      },
      checkeValue: '',
      sizes: {
        clothes: [],
        maleClothes: [],
        femaleClothes: [],
        hat: [],
        shoes: ['34', '35', '36', '37', '38', '39', '40', '41', '42', '43', '44', '45', '46']
      },
      referenceSize: {},
      selectSize: {
        clothes: '',
        hat: '',
        shoes: ''
      }
    };
  },

  computed: extends_default()({}, Object(vuex_esm["c" /* mapState */])({
    token: function token(state) {
      return state.token;
    },
    userInfo: function userInfo(state) {
      return state.userInfo;
    },
    flowInfo: function flowInfo(state) {
      return state.flowInfo;
    },
    title: function title(state) {
      return state.currentProcedureInfo.name;
    },
    currentProcedureInfo: function currentProcedureInfo(state) {
      return state.currentProcedureInfo;
    },
    parentRouter: function parentRouter(state) {
      return state.currentProcedureInfo.parentRouter;
    }
  })),
  created: function created() {
    this.getClothesConfig();
  },
  mounted: function mounted() {
    if (JSON.parse(sessionStorage.getItem('clotheSize'))) {
      this.selectSize = JSON.parse(sessionStorage.getItem('clotheSize'));
    }

    this.getReferenceSize();

    this.getLastData();
  },
  updated: function updated() {},
  destroyed: function destroyed() {},

  watch: {},
  methods: {
    back: function back() {
      var _this = this;

      setTimeout(function () {

        _this.$router.push({
          name: _this.parentRouter
        });
      }, 300);
    },
    submit: function submit() {
      var _this2 = this;

      this.$vux.loading.show();

      var params = {
        id: this.id ? this.id : null,
        studentId: this.userInfo.id,
        flowId: this.flowInfo.flowId,
        flowProcedureId: this.currentProcedureInfo.flowProcedureId,
        procedureId: this.currentProcedureInfo.procedureId,
        sizeClothing: this.clothes[0].selectSize,
        sizeHat: this.clothes[2].selectSize,
        sizeShoe: this.clothes[3].selectSize
      };
      this.$api.post('/clothingSize', params, function (r) {
        _this2.$vux.loading.hide();
        setTimeout(function () {
          _this2.$router.push({ name: 'itemResult' });
        }, 300);
      }, function (err) {
        _this2.$vux.toast.text(err.message, 'middle');
      });
    },
    save: function save(obj) {
      var _this3 = this;

      if (obj === 'coat' || obj === 'pants') {
        this.clothes.forEach(function (element) {
          if (element.value === 'coat' || element.value === 'pants') {
            element.selectSize = _this3.selectSize.clothes;
          }
        });
      } else if (obj === 'hat') {
        this.clothes.forEach(function (element) {
          if (element.value === 'hat') {
            element.selectSize = _this3.selectSize.hat;
          }
        });
      } else if (obj === 'shoes') {
        this.clothes.forEach(function (element) {
          if (element.value === 'shoes') {
            element.selectSize = _this3.selectSize.shoes;
          }
        });
      }
      sessionStorage.setItem('clotheSize', stringify_default()(this.selectSize));
      if (this.selectSize.clothes === '' || this.selectSize.hat === '' || this.selectSize.shoes === '') {
        this.isDisabled = true;
      } else {
        this.isDisabled = false;
      }
      this.sizeShow = false;
      this.notice.isShow = false;
    },
    toClotheSize: function toClotheSize() {
      this.$router.push({ name: 'clotheSize' });
    },
    popupSize: function popupSize(obj) {
      if (this.sizeShow) {
        this.sizeShow = false;
      } else {
        this.popUp.title = obj.name;
        this.popUp.icon = obj.icon;
        this.popUp.value = obj.value;
        this.popUp.pictureUrl = obj.pictureUrl;
        this.popUp.defaultPicture = obj.defaultPicture;
        this.sizeShow = true;
      }
    },
    getReferenceSize: function getReferenceSize() {
      var data = JSON.parse(sessionStorage.getItem('referenceSize'));

      if (data) {
        this.clothes.forEach(function (element) {
          if (element.value === 'coat' || element.value === 'pants') {
            element.referenceSize = data.coat;
          } else if (element.value === 'hat') {
            element.referenceSize = data.hat;
          } else if (element.value === 'shoes') {
            element.referenceSize = data.shoes;
          }
        });
        this.referenceSize = data;
        this.selectSize = {
          clothes: data.coat,
          hat: data.hat,
          shoes: data.shoes
        };
        this.clothes[0].selectSize = data.coat;
        this.clothes[1].selectSize = data.coat;
        this.clothes[2].selectSize = data.hat;
        this.clothes[3].selectSize = data.shoes;
        this.isDisabled = false;
        this.notice.isShow = true;
      }
    },
    getClothesConfig: function getClothesConfig() {
      var _this4 = this;

      this.$vux.loading.show();
      var params = {
        flowprocedureId: this.currentProcedureInfo.flowProcedureId
      };
      this.$api.get('/configClothingSize', params, function (r) {
        _this4.$vux.loading.hide();
        var data = r.data;
        /* 图片 */
        var picUrlArr = [];
        /* 服装尺码表 */

        /* 帽子尺码表 */

        /* 配送方式, (保留) */

        data.forEach(function (element) {
          if (element.kind === 1) {
            /* 图片 */
            picUrlArr.push(element.clothesServiceFileBean.url);
            picUrlArr.push(element.trousersServiceFileBean.url);
            picUrlArr.push(element.hatServiceFileBean.url);
            picUrlArr.push(element.shoesServiceFileBean.url);
          } else if (element.kind === 2) {
            /* 服装尺码表 */
            _this4.sizes.clothes = element.sizeValueList;
          } else if (element.kind === 3) {
            /* 服装尺码表  男 */
            _this4.sizes.maleClothes = element.sizeValueList;
          } else if (element.kind === 4) {
            /* 服装尺码表  女 */
            _this4.sizes.femaleClothes = element.sizeValueList;
          } else if (element.kind === 5) {
            _this4.sizes.hat = element.hatSizeValueList;
          }
        });
        if (_this4.userInfo.sex === 1) {
          _this4.sizes.clothes = _this4.sizes.maleClothes;
        } else if (_this4.userInfo.sex === 2) {
          _this4.sizes.clothes = _this4.sizes.femaleClothes;
        }

        _this4.clothes.forEach(function (element, i) {
          element.pictureUrl = picUrlArr[i];
        });

        sessionStorage.setItem('sizeTable', stringify_default()(_this4.sizes));
      }, function (err) {
        _this4.$vux.toast.text(err.message, 'middle');
      });
    },
    getLastData: function getLastData() {
      var _this5 = this;

      this.$vux.loading.show();
      var params = {
        'studentId': this.userInfo.id,
        'flowId': this.flowInfo.flowId,
        'procedureId': this.currentProcedureInfo.procedureId
      };

      this.$api.get('/clothingSize', params, function (r) {
        _this5.$vux.loading.hide();
        var data = r.data;

        if (data.length > 0) {
          _this5.id = data[0].id;
          _this5.selectSize = {
            clothes: data[0].sizeClothing,
            hat: data[0].sizeHat,
            shoes: data[0].sizeShoe
          };
          _this5.notice.isShow = false;
          _this5.isDisabled = false;
          _this5.clothes[0].selectSize = data[0].sizeClothing;
          _this5.clothes[1].selectSize = data[0].sizeClothing;
          _this5.clothes[2].selectSize = data[0].sizeHat;
          _this5.clothes[3].selectSize = data[0].sizeShoe;
        }
      }, function (err) {
        _this5.$vux.toast.text(err.message, 'top');
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/yingxin/tskjxy/views/items/clothes.vue














/* harmony default export */ var items_clothes = ({
  name: 'clothes',
  props: [],
  directives: {
    TransferDom: transfer_dom["a" /* default */]
  },
  components: {
    XHeader: vux_src_components_x_header,
    Grid: src_components_grid_grid,
    GridItem: src_components_grid_grid_item,
    XButton: vux_src_components_x_button,
    Popup: node_modules_vux_src_components_popup,
    Checker: src_components_checker_checker,
    CheckerItem: src_components_checker_checker_item,
    XTable: vux_src_components_x_table
  },
  data: function data() {
    return {
      id: '',
      isDisabled: true,
      clothes: [{
        name: '军需服装—上衣',
        value: 'coat',
        referenceSize: '',
        selectSize: JSON.parse(sessionStorage.getItem('clotheSize')) ? JSON.parse(sessionStorage.getItem('clotheSize')).clothes : '请选择',
        icon: 'coat',
        pictureUrl: __webpack_require__("KR60"),
        defaultPicture: 'this.src="' + __webpack_require__("pE22") + '"'
      }, {
        name: '军需服装—迷彩裤',
        value: 'pants',
        referenceSize: '',
        selectSize: JSON.parse(sessionStorage.getItem('clotheSize')) ? JSON.parse(sessionStorage.getItem('clotheSize')).clothes : '请选择',
        icon: 'pants',
        pictureUrl: __webpack_require__("KR60"),
        defaultPicture: 'this.src="' + __webpack_require__("KR60") + '"'
      }, {
        name: '军需服装—迷彩帽',
        value: 'hat',
        referenceSize: '',
        selectSize: JSON.parse(sessionStorage.getItem('clotheSize')) ? JSON.parse(sessionStorage.getItem('clotheSize')).hat : '请选择',
        icon: 'hat',
        pictureUrl: __webpack_require__("KR60"),
        defaultPicture: 'this.src="' + __webpack_require__("jk1Q") + '"'
      }, {
        name: '军需服装—迷彩鞋',
        value: 'shoes',
        referenceSize: '',
        selectSize: JSON.parse(sessionStorage.getItem('clotheSize')) ? JSON.parse(sessionStorage.getItem('clotheSize')).shoes : '请选择',
        icon: 'shoes',
        pictureUrl: __webpack_require__("KR60"),
        defaultPicture: 'this.src="' + __webpack_require__("ptqo") + '"'
      }],
      notice: {
        isShow: false,
        msg: '(根据身高体重推荐)'
      },
      sizeShow: false,
      popUp: {
        title: '',
        icon: ''
      },
      checkeValue: '',
      sizes: {
        clothes: [],
        maleClothes: [],
        femaleClothes: [],
        hat: [],
        shoes: ['34', '35', '36', '37', '38', '39', '40', '41', '42', '43', '44', '45', '46']
      },
      referenceSize: {},
      selectSize: {
        clothes: '',
        hat: '',
        shoes: ''
      }
    };
  },

  computed: extends_default()({}, Object(vuex_esm["c" /* mapState */])({
    token: function token(state) {
      return state.token;
    },
    userInfo: function userInfo(state) {
      return state.userInfo;
    },
    flowInfo: function flowInfo(state) {
      return state.flowInfo;
    },
    title: function title(state) {
      return state.currentProcedureInfo.name;
    },
    currentProcedureInfo: function currentProcedureInfo(state) {
      return state.currentProcedureInfo;
    },
    parentRouter: function parentRouter(state) {
      return state.currentProcedureInfo.parentRouter;
    }
  })),
  created: function created() {
    this.getClothesConfig();
  },
  mounted: function mounted() {
    if (JSON.parse(sessionStorage.getItem('clotheSize'))) {
      this.selectSize = JSON.parse(sessionStorage.getItem('clotheSize'));
    }

    this.getReferenceSize();

    this.getLastData();
  },
  updated: function updated() {},
  destroyed: function destroyed() {},

  watch: {},
  methods: {
    back: function back() {
      var _this = this;

      setTimeout(function () {

        _this.$router.push({
          name: _this.parentRouter
        });
      }, 300);
    },
    submit: function submit() {
      var _this2 = this;

      this.$vux.loading.show();

      var params = {
        id: this.id ? this.id : null,
        studentId: this.userInfo.id,
        flowId: this.flowInfo.flowId,
        flowProcedureId: this.currentProcedureInfo.flowProcedureId,
        procedureId: this.currentProcedureInfo.procedureId,
        sizeClothing: this.clothes[0].selectSize,
        sizeHat: this.clothes[2].selectSize,
        sizeShoe: this.clothes[3].selectSize
      };
      this.$api.post('/clothingSize', params, function (r) {
        _this2.$vux.loading.hide();
        setTimeout(function () {
          _this2.$router.push({ name: 'itemResult' });
        }, 300);
      }, function (err) {
        _this2.$vux.toast.text(err.message, 'middle');
      });
    },
    save: function save(obj) {
      var _this3 = this;

      if (obj === 'coat' || obj === 'pants') {
        this.clothes.forEach(function (element) {
          if (element.value === 'coat' || element.value === 'pants') {
            element.selectSize = _this3.selectSize.clothes;
          }
        });
      } else if (obj === 'hat') {
        this.clothes.forEach(function (element) {
          if (element.value === 'hat') {
            element.selectSize = _this3.selectSize.hat;
          }
        });
      } else if (obj === 'shoes') {
        this.clothes.forEach(function (element) {
          if (element.value === 'shoes') {
            element.selectSize = _this3.selectSize.shoes;
          }
        });
      }
      sessionStorage.setItem('clotheSize', stringify_default()(this.selectSize));
      if (this.selectSize.clothes === '' || this.selectSize.hat === '' || this.selectSize.shoes === '') {
        this.isDisabled = true;
      } else {
        this.isDisabled = false;
      }
      this.sizeShow = false;
      this.notice.isShow = false;
    },
    toClotheSize: function toClotheSize() {
      this.$router.push({ name: 'clotheSize' });
    },
    popupSize: function popupSize(obj) {
      if (this.sizeShow) {
        this.sizeShow = false;
      } else {
        this.popUp.title = obj.name;
        this.popUp.icon = obj.icon;
        this.popUp.value = obj.value;
        this.popUp.pictureUrl = obj.pictureUrl;
        this.popUp.defaultPicture = obj.defaultPicture;
        this.sizeShow = true;
      }
    },
    getReferenceSize: function getReferenceSize() {
      var data = JSON.parse(sessionStorage.getItem('referenceSize'));

      if (data) {
        this.clothes.forEach(function (element) {
          if (element.value === 'coat' || element.value === 'pants') {
            element.referenceSize = data.coat;
          } else if (element.value === 'hat') {
            element.referenceSize = data.hat;
          } else if (element.value === 'shoes') {
            element.referenceSize = data.shoes;
          }
        });
        this.referenceSize = data;
        this.selectSize = {
          clothes: data.coat,
          hat: data.hat,
          shoes: data.shoes
        };
        this.clothes[0].selectSize = data.coat;
        this.clothes[1].selectSize = data.coat;
        this.clothes[2].selectSize = data.hat;
        this.clothes[3].selectSize = data.shoes;
        this.isDisabled = false;
        this.notice.isShow = true;
      }
    },
    getClothesConfig: function getClothesConfig() {
      var _this4 = this;

      this.$vux.loading.show();
      var params = {
        flowprocedureId: this.currentProcedureInfo.flowProcedureId
      };
      this.$api.get('/configClothingSize', params, function (r) {
        _this4.$vux.loading.hide();
        var data = r.data;
        /* 图片 */
        var picUrlArr = [];
        /* 服装尺码表 */

        /* 帽子尺码表 */

        /* 配送方式, (保留) */

        data.forEach(function (element) {
          if (element.kind === 1) {
            /* 图片 */
            picUrlArr.push(element.clothesServiceFileBean.url);
            picUrlArr.push(element.trousersServiceFileBean.url);
            picUrlArr.push(element.hatServiceFileBean.url);
            picUrlArr.push(element.shoesServiceFileBean.url);
          } else if (element.kind === 2) {
            /* 服装尺码表 */
            _this4.sizes.clothes = element.sizeValueList;
          } else if (element.kind === 3) {
            /* 服装尺码表  男 */
            _this4.sizes.maleClothes = element.sizeValueList;
          } else if (element.kind === 4) {
            /* 服装尺码表  女 */
            _this4.sizes.femaleClothes = element.sizeValueList;
          } else if (element.kind === 5) {
            _this4.sizes.hat = element.hatSizeValueList;
          }
        });
        if (_this4.userInfo.sex === 1) {
          _this4.sizes.clothes = _this4.sizes.maleClothes;
        } else if (_this4.userInfo.sex === 2) {
          _this4.sizes.clothes = _this4.sizes.femaleClothes;
        }

        _this4.clothes.forEach(function (element, i) {
          element.pictureUrl = picUrlArr[i];
        });

        sessionStorage.setItem('sizeTable', stringify_default()(_this4.sizes));
      }, function (err) {
        _this4.$vux.toast.text(err.message, 'middle');
      });
    },
    getLastData: function getLastData() {
      var _this5 = this;

      this.$vux.loading.show();
      var params = {
        'studentId': this.userInfo.id,
        'flowId': this.flowInfo.flowId,
        'procedureId': this.currentProcedureInfo.procedureId
      };

      this.$api.get('/clothingSize', params, function (r) {
        _this5.$vux.loading.hide();
        var data = r.data;

        if (data.length > 0) {
          _this5.id = data[0].id;
          _this5.selectSize = {
            clothes: data[0].sizeClothing,
            hat: data[0].sizeHat,
            shoes: data[0].sizeShoe
          };
          _this5.notice.isShow = false;
          _this5.isDisabled = false;
          _this5.clothes[0].selectSize = data[0].sizeClothing;
          _this5.clothes[1].selectSize = data[0].sizeClothing;
          _this5.clothes[2].selectSize = data[0].sizeHat;
          _this5.clothes[3].selectSize = data[0].sizeShoe;
        }
      }, function (err) {
        _this5.$vux.toast.text(err.message, 'top');
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ce3180de","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/yingxin/tskjxy/views/items/clothes.vue
var clothes_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('x-header',{staticClass:"header bg-white box-shadow"},[_c('em',{staticClass:"icon icon-arrow-left",attrs:{"slot":"overwrite-left","size":""},on:{"click":_vm.back},slot:"overwrite-left"}),_vm._v(_vm._s(_vm.title)),_c('span',{staticClass:"text-brand",attrs:{"slot":"right","size":""},on:{"click":_vm.toClotheSize},slot:"right"},[_vm._v("尺码设置")])]),_c('section',{staticClass:"section"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"panel clothes-panel"},[_vm._m(0),_c('div',{staticClass:"panel-body"},[_c('grid',{attrs:{"show-lr-borders":false,"show-vertical-dividers":false,"cols":2}},_vm._l((_vm.clothes),function(item,index){return _c('grid-item',{key:index},[_c('ul',{staticClass:"bg-white",on:{"click":function($event){return _vm.popupSize(item)}}},[_c('li',{staticClass:"picture"},[_c('img',{attrs:{"src":item.pictureUrl,"onerror":item.defaultPicture}})]),_c('li',{staticStyle:{"padding":".5rem .5rem"}},[_c('h4',{staticClass:"name"},[_vm._v(_vm._s(item.name))]),_c('p',{staticClass:"size"},[(item.referenceSize == '' && item.selectSize == '请选择')?_c('span',[_vm._v(_vm._s(item.selectSize))]):(item.referenceSize != '' && item.selectSize == '请选择')?_c('strong',[_vm._v(_vm._s(item.referenceSize))]):(item.selectSize != '请选择')?_c('strong',[_vm._v(_vm._s(item.selectSize))]):_vm._e(),(_vm.notice.isShow)?_c('span',[_vm._v(" "+_vm._s(_vm.notice.msg))]):_vm._e()])])])])}),1)],1)])])]),_c('div',{directives:[{name:"transfer-dom",rawName:"v-transfer-dom"}]},[_c('popup',{staticClass:"clothes-popup-content",attrs:{"height":"68vh","position":"bottom"},model:{value:(_vm.sizeShow),callback:function ($$v) {_vm.sizeShow=$$v},expression:"sizeShow"}},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"panel clothes-popUp"},[_c('div',{staticClass:"panel-header"},[_c('span',{staticClass:"pic-box"},[_c('img',{attrs:{"src":_vm.popUp.pictureUrl,"onerror":_vm.popUp.defaultPicture}})]),_c('h4',{staticClass:"title"},[_vm._v(_vm._s(_vm.popUp.title))])]),_c('div',{staticClass:"panel-body"},[_c('div',{staticClass:"size-select"},[_c('div',{staticClass:"title"},[_vm._v("尺码选择")]),_c('div',{staticClass:"size-checker"},[(_vm.popUp.value == 'pants' || _vm.popUp.value == 'coat')?_c('checker',{attrs:{"default-item-class":"sizeItem","selected-item-class":"sizeItem-selected"},model:{value:(_vm.selectSize.clothes),callback:function ($$v) {_vm.$set(_vm.selectSize, "clothes", $$v)},expression:"selectSize.clothes"}},_vm._l((_vm.sizes.clothes),function(item,index){return _c('checker-item',{key:index,attrs:{"value":item.size}},[_vm._v(_vm._s(item.size)),(item.size == _vm.referenceSize.coat)?_c('span',{staticClass:"reference"},[_vm._v("(推荐尺码)")]):_vm._e()])}),1):_vm._e(),(_vm.popUp.value == 'hat')?_c('checker',{attrs:{"default-item-class":"sizeItem","selected-item-class":"sizeItem-selected"},model:{value:(_vm.selectSize.hat),callback:function ($$v) {_vm.$set(_vm.selectSize, "hat", $$v)},expression:"selectSize.hat"}},_vm._l((_vm.sizes.hat),function(item,index){return _c('checker-item',{key:index,attrs:{"value":item.size}},[_vm._v(_vm._s(item.size)),(item.size == _vm.referenceSize.hat)?_c('span',{staticClass:"reference"},[_vm._v("(推荐尺码)")]):_vm._e()])}),1):_vm._e(),(_vm.popUp.value == 'shoes')?_c('checker',{attrs:{"default-item-class":"sizeItem","selected-item-class":"sizeItem-selected"},model:{value:(_vm.selectSize.shoes),callback:function ($$v) {_vm.$set(_vm.selectSize, "shoes", $$v)},expression:"selectSize.shoes"}},_vm._l((_vm.sizes.shoes),function(item,index){return _c('checker-item',{key:index,attrs:{"value":item}},[_vm._v(_vm._s(item)),(item == _vm.referenceSize.shoes)?_c('span',{staticClass:"reference"},[_vm._v("(推荐尺码)")]):_vm._e()])}),1):_vm._e()],1)]),(_vm.popUp.value == 'pants' || _vm.popUp.value == 'coat')?_c('div',{staticClass:"size-reference"},[_c('div',{staticClass:"title"},[_vm._v("尺码参考")]),_c('x-table',{staticStyle:{"background-color":"#fff"},attrs:{"full-bordered":""}},[_c('thead',[_c('tr',[_c('th',[_vm._v("尺码")]),_c('th',[_vm._v("最大身高(cm)")]),_c('th',[_vm._v("最小身高(cm)")]),_c('th',[_vm._v("最大体重(kg)")]),_c('th',[_vm._v("最小体重(kg)")])])]),_c('tbody',_vm._l((_vm.sizes.clothes),function(item,i){return _c('tr',{key:i},[_c('td',{domProps:{"textContent":_vm._s(item.size)}}),_c('td',{domProps:{"textContent":_vm._s(item.maxHeight)}}),_c('td',{domProps:{"textContent":_vm._s(item.minHeight)}}),_c('td',{domProps:{"textContent":_vm._s(item.maxWeight)}}),_c('td',{domProps:{"textContent":_vm._s(item.minWeight)}})])}),0)])],1):_vm._e(),(_vm.popUp.value == 'hat')?_c('div',{staticClass:"size-reference"},[_c('div',{staticClass:"title"},[_vm._v("尺码参考")]),(_vm.popUp.value == 'hat')?_c('x-table',{staticStyle:{"background-color":"#fff"},attrs:{"full-bordered":""}},[_c('thead',[_c('tr',[_c('th',[_vm._v("尺码")]),_c('th',[_vm._v("最大头围(cm)")]),_c('th',[_vm._v("最小头围(cm)")])])]),_c('tbody',_vm._l((_vm.sizes.hat),function(item,i){return _c('tr',{key:i},[_c('td',{domProps:{"textContent":_vm._s(item.size)}}),_c('td',{domProps:{"textContent":_vm._s(item.maxHead)}}),_c('td',{domProps:{"textContent":_vm._s(item.minHead)}})])}),0)]):_vm._e()],1):_vm._e()])]),_c('br')]),_c('div',{staticClass:"button-group",staticStyle:{"padding":"0 0.625rem"}},[(_vm.popUp.value == 'pants' || _vm.popUp.value == 'coat')?_c('x-button',{attrs:{"type":"brand","disabled":!_vm.selectSize.clothes},nativeOn:{"click":function($event){return _vm.save(_vm.popUp.value)}}},[_vm._v("确定")]):_vm._e(),(_vm.popUp.value == 'hat')?_c('x-button',{attrs:{"type":"brand","disabled":!_vm.selectSize.hat},nativeOn:{"click":function($event){return _vm.save(_vm.popUp.value)}}},[_vm._v("确定")]):_vm._e(),(_vm.popUp.value == 'shoes')?_c('x-button',{attrs:{"type":"brand","disabled":!_vm.selectSize.shoes},nativeOn:{"click":function($event){return _vm.save(_vm.popUp.value)}}},[_vm._v("确定")]):_vm._e()],1)])],1),_c('div',{staticClass:"button-group fixed bottom container"},[_c('x-button',{attrs:{"type":"brand","disabled":_vm.isDisabled},nativeOn:{"click":function($event){return _vm.submit($event)}}},[_vm._v("提交")])],1),_c('transition',{attrs:{"name":"slide","enter-active-class":"animated fastest slideInRight","leave-active-class":"animated fastest slideOutRight"}},[_c('router-view')],1)],1)}
var clothes_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"panel-header",staticStyle:{"margin-bottom":"-1.5rem"}},[_c('p',[_vm._v("* 可自行选择或在尺码设置里填写身高体重推荐")])])}]
var clothes_esExports = { render: clothes_render, staticRenderFns: clothes_staticRenderFns }
/* harmony default export */ var views_items_clothes = (clothes_esExports);
// CONCATENATED MODULE: ./src/yingxin/tskjxy/views/items/clothes.vue
var clothes_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var clothes___vue_template_functional__ = false
/* styles */
var clothes___vue_styles__ = null
/* scopeId */
var clothes___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var clothes___vue_module_identifier__ = null
var clothes_Component = clothes_normalizeComponent(
  items_clothes,
  views_items_clothes,
  clothes___vue_template_functional__,
  clothes___vue_styles__,
  clothes___vue_scopeId__,
  clothes___vue_module_identifier__
)

/* harmony default export */ var tskjxy_views_items_clothes = (clothes_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/yingxin/tskjxy/views/items/clothes/clotheSize.vue










/* harmony default export */ var clotheSize = ({
  name: 'clotheSize',
  props: [],
  components: {
    XHeader: vux_src_components_x_header,
    Group: vux_src_components_group,
    Cell: vux_src_components_cell,
    XInput: vux_src_components_x_input,
    'scroller': vuescroll_default.a
  },
  data: function data() {
    return {
      title: this.$route.meta.title,
      value: '',
      isCheck: 0,
      sex: [{
        name: 'girl',
        value: '女生'
      }, {
        name: 'boy',
        value: '男生'
      }],
      sizeInfo: {
        sex: '请选择',
        height: {
          name: '请选择',
          value: Number
        },
        weight: {
          name: '请选择',
          value: Number
        },
        head: {
          name: '请输入',
          value: ''
        }
      },
      rulerOps: {
        scrollPanel: {
          scrollingX: false,
          initialScrollY: 250
        },
        bar: {
          background: 'rgba(0, 107, 178, 1)',
          size: '3px',
          opacity: 0
        }
      },
      weighOps: {
        scrollPanel: {
          scrollingY: false,
          initialScrollX: 50
        },
        bar: {
          background: 'rgba(0, 107, 178, 1)',
          size: '3px',
          opacity: 0
        }
      },
      ruler: {
        max: 220
      },
      weigh: {
        max: 160
      },
      subSizeTable: [],
      headSizeTable: []
    };
  },

  computed: extends_default()({}, Object(vuex_esm["c" /* mapState */])({
    userInfo: function userInfo(state) {
      return state.userInfo;
    }
  })),
  created: function created() {},
  mounted: function mounted() {

    var sizeTable = JSON.parse(sessionStorage.getItem('sizeTable'));

    this.subSizeTable = sizeTable.clothes;
    if (this.userInfo.sex === 1) {
      this.isCheck = 1;
    } else if (this.userInfo.sex === 2) {
      this.isCheck = 0;
    }
    this.headSizeTable = sizeTable.hat;

    this.sizeInfo.sex = this.sex[this.isCheck].value;
  },
  updated: function updated() {},
  destroyed: function destroyed() {},

  watch: {},
  methods: {
    back: function back() {
      var _this = this;

      setTimeout(function () {
        _this.$router.back(-1);
      }, 300);
    },
    finish: function finish() {
      if (this.sizeInfo.head.value) {
        this.sendReferenceSize();
        this.back();
      } else {
        this.$vux.toast.text('请输入头围', 'middle');
      }
    },

    /* ruler */
    handleScrollRuler: function handleScrollRuler(vertical, horizontal, nativeEvent) {
      var num = this.ruler.max - vertical.scrollTop / 5;
      this.sizeInfo.height.name = num.toFixed(2) + 'cm';
      this.sizeInfo.height.value = num;
    },

    /* Weigh */
    handleScrollWeigh: function handleScrollWeigh(vertical, horizontal, nativeEvent) {
      var offsetLeft = (this.$refs.markingWeigh.offsetLeft - 24) / 5;
      var num = offsetLeft + horizontal.scrollLeft / 5;
      this.sizeInfo.weight.name = num.toFixed(2) + 'kg';
      this.sizeInfo.weight.value = num;
    },
    sendReferenceSize: function sendReferenceSize() {
      var _this2 = this;

      var obj = {
        coat: '',
        pants: '',
        hat: '',
        shoes: '38'
      };

      var heightSize = {};
      var weightSize = {};
      if (this.sizeInfo.height.value < this.subSizeTable[0].minHeight) {
        heightSize = this.subSizeTable[0];
      } else if (this.sizeInfo.height.value >= this.subSizeTable[this.subSizeTable.length - 1].maxHeight) {
        heightSize = this.subSizeTable[this.subSizeTable.length - 1];
      } else {
        this.subSizeTable.forEach(function (element, i) {
          if (_this2.sizeInfo.height.value >= element.minHeight && _this2.sizeInfo.height.value < element.maxHeight) {
            heightSize = element;
          }
        });
      }
      if (this.sizeInfo.weight.value < this.subSizeTable[0].minWeight) {
        weightSize = this.subSizeTable[0];
      } else if (this.sizeInfo.weight.value >= this.subSizeTable[this.subSizeTable.length - 1].maxWeight) {
        weightSize = this.subSizeTable[this.subSizeTable.length - 1];
      } else {
        this.subSizeTable.forEach(function (element, i) {
          if (_this2.sizeInfo.weight.value >= element.minWeight && _this2.sizeInfo.weight.value < element.maxWeight) {
            weightSize = element;
          }
        });
      }
      if (heightSize.id >= weightSize.id) {
        obj.coat = heightSize.size;
      } else {
        obj.coat = weightSize.size;
      }
      obj.pants = obj.coat;

      if (this.sizeInfo.head.value < this.headSizeTable[0].minHead) {
        obj.hat = this.headSizeTable[0].size;
      } else if (this.sizeInfo.head.value >= this.headSizeTable[this.headSizeTable.length - 1].maxHead) {
        obj.hat = this.headSizeTable[this.headSizeTable.length - 1].size;
      } else {
        this.headSizeTable.forEach(function (element, i) {
          if (_this2.sizeInfo.head.value >= element.minHead && _this2.sizeInfo.head.value < element.maxHead) {
            obj.hat = element.size;
          }
        });
      }

      var shoesSize = Math.ceil(this.sizeInfo.height.value / 6.868 * 2 - 10);
      obj.shoes = String(shoesSize);
      sessionStorage.setItem('referenceSize', stringify_default()(obj));
      this.$parent.getReferenceSize();
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/yingxin/tskjxy/views/items/clothes/clotheSize.vue










/* harmony default export */ var clothes_clotheSize = ({
  name: 'clotheSize',
  props: [],
  components: {
    XHeader: vux_src_components_x_header,
    Group: vux_src_components_group,
    Cell: vux_src_components_cell,
    XInput: vux_src_components_x_input,
    'scroller': vuescroll_default.a
  },
  data: function data() {
    return {
      title: this.$route.meta.title,
      value: '',
      isCheck: 0,
      sex: [{
        name: 'girl',
        value: '女生'
      }, {
        name: 'boy',
        value: '男生'
      }],
      sizeInfo: {
        sex: '请选择',
        height: {
          name: '请选择',
          value: Number
        },
        weight: {
          name: '请选择',
          value: Number
        },
        head: {
          name: '请输入',
          value: ''
        }
      },
      rulerOps: {
        scrollPanel: {
          scrollingX: false,
          initialScrollY: 250
        },
        bar: {
          background: 'rgba(0, 107, 178, 1)',
          size: '3px',
          opacity: 0
        }
      },
      weighOps: {
        scrollPanel: {
          scrollingY: false,
          initialScrollX: 50
        },
        bar: {
          background: 'rgba(0, 107, 178, 1)',
          size: '3px',
          opacity: 0
        }
      },
      ruler: {
        max: 220
      },
      weigh: {
        max: 160
      },
      subSizeTable: [],
      headSizeTable: []
    };
  },

  computed: extends_default()({}, Object(vuex_esm["c" /* mapState */])({
    userInfo: function userInfo(state) {
      return state.userInfo;
    }
  })),
  created: function created() {},
  mounted: function mounted() {

    var sizeTable = JSON.parse(sessionStorage.getItem('sizeTable'));

    this.subSizeTable = sizeTable.clothes;
    if (this.userInfo.sex === 1) {
      this.isCheck = 1;
    } else if (this.userInfo.sex === 2) {
      this.isCheck = 0;
    }
    this.headSizeTable = sizeTable.hat;

    this.sizeInfo.sex = this.sex[this.isCheck].value;
  },
  updated: function updated() {},
  destroyed: function destroyed() {},

  watch: {},
  methods: {
    back: function back() {
      var _this = this;

      setTimeout(function () {
        _this.$router.back(-1);
      }, 300);
    },
    finish: function finish() {
      if (this.sizeInfo.head.value) {
        this.sendReferenceSize();
        this.back();
      } else {
        this.$vux.toast.text('请输入头围', 'middle');
      }
    },

    /* ruler */
    handleScrollRuler: function handleScrollRuler(vertical, horizontal, nativeEvent) {
      var num = this.ruler.max - vertical.scrollTop / 5;
      this.sizeInfo.height.name = num.toFixed(2) + 'cm';
      this.sizeInfo.height.value = num;
    },

    /* Weigh */
    handleScrollWeigh: function handleScrollWeigh(vertical, horizontal, nativeEvent) {
      var offsetLeft = (this.$refs.markingWeigh.offsetLeft - 24) / 5;
      var num = offsetLeft + horizontal.scrollLeft / 5;
      this.sizeInfo.weight.name = num.toFixed(2) + 'kg';
      this.sizeInfo.weight.value = num;
    },
    sendReferenceSize: function sendReferenceSize() {
      var _this2 = this;

      var obj = {
        coat: '',
        pants: '',
        hat: '',
        shoes: '38'
      };

      var heightSize = {};
      var weightSize = {};
      if (this.sizeInfo.height.value < this.subSizeTable[0].minHeight) {
        heightSize = this.subSizeTable[0];
      } else if (this.sizeInfo.height.value >= this.subSizeTable[this.subSizeTable.length - 1].maxHeight) {
        heightSize = this.subSizeTable[this.subSizeTable.length - 1];
      } else {
        this.subSizeTable.forEach(function (element, i) {
          if (_this2.sizeInfo.height.value >= element.minHeight && _this2.sizeInfo.height.value < element.maxHeight) {
            heightSize = element;
          }
        });
      }
      if (this.sizeInfo.weight.value < this.subSizeTable[0].minWeight) {
        weightSize = this.subSizeTable[0];
      } else if (this.sizeInfo.weight.value >= this.subSizeTable[this.subSizeTable.length - 1].maxWeight) {
        weightSize = this.subSizeTable[this.subSizeTable.length - 1];
      } else {
        this.subSizeTable.forEach(function (element, i) {
          if (_this2.sizeInfo.weight.value >= element.minWeight && _this2.sizeInfo.weight.value < element.maxWeight) {
            weightSize = element;
          }
        });
      }
      if (heightSize.id >= weightSize.id) {
        obj.coat = heightSize.size;
      } else {
        obj.coat = weightSize.size;
      }
      obj.pants = obj.coat;

      if (this.sizeInfo.head.value < this.headSizeTable[0].minHead) {
        obj.hat = this.headSizeTable[0].size;
      } else if (this.sizeInfo.head.value >= this.headSizeTable[this.headSizeTable.length - 1].maxHead) {
        obj.hat = this.headSizeTable[this.headSizeTable.length - 1].size;
      } else {
        this.headSizeTable.forEach(function (element, i) {
          if (_this2.sizeInfo.head.value >= element.minHead && _this2.sizeInfo.head.value < element.maxHead) {
            obj.hat = element.size;
          }
        });
      }

      var shoesSize = Math.ceil(this.sizeInfo.height.value / 6.868 * 2 - 10);
      obj.shoes = String(shoesSize);
      sessionStorage.setItem('referenceSize', stringify_default()(obj));
      this.$parent.getReferenceSize();
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ac80a866","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/yingxin/tskjxy/views/items/clothes/clotheSize.vue
var clotheSize_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sub-page"},[_c('x-header',{staticClass:"header bg-white box-shadow fixed"},[_c('em',{staticClass:"icon icon-arrow-left",attrs:{"slot":"overwrite-left","size":""},on:{"click":_vm.back},slot:"overwrite-left"}),_vm._v(_vm._s(_vm.title)),_c('span',{staticClass:"text-brand",attrs:{"slot":"right","size":""},on:{"click":_vm.finish},slot:"right"},[_vm._v("完成")])]),_c('div',{staticClass:"fixed-next"},[_c('section',{staticClass:"section input-color-inherit"},[_c('group',[_c('cell',{attrs:{"title":"性别"}},[_vm._v(_vm._s(this.sizeInfo.sex))]),_c('cell',{attrs:{"title":"身高"}},[_vm._v(_vm._s(this.sizeInfo.height.name))]),_c('cell',{attrs:{"title":"体重"}},[_vm._v(_vm._s(this.sizeInfo.weight.name))]),_c('x-input',{attrs:{"title":"头围","type":"number","text-align":"right","placeholder":"请输入头围"},model:{value:(_vm.sizeInfo.head.value),callback:function ($$v) {_vm.$set(_vm.sizeInfo.head, "value", $$v)},expression:"sizeInfo.head.value"}},[_c('span',{attrs:{"slot":"right"},slot:"right"},[_vm._v(" cm")])])],1)],1),_c('section',{staticClass:"section"},[_c('group',[_c('div',{staticClass:"container"},[_c('div',{staticClass:"selectHeight"},[(_vm.isCheck==null )?_c('div',{staticClass:"sex-bg-large",class:_vm.sex[0].name}):_c('div',{staticClass:"sex-bg-large",class:_vm.sex[_vm.isCheck].name}),_c('div',{staticClass:"unit-height"},[_vm._v("身高/cm")]),_c('div',{staticClass:"marking-ruler"},[_c('span',{staticClass:"dashed"}),_c('span',{staticClass:"solid"})]),_c('div',{staticClass:"ruler-outer"},[_c('scroller',{attrs:{"ops":_vm.rulerOps},on:{"handle-scroll":_vm.handleScrollRuler}},[_c('div',{staticClass:"ruler-inner"},[_c('div',{staticClass:"scale-box"},[_vm._l((_vm.ruler.max),function(i){return [(i%5==0 || i==0)?_c('div',{key:i,staticClass:"scale long"}):_c('div',{key:i,staticClass:"scale"})]})],2),_c('div',{staticClass:"number-box"},_vm._l((_vm.ruler.max),function(i){return (i%10==0)?_c('div',{key:i,staticClass:"number"},[_vm._v(_vm._s(_vm.ruler.max - (i-10)))]):_vm._e()}),0)])])],1)]),_c('div',{staticClass:"selectWeight"},[_c('div',{staticClass:"unit-weight"},[_vm._v("体重/kg")]),_c('div',{ref:"markingWeigh",staticClass:"marking-weigh"},[_c('div',{staticClass:"solid"})]),_c('div',{staticClass:"weigh-outer"},[_c('scroller',{attrs:{"ops":_vm.weighOps},on:{"handle-scroll":_vm.handleScrollWeigh}},[_c('div',{staticClass:"weigh-inner"},[_c('div',{staticClass:"scale-box"},[_vm._l((_vm.weigh.max),function(i){return [(i%10==0 || i==0)?_c('span',{key:i,staticClass:"scale long"}):_c('span',{key:i,staticClass:"scale"})]})],2),_c('div',{staticClass:"number-box"},_vm._l((_vm.weigh.max),function(i){return (i%10==0)?_c('span',{key:i,staticClass:"number"},[_vm._v(_vm._s(i-10))]):_vm._e()}),0)])])],1)])])])],1)])],1)}
var clotheSize_staticRenderFns = []
var clotheSize_esExports = { render: clotheSize_render, staticRenderFns: clotheSize_staticRenderFns }
/* harmony default export */ var items_clothes_clotheSize = (clotheSize_esExports);
// CONCATENATED MODULE: ./src/yingxin/tskjxy/views/items/clothes/clotheSize.vue
var clotheSize_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var clotheSize___vue_template_functional__ = false
/* styles */
var clotheSize___vue_styles__ = null
/* scopeId */
var clotheSize___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var clotheSize___vue_module_identifier__ = null
var clotheSize_Component = clotheSize_normalizeComponent(
  clothes_clotheSize,
  items_clothes_clotheSize,
  clotheSize___vue_template_functional__,
  clotheSize___vue_styles__,
  clotheSize___vue_scopeId__,
  clotheSize___vue_module_identifier__
)

/* harmony default export */ var views_items_clothes_clotheSize = (clotheSize_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/yingxin/tskjxy/views/items/medical.vue










/* harmony default export */ var medical = ({
  name: 'medical',
  props: [],
  directives: {
    TransferDom: transfer_dom["a" /* default */]
  },
  components: {
    XHeader: vux_src_components_x_header,
    XButton: vux_src_components_x_button,
    Group: vux_src_components_group,
    Cell: vux_src_components_cell,
    Popup: node_modules_vux_src_components_popup
  },
  data: function data() {
    return {
      showDate: false,
      dateValue: '请选择',
      value1: [],
      id: '',
      preiod: '',
      dateArr: [],
      notice: {
        content: '1、注意饮食对于体检来说在前一天的时候，特别是在饮食方面要特别的注意，注意不可以大吃大喝，对于一些辛辣刺激的食物我们也尽量不要吃，忌烟酒，另外要保证自己的心情愉悦，不可以过度的劳累，早点休息，同时要保证自己的精力充沛，对于一些血压不稳定的患者要避免劳动，保持血压的稳定性',
        department: '校医院',
        date: ''
      },
      btnText: '预约'
    };
  },

  computed: extends_default()({}, Object(vuex_esm["c" /* mapState */])({
    title: function title(state) {
      return state.currentProcedureInfo.name;
    },
    studentId: function studentId(state) {
      return state.userInfo.id;
    },
    flowId: function flowId(state) {
      return state.flowInfo.flowId;
    },
    flowProcedureId: function flowProcedureId(state) {
      return state.currentProcedureInfo.flowProcedureId;
    },
    procedureId: function procedureId(state) {
      return state.currentProcedureInfo.procedureId;
    },
    campusCode: function campusCode(state) {
      return state.userInfo.campusCode;
    },
    parentRouter: function parentRouter(state) {
      return state.currentProcedureInfo.parentRouter;
    }
  }), {
    dateID: function dateID() {
      return this.$route.params.dateId;
    }
  }),
  watch: {},
  created: function created() {},
  mounted: function mounted() {
    this.getTimeSlot();
  },
  updated: function updated() {},
  destroyed: function destroyed() {},

  methods: {
    back: function back() {
      var _this = this;

      setTimeout(function () {

        _this.$router.push({
          name: _this.parentRouter
        });
      }, 300);
    },
    getTimeSlot: function getTimeSlot() {
      var _this2 = this;

      this.dateArr = [];
      var params = {
        flowId: this.flowId,
        flowProcedureId: this.flowProcedureId,
        procedureId: this.procedureId,
        campusCode: this.campusCode
      };
      this.$api.get('/configBodyExam', params, function (r) {
        _this2.daylist = r.data;
        _this2.getLastData();
        r.data.forEach(function (element) {
          var obj = {};
          var isfull = '';
          var flag = false;
          if (element.totalNumber - element.useNumber === 0) {
            isfull = ' 名额已满';
            flag = false;
          } else {
            isfull = '可预约';
            flag = true;
          }
          obj = {
            'value': element.startDatetime.split(' ')[0] + ' ' + element.startDatetime.split(' ')[1] + '至' + element.endDatetime.split(' ')[1],
            'state': isfull,
            'num': element.totalNumber - element.useNumber,
            'id': element.id,
            'flag': flag
          };
          _this2.dateArr.push(obj);
        });
        _this2.dateArr = _this2.dateArr.sort(_this2.sortNumber);
      }, function (err) {
        _this2.$vux.toast.text(err.message, 'top');
      });
    },
    sortNumber: function sortNumber(a, b) {
      return Date.parse(a.value.split(' ')[0]) - Date.parse(b.value.split(' ')[0]);
    },
    changeDate: function changeDate(value, flag) {
      if (flag) {
        this.showDate = false;
        this.dateValue = value;
        this.preiod = value.replace('至', '-');
      }
    },
    save: function save() {
      var _this3 = this;

      var params = {
        id: this.id,
        flowId: this.flowId,
        flowProcedureId: this.flowProcedureId,
        procedureId: this.procedureId,
        studentId: this.studentId,
        preiod: this.preiod,
        status: 4
      };
      this.$api.post('/bodyExamOrder/handle', params, function (r) {
        _this3.$vux.loading.show({
          text: '加载中,请稍后'
        });
        setTimeout(function () {
          _this3.$vux.loading.hide();
          _this3.$router.push({
            name: 'itemResult'
          });
        }, 5000);
      }, function (err) {
        _this3.$vux.toast.text(err.message, 'top');
      });
    },
    getLastData: function getLastData() {
      var _this4 = this;

      var params = {
        'studentId': this.studentId,
        'flowId': this.flowId
      };
      this.$api.get('/bodyExamOrder', params, function (r) {
        if (r.data.length > 0) {
          _this4.btnText = '重新预约';
          var data = r.data[0];
          _this4.id = data.id;
          _this4.dateValue = data.preiod.split(' ')[0] + ' ' + data.preiod.split(' ')[1].replace('-', '至');
          _this4.preiod = data.preiod;
        }
      }, function (err) {
        _this4.$vux.toast.text(err.message, 'top');
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/yingxin/tskjxy/views/items/medical.vue










/* harmony default export */ var items_medical = ({
  name: 'medical',
  props: [],
  directives: {
    TransferDom: transfer_dom["a" /* default */]
  },
  components: {
    XHeader: vux_src_components_x_header,
    XButton: vux_src_components_x_button,
    Group: vux_src_components_group,
    Cell: vux_src_components_cell,
    Popup: node_modules_vux_src_components_popup
  },
  data: function data() {
    return {
      showDate: false,
      dateValue: '请选择',
      value1: [],
      id: '',
      preiod: '',
      dateArr: [],
      notice: {
        content: '1、注意饮食对于体检来说在前一天的时候，特别是在饮食方面要特别的注意，注意不可以大吃大喝，对于一些辛辣刺激的食物我们也尽量不要吃，忌烟酒，另外要保证自己的心情愉悦，不可以过度的劳累，早点休息，同时要保证自己的精力充沛，对于一些血压不稳定的患者要避免劳动，保持血压的稳定性',
        department: '校医院',
        date: ''
      },
      btnText: '预约'
    };
  },

  computed: extends_default()({}, Object(vuex_esm["c" /* mapState */])({
    title: function title(state) {
      return state.currentProcedureInfo.name;
    },
    studentId: function studentId(state) {
      return state.userInfo.id;
    },
    flowId: function flowId(state) {
      return state.flowInfo.flowId;
    },
    flowProcedureId: function flowProcedureId(state) {
      return state.currentProcedureInfo.flowProcedureId;
    },
    procedureId: function procedureId(state) {
      return state.currentProcedureInfo.procedureId;
    },
    campusCode: function campusCode(state) {
      return state.userInfo.campusCode;
    },
    parentRouter: function parentRouter(state) {
      return state.currentProcedureInfo.parentRouter;
    }
  }), {
    dateID: function dateID() {
      return this.$route.params.dateId;
    }
  }),
  watch: {},
  created: function created() {},
  mounted: function mounted() {
    this.getTimeSlot();
  },
  updated: function updated() {},
  destroyed: function destroyed() {},

  methods: {
    back: function back() {
      var _this = this;

      setTimeout(function () {

        _this.$router.push({
          name: _this.parentRouter
        });
      }, 300);
    },
    getTimeSlot: function getTimeSlot() {
      var _this2 = this;

      this.dateArr = [];
      var params = {
        flowId: this.flowId,
        flowProcedureId: this.flowProcedureId,
        procedureId: this.procedureId,
        campusCode: this.campusCode
      };
      this.$api.get('/configBodyExam', params, function (r) {
        _this2.daylist = r.data;
        _this2.getLastData();
        r.data.forEach(function (element) {
          var obj = {};
          var isfull = '';
          var flag = false;
          if (element.totalNumber - element.useNumber === 0) {
            isfull = ' 名额已满';
            flag = false;
          } else {
            isfull = '可预约';
            flag = true;
          }
          obj = {
            'value': element.startDatetime.split(' ')[0] + ' ' + element.startDatetime.split(' ')[1] + '至' + element.endDatetime.split(' ')[1],
            'state': isfull,
            'num': element.totalNumber - element.useNumber,
            'id': element.id,
            'flag': flag
          };
          _this2.dateArr.push(obj);
        });
        _this2.dateArr = _this2.dateArr.sort(_this2.sortNumber);
      }, function (err) {
        _this2.$vux.toast.text(err.message, 'top');
      });
    },
    sortNumber: function sortNumber(a, b) {
      return Date.parse(a.value.split(' ')[0]) - Date.parse(b.value.split(' ')[0]);
    },
    changeDate: function changeDate(value, flag) {
      if (flag) {
        this.showDate = false;
        this.dateValue = value;
        this.preiod = value.replace('至', '-');
      }
    },
    save: function save() {
      var _this3 = this;

      var params = {
        id: this.id,
        flowId: this.flowId,
        flowProcedureId: this.flowProcedureId,
        procedureId: this.procedureId,
        studentId: this.studentId,
        preiod: this.preiod,
        status: 4
      };
      this.$api.post('/bodyExamOrder/handle', params, function (r) {
        _this3.$vux.loading.show({
          text: '加载中,请稍后'
        });
        setTimeout(function () {
          _this3.$vux.loading.hide();
          _this3.$router.push({
            name: 'itemResult'
          });
        }, 5000);
      }, function (err) {
        _this3.$vux.toast.text(err.message, 'top');
      });
    },
    getLastData: function getLastData() {
      var _this4 = this;

      var params = {
        'studentId': this.studentId,
        'flowId': this.flowId
      };
      this.$api.get('/bodyExamOrder', params, function (r) {
        if (r.data.length > 0) {
          _this4.btnText = '重新预约';
          var data = r.data[0];
          _this4.id = data.id;
          _this4.dateValue = data.preiod.split(' ')[0] + ' ' + data.preiod.split(' ')[1].replace('-', '至');
          _this4.preiod = data.preiod;
        }
      }, function (err) {
        _this4.$vux.toast.text(err.message, 'top');
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-569369af","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/yingxin/tskjxy/views/items/medical.vue
var medical_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('x-header',{staticClass:"header bg-white fixed"},[_c('em',{staticClass:"icon icon-arrow-left",attrs:{"slot":"overwrite-left","size":""},on:{"click":_vm.back},slot:"overwrite-left"}),_vm._v(_vm._s(_vm.title))]),_c('section',{staticClass:"section fixed-next"},[_c('Group',[_c('cell',{attrs:{"title":"体检日期","value":_vm.dateValue,"is-link":true},nativeOn:{"click":function($event){_vm.showDate = true}}})],1),_vm._m(0)],1),_c('div',{staticClass:"button-group fixed bottom container"},[_c('x-button',{attrs:{"type":"brand","disabled":_vm.dateValue.length===''},nativeOn:{"click":function($event){return _vm.save($event)}}},[_vm._v(_vm._s(_vm.btnText))])],1),_c('div',{directives:[{name:"transfer-dom",rawName:"v-transfer-dom"}],staticClass:"medical-date-modal"},[_c('popup',{attrs:{"position":"right","width":"100%"},model:{value:(_vm.showDate),callback:function ($$v) {_vm.showDate=$$v},expression:"showDate"}},[_c('div',[_c('x-header',{staticClass:"header bg-white box-shadow"},[_c('em',{staticClass:"icon icon-arrow-left",attrs:{"slot":"overwrite-left","size":""},on:{"click":function($event){_vm.showDate = false}},slot:"overwrite-left"}),_vm._v(_vm._s(_vm.title))]),_c('Group',{staticClass:"mediacal-date"},_vm._l((_vm.dateArr),function(item){return _c('cell',{key:item.id,attrs:{"is-link":true,"disabled":!item.flag},nativeOn:{"click":function($event){return _vm.changeDate(item.value, item.flag)}}},[_c('div',{staticStyle:{"width":"100%"},attrs:{"solt":"child"}},[_c('span',{staticStyle:{"padding-left":"10px"}},[_vm._v(_vm._s(item.value))]),_c('span',{staticClass:"num"},[_vm._v(" (剩"+_vm._s(item.num)+"个)")]),_c('i',{staticClass:"sign",class:item.flag?'green-sign':'red-sign'},[_vm._v(_vm._s(item.state))])])])}),1)],1)])],1)],1)}
var medical_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container notice-procedure"},[_c('div',{staticClass:"panel",staticStyle:{"padding-bottom":"60px"}},[_c('p',{staticClass:"panel-header"},[_vm._v("体检须知")]),_c('ul',{staticClass:"panel-body medical-tips-content"},[_c('li',[_c('p',[_vm._v("（1）为减少体检排队时间，迎新系统提供下载体检单的功能，你可以提前在家中预约体检时间并下载打印体检单，省去体检排队打印体检单的时间。")]),_c('p',[_vm._v("（2）已经提前打印体检单的同学可以直接去校医院参加体检。")]),_c('p',[_vm._v("（3）您下载的体检单文件格式为PDF文档，需要使用相关软件才能读取并打印。如果您没有打印机，可以将电子版的体检单文件拷贝到U盘，到打印店打印即可。")]),_c('p',[_vm._v("（4）体检单所使用的照片与校园卡照片相同，本系统不提供上传照片功能。")]),_c('p',[_vm._v("（5）请您确认已经将体检费缴清，否则不能下载体检单。")]),_c('p',[_vm._v("（6）如果遇到问题请拨打技术咨询电话029-82667777。")])])])])])}]
var medical_esExports = { render: medical_render, staticRenderFns: medical_staticRenderFns }
/* harmony default export */ var views_items_medical = (medical_esExports);
// CONCATENATED MODULE: ./src/yingxin/tskjxy/views/items/medical.vue
var medical_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var medical___vue_template_functional__ = false
/* styles */
var medical___vue_styles__ = null
/* scopeId */
var medical___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var medical___vue_module_identifier__ = null
var medical_Component = medical_normalizeComponent(
  items_medical,
  views_items_medical,
  medical___vue_template_functional__,
  medical___vue_styles__,
  medical___vue_scopeId__,
  medical___vue_module_identifier__
)

/* harmony default export */ var tskjxy_views_items_medical = (medical_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/yingxin/tskjxy/views/items/medical/medicalDate.vue







/* harmony default export */ var medicalDate = ({
  name: 'medicalDate',
  props: [],
  components: {
    XHeader: vux_src_components_x_header,
    Group: vux_src_components_group,
    Cell: vux_src_components_cell
  },
  data: function data() {
    return {
      dateArr: []
    };
  },

  computed: extends_default()({}, Object(vuex_esm["c" /* mapState */])({
    title: function title(state) {
      return state.currentProcedureInfo.name;
    },
    studentId: function studentId(state) {
      return state.userInfo.id;
    },
    flowId: function flowId(state) {
      return state.flowInfo.flowId;
    },
    flowProcedureId: function flowProcedureId(state) {
      return state.currentProcedureInfo.flowProcedureId;
    },
    procedureId: function procedureId(state) {
      return state.currentProcedureInfo.procedureId;
    }
  })),
  created: function created() {},
  mounted: function mounted() {
    this.getTimeSlot();
  },
  updated: function updated() {},
  destroyed: function destroyed() {},

  watch: {},
  methods: {
    back: function back() {
      var _this = this;

      setTimeout(function () {
        _this.$router.back(-1);
      }, 300);
    },
    goMedical: function goMedical(id, flag) {
      if (flag) {
        this.$router.replace({
          name: 'medical',
          params: { dateId: id }
        });
      }
    },
    getTimeSlot: function getTimeSlot() {
      var _this2 = this;

      var params = {
        flowId: this.flowId,
        flowProcedureId: this.flowProcedureId,
        procedureId: this.procedureId
      };
      this.$api.get('/configBodyExam', params, function (r) {
        r.data.forEach(function (element) {
          var obj = {};
          var isfull = '';
          var flag = false;
          if (element.totalNumber - element.useNumber === 0) {
            isfull = ' 名额已满';
            flag = false;
          } else {
            isfull = '可预约';
            flag = true;
          }
          obj = {
            'value': element.startDatetime.split(' ')[0] + ' ' + element.startDatetime.split(' ')[1] + '至' + element.endDatetime.split(' ')[1],
            'state': isfull,
            'num': element.totalNumber - element.useNumber,
            'id': element.id,
            'flag': flag
          };
          _this2.dateArr.push(obj);
        });
        _this2.dateArr = _this2.dateArr.sort(_this2.sortNumber);
      }, function (err) {
        _this2.$vux.toast.text(err.message, 'top');
      });
    },
    sortNumber: function sortNumber(a, b) {
      return Date.parse(a.value.split(' ')[0]) - Date.parse(b.value.split(' ')[0]);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/yingxin/tskjxy/views/items/medical/medicalDate.vue







/* harmony default export */ var medical_medicalDate = ({
  name: 'medicalDate',
  props: [],
  components: {
    XHeader: vux_src_components_x_header,
    Group: vux_src_components_group,
    Cell: vux_src_components_cell
  },
  data: function data() {
    return {
      dateArr: []
    };
  },

  computed: extends_default()({}, Object(vuex_esm["c" /* mapState */])({
    title: function title(state) {
      return state.currentProcedureInfo.name;
    },
    studentId: function studentId(state) {
      return state.userInfo.id;
    },
    flowId: function flowId(state) {
      return state.flowInfo.flowId;
    },
    flowProcedureId: function flowProcedureId(state) {
      return state.currentProcedureInfo.flowProcedureId;
    },
    procedureId: function procedureId(state) {
      return state.currentProcedureInfo.procedureId;
    }
  })),
  created: function created() {},
  mounted: function mounted() {
    this.getTimeSlot();
  },
  updated: function updated() {},
  destroyed: function destroyed() {},

  watch: {},
  methods: {
    back: function back() {
      var _this = this;

      setTimeout(function () {
        _this.$router.back(-1);
      }, 300);
    },
    goMedical: function goMedical(id, flag) {
      if (flag) {
        this.$router.replace({
          name: 'medical',
          params: { dateId: id }
        });
      }
    },
    getTimeSlot: function getTimeSlot() {
      var _this2 = this;

      var params = {
        flowId: this.flowId,
        flowProcedureId: this.flowProcedureId,
        procedureId: this.procedureId
      };
      this.$api.get('/configBodyExam', params, function (r) {
        r.data.forEach(function (element) {
          var obj = {};
          var isfull = '';
          var flag = false;
          if (element.totalNumber - element.useNumber === 0) {
            isfull = ' 名额已满';
            flag = false;
          } else {
            isfull = '可预约';
            flag = true;
          }
          obj = {
            'value': element.startDatetime.split(' ')[0] + ' ' + element.startDatetime.split(' ')[1] + '至' + element.endDatetime.split(' ')[1],
            'state': isfull,
            'num': element.totalNumber - element.useNumber,
            'id': element.id,
            'flag': flag
          };
          _this2.dateArr.push(obj);
        });
        _this2.dateArr = _this2.dateArr.sort(_this2.sortNumber);
      }, function (err) {
        _this2.$vux.toast.text(err.message, 'top');
      });
    },
    sortNumber: function sortNumber(a, b) {
      return Date.parse(a.value.split(' ')[0]) - Date.parse(b.value.split(' ')[0]);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-680e7785","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/yingxin/tskjxy/views/items/medical/medicalDate.vue
var medicalDate_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sub-page bg-white"},[_c('x-header',{staticClass:"header bg-white box-shadow"},[_c('em',{staticClass:"icon icon-arrow-left",attrs:{"slot":"overwrite-left","size":""},on:{"click":_vm.back},slot:"overwrite-left"}),_vm._v(_vm._s(_vm.title))]),_c('Group',{staticClass:"mediacal-date"},_vm._l((_vm.dateArr),function(item){return _c('cell',{key:item.id,attrs:{"is-link":true,"disabled":!item.flag},nativeOn:{"click":function($event){return _vm.goMedical(item.id, item.flag)}}},[_c('div',{staticStyle:{"width":"100%"},attrs:{"solt":"child"}},[_c('span',[_vm._v(_vm._s(item.value))]),_c('span',{staticClass:"num"},[_vm._v(" (剩"+_vm._s(item.num)+"个)")]),_c('i',{staticClass:"sign",class:item.flag?'green-sign':'red-sign'},[_vm._v(_vm._s(item.state))])])])}),1)],1)}
var medicalDate_staticRenderFns = []
var medicalDate_esExports = { render: medicalDate_render, staticRenderFns: medicalDate_staticRenderFns }
/* harmony default export */ var items_medical_medicalDate = (medicalDate_esExports);
// CONCATENATED MODULE: ./src/yingxin/tskjxy/views/items/medical/medicalDate.vue
function medicalDate_injectStyle (ssrContext) {
  __webpack_require__("mLHi")
}
var medicalDate_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var medicalDate___vue_template_functional__ = false
/* styles */
var medicalDate___vue_styles__ = medicalDate_injectStyle
/* scopeId */
var medicalDate___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var medicalDate___vue_module_identifier__ = null
var medicalDate_Component = medicalDate_normalizeComponent(
  medical_medicalDate,
  items_medical_medicalDate,
  medicalDate___vue_template_functional__,
  medicalDate___vue_styles__,
  medicalDate___vue_scopeId__,
  medicalDate___vue_module_identifier__
)

/* harmony default export */ var views_items_medical_medicalDate = (medicalDate_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/form-preview/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var form_preview = ({
  name: 'form-preview',
  props: ['headerLabel', 'headerValue', 'bodyItems', 'footerButtons', 'name'],
  methods: {
    onButtonClick: function onButtonClick(cb, link) {
      cb && cb(this.name);
      if (link) {
        Object(libs_router["b" /* go */])(link, this.$router);
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/form-preview/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var components_form_preview = ({
  name: 'form-preview',
  props: ['headerLabel', 'headerValue', 'bodyItems', 'footerButtons', 'name'],
  methods: {
    onButtonClick: function onButtonClick(cb, link) {
      cb && cb(this.name);
      if (link) {
        Object(libs_router["b" /* go */])(link, this.$router);
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4af8ca20","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/form-preview/index.vue
var form_preview_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-form-preview weui-form-preview"},[_c('div',{staticClass:"weui-form-preview__hd"},[_c('label',{staticClass:"weui-form-preview__label",domProps:{"innerHTML":_vm._s(_vm.headerLabel)}}),_vm._v(" "),_c('em',{staticClass:"weui-form-preview__value",domProps:{"innerHTML":_vm._s(_vm.headerValue || '&nbsp;')}})]),_vm._v(" "),_c('div',{staticClass:"weui-form-preview__bd"},_vm._l((_vm.bodyItems),function(item){return _c('div',{staticClass:"weui-form-preview__item"},[_c('label',{staticClass:"weui-form-preview__label"},[_vm._v(_vm._s(item.label))]),_vm._v(" "),_c('span',{staticClass:"weui-form-preview__value"},[_vm._v(_vm._s(item.value))])])}),0),_vm._v(" "),_c('div',{staticClass:"weui-form-preview__ft"},_vm._l((_vm.footerButtons),function(button){return _c('a',{staticClass:"weui-form-preview__btn",class:{'weui-form-preview__btn_default': button.style==='default', 'weui-form-preview__btn_primary': button.style === 'primary'},attrs:{"href":"javascript:"},on:{"click":function($event){return _vm.onButtonClick(button.onButtonClick, button.link)}}},[_vm._v(_vm._s(button.text))])}),0)])}
var form_preview_staticRenderFns = []
var form_preview_esExports = { render: form_preview_render, staticRenderFns: form_preview_staticRenderFns }
/* harmony default export */ var src_components_form_preview = (form_preview_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/form-preview/index.vue
function form_preview_injectStyle (ssrContext) {
  __webpack_require__("Yl6F")
}
var form_preview_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var form_preview___vue_template_functional__ = false
/* styles */
var form_preview___vue_styles__ = form_preview_injectStyle
/* scopeId */
var form_preview___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var form_preview___vue_module_identifier__ = null
var form_preview_Component = form_preview_normalizeComponent(
  components_form_preview,
  src_components_form_preview,
  form_preview___vue_template_functional__,
  form_preview___vue_styles__,
  form_preview___vue_scopeId__,
  form_preview___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_form_preview = (form_preview_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/result.vue









/* harmony default export */ var result = ({
  name: 'result',
  props: {
    resultMsg: {}
  },
  directives: {
    TransferDom: transfer_dom["a" /* default */]
  },
  components: {
    XButton: vux_src_components_x_button, Icon: vux_src_components_icon, FormPreview: vux_src_components_form_preview, Flexbox: flexbox_flexbox["a" /* default */], FlexboxItem: flexbox_item["a" /* default */], Confirm: node_modules_vux_src_components_confirm
  },
  data: function data() {
    return {};
  },

  methods: {
    resetChild: function resetChild() {
      this.$parent.reset();
    },
    onConfirm: function onConfirm(type) {
      var info = {
        msg: '',
        isEdit: true
      };

      if (type === 'edit') {
        info.msg = '请重新填写';
      } else if (type === 'cancel') {
        info.msg = '取消成功';
      }
      this.$parent.onConfirm(info);
    },
    onCancel: function onCancel() {
      this.$parent.onCancel();
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/result.vue









/* harmony default export */ var components_result = ({
  name: 'result',
  props: {
    resultMsg: {}
  },
  directives: {
    TransferDom: transfer_dom["a" /* default */]
  },
  components: {
    XButton: vux_src_components_x_button, Icon: vux_src_components_icon, FormPreview: vux_src_components_form_preview, Flexbox: flexbox_flexbox["a" /* default */], FlexboxItem: flexbox_item["a" /* default */], Confirm: node_modules_vux_src_components_confirm
  },
  data: function data() {
    return {};
  },

  methods: {
    resetChild: function resetChild() {
      this.$parent.reset();
    },
    onConfirm: function onConfirm(type) {
      var info = {
        msg: '',
        isEdit: true
      };

      if (type === 'edit') {
        info.msg = '请重新填写';
      } else if (type === 'cancel') {
        info.msg = '取消成功';
      }
      this.$parent.onConfirm(info);
    },
    onCancel: function onCancel() {
      this.$parent.onCancel();
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1e8939f3","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/result.vue
var result_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"result"},[(_vm.resultMsg.state == 0)?_c('div',{staticClass:"box"},[_c('div',{staticClass:"icon-msg"},[_c('icon',{attrs:{"type":"success"}})],1),_c('div',{staticClass:"info-msg",domProps:{"innerHTML":_vm._s(_vm.resultMsg.successMsg)}},[_vm._v(_vm._s(_vm.resultMsg.successMsg))]),(_vm.resultMsg.infoList.length != 0)?_c('div',{staticClass:"form"},[_c('form-preview',{attrs:{"header-label":_vm.resultMsg.infoTitle,"body-items":_vm.resultMsg.infoList}})],1):_vm._e(),(_vm.resultMsg.successBtn.length !== 0)?_c('div',{staticClass:"button-group fixed bottom container"},[_c('flexbox',_vm._l((_vm.resultMsg.successBtn),function(item,index){return _c('flexbox-item',{key:index},[_c('x-button',{attrs:{"type":item.type},nativeOn:{"click":function($event){return item.callback($event)}}},[_vm._v(_vm._s(item.name))])],1)}),1)],1):_vm._e()]):_vm._e(),(_vm.resultMsg.state == 1)?_c('div',{staticClass:"box"},[_c('div',{staticClass:"icon-msg"},[_c('icon',{attrs:{"type":"warn"}})],1),_c('div',{staticClass:"info-msg"},[_vm._v(_vm._s(_vm.resultMsg.errorMsg))]),(_vm.resultMsg.infoList.length != 0)?_c('div',{staticClass:"form"},[_c('form-preview',{attrs:{"header-label":_vm.resultMsg.infoTitle,"body-items":_vm.resultMsg.infoList}})],1):_vm._e(),_c('div',{staticClass:"button container"},[_c('x-button',{attrs:{"type":"brand"},nativeOn:{"click":function($event){return _vm.resetChild($event)}}},[_vm._v(_vm._s(_vm.resultMsg.errorBtn))])],1)]):_vm._e(),_c('div',{directives:[{name:"transfer-dom",rawName:"v-transfer-dom"}]},[_c('confirm',{on:{"on-cancel":_vm.onCancel,"on-confirm":function($event){return _vm.onConfirm(_vm.resultMsg.confirmShow.type)}},model:{value:(_vm.resultMsg.confirmShow.state),callback:function ($$v) {_vm.$set(_vm.resultMsg.confirmShow, "state", $$v)},expression:"resultMsg.confirmShow.state"}},[_c('p',{staticStyle:{"text-align":"center"}},[_vm._v(_vm._s(_vm.resultMsg.confirmShow.content))])])],1)])}
var result_staticRenderFns = []
var result_esExports = { render: result_render, staticRenderFns: result_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_result = (result_esExports);
// CONCATENATED MODULE: ./src/components/result.vue
var result_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var result___vue_template_functional__ = false
/* styles */
var result___vue_styles__ = null
/* scopeId */
var result___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var result___vue_module_identifier__ = null
var result_Component = result_normalizeComponent(
  components_result,
  selectortype_template_index_0_src_components_result,
  result___vue_template_functional__,
  result___vue_styles__,
  result___vue_scopeId__,
  result___vue_module_identifier__
)

/* harmony default export */ var src_components_result = (result_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/yingxin/tskjxy/views/items/medical/medicalResult.vue




/* harmony default export */ var medicalResult = ({
  name: 'info',
  props: [],
  components: {
    XHeader: vux_src_components_x_header,
    Result: src_components_result
  },
  data: function data() {
    var _this = this;

    return {
      resultMsg: {
        state: '0',
        successMsg: '预约成功，请按时体检',
        errorMsg: '预约失败，稍后请重新预约',
        successBtn: [{
          name: '取消',
          type: 'warn',
          callback: function callback() {
            _this.resultMsg.confirmShow.state = true;
            _this.resultMsg.confirmShow.content = '确定取消本次预约吗？';
            _this.resultMsg.confirmShow.type = 'cancel';
          }
        }, {
          name: '编辑',
          type: 'brand',
          callback: function callback() {
            _this.resultMsg.confirmShow.state = true;
            _this.resultMsg.confirmShow.content = '确定编辑本次预约信息吗？';
            _this.resultMsg.confirmShow.type = 'edit';
          }
        }],
        errorBtn: '重新预约',
        infoTitle: '预约信息',
        infoList: [{
          label: '地点',
          value: '兴庆校区校医院'
        }, {
          label: '姓名',
          value: '李泽言'
        }, {
          label: '预约号',
          value: '19035'
        }, {
          label: '预约体检时间',
          value: '2019-09-02 10:00-12:00'
        }, {
          label: '预约提交时间',
          value: '2019-08-30 14:30:15'
        }],
        confirmShow: {
          state: false,
          content: '',
          type: ''
        }
      }
    };
  },

  computed: {
    title: function title() {
      return this.$route.meta.title;
    }
  },
  created: function created() {},
  mounted: function mounted() {},
  updated: function updated() {},
  destroyed: function destroyed() {},

  watch: {},
  methods: {
    back: function back() {
      var _this2 = this;

      setTimeout(function () {
        _this2.$router.back(-1);
      }, 300);
    },
    onConfirm: function onConfirm(msg) {
      var _this3 = this;

      setTimeout(function () {
        _this3.back();
      }, 300);
    },
    onCancel: function onCancel() {
      this.confirmShow = false;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/yingxin/tskjxy/views/items/medical/medicalResult.vue




/* harmony default export */ var medical_medicalResult = ({
  name: 'info',
  props: [],
  components: {
    XHeader: vux_src_components_x_header,
    Result: src_components_result
  },
  data: function data() {
    var _this = this;

    return {
      resultMsg: {
        state: '0',
        successMsg: '预约成功，请按时体检',
        errorMsg: '预约失败，稍后请重新预约',
        successBtn: [{
          name: '取消',
          type: 'warn',
          callback: function callback() {
            _this.resultMsg.confirmShow.state = true;
            _this.resultMsg.confirmShow.content = '确定取消本次预约吗？';
            _this.resultMsg.confirmShow.type = 'cancel';
          }
        }, {
          name: '编辑',
          type: 'brand',
          callback: function callback() {
            _this.resultMsg.confirmShow.state = true;
            _this.resultMsg.confirmShow.content = '确定编辑本次预约信息吗？';
            _this.resultMsg.confirmShow.type = 'edit';
          }
        }],
        errorBtn: '重新预约',
        infoTitle: '预约信息',
        infoList: [{
          label: '地点',
          value: '兴庆校区校医院'
        }, {
          label: '姓名',
          value: '李泽言'
        }, {
          label: '预约号',
          value: '19035'
        }, {
          label: '预约体检时间',
          value: '2019-09-02 10:00-12:00'
        }, {
          label: '预约提交时间',
          value: '2019-08-30 14:30:15'
        }],
        confirmShow: {
          state: false,
          content: '',
          type: ''
        }
      }
    };
  },

  computed: {
    title: function title() {
      return this.$route.meta.title;
    }
  },
  created: function created() {},
  mounted: function mounted() {},
  updated: function updated() {},
  destroyed: function destroyed() {},

  watch: {},
  methods: {
    back: function back() {
      var _this2 = this;

      setTimeout(function () {
        _this2.$router.back(-1);
      }, 300);
    },
    onConfirm: function onConfirm(msg) {
      var _this3 = this;

      setTimeout(function () {
        _this3.back();
      }, 300);
    },
    onCancel: function onCancel() {
      this.confirmShow = false;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-73c4e955","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/yingxin/tskjxy/views/items/medical/medicalResult.vue
var medicalResult_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sub-page"},[_c('x-header',{staticClass:"header bg-white box-shadow"},[_c('em',{staticClass:"icon icon-arrow-left",attrs:{"slot":"overwrite-left","size":""},on:{"click":_vm.back},slot:"overwrite-left"}),_vm._v(_vm._s(_vm.title)),(_vm.resultMsg.state =='0')?_c('span',{staticClass:"text-brand",attrs:{"slot":"right","size":""},on:{"click":_vm.finish},slot:"right"},[_vm._v("完成")]):_vm._e()]),_c('section',{staticClass:"section"},[_c('Result',{attrs:{"resultMsg":_vm.resultMsg}})],1)],1)}
var medicalResult_staticRenderFns = []
var medicalResult_esExports = { render: medicalResult_render, staticRenderFns: medicalResult_staticRenderFns }
/* harmony default export */ var items_medical_medicalResult = (medicalResult_esExports);
// CONCATENATED MODULE: ./src/yingxin/tskjxy/views/items/medical/medicalResult.vue
function medicalResult_injectStyle (ssrContext) {
  __webpack_require__("/GJc")
}
var medicalResult_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var medicalResult___vue_template_functional__ = false
/* styles */
var medicalResult___vue_styles__ = medicalResult_injectStyle
/* scopeId */
var medicalResult___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var medicalResult___vue_module_identifier__ = null
var medicalResult_Component = medicalResult_normalizeComponent(
  medical_medicalResult,
  items_medical_medicalResult,
  medicalResult___vue_template_functional__,
  medicalResult___vue_styles__,
  medicalResult___vue_scopeId__,
  medicalResult___vue_module_identifier__
)

/* harmony default export */ var views_items_medical_medicalResult = (medicalResult_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/yingxin/tskjxy/views/items/books.vue









/* harmony default export */ var books = ({
  name: 'books',
  props: [],
  components: {
    XHeader: vux_src_components_x_header,
    CheckIcon: vux_src_components_check_icon,
    Group: vux_src_components_group,
    Cell: vux_src_components_cell,
    XButton: vux_src_components_x_button,
    XSwitch: vux_src_components_x_switch,
    'scroller': vuescroll_default.a
  },
  data: function data() {
    return {
      ops: {
        scrollPanel: {
          scrollingX: false
        },
        bar: {
          background: 'rgba(0, 107, 178, 0.3)',
          size: '3px',
          opacity: 0
        }
      },
      bookList: [{
        id: '0',
        type: '公共课教材',
        books: [{
          name: '高等数学Ⅰ',
          price: 30
        }, {
          name: '大学英语Ⅰ',
          price: 42
        }, {
          name: '中国近现代史纲要',
          price: 26
        }],
        seletedTotal: '0.00',
        allCheck: false,
        checkArray: []
      }, {
        id: '1',
        type: '专业课教材',
        books: [{
          name: '大学物理',
          price: 38
        }, {
          name: '材料力学',
          price: 42
        }, {
          name: '机械原理与设计',
          price: 55
        }, {
          name: 'AutoCAD机械制图',
          price: 55
        }],
        seletedTotal: '0.00',
        allCheck: false,
        checkArray: []
      }],
      isDelivery: false,
      address: '兴庆校区5#宿舍楼503'
    };
  },

  computed: {
    title: function title() {
      return this.$route.params.title;
    }
  },
  created: function created() {},
  mounted: function mounted() {
    this.setCheckArray();
  },
  updated: function updated() {},
  destroyed: function destroyed() {},

  watch: {},
  methods: {
    back: function back() {
      var _this = this;

      setTimeout(function () {
        _this.$router.back(-1);
      }, 300);
    },
    submit: function submit() {},
    selectAll: function selectAll(id) {
      this.bookList.forEach(function (element) {});
    },
    setCheckArray: function setCheckArray() {
      this.bookList.forEach(function (element) {
        element.books.forEach(function (sube) {
          element.checkArray.push(false);
        });
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/yingxin/tskjxy/views/items/books.vue









/* harmony default export */ var items_books = ({
  name: 'books',
  props: [],
  components: {
    XHeader: vux_src_components_x_header,
    CheckIcon: vux_src_components_check_icon,
    Group: vux_src_components_group,
    Cell: vux_src_components_cell,
    XButton: vux_src_components_x_button,
    XSwitch: vux_src_components_x_switch,
    'scroller': vuescroll_default.a
  },
  data: function data() {
    return {
      ops: {
        scrollPanel: {
          scrollingX: false
        },
        bar: {
          background: 'rgba(0, 107, 178, 0.3)',
          size: '3px',
          opacity: 0
        }
      },
      bookList: [{
        id: '0',
        type: '公共课教材',
        books: [{
          name: '高等数学Ⅰ',
          price: 30
        }, {
          name: '大学英语Ⅰ',
          price: 42
        }, {
          name: '中国近现代史纲要',
          price: 26
        }],
        seletedTotal: '0.00',
        allCheck: false,
        checkArray: []
      }, {
        id: '1',
        type: '专业课教材',
        books: [{
          name: '大学物理',
          price: 38
        }, {
          name: '材料力学',
          price: 42
        }, {
          name: '机械原理与设计',
          price: 55
        }, {
          name: 'AutoCAD机械制图',
          price: 55
        }],
        seletedTotal: '0.00',
        allCheck: false,
        checkArray: []
      }],
      isDelivery: false,
      address: '兴庆校区5#宿舍楼503'
    };
  },

  computed: {
    title: function title() {
      return this.$route.params.title;
    }
  },
  created: function created() {},
  mounted: function mounted() {
    this.setCheckArray();
  },
  updated: function updated() {},
  destroyed: function destroyed() {},

  watch: {},
  methods: {
    back: function back() {
      var _this = this;

      setTimeout(function () {
        _this.$router.back(-1);
      }, 300);
    },
    submit: function submit() {},
    selectAll: function selectAll(id) {
      this.bookList.forEach(function (element) {});
    },
    setCheckArray: function setCheckArray() {
      this.bookList.forEach(function (element) {
        element.books.forEach(function (sube) {
          element.checkArray.push(false);
        });
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-571fadc1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/yingxin/tskjxy/views/items/books.vue
var books_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('x-header',{staticClass:"header bg-white box-shadow"},[_c('em',{staticClass:"icon icon-arrow-left",attrs:{"slot":"overwrite-left","size":""},on:{"click":_vm.back},slot:"overwrite-left"}),_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"scroller-wrapper"},[_c('scroller',{attrs:{"ops":_vm.ops}},[_c('section',{staticClass:"section"},[_c('div',{staticClass:"container"},_vm._l((_vm.bookList),function(item,index){return _c('div',{key:index,staticClass:"card books-card"},[_c('div',{staticClass:"card-header border-bottom"},[_c('h4',{staticClass:"title"},[_vm._v(_vm._s(item.type))]),_c('div',{staticClass:"checkbox float-right",on:{"click":function($event){return _vm.selectAll(item.id)}}},[_c('check-icon',{attrs:{"value":item.allCheck},on:{"update:value":function($event){return _vm.$set(item, "allCheck", $event)}}})],1),_c('span',{staticClass:"total"},[_vm._v("总计: ￥"+_vm._s(item.seletedTotal))])]),_c('div',{staticClass:"card-body"},[_c('group',_vm._l((item.books),function(subItem,j){return _c('cell',{key:j,attrs:{"title":subItem.name}},[_c('span',[_vm._v("￥"+_vm._s(subItem.price.toFixed(2)))]),_c('div',{staticClass:"checkbox float-right"},[_c('check-icon',{attrs:{"value":item.checkArray[j]},on:{"update:value":function($event){return _vm.$set(item.checkArray, j, $event)}}})],1)])}),1)],1)])}),0)]),_c('section',{staticClass:"section"},[_c('group',[_c('x-switch',{attrs:{"title":"是否配送"},model:{value:(_vm.isDelivery),callback:function ($$v) {_vm.isDelivery=$$v},expression:"isDelivery"}}),(_vm.isDelivery)?_c('span',{staticClass:"books-address"},[_vm._v(_vm._s(_vm.address))]):_vm._e()],1)],1)])],1),_c('div',{staticClass:"button-group fixed bottom container"},[_c('x-button',{attrs:{"type":"brand"},nativeOn:{"click":function($event){return _vm.submit($event)}}},[_vm._v("提交")])],1),_c('transition',{attrs:{"name":"slide","enter-active-class":"animated fastest slideInUp","leave-active-class":"animated fastest slideOutDown"}},[_c('router-view')],1)],1)}
var books_staticRenderFns = []
var books_esExports = { render: books_render, staticRenderFns: books_staticRenderFns }
/* harmony default export */ var views_items_books = (books_esExports);
// CONCATENATED MODULE: ./src/yingxin/tskjxy/views/items/books.vue
function books_injectStyle (ssrContext) {
  __webpack_require__("sgDB")
}
var books_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var books___vue_template_functional__ = false
/* styles */
var books___vue_styles__ = books_injectStyle
/* scopeId */
var books___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var books___vue_module_identifier__ = null
var books_Component = books_normalizeComponent(
  items_books,
  views_items_books,
  books___vue_template_functional__,
  books___vue_styles__,
  books___vue_scopeId__,
  books___vue_module_identifier__
)

/* harmony default export */ var tskjxy_views_items_books = (books_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/yingxin/tskjxy/views/items/alumnus.vue










/* harmony default export */ var alumnus = ({
  name: 'user',
  props: [],
  directives: {
    TransferDom: transfer_dom["a" /* default */]
  },
  components: {
    XHeader: vux_src_components_x_header,
    Group: vux_src_components_group,
    XInput: vux_src_components_x_input,
    XButton: vux_src_components_x_button,
    Confirm: node_modules_vux_src_components_confirm
  },
  data: function data() {
    return {
      status: 0,
      isEdit: this.$route.params.isEdit,
      isShow: false,
      title: this.$route.meta.title,
      alumnusList: [{
        id: 0,
        label: '手机',
        placeholder: '请填写您的手机',
        type: 'tel',
        isType: 'china-mobile',
        value: ''
      }, {
        id: 1,
        label: '邮箱',
        placeholder: '请填写您的邮箱',
        type: 'email',
        isType: 'email',
        value: ''
      }, {
        id: 2,
        label: 'QQ',
        placeholder: '请填写您的QQ',
        type: 'number',
        isType: '',
        value: ''
      }, {
        id: 3,
        label: '微信号',
        placeholder: '请填写您的微信号',
        type: 'number',
        isType: '',
        value: ''
      }],
      resultMsg: {}
    };
  },

  computed: extends_default()({}, Object(vuex_esm["c" /* mapState */])({
    studentId: function studentId(state) {
      return state.userInfo.id;
    },
    flowId: function flowId(state) {
      return state.flowInfo.flowId;
    },
    flowProcedureId: function flowProcedureId(state) {
      return state.currentProcedureInfo.flowProcedureId;
    },
    procedureId: function procedureId(state) {
      return state.currentProcedureInfo.procedureId;
    }
  })),
  created: function created() {},
  mounted: function mounted() {

    this.getProcedureStatus();
  },

  methods: {
    back: function back() {
      var _this = this;

      if (this.isEdit) {
        this.isShow = true;
      } else {
        setTimeout(function () {
          _this.$router.back(-1);
        }, 300);
      }
    },
    save: function save() {
      var _this2 = this;

      var errorLength = document.getElementsByClassName('weui-cell weui-cell_warn').length;
      var flag = void 0;
      this.alumnusList.forEach(function (element) {
        if (element.value !== '') {
          flag = true;
        } else {
          flag = false;
        }
      });
      if (flag && errorLength === 0) {
        var params = {
          id: this.studentId,
          flowId: this.flowId,
          flowProcedureId: this.flowProcedureId,
          procedureId: this.procedureId,
          phoneNumber: this.alumnusList[0].value,
          email: this.alumnusList[1].value,
          qq: this.alumnusList[2].value,
          wechat: this.alumnusList[3].value
        };
        this.$api.post('/studentInfo', params, function (r) {
          setTimeout(function () {
            _this2.$router.push({
              name: 'itemResult',
              params: {
                title: _this2.title
              }
            });
          }, 300);
        }, function (err) {
          _this2.$vux.toast.text(err.message, 'top');
        });
      } else {
        this.$vux.toast.text('请填写正确的信息', 'middle');
      }
    },
    getProcedureStatus: function getProcedureStatus() {
      var _this3 = this;

      var params = {
        studentId: this.studentId,
        flowId: this.flowId,
        procedureId: this.procedureId,
        flowProcedureId: this.flowProcedureId
      };
      this.$api.get('/dataManagement/getDataManagementList', params, function (r) {
        _this3.$vux.loading.hide();
        var data = r.data[0];
        _this3.status = data.status;
        if (_this3.status === 4 && _this3.isEdit === false) {
          _this3.$router.push({
            name: 'itemResult',
            params: {
              title: _this3.title
            }
          });
        }
      }, function (err) {
        _this3.$vux.toast.text(err.message, 'top');
      });
    },
    onCancel: function onCancel() {
      this.isShow = false;
    },
    onConfirm: function onConfirm() {
      var _this4 = this;

      this.isShow = false;
      setTimeout(function () {
        _this4.$router.back(-1);
      }, 300);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/yingxin/tskjxy/views/items/alumnus.vue










/* harmony default export */ var items_alumnus = ({
  name: 'user',
  props: [],
  directives: {
    TransferDom: transfer_dom["a" /* default */]
  },
  components: {
    XHeader: vux_src_components_x_header,
    Group: vux_src_components_group,
    XInput: vux_src_components_x_input,
    XButton: vux_src_components_x_button,
    Confirm: node_modules_vux_src_components_confirm
  },
  data: function data() {
    return {
      status: 0,
      isEdit: this.$route.params.isEdit,
      isShow: false,
      title: this.$route.meta.title,
      alumnusList: [{
        id: 0,
        label: '手机',
        placeholder: '请填写您的手机',
        type: 'tel',
        isType: 'china-mobile',
        value: ''
      }, {
        id: 1,
        label: '邮箱',
        placeholder: '请填写您的邮箱',
        type: 'email',
        isType: 'email',
        value: ''
      }, {
        id: 2,
        label: 'QQ',
        placeholder: '请填写您的QQ',
        type: 'number',
        isType: '',
        value: ''
      }, {
        id: 3,
        label: '微信号',
        placeholder: '请填写您的微信号',
        type: 'number',
        isType: '',
        value: ''
      }],
      resultMsg: {}
    };
  },

  computed: extends_default()({}, Object(vuex_esm["c" /* mapState */])({
    studentId: function studentId(state) {
      return state.userInfo.id;
    },
    flowId: function flowId(state) {
      return state.flowInfo.flowId;
    },
    flowProcedureId: function flowProcedureId(state) {
      return state.currentProcedureInfo.flowProcedureId;
    },
    procedureId: function procedureId(state) {
      return state.currentProcedureInfo.procedureId;
    }
  })),
  created: function created() {},
  mounted: function mounted() {

    this.getProcedureStatus();
  },

  methods: {
    back: function back() {
      var _this = this;

      if (this.isEdit) {
        this.isShow = true;
      } else {
        setTimeout(function () {
          _this.$router.back(-1);
        }, 300);
      }
    },
    save: function save() {
      var _this2 = this;

      var errorLength = document.getElementsByClassName('weui-cell weui-cell_warn').length;
      var flag = void 0;
      this.alumnusList.forEach(function (element) {
        if (element.value !== '') {
          flag = true;
        } else {
          flag = false;
        }
      });
      if (flag && errorLength === 0) {
        var params = {
          id: this.studentId,
          flowId: this.flowId,
          flowProcedureId: this.flowProcedureId,
          procedureId: this.procedureId,
          phoneNumber: this.alumnusList[0].value,
          email: this.alumnusList[1].value,
          qq: this.alumnusList[2].value,
          wechat: this.alumnusList[3].value
        };
        this.$api.post('/studentInfo', params, function (r) {
          setTimeout(function () {
            _this2.$router.push({
              name: 'itemResult',
              params: {
                title: _this2.title
              }
            });
          }, 300);
        }, function (err) {
          _this2.$vux.toast.text(err.message, 'top');
        });
      } else {
        this.$vux.toast.text('请填写正确的信息', 'middle');
      }
    },
    getProcedureStatus: function getProcedureStatus() {
      var _this3 = this;

      var params = {
        studentId: this.studentId,
        flowId: this.flowId,
        procedureId: this.procedureId,
        flowProcedureId: this.flowProcedureId
      };
      this.$api.get('/dataManagement/getDataManagementList', params, function (r) {
        _this3.$vux.loading.hide();
        var data = r.data[0];
        _this3.status = data.status;
        if (_this3.status === 4 && _this3.isEdit === false) {
          _this3.$router.push({
            name: 'itemResult',
            params: {
              title: _this3.title
            }
          });
        }
      }, function (err) {
        _this3.$vux.toast.text(err.message, 'top');
      });
    },
    onCancel: function onCancel() {
      this.isShow = false;
    },
    onConfirm: function onConfirm() {
      var _this4 = this;

      this.isShow = false;
      setTimeout(function () {
        _this4.$router.back(-1);
      }, 300);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-24a13b06","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/yingxin/tskjxy/views/items/alumnus.vue
var alumnus_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sub-page"},[_c('x-header',{staticClass:"header bg-white fixed"},[_c('em',{staticClass:"icon icon-arrow-left",attrs:{"slot":"overwrite-left","size":""},on:{"click":_vm.back},slot:"overwrite-left"}),_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"fixed-next input-right section"},[_c('group',{attrs:{"title":""}},_vm._l((_vm.alumnusList),function(item,index){return _c('x-input',{key:index,attrs:{"label-width":"4em","title":item.label,"type":item.type,"is-type":item.isType,"placeholder":item.placeholder},model:{value:(item.value),callback:function ($$v) {_vm.$set(item, "value", $$v)},expression:"item.value"}})}),1)],1),_c('div',{staticClass:"button-group fixed bottom container"},[_c('x-button',{attrs:{"type":"brand"},nativeOn:{"click":function($event){return _vm.save($event)}}},[_vm._v("保存")])],1),_c('div',{directives:[{name:"transfer-dom",rawName:"v-transfer-dom"}]},[_c('confirm',{on:{"on-cancel":_vm.onCancel,"on-confirm":_vm.onConfirm},model:{value:(_vm.isShow),callback:function ($$v) {_vm.isShow=$$v},expression:"isShow"}},[_c('p',{staticStyle:{"text-align":"center"}},[_vm._v("是否放弃此次编辑？")])])],1)],1)}
var alumnus_staticRenderFns = []
var alumnus_esExports = { render: alumnus_render, staticRenderFns: alumnus_staticRenderFns }
/* harmony default export */ var views_items_alumnus = (alumnus_esExports);
// CONCATENATED MODULE: ./src/yingxin/tskjxy/views/items/alumnus.vue
var alumnus_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var alumnus___vue_template_functional__ = false
/* styles */
var alumnus___vue_styles__ = null
/* scopeId */
var alumnus___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var alumnus___vue_module_identifier__ = null
var alumnus_Component = alumnus_normalizeComponent(
  items_alumnus,
  views_items_alumnus,
  alumnus___vue_template_functional__,
  alumnus___vue_styles__,
  alumnus___vue_scopeId__,
  alumnus___vue_module_identifier__
)

/* harmony default export */ var tskjxy_views_items_alumnus = (alumnus_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/yingxin/tskjxy/views/items/itemResult.vue













/* harmony default export */ var itemResult = ({
  name: 'info',
  props: [],
  components: {
    XHeader: vux_src_components_x_header,
    Result: src_components_result,
    XButton: vux_src_components_x_button,
    Flexbox: flexbox_flexbox["a" /* default */],
    FlexboxItem: flexbox_item["a" /* default */],
    Confirm: node_modules_vux_src_components_confirm
  },
  directives: {
    TransferDom: transfer_dom["a" /* default */]
  },
  data: function data() {
    return {
      resultMsg: {
        state: 0,
        successMsg: '预约成功，请按时体检',
        errorMsg: '预约失败，稍后请重新预约',
        successBtn: [],
        errorBtn: '',
        infoTitle: '预约信息',
        infoList: [],
        confirmShow: {
          state: false,
          content: '',
          type: ''
        }
      },
      confirmInfo: {
        show: false,
        content: '',
        type: ''
      },
      handle: '',
      id: '',
      status: '',
      isShow: true,
      pdfSrc: '',
      btns: {
        btnRepeal: false,
        btnEdit: false,
        btnReapply: false
      },
      currentDate: '',
      medicalNotPay: false,
      medicalNotPayMessage: ''
    };
  },

  computed: extends_default()({}, Object(vuex_esm["c" /* mapState */])({
    userInfo: function userInfo(state) {
      return state.userInfo;
    },
    studentId: function studentId(state) {
      return state.userInfo.id;
    },
    currentProcedureInfo: function currentProcedureInfo(state) {
      return state.currentProcedureInfo;
    },
    router: function router(state) {
      return state.currentProcedureInfo.router;
    },
    title: function title(state) {
      return state.currentProcedureInfo.name;
    },
    flowId: function flowId(state) {
      return state.flowInfo.flowId;
    },
    procedureId: function procedureId(state) {
      return state.currentProcedureInfo.procedureId;
    },
    flowProcedureId: function flowProcedureId(state) {
      return state.currentProcedureInfo.flowProcedureId;
    },
    flowYear: function flowYear(state) {
      return state.flowInfo.flowYear;
    },
    parentRouter: function parentRouter(state) {
      return state.currentProcedureInfo.parentRouter;
    }
  })),
  created: function created() {},
  mounted: function mounted() {
    this.getProcedureInfo();
    this.getCurrentDate();
  },
  updated: function updated() {},
  destroyed: function destroyed() {},

  watch: {},
  methods: {
    back: function back() {
      var _this = this;

      setTimeout(function () {

        _this.$router.push({
          name: _this.parentRouter
        });
      }, 300);
    },
    finish: function finish() {
      var _this2 = this;

      setTimeout(function () {
        _this2.$router.push({
          name: _this2.parentRouter
        });
      }, 300);
    },
    onConfirm: function onConfirm(info) {
      var _this3 = this;

      setTimeout(function () {
        setTimeout(function () {
          _this3.$router.push({
            name: _this3.currentProcedureInfo.router,
            params: {
              isEdit: info.isEdit
            }
          });
        }, 300);
        _this3.$vux.toast.text(info.msg, 'middle');
      }, 300);
    },
    onCancel: function onCancel() {
      this.confirmShow = false;
    },
    getCurrentDate: function getCurrentDate() {
      var _this4 = this;

      return new promise_default.a(function (resolve, reject) {
        _this4.$api.get('/helper/systemDateTime', null, function (r) {
          _this4.currentDate = r.data;
          if (DatetimeStamp(_this4.currentProcedureInfo.endDate + ' 23:59:59') < DatetimeStamp(_this4.currentDate)) {
            _this4.isShow = false;
          }
          resolve();
        }, function (err) {
          _this4.$vux.toast.text(err.message, 'middle');
        });
      });
    },
    getProcedureInfo: function getProcedureInfo() {
      this.resultMsg.infoTitle = this.currentProcedureInfo.name;
      switch (this.currentProcedureInfo.router) {
        case 'alumnus':
          this.resultMsg.successMsg = '校友部信息提交成功';
          this.btns.btnEdit = true;
          this.getAlumnus();
          break;
        case 'car':
          this.resultMsg.successMsg = '接站预定提交成功';
          this.btns.btnRepeal = true;

          this.getCar();
          break;
        case 'loan':
          this.resultMsg.successMsg = '';
          this.getLoan();
          break;
        case 'medical':
          this.resultMsg.successMsg = '体检预约提交成功';
          this.getMedical();
          break;
        case 'clothes':
          this.resultMsg.successMsg = '军训服装尺码提交成功';
          this.btns.btnRepeal = true;

          this.getClothes();
          break;
      }
    },
    revocation: function revocation(router) {
      this.handle = 'revocation';
      this.confirmInfo.show = true;
      this.confirmInfo.content = '确定撤销？';
    },
    edit: function edit(router) {
      this.handle = 'edit';
      this.confirmInfo.show = true;
      this.confirmInfo.content = '确定重新编辑？';
    },
    reapply: function reapply(router) {
      this.handle = 'reapply';
      this.confirmInfo.show = true;
      this.confirmInfo.content = '确定重新申请？';
    },
    onConfirmModal: function onConfirmModal(handle) {
      var _this5 = this;

      if (handle === 'edit') {
        setTimeout(function () {
          _this5.$router.push({
            name: _this5.router,
            params: {
              isEdit: true
            }
          });
        }, 300);
      } else if (handle === 'reapply') {
        setTimeout(function () {
          _this5.$router.push({
            name: _this5.router,
            params: {
              isEdit: true
            }
          });
        }, 300);
      } else if (handle === 'revocation') {
        switch (this.currentProcedureInfo.router) {
          case 'alumnus':
            break;
          case 'car':
            this.revocationCar();
            break;
          case 'loan':
            this.revocationLoan();
            break;
          case 'medical':
            this.revocationMedical();
            break;
          case 'clothes':
            this.revocationClothes();
        }
      }
    },
    getAlumnus: function getAlumnus() {
      var _this6 = this;

      this.$vux.loading.show();
      var params = {
        account: this.userInfo.account
      };
      this.$api.get('/student', params, function (r) {
        _this6.$vux.loading.hide();
        var data = r.data[0];
        _this6.resultMsg.infoList = [{
          label: '手机',
          value: data.phoneNumber
        }, {
          label: '邮箱',
          value: data.email
        }, {
          label: 'QQ',
          value: data.qq
        }, {
          label: '微信号',
          value: data.wechat
        }];
      }, function (err) {
        _this6.$vux.toast.text(err.message, 'top');
      });
    },
    getCar: function getCar() {
      var _this7 = this;

      this.$vux.loading.show();
      var params = {
        'studentId': this.studentId
      };
      this.$api.get('/wayToSchool', params, function (r) {
        _this7.$vux.loading.hide();
        var data = r.data[0];
        _this7.id = data.id;
        var station = '';
        switch (data.transportation) {
          case '1':
            station = '飞机';
            break;
          case '2':
            station = '火车';
            break;
          case '3':
            station = '汽车';
            break;
          case '4':
            station = '其他';
            break;
        }
        _this7.resultMsg.infoList = [{
          label: '交通工具',
          value: station
        }, {
          label: '预期出发时间',
          value: data.departureDatetime
        }, {
          label: '预期到达时间',
          value: data.arriveDatetime
        }, {
          label: '是否接站',
          value: data.isPicked === 1 ? '接站' : '不接站'
        }, {
          label: '接站人数',
          value: data.arriveNumber
        }, {
          label: '是否请假',
          value: data.isOntime === 2 ? '请假' : '按时'
        }];
        if (r.data[0].transportation !== '4') {
          _this7.resultMsg.infoList.splice(1, 0, {
            label: '到达站点',
            value: data.arriveStation
          });
        }
      }, function (err) {
        _this7.$vux.toast.text(err.message, 'top');
      });
    },
    revocationCar: function revocationCar() {
      var _this8 = this;

      var params = {
        'id': this.id
      };
      this.$api.post('/wayToSchool/backout', params, function (r) {
        _this8.$vux.toast.text('撤销成功', 'top');
        setTimeout(function () {
          _this8.$router.push({
            name: _this8.router
          });
        }, 300);
      }, function (err) {
        _this8.$vux.toast.text(err.message, 'top');
      });
    },
    getLoan: function getLoan() {
      var _this9 = this;

      this.$vux.loading.show();
      var params = {
        'studentId': this.studentId,
        'flowId': this.flowId,
        'procedureId': this.procedureId
      };
      this.$api.get('/greenChannel', params, function (r) {
        _this9.$vux.loading.hide();
        var data = r.data;
        if (data.status === 1) {
          _this9.resultMsg.successMsg = '已提交成功，审核中...';
          _this9.btns.btnRepeal = true;
        } else if (data.status === 3) {
          _this9.resultMsg.state = 1;
          _this9.resultMsg.errorMsg = '审核未通过';
          _this9.btns.btnReapply = true;
        } else if (data.status === 4) {
          _this9.resultMsg.successMsg = '审核通过';
          _this9.btns.btnRepeal = true;
        } else if (data.status === 6) {
          _this9.resultMsg.successMsg = '审核已通过,暂未生效';
        }
        _this9.status = data.status;
        _this9.id = data.id;
        _this9.resultMsg.infoList = [{
          label: '申请原因',
          value: data.remark
        }];
        if (data.status === 4) {
          _this9.resultMsg.infoList.splice(2, 0, {
            label: '审批金额',
            value: data.checkMoney + '元'
          });
        }
      }, function (err) {
        _this9.$vux.toast.text(err.message, 'top');
      });
    },
    revocationLoan: function revocationLoan() {
      var _this10 = this;

      var status = 5;
      if (this.status === 1) {
        status = 2;
      }
      var params = {
        'id': this.id,
        'studentId': this.studentId,
        'flowId': this.flowId,
        'flowProcedureId': this.flowProcedureId,
        'procedureId': this.procedureId,
        'status': status,
        'greenchanneltypeId': 1,
        'applyMoney': 0,
        'handdlerType': 0
      };
      this.$api.post('/sdtskjxy/greenChannel/handle', params, function (r) {
        setTimeout(function () {
          _this10.$router.push({ name: _this10.router });
        }, 300);
      }, function (err) {
        _this10.$vux.toast.text(err.message, 'top');
      });
    },
    getMedical: function getMedical() {
      var _this11 = this;

      this.$vux.loading.show();
      var params = {
        'studentId': this.studentId,
        'flowId': this.flowId,
        'procedureId': this.procedureId
      };
      this.$api.get('/bodyExamOrder', params, function (r) {
        _this11.$vux.loading.hide();
        var data = r.data;
        _this11.id = r.data[0].id;

        _this11.resultMsg.infoList = [{
          label: '体检日期',
          value: data[0].preiod
        }];
      }, function (err) {
        _this11.$vux.toast.text(err.message, 'top');
      });
    },
    revocationMedical: function revocationMedical() {
      var _this12 = this;

      var params = {
        id: this.id,
        flowId: this.flowId,
        flowProcedureId: this.flowProcedureId,
        procedureId: this.procedureId,
        studentId: this.studentId,
        status: 5
      };
      this.$api.post('/bodyExamOrder/handle', params, function (r) {
        _this12.$vux.loading.show({
          text: '正在撤销...'
        });
        setTimeout(function () {
          _this12.$vux.loading.hide();
          _this12.$vux.toast.text('撤销成功，请重新预约', 'top');
          _this12.$router.push({
            name: 'medical'
          });
        }, 5000);
      }, function (err) {
        _this12.$vux.toast.text(err.message, 'top');
      });
    },
    getMedicalPDF: function getMedicalPDF() {
      var _this13 = this;

      this.$vux.loading.show();
      var params = {
        'id': this.id,
        'studentId': this.studentId
      };
      this.$api.get('/bodyExamOrder/createMedicalChecklist', params, function (r) {
        _this13.$vux.loading.hide();
        _this13.pdfSrc = r.data;
        _this13.medicalNotPay = false;
      }, function (err) {
        _this13.medicalNotPay = true;
        _this13.medicalNotPayMessage = err.message;
      });
    },
    checkMedicalPdf: function checkMedicalPdf() {
      this.$vux.alert.show({
        title: this.medicalNotPayMessage,
        buttonText: '我知道了'
      });
    },
    getClothes: function getClothes() {
      var _this14 = this;

      this.$vux.loading.show();
      var params = {
        'studentId': this.studentId,
        'flowId': this.flowId,
        'procedureId': this.procedureId
      };
      this.$api.get('/clothingSize', params, function (r) {
        _this14.$vux.loading.hide();
        var data = r.data;
        if (data.length > 0) {
          _this14.id = data[0].id;
          _this14.resultMsg.infoList = [{
            label: '服装尺码',
            value: data[0].sizeClothing
          }, {
            label: '帽子尺码',
            value: data[0].sizeHat
          }, {
            label: '鞋码',
            value: data[0].sizeShoe
          }, {
            label: '提交时间',
            value: data[0].datetime
          }];
        }
      }, function (err) {
        _this14.$vux.toast.text(err.message, 'top');
      });
    },
    revocationClothes: function revocationClothes() {
      var _this15 = this;

      var params = {
        id: this.id
      };

      this.$api.delete('/clothingSize', params, function (r) {
        _this15.$vux.loading.show({
          text: '加载中,请稍后'
        });

        setTimeout(function () {
          _this15.$vux.loading.hide();
          _this15.$vux.toast.text('撤销成功', 'top');
          _this15.$router.push({
            name: _this15.router
          });
        }, 300);
      }, function (err) {
        _this15.$vux.toast.text(err.message, 'top');
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/yingxin/tskjxy/views/items/itemResult.vue













/* harmony default export */ var items_itemResult = ({
  name: 'info',
  props: [],
  components: {
    XHeader: vux_src_components_x_header,
    Result: src_components_result,
    XButton: vux_src_components_x_button,
    Flexbox: flexbox_flexbox["a" /* default */],
    FlexboxItem: flexbox_item["a" /* default */],
    Confirm: node_modules_vux_src_components_confirm
  },
  directives: {
    TransferDom: transfer_dom["a" /* default */]
  },
  data: function data() {
    return {
      resultMsg: {
        state: 0,
        successMsg: '预约成功，请按时体检',
        errorMsg: '预约失败，稍后请重新预约',
        successBtn: [],
        errorBtn: '',
        infoTitle: '预约信息',
        infoList: [],
        confirmShow: {
          state: false,
          content: '',
          type: ''
        }
      },
      confirmInfo: {
        show: false,
        content: '',
        type: ''
      },
      handle: '',
      id: '',
      status: '',
      isShow: true,
      pdfSrc: '',
      btns: {
        btnRepeal: false,
        btnEdit: false,
        btnReapply: false
      },
      currentDate: '',
      medicalNotPay: false,
      medicalNotPayMessage: ''
    };
  },

  computed: extends_default()({}, Object(vuex_esm["c" /* mapState */])({
    userInfo: function userInfo(state) {
      return state.userInfo;
    },
    studentId: function studentId(state) {
      return state.userInfo.id;
    },
    currentProcedureInfo: function currentProcedureInfo(state) {
      return state.currentProcedureInfo;
    },
    router: function router(state) {
      return state.currentProcedureInfo.router;
    },
    title: function title(state) {
      return state.currentProcedureInfo.name;
    },
    flowId: function flowId(state) {
      return state.flowInfo.flowId;
    },
    procedureId: function procedureId(state) {
      return state.currentProcedureInfo.procedureId;
    },
    flowProcedureId: function flowProcedureId(state) {
      return state.currentProcedureInfo.flowProcedureId;
    },
    flowYear: function flowYear(state) {
      return state.flowInfo.flowYear;
    },
    parentRouter: function parentRouter(state) {
      return state.currentProcedureInfo.parentRouter;
    }
  })),
  created: function created() {},
  mounted: function mounted() {
    this.getProcedureInfo();
    this.getCurrentDate();
  },
  updated: function updated() {},
  destroyed: function destroyed() {},

  watch: {},
  methods: {
    back: function back() {
      var _this = this;

      setTimeout(function () {

        _this.$router.push({
          name: _this.parentRouter
        });
      }, 300);
    },
    finish: function finish() {
      var _this2 = this;

      setTimeout(function () {
        _this2.$router.push({
          name: _this2.parentRouter
        });
      }, 300);
    },
    onConfirm: function onConfirm(info) {
      var _this3 = this;

      setTimeout(function () {
        setTimeout(function () {
          _this3.$router.push({
            name: _this3.currentProcedureInfo.router,
            params: {
              isEdit: info.isEdit
            }
          });
        }, 300);
        _this3.$vux.toast.text(info.msg, 'middle');
      }, 300);
    },
    onCancel: function onCancel() {
      this.confirmShow = false;
    },
    getCurrentDate: function getCurrentDate() {
      var _this4 = this;

      return new promise_default.a(function (resolve, reject) {
        _this4.$api.get('/helper/systemDateTime', null, function (r) {
          _this4.currentDate = r.data;
          if (DatetimeStamp(_this4.currentProcedureInfo.endDate + ' 23:59:59') < DatetimeStamp(_this4.currentDate)) {
            _this4.isShow = false;
          }
          resolve();
        }, function (err) {
          _this4.$vux.toast.text(err.message, 'middle');
        });
      });
    },
    getProcedureInfo: function getProcedureInfo() {
      this.resultMsg.infoTitle = this.currentProcedureInfo.name;
      switch (this.currentProcedureInfo.router) {
        case 'alumnus':
          this.resultMsg.successMsg = '校友部信息提交成功';
          this.btns.btnEdit = true;
          this.getAlumnus();
          break;
        case 'car':
          this.resultMsg.successMsg = '接站预定提交成功';
          this.btns.btnRepeal = true;

          this.getCar();
          break;
        case 'loan':
          this.resultMsg.successMsg = '';
          this.getLoan();
          break;
        case 'medical':
          this.resultMsg.successMsg = '体检预约提交成功';
          this.getMedical();
          break;
        case 'clothes':
          this.resultMsg.successMsg = '军训服装尺码提交成功';
          this.btns.btnRepeal = true;

          this.getClothes();
          break;
      }
    },
    revocation: function revocation(router) {
      this.handle = 'revocation';
      this.confirmInfo.show = true;
      this.confirmInfo.content = '确定撤销？';
    },
    edit: function edit(router) {
      this.handle = 'edit';
      this.confirmInfo.show = true;
      this.confirmInfo.content = '确定重新编辑？';
    },
    reapply: function reapply(router) {
      this.handle = 'reapply';
      this.confirmInfo.show = true;
      this.confirmInfo.content = '确定重新申请？';
    },
    onConfirmModal: function onConfirmModal(handle) {
      var _this5 = this;

      if (handle === 'edit') {
        setTimeout(function () {
          _this5.$router.push({
            name: _this5.router,
            params: {
              isEdit: true
            }
          });
        }, 300);
      } else if (handle === 'reapply') {
        setTimeout(function () {
          _this5.$router.push({
            name: _this5.router,
            params: {
              isEdit: true
            }
          });
        }, 300);
      } else if (handle === 'revocation') {
        switch (this.currentProcedureInfo.router) {
          case 'alumnus':
            break;
          case 'car':
            this.revocationCar();
            break;
          case 'loan':
            this.revocationLoan();
            break;
          case 'medical':
            this.revocationMedical();
            break;
          case 'clothes':
            this.revocationClothes();
        }
      }
    },
    getAlumnus: function getAlumnus() {
      var _this6 = this;

      this.$vux.loading.show();
      var params = {
        account: this.userInfo.account
      };
      this.$api.get('/student', params, function (r) {
        _this6.$vux.loading.hide();
        var data = r.data[0];
        _this6.resultMsg.infoList = [{
          label: '手机',
          value: data.phoneNumber
        }, {
          label: '邮箱',
          value: data.email
        }, {
          label: 'QQ',
          value: data.qq
        }, {
          label: '微信号',
          value: data.wechat
        }];
      }, function (err) {
        _this6.$vux.toast.text(err.message, 'top');
      });
    },
    getCar: function getCar() {
      var _this7 = this;

      this.$vux.loading.show();
      var params = {
        'studentId': this.studentId
      };
      this.$api.get('/wayToSchool', params, function (r) {
        _this7.$vux.loading.hide();
        var data = r.data[0];
        _this7.id = data.id;
        var station = '';
        switch (data.transportation) {
          case '1':
            station = '飞机';
            break;
          case '2':
            station = '火车';
            break;
          case '3':
            station = '汽车';
            break;
          case '4':
            station = '其他';
            break;
        }
        _this7.resultMsg.infoList = [{
          label: '交通工具',
          value: station
        }, {
          label: '预期出发时间',
          value: data.departureDatetime
        }, {
          label: '预期到达时间',
          value: data.arriveDatetime
        }, {
          label: '是否接站',
          value: data.isPicked === 1 ? '接站' : '不接站'
        }, {
          label: '接站人数',
          value: data.arriveNumber
        }, {
          label: '是否请假',
          value: data.isOntime === 2 ? '请假' : '按时'
        }];
        if (r.data[0].transportation !== '4') {
          _this7.resultMsg.infoList.splice(1, 0, {
            label: '到达站点',
            value: data.arriveStation
          });
        }
      }, function (err) {
        _this7.$vux.toast.text(err.message, 'top');
      });
    },
    revocationCar: function revocationCar() {
      var _this8 = this;

      var params = {
        'id': this.id
      };
      this.$api.post('/wayToSchool/backout', params, function (r) {
        _this8.$vux.toast.text('撤销成功', 'top');
        setTimeout(function () {
          _this8.$router.push({
            name: _this8.router
          });
        }, 300);
      }, function (err) {
        _this8.$vux.toast.text(err.message, 'top');
      });
    },
    getLoan: function getLoan() {
      var _this9 = this;

      this.$vux.loading.show();
      var params = {
        'studentId': this.studentId,
        'flowId': this.flowId,
        'procedureId': this.procedureId
      };
      this.$api.get('/greenChannel', params, function (r) {
        _this9.$vux.loading.hide();
        var data = r.data;
        if (data.status === 1) {
          _this9.resultMsg.successMsg = '已提交成功，审核中...';
          _this9.btns.btnRepeal = true;
        } else if (data.status === 3) {
          _this9.resultMsg.state = 1;
          _this9.resultMsg.errorMsg = '审核未通过';
          _this9.btns.btnReapply = true;
        } else if (data.status === 4) {
          _this9.resultMsg.successMsg = '审核通过';
          _this9.btns.btnRepeal = true;
        } else if (data.status === 6) {
          _this9.resultMsg.successMsg = '审核已通过,暂未生效';
        }
        _this9.status = data.status;
        _this9.id = data.id;
        _this9.resultMsg.infoList = [{
          label: '申请原因',
          value: data.remark
        }];
        if (data.status === 4) {
          _this9.resultMsg.infoList.splice(2, 0, {
            label: '审批金额',
            value: data.checkMoney + '元'
          });
        }
      }, function (err) {
        _this9.$vux.toast.text(err.message, 'top');
      });
    },
    revocationLoan: function revocationLoan() {
      var _this10 = this;

      var status = 5;
      if (this.status === 1) {
        status = 2;
      }
      var params = {
        'id': this.id,
        'studentId': this.studentId,
        'flowId': this.flowId,
        'flowProcedureId': this.flowProcedureId,
        'procedureId': this.procedureId,
        'status': status,
        'greenchanneltypeId': 1,
        'applyMoney': 0,
        'handdlerType': 0
      };
      this.$api.post('/sdtskjxy/greenChannel/handle', params, function (r) {
        setTimeout(function () {
          _this10.$router.push({ name: _this10.router });
        }, 300);
      }, function (err) {
        _this10.$vux.toast.text(err.message, 'top');
      });
    },
    getMedical: function getMedical() {
      var _this11 = this;

      this.$vux.loading.show();
      var params = {
        'studentId': this.studentId,
        'flowId': this.flowId,
        'procedureId': this.procedureId
      };
      this.$api.get('/bodyExamOrder', params, function (r) {
        _this11.$vux.loading.hide();
        var data = r.data;
        _this11.id = r.data[0].id;

        _this11.resultMsg.infoList = [{
          label: '体检日期',
          value: data[0].preiod
        }];
      }, function (err) {
        _this11.$vux.toast.text(err.message, 'top');
      });
    },
    revocationMedical: function revocationMedical() {
      var _this12 = this;

      var params = {
        id: this.id,
        flowId: this.flowId,
        flowProcedureId: this.flowProcedureId,
        procedureId: this.procedureId,
        studentId: this.studentId,
        status: 5
      };
      this.$api.post('/bodyExamOrder/handle', params, function (r) {
        _this12.$vux.loading.show({
          text: '正在撤销...'
        });
        setTimeout(function () {
          _this12.$vux.loading.hide();
          _this12.$vux.toast.text('撤销成功，请重新预约', 'top');
          _this12.$router.push({
            name: 'medical'
          });
        }, 5000);
      }, function (err) {
        _this12.$vux.toast.text(err.message, 'top');
      });
    },
    getMedicalPDF: function getMedicalPDF() {
      var _this13 = this;

      this.$vux.loading.show();
      var params = {
        'id': this.id,
        'studentId': this.studentId
      };
      this.$api.get('/bodyExamOrder/createMedicalChecklist', params, function (r) {
        _this13.$vux.loading.hide();
        _this13.pdfSrc = r.data;
        _this13.medicalNotPay = false;
      }, function (err) {
        _this13.medicalNotPay = true;
        _this13.medicalNotPayMessage = err.message;
      });
    },
    checkMedicalPdf: function checkMedicalPdf() {
      this.$vux.alert.show({
        title: this.medicalNotPayMessage,
        buttonText: '我知道了'
      });
    },
    getClothes: function getClothes() {
      var _this14 = this;

      this.$vux.loading.show();
      var params = {
        'studentId': this.studentId,
        'flowId': this.flowId,
        'procedureId': this.procedureId
      };
      this.$api.get('/clothingSize', params, function (r) {
        _this14.$vux.loading.hide();
        var data = r.data;
        if (data.length > 0) {
          _this14.id = data[0].id;
          _this14.resultMsg.infoList = [{
            label: '服装尺码',
            value: data[0].sizeClothing
          }, {
            label: '帽子尺码',
            value: data[0].sizeHat
          }, {
            label: '鞋码',
            value: data[0].sizeShoe
          }, {
            label: '提交时间',
            value: data[0].datetime
          }];
        }
      }, function (err) {
        _this14.$vux.toast.text(err.message, 'top');
      });
    },
    revocationClothes: function revocationClothes() {
      var _this15 = this;

      var params = {
        id: this.id
      };

      this.$api.delete('/clothingSize', params, function (r) {
        _this15.$vux.loading.show({
          text: '加载中,请稍后'
        });

        setTimeout(function () {
          _this15.$vux.loading.hide();
          _this15.$vux.toast.text('撤销成功', 'top');
          _this15.$router.push({
            name: _this15.router
          });
        }, 300);
      }, function (err) {
        _this15.$vux.toast.text(err.message, 'top');
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-62fbe558","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/yingxin/tskjxy/views/items/itemResult.vue
var itemResult_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sub-page",staticStyle:{"padding-bottom":"60px"}},[_c('x-header',{staticClass:"header bg-white box-shadow fixed"},[_c('em',{staticClass:"icon icon-arrow-left",attrs:{"slot":"overwrite-left","size":""},on:{"click":_vm.back},slot:"overwrite-left"}),_vm._v(_vm._s(_vm.title)+"详情")]),_c('section',{staticClass:"section fixed-next"},[_c('Result',{attrs:{"resultMsg":_vm.resultMsg}})],1),(_vm.isShow)?_c('div',{staticClass:"button-group fixed bottom container"},[_c('flexbox',[(_vm.btns.btnRepeal)?_c('flexbox-item',[_c('x-button',{attrs:{"type":"warn"},nativeOn:{"click":function($event){return _vm.revocation(_vm.router)}}},[_vm._v("撤销")])],1):_vm._e(),(_vm.btns.btnEdit)?_c('flexbox-item',[_c('x-button',{attrs:{"type":"brand"},nativeOn:{"click":function($event){return _vm.edit(_vm.router)}}},[_vm._v(" 编辑")])],1):_vm._e(),(_vm.btns.btnReapply)?_c('flexbox-item',[_c('x-button',{attrs:{"type":"primary"},nativeOn:{"click":function($event){return _vm.reapply(_vm.router)}}},[_vm._v(" 重新申请")])],1):_vm._e()],1)],1):_vm._e(),_c('div',{directives:[{name:"transfer-dom",rawName:"v-transfer-dom"}]},[_c('confirm',{attrs:{"title":"提示"},on:{"on-confirm":function($event){return _vm.onConfirmModal(_vm.handle)},"on-cancel":_vm.onCancel},model:{value:(_vm.confirmInfo.show),callback:function ($$v) {_vm.$set(_vm.confirmInfo, "show", $$v)},expression:"confirmInfo.show"}},[_c('p',{staticStyle:{"text-align":"center"}},[_vm._v(_vm._s(_vm.confirmInfo.content))])])],1)],1)}
var itemResult_staticRenderFns = []
var itemResult_esExports = { render: itemResult_render, staticRenderFns: itemResult_staticRenderFns }
/* harmony default export */ var views_items_itemResult = (itemResult_esExports);
// CONCATENATED MODULE: ./src/yingxin/tskjxy/views/items/itemResult.vue
var itemResult_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var itemResult___vue_template_functional__ = false
/* styles */
var itemResult___vue_styles__ = null
/* scopeId */
var itemResult___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var itemResult___vue_module_identifier__ = null
var itemResult_Component = itemResult_normalizeComponent(
  items_itemResult,
  views_items_itemResult,
  itemResult___vue_template_functional__,
  itemResult___vue_styles__,
  itemResult___vue_scopeId__,
  itemResult___vue_module_identifier__
)

/* harmony default export */ var tskjxy_views_items_itemResult = (itemResult_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/yingxin/tskjxy/views/items/default.vue



/* harmony default export */ var items_default = ({
  name: 'info',
  props: [],
  components: {
    XHeader: vux_src_components_x_header
  },
  data: function data() {
    return {};
  },

  computed: {
    title: function title() {
      return this.$route.params.title;
    }
  },
  created: function created() {},
  mounted: function mounted() {},
  updated: function updated() {},
  destroyed: function destroyed() {},

  watch: {},
  methods: {
    back: function back() {
      var _this = this;

      setTimeout(function () {
        _this.$router.back(-1);
      }, 300);
    },
    finish: function finish() {
      var _this2 = this;

      setTimeout(function () {
        _this2.$router.push({ name: 'home' });
      }, 300);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/yingxin/tskjxy/views/items/default.vue



/* harmony default export */ var views_items_default = ({
  name: 'info',
  props: [],
  components: {
    XHeader: vux_src_components_x_header
  },
  data: function data() {
    return {};
  },

  computed: {
    title: function title() {
      return this.$route.params.title;
    }
  },
  created: function created() {},
  mounted: function mounted() {},
  updated: function updated() {},
  destroyed: function destroyed() {},

  watch: {},
  methods: {
    back: function back() {
      var _this = this;

      setTimeout(function () {
        _this.$router.back(-1);
      }, 300);
    },
    finish: function finish() {
      var _this2 = this;

      setTimeout(function () {
        _this2.$router.push({ name: 'home' });
      }, 300);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2fe570e0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/yingxin/tskjxy/views/items/default.vue
var default_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('x-header',{staticClass:"header bg-white box-shadow"},[_c('em',{staticClass:"icon icon-arrow-left",attrs:{"slot":"overwrite-left","size":""},on:{"click":_vm.back},slot:"overwrite-left"}),_vm._v(_vm._s(_vm.title)),_c('span',{staticClass:"text-brand",attrs:{"slot":"right","size":""},on:{"click":_vm.finish},slot:"right"},[_vm._v("完成")])]),_c('section',{staticClass:"section text-center"},[_c('br'),_c('br'),_c('br'),_c('br'),_c('br'),_c('h3',[_vm._v("通用测试界面 "+_vm._s(_vm.title))])]),_c('transition',{attrs:{"name":"slide","enter-active-class":"animated fastest slideInUp","leave-active-class":"animated fastest slideOutDown"}},[_c('router-view')],1)],1)}
var default_staticRenderFns = []
var default_esExports = { render: default_render, staticRenderFns: default_staticRenderFns }
/* harmony default export */ var tskjxy_views_items_default = (default_esExports);
// CONCATENATED MODULE: ./src/yingxin/tskjxy/views/items/default.vue
var default_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var default___vue_template_functional__ = false
/* styles */
var default___vue_styles__ = null
/* scopeId */
var default___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var default___vue_module_identifier__ = null
var default_Component = default_normalizeComponent(
  views_items_default,
  tskjxy_views_items_default,
  default___vue_template_functional__,
  default___vue_styles__,
  default___vue_scopeId__,
  default___vue_module_identifier__
)

/* harmony default export */ var yingxin_tskjxy_views_items_default = (default_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/yingxin/tskjxy/views/notice/messageList.vue






/* harmony default export */ var messageList = ({
  name: 'notice',
  components: {
    XHeader: vux_src_components_x_header,
    Badge: vux_src_components_badge,
    Error: src_components_error,
    'scroller': vuescroll_default.a
  },
  data: function data() {
    return {
      title: this.$route.meta.title,
      allState: false,
      errorMsg: {
        type: 'null',
        content: '暂无私信'
      },
      isFirstLoad: true,
      isNoMoreData: false,
      current: 1,
      totalPage: 0,
      list: [],
      listNew: [],
      scrollHeight: 0,
      ops: {
        vuescroll: {
          mode: 'slide',
          pullRefresh: {
            enable: true,
            tips: {
              deactive: '下拉刷新',
              active: '释放刷新',
              start: '刷新中...',
              beforeDeactive: '刷新成功!'
            }
          },
          pushLoad: {
            enable: true,
            tips: {
              deactive: '上拉加载',
              active: '释放加载',
              start: '加载中...',
              beforeDeactive: '加载成功!'
            }
          }
        },
        bar: {
          background: 'rgba(0, 107, 178, 0.3)',
          size: '3px',
          opacity: 0
        }
      }
    };
  },

  computed: {},
  created: function created() {},
  mounted: function mounted() {
    this.$vux.loading.show({
      text: '加载中'
    });
    this.getList();
    this.getScrollHeight();
    this.getMessageUnread();
  },
  updated: function updated() {},
  destroyed: function destroyed() {},

  watch: {},
  methods: {
    back: function back() {
      var _this = this;

      setTimeout(function () {
        _this.$router.back(-1);
      }, 300);
    },
    getScrollHeight: function getScrollHeight() {
      this.scrollHeight = document.documentElement.clientHeight - 47;
    },
    readAll: function readAll() {
      this.list.forEach(function (c) {
        c.flag = '1000000000';
      });
      this.allState = true;
    },
    getList: function getList() {
      var _this2 = this;

      var pageSize = 10;
      var params = {};
      this.listNew = [];
      params.sendType = 0;
      params.status = 0;
      params.pageSize = pageSize;
      params.current = this.current;
      this.$api.get('/message/info/page', params, function (r) {
        _this2.$vux.loading.hide();
        _this2.totalPage = Math.ceil(r.data.totalCount / pageSize);
        if (r.data.list.length > 0) {
          _this2.listNew = r.data.list;
        }
        if (_this2.isFirstLoad) {
          _this2.list = r.data.list;
          if (_this2.$refs['vs'] && r.data.list.length > 0) {
            _this2.$refs['vs'].refresh();
          }
        }
      }, function (err) {
        _this2.$vux.toast.text(err.message, 'top');
      });
    },
    getMessageUnread: function getMessageUnread() {
      var _this3 = this;

      var params = {};
      params.status = 0;
      params.isRead = 0;
      params.sendType = 0;
      this.$api.get('/message/info', params, function (r) {
        _this3.$vux.loading.hide();
        if (r.data.length > 0) {
          _this3.allState = false;
        } else {
          _this3.allState = true;
        }
      }, function (err) {
        _this3.$vux.toast.text(err.message, 'top');
      });
    },
    handleRS: function handleRS(vsInstance, refreshDom, done) {
      var _this4 = this;

      setTimeout(function () {
        _this4.isFirstLoad = false;
        _this4.isNoMoreData = false;
        _this4.current = 1;
        _this4.getList();
        done();
      }, 1500);
    },
    handleLoadStart: function handleLoadStart(vm, dom, done) {
      var _this5 = this;

      setTimeout(function () {
        _this5.isFirstLoad = false;
        if (_this5.current < _this5.totalPage) {
          _this5.current += 1;
          _this5.getList();
          _this5.ops.vuescroll.pushLoad.tips.beforeDeactive = '加载成功';
        } else {
          _this5.isNoMoreData = true;
          _this5.ops.vuescroll.pushLoad.tips.beforeDeactive = '没有更多数据了';
        }
        done();
      }, 600);
    },
    handleLBD: function handleLBD(vm, loadDom, done) {
      var _this6 = this;

      setTimeout(function () {
        if (!_this6.isNoMoreData) {
          _this6.list = _this6.list.concat(_this6.listNew);
        }
        _this6.$refs['vs'].refresh();
        done();
      }, 500);
    },
    handleRBD: function handleRBD(vm, loadDom, done) {
      var _this7 = this;

      setTimeout(function () {
        _this7.list = [];
        _this7.list = _this7.list.concat(_this7.listNew);
        _this7.$refs['vs'].refresh();
        done();
      }, 500);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/yingxin/tskjxy/views/notice/messageList.vue






/* harmony default export */ var notice_messageList = ({
  name: 'notice',
  components: {
    XHeader: vux_src_components_x_header,
    Badge: vux_src_components_badge,
    Error: src_components_error,
    'scroller': vuescroll_default.a
  },
  data: function data() {
    return {
      title: this.$route.meta.title,
      allState: false,
      errorMsg: {
        type: 'null',
        content: '暂无私信'
      },
      isFirstLoad: true,
      isNoMoreData: false,
      current: 1,
      totalPage: 0,
      list: [],
      listNew: [],
      scrollHeight: 0,
      ops: {
        vuescroll: {
          mode: 'slide',
          pullRefresh: {
            enable: true,
            tips: {
              deactive: '下拉刷新',
              active: '释放刷新',
              start: '刷新中...',
              beforeDeactive: '刷新成功!'
            }
          },
          pushLoad: {
            enable: true,
            tips: {
              deactive: '上拉加载',
              active: '释放加载',
              start: '加载中...',
              beforeDeactive: '加载成功!'
            }
          }
        },
        bar: {
          background: 'rgba(0, 107, 178, 0.3)',
          size: '3px',
          opacity: 0
        }
      }
    };
  },

  computed: {},
  created: function created() {},
  mounted: function mounted() {
    this.$vux.loading.show({
      text: '加载中'
    });
    this.getList();
    this.getScrollHeight();
    this.getMessageUnread();
  },
  updated: function updated() {},
  destroyed: function destroyed() {},

  watch: {},
  methods: {
    back: function back() {
      var _this = this;

      setTimeout(function () {
        _this.$router.back(-1);
      }, 300);
    },
    getScrollHeight: function getScrollHeight() {
      this.scrollHeight = document.documentElement.clientHeight - 47;
    },
    readAll: function readAll() {
      this.list.forEach(function (c) {
        c.flag = '1000000000';
      });
      this.allState = true;
    },
    getList: function getList() {
      var _this2 = this;

      var pageSize = 10;
      var params = {};
      this.listNew = [];
      params.sendType = 0;
      params.status = 0;
      params.pageSize = pageSize;
      params.current = this.current;
      this.$api.get('/message/info/page', params, function (r) {
        _this2.$vux.loading.hide();
        _this2.totalPage = Math.ceil(r.data.totalCount / pageSize);
        if (r.data.list.length > 0) {
          _this2.listNew = r.data.list;
        }
        if (_this2.isFirstLoad) {
          _this2.list = r.data.list;
          if (_this2.$refs['vs'] && r.data.list.length > 0) {
            _this2.$refs['vs'].refresh();
          }
        }
      }, function (err) {
        _this2.$vux.toast.text(err.message, 'top');
      });
    },
    getMessageUnread: function getMessageUnread() {
      var _this3 = this;

      var params = {};
      params.status = 0;
      params.isRead = 0;
      params.sendType = 0;
      this.$api.get('/message/info', params, function (r) {
        _this3.$vux.loading.hide();
        if (r.data.length > 0) {
          _this3.allState = false;
        } else {
          _this3.allState = true;
        }
      }, function (err) {
        _this3.$vux.toast.text(err.message, 'top');
      });
    },
    handleRS: function handleRS(vsInstance, refreshDom, done) {
      var _this4 = this;

      setTimeout(function () {
        _this4.isFirstLoad = false;
        _this4.isNoMoreData = false;
        _this4.current = 1;
        _this4.getList();
        done();
      }, 1500);
    },
    handleLoadStart: function handleLoadStart(vm, dom, done) {
      var _this5 = this;

      setTimeout(function () {
        _this5.isFirstLoad = false;
        if (_this5.current < _this5.totalPage) {
          _this5.current += 1;
          _this5.getList();
          _this5.ops.vuescroll.pushLoad.tips.beforeDeactive = '加载成功';
        } else {
          _this5.isNoMoreData = true;
          _this5.ops.vuescroll.pushLoad.tips.beforeDeactive = '没有更多数据了';
        }
        done();
      }, 600);
    },
    handleLBD: function handleLBD(vm, loadDom, done) {
      var _this6 = this;

      setTimeout(function () {
        if (!_this6.isNoMoreData) {
          _this6.list = _this6.list.concat(_this6.listNew);
        }
        _this6.$refs['vs'].refresh();
        done();
      }, 500);
    },
    handleRBD: function handleRBD(vm, loadDom, done) {
      var _this7 = this;

      setTimeout(function () {
        _this7.list = [];
        _this7.list = _this7.list.concat(_this7.listNew);
        _this7.$refs['vs'].refresh();
        done();
      }, 500);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-313fbdbc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/yingxin/tskjxy/views/notice/messageList.vue
var messageList_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sub-page"},[_c('x-header',{staticClass:"header bg-white border-bottom fixed top"},[_c('em',{staticClass:"icon icon-arrow-left",attrs:{"slot":"overwrite-left","size":""},on:{"click":_vm.back},slot:"overwrite-left"}),_vm._v(_vm._s(_vm.title)),(!_vm.allState)?_c('a',{staticClass:"read-state",attrs:{"slot":"right"},on:{"click":function($event){return _vm.readAll()}},slot:"right"},[_vm._v("全部已读")]):_c('a',{attrs:{"slot":"right"},slot:"right"},[_vm._v("全部已读")])]),_c('section',{staticClass:"fixed-next scroller-box",style:(("height:" + _vm.scrollHeight + "px"))},[(_vm.list.length>0)?_c('scroller',{ref:"vs",staticClass:"scroller",attrs:{"ops":_vm.ops},on:{"refresh-start":_vm.handleRS,"load-before-deactivate":_vm.handleLBD,"refresh-before-deactivate":_vm.handleRBD,"load-start":_vm.handleLoadStart}},[_c('div',{staticClass:"section message-list container"},_vm._l((_vm.list),function(item,index){return _c('div',{key:index,ref:"card",refInFor:true,staticClass:"m-list-item bg-white"},[_c('div',{staticClass:"m-title"},[(item.flag.substr(0, 1)=='0')?_c('badge'):_vm._e(),_c('div',{staticClass:"title"},[_vm._v(_vm._s(item.messageBean.name))])],1),_c('div',{staticClass:"m-content"},[_c('div',{staticClass:"matter"},[_vm._v(_vm._s(item.content))])]),_c('div',{staticClass:"m-bottom"},[_c('span',{staticClass:"date"},[_vm._v(_vm._s(item.sendDatetime))])])])}),0)]):_c('error',{staticStyle:{"padding":"2rem 0"},attrs:{"errorMsg":_vm.errorMsg}})],1)],1)}
var messageList_staticRenderFns = []
var messageList_esExports = { render: messageList_render, staticRenderFns: messageList_staticRenderFns }
/* harmony default export */ var views_notice_messageList = (messageList_esExports);
// CONCATENATED MODULE: ./src/yingxin/tskjxy/views/notice/messageList.vue
function messageList_injectStyle (ssrContext) {
  __webpack_require__("Amcn")
}
var messageList_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var messageList___vue_template_functional__ = false
/* styles */
var messageList___vue_styles__ = messageList_injectStyle
/* scopeId */
var messageList___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var messageList___vue_module_identifier__ = null
var messageList_Component = messageList_normalizeComponent(
  notice_messageList,
  views_notice_messageList,
  messageList___vue_template_functional__,
  messageList___vue_styles__,
  messageList___vue_scopeId__,
  messageList___vue_module_identifier__
)

/* harmony default export */ var tskjxy_views_notice_messageList = (messageList_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/actionsheet/index.vue


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var actionsheet = ({
  name: 'actionsheet',
  mounted: function mounted() {
    var _this = this;

    this.hasHeaderSlot = !!this.$slots.header;
    this.$nextTick(function () {
      _this.$tabbar = document.querySelector('.weui-tabbar');
      _this.$refs.iOSMenu && _this.$refs.iOSMenu.addEventListener('transitionend', _this.onTransitionEnd);
    });
  },

  props: {
    value: Boolean,
    showCancel: Boolean,
    cancelText: String,
    theme: {
      type: String,
      default: 'ios'
    },
    menus: {
      type: [Object, Array],
      default: function _default() {
        return {};
      }
    },
    closeOnClickingMask: {
      type: Boolean,
      default: true
    },
    closeOnClickingMenu: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      hasHeaderSlot: false,
      show: false
    };
  },

  methods: {
    onTransitionEnd: function onTransitionEnd() {
      this.$emit(this.show ? 'on-after-show' : 'on-after-hide');
    },
    onMenuClick: function onMenuClick(text, key) {
      if (typeof text === 'string') {
        this.emitEvent('on-click-menu', key, text);
      } else {
        if (text.type !== 'disabled' && text.type !== 'info') {
          if (text.value || text.value === 0) {
            this.emitEvent('on-click-menu', text.value, text);
          } else {
            this.emitEvent('on-click-menu', '', text);
            this.show = false;
          }
        }
      }
    },
    onClickingMask: function onClickingMask() {
      this.$emit('on-click-mask');
      this.closeOnClickingMask && (this.show = false);
    },
    emitEvent: function emitEvent(event, menu, item) {
      if (event === 'on-click-menu' && !/.noop/.test(menu)) {
        var _item = item;
        if ((typeof _item === 'undefined' ? 'undefined' : typeof_default()(_item)) === 'object') {
          _item = JSON.parse(stringify_default()(_item));
        }
        this.$emit(event, menu, _item);
        this.$emit(event + '-' + menu);
        this.closeOnClickingMenu && (this.show = false);
      }
    },
    fixIos: function fixIos(zIndex) {
      if (this.$el.parentNode && this.$el.parentNode.className.indexOf('v-transfer-dom') !== -1) {
        return;
      }
      if (this.$tabbar && /iphone/i.test(navigator.userAgent)) {
        this.$tabbar.style.zIndex = zIndex;
      }
    }
  },
  watch: {
    show: function show(val) {
      var _this2 = this;

      this.$emit('input', val);
      if (val) {
        this.fixIos(-1);
      } else {
        setTimeout(function () {
          _this2.fixIos(100);
        }, 200);
      }
    },

    value: {
      handler: function handler(val) {
        this.show = val;
      },
      immediate: true
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.fixIos(100);
    this.$refs.iOSMenu && this.$refs.iOSMenu.removeEventListener('transitionend', this.onTransitionEnd);
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/actionsheet/index.vue


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var components_actionsheet = ({
  name: 'actionsheet',
  mounted: function mounted() {
    var _this = this;

    this.hasHeaderSlot = !!this.$slots.header;
    this.$nextTick(function () {
      _this.$tabbar = document.querySelector('.weui-tabbar');
      _this.$refs.iOSMenu && _this.$refs.iOSMenu.addEventListener('transitionend', _this.onTransitionEnd);
    });
  },

  props: {
    value: Boolean,
    showCancel: Boolean,
    cancelText: String,
    theme: {
      type: String,
      default: 'ios'
    },
    menus: {
      type: [Object, Array],
      default: function _default() {
        return {};
      }
    },
    closeOnClickingMask: {
      type: Boolean,
      default: true
    },
    closeOnClickingMenu: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      hasHeaderSlot: false,
      show: false
    };
  },

  methods: {
    onTransitionEnd: function onTransitionEnd() {
      this.$emit(this.show ? 'on-after-show' : 'on-after-hide');
    },
    onMenuClick: function onMenuClick(text, key) {
      if (typeof text === 'string') {
        this.emitEvent('on-click-menu', key, text);
      } else {
        if (text.type !== 'disabled' && text.type !== 'info') {
          if (text.value || text.value === 0) {
            this.emitEvent('on-click-menu', text.value, text);
          } else {
            this.emitEvent('on-click-menu', '', text);
            this.show = false;
          }
        }
      }
    },
    onClickingMask: function onClickingMask() {
      this.$emit('on-click-mask');
      this.closeOnClickingMask && (this.show = false);
    },
    emitEvent: function emitEvent(event, menu, item) {
      if (event === 'on-click-menu' && !/.noop/.test(menu)) {
        var _item = item;
        if ((typeof _item === 'undefined' ? 'undefined' : typeof_default()(_item)) === 'object') {
          _item = JSON.parse(stringify_default()(_item));
        }
        this.$emit(event, menu, _item);
        this.$emit(event + '-' + menu);
        this.closeOnClickingMenu && (this.show = false);
      }
    },
    fixIos: function fixIos(zIndex) {
      if (this.$el.parentNode && this.$el.parentNode.className.indexOf('v-transfer-dom') !== -1) {
        return;
      }
      if (this.$tabbar && /iphone/i.test(navigator.userAgent)) {
        this.$tabbar.style.zIndex = zIndex;
      }
    }
  },
  watch: {
    show: function show(val) {
      var _this2 = this;

      this.$emit('input', val);
      if (val) {
        this.fixIos(-1);
      } else {
        setTimeout(function () {
          _this2.fixIos(100);
        }, 200);
      }
    },

    value: {
      handler: function handler(val) {
        this.show = val;
      },
      immediate: true
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.fixIos(100);
    this.$refs.iOSMenu && this.$refs.iOSMenu.removeEventListener('transitionend', this.onTransitionEnd);
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-76e1b9a2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/actionsheet/index.vue
var actionsheet_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-actionsheet"},[_c('transition',{attrs:{"name":"vux-actionsheet-mask"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"weui-mask weui-mask_transparent",on:{"click":_vm.onClickingMask}})]),_vm._v(" "),(_vm.theme === 'android')?_c('div',{staticClass:"weui-skin_android"},[_c('transition',{attrs:{"name":"vux-android-actionsheet"},on:{"after-enter":function($event){return _vm.$emit('on-after-show')},"after-leave":function($event){return _vm.$emit('on-after-hide')}}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"weui-actionsheet"},[_c('div',{staticClass:"weui-actionsheet__menu"},_vm._l((_vm.menus),function(text,key){return _c('div',{staticClass:"weui-actionsheet__cell",domProps:{"innerHTML":_vm._s(text.label || text)},on:{"click":function($event){return _vm.onMenuClick(text, key)}}})}),0)])])],1):_c('div',{ref:"iOSMenu",staticClass:"weui-actionsheet",class:{'weui-actionsheet_toggle': _vm.show}},[_c('div',{staticClass:"weui-actionsheet__menu"},[(_vm.hasHeaderSlot)?_c('div',{staticClass:"weui-actionsheet__cell"},[_vm._t("header")],2):_vm._e(),_vm._v(" "),_vm._l((_vm.menus),function(text,key){return _c('div',{staticClass:"weui-actionsheet__cell",class:("vux-actionsheet-menu-" + (text.type || 'default')),domProps:{"innerHTML":_vm._s(text.label || text)},on:{"click":function($event){return _vm.onMenuClick(text, key)}}})})],2),_vm._v(" "),(_vm.showCancel)?_c('div',{staticClass:"weui-actionsheet__action",on:{"click":function($event){return _vm.emitEvent('on-click-menu', 'cancel')}}},[_c('div',{staticClass:"weui-actionsheet__cell"},[_vm._v(_vm._s(_vm.cancelText || '取消'))])]):_vm._e()])],1)}
var actionsheet_staticRenderFns = []
var actionsheet_esExports = { render: actionsheet_render, staticRenderFns: actionsheet_staticRenderFns }
/* harmony default export */ var src_components_actionsheet = (actionsheet_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/actionsheet/index.vue
function actionsheet_injectStyle (ssrContext) {
  __webpack_require__("0UZ+")
}
var actionsheet_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var actionsheet___vue_template_functional__ = false
/* styles */
var actionsheet___vue_styles__ = actionsheet_injectStyle
/* scopeId */
var actionsheet___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var actionsheet___vue_module_identifier__ = null
var actionsheet_Component = actionsheet_normalizeComponent(
  components_actionsheet,
  src_components_actionsheet,
  actionsheet___vue_template_functional__,
  actionsheet___vue_styles__,
  actionsheet___vue_scopeId__,
  actionsheet___vue_module_identifier__
)


/* harmony default export */ var vux_src_components_actionsheet = (actionsheet_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/yingxin/tskjxy/views/notice/noticeDetail.vue





/* harmony default export */ var noticeDetail = ({
  name: 'notice',
  components: {
    XHeader: vux_src_components_x_header,
    Actionsheet: vux_src_components_actionsheet
  },
  directives: {
    TransferDom: transfer_dom["a" /* default */]
  },
  data: function data() {
    return {
      title: this.$route.meta.title,
      id: this.$route.params.id,
      menus: {
        menu1: '<div class="share-item"><i class="icon icon-wechat"></i><span class="text">朋友圈</span></div>',
        menu2: '<div class="share-item"><i class="icon icon-wechat-o"></i><span  class="text">发送好友</span></div>',
        menu3: '<div class="share-item"><i class="icon icon-QQspace"></i><span  class="text">QQ空间</span></div>',
        menu4: '<div class="share-item"><i class="icon icon-QQ"></i><span  class="text">QQ</span></div>',
        menu5: '<div class="share-item"><i class="icon icon-sina"></i><span  class="text">新浪微博</span></div>'
      },
      showMenus: false,
      info: ''
    };
  },

  computed: {},
  created: function created() {},
  mounted: function mounted() {
    this.$vux.loading.show({
      text: '加载中'
    });
    this.getDetail();
  },
  updated: function updated() {},
  destroyed: function destroyed() {},

  watch: {},
  methods: {
    back: function back() {
      var _this = this;

      setTimeout(function () {
        _this.$router.back(-1);
      }, 300);
    },
    click: function click(key) {
      console.log(key);
    },
    share: function share() {
      this.showMenus = true;
    },
    getDetail: function getDetail() {
      var _this2 = this;

      var params = {};
      params.id = this.id;
      params.isQueryContent = 1;
      params.isExpire = 1;
      this.$api.get('/notice', params, function (r) {
        _this2.$vux.loading.hide();
        _this2.info = r.data[0];
      }, function (err) {
        _this2.$vux.toast.text(err.message, 'top');
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/yingxin/tskjxy/views/notice/noticeDetail.vue





/* harmony default export */ var notice_noticeDetail = ({
  name: 'notice',
  components: {
    XHeader: vux_src_components_x_header,
    Actionsheet: vux_src_components_actionsheet
  },
  directives: {
    TransferDom: transfer_dom["a" /* default */]
  },
  data: function data() {
    return {
      title: this.$route.meta.title,
      id: this.$route.params.id,
      menus: {
        menu1: '<div class="share-item"><i class="icon icon-wechat"></i><span class="text">朋友圈</span></div>',
        menu2: '<div class="share-item"><i class="icon icon-wechat-o"></i><span  class="text">发送好友</span></div>',
        menu3: '<div class="share-item"><i class="icon icon-QQspace"></i><span  class="text">QQ空间</span></div>',
        menu4: '<div class="share-item"><i class="icon icon-QQ"></i><span  class="text">QQ</span></div>',
        menu5: '<div class="share-item"><i class="icon icon-sina"></i><span  class="text">新浪微博</span></div>'
      },
      showMenus: false,
      info: ''
    };
  },

  computed: {},
  created: function created() {},
  mounted: function mounted() {
    this.$vux.loading.show({
      text: '加载中'
    });
    this.getDetail();
  },
  updated: function updated() {},
  destroyed: function destroyed() {},

  watch: {},
  methods: {
    back: function back() {
      var _this = this;

      setTimeout(function () {
        _this.$router.back(-1);
      }, 300);
    },
    click: function click(key) {
      console.log(key);
    },
    share: function share() {
      this.showMenus = true;
    },
    getDetail: function getDetail() {
      var _this2 = this;

      var params = {};
      params.id = this.id;
      params.isQueryContent = 1;
      params.isExpire = 1;
      this.$api.get('/notice', params, function (r) {
        _this2.$vux.loading.hide();
        _this2.info = r.data[0];
      }, function (err) {
        _this2.$vux.toast.text(err.message, 'top');
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7241dfb2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/yingxin/tskjxy/views/notice/noticeDetail.vue
var noticeDetail_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sub-page"},[_c('x-header',{staticClass:"header bg-white border-bottom fixed top"},[_c('em',{staticClass:"icon icon-arrow-left",attrs:{"slot":"overwrite-left","size":""},on:{"click":_vm.back},slot:"overwrite-left"}),_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"notice notice-detail fixed-next"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"n-list-item"},[_c('div',{staticClass:"n-title"},[_vm._v(_vm._s(_vm.info.title))]),_c('div',{staticClass:"n-source"},[_c('span',[_vm._v(_vm._s(_vm.info.source))]),_c('span',{staticClass:"date float-right"},[_vm._v("发布时间："+_vm._s(_vm.info.publishDatetime))])]),_c('div',{staticClass:"n-article",domProps:{"innerHTML":_vm._s(_vm.info.content)}},[_vm._v(_vm._s(_vm.info.content))])])])]),_c('div',{directives:[{name:"transfer-dom",rawName:"v-transfer-dom"}]},[_c('actionsheet',{staticClass:"share-model file-model",attrs:{"menus":_vm.menus,"show-cancel":"show-cancel"},model:{value:(_vm.showMenus),callback:function ($$v) {_vm.showMenus=$$v},expression:"showMenus"}})],1)],1)}
var noticeDetail_staticRenderFns = []
var noticeDetail_esExports = { render: noticeDetail_render, staticRenderFns: noticeDetail_staticRenderFns }
/* harmony default export */ var views_notice_noticeDetail = (noticeDetail_esExports);
// CONCATENATED MODULE: ./src/yingxin/tskjxy/views/notice/noticeDetail.vue
var noticeDetail_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var noticeDetail___vue_template_functional__ = false
/* styles */
var noticeDetail___vue_styles__ = null
/* scopeId */
var noticeDetail___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var noticeDetail___vue_module_identifier__ = null
var noticeDetail_Component = noticeDetail_normalizeComponent(
  notice_noticeDetail,
  views_notice_noticeDetail,
  noticeDetail___vue_template_functional__,
  noticeDetail___vue_styles__,
  noticeDetail___vue_scopeId__,
  noticeDetail___vue_module_identifier__
)

/* harmony default export */ var tskjxy_views_notice_noticeDetail = (noticeDetail_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/yingxin/tskjxy/views/record/map.vue










/* harmony default export */ var map = ({
  name: 'mapPosition',
  props: [],
  components: {
    XHeader: vux_src_components_x_header,
    Group: vux_src_components_group,
    Cell: vux_src_components_cell,
    BaiduMap: vue_baidu_map["BaiduMap"],
    BmMarker: vue_baidu_map["BmMarker"],
    BmLabel: vue_baidu_map["BmLabel"],
    BmOverlay: vue_baidu_map["BmOverlay"]
  },
  data: function data() {
    return {
      title: this.$route.params.title,
      flowProcedureId: this.$route.params.flowProcedureId,
      procedureId: this.$route.params.procedureId,
      procedureInfo: [{
        title: '办理地址',
        content: ''
      }, {
        title: '联系老师',
        content: ''
      }, {
        title: '联系电话',
        content: ''
      }, {
        title: '办理日期',
        content: ''
      }],
      zoom: 16,
      center: '北京',
      contactInfo: {
        position: ''
      },
      isMap: false,
      isShowMap: false,
      mapStyle: {
        styleJson: [{
          'featureType': 'all',
          'elementType': 'geometry',
          'stylers': {
            'hue': '#007fff',
            'saturation': 89
          }
        }, {
          'featureType': 'water',
          'elementType': 'all',
          'stylers': {
            'color': '#ffffff'
          }
        }]
      }
    };
  },

  computed: extends_default()({}, Object(vuex_esm["c" /* mapState */])({
    studentId: function studentId(state) {
      return state.userInfo.id;
    },
    flowId: function flowId(state) {
      return state.flowInfo.flowId;
    }
  })),
  created: function created() {},
  mounted: function mounted() {
    this.$vux.loading.show({
      text: '加载中,请稍候'
    });
    this.getContactInfo();
  },
  updated: function updated() {},
  destroyed: function destroyed() {},

  watch: {},
  methods: {
    back: function back() {
      var _this = this;

      setTimeout(function () {
        _this.$router.back(-1);
      }, 300);
    },
    draw: function draw(_ref) {
      var _this2 = this;

      var el = _ref.el,
          BMap = _ref.BMap,
          map = _ref.map;

      this.getContactInfo().then(function () {
        var pixel = map.pointToOverlayPixel(new BMap.Point(_this2.contactInfo.position.lng, _this2.contactInfo.position.lat));
        el.style.left = pixel.x - 82 + 'px';
        el.style.top = pixel.y + 'px';
      });
    },
    getContactInfo: function getContactInfo() {
      var _this3 = this;

      var params = {
        studentId: this.studentId,
        flowId: this.flowId,
        flowProcedureId: this.flowProcedureId,
        procedureId: this.procedureId,
        'flowBean.isInFlow': 1
      };
      return new promise_default.a(function (resolve, reject) {
        _this3.$api.get('/dataManagement/getDataManagementList', params, function (r) {
          _this3.$vux.loading.hide();
          var data = r.data;
          var procedureInfo = {
            address: data[0].flowProcedureBean.address,
            contact: data[0].flowProcedureBean.contact,
            contactNumber: data[0].flowProcedureBean.contactNumber,
            date: data[0].flowProcedureBean.startDate + ' 至 ' + data[0].flowProcedureBean.endDate
          };
          var arr = [];
          for (var i in procedureInfo) {
            arr.push(procedureInfo[i]);
          }
          for (var j = 0; j < arr.length; j++) {
            _this3.procedureInfo[j].content = arr[j];
          }

          _this3.isShowMap = Boolean(data[0].flowProcedureBean.position);
          if (data[0].flowProcedureBean.position) {
            var arrLen = data[0].flowProcedureBean.position.split(',').length;
            if (arrLen === 1) {
              _this3.center = data[0].flowProcedureBean.position;
            } else if (arrLen === 2) {
              var _arr = data[0].flowProcedureBean.position.split(',');
              var position = {
                lng: parseFloat(_arr[1]),
                lat: parseFloat(_arr[0])
              };
              _this3.center = position;
              _this3.contactInfo.position = position;
            }
          }
          resolve();
        }, function (err) {
          _this3.$vux.toast.text(err.message, 'top');
        });
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/yingxin/tskjxy/views/record/map.vue










/* harmony default export */ var record_map = ({
  name: 'mapPosition',
  props: [],
  components: {
    XHeader: vux_src_components_x_header,
    Group: vux_src_components_group,
    Cell: vux_src_components_cell,
    BaiduMap: vue_baidu_map["BaiduMap"],
    BmMarker: vue_baidu_map["BmMarker"],
    BmLabel: vue_baidu_map["BmLabel"],
    BmOverlay: vue_baidu_map["BmOverlay"]
  },
  data: function data() {
    return {
      title: this.$route.params.title,
      flowProcedureId: this.$route.params.flowProcedureId,
      procedureId: this.$route.params.procedureId,
      procedureInfo: [{
        title: '办理地址',
        content: ''
      }, {
        title: '联系老师',
        content: ''
      }, {
        title: '联系电话',
        content: ''
      }, {
        title: '办理日期',
        content: ''
      }],
      zoom: 16,
      center: '北京',
      contactInfo: {
        position: ''
      },
      isMap: false,
      isShowMap: false,
      mapStyle: {
        styleJson: [{
          'featureType': 'all',
          'elementType': 'geometry',
          'stylers': {
            'hue': '#007fff',
            'saturation': 89
          }
        }, {
          'featureType': 'water',
          'elementType': 'all',
          'stylers': {
            'color': '#ffffff'
          }
        }]
      }
    };
  },

  computed: extends_default()({}, Object(vuex_esm["c" /* mapState */])({
    studentId: function studentId(state) {
      return state.userInfo.id;
    },
    flowId: function flowId(state) {
      return state.flowInfo.flowId;
    }
  })),
  created: function created() {},
  mounted: function mounted() {
    this.$vux.loading.show({
      text: '加载中,请稍候'
    });
    this.getContactInfo();
  },
  updated: function updated() {},
  destroyed: function destroyed() {},

  watch: {},
  methods: {
    back: function back() {
      var _this = this;

      setTimeout(function () {
        _this.$router.back(-1);
      }, 300);
    },
    draw: function draw(_ref) {
      var _this2 = this;

      var el = _ref.el,
          BMap = _ref.BMap,
          map = _ref.map;

      this.getContactInfo().then(function () {
        var pixel = map.pointToOverlayPixel(new BMap.Point(_this2.contactInfo.position.lng, _this2.contactInfo.position.lat));
        el.style.left = pixel.x - 82 + 'px';
        el.style.top = pixel.y + 'px';
      });
    },
    getContactInfo: function getContactInfo() {
      var _this3 = this;

      var params = {
        studentId: this.studentId,
        flowId: this.flowId,
        flowProcedureId: this.flowProcedureId,
        procedureId: this.procedureId,
        'flowBean.isInFlow': 1
      };
      return new promise_default.a(function (resolve, reject) {
        _this3.$api.get('/dataManagement/getDataManagementList', params, function (r) {
          _this3.$vux.loading.hide();
          var data = r.data;
          var procedureInfo = {
            address: data[0].flowProcedureBean.address,
            contact: data[0].flowProcedureBean.contact,
            contactNumber: data[0].flowProcedureBean.contactNumber,
            date: data[0].flowProcedureBean.startDate + ' 至 ' + data[0].flowProcedureBean.endDate
          };
          var arr = [];
          for (var i in procedureInfo) {
            arr.push(procedureInfo[i]);
          }
          for (var j = 0; j < arr.length; j++) {
            _this3.procedureInfo[j].content = arr[j];
          }

          _this3.isShowMap = Boolean(data[0].flowProcedureBean.position);
          if (data[0].flowProcedureBean.position) {
            var arrLen = data[0].flowProcedureBean.position.split(',').length;
            if (arrLen === 1) {
              _this3.center = data[0].flowProcedureBean.position;
            } else if (arrLen === 2) {
              var _arr = data[0].flowProcedureBean.position.split(',');
              var position = {
                lng: parseFloat(_arr[1]),
                lat: parseFloat(_arr[0])
              };
              _this3.center = position;
              _this3.contactInfo.position = position;
            }
          }
          resolve();
        }, function (err) {
          _this3.$vux.toast.text(err.message, 'top');
        });
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8a0df3c2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/yingxin/tskjxy/views/record/map.vue
var map_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sub-page"},[_c('x-header',{staticClass:"header bg-white fixed"},[_c('em',{staticClass:"icon icon-arrow-left",attrs:{"slot":"overwrite-left","size":""},on:{"click":_vm.back},slot:"overwrite-left"}),_vm._v(_vm._s(_vm.title)+"办理信息")]),_c('section',{staticClass:"section fixed-next"},[_c('group',{attrs:{"label-width":"5em"}},_vm._l((_vm.procedureInfo),function(item,i){return _c('cell',{key:i,attrs:{"title":item.title,"value":item.content ? item.content : '暂无',"align-items":"flex-start"}})}),1)],1),(_vm.isShowMap)?_c('section',{staticClass:"section"},[_c('group',{attrs:{"label-width":"5em"}},[_c('cell',{attrs:{"title":"查看地图","is-link":"","border-intent":false,"arrow-direction":_vm.isMap ? 'down' : 'right'},nativeOn:{"click":function($event){_vm.isMap = !_vm.isMap}}}),_c('section',{staticClass:"slide",class:_vm.isMap?'animate':''},[_c('baidu-map',{staticStyle:{"width":"100vw","height":"85vh"},attrs:{"center":_vm.center,"scroll-wheel-zoom":true,"zoom":_vm.zoom,"ak":"teb3oj4kPudP57wFREYRCyRUga5X4Qpj","mapStyle":_vm.mapStyle},on:{"ready":function($event){}}},[_c('bm-marker',{attrs:{"position":_vm.contactInfo.position,"animation":"BMAP_ANIMATION_BOUNCE","icon":{url: __webpack_require__("09Uw"), size: {width: 60, height: 100}},"offset":{width: -4, height: 0}}})],1)],1)],1)],1):_vm._e()],1)}
var map_staticRenderFns = []
var map_esExports = { render: map_render, staticRenderFns: map_staticRenderFns }
/* harmony default export */ var views_record_map = (map_esExports);
// CONCATENATED MODULE: ./src/yingxin/tskjxy/views/record/map.vue
function map_injectStyle (ssrContext) {
  __webpack_require__("ohus")
}
var map_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var map___vue_template_functional__ = false
/* styles */
var map___vue_styles__ = map_injectStyle
/* scopeId */
var map___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var map___vue_module_identifier__ = null
var map_Component = map_normalizeComponent(
  record_map,
  views_record_map,
  map___vue_template_functional__,
  map___vue_styles__,
  map___vue_scopeId__,
  map___vue_module_identifier__
)

/* harmony default export */ var tskjxy_views_record_map = (map_Component.exports);

// EXTERNAL MODULE: ./node_modules/qr.js/lib/QRCode.js
var QRCode = __webpack_require__("0k+n");
var QRCode_default = /*#__PURE__*/__webpack_require__.n(QRCode);

// EXTERNAL MODULE: ./node_modules/qr.js/lib/ErrorCorrectLevel.js
var ErrorCorrectLevel = __webpack_require__("LpmL");
var ErrorCorrectLevel_default = /*#__PURE__*/__webpack_require__.n(ErrorCorrectLevel);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/qrcode/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var components_qrcode = ({
  name: 'qrcode',
  props: {
    value: String,
    size: {
      type: Number,
      default: 160
    },
    level: {
      type: String,
      default: 'L'
    },
    bgColor: {
      type: String,
      default: '#FFFFFF'
    },
    fgColor: {
      type: String,
      default: '#000000'
    },
    type: {
      type: String,
      default: 'img'
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.$nextTick(function () {
      _this.render();
    });
  },
  data: function data() {
    return {
      imgData: ''
    };
  },

  watch: {
    value: function value() {
      this.render();
    },
    size: function size() {
      this.render();
    },
    level: function level() {
      this.render();
    },
    bgColor: function bgColor() {
      this.render();
    },
    fgColor: function fgColor() {
      this.render();
    }
  },
  methods: {
    render: function render() {
      var _this2 = this;

      if (typeof this.value === 'undefined') {
        return;
      }

      var qrcode = new QRCode_default.a(-1, ErrorCorrectLevel_default.a[this.level]);
      qrcode.addData(utf16to8(this.value));
      qrcode.make();

      var canvas = this.$refs.canvas;

      var ctx = canvas.getContext('2d');
      var cells = qrcode.modules;
      var tileW = this.size / cells.length;
      var tileH = this.size / cells.length;
      var scale = (window.devicePixelRatio || 1) / getBackingStorePixelRatio(ctx);
      canvas.height = canvas.width = this.size * scale;
      ctx.scale(scale, scale);

      cells.forEach(function (row, rdx) {
        row.forEach(function (cell, cdx) {
          ctx.fillStyle = cell ? _this2.fgColor : _this2.bgColor;
          var w = Math.ceil((cdx + 1) * tileW) - Math.floor(cdx * tileW);
          var h = Math.ceil((rdx + 1) * tileH) - Math.floor(rdx * tileH);
          ctx.fillRect(Math.round(cdx * tileW), Math.round(rdx * tileH), w, h);
        });
      });
      if (this.type === 'img') {
        this.imgData = canvas.toDataURL('image/png');
      }
    }
  }
});

function getBackingStorePixelRatio(ctx) {
  return ctx.webkitBackingStorePixelRatio || ctx.mozBackingStorePixelRatio || ctx.msBackingStorePixelRatio || ctx.oBackingStorePixelRatio || ctx.backingStorePixelRatio || 1;
}

function utf16to8(str) {
  var out, i, len, c;
  out = '';
  len = str.length;
  for (i = 0; i < len; i++) {
    c = str.charCodeAt(i);
    if (c >= 0x0001 && c <= 0x007F) {
      out += str.charAt(i);
    } else if (c > 0x07FF) {
      out += String.fromCharCode(0xE0 | c >> 12 & 0x0F);
      out += String.fromCharCode(0x80 | c >> 6 & 0x3F);
      out += String.fromCharCode(0x80 | c >> 0 & 0x3F);
    } else {
      out += String.fromCharCode(0xC0 | c >> 6 & 0x1F);
      out += String.fromCharCode(0x80 | c >> 0 & 0x3F);
    }
  }
  return out;
}
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/qrcode/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var src_components_qrcode = ({
  name: 'qrcode',
  props: {
    value: String,
    size: {
      type: Number,
      default: 160
    },
    level: {
      type: String,
      default: 'L'
    },
    bgColor: {
      type: String,
      default: '#FFFFFF'
    },
    fgColor: {
      type: String,
      default: '#000000'
    },
    type: {
      type: String,
      default: 'img'
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.$nextTick(function () {
      _this.render();
    });
  },
  data: function data() {
    return {
      imgData: ''
    };
  },

  watch: {
    value: function value() {
      this.render();
    },
    size: function size() {
      this.render();
    },
    level: function level() {
      this.render();
    },
    bgColor: function bgColor() {
      this.render();
    },
    fgColor: function fgColor() {
      this.render();
    }
  },
  methods: {
    render: function render() {
      var _this2 = this;

      if (typeof this.value === 'undefined') {
        return;
      }

      var qrcode = new QRCode_default.a(-1, ErrorCorrectLevel_default.a[this.level]);
      qrcode.addData(qrcode_utf16to8(this.value));
      qrcode.make();

      var canvas = this.$refs.canvas;

      var ctx = canvas.getContext('2d');
      var cells = qrcode.modules;
      var tileW = this.size / cells.length;
      var tileH = this.size / cells.length;
      var scale = (window.devicePixelRatio || 1) / qrcode_getBackingStorePixelRatio(ctx);
      canvas.height = canvas.width = this.size * scale;
      ctx.scale(scale, scale);

      cells.forEach(function (row, rdx) {
        row.forEach(function (cell, cdx) {
          ctx.fillStyle = cell ? _this2.fgColor : _this2.bgColor;
          var w = Math.ceil((cdx + 1) * tileW) - Math.floor(cdx * tileW);
          var h = Math.ceil((rdx + 1) * tileH) - Math.floor(rdx * tileH);
          ctx.fillRect(Math.round(cdx * tileW), Math.round(rdx * tileH), w, h);
        });
      });
      if (this.type === 'img') {
        this.imgData = canvas.toDataURL('image/png');
      }
    }
  }
});

function qrcode_getBackingStorePixelRatio(ctx) {
  return ctx.webkitBackingStorePixelRatio || ctx.mozBackingStorePixelRatio || ctx.msBackingStorePixelRatio || ctx.oBackingStorePixelRatio || ctx.backingStorePixelRatio || 1;
}

function qrcode_utf16to8(str) {
  var out, i, len, c;
  out = '';
  len = str.length;
  for (i = 0; i < len; i++) {
    c = str.charCodeAt(i);
    if (c >= 0x0001 && c <= 0x007F) {
      out += str.charAt(i);
    } else if (c > 0x07FF) {
      out += String.fromCharCode(0xE0 | c >> 12 & 0x0F);
      out += String.fromCharCode(0x80 | c >> 6 & 0x3F);
      out += String.fromCharCode(0x80 | c >> 0 & 0x3F);
    } else {
      out += String.fromCharCode(0xC0 | c >> 6 & 0x1F);
      out += String.fromCharCode(0x80 | c >> 0 & 0x3F);
    }
  }
  return out;
}
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1fba41f8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/qrcode/index.vue
var qrcode_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('canvas',{directives:[{name:"show",rawName:"v-show",value:(_vm.type === 'canvas'),expression:"type === 'canvas'"}],ref:"canvas",style:({
    height: (_vm.size + "px"),
    width: (_vm.size + "px")
  }),attrs:{"height":_vm.size,"width":_vm.size}}),_vm._v(" "),(_vm.type === 'img')?_c('img',{style:({
    height: (_vm.size + "px"),
    width: (_vm.size + "px")
  }),attrs:{"src":_vm.imgData}}):_vm._e()])}
var qrcode_staticRenderFns = []
var qrcode_esExports = { render: qrcode_render, staticRenderFns: qrcode_staticRenderFns }
/* harmony default export */ var vux_src_components_qrcode = (qrcode_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/qrcode/index.vue
var qrcode_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var qrcode___vue_template_functional__ = false
/* styles */
var qrcode___vue_styles__ = null
/* scopeId */
var qrcode___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var qrcode___vue_module_identifier__ = null
var qrcode_Component = qrcode_normalizeComponent(
  src_components_qrcode,
  vux_src_components_qrcode,
  qrcode___vue_template_functional__,
  qrcode___vue_styles__,
  qrcode___vue_scopeId__,
  qrcode___vue_module_identifier__
)

/* harmony default export */ var node_modules_vux_src_components_qrcode = (qrcode_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/yingxin/tskjxy/views/user/userItem/userinfo.vue






/* harmony default export */ var userinfo = ({
  name: 'user',
  props: [],
  components: {
    XHeader: vux_src_components_x_header,
    Group: vux_src_components_group,
    Cell: vux_src_components_cell,
    Qrcode: node_modules_vux_src_components_qrcode
  },
  data: function data() {
    return {
      userinfo: [{
        id: 0,
        label: '姓名',
        value: ''
      }, {
        id: 1,
        label: '学院',
        value: ''
      }, {
        id: 2,
        label: '专业',
        value: ''
      }, {
        id: 3,
        label: '班级',
        value: ''
      }, {
        id: 4,
        label: '电话',
        value: ''
      }, {
        id: 5,
        label: 'E-mail',
        value: ''
      }, {
        id: 6,
        label: 'QQ',
        value: ''
      }]
    };
  },

  computed: {
    title: function title() {
      return this.$route.meta.title;
    }
  },
  created: function created() {},
  mounted: function mounted() {
    this.$vux.loading.show({
      text: '加载中'
    });
    this.goUserInfo();
  },

  methods: {
    back: function back() {
      var _this = this;

      setTimeout(function () {
        _this.$router.back(-1);
      }, 300);
    },
    goUserInfo: function goUserInfo() {
      var _this2 = this;

      this.$api.get('/user/afterLogin', null, function (r) {
        _this2.$vux.loading.hide();
        var info = r.data.studentBean;
        _this2.userinfo[0].value = info.name;
        _this2.userinfo[1].value = info.departmentName;
        _this2.userinfo[2].value = info.professionName;
        _this2.userinfo[3].value = info.className;
        _this2.userinfo[4].value = info.phoneNumber;
        _this2.userinfo[5].value = info.email;
        _this2.userinfo[6].value = info.qq;
      }, function (err) {
        _this2.$vux.toast.text(err.message, 'middle');
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/yingxin/tskjxy/views/user/userItem/userinfo.vue






/* harmony default export */ var userItem_userinfo = ({
  name: 'user',
  props: [],
  components: {
    XHeader: vux_src_components_x_header,
    Group: vux_src_components_group,
    Cell: vux_src_components_cell,
    Qrcode: node_modules_vux_src_components_qrcode
  },
  data: function data() {
    return {
      userinfo: [{
        id: 0,
        label: '姓名',
        value: ''
      }, {
        id: 1,
        label: '学院',
        value: ''
      }, {
        id: 2,
        label: '专业',
        value: ''
      }, {
        id: 3,
        label: '班级',
        value: ''
      }, {
        id: 4,
        label: '电话',
        value: ''
      }, {
        id: 5,
        label: 'E-mail',
        value: ''
      }, {
        id: 6,
        label: 'QQ',
        value: ''
      }]
    };
  },

  computed: {
    title: function title() {
      return this.$route.meta.title;
    }
  },
  created: function created() {},
  mounted: function mounted() {
    this.$vux.loading.show({
      text: '加载中'
    });
    this.goUserInfo();
  },

  methods: {
    back: function back() {
      var _this = this;

      setTimeout(function () {
        _this.$router.back(-1);
      }, 300);
    },
    goUserInfo: function goUserInfo() {
      var _this2 = this;

      this.$api.get('/user/afterLogin', null, function (r) {
        _this2.$vux.loading.hide();
        var info = r.data.studentBean;
        _this2.userinfo[0].value = info.name;
        _this2.userinfo[1].value = info.departmentName;
        _this2.userinfo[2].value = info.professionName;
        _this2.userinfo[3].value = info.className;
        _this2.userinfo[4].value = info.phoneNumber;
        _this2.userinfo[5].value = info.email;
        _this2.userinfo[6].value = info.qq;
      }, function (err) {
        _this2.$vux.toast.text(err.message, 'middle');
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-307560a9","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/yingxin/tskjxy/views/user/userItem/userinfo.vue
var userinfo_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sub-page"},[_c('x-header',{staticClass:"header bg-white header-fixed"},[_c('em',{staticClass:"icon icon-arrow-left",attrs:{"slot":"overwrite-left","size":""},on:{"click":_vm.back},slot:"overwrite-left"}),_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"fixed-next section"},[_c('group',{staticClass:"user-info"},_vm._l((_vm.userinfo),function(item,index){return (item.value)?_c('cell',{key:item.id,attrs:{"title":item.label,"value":item.value}}):_vm._e()}),1)],1)],1)}
var userinfo_staticRenderFns = []
var userinfo_esExports = { render: userinfo_render, staticRenderFns: userinfo_staticRenderFns }
/* harmony default export */ var user_userItem_userinfo = (userinfo_esExports);
// CONCATENATED MODULE: ./src/yingxin/tskjxy/views/user/userItem/userinfo.vue
var userinfo_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var userinfo___vue_template_functional__ = false
/* styles */
var userinfo___vue_styles__ = null
/* scopeId */
var userinfo___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var userinfo___vue_module_identifier__ = null
var userinfo_Component = userinfo_normalizeComponent(
  userItem_userinfo,
  user_userItem_userinfo,
  userinfo___vue_template_functional__,
  userinfo___vue_styles__,
  userinfo___vue_scopeId__,
  userinfo___vue_module_identifier__
)

/* harmony default export */ var views_user_userItem_userinfo = (userinfo_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/button-tab/button-tab.vue
//
//
//
//
//
//



/* harmony default export */ var button_tab = ({
  name: 'button-tab',
  mixins: [multi_items["b" /* parentMixin */]],
  props: {
    height: Number
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/button-tab/button-tab.vue
//
//
//
//
//
//



/* harmony default export */ var button_tab_button_tab = ({
  name: 'button-tab',
  mixins: [multi_items["b" /* parentMixin */]],
  props: {
    height: Number
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d8bd43de","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/button-tab/button-tab.vue
var button_tab_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-button-group"},[_vm._t("default")],2)}
var button_tab_staticRenderFns = []
var button_tab_esExports = { render: button_tab_render, staticRenderFns: button_tab_staticRenderFns }
/* harmony default export */ var components_button_tab_button_tab = (button_tab_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/button-tab/button-tab.vue
function button_tab_injectStyle (ssrContext) {
  __webpack_require__("JhC5")
}
var button_tab_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var button_tab___vue_template_functional__ = false
/* styles */
var button_tab___vue_styles__ = button_tab_injectStyle
/* scopeId */
var button_tab___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var button_tab___vue_module_identifier__ = null
var button_tab_Component = button_tab_normalizeComponent(
  button_tab_button_tab,
  components_button_tab_button_tab,
  button_tab___vue_template_functional__,
  button_tab___vue_styles__,
  button_tab___vue_scopeId__,
  button_tab___vue_module_identifier__
)

/* harmony default export */ var src_components_button_tab_button_tab = (button_tab_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/button-tab/button-tab-item.vue
//
//
//
//
//
//



/* harmony default export */ var button_tab_item = ({
  name: 'button-tab-item',
  mixins: [multi_items["a" /* childMixin */]],
  computed: {
    classes: function classes() {
      return {
        'vux-button-group-current': this.currentIndex === this.$parent.currentIndex,
        'vux-button-tab-item-first': this.currentIndex === 0,
        'vux-button-tab-item-last': this.currentIndex === this.$parent.$children.length - 1,
        'vux-button-tab-item-middle': this.currentIndex > 0 && this.currentIndex !== this.$parent.$children.length - 1
      };
    },
    style: function style() {
      if (this.$parent.height) {
        return {
          height: this.$parent.height + 'px',
          lineHeight: this.$parent.height + 'px'
        };
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/button-tab/button-tab-item.vue
//
//
//
//
//
//



/* harmony default export */ var button_tab_button_tab_item = ({
  name: 'button-tab-item',
  mixins: [multi_items["a" /* childMixin */]],
  computed: {
    classes: function classes() {
      return {
        'vux-button-group-current': this.currentIndex === this.$parent.currentIndex,
        'vux-button-tab-item-first': this.currentIndex === 0,
        'vux-button-tab-item-last': this.currentIndex === this.$parent.$children.length - 1,
        'vux-button-tab-item-middle': this.currentIndex > 0 && this.currentIndex !== this.$parent.$children.length - 1
      };
    },
    style: function style() {
      if (this.$parent.height) {
        return {
          height: this.$parent.height + 'px',
          lineHeight: this.$parent.height + 'px'
        };
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-673aa6ac","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/button-tab/button-tab-item.vue
var button_tab_item_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"vux-button-tab-item",class:_vm.classes,style:(_vm.style),attrs:{"href":"javascript:"},on:{"click":_vm.onItemClick}},[_vm._t("default")],2)}
var button_tab_item_staticRenderFns = []
var button_tab_item_esExports = { render: button_tab_item_render, staticRenderFns: button_tab_item_staticRenderFns }
/* harmony default export */ var components_button_tab_button_tab_item = (button_tab_item_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/button-tab/button-tab-item.vue
var button_tab_item_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var button_tab_item___vue_template_functional__ = false
/* styles */
var button_tab_item___vue_styles__ = null
/* scopeId */
var button_tab_item___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var button_tab_item___vue_module_identifier__ = null
var button_tab_item_Component = button_tab_item_normalizeComponent(
  button_tab_button_tab_item,
  components_button_tab_button_tab_item,
  button_tab_item___vue_template_functional__,
  button_tab_item___vue_styles__,
  button_tab_item___vue_scopeId__,
  button_tab_item___vue_module_identifier__
)

/* harmony default export */ var src_components_button_tab_button_tab_item = (button_tab_item_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/yingxin/tskjxy/views/user/userItem/myQrcode.vue






/* harmony default export */ var myQrcode = ({
  name: 'user',
  props: [],
  components: {
    XHeader: vux_src_components_x_header,
    Qrcode: node_modules_vux_src_components_qrcode,
    ButtonTab: src_components_button_tab_button_tab,
    ButtonTabItem: src_components_button_tab_button_tab_item
  },
  data: function data() {
    return {
      title: this.$route.meta.title,
      userInfo: this.$store.state.userInfo,
      index: 0
    };
  },

  computed: {},
  created: function created() {},
  mounted: function mounted() {},

  methods: {
    back: function back() {
      var _this = this;

      setTimeout(function () {
        _this.$router.back(-1);
      }, 300);
    },
    select: function select() {
      console.log(this.userInfo);
      console.log(this.index);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/yingxin/tskjxy/views/user/userItem/myQrcode.vue






/* harmony default export */ var userItem_myQrcode = ({
  name: 'user',
  props: [],
  components: {
    XHeader: vux_src_components_x_header,
    Qrcode: node_modules_vux_src_components_qrcode,
    ButtonTab: src_components_button_tab_button_tab,
    ButtonTabItem: src_components_button_tab_button_tab_item
  },
  data: function data() {
    return {
      title: this.$route.meta.title,
      userInfo: this.$store.state.userInfo,
      index: 0
    };
  },

  computed: {},
  created: function created() {},
  mounted: function mounted() {},

  methods: {
    back: function back() {
      var _this = this;

      setTimeout(function () {
        _this.$router.back(-1);
      }, 300);
    },
    select: function select() {
      console.log(this.userInfo);
      console.log(this.index);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5d3fb078","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/yingxin/tskjxy/views/user/userItem/myQrcode.vue
var myQrcode_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sub-page bg-brand"},[_c('x-header',{staticClass:"header bg-transparent fixed"},[_c('em',{staticClass:"icon icon-arrow-left",attrs:{"slot":"overwrite-left","size":""},on:{"click":_vm.back},slot:"overwrite-left"}),_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"section pay-qrcode fixed-next"},[_c('div',{staticClass:"container"},[_c('br'),_c('button-tab',{model:{value:(_vm.index),callback:function ($$v) {_vm.index=$$v},expression:"index"}},[_c('button-tab-item',{attrs:{"selected":""},on:{"on-item-click":function($event){return _vm.select()}}},[_vm._v("学号")]),_c('button-tab-item',{on:{"on-item-click":function($event){return _vm.select()}}},[_vm._v("身份证号")])],1),_c('br'),_c('div',{staticClass:"card bg-white"},[_c('div',{staticClass:"panel"},[_c('div',{staticClass:"panel-head"},[_c('h3',{staticClass:"text-center"},[_vm._v(_vm._s(_vm.userInfo.name))])]),(_vm.index == 0)?_c('div',{staticClass:"panel-body"},[_c('div',{staticClass:"code-box"},[_c('qrcode',{attrs:{"value":_vm.userInfo.sno,"type":"img","size":240}})],1),_c('p',{staticClass:"remark"},[_vm._v("扫一扫上面的二维码，获取我的学号")])]):_vm._e(),(_vm.index == 1)?_c('div',{staticClass:"panel-body"},[_c('div',{staticClass:"code-box"},[_c('qrcode',{attrs:{"value":_vm.userInfo.idNumber,"type":"img","size":240}})],1),_c('p',{staticClass:"remark"},[_vm._v("扫一扫上面的二维码，获取我的身份证号")])]):_vm._e()])])],1)])],1)}
var myQrcode_staticRenderFns = []
var myQrcode_esExports = { render: myQrcode_render, staticRenderFns: myQrcode_staticRenderFns }
/* harmony default export */ var user_userItem_myQrcode = (myQrcode_esExports);
// CONCATENATED MODULE: ./src/yingxin/tskjxy/views/user/userItem/myQrcode.vue
var myQrcode_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var myQrcode___vue_template_functional__ = false
/* styles */
var myQrcode___vue_styles__ = null
/* scopeId */
var myQrcode___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var myQrcode___vue_module_identifier__ = null
var myQrcode_Component = myQrcode_normalizeComponent(
  userItem_myQrcode,
  user_userItem_myQrcode,
  myQrcode___vue_template_functional__,
  myQrcode___vue_styles__,
  myQrcode___vue_scopeId__,
  myQrcode___vue_module_identifier__
)

/* harmony default export */ var views_user_userItem_myQrcode = (myQrcode_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/yingxin/tskjxy/views/user/userItem/fullOffer.vue







/* harmony default export */ var fullOffer = ({
  name: 'user',
  props: [],
  components: {
    XHeader: vux_src_components_x_header,
    Actionsheet: vux_src_components_actionsheet
  },
  directives: {
    TransferDom: transfer_dom["a" /* default */]
  },
  data: function data() {
    return {
      title: this.$route.meta.title,
      innerWidth: (document.documentElement.clientHeight - 48) * 828 / 1355,
      imgsrc: '',
      imgErrorUrl: 'this.src="' + __webpack_require__("rPBl") + '"'
    };
  },

  computed: extends_default()({}, Object(vuex_esm["c" /* mapState */])({
    token: function token(state) {
      return state.token;
    }
  })),
  created: function created() {},
  mounted: function mounted() {},

  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])(['LogoutAction']), {
    back: function back() {
      var _this = this;

      setTimeout(function () {
        _this.$router.back(-1);
      }, 300);
    },
    Login: function Login() {
      this.$router.push({
        name: 'login'
      });
    }
  })
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/yingxin/tskjxy/views/user/userItem/fullOffer.vue







/* harmony default export */ var userItem_fullOffer = ({
  name: 'user',
  props: [],
  components: {
    XHeader: vux_src_components_x_header,
    Actionsheet: vux_src_components_actionsheet
  },
  directives: {
    TransferDom: transfer_dom["a" /* default */]
  },
  data: function data() {
    return {
      title: this.$route.meta.title,
      innerWidth: (document.documentElement.clientHeight - 48) * 828 / 1355,
      imgsrc: '',
      imgErrorUrl: 'this.src="' + __webpack_require__("rPBl") + '"'
    };
  },

  computed: extends_default()({}, Object(vuex_esm["c" /* mapState */])({
    token: function token(state) {
      return state.token;
    }
  })),
  created: function created() {},
  mounted: function mounted() {},

  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])(['LogoutAction']), {
    back: function back() {
      var _this = this;

      setTimeout(function () {
        _this.$router.back(-1);
      }, 300);
    },
    Login: function Login() {
      this.$router.push({
        name: 'login'
      });
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a647d962","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/yingxin/tskjxy/views/user/userItem/fullOffer.vue
var fullOffer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sub-page fullOffer"},[_c('x-header',{staticClass:"header bg-white fixed"},[_c('em',{staticClass:"icon icon-arrow-left",attrs:{"slot":"overwrite-left","size":""},on:{"click":_vm.back},slot:"overwrite-left"}),_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"fixed-next"},[_c('div',{staticClass:"inner"},[_c('img',{attrs:{"src":__webpack_require__("xNht")}}),_c('img',{staticClass:"photo",attrs:{"src":_vm.imgsrc,"onerror":_vm.imgErrorUrl}}),_c('h2',{staticClass:"title line css1ae1c896c3201d4"},[_vm._v("本科生录取通知书")]),_vm._m(0),_c('div',{staticClass:"author line css1ae1c896c3201d4"},[_vm._v("西安交通大学")]),_c('div',{staticClass:"date line css1ae1c896c3201d4"},[_vm._v("2019年7月")]),_c('div',{staticClass:"bar-code"})])])],1)}
var fullOffer_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"line content"},[_c('div',{staticClass:"student css1ae1c896c3201d4"},[_vm._v("同学："),_c('span',[_vm._v("刘小强")])]),_c('div',[_c('span',{staticClass:"css1ae1c896c3201d4"},[_vm._v(" 祝贺你取得优异成绩，经批准，被我校录取到")]),_c('span',{staticClass:"major"},[_vm._v("网络工程")]),_c('span',{staticClass:"css1ae1c896c3201d4"},[_vm._v(" 专业学习。请持此《录取通知书》于9月1日值3日到校报到。")])])])}]
var fullOffer_esExports = { render: fullOffer_render, staticRenderFns: fullOffer_staticRenderFns }
/* harmony default export */ var user_userItem_fullOffer = (fullOffer_esExports);
// CONCATENATED MODULE: ./src/yingxin/tskjxy/views/user/userItem/fullOffer.vue
var fullOffer_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var fullOffer___vue_template_functional__ = false
/* styles */
var fullOffer___vue_styles__ = null
/* scopeId */
var fullOffer___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var fullOffer___vue_module_identifier__ = null
var fullOffer_Component = fullOffer_normalizeComponent(
  userItem_fullOffer,
  user_userItem_fullOffer,
  fullOffer___vue_template_functional__,
  fullOffer___vue_styles__,
  fullOffer___vue_scopeId__,
  fullOffer___vue_module_identifier__
)

/* harmony default export */ var views_user_userItem_fullOffer = (fullOffer_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/yingxin/tskjxy/views/user/userItem/findClassmate.vue







/* harmony default export */ var findClassmate = ({
  name: 'user',
  props: [],
  components: {
    XHeader: vux_src_components_x_header,
    Group: vux_src_components_group,
    Cell: vux_src_components_cell,
    Tab: src_components_tab_tab,
    TabItem: src_components_tab_tab_item
  },
  data: function data() {
    return {
      titlepage: this.$route.meta.title,
      index: 0,
      listTitle: ['同省', '同市', '同区', '同学院', '同专业', '同班级', '同宿舍'],
      list: [{
        id: 0,
        label: '李明',
        phone: '17691237215',
        isShow: true
      }, {
        id: 1,
        label: '李明',
        phone: '17691237215',
        isShow: false
      }, {
        id: 2,
        label: '李明',
        phone: '17691237215',
        isShow: false
      }, {
        id: 3,
        label: '李明',
        phone: '17691237215',
        isShow: true
      }, {
        id: 4,
        label: '李明',
        phone: '17691237215',
        isShow: true
      }, {
        id: 5,
        label: '李明',
        phone: '17691237215',
        isShow: true
      }, {
        id: 6,
        label: '李明',
        phone: '17691237215',
        isShow: true
      }, {
        id: 7,
        label: '李明',
        phone: '17691237215',
        isShow: true
      }]
    };
  },

  computed: {
    title: function title() {
      return this.$route.meta.title;
    }
  },
  created: function created() {},
  mounted: function mounted() {},

  methods: {
    back: function back() {
      var _this = this;

      setTimeout(function () {
        _this.$router.back(-1);
      }, 300);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/yingxin/tskjxy/views/user/userItem/findClassmate.vue







/* harmony default export */ var userItem_findClassmate = ({
  name: 'user',
  props: [],
  components: {
    XHeader: vux_src_components_x_header,
    Group: vux_src_components_group,
    Cell: vux_src_components_cell,
    Tab: src_components_tab_tab,
    TabItem: src_components_tab_tab_item
  },
  data: function data() {
    return {
      titlepage: this.$route.meta.title,
      index: 0,
      listTitle: ['同省', '同市', '同区', '同学院', '同专业', '同班级', '同宿舍'],
      list: [{
        id: 0,
        label: '李明',
        phone: '17691237215',
        isShow: true
      }, {
        id: 1,
        label: '李明',
        phone: '17691237215',
        isShow: false
      }, {
        id: 2,
        label: '李明',
        phone: '17691237215',
        isShow: false
      }, {
        id: 3,
        label: '李明',
        phone: '17691237215',
        isShow: true
      }, {
        id: 4,
        label: '李明',
        phone: '17691237215',
        isShow: true
      }, {
        id: 5,
        label: '李明',
        phone: '17691237215',
        isShow: true
      }, {
        id: 6,
        label: '李明',
        phone: '17691237215',
        isShow: true
      }, {
        id: 7,
        label: '李明',
        phone: '17691237215',
        isShow: true
      }]
    };
  },

  computed: {
    title: function title() {
      return this.$route.meta.title;
    }
  },
  created: function created() {},
  mounted: function mounted() {},

  methods: {
    back: function back() {
      var _this = this;

      setTimeout(function () {
        _this.$router.back(-1);
      }, 300);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-10e472cd","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/yingxin/tskjxy/views/user/userItem/findClassmate.vue
var findClassmate_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sub-page"},[_c('x-header',{staticClass:"header bg-white border-bottom fixed"},[_c('em',{staticClass:"icon icon-arrow-left",attrs:{"slot":"overwrite-left","size":""},on:{"click":_vm.back},slot:"overwrite-left"}),_vm._v(_vm._s(_vm.titlepage))]),_c('div',{staticClass:"tab-box fixed-next tab-top"},[_c('div',{staticClass:"tab-outer",attrs:{"id":"tab-outer"}},[_c('tab',{attrs:{"line-width":2,"active-color":"#FEAA33"},model:{value:(_vm.index),callback:function ($$v) {_vm.index=$$v},expression:"index"}},_vm._l((_vm.listTitle),function(n){return _c('tab-item',{key:n},[_vm._v(_vm._s(n))])}),1)],1)]),_c('group',{staticClass:"tab-outside-next find-classmate section"},_vm._l((_vm.list),function(item,index){return _c('cell',{key:item.id,attrs:{"title":item.label,"value":item.isShow ? item.phone : '',"link":{name: 'findClassmateDetail'}}},[_c('i',{attrs:{"slot":"icon"},slot:"icon"})])}),1),_c('transition',{attrs:{"name":"slide","enter-active-class":"animated fastest slideInRight","leave-active-class":"animated fastest slideOutRight"}},[_c('router-view')],1)],1)}
var findClassmate_staticRenderFns = []
var findClassmate_esExports = { render: findClassmate_render, staticRenderFns: findClassmate_staticRenderFns }
/* harmony default export */ var user_userItem_findClassmate = (findClassmate_esExports);
// CONCATENATED MODULE: ./src/yingxin/tskjxy/views/user/userItem/findClassmate.vue
var findClassmate_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var findClassmate___vue_template_functional__ = false
/* styles */
var findClassmate___vue_styles__ = null
/* scopeId */
var findClassmate___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var findClassmate___vue_module_identifier__ = null
var findClassmate_Component = findClassmate_normalizeComponent(
  userItem_findClassmate,
  user_userItem_findClassmate,
  findClassmate___vue_template_functional__,
  findClassmate___vue_styles__,
  findClassmate___vue_scopeId__,
  findClassmate___vue_module_identifier__
)

/* harmony default export */ var views_user_userItem_findClassmate = (findClassmate_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/yingxin/tskjxy/views/user/userItem/findClassmate/findClassmateDetail.vue







/* harmony default export */ var findClassmateDetail = ({
  name: 'user',
  props: [],
  components: {
    XHeader: vux_src_components_x_header,
    Group: vux_src_components_group,
    Cell: vux_src_components_cell,
    Tab: src_components_tab_tab,
    TabItem: src_components_tab_tab_item
  },
  data: function data() {
    return {
      titlepage: this.$route.meta.title,
      index: 0,
      listTitle: ['同学院', '同专业', '同班级', '同宿舍', '同省', '同市', '同区'],
      info: [{
        id: 0,
        label: '姓名',
        content: '张小明',
        isShow: true
      }, {
        id: 1,
        label: '生物学',
        content: '17691237215',
        isShow: false
      }, {
        id: 2,
        label: '手机',
        content: '17691237215',
        isShow: false
      }, {
        id: 3,
        label: '邮箱',
        content: '18922@qq.com',
        isShow: true
      }, {
        id: 4,
        label: 'QQ',
        content: '457237215',
        isShow: true
      }, {
        id: 5,
        label: '微信',
        content: '17691237215',
        isShow: true
      }]
    };
  },

  computed: {
    title: function title() {
      return this.$route.meta.title;
    }
  },
  created: function created() {},
  mounted: function mounted() {},

  methods: {
    back: function back() {
      var _this = this;

      setTimeout(function () {
        _this.$router.back(-1);
      }, 300);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/yingxin/tskjxy/views/user/userItem/findClassmate/findClassmateDetail.vue







/* harmony default export */ var findClassmate_findClassmateDetail = ({
  name: 'user',
  props: [],
  components: {
    XHeader: vux_src_components_x_header,
    Group: vux_src_components_group,
    Cell: vux_src_components_cell,
    Tab: src_components_tab_tab,
    TabItem: src_components_tab_tab_item
  },
  data: function data() {
    return {
      titlepage: this.$route.meta.title,
      index: 0,
      listTitle: ['同学院', '同专业', '同班级', '同宿舍', '同省', '同市', '同区'],
      info: [{
        id: 0,
        label: '姓名',
        content: '张小明',
        isShow: true
      }, {
        id: 1,
        label: '生物学',
        content: '17691237215',
        isShow: false
      }, {
        id: 2,
        label: '手机',
        content: '17691237215',
        isShow: false
      }, {
        id: 3,
        label: '邮箱',
        content: '18922@qq.com',
        isShow: true
      }, {
        id: 4,
        label: 'QQ',
        content: '457237215',
        isShow: true
      }, {
        id: 5,
        label: '微信',
        content: '17691237215',
        isShow: true
      }]
    };
  },

  computed: {
    title: function title() {
      return this.$route.meta.title;
    }
  },
  created: function created() {},
  mounted: function mounted() {},

  methods: {
    back: function back() {
      var _this = this;

      setTimeout(function () {
        _this.$router.back(-1);
      }, 300);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2e37076f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/yingxin/tskjxy/views/user/userItem/findClassmate/findClassmateDetail.vue
var findClassmateDetail_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sub-page"},[_c('x-header',{staticClass:"header bg-white fixed border-bottom"},[_c('em',{staticClass:"icon icon-arrow-left",attrs:{"slot":"overwrite-left","size":""},on:{"click":_vm.back},slot:"overwrite-left"}),_vm._v(_vm._s(_vm.titlepage))]),_c('group',{staticClass:"fixed-next tab-outside-next section"},_vm._l((_vm.info),function(item,index){return _c('cell',{key:item.id,attrs:{"title":item.label,"value":item.isShow ? item.content : ''}},[_c('i',{attrs:{"slot":"icon"},slot:"icon"})])}),1)],1)}
var findClassmateDetail_staticRenderFns = []
var findClassmateDetail_esExports = { render: findClassmateDetail_render, staticRenderFns: findClassmateDetail_staticRenderFns }
/* harmony default export */ var userItem_findClassmate_findClassmateDetail = (findClassmateDetail_esExports);
// CONCATENATED MODULE: ./src/yingxin/tskjxy/views/user/userItem/findClassmate/findClassmateDetail.vue
var findClassmateDetail_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var findClassmateDetail___vue_template_functional__ = false
/* styles */
var findClassmateDetail___vue_styles__ = null
/* scopeId */
var findClassmateDetail___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var findClassmateDetail___vue_module_identifier__ = null
var findClassmateDetail_Component = findClassmateDetail_normalizeComponent(
  findClassmate_findClassmateDetail,
  userItem_findClassmate_findClassmateDetail,
  findClassmateDetail___vue_template_functional__,
  findClassmateDetail___vue_styles__,
  findClassmateDetail___vue_scopeId__,
  findClassmateDetail___vue_module_identifier__
)

/* harmony default export */ var user_userItem_findClassmate_findClassmateDetail = (findClassmateDetail_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/tip/index.vue
//
//
//
//
//
//

/* harmony default export */ var tip = ({
  name: 'tip',
  props: {
    align: {
      type: String,
      default: 'left'
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/tip/index.vue
//
//
//
//
//
//

/* harmony default export */ var components_tip = ({
  name: 'tip',
  props: {
    align: {
      type: String,
      default: 'left'
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-09e4095d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/tip/index.vue
var tip_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-group-tip",style:({'text-align':_vm.align})},[_vm._t("default")],2)}
var tip_staticRenderFns = []
var tip_esExports = { render: tip_render, staticRenderFns: tip_staticRenderFns }
/* harmony default export */ var src_components_tip = (tip_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/tip/index.vue
function tip_injectStyle (ssrContext) {
  __webpack_require__("BCGI")
}
var tip_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var tip___vue_template_functional__ = false
/* styles */
var tip___vue_styles__ = tip_injectStyle
/* scopeId */
var tip___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var tip___vue_module_identifier__ = null
var tip_Component = tip_normalizeComponent(
  components_tip,
  src_components_tip,
  tip___vue_template_functional__,
  tip___vue_styles__,
  tip___vue_scopeId__,
  tip___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_tip = (tip_Component.exports);

// EXTERNAL MODULE: ./node_modules/array-shuffle/index.js
var array_shuffle = __webpack_require__("HHx2");
var array_shuffle_default = /*#__PURE__*/__webpack_require__.n(array_shuffle);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/checklist/index.vue


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ var checklist = ({
  name: 'checklist',
  components: {
    Tip: vux_src_components_tip,
    Icon: vux_src_components_icon,
    InlineDesc: vux_src_components_inline_desc
  },
  filters: {
    getValue: object_filter["e" /* getValue */],
    getKey: object_filter["b" /* getKey */]
  },
  mixins: [base["a" /* default */]],
  props: {
    name: String,
    showError: Boolean,
    title: String,
    required: {
      type: Boolean,
      default: false
    },
    options: {
      type: Array,
      required: true
    },
    value: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    max: Number,
    min: Number,
    fillMode: Boolean,
    randomOrder: Boolean,
    checkDisabled: {
      type: Boolean,
      default: true
    },
    labelPosition: {
      type: String,
      default: 'right'
    },
    disabled: Boolean
  },
  data: function data() {
    return {
      currentValue: [],
      currentOptions: this.options,
      tempValue: '' // used only for radio mode
    };
  },
  beforeUpdate: function beforeUpdate() {
    if (this.isRadio) {
      var length = this.currentValue.length;
      if (length > 1) {
        this.currentValue = [this.currentValue[length - 1]];
      }
      var val = pure(this.currentValue);
      this.tempValue = val.length ? val[0] : '';
    }
  },
  created: function created() {
    this.handleChangeEvent = true;
    if (this.value) {
      this.currentValue = this.value;
      if (this.isRadio) {
        this.tempValue = this.isRadio ? this.value[0] : this.value;
      }
    }
    if (this.randomOrder) {
      this.currentOptions = array_shuffle_default()(this.options);
    } else {
      this.currentOptions = this.options;
    }
  },

  methods: {
    getValue: object_filter["e" /* getValue */],
    getKey: object_filter["b" /* getKey */],
    getInlineDesc: object_filter["a" /* getInlineDesc */],
    getFullValue: function getFullValue() {
      var labels = Object(object_filter["d" /* getLabels */])(this.options, this.value);
      return this.currentValue.map(function (one, index) {
        return {
          value: one,
          label: labels[index]
        };
      });
    },
    isDisabled: function isDisabled(key) {
      if (!this.checkDisabled) {
        return false;
      }
      if (this._max > 1) {
        return this.currentValue.indexOf(key) === -1 && this.currentValue.length === this._max;
      }
      return false;
    }
  },
  computed: {
    isRadio: function isRadio() {
      if (typeof this.max === 'undefined') {
        return false;
      } else {
        return this.max === 1;
      }
    },
    _total: function _total() {
      return this.fillMode ? this.options.length + 1 : this.options.length;
    },
    _min: function _min() {
      if (!this.required && !this.min) {
        return 0;
      }
      if (!this.required && this.min) {
        return Math.min(this._total, this.min);
      }
      if (this.required) {
        if (this.min) {
          var max = Math.max(1, this.min);
          return Math.min(this._total, max);
        } else {
          return 1;
        }
      }
    },
    _max: function _max() {
      if (!this.required && !this.max) {
        return this._total;
      }
      if (this.max) {
        if (this.max > this._total) {
          return this._total;
        }
        return this.max;
      } else {
        return this._total;
      }
    },
    valid: function valid() {
      return this.currentValue.length >= this._min && this.currentValue.length <= this._max;
    }
  },
  watch: {
    tempValue: function tempValue(val) {
      var _val = val ? [val] : [];
      this.$emit('input', _val);
      this.$emit('on-change', _val, Object(object_filter["d" /* getLabels */])(this.options, _val));
    },
    value: function value(newVal) {
      if (stringify_default()(newVal) !== stringify_default()(this.currentValue)) {
        this.currentValue = newVal;
      }
    },
    options: function options(val) {
      this.currentOptions = val;
    },
    currentValue: function currentValue(newVal) {
      var val = pure(newVal);

      if (!this.isRadio) {
        this.$emit('input', val);
        this.$emit('on-change', val, Object(object_filter["d" /* getLabels */])(this.options, val));
        var err = {};
        if (this._min) {
          if (this.required) {
            if (this.currentValue.length < this._min) {
              err = {
                min: this._min
              };
            }
          } else {
            if (this.currentValue.length && this.currentValue.length < this._min) {
              err = {
                min: this._min
              };
            }
          }
        }
        if (!this.valid && this.dirty && keys_default()(err).length) {
          this.$emit('on-error', err);
        } else {
          this.$emit('on-clear-error');
        }
      }
    }
  }
});
function pure(obj) {
  return JSON.parse(stringify_default()(obj));
}
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/checklist/index.vue


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ var components_checklist = ({
  name: 'checklist',
  components: {
    Tip: vux_src_components_tip,
    Icon: vux_src_components_icon,
    InlineDesc: vux_src_components_inline_desc
  },
  filters: {
    getValue: object_filter["e" /* getValue */],
    getKey: object_filter["b" /* getKey */]
  },
  mixins: [base["a" /* default */]],
  props: {
    name: String,
    showError: Boolean,
    title: String,
    required: {
      type: Boolean,
      default: false
    },
    options: {
      type: Array,
      required: true
    },
    value: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    max: Number,
    min: Number,
    fillMode: Boolean,
    randomOrder: Boolean,
    checkDisabled: {
      type: Boolean,
      default: true
    },
    labelPosition: {
      type: String,
      default: 'right'
    },
    disabled: Boolean
  },
  data: function data() {
    return {
      currentValue: [],
      currentOptions: this.options,
      tempValue: '' // used only for radio mode
    };
  },
  beforeUpdate: function beforeUpdate() {
    if (this.isRadio) {
      var length = this.currentValue.length;
      if (length > 1) {
        this.currentValue = [this.currentValue[length - 1]];
      }
      var val = checklist_pure(this.currentValue);
      this.tempValue = val.length ? val[0] : '';
    }
  },
  created: function created() {
    this.handleChangeEvent = true;
    if (this.value) {
      this.currentValue = this.value;
      if (this.isRadio) {
        this.tempValue = this.isRadio ? this.value[0] : this.value;
      }
    }
    if (this.randomOrder) {
      this.currentOptions = array_shuffle_default()(this.options);
    } else {
      this.currentOptions = this.options;
    }
  },

  methods: {
    getValue: object_filter["e" /* getValue */],
    getKey: object_filter["b" /* getKey */],
    getInlineDesc: object_filter["a" /* getInlineDesc */],
    getFullValue: function getFullValue() {
      var labels = Object(object_filter["d" /* getLabels */])(this.options, this.value);
      return this.currentValue.map(function (one, index) {
        return {
          value: one,
          label: labels[index]
        };
      });
    },
    isDisabled: function isDisabled(key) {
      if (!this.checkDisabled) {
        return false;
      }
      if (this._max > 1) {
        return this.currentValue.indexOf(key) === -1 && this.currentValue.length === this._max;
      }
      return false;
    }
  },
  computed: {
    isRadio: function isRadio() {
      if (typeof this.max === 'undefined') {
        return false;
      } else {
        return this.max === 1;
      }
    },
    _total: function _total() {
      return this.fillMode ? this.options.length + 1 : this.options.length;
    },
    _min: function _min() {
      if (!this.required && !this.min) {
        return 0;
      }
      if (!this.required && this.min) {
        return Math.min(this._total, this.min);
      }
      if (this.required) {
        if (this.min) {
          var max = Math.max(1, this.min);
          return Math.min(this._total, max);
        } else {
          return 1;
        }
      }
    },
    _max: function _max() {
      if (!this.required && !this.max) {
        return this._total;
      }
      if (this.max) {
        if (this.max > this._total) {
          return this._total;
        }
        return this.max;
      } else {
        return this._total;
      }
    },
    valid: function valid() {
      return this.currentValue.length >= this._min && this.currentValue.length <= this._max;
    }
  },
  watch: {
    tempValue: function tempValue(val) {
      var _val = val ? [val] : [];
      this.$emit('input', _val);
      this.$emit('on-change', _val, Object(object_filter["d" /* getLabels */])(this.options, _val));
    },
    value: function value(newVal) {
      if (stringify_default()(newVal) !== stringify_default()(this.currentValue)) {
        this.currentValue = newVal;
      }
    },
    options: function options(val) {
      this.currentOptions = val;
    },
    currentValue: function currentValue(newVal) {
      var val = checklist_pure(newVal);

      if (!this.isRadio) {
        this.$emit('input', val);
        this.$emit('on-change', val, Object(object_filter["d" /* getLabels */])(this.options, val));
        var err = {};
        if (this._min) {
          if (this.required) {
            if (this.currentValue.length < this._min) {
              err = {
                min: this._min
              };
            }
          } else {
            if (this.currentValue.length && this.currentValue.length < this._min) {
              err = {
                min: this._min
              };
            }
          }
        }
        if (!this.valid && this.dirty && keys_default()(err).length) {
          this.$emit('on-error', err);
        } else {
          this.$emit('on-clear-error');
        }
      }
    }
  }
});
function checklist_pure(obj) {
  return JSON.parse(stringify_default()(obj));
}
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2c4e59bc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/checklist/index.vue
var checklist_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.disabled ? 'vux-checklist-disabled' : ''},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.title),expression:"title"}],staticClass:"weui-cells__title"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_vm._t("after-title"),_vm._v(" "),_c('div',{staticClass:"weui-cells weui-cells_checkbox"},_vm._l((_vm.currentOptions),function(one,index){return _c('label',{staticClass:"weui-cell weui-check_label",class:{
        'vux-checklist-label-left': _vm.labelPosition === 'left'
      },attrs:{"for":("checkbox_" + _vm.uuid + "_" + index)}},[_c('div',{staticClass:"weui-cell__hd"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentValue),expression:"currentValue"}],staticClass:"weui-check",attrs:{"type":"checkbox","name":("vux-checkbox-" + _vm.uuid),"id":_vm.disabled ? '' : ("checkbox_" + _vm.uuid + "_" + index),"disabled":_vm.isDisabled(_vm.getKey(one))},domProps:{"value":_vm.getKey(one),"checked":Array.isArray(_vm.currentValue)?_vm._i(_vm.currentValue,_vm.getKey(one))>-1:(_vm.currentValue)},on:{"change":function($event){var $$a=_vm.currentValue,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=_vm.getKey(one),$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.currentValue=$$a.concat([$$v]))}else{$$i>-1&&(_vm.currentValue=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.currentValue=$$c}}}}),_vm._v(" "),_c('i',{staticClass:"weui-icon-checked vux-checklist-icon-checked"})]),_vm._v(" "),_c('div',{staticClass:"weui-cell__bd"},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.getValue(one))}}),_vm._v(" "),(_vm.getInlineDesc(one))?_c('inline-desc',[_vm._v(_vm._s(_vm.getInlineDesc(one)))]):_vm._e()],1)])}),0),_vm._v(" "),_vm._t("footer")],2)}
var checklist_staticRenderFns = []
var checklist_esExports = { render: checklist_render, staticRenderFns: checklist_staticRenderFns }
/* harmony default export */ var src_components_checklist = (checklist_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/checklist/index.vue
function checklist_injectStyle (ssrContext) {
  __webpack_require__("PuPU")
}
var checklist_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var checklist___vue_template_functional__ = false
/* styles */
var checklist___vue_styles__ = checklist_injectStyle
/* scopeId */
var checklist___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var checklist___vue_module_identifier__ = null
var checklist_Component = checklist_normalizeComponent(
  components_checklist,
  src_components_checklist,
  checklist___vue_template_functional__,
  checklist___vue_styles__,
  checklist___vue_scopeId__,
  checklist___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_checklist = (checklist_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/yingxin/tskjxy/views/user/userItem/donate.vue









/* harmony default export */ var donate = ({
  name: 'user',
  props: [],
  components: {
    XHeader: vux_src_components_x_header,
    Group: vux_src_components_group,
    XButton: vux_src_components_x_button,
    XSwitch: vux_src_components_x_switch,
    Checklist: vux_src_components_checklist
  },
  data: function data() {
    return {
      title: this.$route.meta.title,
      value: ['0'],
      isEdit: false,
      donateId: '',
      btnText: '',
      isList: [{ key: '1', value: '捐赠' }, { key: '0', value: '不捐赠' }],
      tips: '根据《关于做好2015届毕业生离校工作的通知》（西交就（2015）5号）文件精神，学校基金会倡议，毕业生可将校园卡中余额捐赠给学校，以助学校未来发展。卡内余额将在校园卡功能失效一个月后，转到学校教育基金会设立的捐款账户。'
    };
  },

  computed: extends_default()({
    value1: function value1() {
      if (this.value[0] === '0') {
        return 0;
      } else {
        return 1;
      }
    }
  }, Object(vuex_esm["c" /* mapState */])({
    token: function token(state) {
      return state.token;
    },
    flowId: function flowId(state) {
      return state.flowInfo.flowId;
    },
    studentId: function studentId(state) {
      return state.userInfo.id;
    }
  })),
  created: function created() {},
  mounted: function mounted() {
    this.getDonte();
  },

  methods: {
    back: function back() {
      var _this = this;

      setTimeout(function () {
        _this.$router.back(-1);
      }, 300);
    },
    change: function change(value, label) {},
    getDonte: function getDonte() {
      var _this2 = this;

      this.$vux.loading.show({
        text: '加载中'
      });
      var params = {};
      params.flowId = this.flowId;
      params.studentId = this.studentId;
      this.$api.get('/donation', params, function (r) {
        _this2.$vux.loading.hide();
        if (r.data.length > 0) {
          if (r.data[0].will) {
            _this2.value = ['1'];
          } else {
            _this2.value = ['0'];
          }
          _this2.isEdit = true;
          _this2.donateId = r.data[0].id;
          _this2.btnText = '重新提交';
        } else {
          _this2.btnText = '提交';
        }
      }, function (err) {
        _this2.$vux.toast.text(err.message, 'middle');
      });
    },
    postDonte: function postDonte() {
      var _this3 = this;

      var params = {};
      params.flowId = this.flowId;
      params.studentId = this.studentId;
      params.will = this.value1;
      this.$api.post('/donation', params, function (r) {
        _this3.$vux.loading.hide();
        var msg = params.will ? '余额已捐赠' : '余额未捐赠';
        _this3.$vux.toast.text('提交成功，' + msg, 'middle');
      }, function (err) {
        _this3.$vux.toast.text(err.message, 'middle');
      });
    },
    putDonte: function putDonte() {
      var _this4 = this;

      var params = {};
      params.flowId = this.flowId;
      params.studentId = this.studentId;
      params.will = this.value1;
      params.id = this.donateId;
      this.$api.put('/donation', params, function (r) {
        _this4.$vux.loading.hide();
        var msg = params.will ? '余额已捐赠' : '余额未捐赠';
        _this4.$vux.toast.text('提交成功，' + msg, 'middle');
      }, function (err) {
        _this4.$vux.toast.text(err.message, 'middle');
      });
    },
    submit: function submit() {
      if (this.isEdit) {
        this.putDonte();
      } else {
        this.postDonte();
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/yingxin/tskjxy/views/user/userItem/donate.vue









/* harmony default export */ var userItem_donate = ({
  name: 'user',
  props: [],
  components: {
    XHeader: vux_src_components_x_header,
    Group: vux_src_components_group,
    XButton: vux_src_components_x_button,
    XSwitch: vux_src_components_x_switch,
    Checklist: vux_src_components_checklist
  },
  data: function data() {
    return {
      title: this.$route.meta.title,
      value: ['0'],
      isEdit: false,
      donateId: '',
      btnText: '',
      isList: [{ key: '1', value: '捐赠' }, { key: '0', value: '不捐赠' }],
      tips: '根据《关于做好2015届毕业生离校工作的通知》（西交就（2015）5号）文件精神，学校基金会倡议，毕业生可将校园卡中余额捐赠给学校，以助学校未来发展。卡内余额将在校园卡功能失效一个月后，转到学校教育基金会设立的捐款账户。'
    };
  },

  computed: extends_default()({
    value1: function value1() {
      if (this.value[0] === '0') {
        return 0;
      } else {
        return 1;
      }
    }
  }, Object(vuex_esm["c" /* mapState */])({
    token: function token(state) {
      return state.token;
    },
    flowId: function flowId(state) {
      return state.flowInfo.flowId;
    },
    studentId: function studentId(state) {
      return state.userInfo.id;
    }
  })),
  created: function created() {},
  mounted: function mounted() {
    this.getDonte();
  },

  methods: {
    back: function back() {
      var _this = this;

      setTimeout(function () {
        _this.$router.back(-1);
      }, 300);
    },
    change: function change(value, label) {},
    getDonte: function getDonte() {
      var _this2 = this;

      this.$vux.loading.show({
        text: '加载中'
      });
      var params = {};
      params.flowId = this.flowId;
      params.studentId = this.studentId;
      this.$api.get('/donation', params, function (r) {
        _this2.$vux.loading.hide();
        if (r.data.length > 0) {
          if (r.data[0].will) {
            _this2.value = ['1'];
          } else {
            _this2.value = ['0'];
          }
          _this2.isEdit = true;
          _this2.donateId = r.data[0].id;
          _this2.btnText = '重新提交';
        } else {
          _this2.btnText = '提交';
        }
      }, function (err) {
        _this2.$vux.toast.text(err.message, 'middle');
      });
    },
    postDonte: function postDonte() {
      var _this3 = this;

      var params = {};
      params.flowId = this.flowId;
      params.studentId = this.studentId;
      params.will = this.value1;
      this.$api.post('/donation', params, function (r) {
        _this3.$vux.loading.hide();
        var msg = params.will ? '余额已捐赠' : '余额未捐赠';
        _this3.$vux.toast.text('提交成功，' + msg, 'middle');
      }, function (err) {
        _this3.$vux.toast.text(err.message, 'middle');
      });
    },
    putDonte: function putDonte() {
      var _this4 = this;

      var params = {};
      params.flowId = this.flowId;
      params.studentId = this.studentId;
      params.will = this.value1;
      params.id = this.donateId;
      this.$api.put('/donation', params, function (r) {
        _this4.$vux.loading.hide();
        var msg = params.will ? '余额已捐赠' : '余额未捐赠';
        _this4.$vux.toast.text('提交成功，' + msg, 'middle');
      }, function (err) {
        _this4.$vux.toast.text(err.message, 'middle');
      });
    },
    submit: function submit() {
      if (this.isEdit) {
        this.putDonte();
      } else {
        this.postDonte();
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-226a5df5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/yingxin/tskjxy/views/user/userItem/donate.vue
var donate_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sub-page"},[_c('x-header',{staticClass:"header bg-white fixed"},[_c('em',{staticClass:"icon icon-arrow-left",attrs:{"slot":"overwrite-left","size":""},on:{"click":_vm.back},slot:"overwrite-left"}),_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"fixed-next donate"},[_c('group',{attrs:{"title":""}},[_c('div',{staticClass:"tips"},[_vm._v(_vm._s(_vm.tips))])])],1),_c('div',{staticClass:"section"},[_c('h4',{staticClass:"container"},[_vm._v("是否捐出校园卡余额")]),_c('checklist',{attrs:{"options":_vm.isList,"max":1,"label-position":"left"},on:{"on-change":_vm.change},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})],1),_c('div',{staticClass:"button-group fixed bottom container"},[_c('x-button',{attrs:{"type":"brand"},nativeOn:{"click":function($event){return _vm.submit($event)}}},[_vm._v(_vm._s(_vm.btnText))])],1)],1)}
var donate_staticRenderFns = []
var donate_esExports = { render: donate_render, staticRenderFns: donate_staticRenderFns }
/* harmony default export */ var user_userItem_donate = (donate_esExports);
// CONCATENATED MODULE: ./src/yingxin/tskjxy/views/user/userItem/donate.vue
var donate_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var donate___vue_template_functional__ = false
/* styles */
var donate___vue_styles__ = null
/* scopeId */
var donate___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var donate___vue_module_identifier__ = null
var donate_Component = donate_normalizeComponent(
  userItem_donate,
  user_userItem_donate,
  donate___vue_template_functional__,
  donate___vue_styles__,
  donate___vue_scopeId__,
  donate___vue_module_identifier__
)

/* harmony default export */ var views_user_userItem_donate = (donate_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/yingxin/tskjxy/views/user/userItem/privacy.vue






/* harmony default export */ var privacy = ({
  name: 'user',
  props: [],
  components: {
    XHeader: vux_src_components_x_header,
    Group: vux_src_components_group,
    XButton: vux_src_components_x_button,
    XSwitch: vux_src_components_x_switch
  },
  data: function data() {
    return {
      titlepage: this.$route.meta.title,
      list: [{
        id: 0,
        label: '学院',
        value: true
      }, {
        id: 1,
        label: '专业',
        value: true
      }, {
        id: 2,
        label: '班级',
        value: true
      }, {
        id: 3,
        label: 'QQ',
        value: true
      }, {
        id: 4,
        label: '微信',
        value: true
      }, {
        id: 5,
        label: '邮箱',
        value: true
      }, {
        id: 6,
        label: '联系电话',
        value: true
      }, {
        id: 7,
        label: '生源地',
        value: true
      }, {
        id: 8,
        label: '宿舍信息',
        value: true
      }]
    };
  },

  computed: {
    title: function title() {
      return this.$route.meta.title;
    }
  },
  created: function created() {},
  mounted: function mounted() {},

  methods: {
    back: function back() {
      var _this = this;

      setTimeout(function () {
        _this.$router.back(-1);
      }, 300);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/yingxin/tskjxy/views/user/userItem/privacy.vue






/* harmony default export */ var userItem_privacy = ({
  name: 'user',
  props: [],
  components: {
    XHeader: vux_src_components_x_header,
    Group: vux_src_components_group,
    XButton: vux_src_components_x_button,
    XSwitch: vux_src_components_x_switch
  },
  data: function data() {
    return {
      titlepage: this.$route.meta.title,
      list: [{
        id: 0,
        label: '学院',
        value: true
      }, {
        id: 1,
        label: '专业',
        value: true
      }, {
        id: 2,
        label: '班级',
        value: true
      }, {
        id: 3,
        label: 'QQ',
        value: true
      }, {
        id: 4,
        label: '微信',
        value: true
      }, {
        id: 5,
        label: '邮箱',
        value: true
      }, {
        id: 6,
        label: '联系电话',
        value: true
      }, {
        id: 7,
        label: '生源地',
        value: true
      }, {
        id: 8,
        label: '宿舍信息',
        value: true
      }]
    };
  },

  computed: {
    title: function title() {
      return this.$route.meta.title;
    }
  },
  created: function created() {},
  mounted: function mounted() {},

  methods: {
    back: function back() {
      var _this = this;

      setTimeout(function () {
        _this.$router.back(-1);
      }, 300);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6fabf518","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/yingxin/tskjxy/views/user/userItem/privacy.vue
var privacy_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sub-page"},[_c('x-header',{staticClass:"header bg-white fixed"},[_c('em',{staticClass:"icon icon-arrow-left",attrs:{"slot":"overwrite-left","size":""},on:{"click":_vm.back},slot:"overwrite-left"}),_vm._v(_vm._s(_vm.titlepage))]),_c('div',{staticClass:"fixed-next section"},[_c('group',{attrs:{"title":""}},_vm._l((_vm.list),function(item,index){return _c('x-switch',{key:item.id,attrs:{"title":item.label},model:{value:(item.value),callback:function ($$v) {_vm.$set(item, "value", $$v)},expression:"item.value"}})}),1)],1),_c('div',{staticClass:"button-group fixed bottom container"},[_c('x-button',{attrs:{"type":"brand"},nativeOn:{"click":function($event){return _vm.save($event)}}},[_vm._v("保存")])],1)],1)}
var privacy_staticRenderFns = []
var privacy_esExports = { render: privacy_render, staticRenderFns: privacy_staticRenderFns }
/* harmony default export */ var user_userItem_privacy = (privacy_esExports);
// CONCATENATED MODULE: ./src/yingxin/tskjxy/views/user/userItem/privacy.vue
var privacy_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var privacy___vue_template_functional__ = false
/* styles */
var privacy___vue_styles__ = null
/* scopeId */
var privacy___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var privacy___vue_module_identifier__ = null
var privacy_Component = privacy_normalizeComponent(
  userItem_privacy,
  user_userItem_privacy,
  privacy___vue_template_functional__,
  privacy___vue_styles__,
  privacy___vue_scopeId__,
  privacy___vue_module_identifier__
)

/* harmony default export */ var views_user_userItem_privacy = (privacy_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/yingxin/tskjxy/views/user/userItem/password.vue






/* harmony default export */ var userItem_password = ({
  name: 'user',
  props: [],
  components: {
    XHeader: vux_src_components_x_header,
    Group: vux_src_components_group,
    XInput: vux_src_components_x_input,
    XButton: vux_src_components_x_button
  },
  data: function data() {
    return {
      titlepage: this.$route.meta.title
    };
  },

  computed: {
    title: function title() {
      return this.$route.meta.title;
    }
  },
  created: function created() {},
  mounted: function mounted() {},

  methods: {
    back: function back() {
      var _this = this;

      setTimeout(function () {
        _this.$router.back(-1);
      }, 300);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/yingxin/tskjxy/views/user/userItem/password.vue






/* harmony default export */ var user_userItem_password = ({
  name: 'user',
  props: [],
  components: {
    XHeader: vux_src_components_x_header,
    Group: vux_src_components_group,
    XInput: vux_src_components_x_input,
    XButton: vux_src_components_x_button
  },
  data: function data() {
    return {
      titlepage: this.$route.meta.title
    };
  },

  computed: {
    title: function title() {
      return this.$route.meta.title;
    }
  },
  created: function created() {},
  mounted: function mounted() {},

  methods: {
    back: function back() {
      var _this = this;

      setTimeout(function () {
        _this.$router.back(-1);
      }, 300);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7f889d50","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/yingxin/tskjxy/views/user/userItem/password.vue
var password_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sub-page"},[_c('x-header',{staticClass:"header bg-white fixed"},[_c('em',{staticClass:"icon icon-arrow-left",attrs:{"slot":"overwrite-left","size":""},on:{"click":_vm.back},slot:"overwrite-left"}),_vm._v(_vm._s(_vm.titlepage))]),_c('div',{staticClass:"fixed-next input-right section"},[_c('group',{attrs:{"title":""}},[_c('x-input',{attrs:{"title":"旧密码","type":"password","placeholder":"请输入6位旧密码"}}),_c('x-input',{attrs:{"title":"新密码","type":"password","placeholder":"请输入6位新密码"}}),_c('x-input',{attrs:{"title":"确认新密码","type":"password","placeholder":"请再次输入6位新密码"}})],1)],1),_c('div',{staticClass:"button-group fixed bottom container"},[_c('x-button',{attrs:{"type":"brand"},nativeOn:{"click":function($event){return _vm.save($event)}}},[_vm._v("保存")])],1)],1)}
var password_staticRenderFns = []
var password_esExports = { render: password_render, staticRenderFns: password_staticRenderFns }
/* harmony default export */ var views_user_userItem_password = (password_esExports);
// CONCATENATED MODULE: ./src/yingxin/tskjxy/views/user/userItem/password.vue
var password_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var password___vue_template_functional__ = false
/* styles */
var password___vue_styles__ = null
/* scopeId */
var password___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var password___vue_module_identifier__ = null
var password_Component = password_normalizeComponent(
  user_userItem_password,
  views_user_userItem_password,
  password___vue_template_functional__,
  password___vue_styles__,
  password___vue_scopeId__,
  password___vue_module_identifier__
)

/* harmony default export */ var tskjxy_views_user_userItem_password = (password_Component.exports);

// CONCATENATED MODULE: ./src/yingxin/tskjxy/router/index.js



























































// import DonateResult from '@@/views/user/userItem/donateResult'


vue_esm["default"].use(vue_router_esm["a" /* default */]);
var routes = [{
  path: '/',
  redirect: function redirect() {
    var wx = navigator.userAgent.toLowerCase().indexOf('micromessenger') !== -1;
    // alert(navigator.userAgent.toLowerCase())
    if (wx) {
      return '/login';
    } else {
      return '/home';
    }
  }
}, {
  path: '/login',
  name: 'login',
  component: yingxin_tskjxy_views_common_login,
  meta: {
    title: '登录',
    tabbar: false
  }
}, {
  path: '/regist',
  name: 'regist',
  component: yingxin_tskjxy_views_common_regist,
  meta: {
    title: '注册',
    tabbar: false
  }
}, {
  path: '/errorPage',
  name: 'errorPage',
  component: tskjxy_views_common_errorPage,
  meta: {
    title: '错误提示',
    tabbar: false
  }
}, {
  path: '/home',
  name: 'home',
  component: yingxin_tskjxy_views_home,
  meta: {
    title: '迎新注册离校',
    tabbar: true,
    requireAuth: false
  }
}, {
  path: '/record',
  name: 'record',
  component: tskjxy_views_record_record,
  meta: {
    title: '办理记录',
    tabbar: true,
    requireAuth: true
  },
  children: [{
    path: 'mapPosition/:flowProcedureId/:procedureId/:title',
    name: 'mapPosition',
    component: tskjxy_views_record_map,
    meta: {
      title: '个人信息',
      tabbar: false
    }
  }]
}, {
  path: '/notice',
  name: 'notice',
  component: tskjxy_views_notice_notice,
  meta: {
    title: '通知',
    tabbar: true
  },
  children: [{
    path: '/messageList',
    name: 'messageList',
    component: tskjxy_views_notice_messageList,
    meta: {
      title: '私信',
      tabbar: false
    }
  }, {
    path: 'noticeDetail',
    name: 'noticeDetail',
    component: tskjxy_views_notice_noticeDetail,
    meta: {
      title: '通知详情',
      tabbar: false
    }
  }]
}, {
  path: '/user',
  name: 'user',
  component: tskjxy_views_user_user,
  meta: {
    title: '我的',
    tabbar: true
  },
  children: [{
    path: 'usserInfo',
    name: 'userInfo',
    component: views_user_userItem_userinfo,
    meta: {
      title: '个人信息',
      tabbar: false,
      requireAuth: true
    }
  }, {
    path: 'qrcode',
    name: 'qrcode',
    component: views_user_userItem_myQrcode,
    meta: {
      title: '我的二维码',
      tabbar: false,
      requireAuth: true
    }
  }, {
    path: 'fullOffer',
    name: 'fullOffer',
    component: views_user_userItem_fullOffer,
    meta: {
      title: '录取通知书',
      tabbar: false,
      requireAuth: true
    }
  }, {
    path: 'donate',
    name: 'donate',
    component: views_user_userItem_donate,
    meta: {
      title: '余额捐赠',
      tabbar: false,
      requireAuth: true
    }
  }, {
    path: 'findClassmate',
    name: 'findClassmate',
    component: views_user_userItem_findClassmate,
    meta: {
      title: '找同学',
      tabbar: false,
      requireAuth: true
    },
    children: [{
      path: 'findClassmateDetail',
      name: 'findClassmateDetail',
      component: user_userItem_findClassmate_findClassmateDetail,
      meta: {
        title: '找同学',
        tabbar: false
      }
    }]
  }, {
    path: 'privacy',
    name: 'privacy',
    component: views_user_userItem_privacy,
    meta: {
      title: '隐私设置',
      tabbar: false,
      requireAuth: true
    }
  }, {
    path: 'password',
    name: 'password',
    component: tskjxy_views_user_userItem_password,
    meta: {
      title: '修改密码',
      tabbar: false,
      requireAuth: true
    }
  }]
}, {
  path: '/info',
  name: 'info',
  component: tskjxy_views_items_info,
  meta: {
    title: '完善信息',
    tabbar: false,
    requireAuth: true
  },
  children: [{
    path: 'personalInfo',
    name: 'personalInfo',
    component: views_items_info_personalInfo,
    meta: {
      title: '个人信息',
      tabbar: false
    }
  }, {
    path: 'parentsInfo',
    name: 'parentsInfo',
    component: views_items_info_parentsInfo,
    meta: {
      title: '家庭成员信息',
      tabbar: false
    },
    children: [{
      path: 'parentsInfoEdit',
      name: 'parentsInfoEdit',
      component: views_items_info_parentsInfoEdit,
      meta: {
        title: '填写家庭成员信息',
        tabbar: false
      }
    }]
  }]
}, {
  path: '/car',
  name: 'car',
  component: tskjxy_views_items_car,
  meta: {
    title: '接站预订',
    tabbar: false,
    requireAuth: true
  },
  children: [{
    path: '/carInfo/:type',
    name: 'carInfo',
    component: tskjxy_views_items_car_carInfo,
    meta: {
      title: '接站预订',
      tabbar: false
    }
  }]
}, {
  path: '/loan',
  name: 'loan',
  component: tskjxy_views_items_loan,
  meta: {
    title: '绿色通道',
    tabbar: false,
    requireAuth: true
  }
}, {
  path: '/dormroom',
  name: 'dormroom',
  component: tskjxy_views_items_dormroom,
  meta: {
    title: '宿舍选择',
    tabbar: false,
    requireAuth: false
  },
  children: [{
    path: 'dormroomDeatil',
    name: 'dormroomDeatil',
    component: views_items_dormroom_dormroomDeatil,
    meta: {
      title: '宿舍选择',
      tabbar: false
    }
  }, {
    path: 'dormChoseRoom',
    name: 'dormChoseRoom',
    component: views_items_dormroom_dormChoseRoom,
    meta: {
      title: '预约床位',
      tabbar: false
    }
  }]
}, {
  path: '/pay',
  name: 'pay',
  component: tskjxy_views_items_pay,
  meta: {
    title: '缴费明细',
    tabbar: false,
    requireAuth: true
  },
  children: [{
    path: 'pendingBill',
    name: 'pendingBill',
    component: views_items_pay_pendingBill,
    meta: {
      title: '待缴账单',
      tabbar: false
    }
  }]
}, {
  path: '/picture',
  name: 'picture',
  component: tskjxy_views_items_picture,
  meta: {
    title: '上传图片',
    tabbar: false,
    requireAuth: true
  }
}, {
  path: '/address',
  name: 'address',
  component: tskjxy_views_items_address,
  meta: {
    title: '户口迁移',
    tabbar: false,
    requireAuth: true
  }
}, {
  path: '/clothes',
  name: 'clothes',
  component: tskjxy_views_items_clothes,
  meta: {
    title: '军训服装',
    tabbar: false,
    requireAuth: true
  },
  children: [{
    path: 'clotheSize',
    name: 'clotheSize',
    component: views_items_clothes_clotheSize,
    meta: {
      title: '尺码设置',
      tabbar: false
    }
  }]
}, {
  path: '/medical',
  name: 'medical',
  component: tskjxy_views_items_medical,
  meta: {
    title: '体检预约',
    tabbar: false,
    requireAuth: true
  },
  children: [{
    path: '/medicalDate',
    name: 'medicalDate',
    component: views_items_medical_medicalDate,
    meta: {
      title: '体检预约',
      tabbar: false
    }
  }, {
    path: '/medicalResult',
    name: 'medicalResult',
    component: views_items_medical_medicalResult,
    meta: {
      title: '体检预约',
      tabbar: false
    }
  }]
}, {
  path: '/books',
  name: 'books',
  component: tskjxy_views_items_books,
  meta: {
    title: '教材预订',
    tabbar: false,
    requireAuth: true
  }
}, {
  path: '/default',
  name: 'default',
  component: yingxin_tskjxy_views_items_default,
  meta: {
    title: '',
    tabbar: false,
    requireAuth: true
  }
}, {
  path: '/alumnus/:isEdit',
  name: 'alumnus',
  component: tskjxy_views_items_alumnus,
  meta: {
    title: '校友部信息填写',
    tabbar: false,
    requireAuth: true
  }
}, {
  path: '/itemResult/',
  name: 'itemResult',
  component: tskjxy_views_items_itemResult,
  meta: {
    title: '结果',
    tabbar: false
  }
}];

var router_router = new vue_router_esm["a" /* default */]({
  routes: routes
});
// 导航守卫
// 使用 router.beforeEach 注册一个全局前置守卫，判断用户是否登陆
router_router.beforeEach(function (to, from, next) {
  if (to.path === '/login') {
    next();
  } else {
    var token = store.state.token;
    var wx = navigator.userAgent.toLowerCase().indexOf('micromessenger') !== -1;
    if (wx) {
      if (to.matched.some(function (record) {
        return record.meta.requireAuth;
      }) && (token === null || token === '')) {
        next({
          path: '/login',
          query: {
            redirect: to.fullPath
          }
        });
      } else {
        next();
      }
    } else {
      next();
    }
  }
});
/* harmony default export */ var tskjxy_router = (router_router);
// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__("mtWM");
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);

// EXTERNAL MODULE: ./node_modules/qs/lib/index.js
var lib = __webpack_require__("mw3O");
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);

// EXTERNAL MODULE: ./static/config/index.json
var static_config = __webpack_require__("fhwO");
var config_default = /*#__PURE__*/__webpack_require__.n(static_config);

// CONCATENATED MODULE: ./src/api/index.js


// 引用axios




axios_default.a.get('./static/config/index.json').then(function (r) {
  // console.log(r.data)
  localStorage.setItem('configs', stringify_default()(r.data));
}).catch(function (err) {
  console.log('配置文件获取失败', err);
});

var api_config = JSON.parse(localStorage.getItem('configs'));
// console.log(config)

// 配置API接口地址
var apiRoot = api_config ? api_config.baseApi : config_default.a.baseApi;
var payApiRoot = api_config ? api_config.payApi : config_default.a.payApi;
var loginApiRoot = api_config ? api_config.loginApi : config_default.a.loginApi;
// var apiRoot = conf.baseApi
// var payApiRoot = conf.payApi
// var loginApiRoot = conf.loginApi

// console.log(apiRoot)
// 自定义判断元素类型JS
function toType(obj) {
  return {}.toString.call(obj).match(/\s([a-zA-Z]+)/)[1].toLowerCase();
}
// 参数过滤函数
function filterNull(o) {
  for (var key in o) {
    if (o[key] === null) {
      delete o[key];
    }
    if (toType(o[key]) === 'string') {
      o[key] = o[key].trim();
    } else if (toType(o[key]) === 'object') {
      o[key] = filterNull(o[key]);
    } else if (toType(o[key]) === 'array') {
      o[key] = filterNull(o[key]);
    }
  }
  return o;
}

function useApi(method, url, params, success, failure, qs) {
  if (params) {
    params = filterNull(params);
  }
  axios_default()({
    method: method,
    url: url,
    data: method === 'POST' || method === 'DELETE' || method === 'PUT' ? qs === 'qs' ? lib_default.a.stringify(params) : params : null,
    params: method === 'GET' ? params : null,
    baseURL: apiRoot,
    withCredentials: false
  }).then(function (res) {
    if (res.status === 200) {
      if (res.data.code === 200 || res.data.state === 200 || !res.data.code && !res.data.state) {
        if (success) {
          success(res.data);
        }
      } else {
        if (failure) {
          failure(res.data);
        } else {
          console.log('error: ' + stringify_default()(res.data));
          // window.alert('error: ' + JSON.stringify(res.data))
        }
      }
    } else {
      if (failure) {
        failure(res.status);
      } else {
        console.log('error: ' + stringify_default()(res.data));
        // window.alert('error: ' + JSON.stringify(res.data))
      }
    }
  }).catch(function (err) {
    if (err.error) {
      vue_esm["default"].$vux.toast.text(err.error_description, 'middle');
    } else {
      console.log('api error, HTTP CODE: ' + err);
      // window.alert('api error, HTTP CODE: ' + err)
    }
  });
}

// 返回在vue模板中的调用接口
/* harmony default export */ var api = ({
  get: function get(url, params, success, failure) {
    return useApi('GET', url, params, success, failure);
  },
  post: function post(url, params, success, failure, qs) {
    return useApi('POST', url, params, success, failure, qs);
  },
  put: function put(url, params, success, failure, qs) {
    return useApi('PUT', url, params, success, failure, qs);
  },
  delete: function _delete(url, params, success, failure) {
    return useApi('DELETE', url, params, success, failure);
  },
  payApi: payApiRoot,
  loginApi: loginApiRoot
  // transApi: transApiRoot
});
// EXTERNAL MODULE: ./node_modules/vux/src/plugins/loading/index.js
var loading = __webpack_require__("Y+qm");

// EXTERNAL MODULE: ./node_modules/vux/src/plugins/toast/index.js
var plugins_toast = __webpack_require__("3BeM");

// EXTERNAL MODULE: ./node_modules/vux/src/plugins/alert/index.js + 1 modules
var plugins_alert = __webpack_require__("Peep");

// CONCATENATED MODULE: ./src/common/http.js


/**
* Created by superman on 17/2/16.
* http配置
*/











vue_esm["default"].use(loading["a" /* default */]);
vue_esm["default"].use(plugins_toast["a" /* default */]);
vue_esm["default"].use(plugins_alert["a" /* default */]);

axios_default.a.defaults.timeout = 20000;
axios_default.a.defaults.baseURL = '/';

var type = config_default.a.systemType;

axios_default.a.interceptors.request.use(function (config) {
  config.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
  if (type === 'yingxin') {
    config.headers['systemType'] = 'yingxin_student_app';
  } else if (type === 'yingxin-manage') {
    config.headers['systemType'] = 'yingxin_teacher_app';
  } else if (type === 'pay') {
    config.headers['Authorization'] = 'Basic Y2hhcmdlOmNoYXJnZV9zZWNyZXQ=';
  }
  var url = config.url.split('/');
  if (type === 'pay') {

    config.headers['synjones-auth'] = 'bearer ' + store.state.token;
    if (url[url.length - 1] === 'token' || url[url.length - 1] === 'pay') {
      config.headers['Content-Type'] = 'application/x-www-form-urlencoded';
    }
  } else if (type === 'yingxin' || type === 'yingxin-manage') {
    config.headers['access_token'] = store.state.token;
  }

  return config;
}, function (err) {
  vue_esm["default"].$vux.loading.hide();
  return promise_default.a.reject(err);
});

axios_default.a.interceptors.response.use(function (response) {

  if (response.data.code || response.data.state) {
    switch (response.data.code || response.data.state) {
      case 200:

        var current = new Date().getTime();

        if (sessionStorage.getItem('refreshObj') && type === 'pay') {
          var login = JSON.parse(sessionStorage.getItem('refreshObj')).login_time;
          var expire = JSON.parse(sessionStorage.getItem('refreshObj')).expires_in;
          var time = parseInt((current - login) / 1000);

          var params = {
            'grant_type': 'refresh_token',
            'scope': 'all',
            'refresh_token': JSON.parse(sessionStorage.getItem('refreshObj')).refresh_token,
            'logintype': JSON.parse(sessionStorage.getItem('refreshObj')).logintype
          };
          if (time > expire - 5 * 60) {

            axios_default.a.post(config_default.a.loginApi + '/blade-auth/oauth/token', lib_default.a.stringify(params)).then(function (r) {
              var data = r.data;

              var newObj = {
                'expires_in': data.expires_in,
                'refresh_token': data.refresh_token,
                'login_time': new Date().getTime(),
                'logintype': JSON.parse(sessionStorage.getItem('refreshObj')).logintype
              };

              store.dispatch('LoginAction', data.access_token);

              sessionStorage.setItem('refreshObj', stringify_default()(newObj));
            }).catch(function (err) {
              console.log(err);
            });
          }
        }
        break;
      case 401:

        if (type === 'pay') {}
        store.dispatch('LogoutAction');
        break;
      case 500:
        vue_esm["default"].$vux.toast.text(response.data.msg, 'middle');
    }
  }
  return response;
}, function (error) {
  vue_esm["default"].$vux.loading.hide();
  console.log(error);
});

/* harmony default export */ var http = (axios_default.a);
// EXTERNAL MODULE: ./src/assets/sass/style.scss
var style = __webpack_require__("s6Sl");
var style_default = /*#__PURE__*/__webpack_require__.n(style);

// EXTERNAL MODULE: ./src/assets/scripts/flexible.js
var flexible = __webpack_require__("PY3Y");
var flexible_default = /*#__PURE__*/__webpack_require__.n(flexible);

// EXTERNAL MODULE: ./node_modules/animate.css/animate.css
var animate = __webpack_require__("oPmM");
var animate_default = /*#__PURE__*/__webpack_require__.n(animate);

// CONCATENATED MODULE: ./src/yingxin/tskjxy/main.js














/*
* Style.css import
*/

/*
* flexible.js import
*/

/*
* animate import
*/

vue_esm["default"].use(animate_default.a);
vue_esm["default"].use(loading["a" /* default */]);
vue_esm["default"].use(plugins_toast["a" /* default */]);
vue_esm["default"].use(plugins_alert["a" /* default */]);

vue_esm["default"].config.productionTip = false;
vue_esm["default"].prototype.$api = api;

/* eslint-disable no-new */
new vue_esm["default"]({
  router: tskjxy_router,
  axios: http,
  store: store,
  render: function render(h) {
    return h(src_yingxin_tskjxy_App);
  }
}).$mount('#app-box');

/***/ }),

/***/ "dUMw":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "edYq":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "eds1":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "egYO":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "fhwO":
/***/ (function(module, exports) {

module.exports = {"title":"泰山科技学院","baseApi":"http://58.56.217.180:8085/yingxin","payApi":"null","loginApi":"null","systemType":"yingxin","version":"1.0.0","code":200}

/***/ }),

/***/ "i+gR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "i+k6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "iHWY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "iJSS":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "jk1Q":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/hat.10881f7.png";

/***/ }),

/***/ "kEC1":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "kKqQ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "mLHi":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "mzja":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/vux/src/components/x-dialog/index.vue + 3 modules
var x_dialog = __webpack_require__("/kga");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/alert/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var components_alert = ({
  name: 'alert',
  components: {
    XDialog: x_dialog["a" /* default */]
  },
  created: function created() {
    if (typeof this.value !== 'undefined') {
      this.showValue = this.value;
    }
  },

  props: {
    value: Boolean,
    title: String,
    content: String,
    buttonText: String,
    hideOnBlur: {
      type: Boolean,
      default: false
    },
    maskTransition: {
      type: String,
      default: 'vux-mask'
    },
    dialogTransition: {
      type: String,
      default: 'vux-dialog'
    },
    maskZIndex: [Number, String]
  },
  data: function data() {
    return {
      showValue: false
    };
  },

  methods: {
    _onHide: function _onHide() {
      this.showValue = false;
    }
  },
  watch: {
    value: function value(val) {
      this.showValue = val;
    },
    showValue: function showValue(val) {
      this.$emit('input', val);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/alert/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var src_components_alert = ({
  name: 'alert',
  components: {
    XDialog: x_dialog["a" /* default */]
  },
  created: function created() {
    if (typeof this.value !== 'undefined') {
      this.showValue = this.value;
    }
  },

  props: {
    value: Boolean,
    title: String,
    content: String,
    buttonText: String,
    hideOnBlur: {
      type: Boolean,
      default: false
    },
    maskTransition: {
      type: String,
      default: 'vux-mask'
    },
    dialogTransition: {
      type: String,
      default: 'vux-dialog'
    },
    maskZIndex: [Number, String]
  },
  data: function data() {
    return {
      showValue: false
    };
  },

  methods: {
    _onHide: function _onHide() {
      this.showValue = false;
    }
  },
  watch: {
    value: function value(val) {
      this.showValue = val;
    },
    showValue: function showValue(val) {
      this.$emit('input', val);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0222073a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/alert/index.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-alert"},[_c('x-dialog',{attrs:{"mask-transition":_vm.maskTransition,"dialog-transition":_vm.dialogTransition,"hide-on-blur":_vm.hideOnBlur,"mask-z-index":_vm.maskZIndex},on:{"on-hide":function($event){return _vm.$emit('on-hide')},"on-show":function($event){return _vm.$emit('on-show')}},model:{value:(_vm.showValue),callback:function ($$v) {_vm.showValue=$$v},expression:"showValue"}},[_c('div',{staticClass:"weui-dialog__hd"},[_c('strong',{staticClass:"weui-dialog__title"},[_vm._v(_vm._s(_vm.title))])]),_vm._v(" "),_c('div',{staticClass:"weui-dialog__bd"},[_vm._t("default",[_c('div',{domProps:{"innerHTML":_vm._s(_vm.content)}})])],2),_vm._v(" "),_c('div',{staticClass:"weui-dialog__ft"},[_c('a',{staticClass:"weui-dialog__btn weui-dialog__btn_primary",attrs:{"href":"javascript:;"},on:{"click":_vm._onHide}},[_vm._v(_vm._s(_vm.buttonText || '确定'))])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var vux_src_components_alert = (esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/alert/index.vue
function injectStyle (ssrContext) {
  __webpack_require__("Scr7")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  src_components_alert,
  vux_src_components_alert,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)


/* harmony default export */ var node_modules_vux_src_components_alert = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "oNIB":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "oPmM":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "oSoZ":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/404.2c0b1e6.png";

/***/ }),

/***/ "oWAa":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ohus":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "p80d":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "p8bI":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "pE22":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/coat.b196083.png";

/***/ }),

/***/ "ptqo":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/shoes.b0b6e35.png";

/***/ }),

/***/ "qUqB":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/null.3e06b6f.png";

/***/ }),

/***/ "rGAb":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "rIeQ":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/dorm-bg.bac54d7.png";

/***/ }),

/***/ "rLAy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/vux/src/mixins/safari-fix.js
var safari_fix = __webpack_require__("xNvf");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/toast/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var toast = ({
  name: 'toast',
  mixins: [safari_fix["a" /* default */]],
  props: {
    value: Boolean,
    time: {
      type: Number,
      default: 2000
    },
    type: {
      type: String,
      default: 'success'
    },
    transition: String,
    width: {
      type: String,
      default: '7.6em'
    },
    isShowMask: {
      type: Boolean,
      default: false
    },
    text: String,
    position: String
  },
  data: function data() {
    return {
      show: false
    };
  },
  created: function created() {
    if (this.value) {
      this.show = true;
    }
  },

  computed: {
    currentTransition: function currentTransition() {
      if (this.transition) {
        return this.transition;
      }
      if (this.position === 'top') {
        return 'vux-slide-from-top';
      }
      if (this.position === 'bottom') {
        return 'vux-slide-from-bottom';
      }
      return 'vux-fade';
    },
    toastClass: function toastClass() {
      return {
        'weui-toast_forbidden': this.type === 'warn',
        'weui-toast_cancel': this.type === 'cancel',
        'weui-toast_success': this.type === 'success',
        'weui-toast_text': this.type === 'text',
        'vux-toast-top': this.position === 'top',
        'vux-toast-bottom': this.position === 'bottom',
        'vux-toast-middle': this.position === 'middle'
      };
    },
    style: function style() {
      if (this.type === 'text' && this.width === 'auto') {
        return { padding: '10px' };
      }
    }
  },
  watch: {
    show: function show(val) {
      var _this = this;

      if (val) {
        this.$emit('input', true);
        this.$emit('on-show');
        this.fixSafariOverflowScrolling('auto');

        clearTimeout(this.timeout);
        this.timeout = setTimeout(function () {
          _this.show = false;
          _this.$emit('input', false);
          _this.$emit('on-hide');
          _this.fixSafariOverflowScrolling('touch');
        }, this.time);
      }
    },
    value: function value(val) {
      this.show = val;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/toast/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var components_toast = ({
  name: 'toast',
  mixins: [safari_fix["a" /* default */]],
  props: {
    value: Boolean,
    time: {
      type: Number,
      default: 2000
    },
    type: {
      type: String,
      default: 'success'
    },
    transition: String,
    width: {
      type: String,
      default: '7.6em'
    },
    isShowMask: {
      type: Boolean,
      default: false
    },
    text: String,
    position: String
  },
  data: function data() {
    return {
      show: false
    };
  },
  created: function created() {
    if (this.value) {
      this.show = true;
    }
  },

  computed: {
    currentTransition: function currentTransition() {
      if (this.transition) {
        return this.transition;
      }
      if (this.position === 'top') {
        return 'vux-slide-from-top';
      }
      if (this.position === 'bottom') {
        return 'vux-slide-from-bottom';
      }
      return 'vux-fade';
    },
    toastClass: function toastClass() {
      return {
        'weui-toast_forbidden': this.type === 'warn',
        'weui-toast_cancel': this.type === 'cancel',
        'weui-toast_success': this.type === 'success',
        'weui-toast_text': this.type === 'text',
        'vux-toast-top': this.position === 'top',
        'vux-toast-bottom': this.position === 'bottom',
        'vux-toast-middle': this.position === 'middle'
      };
    },
    style: function style() {
      if (this.type === 'text' && this.width === 'auto') {
        return { padding: '10px' };
      }
    }
  },
  watch: {
    show: function show(val) {
      var _this = this;

      if (val) {
        this.$emit('input', true);
        this.$emit('on-show');
        this.fixSafariOverflowScrolling('auto');

        clearTimeout(this.timeout);
        this.timeout = setTimeout(function () {
          _this.show = false;
          _this.$emit('input', false);
          _this.$emit('on-hide');
          _this.fixSafariOverflowScrolling('touch');
        }, this.time);
      }
    },
    value: function value(val) {
      this.show = val;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-25afd1ad","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/toast/index.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-toast"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isShowMask && _vm.show),expression:"isShowMask && show"}],staticClass:"weui-mask_transparent"}),_vm._v(" "),_c('transition',{attrs:{"name":_vm.currentTransition}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"weui-toast",class:_vm.toastClass,style:({width: _vm.width})},[_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.type !== 'text'),expression:"type !== 'text'"}],staticClass:"weui-icon-success-no-circle weui-icon_toast"}),_vm._v(" "),(_vm.text)?_c('p',{staticClass:"weui-toast__content",style:(_vm.style),domProps:{"innerHTML":_vm._s(_vm.text)}}):_c('p',{staticClass:"weui-toast__content",style:(_vm.style)},[_vm._t("default")],2)])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var src_components_toast = (esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/toast/index.vue
function injectStyle (ssrContext) {
  __webpack_require__("TYQ4")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  components_toast,
  src_components_toast,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var vux_src_components_toast = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "rPBl":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/default.b7b37f3.png";

/***/ }),

/***/ "s6Sl":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "sgDB":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "tAeU":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "v2ns":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "xNht":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/offer-bg.15be255.jpg";

/***/ }),

/***/ "ze5M":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "zn2m":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},[0]);


// WEBPACK FOOTER //
// static/js/app.6e618502ff1b36520d9d.js